/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "90c5b96e0ec2175f53ec"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/ 	
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/ 	
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 1;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _reactHotLoader = __webpack_require__(76);
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(111);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reduxThunk = __webpack_require__(250);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(251);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _onsenui = __webpack_require__(252);
	
	var _reactRedux = __webpack_require__(255);
	
	var _redux = __webpack_require__(264);
	
	var _index = __webpack_require__(285);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _app = __webpack_require__(293);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _loader = __webpack_require__(503);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _chatBody = __webpack_require__(288);
	
	var _chatRoot = __webpack_require__(291);
	
	var _isBrowser = __webpack_require__(367);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_index2.default, window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	},  true ? (0, _redux.applyMiddleware)(_reduxThunk2.default) : (0, _redux.applyMiddleware)(_reduxThunk2.default, _reduxLogger2.default));
	
	// ReactDOM.render(
	//   <AppContainer>
	//     <Provider store={store}>
	//       <Loader />
	//     </Provider>
	//   </AppContainer>,
	//   rootElement
	// );
	//
	// if (module.hot) {
	//   module.hot.accept('./loader', () => {
	//     const NextApp = require('./loader').default;
	//     ReactDOM.render(
	//       <AppContainer>
	//         <Provider store={store}>
	//           <NextApp />
	//         </Provider>
	//       </AppContainer>,
	//       rootElement
	//     );
	//   });
	// }
	
	function render(rootElement) {
	
	  if (_onsenui.platform.isIPad()) {
	    rootElement.classList.add('cu-ui-chat-large');
	  }
	
	  if (window != undefined || (0, _isBrowser2.default)()) {
	    if (window.innerWidth > 600) {
	      rootElement.classList.add('cu-ui-chat-large');
	    }
	
	    window.onresize = function () {
	      if (window.innerWidth > 600) {
	        rootElement.classList.add('cu-ui-chat-large');
	      } else {
	        rootElement.classList.remove('cu-ui-chat-large');
	      }
	    };
	  }
	
	  // google ana
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	
	  ga('create', 'UA-104949268-1', 'auto');
	  ga('send', 'pageview');
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactHotLoader.AppContainer,
	    null,
	    _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(_app2.default, null)
	    )
	  ), rootElement);
	
	  if (true) {
	    module.hot.accept(293, function () {
	      var NextApp = __webpack_require__(293).default;
	      _reactDom2.default.render(_react2.default.createElement(
	        _reactHotLoader.AppContainer,
	        null,
	        _react2.default.createElement(
	          _reactRedux.Provider,
	          { store: store },
	          _react2.default.createElement(NextApp, null)
	        )
	      ), rootElement);
	    });
	  }
	}
	
	window.cu_web_plugin = {
	  initApp: function initApp(element, _ref) {
	    var title = _ref.title,
	        debugFunc = _ref.debugFunc,
	        fullFunc = _ref.fullFunc,
	        closeFunc = _ref.closeFunc;
	
	    store.dispatch((0, _chatRoot.initApp)({
	      title: title,
	      debugFunc: debugFunc,
	      fullFunc: fullFunc,
	      closeFunc: closeFunc
	    }));
	    render(element);
	  },
	  initProtocol: function initProtocol(custom_functions) {
	    store.dispatch((0, _chatRoot.initProtocol)(custom_functions));
	  },
	  loadData: function loadData(messages) {
	    store.dispatch((0, _chatBody.addMessages)(messages));
	  },
	  passsiveReceiver: function passsiveReceiver(message) {
	    store.dispatch((0, _chatBody.addMessages)([message]));
	  }
	};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2)


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(3);
	} else {
	  module.exports = require('./patch.dev');
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/* noop */
	"use strict";

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(77)


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(78);
	} else {
	  module.exports = require('./index.dev');
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__(79);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(80);
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prop-types */
	
	var React = __webpack_require__(81);
	
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(82);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var ReactBaseClasses = __webpack_require__(84);
	var ReactChildren = __webpack_require__(93);
	var ReactDOMFactories = __webpack_require__(101);
	var ReactElement = __webpack_require__(95);
	var ReactPropTypes = __webpack_require__(102);
	var ReactVersion = __webpack_require__(107);
	
	var createReactClass = __webpack_require__(108);
	var onlyChild = __webpack_require__(110);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85),
	    _assign = __webpack_require__(83);
	
	var ReactNoopUpdateQueue = __webpack_require__(86);
	
	var canDefineProperty = __webpack_require__(89);
	var emptyObject = __webpack_require__(90);
	var invariant = __webpack_require__(91);
	var lowPriorityWarning = __webpack_require__(92);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(87);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(94);
	var ReactElement = __webpack_require__(95);
	
	var emptyFunction = __webpack_require__(88);
	var traverseAllChildren = __webpack_require__(98);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 94 */
[506, 85],
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var ReactCurrentOwner = __webpack_require__(96);
	
	var warning = __webpack_require__(87);
	var canDefineProperty = __webpack_require__(89);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(97);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var REACT_ELEMENT_TYPE = __webpack_require__(97);
	
	var getIteratorFn = __webpack_require__(99);
	var invariant = __webpack_require__(91);
	var KeyEscapeUtils = __webpack_require__(100);
	var warning = __webpack_require__(87);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(95);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(95),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(103);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(104);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	var assign = __webpack_require__(83);
	
	var ReactPropTypesSecret = __webpack_require__(105);
	var checkPropTypes = __webpack_require__(106);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(84),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(95),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(86);
	var factory = __webpack_require__(109);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var emptyObject = __webpack_require__(90);
	var _invariant = __webpack_require__(91);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactElement = __webpack_require__(95);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(112);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactDefaultInjection = __webpack_require__(117);
	var ReactMount = __webpack_require__(241);
	var ReactReconciler = __webpack_require__(138);
	var ReactUpdates = __webpack_require__(135);
	var ReactVersion = __webpack_require__(246);
	
	var findDOMNode = __webpack_require__(247);
	var getHostComponentFromComposite = __webpack_require__(248);
	var renderSubtreeIntoContainer = __webpack_require__(249);
	var warning = __webpack_require__(87);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var DOMProperty = __webpack_require__(115);
	var ReactDOMComponentFlags = __webpack_require__(116);
	
	var invariant = __webpack_require__(91);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 114 */
85,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(118);
	var BeforeInputEventPlugin = __webpack_require__(119);
	var ChangeEventPlugin = __webpack_require__(134);
	var DefaultEventPluginOrder = __webpack_require__(147);
	var EnterLeaveEventPlugin = __webpack_require__(148);
	var HTMLDOMPropertyConfig = __webpack_require__(153);
	var ReactComponentBrowserEnvironment = __webpack_require__(154);
	var ReactDOMComponent = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactDOMEmptyComponent = __webpack_require__(212);
	var ReactDOMTreeTraversal = __webpack_require__(213);
	var ReactDOMTextComponent = __webpack_require__(214);
	var ReactDefaultBatchingStrategy = __webpack_require__(215);
	var ReactEventListener = __webpack_require__(216);
	var ReactInjection = __webpack_require__(219);
	var ReactReconcileTransaction = __webpack_require__(220);
	var SVGDOMPropertyConfig = __webpack_require__(228);
	var SelectEventPlugin = __webpack_require__(229);
	var SimpleEventPlugin = __webpack_require__(230);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(120);
	var ExecutionEnvironment = __webpack_require__(127);
	var FallbackCompositionState = __webpack_require__(128);
	var SyntheticCompositionEvent = __webpack_require__(131);
	var SyntheticInputEvent = __webpack_require__(133);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(121);
	var EventPluginUtils = __webpack_require__(123);
	
	var accumulateInto = __webpack_require__(125);
	var forEachAccumulated = __webpack_require__(126);
	var warning = __webpack_require__(87);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var EventPluginRegistry = __webpack_require__(122);
	var EventPluginUtils = __webpack_require__(123);
	var ReactErrorUtils = __webpack_require__(124);
	
	var accumulateInto = __webpack_require__(125);
	var forEachAccumulated = __webpack_require__(126);
	var invariant = __webpack_require__(91);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactErrorUtils = __webpack_require__(124);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var PooledClass = __webpack_require__(129);
	
	var getTextContentAccessor = __webpack_require__(130);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 129 */
[506, 114],
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var PooledClass = __webpack_require__(129);
	
	var emptyFunction = __webpack_require__(88);
	var warning = __webpack_require__(87);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(121);
	var EventPropagators = __webpack_require__(120);
	var ExecutionEnvironment = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(135);
	var SyntheticEvent = __webpack_require__(132);
	
	var inputValueTracking = __webpack_require__(143);
	var getEventTarget = __webpack_require__(144);
	var isEventSupported = __webpack_require__(145);
	var isTextInputElement = __webpack_require__(146);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var CallbackQueue = __webpack_require__(136);
	var PooledClass = __webpack_require__(129);
	var ReactFeatureFlags = __webpack_require__(137);
	var ReactReconciler = __webpack_require__(138);
	var Transaction = __webpack_require__(142);
	
	var invariant = __webpack_require__(91);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(129);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(139);
	var ReactInstrumentation = __webpack_require__(141);
	
	var warning = __webpack_require__(87);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(140);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(113);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(113);
	var SyntheticMouseEvent = __webpack_require__(149);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(150);
	var ViewportMetrics = __webpack_require__(151);
	
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	var getEventTarget = __webpack_require__(144);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(115);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(155);
	var ReactDOMIDOperations = __webpack_require__(166);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(156);
	var Danger = __webpack_require__(162);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactInstrumentation = __webpack_require__(141);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(159);
	var setInnerHTML = __webpack_require__(158);
	var setTextContent = __webpack_require__(160);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(157);
	var setInnerHTML = __webpack_require__(158);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(159);
	var setTextContent = __webpack_require__(160);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	var DOMNamespaces = __webpack_require__(157);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(159);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	var escapeTextContentForBrowser = __webpack_require__(161);
	var setInnerHTML = __webpack_require__(158);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var DOMLazyTree = __webpack_require__(156);
	var ExecutionEnvironment = __webpack_require__(127);
	
	var createNodesFromMarkup = __webpack_require__(163);
	var emptyFunction = __webpack_require__(88);
	var invariant = __webpack_require__(91);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	var createArrayFromMixed = __webpack_require__(164);
	var getMarkupWrap = __webpack_require__(165);
	var invariant = __webpack_require__(91);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(155);
	var ReactDOMComponentTree = __webpack_require__(113);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var AutoFocusUtils = __webpack_require__(168);
	var CSSPropertyOperations = __webpack_require__(170);
	var DOMLazyTree = __webpack_require__(156);
	var DOMNamespaces = __webpack_require__(157);
	var DOMProperty = __webpack_require__(115);
	var DOMPropertyOperations = __webpack_require__(178);
	var EventPluginHub = __webpack_require__(121);
	var EventPluginRegistry = __webpack_require__(122);
	var ReactBrowserEventEmitter = __webpack_require__(180);
	var ReactDOMComponentFlags = __webpack_require__(116);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactDOMInput = __webpack_require__(183);
	var ReactDOMOption = __webpack_require__(186);
	var ReactDOMSelect = __webpack_require__(187);
	var ReactDOMTextarea = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactMultiChild = __webpack_require__(189);
	var ReactServerRenderingTransaction = __webpack_require__(208);
	
	var emptyFunction = __webpack_require__(88);
	var escapeTextContentForBrowser = __webpack_require__(161);
	var invariant = __webpack_require__(91);
	var isEventSupported = __webpack_require__(145);
	var shallowEqual = __webpack_require__(197);
	var inputValueTracking = __webpack_require__(143);
	var validateDOMNesting = __webpack_require__(211);
	var warning = __webpack_require__(87);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(113);
	
	var focusNode = __webpack_require__(169);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(171);
	var ExecutionEnvironment = __webpack_require__(127);
	var ReactInstrumentation = __webpack_require__(141);
	
	var camelizeStyleName = __webpack_require__(172);
	var dangerousStyleValue = __webpack_require__(174);
	var hyphenateStyleName = __webpack_require__(175);
	var memoizeStringOnly = __webpack_require__(177);
	var warning = __webpack_require__(87);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(173);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(171);
	var warning = __webpack_require__(87);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(176);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactInstrumentation = __webpack_require__(141);
	
	var quoteAttributeValueForBrowser = __webpack_require__(179);
	var warning = __webpack_require__(87);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(161);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var EventPluginRegistry = __webpack_require__(122);
	var ReactEventEmitterMixin = __webpack_require__(181);
	var ViewportMetrics = __webpack_require__(151);
	
	var getVendorPrefixedEventName = __webpack_require__(182);
	var isEventSupported = __webpack_require__(145);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(121);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var DOMPropertyOperations = __webpack_require__(178);
	var LinkedValueUtils = __webpack_require__(184);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(135);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactPropTypesSecret = __webpack_require__(185);
	var propTypesFactory = __webpack_require__(103);
	
	var React = __webpack_require__(82);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var React = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactDOMSelect = __webpack_require__(187);
	
	var warning = __webpack_require__(87);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var LinkedValueUtils = __webpack_require__(184);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(135);
	
	var warning = __webpack_require__(87);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var LinkedValueUtils = __webpack_require__(184);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(135);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactComponentEnvironment = __webpack_require__(190);
	var ReactInstanceMap = __webpack_require__(191);
	var ReactInstrumentation = __webpack_require__(141);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactReconciler = __webpack_require__(138);
	var ReactChildReconciler = __webpack_require__(192);
	
	var emptyFunction = __webpack_require__(88);
	var flattenChildren = __webpack_require__(207);
	var invariant = __webpack_require__(91);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(138);
	
	var instantiateReactComponent = __webpack_require__(194);
	var KeyEscapeUtils = __webpack_require__(202);
	var shouldUpdateReactComponent = __webpack_require__(198);
	var traverseAllChildren = __webpack_require__(203);
	var warning = __webpack_require__(87);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(206);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(193)))

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var ReactCompositeComponent = __webpack_require__(195);
	var ReactEmptyComponent = __webpack_require__(199);
	var ReactHostComponent = __webpack_require__(200);
	
	var getNextDebugID = __webpack_require__(201);
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var React = __webpack_require__(82);
	var ReactComponentEnvironment = __webpack_require__(190);
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactErrorUtils = __webpack_require__(124);
	var ReactInstanceMap = __webpack_require__(191);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactNodeTypes = __webpack_require__(196);
	var ReactReconciler = __webpack_require__(138);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(90);
	var invariant = __webpack_require__(91);
	var shallowEqual = __webpack_require__(197);
	var shouldUpdateReactComponent = __webpack_require__(198);
	var warning = __webpack_require__(87);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var React = __webpack_require__(82);
	
	var invariant = __webpack_require__(91);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 202 */
100,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var REACT_ELEMENT_TYPE = __webpack_require__(204);
	
	var getIteratorFn = __webpack_require__(205);
	var invariant = __webpack_require__(91);
	var KeyEscapeUtils = __webpack_require__(202);
	var warning = __webpack_require__(87);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 204 */
97,
/* 205 */
99,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactCurrentOwner = __webpack_require__(96);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(202);
	var traverseAllChildren = __webpack_require__(203);
	var warning = __webpack_require__(87);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(206);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(193)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var PooledClass = __webpack_require__(129);
	var Transaction = __webpack_require__(142);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactServerUpdateQueue = __webpack_require__(209);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(210);
	
	var warning = __webpack_require__(87);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactInstanceMap = __webpack_require__(191);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactUpdates = __webpack_require__(135);
	
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var emptyFunction = __webpack_require__(88);
	var warning = __webpack_require__(87);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var DOMLazyTree = __webpack_require__(156);
	var ReactDOMComponentTree = __webpack_require__(113);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114),
	    _assign = __webpack_require__(83);
	
	var DOMChildrenOperations = __webpack_require__(155);
	var DOMLazyTree = __webpack_require__(156);
	var ReactDOMComponentTree = __webpack_require__(113);
	
	var escapeTextContentForBrowser = __webpack_require__(161);
	var invariant = __webpack_require__(91);
	var validateDOMNesting = __webpack_require__(211);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var ReactUpdates = __webpack_require__(135);
	var Transaction = __webpack_require__(142);
	
	var emptyFunction = __webpack_require__(88);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var EventListener = __webpack_require__(217);
	var ExecutionEnvironment = __webpack_require__(127);
	var PooledClass = __webpack_require__(129);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(135);
	
	var getEventTarget = __webpack_require__(144);
	var getUnboundedScrollPosition = __webpack_require__(218);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(115);
	var EventPluginHub = __webpack_require__(121);
	var EventPluginUtils = __webpack_require__(123);
	var ReactComponentEnvironment = __webpack_require__(190);
	var ReactEmptyComponent = __webpack_require__(199);
	var ReactBrowserEventEmitter = __webpack_require__(180);
	var ReactHostComponent = __webpack_require__(200);
	var ReactUpdates = __webpack_require__(135);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(83);
	
	var CallbackQueue = __webpack_require__(136);
	var PooledClass = __webpack_require__(129);
	var ReactBrowserEventEmitter = __webpack_require__(180);
	var ReactInputSelection = __webpack_require__(221);
	var ReactInstrumentation = __webpack_require__(141);
	var Transaction = __webpack_require__(142);
	var ReactUpdateQueue = __webpack_require__(210);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(222);
	
	var containsNode = __webpack_require__(224);
	var focusNode = __webpack_require__(169);
	var getActiveElement = __webpack_require__(227);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(127);
	
	var getNodeForCharacterOffset = __webpack_require__(223);
	var getTextContentAccessor = __webpack_require__(130);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(225);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(226);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(120);
	var ExecutionEnvironment = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactInputSelection = __webpack_require__(221);
	var SyntheticEvent = __webpack_require__(132);
	
	var getActiveElement = __webpack_require__(227);
	var isTextInputElement = __webpack_require__(146);
	var shallowEqual = __webpack_require__(197);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var EventListener = __webpack_require__(217);
	var EventPropagators = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(113);
	var SyntheticAnimationEvent = __webpack_require__(231);
	var SyntheticClipboardEvent = __webpack_require__(232);
	var SyntheticEvent = __webpack_require__(132);
	var SyntheticFocusEvent = __webpack_require__(233);
	var SyntheticKeyboardEvent = __webpack_require__(234);
	var SyntheticMouseEvent = __webpack_require__(149);
	var SyntheticDragEvent = __webpack_require__(237);
	var SyntheticTouchEvent = __webpack_require__(238);
	var SyntheticTransitionEvent = __webpack_require__(239);
	var SyntheticUIEvent = __webpack_require__(150);
	var SyntheticWheelEvent = __webpack_require__(240);
	
	var emptyFunction = __webpack_require__(88);
	var getEventCharCode = __webpack_require__(235);
	var invariant = __webpack_require__(91);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(150);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(150);
	
	var getEventCharCode = __webpack_require__(235);
	var getEventKey = __webpack_require__(236);
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(235);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(149);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(150);
	
	var getEventModifierState = __webpack_require__(152);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(132);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(149);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var DOMLazyTree = __webpack_require__(156);
	var DOMProperty = __webpack_require__(115);
	var React = __webpack_require__(82);
	var ReactBrowserEventEmitter = __webpack_require__(180);
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactDOMContainerInfo = __webpack_require__(242);
	var ReactDOMFeatureFlags = __webpack_require__(243);
	var ReactFeatureFlags = __webpack_require__(137);
	var ReactInstanceMap = __webpack_require__(191);
	var ReactInstrumentation = __webpack_require__(141);
	var ReactMarkupChecksum = __webpack_require__(244);
	var ReactReconciler = __webpack_require__(138);
	var ReactUpdateQueue = __webpack_require__(210);
	var ReactUpdates = __webpack_require__(135);
	
	var emptyObject = __webpack_require__(90);
	var instantiateReactComponent = __webpack_require__(194);
	var invariant = __webpack_require__(91);
	var setInnerHTML = __webpack_require__(158);
	var shouldUpdateReactComponent = __webpack_require__(198);
	var warning = __webpack_require__(87);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(211);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(245);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 246 */
107,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(114);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(191);
	
	var getHostComponentFromComposite = __webpack_require__(248);
	var invariant = __webpack_require__(91);
	var warning = __webpack_require__(87);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(196);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(241);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate, process) {/* onsenui v2.9.1 - 2018-01-26 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ons = factory());
	}(this, (function () { 'use strict';
	
	var onsElements = {};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Add vendor prefix.
	 *
	 * @param {String} name
	 * @return {String}
	 */
	var prefix = function () {
	  var styles = window.getComputedStyle(document.documentElement, '');
	  var prefix = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	
	  return function (name) {
	    return '-' + prefix + '-' + util.hyphenate(name);
	  };
	}();
	
	/**
	 * Minimal utility library for manipulating element's style.
	 * Set element's style.
	 *
	 * @param {Element} element
	 * @param {Object} styles
	 * @return {Element}
	 */
	var styler = function styler(element, style) {
	  Object.keys(style).forEach(function (key) {
	    if (key in element.style) {
	      element.style[key] = style[key];
	    } else if (prefix(key) in element.style) {
	      element.style[prefix(key)] = style[key];
	    } else {
	      util.warn('No such style property: ' + key);
	    }
	  });
	  return element;
	};
	
	/**
	 * @param {Element} element
	 * @param {String} styles Space-separated CSS properties to remove
	 */
	styler.clear = function (element) {
	  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var clearlist = styles.split(/\s+/).reduce(function (r, s) {
	    return r.concat([util.hyphenate(s), prefix(s)]);
	  }, []),
	      keys = [];
	
	  var _loop = function _loop(i) {
	    var key = element.style[i];
	    if (clearlist.length === 0 || clearlist.some(function (s) {
	      return key.indexOf(s) === 0;
	    })) {
	      keys.push(key); // Store the key to fix Safari style indexes
	    }
	  };
	
	  for (var i = element.style.length - 1; i >= 0; i--) {
	    _loop(i);
	  }
	
	  keys.forEach(function (key) {
	    return element.style[key] = '';
	  });
	  element.getAttribute('style') === '' && element.removeAttribute('style');
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	// Save HTMLElement object before Custom Elements polyfill patch global HTMLElement.
	var NativeHTMLElement = window.HTMLElement;
	
	/**
	 * @object ons.platform
	 * @category util
	 * @description
	 *   [en]Utility methods to detect current platform.[/en]
	 *   [ja]現在実行されているプラットフォームを検知するためのユーティリティメソッドを収めたオブジェクトです。[/ja]
	 */
	
	var Platform = function () {
	
	  /**
	   * All elements will be rendered as if the app was running on this platform.
	   * @type {String}
	   */
	  function Platform() {
	    classCallCheck(this, Platform);
	
	    this._selectedPlatform = null;
	    this._ignorePlatformSelect = false;
	  }
	
	  /**
	   * @method select
	   * @signature select(platform)
	   * @param  {string} platform Name of the platform.
	   *   [en]Possible values are: "opera", "firefox", "safari", "chrome", "ie", "android", "blackberry", "ios" or "wp".[/en]
	   *   [ja]"opera", "firefox", "safari", "chrome", "ie", "android", "blackberry", "ios", "wp"のいずれかを指定します。[/ja]
	   * @description
	   *   [en]Sets the platform used to render the elements. Useful for testing.[/en]
	   *   [ja]要素を描画するために利用するプラットフォーム名を設定します。テストに便利です。[/ja]
	   */
	
	
	  createClass(Platform, [{
	    key: 'select',
	    value: function select(platform) {
	      if (typeof platform === 'string') {
	        this._selectedPlatform = platform.trim().toLowerCase();
	      }
	    }
	  }, {
	    key: '_getSelectedPlatform',
	    value: function _getSelectedPlatform() {
	      return this._ignorePlatformSelect ? null : this._selectedPlatform;
	    }
	  }, {
	    key: '_runOnActualPlatform',
	    value: function _runOnActualPlatform(fn) {
	      this._ignorePlatformSelect = true;
	      var result = fn();
	      this._ignorePlatformSelect = false;
	
	      return result;
	    }
	
	    //----------------
	    // General
	    //----------------
	    /**
	     * @method isWebView
	     * @signature isWebView()
	     * @description
	     *   [en]Returns whether app is running in Cordova.[/en]
	     *   [ja]Cordova内で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isWebView',
	    value: function isWebView() {
	      if (document.readyState === 'loading' || document.readyState == 'uninitialized') {
	        throw new Error('isWebView() method is available after dom contents loaded.');
	      }
	
	      return !!(window.cordova || window.phonegap || window.PhoneGap);
	    }
	
	    //----------------
	    // iOS devices
	    //----------------
	    /**
	     * @method isIPhone
	     * @signature isIPhone()
	     * @description
	     *   [en]Returns whether the device is iPhone.[/en]
	     *   [ja]iPhone上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIPhone',
	    value: function isIPhone() {
	      return (/iPhone/i.test(navigator.userAgent)
	      );
	    }
	
	    /**
	     * @method isIPhoneX
	     * @signature isIPhoneX()
	     * @description
	     *   [en]Returns whether the device is iPhone X.[/en]
	     *   [ja]iPhone X上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIPhoneX',
	    value: function isIPhoneX() {
	      // iPhone 8 and iPhone X have a same user agent. We cannot avoid using window.screen.
	      // This works well both in iOS Safari and (UI|WK)WebView of iPhone X.
	      return this.isIPhone() && (window.screen.width === 375 && window.screen.height === 812 || window.screen.width === 812 && window.screen.height === 375);
	    }
	
	    /**
	     * @method isIPad
	     * @signature isIPad()
	     * @description
	     *   [en]Returns whether the device is iPad.[/en]
	     *   [ja]iPad上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIPad',
	    value: function isIPad() {
	      return (/iPad/i.test(navigator.userAgent)
	      );
	    }
	
	    /**
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIPod',
	    value: function isIPod() {
	      return (/iPod/i.test(navigator.userAgent)
	      );
	    }
	
	    //----------------
	    // iOS versions
	    //----------------
	    /**
	     * @method isIOS
	     * @signature isIOS()
	     * @description
	     *   [en]Returns whether the OS is iOS.[/en]
	     *   [ja]iOS上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIOS',
	    value: function isIOS() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'ios';
	      }
	
	      if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object' && !/browser/i.test(device.platform)) {
	        return (/iOS/i.test(device.platform)
	        );
	      } else {
	        return (/iPhone|iPad|iPod/i.test(navigator.userAgent)
	        );
	      }
	    }
	
	    /**
	     * @method isIOS7above
	     * @signature isIOS7above()
	     * @description
	     *   [en]Returns whether the iOS version is 7 or above.[/en]
	     *   [ja]iOS7以上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIOS7above',
	    value: function isIOS7above() {
	      if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object' && !/browser/i.test(device.platform)) {
	        return (/iOS/i.test(device.platform) && parseInt(device.version.split('.')[0]) >= 7
	        );
	      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
	        var ver = (navigator.userAgent.match(/\b[0-9]+_[0-9]+(?:_[0-9]+)?\b/) || [''])[0].replace(/_/g, '.');
	        return parseInt(ver.split('.')[0]) >= 7;
	      }
	      return false;
	    }
	
	    //----------------
	    // iOS browsers
	    //----------------
	    /**
	     * @method isIOSSafari
	     * @signature isIOSSafari()
	     * @description
	     *   [en]Returns whether app is running in iOS Safari.[/en]
	     *   [ja]iOS Safariで実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIOSSafari',
	    value: function isIOSSafari() {
	      var navigator = window.navigator;
	      var ua = navigator.userAgent;
	
	      return !!(this.isIOS() && ua.indexOf('Safari') !== -1 && ua.indexOf('Version') !== -1 && !navigator.standalone);
	    }
	
	    /**
	     * @method isWKWebView
	     * @signature isWKWebView()
	     * @description
	     *   [en]Returns whether app is running in WKWebView.[/en]
	     *   [ja]WKWebViewで実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isWKWebView',
	    value: function isWKWebView() {
	      var lte9 = /constructor/i.test(NativeHTMLElement);
	      return !!(this.isIOS() && window.webkit && window.webkit.messageHandlers && window.indexedDB && !lte9);
	    }
	
	    /**
	     * @method isUIWebView
	     * @signature isUIWebView()
	     * @description
	     *   [en]Returns whether app is running in UIWebView.[/en]
	     *   [ja]UIWebViewで実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isUIWebView',
	    value: function isUIWebView() {
	      return !!(this.isIOS() && !this.isIOSSafari() && !this.isWKWebView());
	    }
	
	    //----------------
	    // Android devices
	    //----------------
	    /**
	     * @method isAndroidPhone
	     * @signature isAndroidPhone()
	     * @description
	     *   [en]Returns whether the device is Android phone.[/en]
	     *   [ja]Android携帯上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isAndroidPhone',
	    value: function isAndroidPhone() {
	      return (/Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent)
	      );
	    }
	
	    /**
	     * @method isAndroidTablet
	     * @signature isAndroidTablet()
	     * @description
	     *   [en]Returns whether the device is Android tablet.[/en]
	     *   [ja]Androidタブレット上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isAndroidTablet',
	    value: function isAndroidTablet() {
	      return (/Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent)
	      );
	    }
	
	    //----------------
	    // Android versions
	    //----------------
	    /**
	     * @method isAndroid
	     * @signature isAndroid()
	     * @description
	     *   [en]Returns whether the OS is Android.[/en]
	     *   [ja]Android上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isAndroid',
	    value: function isAndroid() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'android';
	      }
	
	      if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object' && !/browser/i.test(device.platform)) {
	        return (/Android/i.test(device.platform)
	        );
	      } else {
	        return (/Android/i.test(navigator.userAgent)
	        );
	      }
	    }
	
	    //----------------
	    // Other devices
	    //----------------
	    /**
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isWP',
	    value: function isWP() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'wp';
	      }
	
	      if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object' && !/browser/i.test(device.platform)) {
	        return (/Win32NT|WinCE/i.test(device.platform)
	        );
	      } else {
	        return (/Windows Phone|IEMobile|WPDesktop/i.test(navigator.userAgent)
	        );
	      }
	    }
	
	    /**
	     * @method isBlackBerry
	     * @signature isBlackBerry()
	     * @description
	     *   [en]Returns whether the device is BlackBerry.[/en]
	     *   [ja]BlackBerry上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isBlackBerry',
	    value: function isBlackBerry() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'blackberry';
	      }
	
	      if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object' && !/browser/i.test(device.platform)) {
	        return (/BlackBerry/i.test(device.platform)
	        );
	      } else {
	        return (/BlackBerry|RIM Tablet OS|BB10/i.test(navigator.userAgent)
	        );
	      }
	    }
	
	    //----------------
	    // Other browsers
	    //----------------
	    /**
	     * @method isOpera
	     * @signature isOpera()
	     * @description
	     *   [en]Returns whether the browser is Opera.[/en]
	     *   [ja]Opera上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isOpera',
	    value: function isOpera() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'opera';
	      }
	
	      return !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	    }
	
	    /**
	     * @method isFirefox
	     * @signature isFirefox()
	     * @description
	     *   [en]Returns whether the browser is Firefox.[/en]
	     *   [ja]Firefox上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isFirefox',
	    value: function isFirefox() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'firefox';
	      }
	
	      return typeof InstallTrigger !== 'undefined';
	    }
	
	    /**
	     * @method isSafari
	     * @signature isSafari()
	     * @description
	     *   [en]Returns whether the browser is Safari.[/en]
	     *   [ja]Safari上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isSafari',
	    value: function isSafari() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'safari';
	      }
	
	      return Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || function (p) {
	        return p.toString() === '[object SafariRemoteNotification]';
	      }(!window['safari'] || safari.pushNotification);
	    }
	
	    /**
	     * @method isChrome
	     * @signature isChrome()
	     * @description
	     *   [en]Returns whether the browser is Chrome.[/en]
	     *   [ja]Chrome上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isChrome',
	    value: function isChrome() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'chrome';
	      }
	
	      return !!window.chrome && !(!!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) && !(navigator.userAgent.indexOf(' Edge/') >= 0);
	    }
	
	    /**
	     * @method isIE
	     * @signature isIE()
	     * @description
	     *   [en]Returns whether the browser is Internet Explorer.[/en]
	     *   [ja]Internet Explorer上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isIE',
	    value: function isIE() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'ie';
	      }
	
	      return false || !!document.documentMode;
	    }
	
	    /**
	     * @method isEdge
	     * @signature isEdge()
	     * @description
	     *   [en]Returns whether the browser is Edge.[/en]
	     *   [ja]Edge上で実行されているかどうかを返します。[/ja]
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isEdge',
	    value: function isEdge() {
	      if (this._getSelectedPlatform()) {
	        return this._getSelectedPlatform() === 'edge';
	      }
	
	      return navigator.userAgent.indexOf(' Edge/') >= 0;
	    }
	
	    //----------------
	    // Utility functions
	    //----------------
	    /**
	     * @return {String}
	     */
	
	  }, {
	    key: 'getMobileOS',
	    value: function getMobileOS() {
	      if (this.isAndroid()) {
	        return 'android';
	      } else if (this.isIOS()) {
	        return 'ios';
	      } else if (this.isWP()) {
	        return 'wp';
	      } else {
	        return 'other';
	      }
	    }
	
	    /**
	     * @return {String}
	     */
	
	  }, {
	    key: 'getIOSDevice',
	    value: function getIOSDevice() {
	      if (this.isIPhone()) {
	        return 'iphone';
	      } else if (this.isIPad()) {
	        return 'ipad';
	      } else if (this.isIPod()) {
	        return 'ipod';
	      } else {
	        return 'na';
	      }
	    }
	  }]);
	  return Platform;
	}();
	
	var platform = new Platform();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var pageAttributeExpression = {
	  _variables: {},
	
	  /**
	   * Define a variable.
	   *
	   * @param {String} name Name of the variable
	   * @param {String|Function} value Value of the variable. Can be a string or a function. The function must return a string.
	   * @param {Boolean} overwrite If this value is false, an error will be thrown when trying to define a variable that has already been defined.
	   */
	  defineVariable: function defineVariable(name, value) {
	    var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (typeof name !== 'string') {
	      throw new Error('Variable name must be a string.');
	    } else if (typeof value !== 'string' && typeof value !== 'function') {
	      throw new Error('Variable value must be a string or a function.');
	    } else if (this._variables.hasOwnProperty(name) && !overwrite) {
	      throw new Error('"' + name + '" is already defined.');
	    }
	    this._variables[name] = value;
	  },
	
	  /**
	   * Get a variable.
	   *
	   * @param {String} name Name of the variable.
	   * @return {String|Function|null}
	   */
	  getVariable: function getVariable(name) {
	    if (!this._variables.hasOwnProperty(name)) {
	      return null;
	    }
	
	    return this._variables[name];
	  },
	
	  /**
	   * Remove a variable.
	   *
	   * @param {String} name Name of the varaible.
	   */
	  removeVariable: function removeVariable(name) {
	    delete this._variables[name];
	  },
	
	  /**
	   * Get all variables.
	   *
	   * @return {Object}
	   */
	  getAllVariables: function getAllVariables() {
	    return this._variables;
	  },
	  _parsePart: function _parsePart(part) {
	    var c = void 0,
	        inInterpolation = false,
	        currentIndex = 0;
	
	    var tokens = [];
	
	    if (part.length === 0) {
	      throw new Error('Unable to parse empty string.');
	    }
	
	    for (var i = 0; i < part.length; i++) {
	      c = part.charAt(i);
	
	      if (c === '$' && part.charAt(i + 1) === '{') {
	        if (inInterpolation) {
	          throw new Error('Nested interpolation not supported.');
	        }
	
	        var token = part.substring(currentIndex, i);
	        if (token.length > 0) {
	          tokens.push(part.substring(currentIndex, i));
	        }
	
	        currentIndex = i;
	        inInterpolation = true;
	      } else if (c === '}') {
	        if (!inInterpolation) {
	          throw new Error('} must be preceeded by ${');
	        }
	
	        var _token = part.substring(currentIndex, i + 1);
	        if (_token.length > 0) {
	          tokens.push(part.substring(currentIndex, i + 1));
	        }
	
	        currentIndex = i + 1;
	        inInterpolation = false;
	      }
	    }
	
	    if (inInterpolation) {
	      throw new Error('Unterminated interpolation.');
	    }
	
	    tokens.push(part.substring(currentIndex, part.length));
	
	    return tokens;
	  },
	  _replaceToken: function _replaceToken(token) {
	    var re = /^\${(.*?)}$/,
	        match = token.match(re);
	
	    if (match) {
	      var name = match[1].trim();
	      var variable = this.getVariable(name);
	
	      if (variable === null) {
	        throw new Error('Variable "' + name + '" does not exist.');
	      } else if (typeof variable === 'string') {
	        return variable;
	      } else {
	        var rv = variable();
	
	        if (typeof rv !== 'string') {
	          throw new Error('Must return a string.');
	        }
	
	        return rv;
	      }
	    } else {
	      return token;
	    }
	  },
	  _replaceTokens: function _replaceTokens(tokens) {
	    return tokens.map(this._replaceToken.bind(this));
	  },
	  _parseExpression: function _parseExpression(expression) {
	    return expression.split(',').map(function (part) {
	      return part.trim();
	    }).map(this._parsePart.bind(this)).map(this._replaceTokens.bind(this)).map(function (part) {
	      return part.join('');
	    });
	  },
	
	  /**
	   * Evaluate an expression.
	   *
	   * @param {String} expression An page attribute expression.
	   * @return {Array}
	   */
	  evaluate: function evaluate(expression) {
	    if (!expression) {
	      return [];
	    }
	
	    return this._parseExpression(expression);
	  }
	};
	
	// Define default variables.
	pageAttributeExpression.defineVariable('mobileOS', platform.getMobileOS());
	pageAttributeExpression.defineVariable('iOSDevice', platform.getIOSDevice());
	pageAttributeExpression.defineVariable('runtime', function () {
	  return platform.isWebView() ? 'cordova' : 'browser';
	});
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var internal$1 = {};
	
	internal$1.config = {
	  autoStatusBarFill: true,
	  animationsDisabled: false,
	  warningsDisabled: false
	};
	
	internal$1.nullElement = window.document.createElement('div');
	
	/**
	 * @return {Boolean}
	 */
	internal$1.isEnabledAutoStatusBarFill = function () {
	  return !!internal$1.config.autoStatusBarFill;
	};
	
	/**
	 * @param {String} html
	 * @return {String}
	 */
	internal$1.normalizePageHTML = function (html) {
	  return ('' + html).trim();
	};
	
	internal$1.waitDOMContentLoaded = function (callback) {
	  if (window.document.readyState === 'loading' || window.document.readyState == 'uninitialized') {
	    var wrappedCallback = function wrappedCallback() {
	      callback();
	      window.document.removeEventListener('DOMContentLoaded', wrappedCallback);
	    };
	    window.document.addEventListener('DOMContentLoaded', wrappedCallback);
	  } else {
	    setImmediate(callback);
	  }
	};
	
	internal$1.autoStatusBarFill = function (action) {
	  var onReady = function onReady() {
	    if (internal$1.shouldFillStatusBar()) {
	      action();
	    }
	    document.removeEventListener('deviceready', onReady);
	  };
	
	  if ((typeof device === 'undefined' ? 'undefined' : _typeof(device)) === 'object') {
	    document.addEventListener('deviceready', onReady);
	  } else if (['complete', 'interactive'].indexOf(document.readyState) === -1) {
	    internal$1.waitDOMContentLoaded(onReady);
	  } else {
	    onReady();
	  }
	};
	
	internal$1.shouldFillStatusBar = function () {
	  return internal$1.isEnabledAutoStatusBarFill() && (platform.isWebView() && platform.isIOS7above() && !platform.isIPhoneX() || document.body.querySelector('.ons-status-bar-mock.ios'));
	};
	
	internal$1.templateStore = {
	  _storage: {},
	
	  /**
	   * @param {String} key
	   * @return {String/null} template
	   */
	  get: function get$$1(key) {
	    return internal$1.templateStore._storage[key] || null;
	  },
	
	
	  /**
	   * @param {String} key
	   * @param {String} template
	   */
	  set: function set$$1(key, template) {
	    internal$1.templateStore._storage[key] = template;
	  }
	};
	
	window.document.addEventListener('_templateloaded', function (e) {
	  if (e.target.nodeName.toLowerCase() === 'ons-template') {
	    internal$1.templateStore.set(e.templateId, e.template);
	  }
	}, false);
	
	internal$1.waitDOMContentLoaded(function () {
	  register('script[type="text/ons-template"]');
	  register('script[type="text/template"]');
	  register('script[type="text/ng-template"]');
	  register('template');
	
	  function register(query) {
	    var templates = window.document.querySelectorAll(query);
	    for (var i = 0; i < templates.length; i++) {
	      internal$1.templateStore.set(templates[i].getAttribute('id'), templates[i].textContent || templates[i].content);
	    }
	  }
	});
	
	/**
	 * @param {String} page
	 * @return {Promise}
	 */
	internal$1.getTemplateHTMLAsync = function (page) {
	  return new Promise(function (resolve, reject) {
	    internal$1.waitDOMContentLoaded(function () {
	      var cache = internal$1.templateStore.get(page);
	      if (cache) {
	        if (cache instanceof DocumentFragment) {
	          return resolve(cache);
	        }
	
	        var html = typeof cache === 'string' ? cache : cache[1];
	        return resolve(internal$1.normalizePageHTML(html));
	      }
	
	      var local = window.document.getElementById(page);
	      if (local) {
	        var _html = local.textContent || local.content;
	        return resolve(_html);
	      }
	
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET', page, true);
	      xhr.onload = function () {
	        var html = xhr.responseText;
	        if (xhr.status >= 400 && xhr.status < 600) {
	          reject(html);
	        } else {
	          // Refresh script tags
	          var fragment = util.createFragment(html);
	          util.arrayFrom(fragment.querySelectorAll('script')).forEach(function (el) {
	            var script = document.createElement('script');
	            script.type = el.type || 'text/javascript';
	            script.appendChild(document.createTextNode(el.text || el.textContent || el.innerHTML));
	            el.parentNode.replaceChild(script, el);
	          });
	
	          internal$1.templateStore.set(page, fragment);
	          resolve(fragment);
	        }
	      };
	      xhr.onerror = function () {
	        throw new Error('The page is not found: ' + page);
	      };
	      xhr.send(null);
	    });
	  });
	};
	
	/**
	 * @param {String} page
	 * @return {Promise}
	 */
	internal$1.getPageHTMLAsync = function (page) {
	  var pages = pageAttributeExpression.evaluate(page);
	
	  var getPage = function getPage(page) {
	    if (typeof page !== 'string') {
	      return Promise.reject('Must specify a page.');
	    }
	
	    return internal$1.getTemplateHTMLAsync(page).catch(function (error) {
	      if (pages.length === 0) {
	        return Promise.reject(error);
	      }
	
	      return getPage(pages.shift());
	    });
	  };
	
	  return getPage(pages.shift());
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var AnimatorFactory = function () {
	
	  /**
	   * @param {Object} opts
	   * @param {Object} opts.animators The dictionary for animator classes
	   * @param {Function} opts.baseClass The base class of animators
	   * @param {String} [opts.baseClassName] The name of the base class of animators
	   * @param {String} [opts.defaultAnimation] The default animation name
	   * @param {Object} [opts.defaultAnimationOptions] The default animation options
	   */
	  function AnimatorFactory(opts) {
	    classCallCheck(this, AnimatorFactory);
	
	    this._animators = opts.animators;
	    this._baseClass = opts.baseClass;
	    this._baseClassName = opts.baseClassName || opts.baseClass.name;
	    this._animation = opts.defaultAnimation || 'default';
	    this._animationOptions = opts.defaultAnimationOptions || {};
	
	    if (!this._animators[this._animation]) {
	      throw new Error('No such animation: ' + this._animation);
	    }
	  }
	
	  /**
	   * @param {String} jsonString
	   * @return {Object/null}
	   */
	
	
	  createClass(AnimatorFactory, [{
	    key: 'setAnimationOptions',
	
	
	    /**
	     * @param {Object} options
	     */
	    value: function setAnimationOptions(options) {
	      this._animationOptions = options;
	    }
	
	    /**
	     * @param {Object} options
	     * @param {String} [options.animation] The animation name
	     * @param {Object} [options.animationOptions] The animation options
	     * @param {Object} defaultAnimator The default animator instance
	     * @return {Object} An animator instance
	     */
	
	  }, {
	    key: 'newAnimator',
	    value: function newAnimator() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var defaultAnimator = arguments[1];
	
	
	      var animator = null;
	
	      if (options.animation instanceof this._baseClass) {
	        return options.animation;
	      }
	
	      var Animator = null;
	
	      if (typeof options.animation === 'string') {
	        Animator = this._animators[options.animation];
	      }
	
	      if (!Animator && defaultAnimator) {
	        animator = defaultAnimator;
	      } else {
	        Animator = Animator || this._animators[this._animation];
	
	        var animationOpts = util.extend({}, this._animationOptions, options.animationOptions || {}, internal$1.config.animationsDisabled ? { duration: 0, delay: 0 } : {});
	
	        animator = new Animator(animationOpts);
	
	        if (typeof animator === 'function') {
	          animator = new animator(animationOpts); // eslint-disable-line new-cap
	        }
	      }
	
	      if (!(animator instanceof this._baseClass)) {
	        throw new Error('"animator" is not an instance of ' + this._baseClassName + '.');
	      }
	
	      return animator;
	    }
	  }], [{
	    key: 'parseAnimationOptionsString',
	    value: function parseAnimationOptionsString(jsonString) {
	      try {
	        if (typeof jsonString === 'string') {
	          var result = util.animationOptionsParse(jsonString);
	          if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result !== null) {
	            return result;
	          } else {
	            console.error('"animation-options" attribute must be a JSON object string: ' + jsonString);
	          }
	        }
	        return {};
	      } catch (e) {
	        console.error('"animation-options" attribute must be a JSON object string: ' + jsonString);
	        return {};
	      }
	    }
	  }]);
	  return AnimatorFactory;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var autoStyleEnabled = true;
	
	// Modifiers
	var modifiersMap = {
	  'quiet': 'material--flat',
	  'light': 'material--flat',
	  'outline': 'material--flat',
	  'cta': '',
	  'large--quiet': 'material--flat large',
	  'large--cta': 'large',
	  'noborder': '',
	  'tappable': ''
	};
	
	var platforms = {};
	
	platforms.android = function (element) {
	
	  var elementName = element.tagName.toLowerCase();
	
	  if (!util.hasModifier(element, 'material')) {
	    var oldModifier = element.getAttribute('modifier') || '';
	
	    var newModifier = oldModifier.trim().split(/\s+/).map(function (e) {
	      return modifiersMap.hasOwnProperty(e) ? modifiersMap[e] : e;
	    });
	    newModifier.unshift('material');
	
	    element.setAttribute('modifier', newModifier.join(' ').trim());
	  }
	
	  var elements = ['ons-alert-dialog-button', 'ons-toolbar-button', 'ons-back-button', 'ons-button', 'ons-list-item', 'ons-fab', 'ons-speed-dial', 'ons-speed-dial-item', 'ons-tab'];
	
	  // Effects
	  if (elements.indexOf(elementName) !== -1 && !element.hasAttribute('ripple') && !element.querySelector('ons-ripple')) {
	
	    if (elementName === 'ons-list-item') {
	      if (element.hasAttribute('tappable')) {
	        element.setAttribute('ripple', '');
	        element.removeAttribute('tappable');
	      }
	    } else {
	      element.setAttribute('ripple', '');
	    }
	  }
	};
	
	platforms.ios = function (element) {
	
	  // Modifiers
	  if (util.removeModifier(element, 'material')) {
	    if (util.removeModifier(element, 'material--flat')) {
	      util.addModifier(element, util.removeModifier(element, 'large') ? 'large--quiet' : 'quiet');
	    }
	
	    if (!element.getAttribute('modifier')) {
	      element.removeAttribute('modifier');
	    }
	  }
	
	  // Effects
	  if (element.hasAttribute('ripple')) {
	    if (element.tagName.toLowerCase() === 'ons-list-item') {
	      element.setAttribute('tappable', '');
	    }
	
	    element.removeAttribute('ripple');
	  }
	};
	
	var unlocked = {
	  android: true
	};
	
	var getPlatform = function getPlatform(element, force) {
	  if (autoStyleEnabled && !element.hasAttribute('disable-auto-styling')) {
	    var mobileOS = platform.getMobileOS();
	    if (platforms.hasOwnProperty(mobileOS) && (unlocked.hasOwnProperty(mobileOS) || force)) {
	      return mobileOS;
	    }
	  }
	  return null;
	};
	
	var prepare = function prepare(element, force) {
	  var p = getPlatform(element, force);
	  p && platforms[p](element);
	};
	
	var mapModifier = function mapModifier(modifier, element, force) {
	  if (getPlatform(element, force)) {
	    return modifier.split(/\s+/).map(function (m) {
	      return modifiersMap.hasOwnProperty(m) ? modifiersMap[m] : m;
	    }).join(' ');
	  }
	  return modifier;
	};
	
	var restoreModifier = function restoreModifier(element) {
	  if (getPlatform(element) === 'android') {
	    var modifier = element.getAttribute('modifier') || '';
	    var newModifier = mapModifier(modifier, element);
	
	    if (!/(^|\s+)material($|\s+)/i.test(modifier)) {
	      newModifier = 'material ' + newModifier;
	    }
	
	    if (newModifier !== modifier) {
	      element.setAttribute('modifier', newModifier.trim());
	      return true;
	    }
	  }
	  return false;
	};
	
	var autoStyle = {
	  isEnabled: function isEnabled() {
	    return autoStyleEnabled;
	  },
	  enable: function enable() {
	    return autoStyleEnabled = true;
	  },
	  disable: function disable() {
	    return autoStyleEnabled = false;
	  },
	  prepare: prepare,
	  mapModifier: mapModifier,
	  getPlatform: getPlatform,
	  restoreModifier: restoreModifier
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var ModifierUtil = function () {
	  function ModifierUtil() {
	    classCallCheck(this, ModifierUtil);
	  }
	
	  createClass(ModifierUtil, null, [{
	    key: 'diff',
	
	    /**
	     * @param {String} last
	     * @param {String} current
	     */
	    value: function diff(last, current) {
	      last = makeDict(('' + last).trim());
	      current = makeDict(('' + current).trim());
	
	      var removed = Object.keys(last).reduce(function (result, token) {
	        if (!current[token]) {
	          result.push(token);
	        }
	        return result;
	      }, []);
	
	      var added = Object.keys(current).reduce(function (result, token) {
	        if (!last[token]) {
	          result.push(token);
	        }
	        return result;
	      }, []);
	
	      return { added: added, removed: removed };
	
	      function makeDict(modifier) {
	        var dict = {};
	        ModifierUtil.split(modifier).forEach(function (token) {
	          return dict[token] = token;
	        });
	        return dict;
	      }
	    }
	
	    /**
	     * @param {Object} diff
	     * @param {Array} diff.removed
	     * @param {Array} diff.added
	     * @param {Object} classList
	     * @param {String} template
	     */
	
	  }, {
	    key: 'applyDiffToClassList',
	    value: function applyDiffToClassList(diff, classList, template) {
	      diff.added.map(function (modifier) {
	        return template.replace(/\*/g, modifier);
	      }).forEach(function (klass) {
	        return klass.split(/\s+/).forEach(function (k) {
	          return classList.add(k);
	        });
	      });
	
	      diff.removed.map(function (modifier) {
	        return template.replace(/\*/g, modifier);
	      }).forEach(function (klass) {
	        return klass.split(/\s+/).forEach(function (k) {
	          return classList.remove(k);
	        });
	      });
	    }
	
	    /**
	     * @param {Object} diff
	     * @param {Array} diff.removed
	     * @param {Array} diff.added
	     * @param {HTMLElement} element
	     * @param {Object} scheme
	     */
	
	  }, {
	    key: 'applyDiffToElement',
	    value: function applyDiffToElement(diff, element, scheme) {
	      Object.keys(scheme).forEach(function (selector) {
	        var targetElements = !selector || util.match(element, selector) ? [element] : Array.prototype.filter.call(element.querySelectorAll(selector), function (targetElement) {
	          return !util.findParent(targetElement, element.tagName, function (parent) {
	            return parent === element;
	          });
	        });
	
	        for (var i = 0; i < targetElements.length; i++) {
	          ModifierUtil.applyDiffToClassList(diff, targetElements[i].classList, scheme[selector]);
	        }
	      });
	    }
	
	    /**
	     * @param {String} last
	     * @param {String} current
	     * @param {HTMLElement} element
	     * @param {Object} scheme
	     */
	
	  }, {
	    key: 'onModifierChanged',
	    value: function onModifierChanged(last, current, element, scheme) {
	      ModifierUtil.applyDiffToElement(ModifierUtil.diff(last, current), element, scheme);
	      autoStyle.restoreModifier(element);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh(element, scheme) {
	      ModifierUtil.applyDiffToElement(ModifierUtil.diff('', element.getAttribute('modifier') || ''), element, scheme);
	    }
	
	    /**
	     * @param {HTMLElement} element
	     * @param {Object} scheme
	     */
	
	  }, {
	    key: 'initModifier',
	    value: function initModifier(element, scheme) {
	      var modifier = element.getAttribute('modifier');
	      if (typeof modifier !== 'string') {
	        return;
	      }
	
	      ModifierUtil.applyDiffToElement({
	        removed: [],
	        added: ModifierUtil.split(modifier)
	      }, element, scheme);
	    }
	  }, {
	    key: 'split',
	    value: function split(modifier) {
	      if (typeof modifier !== 'string') {
	        return [];
	      }
	
	      return modifier.trim().split(/ +/).filter(function (token) {
	        return token !== '';
	      });
	    }
	
	    /**
	     * Add modifier token to an element.
	     */
	
	  }, {
	    key: 'addModifier',
	    value: function addModifier(element, modifierToken) {
	      if (!element.hasAttribute('modifier')) {
	        element.setAttribute('modifier', modifierToken);
	      } else {
	        var tokens = ModifierUtil.split(element.getAttribute('modifier'));
	        if (tokens.indexOf(modifierToken) == -1) {
	          tokens.push(modifierToken);
	          element.setAttribute('modifier', tokens.join(' '));
	        }
	      }
	    }
	
	    /**
	     * Remove modifier token from an element.
	     */
	
	  }, {
	    key: 'removeModifier',
	    value: function removeModifier(element, modifierToken) {
	      if (element.hasAttribute('modifier')) {
	        var tokens = ModifierUtil.split(element.getAttribute('modifier'));
	        var index = tokens.indexOf(modifierToken);
	        if (index !== -1) {
	          tokens.splice(index, 1);
	          element.setAttribute('modifier', tokens.join(' '));
	        }
	      }
	    }
	  }]);
	  return ModifierUtil;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var util$2 = {
	  _ready: false,
	
	  _domContentLoaded: false,
	
	  _onDOMContentLoaded: function _onDOMContentLoaded() {
	    util$2._domContentLoaded = true;
	
	    if (platform.isWebView()) {
	      window.document.addEventListener('deviceready', function () {
	        util$2._ready = true;
	      }, false);
	    } else {
	      util$2._ready = true;
	    }
	  },
	
	  addBackButtonListener: function addBackButtonListener(fn) {
	    if (!this._domContentLoaded) {
	      throw new Error('This method is available after DOMContentLoaded');
	    }
	
	    if (this._ready) {
	      window.document.addEventListener('backbutton', fn, false);
	    } else {
	      window.document.addEventListener('deviceready', function () {
	        window.document.addEventListener('backbutton', fn, false);
	      });
	    }
	  },
	
	  removeBackButtonListener: function removeBackButtonListener(fn) {
	    if (!this._domContentLoaded) {
	      throw new Error('This method is available after DOMContentLoaded');
	    }
	
	    if (this._ready) {
	      window.document.removeEventListener('backbutton', fn, false);
	    } else {
	      window.document.addEventListener('deviceready', function () {
	        window.document.removeEventListener('backbutton', fn, false);
	      });
	    }
	  }
	};
	window.addEventListener('DOMContentLoaded', function () {
	  return util$2._onDOMContentLoaded();
	}, false);
	
	var HandlerRepository = {
	  _store: {},
	
	  _genId: function () {
	    var i = 0;
	    return function () {
	      return i++;
	    };
	  }(),
	
	  set: function set$$1(element, handler) {
	    if (element.dataset.deviceBackButtonHandlerId) {
	      this.remove(element);
	    }
	    var id = element.dataset.deviceBackButtonHandlerId = HandlerRepository._genId();
	    this._store[id] = handler;
	  },
	
	  remove: function remove(element) {
	    if (element.dataset.deviceBackButtonHandlerId) {
	      delete this._store[element.dataset.deviceBackButtonHandlerId];
	      delete element.dataset.deviceBackButtonHandlerId;
	    }
	  },
	
	  get: function get$$1(element) {
	    if (!element.dataset.deviceBackButtonHandlerId) {
	      return undefined;
	    }
	
	    var id = element.dataset.deviceBackButtonHandlerId;
	
	    if (!this._store[id]) {
	      throw new Error();
	    }
	
	    return this._store[id];
	  },
	
	  has: function has(element) {
	    if (!element.dataset) {
	      return false;
	    }
	
	    var id = element.dataset.deviceBackButtonHandlerId;
	
	    return !!this._store[id];
	  }
	};
	
	var DeviceBackButtonDispatcher = function () {
	  function DeviceBackButtonDispatcher() {
	    classCallCheck(this, DeviceBackButtonDispatcher);
	
	    this._isEnabled = false;
	    this._boundCallback = this._callback.bind(this);
	  }
	
	  /**
	   * Enable to handle 'backbutton' events.
	   */
	
	
	  createClass(DeviceBackButtonDispatcher, [{
	    key: 'enable',
	    value: function enable() {
	      if (!this._isEnabled) {
	        util$2.addBackButtonListener(this._boundCallback);
	        this._isEnabled = true;
	      }
	    }
	
	    /**
	     * Disable to handle 'backbutton' events.
	     */
	
	  }, {
	    key: 'disable',
	    value: function disable() {
	      if (this._isEnabled) {
	        util$2.removeBackButtonListener(this._boundCallback);
	        this._isEnabled = false;
	      }
	    }
	
	    /**
	     * Fire a 'backbutton' event manually.
	     */
	
	  }, {
	    key: 'fireDeviceBackButtonEvent',
	    value: function fireDeviceBackButtonEvent() {
	      var event = document.createEvent('Event');
	      event.initEvent('backbutton', true, true);
	      document.dispatchEvent(event);
	    }
	  }, {
	    key: '_callback',
	    value: function _callback() {
	      this._dispatchDeviceBackButtonEvent();
	    }
	
	    /**
	     * @param {HTMLElement} element
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'createHandler',
	    value: function createHandler(element, callback) {
	      if (!(element instanceof HTMLElement)) {
	        throw new Error('element must be an instance of HTMLElement');
	      }
	
	      if (!(callback instanceof Function)) {
	        throw new Error('callback must be an instance of Function');
	      }
	
	      var handler = {
	        _callback: callback,
	        _element: element,
	
	        disable: function disable() {
	          HandlerRepository.remove(element);
	        },
	
	        setListener: function setListener(callback) {
	          this._callback = callback;
	        },
	
	        enable: function enable() {
	          HandlerRepository.set(element, this);
	        },
	
	        isEnabled: function isEnabled() {
	          return HandlerRepository.get(element) === this;
	        },
	
	        destroy: function destroy() {
	          HandlerRepository.remove(element);
	          this._callback = this._element = null;
	        }
	      };
	
	      handler.enable();
	
	      return handler;
	    }
	  }, {
	    key: '_dispatchDeviceBackButtonEvent',
	    value: function _dispatchDeviceBackButtonEvent() {
	      var tree = this._captureTree();
	
	      var element = this._findHandlerLeafElement(tree);
	
	      var handler = HandlerRepository.get(element);
	      handler._callback(createEvent(element));
	
	      function createEvent(element) {
	        return {
	          _element: element,
	          callParentHandler: function callParentHandler() {
	            var parent = this._element.parentNode;
	
	            while (parent) {
	              handler = HandlerRepository.get(parent);
	              if (handler) {
	                return handler._callback(createEvent(parent));
	              }
	              parent = parent.parentNode;
	            }
	          }
	        };
	      }
	    }
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: '_captureTree',
	    value: function _captureTree() {
	      return createTree(document.body);
	
	      function createTree(element) {
	        var tree = {
	          element: element,
	          children: Array.prototype.concat.apply([], arrayOf(element.children).map(function (childElement) {
	
	            if (childElement.style.display === 'none' || childElement._isShown === false) {
	              return [];
	            }
	
	            if (childElement.children.length === 0 && !HandlerRepository.has(childElement)) {
	              return [];
	            }
	
	            var result = createTree(childElement);
	
	            if (result.children.length === 0 && !HandlerRepository.has(result.element)) {
	              return [];
	            }
	
	            return [result];
	          }))
	        };
	
	        if (!HandlerRepository.has(tree.element)) {
	          for (var i = 0; i < tree.children.length; i++) {
	            var subTree = tree.children[i];
	            if (HandlerRepository.has(subTree.element)) {
	              return subTree;
	            }
	          }
	        }
	
	        return tree;
	      }
	
	      function arrayOf(target) {
	        var result = [];
	        for (var i = 0; i < target.length; i++) {
	          result.push(target[i]);
	        }
	        return result;
	      }
	    }
	
	    /**
	     * @param {Object} tree
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_findHandlerLeafElement',
	    value: function _findHandlerLeafElement(tree) {
	      return find(tree);
	
	      function find(node) {
	        if (node.children.length === 0) {
	          return node.element;
	        }
	
	        if (node.children.length === 1) {
	          return find(node.children[0]);
	        }
	
	        return node.children.map(function (childNode) {
	          return childNode.element;
	        }).reduce(function (left, right) {
	          if (!left) {
	            return right;
	          }
	
	          var leftZ = parseInt(window.getComputedStyle(left, '').zIndex, 10);
	          var rightZ = parseInt(window.getComputedStyle(right, '').zIndex, 10);
	
	          if (!isNaN(leftZ) && !isNaN(rightZ)) {
	            return leftZ > rightZ ? left : right;
	          }
	
	          throw new Error('Capturing backbutton-handler is failure.');
	        }, null);
	      }
	    }
	  }]);
	  return DeviceBackButtonDispatcher;
	}();
	
	var deviceBackButtonDispatcher = new DeviceBackButtonDispatcher();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	internal$1.AnimatorFactory = AnimatorFactory;
	internal$1.ModifierUtil = ModifierUtil;
	internal$1.dbbDispatcher = deviceBackButtonDispatcher;
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var startsWith = function startsWith(s, c) {
	  return s.substr(0, c.length) === c;
	};
	var endsWith = function endsWith(s, c) {
	  return s.substr(s.length - c.length, c.length) === c;
	};
	var unwrap = function unwrap(s) {
	  return s.slice(1, -1);
	};
	var isObjectString = function isObjectString(s) {
	  return startsWith(s, '{') && endsWith(s, '}');
	};
	var isArrayString = function isArrayString(s) {
	  return startsWith(s, '[') && endsWith(s, ']');
	};
	var isQuotedString = function isQuotedString(s) {
	  return startsWith(s, '\'') && endsWith(s, '\'') || startsWith(s, '"') && endsWith(s, '"');
	};
	
	var error = function error(token, string, originalString) {
	  throw new Error('Unexpected token \'' + token + '\' at position ' + (originalString.length - string.length - 1) + ' in string: \'' + originalString + '\'');
	};
	
	var processToken = function processToken(token, string, originalString) {
	  if (token === 'true' || token === 'false') {
	    return token === 'true';
	  } else if (isQuotedString(token)) {
	    return unwrap(token);
	  } else if (!isNaN(token)) {
	    return +token;
	  } else if (isObjectString(token)) {
	    return parseObject(unwrap(token));
	  } else if (isArrayString(token)) {
	    return parseArray(unwrap(token));
	  } else {
	    error(token, string, originalString);
	  }
	};
	
	var nextToken = function nextToken(string) {
	  string = string.trim();
	  var limit = string.length;
	
	  if (string[0] === ':' || string[0] === ',') {
	
	    limit = 1;
	  } else if (string[0] === '{' || string[0] === '[') {
	
	    var c = string.charCodeAt(0);
	    var nestedObject = 1;
	    for (var i = 1; i < string.length; i++) {
	      if (string.charCodeAt(i) === c) {
	        nestedObject++;
	      } else if (string.charCodeAt(i) === c + 2) {
	        nestedObject--;
	        if (nestedObject === 0) {
	          limit = i + 1;
	          break;
	        }
	      }
	    }
	  } else if (string[0] === '\'' || string[0] === '"') {
	
	    for (var _i = 1; _i < string.length; _i++) {
	      if (string[_i] === string[0]) {
	        limit = _i + 1;
	        break;
	      }
	    }
	  } else {
	
	    for (var _i2 = 1; _i2 < string.length; _i2++) {
	      if ([' ', ',', ':'].indexOf(string[_i2]) !== -1) {
	        limit = _i2;
	        break;
	      }
	    }
	  }
	
	  return string.slice(0, limit);
	};
	
	var parseObject = function parseObject(string) {
	  var isValidKey = function isValidKey(key) {
	    return (/^[A-Z_$][A-Z0-9_$]*$/i.test(key)
	    );
	  };
	
	  string = string.trim();
	  var originalString = string;
	  var object = {};
	  var readingKey = true,
	      key = void 0,
	      previousToken = void 0,
	      token = void 0;
	
	  while (string.length > 0) {
	    previousToken = token;
	    token = nextToken(string);
	    string = string.slice(token.length, string.length).trim();
	
	    if (token === ':' && (!readingKey || !previousToken || previousToken === ',') || token === ',' && readingKey || token !== ':' && token !== ',' && previousToken && previousToken !== ',' && previousToken !== ':') {
	      error(token, string, originalString);
	    } else if (token === ':' && readingKey && previousToken) {
	      previousToken = isQuotedString(previousToken) ? unwrap(previousToken) : previousToken;
	      if (isValidKey(previousToken)) {
	        key = previousToken;
	        readingKey = false;
	      } else {
	        throw new Error('Invalid key token \'' + previousToken + '\' at position 0 in string: \'' + originalString + '\'');
	      }
	    } else if (token === ',' && !readingKey && previousToken) {
	      object[key] = processToken(previousToken, string, originalString);
	      readingKey = true;
	    }
	  }
	
	  if (token) {
	    object[key] = processToken(token, string, originalString);
	  }
	
	  return object;
	};
	
	var parseArray = function parseArray(string) {
	  string = string.trim();
	  var originalString = string;
	  var array = [];
	  var previousToken = void 0,
	      token = void 0;
	
	  while (string.length > 0) {
	    previousToken = token;
	    token = nextToken(string);
	    string = string.slice(token.length, string.length).trim();
	
	    if (token === ',' && (!previousToken || previousToken === ',')) {
	      error(token, string, originalString);
	    } else if (token === ',') {
	      array.push(processToken(previousToken, string, originalString));
	    }
	  }
	
	  if (token) {
	    if (token !== ',') {
	      array.push(processToken(token, string, originalString));
	    } else {
	      error(token, string, originalString);
	    }
	  }
	
	  return array;
	};
	
	var parse = function parse(string) {
	  string = string.trim();
	
	  if (isObjectString(string)) {
	    return parseObject(unwrap(string));
	  } else if (isArrayString(string)) {
	    return parseArray(unwrap(string));
	  } else {
	    throw new Error('Provided string must be object or array like: ' + string);
	  }
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var util = {};
	var errorPrefix = '[Onsen UI]';
	
	util.globals = {
	  fabOffset: 0,
	  errorPrefix: errorPrefix,
	  supportsPassive: false
	};
	
	platform._runOnActualPlatform(function () {
	  util.globals.actualMobileOS = platform.getMobileOS();
	  util.globals.isUIWebView = platform.isUIWebView();
	  util.globals.isWKWebView = platform.isWKWebView();
	});
	
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get$$1() {
	      util.globals.supportsPassive = true;
	    }
	  });
	  window.addEventListener('testPassive', null, opts);
	  window.removeEventListener('testPassive', null, opts);
	} catch (e) {
	  
	}
	
	/**
	 * @param {Element} el Target
	 * @param {String} name Event name
	 * @param {Function} handler Event handler
	 * @param {Object} [opt] Event options (passive, capture...)
	 * @param {Boolean} [isGD] If comes from GestureDetector. Just for testing.
	 */
	util.addEventListener = function (el, name, handler, opt, isGD) {
	  el.addEventListener(name, handler, util.globals.supportsPassive ? opt : (opt || {}).capture);
	};
	util.removeEventListener = function (el, name, handler, opt, isGD) {
	  el.removeEventListener(name, handler, util.globals.supportsPassive ? opt : (opt || {}).capture);
	};
	
	/**
	 * @param {String/Function} query dot class name or node name or matcher function.
	 * @return {Function}
	 */
	util.prepareQuery = function (query) {
	  return query instanceof Function ? query : function (element) {
	    return util.match(element, query);
	  };
	};
	
	/**
	 * @param {Element} e
	 * @param {String/Function} s CSS Selector.
	 * @return {Boolean}
	 */
	util.match = function (e, s) {
	  return (e.matches || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector).call(e, s);
	};
	
	/**
	 * @param {Element} element
	 * @param {String/Function} query dot class name or node name or matcher function.
	 * @return {HTMLElement/null}
	 */
	util.findChild = function (element, query) {
	  var match = util.prepareQuery(query);
	
	  // Caution: `element.children` is `undefined` in some environments if `element` is `svg`
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var node = element.childNodes[i];
	    if (node.nodeType !== Node.ELEMENT_NODE) {
	      // process only element nodes
	      continue;
	    }
	    if (match(node)) {
	      return node;
	    }
	  }
	  return null;
	};
	
	/**
	 * @param {Element} element
	 * @param {String/Function} query dot class name or node name or matcher function.
	 * @return {HTMLElement/null}
	 */
	util.findParent = function (element, query, until) {
	  var match = util.prepareQuery(query);
	
	  var parent = element.parentNode;
	  for (;;) {
	    if (!parent || parent === document || parent instanceof DocumentFragment || until && until(parent)) {
	      return null;
	    } else if (match(parent)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	};
	
	/**
	 * @param {Element} element
	 * @return {boolean}
	 */
	util.isAttached = function (element) {
	  return document.body.contains(element);
	};
	
	/**
	 * @param {Element} element
	 * @return {boolean}
	 */
	util.hasAnyComponentAsParent = function (element) {
	  while (element && document.documentElement !== element) {
	    element = element.parentNode;
	    if (element && element.nodeName.toLowerCase().match(/(ons-navigator|ons-tabbar|ons-modal)/)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @param {Element} element
	 * @return {boolean}
	 */
	util.isPageControl = function (element) {
	  return element.nodeName.match(/^ons-(navigator|splitter|tabbar|page)$/i);
	};
	
	/**
	 * @param {Element} element
	 * @param {String} action to propagate
	 */
	util.propagateAction = function (element, action) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (child[action] instanceof Function) {
	      child[action]();
	    } else {
	      util.propagateAction(child, action);
	    }
	  }
	};
	
	/**
	 * @param {String} string - string to be camelized
	 * @return {String} Camelized string
	 */
	util.camelize = function (string) {
	  return string.toLowerCase().replace(/-([a-z])/g, function (m, l) {
	    return l.toUpperCase();
	  });
	};
	
	/**
	 * @param {String} string - string to be hyphenated
	 * @return {String} Hyphenated string
	 */
	util.hyphenate = function (string) {
	  return string.replace(/([a-zA-Z])([A-Z])/g, '$1-$2').toLowerCase();
	};
	
	/**
	 * @param {String} selector - tag and class only
	 * @param {Object} style
	 * @param {Element}
	 */
	util.create = function () {
	  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var classList = selector.split('.');
	  var element = document.createElement(classList.shift() || 'div');
	
	  if (classList.length) {
	    element.className = classList.join(' ');
	  }
	
	  styler(element, style);
	
	  return element;
	};
	
	/**
	 * @param {String} html
	 * @return {Element}
	 */
	util.createElement = function (html) {
	  var wrapper = document.createElement('div');
	
	  if (html instanceof DocumentFragment) {
	    wrapper.appendChild(document.importNode(html, true));
	  } else {
	    wrapper.innerHTML = html.trim();
	  }
	
	  if (wrapper.children.length > 1) {
	    throw new Error(errorPrefix + ' "html" must be one wrapper element.');
	  }
	
	  var element = wrapper.children[0];
	  wrapper.children[0].remove();
	  return element;
	};
	
	/**
	 * @param {String} html
	 * @return {HTMLFragment}
	 */
	util.createFragment = function (html) {
	  var template = document.createElement('template');
	  template.innerHTML = html;
	  return document.importNode(template.content, true);
	};
	
	/*
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	util.extend = function (dst) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  for (var i = 0; i < args.length; i++) {
	    if (args[i]) {
	      var keys = Object.keys(args[i]);
	      for (var j = 0; j < keys.length; j++) {
	        var key = keys[j];
	        dst[key] = args[i][key];
	      }
	    }
	  }
	
	  return dst;
	};
	
	/**
	 * @param {Object} arrayLike
	 * @return {Array}
	 */
	util.arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.apply(arrayLike);
	};
	
	/**
	 * @param {String} jsonString
	 * @param {Object} [failSafe]
	 * @return {Object}
	 */
	util.parseJSONObjectSafely = function (jsonString) {
	  var failSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  try {
	    var result = JSON.parse('' + jsonString);
	    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result !== null) {
	      return result;
	    }
	  } catch (e) {
	    return failSafe;
	  }
	  return failSafe;
	};
	
	/**
	 * @param {String} path - path such as 'myApp.controllers.data.loadData'
	 * @return {Any} - whatever is located at that path
	 */
	util.findFromPath = function (path) {
	  path = path.split('.');
	  var el = window,
	      key;
	  while (key = path.shift()) {
	    // eslint-disable-line no-cond-assign
	    el = el[key];
	  }
	  return el;
	};
	
	/**
	 * @param {HTMLElement} container - Page or page-container that implements 'topPage'
	 * @return {HTMLElement|null} - Visible page element or null if not found.
	 */
	util.getTopPage = function (container) {
	  return container && (container.tagName.toLowerCase() === 'ons-page' ? container : container.topPage) || null;
	};
	
	/**
	 * @param {HTMLElement} container - Element where the search begins
	 * @return {HTMLElement|null} - Page element that contains the visible toolbar or null.
	 */
	util.findToolbarPage = function (container) {
	  var page = util.getTopPage(container);
	
	  if (page) {
	    if (page._canAnimateToolbar()) {
	      return page;
	    }
	
	    for (var i = 0; i < page._contentElement.children.length; i++) {
	      var nextPage = util.getTopPage(page._contentElement.children[i]);
	      if (nextPage && !/ons-tabbar/i.test(page._contentElement.children[i].tagName)) {
	        return util.findToolbarPage(nextPage);
	      }
	    }
	  }
	
	  return null;
	};
	
	/**
	 * @param {Element} element
	 * @param {String} eventName
	 * @param {Object} [detail]
	 * @return {CustomEvent}
	 */
	util.triggerElementEvent = function (target, eventName) {
	  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  var event = new CustomEvent(eventName, {
	    bubbles: true,
	    cancelable: true,
	    detail: detail
	  });
	
	  Object.keys(detail).forEach(function (key) {
	    event[key] = detail[key];
	  });
	
	  target.dispatchEvent(event);
	
	  return event;
	};
	
	/**
	 * @param {Element} target
	 * @param {String} modifierName
	 * @return {Boolean}
	 */
	util.hasModifier = function (target, modifierName) {
	  if (!target.hasAttribute('modifier')) {
	    return false;
	  }
	
	  return RegExp('(^|\\s+)' + modifierName + '($|\\s+)', 'i').test(target.getAttribute('modifier'));
	};
	
	/**
	 * @param {Element} target
	 * @param {String} modifierName
	 * @param {Object} options.autoStyle Maps the modifierName to the corresponding styled modifier.
	 * @param {Object} options.forceAutoStyle Ignores platform limitation.
	 * @return {Boolean} Whether it was added or not.
	 */
	util.addModifier = function (target, modifierName) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (options.autoStyle) {
	    modifierName = autoStyle.mapModifier(modifierName, target, options.forceAutoStyle);
	  }
	
	  if (util.hasModifier(target, modifierName)) {
	    return false;
	  }
	
	  target.setAttribute('modifier', ((target.getAttribute('modifier') || '') + ' ' + modifierName).trim());
	  return true;
	};
	
	/**
	 * @param {Element} target
	 * @param {String} modifierName
	 * @param {Object} options.autoStyle Maps the modifierName to the corresponding styled modifier.
	 * @param {Object} options.forceAutoStyle Ignores platform limitation.
	 * @return {Boolean} Whether it was found or not.
	 */
	util.removeModifier = function (target, modifierName) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (options.autoStyle) {
	    modifierName = autoStyle.mapModifier(modifierName, target, options.forceAutoStyle);
	  }
	
	  if (!target.getAttribute('modifier') || !util.hasModifier(target, modifierName)) {
	    return false;
	  }
	
	  var newModifiers = target.getAttribute('modifier').split(/\s+/).filter(function (m) {
	    return m && m !== modifierName;
	  });
	  newModifiers.length ? target.setAttribute('modifier', newModifiers.join(' ')) : target.removeAttribute('modifier');
	  return true;
	};
	
	/**
	 * @param {Element} target
	 * @param {String} modifierName
	 * @param {Boolean} options.force Forces modifier to be added or removed.
	 * @param {Object} options.autoStyle Maps the modifierName to the corresponding styled modifier.
	 * @param {Boolean} options.forceAutoStyle Ignores platform limitation.
	 * @return {Boolean} Whether it was found or not.
	 */
	util.toggleModifier = function () {
	  var options = arguments.length > 2 ? arguments.length <= 2 ? undefined : arguments[2] : {};
	  var force = typeof options === 'boolean' ? options : options.force;
	
	  var toggle = typeof force === 'boolean' ? force : !util.hasModifier.apply(util, arguments);
	  toggle ? util.addModifier.apply(util, arguments) : util.removeModifier.apply(util, arguments);
	};
	
	/**
	 * @param {Element} el
	 * @param {String} defaultClass
	 * @param {Object} scheme
	 */
	util.restoreClass = function (el, defaultClass, scheme) {
	  defaultClass.split(/\s+/).forEach(function (c) {
	    return c !== '' && !el.classList.contains(c) && el.classList.add(c);
	  });
	  el.hasAttribute('modifier') && ModifierUtil.refresh(el, scheme);
	};
	
	// TODO: FIX
	util.updateParentPosition = function (el) {
	  if (!el._parentUpdated && el.parentElement) {
	    if (window.getComputedStyle(el.parentElement).getPropertyValue('position') === 'static') {
	      el.parentElement.style.position = 'relative';
	    }
	    el._parentUpdated = true;
	  }
	};
	
	util.toggleAttribute = function (element, name, value) {
	  if (value) {
	    element.setAttribute(name, typeof value === 'boolean' ? '' : value);
	  } else {
	    element.removeAttribute(name);
	  }
	};
	
	util.bindListeners = function (element, listenerNames) {
	  listenerNames.forEach(function (name) {
	    var boundName = name.replace(/^_[a-z]/, '_bound' + name[1].toUpperCase());
	    element[boundName] = element[boundName] || element[name].bind(element);
	  });
	};
	
	util.each = function (obj, f) {
	  return Object.keys(obj).forEach(function (key) {
	    return f(key, obj[key]);
	  });
	};
	
	/**
	 * @param {Element} target
	 * @param {boolean} hasRipple
	 * @param {Object} attrs
	 */
	util.updateRipple = function (target, hasRipple) {
	  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (hasRipple === undefined) {
	    hasRipple = target.hasAttribute('ripple');
	  }
	
	  var rippleElement = util.findChild(target, 'ons-ripple');
	
	  if (hasRipple) {
	    if (!rippleElement) {
	      var element = document.createElement('ons-ripple');
	      Object.keys(attrs).forEach(function (key) {
	        return element.setAttribute(key, attrs[key]);
	      });
	      target.insertBefore(element, target.firstChild);
	    }
	  } else if (rippleElement) {
	    rippleElement.remove();
	  }
	};
	
	/**
	 * @param {String}
	 * @return {Object}
	 */
	util.animationOptionsParse = parse;
	
	/**
	 * @param {*} value
	 */
	util.isInteger = function (value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	};
	
	/**
	 * @return {Object} Deferred promise.
	 */
	util.defer = function () {
	  var deferred = {};
	  deferred.promise = new Promise(function (resolve, reject) {
	    deferred.resolve = resolve;
	    deferred.reject = reject;
	  });
	  return deferred;
	};
	
	/**
	 * Show warnings when they are enabled.
	 *
	 * @param {*} arguments to console.warn
	 */
	util.warn = function () {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!internal$1.config.warningsDisabled) {
	    var _console;
	
	    (_console = console).warn.apply(_console, [errorPrefix].concat(args));
	  }
	};
	
	var prevent = function prevent(e) {
	  return e.cancelable && e.preventDefault();
	};
	
	/**
	 * Prevent scrolling while draging horizontally on iOS.
	 *
	 * @param {gd} GestureDetector instance
	 */
	util.iosPreventScroll = function (gd) {
	  if (util.globals.actualMobileOS === 'ios') {
	    var clean = function clean(e) {
	      gd.off('touchmove', prevent);
	      gd.off('dragend', clean);
	    };
	
	    gd.on('touchmove', prevent);
	    gd.on('dragend', clean);
	  }
	};
	
	/**
	 * Prevents scroll in underlying pages on iOS. See #2220 #2274 #1949
	 *
	 * @param {el} HTMLElement that prevents the events
	 * @param {add} Boolean Add or remove event listeners
	 */
	util.iosPageScrollFix = function (add) {
	  // Full fix - May cause issues with UIWebView's momentum scroll
	  if (util.globals.actualMobileOS === 'ios') {
	    document.body.classList.toggle('ons-ios-scroll', add); // Allows custom and localized fixes (#2274)
	    if (!util.globals.isUIWebView || internal$1.config.forceUIWebViewScrollFix) {
	      document.body.classList.toggle('ons-ios-scroll-fix', add);
	    }
	  }
	};
	util.iosMaskScrollFix = function (el, add) {
	  // Half fix - only prevents scroll on masks
	  if (util.globals.isUIWebView) {
	    var action = (add ? 'add' : 'remove') + 'EventListener';
	    el[action]('touchmove', prevent, false);
	  }
	};
	
	/**
	 * Distance and deltaTime filter some weird dragstart events that are not fired immediately.
	 *
	 * @param {event}
	 */
	util.isValidGesture = function (event) {
	  return event.gesture !== undefined && (event.gesture.distance <= 15 || event.gesture.deltaTime <= 100);
	};
	
	util.checkMissingImport = function () {
	  for (var _len3 = arguments.length, elementNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    elementNames[_key3] = arguments[_key3];
	  }
	
	  elementNames.forEach(function (name) {
	    if (!onsElements[name]) {
	      throw new Error(errorPrefix + ' Ons' + name + ' is required but was not imported (Custom Elements).');
	    }
	  });
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Minimal animation library for managing css transition on mobile browsers.
	 */
	var TIMEOUT_RATIO = 1.4;
	
	var util$3 = {};
	
	// capitalize string
	util$3.capitalize = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	/**
	 * @param {Object} params
	 * @param {String} params.property
	 * @param {Float} params.duration
	 * @param {String} params.timing
	 */
	util$3.buildTransitionValue = function (params) {
	  params.property = params.property || 'all';
	  params.duration = params.duration || 0.4;
	  params.timing = params.timing || 'linear';
	
	  var props = params.property.split(/ +/);
	
	  return props.map(function (prop) {
	    return prop + ' ' + params.duration + 's ' + params.timing;
	  }).join(', ');
	};
	
	/**
	 * Add an event handler on "transitionend" event.
	 */
	util$3.onceOnTransitionEnd = function (element, callback) {
	  if (!element) {
	    return function () {};
	  }
	
	  var fn = function fn(event) {
	    if (element == event.target) {
	      event.stopPropagation();
	      removeListeners();
	
	      callback();
	    }
	  };
	
	  var removeListeners = function removeListeners() {
	    util$3._transitionEndEvents.forEach(function (eventName) {
	      element.removeEventListener(eventName, fn, false);
	    });
	  };
	
	  util$3._transitionEndEvents.forEach(function (eventName) {
	    element.addEventListener(eventName, fn, false);
	  });
	
	  return removeListeners;
	};
	
	util$3._transitionEndEvents = function () {
	
	  if ('ontransitionend' in window) {
	    return ['transitionend'];
	  }
	
	  if ('onwebkittransitionend' in window) {
	    return ['webkitTransitionEnd'];
	  }
	
	  if (util$3.vendorPrefix === 'webkit' || util$3.vendorPrefix === 'o' || util$3.vendorPrefix === 'moz' || util$3.vendorPrefix === 'ms') {
	    return [util$3.vendorPrefix + 'TransitionEnd', 'transitionend'];
	  }
	
	  return [];
	}();
	
	util$3._cssPropertyDict = function () {
	  var styles = window.getComputedStyle(document.documentElement, '');
	  var dict = {};
	  var a = 'A'.charCodeAt(0);
	  var z = 'z'.charCodeAt(0);
	
	  var upper = function upper(s) {
	    return s.substr(1).toUpperCase();
	  };
	
	  for (var i = 0; i < styles.length; i++) {
	
	    var key = styles[i].replace(/^[-]+/, '').replace(/[-][a-z]/g, upper).replace(/^moz/, 'Moz');
	
	    if (a <= key.charCodeAt(0) && z >= key.charCodeAt(0)) {
	      if (key !== 'cssText' && key !== 'parentText') {
	        dict[key] = true;
	      }
	    }
	  }
	
	  return dict;
	}();
	
	util$3.hasCssProperty = function (name) {
	  return name in util$3._cssPropertyDict;
	};
	
	/**
	 * Vendor prefix for css property.
	 */
	util$3.vendorPrefix = function () {
	  var styles = window.getComputedStyle(document.documentElement, ''),
	      pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	  return pre;
	}();
	
	util$3.forceLayoutAtOnce = function (elements, callback) {
	  this.batchImmediate(function () {
	    elements.forEach(function (element) {
	      // force layout
	      element.offsetHeight;
	    });
	    callback();
	  });
	};
	
	util$3.batchImmediate = function () {
	  var callbacks = [];
	
	  return function (callback) {
	    if (callbacks.length === 0) {
	      setImmediate(function () {
	        var concreateCallbacks = callbacks.slice(0);
	        callbacks = [];
	        concreateCallbacks.forEach(function (callback) {
	          callback();
	        });
	      });
	    }
	
	    callbacks.push(callback);
	  };
	}();
	
	util$3.batchAnimationFrame = function () {
	  var callbacks = [];
	
	  var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	    setTimeout(callback, 1000 / 60);
	  };
	
	  return function (callback) {
	    if (callbacks.length === 0) {
	      raf(function () {
	        var concreateCallbacks = callbacks.slice(0);
	        callbacks = [];
	        concreateCallbacks.forEach(function (callback) {
	          callback();
	        });
	      });
	    }
	
	    callbacks.push(callback);
	  };
	}();
	
	util$3.transitionPropertyName = function () {
	  if (util$3.hasCssProperty('transitionDuration')) {
	    return 'transition';
	  }
	
	  if (util$3.hasCssProperty(util$3.vendorPrefix + 'TransitionDuration')) {
	    return util$3.vendorPrefix + 'Transition';
	  }
	
	  throw new Error('Invalid state');
	}();
	
	/**
	 * @param {HTMLElement} element
	 */
	var Animit = function Animit(element) {
	  if (!(this instanceof Animit)) {
	    return new Animit(element);
	  }
	
	  if (element instanceof HTMLElement) {
	    this.elements = [element];
	  } else if (Object.prototype.toString.call(element) === '[object Array]') {
	    this.elements = element;
	  } else {
	    throw new Error('First argument must be an array or an instance of HTMLElement.');
	  }
	
	  this.transitionQueue = [];
	  this.lastStyleAttributeDict = [];
	};
	
	Animit.prototype = {
	
	  /**
	   * @property {Array}
	   */
	  transitionQueue: undefined,
	
	  /**
	   * @property {Array}
	   */
	  elements: undefined,
	
	  /**
	   * Start animation sequence with passed animations.
	   *
	   * @param {Function} callback
	   */
	  play: function play(callback) {
	    if (typeof callback === 'function') {
	      this.transitionQueue.push(function (done) {
	        callback();
	        done();
	      });
	    }
	
	    this.startAnimation();
	
	    return this;
	  },
	
	  /**
	   * Queue transition animations or other function.
	   *
	   * e.g. animit(elt).queue({color: 'red'})
	   * e.g. animit(elt).queue({color: 'red'}, {duration: 0.4})
	   * e.g. animit(elt).queue({css: {color: 'red'}, duration: 0.2})
	   *
	   * @param {Object|Animit.Transition|Function} transition
	   * @param {Object} [options]
	   */
	  queue: function queue(transition, options) {
	    var queue = this.transitionQueue;
	
	    if (transition && options) {
	      options.css = transition;
	      transition = new Animit.Transition(options);
	    }
	
	    if (!(transition instanceof Function || transition instanceof Animit.Transition)) {
	      if (transition.css) {
	        transition = new Animit.Transition(transition);
	      } else {
	        transition = new Animit.Transition({
	          css: transition
	        });
	      }
	    }
	
	    if (transition instanceof Function) {
	      queue.push(transition);
	    } else if (transition instanceof Animit.Transition) {
	      queue.push(transition.build());
	    } else {
	      throw new Error('Invalid arguments');
	    }
	
	    return this;
	  },
	
	  /**
	   * Queue transition animations.
	   *
	   * @param {Float} seconds
	   */
	  wait: function wait(seconds) {
	    if (seconds > 0) {
	      this.transitionQueue.push(function (done) {
	        setTimeout(done, 1000 * seconds);
	      });
	    }
	
	    return this;
	  },
	
	  saveStyle: function saveStyle() {
	
	    this.transitionQueue.push(function (done) {
	      this.elements.forEach(function (element, index) {
	        var css = this.lastStyleAttributeDict[index] = {};
	
	        for (var i = 0; i < element.style.length; i++) {
	          css[element.style[i]] = element.style[element.style[i]];
	        }
	      }.bind(this));
	      done();
	    }.bind(this));
	
	    return this;
	  },
	
	  /**
	   * Restore element's style.
	   *
	   * @param {Object} [options]
	   * @param {Float} [options.duration]
	   * @param {String} [options.timing]
	   * @param {String} [options.transition]
	   */
	  restoreStyle: function restoreStyle(options) {
	    options = options || {};
	    var self = this;
	
	    if (options.transition && !options.duration) {
	      throw new Error('"options.duration" is required when "options.transition" is enabled.');
	    }
	
	    var transitionName = util$3.transitionPropertyName;
	
	    if (options.transition || options.duration && options.duration > 0) {
	      var transitionValue = options.transition || 'all ' + options.duration + 's ' + (options.timing || 'linear');
	
	      this.transitionQueue.push(function (done) {
	        var elements = this.elements;
	        var timeoutId;
	
	        var clearTransition = function clearTransition() {
	          elements.forEach(function (element) {
	            element.style[transitionName] = '';
	          });
	        };
	
	        // add "transitionend" event handler
	        var removeListeners = util$3.onceOnTransitionEnd(elements[0], function () {
	          clearTimeout(timeoutId);
	          clearTransition();
	          done();
	        });
	
	        // for fail safe.
	        timeoutId = setTimeout(function () {
	          removeListeners();
	          clearTransition();
	          done();
	        }, options.duration * 1000 * TIMEOUT_RATIO);
	
	        // transition and style settings
	        elements.forEach(function (element, index) {
	
	          var css = self.lastStyleAttributeDict[index];
	
	          if (!css) {
	            throw new Error('restoreStyle(): The style is not saved. Invoke saveStyle() before.');
	          }
	
	          self.lastStyleAttributeDict[index] = undefined;
	
	          var name;
	          for (var i = 0, len = element.style.length; i < len; i++) {
	            name = element.style[i];
	            if (css[name] === undefined) {
	              css[name] = '';
	            }
	          }
	
	          element.style[transitionName] = transitionValue;
	
	          Object.keys(css).forEach(function (key) {
	            if (key !== transitionName) {
	              element.style[key] = css[key];
	            }
	          });
	
	          element.style[transitionName] = transitionValue;
	        });
	      });
	    } else {
	      this.transitionQueue.push(function (done) {
	        reset();
	        done();
	      });
	    }
	
	    return this;
	
	    function reset() {
	      // Clear transition animation settings.
	      self.elements.forEach(function (element, index) {
	        element.style[transitionName] = 'none';
	
	        var css = self.lastStyleAttributeDict[index];
	
	        if (!css) {
	          throw new Error('restoreStyle(): The style is not saved. Invoke saveStyle() before.');
	        }
	
	        self.lastStyleAttributeDict[index] = undefined;
	
	        for (var i = 0, name = ''; i < element.style.length; i++) {
	          name = element.style[i];
	          if (typeof css[element.style[i]] === 'undefined') {
	            css[element.style[i]] = '';
	          }
	        }
	
	        Object.keys(css).forEach(function (key) {
	          element.style[key] = css[key];
	        });
	      });
	    }
	  },
	
	  /**
	   * Start animation sequence.
	   */
	  startAnimation: function startAnimation() {
	    this._dequeueTransition();
	
	    return this;
	  },
	
	  _dequeueTransition: function _dequeueTransition() {
	    var transition = this.transitionQueue.shift();
	    if (this._currentTransition) {
	      throw new Error('Current transition exists.');
	    }
	    this._currentTransition = transition;
	    var self = this;
	    var called = false;
	
	    var done = function done() {
	      if (!called) {
	        called = true;
	        self._currentTransition = undefined;
	        self._dequeueTransition();
	      } else {
	        throw new Error('Invalid state: This callback is called twice.');
	      }
	    };
	
	    if (transition) {
	      transition.call(this, done);
	    }
	  }
	
	};
	
	/**
	 * @param {Animit} arguments
	 */
	Animit.runAll = function () /* arguments... */{
	  for (var i = 0; i < arguments.length; i++) {
	    arguments[i].play();
	  }
	};
	
	/**
	 * @param {Object} options
	 * @param {Float} [options.duration]
	 * @param {String} [options.property]
	 * @param {String} [options.timing]
	 */
	Animit.Transition = function (options) {
	  this.options = options || {};
	  this.options.duration = this.options.duration || 0;
	  this.options.timing = this.options.timing || 'linear';
	  this.options.css = this.options.css || {};
	  this.options.property = this.options.property || 'all';
	};
	
	Animit.Transition.prototype = {
	
	  /**
	   * @param {HTMLElement} element
	   * @return {Function}
	   */
	  build: function build() {
	
	    if (Object.keys(this.options.css).length === 0) {
	      throw new Error('options.css is required.');
	    }
	
	    var css = createActualCssProps(this.options.css);
	
	    if (this.options.duration > 0) {
	      var transitionValue = util$3.buildTransitionValue(this.options);
	      var self = this;
	
	      return function (callback) {
	        var elements = this.elements;
	        var timeout = self.options.duration * 1000 * TIMEOUT_RATIO;
	        var timeoutId;
	
	        var removeListeners = util$3.onceOnTransitionEnd(elements[0], function () {
	          clearTimeout(timeoutId);
	          callback();
	        });
	
	        timeoutId = setTimeout(function () {
	          removeListeners();
	          callback();
	        }, timeout);
	
	        elements.forEach(function (element) {
	          element.style[util$3.transitionPropertyName] = transitionValue;
	
	          Object.keys(css).forEach(function (name) {
	            element.style[name] = css[name];
	          });
	        });
	      };
	    }
	
	    if (this.options.duration <= 0) {
	      return function (callback) {
	        var elements = this.elements;
	
	        elements.forEach(function (element) {
	          element.style[util$3.transitionPropertyName] = '';
	
	          Object.keys(css).forEach(function (name) {
	            element.style[name] = css[name];
	          });
	        });
	
	        if (elements.length > 0) {
	          util$3.forceLayoutAtOnce(elements, function () {
	            util$3.batchAnimationFrame(callback);
	          });
	        } else {
	          util$3.batchAnimationFrame(callback);
	        }
	      };
	    }
	
	    function createActualCssProps(css) {
	      var result = {};
	
	      Object.keys(css).forEach(function (name) {
	        var value = css[name];
	
	        if (util$3.hasCssProperty(name)) {
	          result[name] = value;
	          return;
	        }
	
	        var prefixed = util$3.vendorPrefix + util$3.capitalize(name);
	        if (util$3.hasCssProperty(prefixed)) {
	          result[prefixed] = value;
	        } else {
	          result[prefixed] = value;
	          result[name] = value;
	        }
	      });
	
	      return result;
	    }
	  }
	};
	
	/*
	 * Gesture detector library that forked from github.com/EightMedia/hammer.js.
	 */
	
	var Event$1;
	var Utils;
	var Detection;
	var PointerEvent;
	
	/**
	 * @object ons.GestureDetector
	 * @category gesture
	 * @description
	 *   [en]Utility class for gesture detection.[/en]
	 *   [ja]ジェスチャを検知するためのユーティリティクラスです。[/ja]
	 */
	
	/**
	 * @method constructor
	 * @signature constructor(element[, options])
	 * @description
	 *  [en]Create a new GestureDetector instance.[/en]
	 *  [ja]GestureDetectorのインスタンスを生成します。[/ja]
	 * @param {Element} element
	 *   [en]Name of the event.[/en]
	 *   [ja]ジェスチャを検知するDOM要素を指定します。[/ja]
	 * @param {Object} [options]
	 *   [en]Options object.[/en]
	 *   [ja]オプションを指定します。[/ja]
	 * @return {ons.GestureDetector.Instance}
	 */
	var GestureDetector = function GestureDetector(element, options) {
	  return new GestureDetector.Instance(element, options || {});
	};
	
	/**
	 * default settings.
	 * more settings are defined per gesture at `/gestures`. Each gesture can be disabled/enabled
	 * by setting it's name (like `swipe`) to false.
	 * You can set the defaults for all instances by changing this object before creating an instance.
	 * @example
	 * ````
	 *  GestureDetector.defaults.drag = false;
	 *  GestureDetector.defaults.behavior.touchAction = 'pan-y';
	 *  delete GestureDetector.defaults.behavior.userSelect;
	 * ````
	 * @property defaults
	 * @type {Object}
	 */
	GestureDetector.defaults = {
	  behavior: {
	    // userSelect: 'none', // Also disables selection in `input` children
	    touchAction: 'pan-y',
	    touchCallout: 'none',
	    contentZooming: 'none',
	    userDrag: 'none',
	    tapHighlightColor: 'rgba(0,0,0,0)'
	  }
	};
	
	/**
	 * GestureDetector document where the base events are added at
	 * @property DOCUMENT
	 * @type {HTMLElement}
	 * @default window.document
	 */
	GestureDetector.DOCUMENT = document;
	
	/**
	 * detect support for pointer events
	 * @property HAS_POINTEREVENTS
	 * @type {Boolean}
	 */
	GestureDetector.HAS_POINTEREVENTS = navigator.pointerEnabled || navigator.msPointerEnabled;
	
	/**
	 * detect support for touch events
	 * @property HAS_TOUCHEVENTS
	 * @type {Boolean}
	 */
	GestureDetector.HAS_TOUCHEVENTS = 'ontouchstart' in window;
	
	/**
	 * detect mobile browsers
	 * @property IS_MOBILE
	 * @type {Boolean}
	 */
	GestureDetector.IS_MOBILE = /mobile|tablet|ip(ad|hone|od)|android|silk/i.test(navigator.userAgent);
	
	/**
	 * detect if we want to support mouseevents at all
	 * @property NO_MOUSEEVENTS
	 * @type {Boolean}
	 */
	GestureDetector.NO_MOUSEEVENTS = GestureDetector.HAS_TOUCHEVENTS && GestureDetector.IS_MOBILE || GestureDetector.HAS_POINTEREVENTS;
	
	/**
	 * interval in which GestureDetector recalculates current velocity/direction/angle in ms
	 * @property CALCULATE_INTERVAL
	 * @type {Number}
	 * @default 25
	 */
	GestureDetector.CALCULATE_INTERVAL = 25;
	
	/**
	 * eventtypes per touchevent (start, move, end) are filled by `Event.determineEventTypes` on `setup`
	 * the object contains the DOM event names per type (`EVENT_START`, `EVENT_MOVE`, `EVENT_END`)
	 * @property EVENT_TYPES
	 * @private
	 * @writeOnce
	 * @type {Object}
	 */
	var EVENT_TYPES = {};
	
	/**
	 * direction strings, for safe comparisons
	 * @property DIRECTION_DOWN|LEFT|UP|RIGHT
	 * @final
	 * @type {String}
	 * @default 'down' 'left' 'up' 'right'
	 */
	var DIRECTION_DOWN = GestureDetector.DIRECTION_DOWN = 'down';
	var DIRECTION_LEFT = GestureDetector.DIRECTION_LEFT = 'left';
	var DIRECTION_UP = GestureDetector.DIRECTION_UP = 'up';
	var DIRECTION_RIGHT = GestureDetector.DIRECTION_RIGHT = 'right';
	
	/**
	 * pointertype strings, for safe comparisons
	 * @property POINTER_MOUSE|TOUCH|PEN
	 * @final
	 * @type {String}
	 * @default 'mouse' 'touch' 'pen'
	 */
	var POINTER_MOUSE = GestureDetector.POINTER_MOUSE = 'mouse';
	var POINTER_TOUCH = GestureDetector.POINTER_TOUCH = 'touch';
	var POINTER_PEN = GestureDetector.POINTER_PEN = 'pen';
	
	/**
	 * eventtypes
	 * @property EVENT_START|MOVE|END|RELEASE|TOUCH
	 * @final
	 * @type {String}
	 * @default 'start' 'change' 'move' 'end' 'release' 'touch'
	 */
	var EVENT_START = GestureDetector.EVENT_START = 'start';
	var EVENT_MOVE = GestureDetector.EVENT_MOVE = 'move';
	var EVENT_END = GestureDetector.EVENT_END = 'end';
	var EVENT_RELEASE = GestureDetector.EVENT_RELEASE = 'release';
	var EVENT_TOUCH = GestureDetector.EVENT_TOUCH = 'touch';
	
	/**
	 * if the window events are set...
	 * @property READY
	 * @writeOnce
	 * @type {Boolean}
	 * @default false
	 */
	GestureDetector.READY = false;
	
	/**
	 * plugins namespace
	 * @property plugins
	 * @type {Object}
	 */
	GestureDetector.plugins = GestureDetector.plugins || {};
	
	/**
	 * gestures namespace
	 * see `/gestures` for the definitions
	 * @property gestures
	 * @type {Object}
	 */
	GestureDetector.gestures = GestureDetector.gestures || {};
	
	/**
	 * setup events to detect gestures on the document
	 * this function is called when creating an new instance
	 * @private
	 */
	function setup(opts) {
	  if (GestureDetector.READY) {
	    return;
	  }
	
	  // find what eventtypes we add listeners to
	  Event$1.determineEventTypes();
	
	  // Register all gestures inside GestureDetector.gestures
	  Utils.each(GestureDetector.gestures, function (gesture) {
	    Detection.register(gesture);
	  });
	
	  // Add touch events on the document
	  Event$1.onTouch(GestureDetector.DOCUMENT, EVENT_MOVE, Detection.detect, opts);
	  Event$1.onTouch(GestureDetector.DOCUMENT, EVENT_END, Detection.detect, opts);
	
	  // GestureDetector is ready...!
	  GestureDetector.READY = true;
	}
	
	/**
	 * @module GestureDetector
	 *
	 * @class Utils
	 * @static
	 */
	Utils = GestureDetector.utils = {
	  /**
	   * extend method, could also be used for cloning when `dest` is an empty object.
	   * changes the dest object
	   * @param {Object} dest
	   * @param {Object} src
	   * @param {Boolean} [merge=false]  do a merge
	   * @return {Object} dest
	   */
	  extend: function extend(dest, src, merge) {
	    for (var key in src) {
	      if (src.hasOwnProperty(key) && (dest[key] === undefined || !merge)) {
	        dest[key] = src[key];
	      }
	    }
	    return dest;
	  },
	
	  /**
	   * simple addEventListener wrapper
	   * @param {HTMLElement} element
	   * @param {String} type
	   * @param {Function} handler
	   */
	  on: function on(element, type, handler, opt) {
	    util.addEventListener(element, type, handler, opt, true);
	  },
	
	  /**
	   * simple removeEventListener wrapper
	   * @param {HTMLElement} element
	   * @param {String} type
	   * @param {Function} handler
	   */
	  off: function off(element, type, handler, opt) {
	    util.removeEventListener(element, type, handler, opt, true);
	  },
	
	  /**
	   * forEach over arrays and objects
	   * @param {Object|Array} obj
	   * @param {Function} iterator
	   * @param {any} iterator.item
	   * @param {Number} iterator.index
	   * @param {Object|Array} iterator.obj the source object
	   * @param {Object} context value to use as `this` in the iterator
	   */
	  each: function each(obj, iterator, context) {
	    var i, len;
	
	    // native forEach on arrays
	    if ('forEach' in obj) {
	      obj.forEach(iterator, context);
	      // arrays
	    } else if (obj.length !== undefined) {
	      for (i = 0, len = obj.length; i < len; i++) {
	        if (iterator.call(context, obj[i], i, obj) === false) {
	          return;
	        }
	      }
	      // objects
	    } else {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj) === false) {
	          return;
	        }
	      }
	    }
	  },
	
	  /**
	   * find if a string contains the string using indexOf
	   * @param {String} src
	   * @param {String} find
	   * @return {Boolean} found
	   */
	  inStr: function inStr(src, find) {
	    return src.indexOf(find) > -1;
	  },
	
	  /**
	   * find if a array contains the object using indexOf or a simple polyfill
	   * @param {String} src
	   * @param {String} find
	   * @return {Boolean|Number} false when not found, or the index
	   */
	  inArray: function inArray(src, find, deep) {
	    if (deep) {
	      for (var i = 0, len = src.length; i < len; i++) {
	        // Array.findIndex
	        if (Object.keys(find).every(function (key) {
	          return src[i][key] === find[key];
	        })) {
	          return i;
	        }
	      }
	      return -1;
	    }
	
	    if (src.indexOf) {
	      return src.indexOf(find);
	    } else {
	      for (var i = 0, len = src.length; i < len; i++) {
	        if (src[i] === find) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  },
	
	  /**
	   * convert an array-like object (`arguments`, `touchlist`) to an array
	   * @param {Object} obj
	   * @return {Array}
	   */
	  toArray: function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	  },
	
	  /**
	   * find if a node is in the given parent
	   * @param {HTMLElement} node
	   * @param {HTMLElement} parent
	   * @return {Boolean} found
	   */
	  hasParent: function hasParent(node, parent) {
	    while (node) {
	      if (node == parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  },
	
	  /**
	   * get the center of all the touches
	   * @param {Array} touches
	   * @return {Object} center contains `pageX`, `pageY`, `clientX` and `clientY` properties
	   */
	  getCenter: function getCenter(touches) {
	    var pageX = [],
	        pageY = [],
	        clientX = [],
	        clientY = [],
	        min = Math.min,
	        max = Math.max;
	
	    // no need to loop when only one touch
	    if (touches.length === 1) {
	      return {
	        pageX: touches[0].pageX,
	        pageY: touches[0].pageY,
	        clientX: touches[0].clientX,
	        clientY: touches[0].clientY
	      };
	    }
	
	    Utils.each(touches, function (touch) {
	      pageX.push(touch.pageX);
	      pageY.push(touch.pageY);
	      clientX.push(touch.clientX);
	      clientY.push(touch.clientY);
	    });
	
	    return {
	      pageX: (min.apply(Math, pageX) + max.apply(Math, pageX)) / 2,
	      pageY: (min.apply(Math, pageY) + max.apply(Math, pageY)) / 2,
	      clientX: (min.apply(Math, clientX) + max.apply(Math, clientX)) / 2,
	      clientY: (min.apply(Math, clientY) + max.apply(Math, clientY)) / 2
	    };
	  },
	
	  /**
	   * calculate the velocity between two points. unit is in px per ms.
	   * @param {Number} deltaTime
	   * @param {Number} deltaX
	   * @param {Number} deltaY
	   * @return {Object} velocity `x` and `y`
	   */
	  getVelocity: function getVelocity(deltaTime, deltaX, deltaY) {
	    return {
	      x: Math.abs(deltaX / deltaTime) || 0,
	      y: Math.abs(deltaY / deltaTime) || 0
	    };
	  },
	
	  /**
	   * calculate the angle between two coordinates
	   * @param {Touch} touch1
	   * @param {Touch} touch2
	   * @return {Number} angle
	   */
	  getAngle: function getAngle(touch1, touch2) {
	    var x = touch2.clientX - touch1.clientX,
	        y = touch2.clientY - touch1.clientY;
	
	    return Math.atan2(y, x) * 180 / Math.PI;
	  },
	
	  /**
	   * do a small comparison to get the direction between two touches.
	   * @param {Touch} touch1
	   * @param {Touch} touch2
	   * @return {String} direction matches `DIRECTION_LEFT|RIGHT|UP|DOWN`
	   */
	  getDirection: function getDirection(touch1, touch2) {
	    var x = Math.abs(touch1.clientX - touch2.clientX),
	        y = Math.abs(touch1.clientY - touch2.clientY);
	
	    if (x >= y) {
	      return touch1.clientX - touch2.clientX > 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return touch1.clientY - touch2.clientY > 0 ? DIRECTION_UP : DIRECTION_DOWN;
	  },
	
	  /**
	   * calculate the distance between two touches
	   * @param {Touch}touch1
	   * @param {Touch} touch2
	   * @return {Number} distance
	   */
	  getDistance: function getDistance(touch1, touch2) {
	    var x = touch2.clientX - touch1.clientX,
	        y = touch2.clientY - touch1.clientY;
	
	    return Math.sqrt(x * x + y * y);
	  },
	
	  /**
	   * calculate the scale factor between two touchLists
	   * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	   * @param {Array} start array of touches
	   * @param {Array} end array of touches
	   * @return {Number} scale
	   */
	  getScale: function getScale(start, end) {
	    // need two fingers...
	    if (start.length >= 2 && end.length >= 2) {
	      return this.getDistance(end[0], end[1]) / this.getDistance(start[0], start[1]);
	    }
	    return 1;
	  },
	
	  /**
	   * calculate the rotation degrees between two touchLists
	   * @param {Array} start array of touches
	   * @param {Array} end array of touches
	   * @return {Number} rotation
	   */
	  getRotation: function getRotation(start, end) {
	    // need two fingers
	    if (start.length >= 2 && end.length >= 2) {
	      return this.getAngle(end[1], end[0]) - this.getAngle(start[1], start[0]);
	    }
	    return 0;
	  },
	
	  /**
	   * find out if the direction is vertical   *
	   * @param {String} direction matches `DIRECTION_UP|DOWN`
	   * @return {Boolean} is_vertical
	   */
	  isVertical: function isVertical(direction) {
	    return direction == DIRECTION_UP || direction == DIRECTION_DOWN;
	  },
	
	  /**
	   * set css properties with their prefixes
	   * @param {HTMLElement} element
	   * @param {String} prop
	   * @param {String} value
	   * @param {Boolean} [toggle=true]
	   * @return {Boolean}
	   */
	  setPrefixedCss: function setPrefixedCss(element, prop, value, toggle) {
	    var prefixes = ['', 'Webkit', 'Moz', 'O', 'ms'];
	    prop = Utils.toCamelCase(prop);
	
	    for (var i = 0; i < prefixes.length; i++) {
	      var p = prop;
	      // prefixes
	      if (prefixes[i]) {
	        p = prefixes[i] + p.slice(0, 1).toUpperCase() + p.slice(1);
	      }
	
	      // test the style
	      if (p in element.style) {
	        element.style[p] = (toggle === null || toggle) && value || '';
	        break;
	      }
	    }
	  },
	
	  /**
	   * toggle browser default behavior by setting css properties.
	   * `userSelect='none'` also sets `element.onselectstart` to false
	   * `userDrag='none'` also sets `element.ondragstart` to false
	   *
	   * @param {HtmlElement} element
	   * @param {Object} props
	   * @param {Boolean} [toggle=true]
	   */
	  toggleBehavior: function toggleBehavior(element, props, toggle) {
	    if (!props || !element || !element.style) {
	      return;
	    }
	
	    // set the css properties
	    Utils.each(props, function (value, prop) {
	      Utils.setPrefixedCss(element, prop, value, toggle);
	    });
	
	    var falseFn = toggle && function () {
	      return false;
	    };
	
	    // also the disable onselectstart
	    if (props.userSelect == 'none') {
	      element.onselectstart = falseFn;
	    }
	    // and disable ondragstart
	    if (props.userDrag == 'none') {
	      element.ondragstart = falseFn;
	    }
	  },
	
	  /**
	   * convert a string with underscores to camelCase
	   * so prevent_default becomes preventDefault
	   * @param {String} str
	   * @return {String} camelCaseStr
	   */
	  toCamelCase: function toCamelCase(str) {
	    return str.replace(/[_-]([a-z])/g, function (s) {
	      return s[1].toUpperCase();
	    });
	  }
	};
	
	/**
	 * @module GestureDetector
	 */
	/**
	 * @class Event
	 * @static
	 */
	Event$1 = GestureDetector.event = {
	  /**
	   * when touch events have been fired, this is true
	   * this is used to stop mouse events
	   * @property prevent_mouseevents
	   * @private
	   * @type {Boolean}
	   */
	  preventMouseEvents: false,
	
	  /**
	   * if EVENT_START has been fired
	   * @property started
	   * @private
	   * @type {Boolean}
	   */
	  started: false,
	
	  /**
	   * when the mouse is hold down, this is true
	   * @property should_detect
	   * @private
	   * @type {Boolean}
	   */
	  shouldDetect: false,
	
	  /**
	   * simple event binder with a hook and support for multiple types
	   * @param {HTMLElement} element
	   * @param {String} type
	   * @param {Function} handler
	   * @param {Object} [opt]
	   * @param {Function} [hook]
	   * @param {Object} hook.type
	   */
	  on: function on(element, type, handler, opt, hook) {
	    var types = type.split(' ');
	    Utils.each(types, function (type) {
	      Utils.on(element, type, handler, opt);
	      hook && hook(type);
	    });
	  },
	
	  /**
	   * simple event unbinder with a hook and support for multiple types
	   * @param {HTMLElement} element
	   * @param {String} type
	   * @param {Function} handler
	   * @param {Object} [opt]
	   * @param {Function} [hook]
	   * @param {Object} hook.type
	   */
	  off: function off(element, type, handler, opt, hook) {
	    var types = type.split(' ');
	    Utils.each(types, function (type) {
	      Utils.off(element, type, handler, opt);
	      hook && hook(type);
	    });
	  },
	
	  /**
	   * the core touch event handler.
	   * this finds out if we should to detect gestures
	   * @param {HTMLElement} element
	   * @param {String} eventType matches `EVENT_START|MOVE|END`
	   * @param {Function} handler
	   * @return onTouchHandler {Function} the core event handler
	   */
	  onTouch: function onTouch(element, eventType, handler, opt) {
	    var self = this;
	
	    var onTouchHandler = function onTouchHandler(ev) {
	      var srcType = ev.type.toLowerCase(),
	          isPointer = GestureDetector.HAS_POINTEREVENTS,
	          isMouse = Utils.inStr(srcType, 'mouse'),
	          triggerType;
	
	      // if we are in a mouseevent, but there has been a touchevent triggered in this session
	      // we want to do nothing. simply break out of the event.
	      if (isMouse && self.preventMouseEvents) {
	        return;
	
	        // mousebutton must be down
	      } else if (isMouse && eventType == EVENT_START && ev.button === 0) {
	        self.preventMouseEvents = false;
	        self.shouldDetect = true;
	      } else if (isPointer && eventType == EVENT_START) {
	        self.shouldDetect = ev.buttons === 1 || PointerEvent.matchType(POINTER_TOUCH, ev);
	        // just a valid start event, but no mouse
	      } else if (!isMouse && eventType == EVENT_START) {
	        self.preventMouseEvents = true;
	        self.shouldDetect = true;
	      }
	
	      // update the pointer event before entering the detection
	      if (isPointer && eventType != EVENT_END) {
	        PointerEvent.updatePointer(eventType, ev);
	      }
	
	      // we are in a touch/down state, so allowed detection of gestures
	      if (self.shouldDetect) {
	        triggerType = self.doDetect.call(self, ev, eventType, element, handler);
	      }
	
	      // ...and we are done with the detection
	      // so reset everything to start each detection totally fresh
	      if (triggerType == EVENT_END) {
	        self.preventMouseEvents = false;
	        self.shouldDetect = false;
	        PointerEvent.reset();
	        // update the pointerevent object after the detection
	      }
	
	      if (isPointer && eventType == EVENT_END) {
	        PointerEvent.updatePointer(eventType, ev);
	      }
	    };
	
	    this.on(element, EVENT_TYPES[eventType], onTouchHandler, opt);
	    return onTouchHandler;
	  },
	
	  /**
	   * the core detection method
	   * this finds out what GestureDetector-touch-events to trigger
	   * @param {Object} ev
	   * @param {String} eventType matches `EVENT_START|MOVE|END`
	   * @param {HTMLElement} element
	   * @param {Function} handler
	   * @return {String} triggerType matches `EVENT_START|MOVE|END`
	   */
	  doDetect: function doDetect(ev, eventType, element, handler) {
	    var touchList = this.getTouchList(ev, eventType);
	    var touchListLength = touchList.length;
	    var triggerType = eventType;
	    var triggerChange = touchList.trigger; // used by fakeMultitouch plugin
	    var changedLength = touchListLength;
	
	    // at each touchstart-like event we want also want to trigger a TOUCH event...
	    if (eventType == EVENT_START) {
	      triggerChange = EVENT_TOUCH;
	      // ...the same for a touchend-like event
	    } else if (eventType == EVENT_END) {
	      triggerChange = EVENT_RELEASE;
	
	      // keep track of how many touches have been removed
	      changedLength = touchList.length - (ev.changedTouches ? ev.changedTouches.length : 1);
	    }
	
	    // after there are still touches on the screen,
	    // we just want to trigger a MOVE event. so change the START or END to a MOVE
	    // but only after detection has been started, the first time we actually want a START
	    if (changedLength > 0 && this.started) {
	      triggerType = EVENT_MOVE;
	    }
	
	    // detection has been started, we keep track of this, see above
	    this.started = true;
	
	    // generate some event data, some basic information
	    var evData = this.collectEventData(element, triggerType, touchList, ev);
	
	    // trigger the triggerType event before the change (TOUCH, RELEASE) events
	    // but the END event should be at last
	    if (eventType != EVENT_END) {
	      handler.call(Detection, evData);
	    }
	
	    // trigger a change (TOUCH, RELEASE) event, this means the length of the touches changed
	    if (triggerChange) {
	      evData.changedLength = changedLength;
	      evData.eventType = triggerChange;
	
	      handler.call(Detection, evData);
	
	      evData.eventType = triggerType;
	      delete evData.changedLength;
	    }
	
	    // trigger the END event
	    if (triggerType == EVENT_END) {
	      handler.call(Detection, evData);
	
	      // ...and we are done with the detection
	      // so reset everything to start each detection totally fresh
	      this.started = false;
	    }
	
	    return triggerType;
	  },
	
	  /**
	   * we have different events for each device/browser
	   * determine what we need and set them in the EVENT_TYPES constant
	   * the `onTouch` method is bind to these properties.
	   * @return {Object} events
	   */
	  determineEventTypes: function determineEventTypes() {
	    var types;
	    if (GestureDetector.HAS_POINTEREVENTS) {
	      if (window.PointerEvent) {
	        types = ['pointerdown', 'pointermove', 'pointerup pointercancel lostpointercapture'];
	      } else {
	        types = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp MSPointerCancel MSLostPointerCapture'];
	      }
	    } else if (GestureDetector.NO_MOUSEEVENTS) {
	      types = ['touchstart', 'touchmove', 'touchend touchcancel'];
	    } else {
	      types = ['touchstart mousedown', 'touchmove mousemove', 'touchend touchcancel mouseup'];
	    }
	
	    EVENT_TYPES[EVENT_START] = types[0];
	    EVENT_TYPES[EVENT_MOVE] = types[1];
	    EVENT_TYPES[EVENT_END] = types[2];
	    return EVENT_TYPES;
	  },
	
	  /**
	   * create touchList depending on the event
	   * @param {Object} ev
	   * @param {String} eventType
	   * @return {Array} touches
	   */
	  getTouchList: function getTouchList(ev, eventType) {
	    // get the fake pointerEvent touchlist
	    if (GestureDetector.HAS_POINTEREVENTS) {
	      return PointerEvent.getTouchList();
	    }
	
	    // get the touchlist
	    if (ev.touches) {
	      if (eventType == EVENT_MOVE) {
	        return ev.touches;
	      }
	
	      var identifiers = [];
	      var concat = [].concat(Utils.toArray(ev.touches), Utils.toArray(ev.changedTouches));
	      var touchList = [];
	
	      Utils.each(concat, function (touch) {
	        if (Utils.inArray(identifiers, touch.identifier) === -1) {
	          touchList.push(touch);
	        }
	        identifiers.push(touch.identifier);
	      });
	
	      return touchList;
	    }
	
	    // make fake touchList from mouse position
	    ev.identifier = 1;
	    return [ev];
	  },
	
	  /**
	   * collect basic event data
	   * @param {HTMLElement} element
	   * @param {String} eventType matches `EVENT_START|MOVE|END`
	   * @param {Array} touches
	   * @param {Object} ev
	   * @return {Object} ev
	   */
	  collectEventData: function collectEventData(element, eventType, touches, ev) {
	    // find out pointerType
	    var pointerType = POINTER_TOUCH;
	    if (Utils.inStr(ev.type, 'mouse') || PointerEvent.matchType(POINTER_MOUSE, ev)) {
	      pointerType = POINTER_MOUSE;
	    } else if (PointerEvent.matchType(POINTER_PEN, ev)) {
	      pointerType = POINTER_PEN;
	    }
	
	    return {
	      center: Utils.getCenter(touches),
	      timeStamp: Date.now(),
	      target: ev.target,
	      touches: touches,
	      eventType: eventType,
	      pointerType: pointerType,
	      srcEvent: ev,
	
	      /**
	       * prevent the browser default actions
	       * mostly used to disable scrolling of the browser
	       */
	      preventDefault: function preventDefault() {
	        var srcEvent = this.srcEvent;
	        srcEvent.preventManipulation && srcEvent.preventManipulation();
	        srcEvent.preventDefault && srcEvent.preventDefault();
	      },
	
	      /**
	       * stop bubbling the event up to its parents
	       */
	      stopPropagation: function stopPropagation() {
	        this.srcEvent.stopPropagation();
	      },
	
	      /**
	       * immediately stop gesture detection
	       * might be useful after a swipe was detected
	       * @return {*}
	       */
	      stopDetect: function stopDetect() {
	        return Detection.stopDetect();
	      }
	    };
	  }
	};
	
	/**
	 * @module GestureDetector
	 *
	 * @class PointerEvent
	 * @static
	 */
	PointerEvent = GestureDetector.PointerEvent = {
	  /**
	   * holds all pointers, by `identifier`
	   * @property pointers
	   * @type {Object}
	   */
	  pointers: {},
	
	  /**
	   * get the pointers as an array
	   * @return {Array} touchlist
	   */
	  getTouchList: function getTouchList() {
	    var touchlist = [];
	    // we can use forEach since pointerEvents only is in IE10
	    Utils.each(this.pointers, function (pointer) {
	      touchlist.push(pointer);
	    });
	    return touchlist;
	  },
	
	  /**
	   * update the position of a pointer
	   * @param {String} eventType matches `EVENT_START|MOVE|END`
	   * @param {Object} pointerEvent
	   */
	  updatePointer: function updatePointer(eventType, pointerEvent) {
	    if (eventType == EVENT_END || eventType != EVENT_END && pointerEvent.buttons !== 1) {
	      delete this.pointers[pointerEvent.pointerId];
	    } else {
	      pointerEvent.identifier = pointerEvent.pointerId;
	      this.pointers[pointerEvent.pointerId] = pointerEvent;
	    }
	  },
	
	  /**
	   * check if ev matches pointertype
	   * @param {String} pointerType matches `POINTER_MOUSE|TOUCH|PEN`
	   * @param {PointerEvent} ev
	   */
	  matchType: function matchType(pointerType, ev) {
	    if (!ev.pointerType) {
	      return false;
	    }
	
	    var pt = ev.pointerType,
	        types = {};
	
	    types[POINTER_MOUSE] = pt === (ev.MSPOINTER_TYPE_MOUSE || POINTER_MOUSE);
	    types[POINTER_TOUCH] = pt === (ev.MSPOINTER_TYPE_TOUCH || POINTER_TOUCH);
	    types[POINTER_PEN] = pt === (ev.MSPOINTER_TYPE_PEN || POINTER_PEN);
	    return types[pointerType];
	  },
	
	  /**
	   * reset the stored pointers
	   */
	  reset: function resetList() {
	    this.pointers = {};
	  }
	};
	
	/**
	 * @module GestureDetector
	 *
	 * @class Detection
	 * @static
	 */
	Detection = GestureDetector.detection = {
	  // contains all registered GestureDetector.gestures in the correct order
	  gestures: [],
	
	  // data of the current GestureDetector.gesture detection session
	  current: null,
	
	  // the previous GestureDetector.gesture session data
	  // is a full clone of the previous gesture.current object
	  previous: null,
	
	  // when this becomes true, no gestures are fired
	  stopped: false,
	
	  /**
	   * start GestureDetector.gesture detection
	   * @param {GestureDetector.Instance} inst
	   * @param {Object} eventData
	   */
	  startDetect: function startDetect(inst, eventData) {
	    // already busy with a GestureDetector.gesture detection on an element
	    if (this.current) {
	      return;
	    }
	
	    this.stopped = false;
	
	    // holds current session
	    this.current = {
	      inst: inst, // reference to GestureDetectorInstance we're working for
	      startEvent: Utils.extend({}, eventData), // start eventData for distances, timing etc
	      lastEvent: false, // last eventData
	      lastCalcEvent: false, // last eventData for calculations.
	      futureCalcEvent: false, // last eventData for calculations.
	      lastCalcData: {}, // last lastCalcData
	      name: '' // current gesture we're in/detected, can be 'tap', 'hold' etc
	    };
	
	    this.detect(eventData);
	  },
	
	  /**
	   * GestureDetector.gesture detection
	   * @param {Object} eventData
	   * @return {any}
	   */
	  detect: function detect(eventData) {
	    if (!this.current || this.stopped) {
	      return;
	    }
	
	    // extend event data with calculations about scale, distance etc
	    eventData = this.extendEventData(eventData);
	
	    // GestureDetector instance and instance options
	    var inst = this.current.inst,
	        instOptions = inst.options;
	
	    // call GestureDetector.gesture handlers
	    Utils.each(this.gestures, function triggerGesture(gesture) {
	      // only when the instance options have enabled this gesture
	      if (!this.stopped && inst.enabled && instOptions[gesture.name]) {
	        gesture.handler.call(gesture, eventData, inst);
	      }
	    }, this);
	
	    // store as previous event event
	    if (this.current) {
	      this.current.lastEvent = eventData;
	    }
	
	    if (eventData.eventType == EVENT_END) {
	      this.stopDetect();
	    }
	
	    return eventData; // eslint-disable-line consistent-return
	  },
	
	  /**
	   * clear the GestureDetector.gesture vars
	   * this is called on endDetect, but can also be used when a final GestureDetector.gesture has been detected
	   * to stop other GestureDetector.gestures from being fired
	   */
	  stopDetect: function stopDetect() {
	    // clone current data to the store as the previous gesture
	    // used for the double tap gesture, since this is an other gesture detect session
	    this.previous = Utils.extend({}, this.current);
	
	    // reset the current
	    this.current = null;
	    this.stopped = true;
	  },
	
	  /**
	   * calculate velocity, angle and direction
	   * @param {Object} ev
	   * @param {Object} center
	   * @param {Number} deltaTime
	   * @param {Number} deltaX
	   * @param {Number} deltaY
	   */
	  getCalculatedData: function getCalculatedData(ev, center, deltaTime, deltaX, deltaY) {
	    var cur = this.current,
	        recalc = false,
	        calcEv = cur.lastCalcEvent,
	        calcData = cur.lastCalcData;
	
	    if (calcEv && ev.timeStamp - calcEv.timeStamp > GestureDetector.CALCULATE_INTERVAL) {
	      center = calcEv.center;
	      deltaTime = ev.timeStamp - calcEv.timeStamp;
	      deltaX = ev.center.clientX - calcEv.center.clientX;
	      deltaY = ev.center.clientY - calcEv.center.clientY;
	      recalc = true;
	    }
	
	    if (ev.eventType == EVENT_TOUCH || ev.eventType == EVENT_RELEASE) {
	      cur.futureCalcEvent = ev;
	    }
	
	    if (!cur.lastCalcEvent || recalc) {
	      calcData.velocity = Utils.getVelocity(deltaTime, deltaX, deltaY);
	      calcData.angle = Utils.getAngle(center, ev.center);
	      calcData.direction = Utils.getDirection(center, ev.center);
	
	      cur.lastCalcEvent = cur.futureCalcEvent || ev;
	      cur.futureCalcEvent = ev;
	    }
	
	    ev.velocityX = calcData.velocity.x;
	    ev.velocityY = calcData.velocity.y;
	    ev.interimAngle = calcData.angle;
	    ev.interimDirection = calcData.direction;
	  },
	
	  /**
	   * extend eventData for GestureDetector.gestures
	   * @param {Object} ev
	   * @return {Object} ev
	   */
	  extendEventData: function extendEventData(ev) {
	    var cur = this.current,
	        startEv = cur.startEvent,
	        lastEv = cur.lastEvent || startEv;
	
	    // update the start touchlist to calculate the scale/rotation
	    if (ev.eventType == EVENT_TOUCH || ev.eventType == EVENT_RELEASE) {
	      startEv.touches = [];
	      Utils.each(ev.touches, function (touch) {
	        startEv.touches.push({
	          clientX: touch.clientX,
	          clientY: touch.clientY
	        });
	      });
	    }
	
	    var deltaTime = ev.timeStamp - startEv.timeStamp,
	        deltaX = ev.center.clientX - startEv.center.clientX,
	        deltaY = ev.center.clientY - startEv.center.clientY;
	
	    this.getCalculatedData(ev, lastEv.center, deltaTime, deltaX, deltaY);
	
	    Utils.extend(ev, {
	      startEvent: startEv,
	
	      deltaTime: deltaTime,
	      deltaX: deltaX,
	      deltaY: deltaY,
	
	      distance: Utils.getDistance(startEv.center, ev.center),
	      angle: Utils.getAngle(startEv.center, ev.center),
	      direction: Utils.getDirection(startEv.center, ev.center),
	      scale: Utils.getScale(startEv.touches, ev.touches),
	      rotation: Utils.getRotation(startEv.touches, ev.touches)
	    });
	
	    return ev;
	  },
	
	  /**
	   * register new gesture
	   * @param {Object} gesture object, see `gestures/` for documentation
	   * @return {Array} gestures
	   */
	  register: function register(gesture) {
	    // add an enable gesture options if there is no given
	    var options = gesture.defaults || {};
	    if (options[gesture.name] === undefined) {
	      options[gesture.name] = true;
	    }
	
	    // extend GestureDetector default options with the GestureDetector.gesture options
	    Utils.extend(GestureDetector.defaults, options, true);
	
	    // set its index
	    gesture.index = gesture.index || 1000;
	
	    // add GestureDetector.gesture to the list
	    this.gestures.push(gesture);
	
	    // sort the list by index
	    this.gestures.sort(function (a, b) {
	      if (a.index < b.index) {
	        return -1;
	      }
	      if (a.index > b.index) {
	        return 1;
	      }
	      return 0;
	    });
	
	    return this.gestures;
	  }
	};
	
	/**
	 * @module GestureDetector
	 */
	
	/**
	 * create new GestureDetector instance
	 * all methods should return the instance itself, so it is chainable.
	 *
	 * @class Instance
	 * @constructor
	 * @param {HTMLElement} element
	 * @param {Object} [options={}] options are merged with `GestureDetector.defaults`
	 * @return {GestureDetector.Instance}
	 */
	GestureDetector.Instance = function (element, options) {
	  var self = this;
	  var listenerOptions = options && options.passive ? { passive: true } : undefined;
	
	  // setup GestureDetectorJS window events and register all gestures
	  // this also sets up the default options
	  setup(listenerOptions);
	
	  /**
	   * @property element
	   * @type {HTMLElement}
	   */
	  this.element = element;
	
	  /**
	   * @property enabled
	   * @type {Boolean}
	   * @protected
	   */
	  this.enabled = true;
	
	  /**
	   * options, merged with the defaults
	   * options with an _ are converted to camelCase
	   * @property options
	   * @type {Object}
	   */
	  Utils.each(options, function (value, name) {
	    delete options[name];
	    options[Utils.toCamelCase(name)] = value;
	  });
	
	  this.options = Utils.extend(Utils.extend({}, GestureDetector.defaults), options || {});
	  this.options.listenerOptions = listenerOptions;
	
	  // add some css to the element to prevent the browser from doing its native behavior
	  if (this.options.behavior) {
	    Utils.toggleBehavior(this.element, this.options.behavior, true);
	  }
	
	  /**
	   * event start handler on the element to start the detection
	   * @property eventStartHandler
	   * @type {Object}
	   */
	  this.eventStartHandler = Event$1.onTouch(element, EVENT_START, function (ev) {
	    if (self.enabled && ev.eventType == EVENT_START) {
	      Detection.startDetect(self, ev);
	    } else if (ev.eventType == EVENT_TOUCH) {
	      Detection.detect(ev);
	    }
	  }, listenerOptions);
	
	  /**
	   * keep a list of user event handlers which needs to be removed when calling 'dispose'
	   * @property eventHandlers
	   * @type {Array}
	   */
	  this.eventHandlers = [];
	};
	
	GestureDetector.Instance.prototype = {
	  /**
	   * @method on
	   * @signature on(gestures, handler)
	   * @description
	   *  [en]Adds an event handler for a gesture. Available gestures are: drag, dragleft, dragright, dragup, dragdown, hold, release, swipe, swipeleft, swiperight, swipeup, swipedown, tap, doubletap, touch, transform, pinch, pinchin, pinchout and rotate. [/en]
	   *  [ja]ジェスチャに対するイベントハンドラを追加します。指定できるジェスチャ名は、drag dragleft dragright dragup dragdown hold release swipe swipeleft swiperight swipeup swipedown tap doubletap touch transform pinch pinchin pinchout rotate です。[/ja]
	   * @param {String} gestures
	   *   [en]A space separated list of gestures.[/en]
	   *   [ja]検知するジェスチャ名を指定します。スペースで複数指定することができます。[/ja]
	   * @param {Function} handler
	   *   [en]An event handling function.[/en]
	   *   [ja]イベントハンドラとなる関数オブジェクトを指定します。[/ja]
	   */
	  on: function onEvent(gestures, handler, opt) {
	    var self = this;
	
	    Event$1.on(self.element, gestures, handler, util.extend({}, self.options.listenerOptions, opt), function (type) {
	      self.eventHandlers.push({ gesture: type, handler: handler });
	    });
	    return self;
	  },
	
	  /**
	   * @method off
	   * @signature off(gestures, handler)
	   * @description
	   *  [en]Remove an event listener.[/en]
	   *  [ja]イベントリスナーを削除します。[/ja]
	   * @param {String} gestures
	   *   [en]A space separated list of gestures.[/en]
	   *   [ja]ジェスチャ名を指定します。スペースで複数指定することができます。[/ja]
	   * @param {Function} handler
	   *   [en]An event handling function.[/en]
	   *   [ja]イベントハンドラとなる関数オブジェクトを指定します。[/ja]
	   */
	  off: function offEvent(gestures, handler, opt) {
	    var self = this;
	
	    Event$1.off(self.element, gestures, handler, util.extend({}, self.options.listenerOptions, opt), function (type) {
	      var index = Utils.inArray(self.eventHandlers, { gesture: type, handler: handler }, true);
	      if (index >= 0) {
	        self.eventHandlers.splice(index, 1);
	      }
	    });
	    return self;
	  },
	
	  /**
	   * trigger gesture event
	   * @method trigger
	   * @signature trigger(gesture, eventData)
	   * @param {String} gesture
	   * @param {Object} [eventData]
	   */
	  trigger: function triggerEvent(gesture, eventData) {
	    // optional
	    if (!eventData) {
	      eventData = {};
	    }
	
	    // create DOM event
	    var event = GestureDetector.DOCUMENT.createEvent('Event');
	    event.initEvent(gesture, true, true);
	    event.gesture = eventData;
	
	    // trigger on the target if it is in the instance element,
	    // this is for event delegation tricks
	    var element = this.element;
	    if (Utils.hasParent(eventData.target, element)) {
	      element = eventData.target;
	    }
	
	    element.dispatchEvent(event);
	    return this;
	  },
	
	  /**
	   * @method enable
	   * @signature enable(state)
	   * @description
	   *  [en]Enable or disable gesture detection.[/en]
	   *  [ja]ジェスチャ検知を有効化/無効化します。[/ja]
	   * @param {Boolean} state
	   *   [en]Specify if it should be enabled or not.[/en]
	   *   [ja]有効にするかどうかを指定します。[/ja]
	   */
	  enable: function enable(state) {
	    this.enabled = state;
	    return this;
	  },
	
	  /**
	   * @method dispose
	   * @signature dispose()
	   * @description
	   *  [en]Remove and destroy all event handlers for this instance.[/en]
	   *  [ja]このインスタンスでのジェスチャの検知や、イベントハンドラを全て解除して廃棄します。[/ja]
	   */
	  dispose: function dispose() {
	    var i, eh;
	
	    // undo all changes made by stop_browser_behavior
	    Utils.toggleBehavior(this.element, this.options.behavior, false);
	
	    // unbind all custom event handlers
	    for (i = -1; eh = this.eventHandlers[++i];) {
	      // eslint-disable-line no-cond-assign
	      Utils.off(this.element, eh.gesture, eh.handler);
	    }
	
	    this.eventHandlers = [];
	
	    // unbind the start event listener
	    Event$1.off(this.element, EVENT_TYPES[EVENT_START], this.eventStartHandler);
	
	    return null;
	  }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * Move with x fingers (default 1) around on the page.
	 * Preventing the default browser behavior is a good way to improve feel and working.
	 * ````
	 *  GestureDetectortime.on("drag", function(ev) {
	 *    console.log(ev);
	 *    ev.gesture.preventDefault();
	 *  });
	 * ````
	 *
	 * @class Drag
	 * @static
	 */
	/**
	 * @event drag
	 * @param {Object} ev
	 */
	/**
	 * @event dragstart
	 * @param {Object} ev
	 */
	/**
	 * @event dragend
	 * @param {Object} ev
	 */
	/**
	 * @event drapleft
	 * @param {Object} ev
	 */
	/**
	 * @event dragright
	 * @param {Object} ev
	 */
	/**
	 * @event dragup
	 * @param {Object} ev
	 */
	/**
	 * @event dragdown
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function (name) {
	  var triggered = false;
	
	  function dragGesture(ev, inst) {
	    var cur = Detection.current;
	
	    // max touches
	    if (inst.options.dragMaxTouches > 0 && ev.touches.length > inst.options.dragMaxTouches) {
	      return;
	    }
	
	    switch (ev.eventType) {
	      case EVENT_START:
	        triggered = false;
	        break;
	
	      case EVENT_MOVE:
	        // when the distance we moved is too small we skip this gesture
	        // or we can be already in dragging
	        if (ev.distance < inst.options.dragMinDistance && cur.name != name) {
	          return;
	        }
	
	        var startCenter = cur.startEvent.center;
	
	        // we are dragging!
	        if (cur.name != name) {
	          cur.name = name;
	          if (inst.options.dragDistanceCorrection && ev.distance > 0) {
	            // When a drag is triggered, set the event center to dragMinDistance pixels from the original event center.
	            // Without this correction, the dragged distance would jumpstart at dragMinDistance pixels instead of at 0.
	            // It might be useful to save the original start point somewhere
	            var factor = Math.abs(inst.options.dragMinDistance / ev.distance);
	            startCenter.pageX += ev.deltaX * factor;
	            startCenter.pageY += ev.deltaY * factor;
	            startCenter.clientX += ev.deltaX * factor;
	            startCenter.clientY += ev.deltaY * factor;
	
	            // recalculate event data using new start point
	            ev = Detection.extendEventData(ev);
	          }
	        }
	
	        // lock drag to axis?
	        if (cur.lastEvent.dragLockToAxis || inst.options.dragLockToAxis && inst.options.dragLockMinDistance <= ev.distance) {
	          ev.dragLockToAxis = true;
	        }
	
	        // keep direction on the axis that the drag gesture started on
	        var lastDirection = cur.lastEvent.direction;
	        if (ev.dragLockToAxis && lastDirection !== ev.direction) {
	          if (Utils.isVertical(lastDirection)) {
	            ev.direction = ev.deltaY < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	          } else {
	            ev.direction = ev.deltaX < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	          }
	        }
	
	        // first time, trigger dragstart event
	        if (!triggered) {
	          inst.trigger(name + 'start', ev);
	          triggered = true;
	        }
	
	        // trigger events
	        inst.trigger(name, ev);
	        inst.trigger(name + ev.direction, ev);
	
	        var isVertical = Utils.isVertical(ev.direction);
	
	        // block the browser events
	        if (inst.options.dragBlockVertical && isVertical || inst.options.dragBlockHorizontal && !isVertical) {
	          ev.preventDefault();
	        }
	        break;
	
	      case EVENT_RELEASE:
	        if (triggered && ev.changedLength <= inst.options.dragMaxTouches) {
	          inst.trigger(name + 'end', ev);
	          triggered = false;
	        }
	        break;
	
	      case EVENT_END:
	        triggered = false;
	        break;
	    }
	  }
	
	  GestureDetector.gestures.Drag = {
	    name: name,
	    index: 50,
	    handler: dragGesture,
	    defaults: {
	      /**
	       * minimal movement that have to be made before the drag event gets triggered
	       * @property dragMinDistance
	       * @type {Number}
	       * @default 10
	       */
	      dragMinDistance: 10,
	
	      /**
	       * Set dragDistanceCorrection to true to make the starting point of the drag
	       * be calculated from where the drag was triggered, not from where the touch started.
	       * Useful to avoid a jerk-starting drag, which can make fine-adjustments
	       * through dragging difficult, and be visually unappealing.
	       * @property dragDistanceCorrection
	       * @type {Boolean}
	       * @default true
	       */
	      dragDistanceCorrection: true,
	
	      /**
	       * set 0 for unlimited, but this can conflict with transform
	       * @property dragMaxTouches
	       * @type {Number}
	       * @default 1
	       */
	      dragMaxTouches: 1,
	
	      /**
	       * prevent default browser behavior when dragging occurs
	       * be careful with it, it makes the element a blocking element
	       * when you are using the drag gesture, it is a good practice to set this true
	       * @property dragBlockHorizontal
	       * @type {Boolean}
	       * @default false
	       */
	      dragBlockHorizontal: false,
	
	      /**
	       * same as `dragBlockHorizontal`, but for vertical movement
	       * @property dragBlockVertical
	       * @type {Boolean}
	       * @default false
	       */
	      dragBlockVertical: false,
	
	      /**
	       * dragLockToAxis keeps the drag gesture on the axis that it started on,
	       * It disallows vertical directions if the initial direction was horizontal, and vice versa.
	       * @property dragLockToAxis
	       * @type {Boolean}
	       * @default false
	       */
	      dragLockToAxis: false,
	
	      /**
	       * drag lock only kicks in when distance > dragLockMinDistance
	       * This way, locking occurs only when the distance has become large enough to reliably determine the direction
	       * @property dragLockMinDistance
	       * @type {Number}
	       * @default 25
	       */
	      dragLockMinDistance: 25
	    }
	  };
	})('drag');
	
	/**
	 * @module gestures
	 */
	/**
	 * trigger a simple gesture event, so you can do anything in your handler.
	 * only usable if you know what your doing...
	 *
	 * @class Gesture
	 * @static
	 */
	/**
	 * @event gesture
	 * @param {Object} ev
	 */
	GestureDetector.gestures.Gesture = {
	  name: 'gesture',
	  index: 1337,
	  handler: function releaseGesture(ev, inst) {
	    inst.trigger(this.name, ev);
	  }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * Touch stays at the same place for x time
	 *
	 * @class Hold
	 * @static
	 */
	/**
	 * @event hold
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function (name) {
	  var timer;
	
	  function holdGesture(ev, inst) {
	    var options = inst.options,
	        current = Detection.current;
	
	    switch (ev.eventType) {
	      case EVENT_START:
	        clearTimeout(timer);
	
	        // set the gesture so we can check in the timeout if it still is
	        current.name = name;
	
	        // set timer and if after the timeout it still is hold,
	        // we trigger the hold event
	        timer = setTimeout(function () {
	          if (current && current.name == name) {
	            inst.trigger(name, ev);
	          }
	        }, options.holdTimeout);
	        break;
	
	      case EVENT_MOVE:
	        if (ev.distance > options.holdThreshold) {
	          clearTimeout(timer);
	        }
	        break;
	
	      case EVENT_RELEASE:
	        clearTimeout(timer);
	        break;
	    }
	  }
	
	  GestureDetector.gestures.Hold = {
	    name: name,
	    index: 10,
	    defaults: {
	      /**
	       * @property holdTimeout
	       * @type {Number}
	       * @default 500
	       */
	      holdTimeout: 500,
	
	      /**
	       * movement allowed while holding
	       * @property holdThreshold
	       * @type {Number}
	       * @default 2
	       */
	      holdThreshold: 2
	    },
	    handler: holdGesture
	  };
	})('hold');
	
	/**
	 * @module gestures
	 */
	/**
	 * when a touch is being released from the page
	 *
	 * @class Release
	 * @static
	 */
	/**
	 * @event release
	 * @param {Object} ev
	 */
	GestureDetector.gestures.Release = {
	  name: 'release',
	  index: Infinity,
	  handler: function releaseGesture(ev, inst) {
	    if (ev.eventType == EVENT_RELEASE) {
	      inst.trigger(this.name, ev);
	    }
	  }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * triggers swipe events when the end velocity is above the threshold
	 * for best usage, set `preventDefault` (on the drag gesture) to `true`
	 * ````
	 *  GestureDetectortime.on("dragleft swipeleft", function(ev) {
	 *    console.log(ev);
	 *    ev.gesture.preventDefault();
	 *  });
	 * ````
	 *
	 * @class Swipe
	 * @static
	 */
	/**
	 * @event swipe
	 * @param {Object} ev
	 */
	/**
	 * @event swipeleft
	 * @param {Object} ev
	 */
	/**
	 * @event swiperight
	 * @param {Object} ev
	 */
	/**
	 * @event swipeup
	 * @param {Object} ev
	 */
	/**
	 * @event swipedown
	 * @param {Object} ev
	 */
	GestureDetector.gestures.Swipe = {
	  name: 'swipe',
	  index: 40,
	  defaults: {
	    /**
	     * @property swipeMinTouches
	     * @type {Number}
	     * @default 1
	     */
	    swipeMinTouches: 1,
	
	    /**
	     * @property swipeMaxTouches
	     * @type {Number}
	     * @default 1
	     */
	    swipeMaxTouches: 1,
	
	    /**
	     * horizontal swipe velocity
	     * @property swipeVelocityX
	     * @type {Number}
	     * @default 0.6
	     */
	    swipeVelocityX: 0.6,
	
	    /**
	     * vertical swipe velocity
	     * @property swipeVelocityY
	     * @type {Number}
	     * @default 0.6
	     */
	    swipeVelocityY: 0.6
	  },
	
	  handler: function swipeGesture(ev, inst) {
	    if (ev.eventType == EVENT_RELEASE) {
	      var touches = ev.touches.length,
	          options = inst.options;
	
	      // max touches
	      if (touches < options.swipeMinTouches || touches > options.swipeMaxTouches) {
	        return;
	      }
	
	      // when the distance we moved is too small we skip this gesture
	      // or we can be already in dragging
	      if (ev.velocityX > options.swipeVelocityX || ev.velocityY > options.swipeVelocityY) {
	        // trigger swipe events
	        inst.trigger(this.name, ev);
	        inst.trigger(this.name + ev.direction, ev);
	      }
	    }
	  }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * Single tap and a double tap on a place
	 *
	 * @class Tap
	 * @static
	 */
	/**
	 * @event tap
	 * @param {Object} ev
	 */
	/**
	 * @event doubletap
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function (name) {
	  var hasMoved = false;
	
	  function tapGesture(ev, inst) {
	    var options = inst.options,
	        current = Detection.current,
	        prev = Detection.previous,
	        sincePrev,
	        didDoubleTap;
	
	    switch (ev.eventType) {
	      case EVENT_START:
	        hasMoved = false;
	        break;
	
	      case EVENT_MOVE:
	        hasMoved = hasMoved || ev.distance > options.tapMaxDistance;
	        break;
	
	      case EVENT_END:
	        if (!Utils.inStr(ev.srcEvent.type, 'cancel') && ev.deltaTime < options.tapMaxTime && !hasMoved) {
	          // previous gesture, for the double tap since these are two different gesture detections
	          sincePrev = prev && prev.lastEvent && ev.timeStamp - prev.lastEvent.timeStamp;
	          didDoubleTap = false;
	
	          // check if double tap
	          if (prev && prev.name == name && sincePrev && sincePrev < options.doubleTapInterval && ev.distance < options.doubleTapDistance) {
	            inst.trigger('doubletap', ev);
	            didDoubleTap = true;
	          }
	
	          // do a single tap
	          if (!didDoubleTap || options.tapAlways) {
	            current.name = name;
	            inst.trigger(current.name, ev);
	          }
	        }
	        break;
	    }
	  }
	
	  GestureDetector.gestures.Tap = {
	    name: name,
	    index: 100,
	    handler: tapGesture,
	    defaults: {
	      /**
	       * max time of a tap, this is for the slow tappers
	       * @property tapMaxTime
	       * @type {Number}
	       * @default 250
	       */
	      tapMaxTime: 250,
	
	      /**
	       * max distance of movement of a tap, this is for the slow tappers
	       * @property tapMaxDistance
	       * @type {Number}
	       * @default 10
	       */
	      tapMaxDistance: 10,
	
	      /**
	       * always trigger the `tap` event, even while double-tapping
	       * @property tapAlways
	       * @type {Boolean}
	       * @default true
	       */
	      tapAlways: true,
	
	      /**
	       * max distance between two taps
	       * @property doubleTapDistance
	       * @type {Number}
	       * @default 20
	       */
	      doubleTapDistance: 20,
	
	      /**
	       * max time between two taps
	       * @property doubleTapInterval
	       * @type {Number}
	       * @default 300
	       */
	      doubleTapInterval: 300
	    }
	  };
	})('tap');
	
	/**
	 * @module gestures
	 */
	/**
	 * when a touch is being touched at the page
	 *
	 * @class Touch
	 * @static
	 */
	/**
	 * @event touch
	 * @param {Object} ev
	 */
	GestureDetector.gestures.Touch = {
	  name: 'touch',
	  index: -Infinity,
	  defaults: {
	    /**
	     * call preventDefault at touchstart, and makes the element blocking by disabling the scrolling of the page,
	     * but it improves gestures like transforming and dragging.
	     * be careful with using this, it can be very annoying for users to be stuck on the page
	     * @property preventDefault
	     * @type {Boolean}
	     * @default false
	     */
	    preventDefault: false,
	
	    /**
	     * disable mouse events, so only touch (or pen!) input triggers events
	     * @property preventMouse
	     * @type {Boolean}
	     * @default false
	     */
	    preventMouse: false
	  },
	  handler: function touchGesture(ev, inst) {
	    if (inst.options.preventMouse && ev.pointerType == POINTER_MOUSE) {
	      ev.stopDetect();
	      return;
	    }
	
	    if (inst.options.preventDefault) {
	      ev.preventDefault();
	    }
	
	    if (ev.eventType == EVENT_TOUCH) {
	      inst.trigger('touch', ev);
	    }
	  }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * User want to scale or rotate with 2 fingers
	 * Preventing the default browser behavior is a good way to improve feel and working. This can be done with the
	 * `preventDefault` option.
	 *
	 * @class Transform
	 * @static
	 */
	/**
	 * @event transform
	 * @param {Object} ev
	 */
	/**
	 * @event transformstart
	 * @param {Object} ev
	 */
	/**
	 * @event transformend
	 * @param {Object} ev
	 */
	/**
	 * @event pinchin
	 * @param {Object} ev
	 */
	/**
	 * @event pinchout
	 * @param {Object} ev
	 */
	/**
	 * @event rotate
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function (name) {
	  var triggered = false;
	
	  function transformGesture(ev, inst) {
	    switch (ev.eventType) {
	      case EVENT_START:
	        triggered = false;
	        break;
	
	      case EVENT_MOVE:
	        // at least multitouch
	        if (ev.touches.length < 2) {
	          return;
	        }
	
	        var scaleThreshold = Math.abs(1 - ev.scale);
	        var rotationThreshold = Math.abs(ev.rotation);
	
	        // when the distance we moved is too small we skip this gesture
	        // or we can be already in dragging
	        if (scaleThreshold < inst.options.transformMinScale && rotationThreshold < inst.options.transformMinRotation) {
	          return;
	        }
	
	        // we are transforming!
	        Detection.current.name = name;
	
	        // first time, trigger dragstart event
	        if (!triggered) {
	          inst.trigger(name + 'start', ev);
	          triggered = true;
	        }
	
	        inst.trigger(name, ev); // basic transform event
	
	        // trigger rotate event
	        if (rotationThreshold > inst.options.transformMinRotation) {
	          inst.trigger('rotate', ev);
	        }
	
	        // trigger pinch event
	        if (scaleThreshold > inst.options.transformMinScale) {
	          inst.trigger('pinch', ev);
	          inst.trigger('pinch' + (ev.scale < 1 ? 'in' : 'out'), ev);
	        }
	        break;
	
	      case EVENT_RELEASE:
	        if (triggered && ev.changedLength < 2) {
	          inst.trigger(name + 'end', ev);
	          triggered = false;
	        }
	        break;
	    }
	  }
	
	  GestureDetector.gestures.Transform = {
	    name: name,
	    index: 45,
	    defaults: {
	      /**
	       * minimal scale factor, no scale is 1, zoomin is to 0 and zoomout until higher then 1
	       * @property transformMinScale
	       * @type {Number}
	       * @default 0.01
	       */
	      transformMinScale: 0.01,
	
	      /**
	       * rotation in degrees
	       * @property transformMinRotation
	       * @type {Number}
	       * @default 1
	       */
	      transformMinRotation: 1
	    },
	
	    handler: transformGesture
	  };
	})('transform');
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var readyMap = void 0;
	var queueMap = void 0;
	
	function isContentReady(element) {
	  if (element.childNodes.length > 0) {
	    setContentReady(element);
	  }
	  return readyMap.has(element);
	}
	
	function setContentReady(element) {
	  readyMap.set(element, true);
	}
	
	function addCallback(element, fn) {
	  if (!queueMap.has(element)) {
	    queueMap.set(element, []);
	  }
	  queueMap.get(element).push(fn);
	}
	
	function consumeQueue(element) {
	  var callbacks = queueMap.get(element, []) || [];
	  queueMap.delete(element);
	  callbacks.forEach(function (callback) {
	    return callback();
	  });
	}
	
	function contentReady(element) {
	  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (readyMap === undefined) {
	    readyMap = new WeakMap();
	    queueMap = new WeakMap();
	  }
	
	  addCallback(element, fn);
	
	  if (isContentReady(element)) {
	    consumeQueue(element);
	    return;
	  }
	
	  var observer = new MutationObserver(function (changes) {
	    setContentReady(element);
	    consumeQueue(element);
	  });
	  observer.observe(element, { childList: true, characterData: true });
	
	  // failback for elements has empty content.
	  setImmediate(function () {
	    setContentReady(element);
	    consumeQueue(element);
	  });
	}
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var ToastQueue = function () {
	  function ToastQueue() {
	    classCallCheck(this, ToastQueue);
	
	    this.queue = [];
	  }
	
	  createClass(ToastQueue, [{
	    key: "add",
	    value: function add(fn, promise) {
	      var _this = this;
	
	      this.queue.push(fn);
	
	      if (this.queue.length === 1) {
	        setImmediate(this.queue[0]);
	      }
	
	      promise.then(function () {
	        _this.queue.shift();
	
	        if (_this.queue.length > 0) {
	          setTimeout(_this.queue[0], 1000 / 30); // Apply some visual delay
	        }
	      });
	    }
	  }]);
	  return ToastQueue;
	}();
	
	var ToastQueue$1 = new ToastQueue();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var _setAttributes = function _setAttributes(element, options) {
	  ['id', 'class', 'animation'].forEach(function (a) {
	    return options.hasOwnProperty(a) && element.setAttribute(a, options[a]);
	  });
	
	  if (options.modifier) {
	    util.addModifier(element, options.modifier);
	  }
	};
	
	var _normalizeArguments = function _normalizeArguments(message) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  options = _extends({}, options);
	  typeof message === 'string' ? options.message = message : options = message;
	  if (!options || !options.message && !options.messageHTML) {
	    throw new Error('Notifications must contain a message.');
	  }
	
	  if (options.hasOwnProperty('buttonLabels') || options.hasOwnProperty('buttonLabel')) {
	    options.buttonLabels = options.buttonLabels || options.buttonLabel;
	    if (!Array.isArray(options.buttonLabels)) {
	      options.buttonLabels = [options.buttonLabels || ''];
	    }
	  }
	
	  return util.extend({
	    compile: function compile(param) {
	      return param;
	    },
	    callback: function callback(param) {
	      return param;
	    },
	    animation: 'default',
	    cancelable: false,
	    primaryButtonIndex: (options.buttonLabels || defaults$$1.buttonLabels || []).length - 1
	  }, defaults$$1, options);
	};
	
	/**
	 * @object ons.notification
	 * @category dialog
	 * @tutorial vanilla/Reference/dialog
	 * @description
	 *   [en]
	 *     Utility methods to create different kinds of notifications. There are three methods available:
	 *
	 *     * `ons.notification.alert()`
	 *     * `ons.notification.confirm()`
	 *     * `ons.notification.prompt()`
	 *     * `ons.notification.toast()`
	 *
	 *     It will automatically display a Material Design dialog on Android devices.
	 *   [/en]
	 *   [ja]いくつかの種類のアラートダイアログを作成するためのユーティリティメソッドを収めたオブジェクトです。[/ja]
	 * @example
	 * ons.notification.alert('Hello, world!');
	 *
	 * ons.notification.confirm('Are you ready?')
	 *   .then(
	 *     function(answer) {
	 *       if (answer === 1) {
	 *         ons.notification.alert('Let\'s go!');
	 *       }
	 *     }
	 *   );
	 *
	 * ons.notification.prompt('How old are ?')
	 *   .then(
	 *     function(age) {
	 *       ons.notification.alert('You are ' + age + ' years old.');
	 *     }
	 *   );
	 */
	var notification = {};
	
	notification._createAlertDialog = function () {
	  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	    params[_key] = arguments[_key];
	  }
	
	  return new Promise(function (resolve) {
	    var options = _normalizeArguments.apply(undefined, params);
	    util.checkMissingImport('AlertDialog', 'AlertDialogButton');
	
	    // Prompt input string
	    var inputString = '';
	    if (options.isPrompt) {
	      inputString = '\n      <input\n        class="text-input text-input--underbar"\n        type="' + (options.inputType || 'text') + '"\n        placeholder="' + (options.placeholder || '') + '"\n        value="' + (options.defaultValue || '') + '"\n        style="width: 100%; margin-top: 10px;"\n      />\n    ';
	    }
	
	    // Buttons string
	    var buttons = '';
	    options.buttonLabels.forEach(function (label, index) {
	      buttons += '\n      <ons-alert-dialog-button\n        class="\n          ' + (index === options.primaryButtonIndex ? ' alert-dialog-button--primal' : '') + '\n          ' + (options.buttonLabels.length <= 2 ? ' alert-dialog-button--rowfooter' : '') + '\n        "\n        style="position: relative;">\n        ' + label + '\n      </ons-alert-dialog-button>\n    ';
	    });
	
	    // Dialog Element
	    var el = {};
	    var _destroyDialog = function _destroyDialog() {
	      if (el.dialog.onDialogCancel) {
	        el.dialog.removeEventListener('dialog-cancel', el.dialog.onDialogCancel);
	      }
	
	      Object.keys(el).forEach(function (key) {
	        return delete el[key];
	      });
	      el = null;
	
	      if (options.destroy instanceof Function) {
	        options.destroy();
	      }
	    };
	
	    el.dialog = document.createElement('ons-alert-dialog');
	    el.dialog.innerHTML = '\n    <div class="alert-dialog-mask"></div>\n    <div class="alert-dialog">\n      <div class="alert-dialog-container">\n        <div class="alert-dialog-title">\n          ' + (options.title || '') + '\n        </div>\n        <div class="alert-dialog-content">\n          ' + (options.message || options.messageHTML) + '\n          ' + inputString + '\n        </div>\n        <div class="\n          alert-dialog-footer\n          ' + (options.buttonLabels.length <= 2 ? ' alert-dialog-footer--rowfooter' : '') + '\n        ">\n          ' + buttons + '\n        </div>\n      </div>\n    </div>\n  ';
	    contentReady(el.dialog);
	
	    // Set attributes
	    _setAttributes(el.dialog, options);
	
	    // Prompt events
	    if (options.isPrompt && options.submitOnEnter) {
	      el.input = el.dialog.querySelector('.text-input');
	      el.input.onkeypress = function (event) {
	        if (event.keyCode === 13) {
	          el.dialog.hide().then(function () {
	            if (el) {
	              var resolveValue = el.input.value;
	              _destroyDialog();
	              options.callback(resolveValue);
	              resolve(resolveValue);
	            }
	          });
	        }
	      };
	    }
	
	    // Button events
	    el.footer = el.dialog.querySelector('.alert-dialog-footer');
	    util.arrayFrom(el.dialog.querySelectorAll('.alert-dialog-button')).forEach(function (buttonElement, index) {
	      buttonElement.onclick = function () {
	        el.dialog.hide().then(function () {
	          if (el) {
	            var resolveValue = index;
	            if (options.isPrompt) {
	              resolveValue = index === options.primaryButtonIndex ? el.input.value : null;
	            }
	            el.dialog.remove();
	            _destroyDialog();
	            options.callback(resolveValue);
	            resolve(resolveValue);
	          }
	        });
	      };
	
	      el.footer.appendChild(buttonElement);
	    });
	
	    // Cancel events
	    if (options.cancelable) {
	      el.dialog.cancelable = true;
	      el.dialog.onDialogCancel = function () {
	        setImmediate(function () {
	          el.dialog.remove();
	          _destroyDialog();
	        });
	        var resolveValue = options.isPrompt ? null : -1;
	        options.callback(resolveValue);
	        resolve(resolveValue);
	      };
	      el.dialog.addEventListener('dialog-cancel', el.dialog.onDialogCancel, false);
	    }
	
	    // Show dialog
	    document.body.appendChild(el.dialog);
	    options.compile(el.dialog);
	    setImmediate(function () {
	      el.dialog.show().then(function () {
	        if (el.input && options.isPrompt && options.autofocus) {
	          el.input.focus();
	        }
	      });
	    });
	  });
	};
	
	/**
	 * @method alert
	 * @signature alert(message [, options] | options)
	 * @return {Promise}
	 *   [en]Will resolve to the index of the button that was pressed or `-1` when canceled.[/en]
	 *   [ja][/ja]
	 * @param {String} message
	 *   [en]Notification message. This argument is optional but if it's not defined either `options.message` or `options.messageHTML` must be defined instead.[/en]
	 *   [ja][/ja]
	 * @param {Object} options
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクトです。[/ja]
	 * @param {String} [options.message]
	 *   [en]Notification message.[/en]
	 *   [ja]アラートダイアログに表示する文字列を指定します。[/ja]
	 * @param {String} [options.messageHTML]
	 *   [en]Notification message in HTML.[/en]
	 *   [ja]アラートダイアログに表示するHTMLを指定します。[/ja]
	 * @param {String | Array} [options.buttonLabels]
	 *   [en]Labels for the buttons. Default is `"OK"`.[/en]
	 *   [ja]確認ボタンのラベルを指定します。"OK"がデフォルトです。[/ja]
	 * @param {Number} [options.primaryButtonIndex]
	 *   [en]Index of primary button. Default is the last one.[/en]
	 *   [ja]プライマリボタンのインデックスを指定します。デフォルトは 0 です。[/ja]
	 * @param {Boolean} [options.cancelable]
	 *   [en]Whether the dialog is cancelable or not. Default is `false`. If the dialog is cancelable it can be closed by clicking the background or pressing the Android back button.[/en]
	 *   [ja]ダイアログがキャンセル可能かどうかを指定します。[/ja]
	 * @param {String} [options.animation]
	 *   [en]Animation name. Available animations are `none` and `fade`. Default is `fade`.[/en]
	 *   [ja]アラートダイアログを表示する際のアニメーション名を指定します。"none", "fade"のいずれかを指定できます。[/ja]
	 * @param {String} [options.id]
	 *   [en]The `<ons-alert-dialog>` element's ID.[/en]
	 *   [ja]ons-alert-dialog要素のID。[/ja]
	 * @param {String} [options.class]
	 *   [en]The `<ons-alert-dialog>` element's class.[/en]
	 *   [ja]ons-alert-dialog要素のclass。[/ja]
	 * @param {String} [options.title]
	 *   [en]Dialog title. Default is `"Alert"`.[/en]
	 *   [ja]アラートダイアログの上部に表示するタイトルを指定します。"Alert"がデフォルトです。[/ja]
	 * @param {String} [options.modifier]
	 *   [en]Modifier for the dialog.[/en]
	 *   [ja]アラートダイアログのmodifier属性の値を指定します。[/ja]
	 * @param {Function} [options.callback]
	 *   [en]Function that executes after dialog has been closed.[/en]
	 *   [ja]アラートダイアログが閉じられた時に呼び出される関数オブジェクトを指定します。[/ja]
	 * @description
	 *   [en]
	 *     Display an alert dialog to show the user a message.
	 *
	 *     The content of the message can be either simple text or HTML.
	 *
	 *     It can be called in the following ways:
	 *
	 *     ```
	 *     ons.notification.alert(message, options);
	 *     ons.notification.alert(options);
	 *     ```
	 *
	 *     Must specify either `message` or `messageHTML`.
	 *   [/en]
	 *   [ja]
	 *     ユーザーへメッセージを見せるためのアラートダイアログを表示します。
	 *     表示するメッセージは、テキストかもしくはHTMLを指定できます。
	 *     このメソッドの引数には、options.messageもしくはoptions.messageHTMLのどちらかを必ず指定する必要があります。
	 *   [/ja]
	 */
	notification.alert = function (message, options) {
	  return notification._createAlertDialog(message, options, {
	    buttonLabels: ['OK'],
	    title: 'Alert'
	  });
	};
	
	/**
	 * @method confirm
	 * @signature confirm(message [, options] | options)
	 * @return {Promise}
	 *   [en]Will resolve to the index of the button that was pressed or `-1` when canceled.[/en]
	 *   [ja][/ja]
	 * @param {String} message
	 *   [en]Notification message. This argument is optional but if it's not defined either `options.message` or `options.messageHTML` must be defined instead.[/en]
	 *   [ja][/ja]
	 * @param {Object} options
	 *   [en]Parameter object.[/en]
	 * @param {Array} [options.buttonLabels]
	 *   [en]Labels for the buttons. Default is `["Cancel", "OK"]`.[/en]
	 *   [ja]ボタンのラベルの配列を指定します。["Cancel", "OK"]がデフォルトです。[/ja]
	 * @param {Number} [options.primaryButtonIndex]
	 *   [en]Index of primary button. Default is the last one.[/en]
	 *   [ja]プライマリボタンのインデックスを指定します。デフォルトは 1 です。[/ja]
	 * @description
	 *   [en]
	 *     Display a dialog to ask the user for confirmation. Extends `alert()` parameters.
	 *     The default button labels are `"Cancel"` and `"OK"` but they can be customized.
	 *
	 *     It can be called in the following ways:
	 *
	 *     ```
	 *     ons.notification.confirm(message, options);
	 *     ons.notification.confirm(options);
	 *     ```
	 *
	 *     Must specify either `message` or `messageHTML`.
	 *   [/en]
	 *   [ja]
	 *     ユーザに確認を促すダイアログを表示します。
	 *     デオルとのボタンラベルは、"Cancel"と"OK"ですが、これはこのメソッドの引数でカスタマイズできます。
	 *     このメソッドの引数には、options.messageもしくはoptions.messageHTMLのどちらかを必ず指定する必要があります。
	 *   [/ja]
	 */
	notification.confirm = function (message, options) {
	  return notification._createAlertDialog(message, options, {
	    buttonLabels: ['Cancel', 'OK'],
	    title: 'Confirm'
	  });
	};
	
	/**
	 * @method prompt
	 * @signature prompt(message [, options] | options)
	 * @param {String} message
	 *   [en]Notification message. This argument is optional but if it's not defined either `options.message` or `options.messageHTML` must be defined instead.[/en]
	 *   [ja][/ja]
	 * @return {Promise}
	 *   [en]Will resolve to the input value when the dialog is closed or `null` when canceled.[/en]
	 *   [ja][/ja]
	 * @param {Object} options
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクトです。[/ja]
	 * @param {String | Array} [options.buttonLabels]
	 *   [en]Labels for the buttons. Default is `"OK"`.[/en]
	 *   [ja]確認ボタンのラベルを指定します。"OK"がデフォルトです。[/ja]
	 * @param {Number} [options.primaryButtonIndex]
	 *   [en]Index of primary button. Default is the last one.[/en]
	 *   [ja]プライマリボタンのインデックスを指定します。デフォルトは 0 です。[/ja]
	 * @param {String} [options.placeholder]
	 *   [en]Placeholder for the text input.[/en]
	 *   [ja]テキスト欄のプレースホルダに表示するテキストを指定します。[/ja]
	 * @param {String} [options.defaultValue]
	 *   [en]Default value for the text input.[/en]
	 *   [ja]テキスト欄のデフォルトの値を指定します。[/ja]
	 * @param {String} [options.inputType]
	 *   [en]Type of the input element (`password`, `date`...). Default is `text`.[/en]
	 *   [ja][/ja]
	 * @param {Boolean} [options.autofocus]
	 *   [en]Autofocus the input element. Default is `true`. In Cordova, `KeyboardDisplayRequiresUserAction` in `config.xml` must be `false` to activate this feature.[/en]
	 *   [ja]input要素に自動的にフォーカスするかどうかを指定します。デフォルトはtrueです。Cordova環境では、この機能を有効にするためには `config.xml` で `KeyboardDisplayRequiresUserAction` を `false` に設定する必要があります。[/ja]
	 * @param {Boolean} [options.submitOnEnter]
	 *   [en]Submit automatically when enter is pressed. Default is `true`.[/en]
	 *   [ja]Enterが押された際にそのformをsubmitするかどうかを指定します。デフォルトはtrueです。[/ja]
	 * @description
	 *   [en]
	 *     Display a dialog with a prompt to ask the user a question. Extends `alert()` parameters.
	 *
	 *     It can be called in the following ways:
	 *
	 *     ```
	 *     ons.notification.prompt(message, options);
	 *     ons.notification.prompt(options);
	 *     ```
	 *
	 *     Must specify either `message` or `messageHTML`.
	 *   [/en]
	 *   [ja]
	 *     ユーザーに入力を促すダイアログを表示します。
	 *     このメソッドの引数には、options.messageもしくはoptions.messageHTMLのどちらかを必ず指定する必要があります。
	 *   [/ja]
	 */
	notification.prompt = function (message, options) {
	  return notification._createAlertDialog(message, options, {
	    buttonLabels: ['OK'],
	    title: 'Alert',
	    isPrompt: true,
	    autofocus: true,
	    submitOnEnter: true
	  });
	};
	
	/**
	 * @method toast
	 * @signature toast(message [, options] | options)
	 * @return {Promise}
	 *   [en]Will resolve when the toast is hidden.[/en]
	 *   [ja][/ja]
	 * @param {String} message
	 *   [en]Toast message. This argument is optional but if it's not defined then `options.message` must be defined instead.[/en]
	 *   [ja][/ja]
	 * @param {Object} options
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクトです。[/ja]
	 * @param {String} [options.message]
	 *   [en]Notification message.[/en]
	 *   [ja]トーストに表示する文字列を指定します。[/ja]
	 * @param {String} [options.buttonLabel]
	 *   [en]Label for the button.[/en]
	 *   [ja]確認ボタンのラベルを指定します。[/ja]
	 * @param {String} [options.animation]
	 *   [en]Animation name. Available animations are `none`, `fade`, `ascend`, `lift` and `fall`. Default is `ascend` for Android and `lift` for iOS.[/en]
	 *   [ja]トーストを表示する際のアニメーション名を指定します。"none", "fade", "ascend", "lift", "fall"のいずれかを指定できます。[/ja]
	 * @param {Number} [options.timeout]
	 *   [en]Number of miliseconds where the toast is visible before hiding automatically.[/en]
	 *   [ja][/ja]
	 * @param {Boolean} [options.force]
	 *   [en]If `true`, the toast skips the notification queue and is shown immediately. Defaults to `false`.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.id]
	 *   [en]The `<ons-toast>` element's ID.[/en]
	 *   [ja]ons-toast要素のID。[/ja]
	 * @param {String} [options.class]
	 *   [en]The `<ons-toast>` element's class.[/en]
	 *   [ja]ons-toast要素のclass。[/ja]
	 * @param {String} [options.modifier]
	 *   [en]Modifier for the element.[/en]
	 *   [ja]トーストのmodifier属性の値を指定します。[/ja]
	 * @param {Function} [options.callback]
	 *   [en]Function that executes after toast has been hidden.[/en]
	 *   [ja]トーストが閉じられた時に呼び出される関数オブジェクトを指定します。[/ja]
	 * @description
	 *   [en]
	 *     Display a simple notification toast with an optional button that can be used for simple actions.
	 *
	 *     It can be called in the following ways:
	 *
	 *     ```
	 *     ons.notification.toast(message, options);
	 *     ons.notification.toast(options);
	 *     ```
	 *   [/en]
	 *   [ja][/ja]
	 */
	notification.toast = function (message, options) {
	  var promise = new Promise(function (resolve) {
	    util.checkMissingImport('Toast'); // Throws error, must be inside promise
	
	    options = _normalizeArguments(message, options, {
	      timeout: 0,
	      force: false
	    });
	
	    var toast = util.createElement('\n      <ons-toast>\n        ' + options.message + '\n        ' + (options.buttonLabels ? '<button>' + options.buttonLabels[0] + '</button>' : '') + '\n      </ons-toast>\n    ');
	
	    _setAttributes(toast, options);
	
	    var finish = function finish(value) {
	      if (toast) {
	        toast.hide().then(function () {
	          if (toast) {
	            toast.remove();
	            toast = null;
	            options.callback(value);
	            resolve(value);
	          }
	        });
	      }
	    };
	
	    if (options.buttonLabels) {
	      util.findChild(toast._toast, 'button').onclick = function () {
	        return finish(0);
	      };
	    }
	
	    document.body.appendChild(toast);
	    options.compile(toast);
	
	    var show = function show() {
	      toast.parentElement && toast.show(options).then(function () {
	        if (options.timeout) {
	          setTimeout(function () {
	            return finish(-1);
	          }, options.timeout);
	        }
	      });
	    };
	
	    setImmediate(function () {
	      return options.force ? show() : ToastQueue$1.add(show, promise);
	    });
	  });
	
	  return promise;
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	// Validate parameters
	var checkOptions = function checkOptions(options) {
	  var err = function err(prop) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Function';
	    throw new Error('"options.' + prop + '" must be an instance of ' + type + '.');
	  };
	  var hasOwnProperty = function hasOwnProperty(prop) {
	    return Object.hasOwnProperty.call(options, prop);
	  };
	  var instanceOf = function instanceOf(prop) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Function;
	    return options[prop] instanceof type;
	  };
	
	  var b = 'buttons',
	      cb = 'callback',
	      c = 'compile',
	      d = 'destroy';
	  (!hasOwnProperty(b) || !instanceOf(b, Array)) && err(b, 'Array');
	  hasOwnProperty(cb) && !instanceOf(cb) && err(cb);
	  hasOwnProperty(c) && !instanceOf(c) && err(c);
	  hasOwnProperty(d) && !instanceOf(d) && err(d);
	};
	
	// Action Sheet
	var actionSheet = (function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve) {
	    util.checkMissingImport('ActionSheet');
	    checkOptions(options);
	
	    // Main component
	    var actionSheet = util.createElement('\n    <ons-action-sheet\n      ' + (options.title ? 'title="' + options.title + '"' : '') + '\n      ' + (options.cancelable ? 'cancelable' : '') + '\n      ' + (options.modifier ? 'modifier="' + options.modifier + '"' : '') + '\n      ' + (options.maskColor ? 'mask-color="' + options.maskColor + '"' : '') + '\n      ' + (options.id ? 'id="' + options.id + '"' : '') + '\n      ' + (options.class ? 'class="' + options.class + '"' : '') + '\n    >\n      <div class="action-sheet"></div>\n    </ons-action-sheet>\n  ');
	
	    // Resolve action and clean up
	    var finish = function finish(event) {
	      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	      if (actionSheet) {
	        options.destroy && options.destroy(actionSheet);
	
	        actionSheet.removeEventListener('dialog-cancel', finish, false);
	        actionSheet.remove();
	        actionSheet = null;
	
	        options.callback && options.callback(index);
	        resolve(index);
	      }
	    };
	
	    // Link cancel handler
	    actionSheet.addEventListener('dialog-cancel', finish, false);
	
	    // Create buttons and link action handler
	    var buttons = document.createDocumentFragment();
	    options.buttons.forEach(function (item, index) {
	      var buttonOptions = typeof item === 'string' ? { label: item } : _extends({}, item);
	      if (options.destructive === index) {
	        buttonOptions.modifier = (buttonOptions.modifier || '') + ' destructive';
	      }
	
	      var button = util.createElement('\n      <ons-action-sheet-button\n        ' + (buttonOptions.icon ? 'icon="' + buttonOptions.icon + '"' : '') + '\n        ' + (buttonOptions.modifier ? 'modifier="' + buttonOptions.modifier + '"' : '') + '\n      >\n        ' + buttonOptions.label + '\n      </ons-action-sheet-button>\n    ');
	
	      button.onclick = function (event) {
	        return actionSheet.hide().then(function () {
	          return finish(event, index);
	        });
	      };
	      buttons.appendChild(button);
	    });
	
	    // Finish component and attach
	    util.findChild(actionSheet, '.action-sheet').appendChild(buttons);
	    document.body.appendChild(actionSheet);
	    options.compile && options.compile(el.dialog);
	
	    // Show
	    setImmediate(function () {
	      return actionSheet.show({
	        animation: options.animation,
	        animationOptions: options.animationOptions
	      });
	    });
	  });
	});
	
	/**
	 * MicroEvent - to make any js object an event emitter (server or browser)
	 *
	 * - pure javascript - server compatible, browser compatible
	 * - dont rely on the browser doms
	 * - super simple - you get it immediately, no mystery, no magic involved
	 *
	 * - create a MicroEventDebug with goodies to debug
	 *   - make it safer to use
	*/
	
	/** NOTE: This library is customized for Onsen UI. */
	
	var MicroEvent = function MicroEvent() {};
	MicroEvent.prototype = {
	  on: function on(event, fct) {
	    this._events = this._events || {};
	    this._events[event] = this._events[event] || [];
	    this._events[event].push(fct);
	  },
	  once: function once(event, fct) {
	    var self = this;
	    var wrapper = function wrapper() {
	      self.off(event, wrapper);
	      return fct.apply(null, arguments);
	    };
	    this.on(event, wrapper);
	  },
	  off: function off(event, fct) {
	    this._events = this._events || {};
	    if (event in this._events === false) {
	      return;
	    }
	
	    this._events[event] = this._events[event].filter(function (_fct) {
	      if (fct) {
	        return fct !== _fct;
	      } else {
	        return false;
	      }
	    });
	  },
	  emit: function emit(event /* , args... */) {
	    this._events = this._events || {};
	    if (event in this._events === false) {
	      return;
	    }
	    for (var i = 0; i < this._events[event].length; i++) {
	      this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
	    }
	  }
	};
	
	/**
	 * mixin will delegate all MicroEvent.js function in the destination object
	 *
	 * - require('MicroEvent').mixin(Foobar) will make Foobar able to use MicroEvent
	 *
	 * @param {Object} the object which will support MicroEvent
	*/
	MicroEvent.mixin = function (destObject) {
	  var props = ['on', 'once', 'off', 'emit'];
	  for (var i = 0; i < props.length; i++) {
	    if (typeof destObject === 'function') {
	      destObject.prototype[props[i]] = MicroEvent.prototype[props[i]];
	    } else {
	      destObject[props[i]] = MicroEvent.prototype[props[i]];
	    }
	  }
	};
	
	window.MicroEvent = MicroEvent;
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var create = function create() {
	
	  /**
	   * @object ons.orientation
	   * @category util
	   * @description
	   *   [en]Utility methods for orientation detection.[/en]
	   *   [ja]画面のオリエンテーション検知のためのユーティリティメソッドを収めているオブジェクトです。[/ja]
	   */
	  var obj = {
	    /**
	     * @event change
	     * @description
	     *   [en]Fired when the device orientation changes.[/en]
	     *   [ja]デバイスのオリエンテーションが変化した際に発火します。[/ja]
	     * @param {Object} event
	     *   [en]Event object.[/en]
	     *   [ja]イベントオブジェクトです。[/ja]
	     * @param {Boolean} event.isPortrait
	     *   [en]Will be true if the current orientation is portrait mode.[/en]
	     *   [ja]現在のオリエンテーションがportraitの場合にtrueを返します。[/ja]
	     */
	
	    /**
	     * @method on
	     * @signature on(eventName, listener)
	     * @description
	     *   [en]Add an event listener.[/en]
	     *   [ja]イベントリスナーを追加します。[/ja]
	     * @param {String} eventName
	     *   [en]Name of the event.[/en]
	     *   [ja]イベント名を指定します。[/ja]
	     * @param {Function} listener
	     *   [en]Function to execute when the event is triggered.[/en]
	     *   [ja]このイベントが発火された際に呼び出される関数オブジェクトを指定します。[/ja]
	     */
	
	    /**
	     * @method once
	     * @signature once(eventName, listener)
	     * @description
	     *  [en]Add an event listener that's only triggered once.[/en]
	     *  [ja]一度だけ呼び出されるイベントリスナーを追加します。[/ja]
	     * @param {String} eventName
	     *   [en]Name of the event.[/en]
	     *   [ja]イベント名を指定します。[/ja]
	     * @param {Function} listener
	     *   [en]Function to execute when the event is triggered.[/en]
	     *   [ja]イベントが発火した際に呼び出される関数オブジェクトを指定します。[/ja]
	     */
	
	    /**
	     * @method off
	     * @signature off(eventName, [listener])
	     * @description
	     *  [en]Remove an event listener. If the listener is not specified all listeners for the event type will be removed.[/en]
	     *  [ja]イベントリスナーを削除します。もしイベントリスナーを指定しなかった場合には、そのイベントに紐づく全てのイベントリスナーが削除されます。[/ja]
	     * @param {String} eventName
	     *   [en]Name of the event.[/en]
	     *   [ja]イベント名を指定します。[/ja]
	     * @param {Function} listener
	     *   [en]Function to execute when the event is triggered.[/en]
	     *   [ja]削除するイベントリスナーを指定します。[/ja]
	     */
	
	    // actual implementation to detect if whether current screen is portrait or not
	    _isPortrait: false,
	
	    /**
	     * @method isPortrait
	     * @signature isPortrait()
	     * @return {Boolean}
	     *   [en]Will be true if the current orientation is portrait mode.[/en]
	     *   [ja]オリエンテーションがportraitモードの場合にtrueになります。[/ja]
	     * @description
	     *   [en]Returns whether the current screen orientation is portrait or not.[/en]
	     *   [ja]オリエンテーションがportraitモードかどうかを返します。[/ja]
	     */
	    isPortrait: function isPortrait() {
	      return this._isPortrait();
	    },
	
	    /**
	     * @method isLandscape
	     * @signature isLandscape()
	     * @return {Boolean}
	     *   [en]Will be true if the current orientation is landscape mode.[/en]
	     *   [ja]オリエンテーションがlandscapeモードの場合にtrueになります。[/ja]
	     * @description
	     *   [en]Returns whether the current screen orientation is landscape or not.[/en]
	     *   [ja]オリエンテーションがlandscapeモードかどうかを返します。[/ja]
	     */
	    isLandscape: function isLandscape() {
	      return !this.isPortrait();
	    },
	
	    _init: function _init() {
	      document.addEventListener('DOMContentLoaded', this._onDOMContentLoaded.bind(this), false);
	
	      if ('orientation' in window) {
	        window.addEventListener('orientationchange', this._onOrientationChange.bind(this), false);
	      } else {
	        window.addEventListener('resize', this._onResize.bind(this), false);
	      }
	
	      this._isPortrait = function () {
	        return window.innerHeight > window.innerWidth;
	      };
	
	      return this;
	    },
	
	    _onDOMContentLoaded: function _onDOMContentLoaded() {
	      this._installIsPortraitImplementation();
	      this.emit('change', { isPortrait: this.isPortrait() });
	    },
	
	    _installIsPortraitImplementation: function _installIsPortraitImplementation() {
	      var isPortrait = window.innerWidth < window.innerHeight;
	
	      if (!('orientation' in window)) {
	        this._isPortrait = function () {
	          return window.innerHeight > window.innerWidth;
	        };
	      } else if (window.orientation % 180 === 0) {
	        this._isPortrait = function () {
	          return Math.abs(window.orientation % 180) === 0 ? isPortrait : !isPortrait;
	        };
	      } else {
	        this._isPortrait = function () {
	          return Math.abs(window.orientation % 180) === 90 ? isPortrait : !isPortrait;
	        };
	      }
	    },
	
	    _onOrientationChange: function _onOrientationChange() {
	      var _this = this;
	
	      var isPortrait = this._isPortrait();
	
	      // Wait for the dimensions to change because
	      // of Android inconsistency.
	      var nIter = 0;
	      var interval = setInterval(function () {
	        nIter++;
	
	        var w = window.innerWidth;
	        var h = window.innerHeight;
	
	        if (isPortrait && w <= h || !isPortrait && w >= h) {
	          _this.emit('change', { isPortrait: isPortrait });
	          clearInterval(interval);
	        } else if (nIter === 50) {
	          _this.emit('change', { isPortrait: isPortrait });
	          clearInterval(interval);
	        }
	      }, 20);
	    },
	
	    // Run on not mobile browser.
	    _onResize: function _onResize() {
	      this.emit('change', { isPortrait: this.isPortrait() });
	    }
	  };
	
	  MicroEvent.mixin(obj);
	
	  return obj;
	};
	
	var orientation = create()._init();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @object ons.modifier
	 * @category visual
	 * @description
	 *   [en]
	 *     Utility methods to change modifier attributes of Onsen UI elements..
	 *   [/en]
	 *   [ja][/ja]
	 * @example
	 * ons.modifier.add(myOnsInputElement, 'underbar');
	 * ons.modifier.toggle(myOnsToastElement, 'custom-modifier');
	 *
	 */
	var modifier = {
	  /**
	   * @method add
	   * @signature add(element, modifier [, modifier])
	   * @description
	   *   [en]Add the specified modifiers to the element if they are not already included.[/en]
	   *   [ja][/ja]
	   * @param {HTMLElement} element
	   *   [en]Target element.[/en]
	   *   [ja][/ja]
	   * @param {String} modifier
	   *   [en]Name of the modifier.[/en]
	   *   [ja][/ja]
	   */
	  add: function add(element) {
	    for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      modifiers[_key - 1] = arguments[_key];
	    }
	
	    return modifiers.forEach(function (modifier) {
	      return util.addModifier(element, modifier);
	    });
	  },
	  /**
	   * @method remove
	   * @signature remove(element, modifier [, modifier])
	   * @description
	   *   [en]Remove the specified modifiers from the element if they are included.[/en]
	   *   [ja][/ja]
	   * @param {HTMLElement} element
	   *   [en]Target element.[/en]
	   *   [ja][/ja]
	   * @param {String} modifier
	   *   [en]Name of the modifier.[/en]
	   *   [ja][/ja]
	   */
	  remove: function remove(element) {
	    for (var _len2 = arguments.length, modifiers = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      modifiers[_key2 - 1] = arguments[_key2];
	    }
	
	    return modifiers.forEach(function (modifier) {
	      return util.removeModifier(element, modifier);
	    });
	  },
	  /**
	   * @method contains
	   * @signature contains(element, modifier)
	   * @description
	   *   [en]Check whether the specified modifier is included in the element.[/en]
	   *   [ja][/ja]
	   * @param {HTMLElement} element
	   *   [en]Target element.[/en]
	   *   [ja][/ja]
	   * @param {String} modifier
	   *   [en]Name of the modifier.[/en]
	   *   [ja][/ja]
	   * @return {Boolean}
	   *   [en]`true` when the specified modifier is found in the element's `modifier` attribute. `false` otherwise.[/en]
	   *   [ja][/ja]
	   */
	  contains: util.hasModifier,
	  /**
	   * @method toggle
	   * @signature toggle(element, modifier [, force])
	   * @description
	   *   [en]Toggle the specified modifier.[/en]
	   *   [ja][/ja]
	   * @param {HTMLElement} element
	   *   [en]Target element.[/en]
	   *   [ja][/ja]
	   * @param {String} modifier
	   *   [en]Name of the modifier.[/en]
	   *   [ja][/ja]
	   * @param {String} force
	   *   [en]If it evaluates to true, add specified modifier value, and if it evaluates to false, remove it.[/en]
	   *   [ja][/ja]
	   */
	  toggle: util.toggleModifier
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var softwareKeyboard = new MicroEvent();
	softwareKeyboard._visible = false;
	
	var onShow = function onShow() {
	  softwareKeyboard._visible = true;
	  softwareKeyboard.emit('show');
	};
	
	var onHide = function onHide() {
	  softwareKeyboard._visible = false;
	  softwareKeyboard.emit('hide');
	};
	
	var bindEvents = function bindEvents() {
	  if (typeof Keyboard !== 'undefined') {
	    // https://github.com/martinmose/cordova-keyboard/blob/95f3da3a38d8f8e1fa41fbf40145352c13535a00/README.md
	    Keyboard.onshow = onShow;
	    Keyboard.onhide = onHide;
	    softwareKeyboard.emit('init', { visible: Keyboard.isVisible });
	
	    return true;
	  } else if (typeof cordova.plugins !== 'undefined' && typeof cordova.plugins.Keyboard !== 'undefined') {
	    // https://github.com/driftyco/ionic-plugins-keyboard/blob/ca27ecf/README.md
	    window.addEventListener('native.keyboardshow', onShow);
	    window.addEventListener('native.keyboardhide', onHide);
	    softwareKeyboard.emit('init', { visible: cordova.plugins.Keyboard.isVisible });
	
	    return true;
	  }
	
	  return false;
	};
	
	var noPluginError = function noPluginError() {
	  util.warn('ons-keyboard: Cordova Keyboard plugin is not present.');
	};
	
	document.addEventListener('deviceready', function () {
	  if (!bindEvents()) {
	    if (document.querySelector('[ons-keyboard-active]') || document.querySelector('[ons-keyboard-inactive]')) {
	      noPluginError();
	    }
	
	    softwareKeyboard.on = noPluginError;
	  }
	});
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    return i++;
	  };
	}();
	
	/**
	 * Door locking system.
	 *
	 * @param {Object} [options]
	 * @param {Function} [options.log]
	 */
	
	var DoorLock = function () {
	  function DoorLock() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, DoorLock);
	
	    this._lockList = [];
	    this._waitList = [];
	    this._log = options.log || function () {};
	  }
	
	  /**
	   * Register a lock.
	   *
	   * @return {Function} Callback for unlocking.
	   */
	
	
	  createClass(DoorLock, [{
	    key: 'lock',
	    value: function lock() {
	      var _this = this;
	
	      var unlock = function unlock() {
	        _this._unlock(unlock);
	      };
	      unlock.id = generateId();
	      this._lockList.push(unlock);
	      this._log('lock: ' + unlock.id);
	
	      return unlock;
	    }
	  }, {
	    key: '_unlock',
	    value: function _unlock(fn) {
	      var index = this._lockList.indexOf(fn);
	      if (index === -1) {
	        throw new Error('This function is not registered in the lock list.');
	      }
	
	      this._lockList.splice(index, 1);
	      this._log('unlock: ' + fn.id);
	
	      this._tryToFreeWaitList();
	    }
	  }, {
	    key: '_tryToFreeWaitList',
	    value: function _tryToFreeWaitList() {
	      while (!this.isLocked() && this._waitList.length > 0) {
	        this._waitList.shift()();
	      }
	    }
	
	    /**
	     * Register a callback for waiting unlocked door.
	     *
	     * @params {Function} callback Callback on unlocking the door completely.
	     */
	
	  }, {
	    key: 'waitUnlock',
	    value: function waitUnlock(callback) {
	      if (!(callback instanceof Function)) {
	        throw new Error('The callback param must be a function.');
	      }
	
	      if (this.isLocked()) {
	        this._waitList.push(callback);
	      } else {
	        callback();
	      }
	    }
	
	    /**
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isLocked',
	    value: function isLocked() {
	      return this._lockList.length > 0;
	    }
	  }]);
	  return DoorLock;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	// Default implementation for global PageLoader.
	function loadPage(_ref, done) {
	  var page = _ref.page,
	      parent = _ref.parent,
	      _ref$params = _ref.params;
	
	  internal$1.getPageHTMLAsync(page).then(function (html) {
	    var pageElement = util.createElement(html);
	    parent.appendChild(pageElement);
	
	    done(pageElement);
	  });
	}
	
	function unloadPage(element) {
	  if (element._destroy instanceof Function) {
	    element._destroy();
	  } else {
	    element.remove();
	  }
	}
	
	var PageLoader = function () {
	  /**
	   * @param {Function} [fn] Returns an object that has "element" property and "unload" function.
	   */
	  function PageLoader(loader, unloader) {
	    classCallCheck(this, PageLoader);
	
	    this._loader = loader instanceof Function ? loader : loadPage;
	    this._unloader = unloader instanceof Function ? unloader : unloadPage;
	  }
	
	  /**
	   * Set internal loader implementation.
	   */
	
	
	  createClass(PageLoader, [{
	    key: 'load',
	
	
	    /**
	     * @param {any} options.page
	     * @param {Element} options.parent A location to load page.
	     * @param {Object} [options.params] Extra parameters for ons-page.
	     * @param {Function} done Take an object that has "element" property and "unload" function.
	     */
	    value: function load(_ref2, done) {
	      var page = _ref2.page,
	          parent = _ref2.parent,
	          _ref2$params = _ref2.params,
	          params = _ref2$params === undefined ? {} : _ref2$params;
	
	      this._loader({ page: page, parent: parent, params: params }, function (pageElement) {
	        if (!(pageElement instanceof Element)) {
	          throw Error('pageElement must be an instance of Element.');
	        }
	
	        done(pageElement);
	      });
	    }
	  }, {
	    key: 'unload',
	    value: function unload(pageElement) {
	      if (!(pageElement instanceof Element)) {
	        throw Error('pageElement must be an instance of Element.');
	      }
	
	      this._unloader(pageElement);
	    }
	  }, {
	    key: 'internalLoader',
	    set: function set$$1(fn) {
	      if (!(fn instanceof Function)) {
	        throw Error('First parameter must be an instance of Function');
	      }
	      this._loader = fn;
	    },
	    get: function get$$1() {
	      return this._loader;
	    }
	  }]);
	  return PageLoader;
	}();
	
	var defaultPageLoader = new PageLoader();
	
	var instantPageLoader = new PageLoader(function (_ref3, done) {
	  var page = _ref3.page,
	      parent = _ref3.parent,
	      _ref3$params = _ref3.params;
	
	  var element = util.createElement(page.trim());
	  parent.appendChild(element);
	
	  done(element);
	}, unloadPage);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @object ons
	 * @category util
	 * @description
	 *   [ja]Onsen UIで利用できるグローバルなオブジェクトです。[/ja]
	 *   [en]A global object that's used in Onsen UI. [/en]
	 */
	var ons$1 = {
	  animit: Animit,
	  defaultPageLoader: defaultPageLoader,
	  elements: onsElements,
	  GestureDetector: GestureDetector,
	  modifier: modifier,
	  notification: notification,
	  orientation: orientation,
	  pageAttributeExpression: pageAttributeExpression,
	  PageLoader: PageLoader,
	  platform: platform,
	  softwareKeyboard: softwareKeyboard,
	  _autoStyle: autoStyle,
	  _internal: internal$1,
	  _readyLock: new DoorLock(),
	  _util: util
	};
	
	ons$1.platform.select((window.location.search.match(/platform=([\w-]+)/) || [])[1]);
	
	waitDeviceReady();
	
	/**
	 * @method isReady
	 * @signature isReady()
	 * @return {Boolean}
	 *   [en]Will be true if Onsen UI is initialized.[/en]
	 *   [ja]初期化されているかどうかを返します。[/ja]
	 * @description
	 *   [en]Returns true if Onsen UI is initialized.[/en]
	 *   [ja]Onsen UIがすでに初期化されているかどうかを返すメソッドです。[/ja]
	 */
	ons$1.isReady = function () {
	  return !ons$1._readyLock.isLocked();
	};
	
	/**
	 * @method isWebView
	 * @signature isWebView()
	 * @return {Boolean}
	 *   [en]Will be true if the app is running in Cordova.[/en]
	 *   [ja]Cordovaで実行されている場合にtrueになります。[/ja]
	 * @description
	 *   [en]Returns true if running inside Cordova.[/en]
	 *   [ja]Cordovaで実行されているかどうかを返すメソッドです。[/ja]
	 */
	ons$1.isWebView = ons$1.platform.isWebView;
	
	/**
	 * @method ready
	 * @signature ready(callback)
	 * @description
	 *   [ja]アプリの初期化に利用するメソッドです。渡された関数は、Onsen UIの初期化が終了している時点で必ず呼ばれます。[/ja]
	 *   [en]Method used to wait for app initialization. Waits for `DOMContentLoaded` and `deviceready`, when necessary, before executing the callback.[/en]
	 * @param {Function} callback
	 *   [en]Function that executes after Onsen UI has been initialized.[/en]
	 *   [ja]Onsen UIが初期化が完了した後に呼び出される関数オブジェクトを指定します。[/ja]
	 */
	ons$1.ready = function (callback) {
	  if (ons$1.isReady()) {
	    callback();
	  } else {
	    ons$1._readyLock.waitUnlock(callback);
	  }
	};
	
	/**
	 * @method setDefaultDeviceBackButtonListener
	 * @signature setDefaultDeviceBackButtonListener(listener)
	 * @param {Function} listener
	 *   [en]Function that executes when device back button is pressed. Must be called on `ons.ready`.[/en]
	 *   [ja]デバイスのバックボタンが押された時に実行される関数オブジェクトを指定します。[/ja]
	 * @description
	 *   [en]Set default handler for device back button.[/en]
	 *   [ja]デバイスのバックボタンのためのデフォルトのハンドラを設定します。[/ja]
	 */
	ons$1.setDefaultDeviceBackButtonListener = function (listener) {
	  if (!ons$1.isReady()) {
	    throw new Error('This method must be called after ons.isReady() is true.');
	  }
	  ons$1._defaultDeviceBackButtonHandler.setListener(listener);
	};
	
	/**
	 * @method disableDeviceBackButtonHandler
	 * @signature disableDeviceBackButtonHandler()
	 * @description
	 * [en]Disable device back button event handler. Must be called on `ons.ready`.[/en]
	 * [ja]デバイスのバックボタンのイベントを受け付けないようにします。[/ja]
	 */
	ons$1.disableDeviceBackButtonHandler = function () {
	  if (!ons$1.isReady()) {
	    throw new Error('This method must be called after ons.isReady() is true.');
	  }
	  internal$1.dbbDispatcher.disable();
	};
	
	/**
	 * @method enableDeviceBackButtonHandler
	 * @signature enableDeviceBackButtonHandler()
	 * @description
	 * [en]Enable device back button event handler. Must be called on `ons.ready`.[/en]
	 * [ja]デバイスのバックボタンのイベントを受け付けるようにします。[/ja]
	 */
	ons$1.enableDeviceBackButtonHandler = function () {
	  if (!ons$1.isReady()) {
	    throw new Error('This method must be called after ons.isReady() is true.');
	  }
	  internal$1.dbbDispatcher.enable();
	};
	
	ons$1.fireDeviceBackButtonEvent = function () {
	  internal$1.dbbDispatcher.fireDeviceBackButtonEvent();
	};
	
	/**
	 * @method enableAutoStatusBarFill
	 * @signature enableAutoStatusBarFill()
	 * @description
	 *   [en]Enable status bar fill feature on iOS7 and above (except for iPhone X). Must be called before `ons.ready`.[/en]
	 *   [ja]iOS7以上（iPhone Xは除く）で、ステータスバー部分の高さを自動的に埋める処理を有効にします。[/ja]
	 */
	ons$1.enableAutoStatusBarFill = function () {
	  if (ons$1.isReady()) {
	    throw new Error('This method must be called before ons.isReady() is true.');
	  }
	  internal$1.config.autoStatusBarFill = true;
	};
	
	/**
	 * @method disableAutoStatusBarFill
	 * @signature disableAutoStatusBarFill()
	 * @description
	 *   [en]Disable status bar fill feature on iOS7 and above (except for iPhone X). Must be called before `ons.ready`.[/en]
	 *   [ja]iOS7以上（iPhone Xは除く）で、ステータスバー部分の高さを自動的に埋める処理を無効にします。[/ja]
	 */
	ons$1.disableAutoStatusBarFill = function () {
	  if (ons$1.isReady()) {
	    throw new Error('This method must be called before ons.isReady() is true.');
	  }
	  internal$1.config.autoStatusBarFill = false;
	};
	
	/**
	 * @method mockStatusBar
	 * @signature mockStatusBar()
	 * @description
	 *   [en]Creates a static element similar to iOS status bar. Only useful for browser testing. Must be called before `ons.ready`.[/en]
	 *   [ja][/ja]
	 */
	ons$1.mockStatusBar = function () {
	  if (ons$1.isReady()) {
	    throw new Error('This method must be called before ons.isReady() is true.');
	  }
	
	  var mock = function mock() {
	    if (!document.body.children[0] || !document.body.children[0].classList.contains('ons-status-bar-mock')) {
	      var android = platform.isAndroid(),
	          i = function i(_i) {
	        return '<i class="' + _i.split('-')[0] + ' ' + _i + '"></i>';
	      };
	      var left = android ? i('zmdi-twitter') + ' ' + i('zmdi-google-play') : 'No SIM ' + i('fa-wifi'),
	          center = android ? '' : '12:28 PM',
	          right = android ? i('zmdi-network') + ' ' + i('zmdi-wifi') + ' ' + i('zmdi-battery') + ' 12:28 PM' : '80% ' + i('fa-battery-three-quarters');
	
	      document.body.insertBefore(util.createElement('<div class="ons-status-bar-mock ' + (android ? 'android' : 'ios') + '">' + ('<div>' + left + '</div><div>' + center + '</div><div>' + right + '</div>') + '</div>'), document.body.firstChild);
	    }
	  };
	
	  document.body ? mock() : internal$1.waitDOMContentLoaded(mock);
	};
	
	/**
	 * @method disableAnimations
	 * @signature disableAnimations()
	 * @description
	 *   [en]Disable all animations. Could be handy for testing and older devices.[/en]
	 *   [ja]アニメーションを全て無効にします。テストの際に便利です。[/ja]
	 */
	ons$1.disableAnimations = function () {
	  internal$1.config.animationsDisabled = true;
	};
	
	/**
	 * @method enableAnimations
	 * @signature enableAnimations()
	 * @description
	 *   [en]Enable animations (default).[/en]
	 *   [ja]アニメーションを有効にします。[/ja]
	 */
	ons$1.enableAnimations = function () {
	  internal$1.config.animationsDisabled = false;
	};
	
	ons$1._disableWarnings = function () {
	  internal$1.config.warningsDisabled = true;
	};
	
	ons$1._enableWarnings = function () {
	  internal$1.config.warningsDisabled = false;
	};
	
	/**
	 * @method disableAutoStyling
	 * @signature disableAutoStyling()
	 * @description
	 *   [en]Disable automatic styling.[/en]
	 *   [ja][/ja]
	 */
	ons$1.disableAutoStyling = autoStyle.disable;
	
	/**
	 * @method enableAutoStyling
	 * @signature enableAutoStyling()
	 * @description
	 *   [en]Enable automatic styling based on OS (default).[/en]
	 *   [ja][/ja]
	 */
	ons$1.enableAutoStyling = autoStyle.enable;
	
	/**
	 * @method disableIconAutoPrefix
	 * @signature disableIconAutoPrefix()
	 * @description
	 *   [en]Disable adding `fa-` prefix automatically to `ons-icon` classes. Useful when including custom icon packs.[/en]
	 *   [ja][/ja]
	 */
	ons$1.disableIconAutoPrefix = function () {
	  util.checkMissingImport('Icon');
	  onsElements.Icon.setAutoPrefix(false);
	};
	
	/**
	 * @method forceUIWebViewScrollFix
	 * @signature forceUIWebViewScrollFix()
	 * @param {Boolean} force Enable or disable the fix.
	 * @description
	 *   [en]Applies a fix for iOS UIWebView which prevents scroll events jumping to pages under the top layer. This may visually affect normal scrolling of UIWebView if you open a dialog/menu before the scroll momentum finished. Disabled by default.[/en]
	 *   [ja][/ja]
	 */
	ons$1.forceUIWebViewScrollFix = function () {
	  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  internal$1.config.forceUIWebViewScrollFix = force;
	};
	
	/**
	 * @method forcePlatformStyling
	 * @signature forcePlatformStyling(platform)
	 * @description
	 *   [en]Refresh styling for the given platform. Only useful for demos. Use `ons.platform.select(...)` instead for development and production.[/en]
	 *   [ja][/ja]
	 * @param {string} platform New platform to style the elements.
	 */
	ons$1.forcePlatformStyling = function (newPlatform) {
	  ons$1.enableAutoStyling();
	  ons$1.platform.select(newPlatform || 'ios');
	
	  ons$1._util.arrayFrom(document.querySelectorAll('*')).forEach(function (element) {
	    if (element.tagName.toLowerCase() === 'ons-if') {
	      element._platformUpdate();
	    } else if (element.tagName.match(/^ons-/i)) {
	      autoStyle.prepare(element, true);
	      if (element.tagName.toLowerCase() === 'ons-tabbar') {
	        element._updatePosition();
	      }
	    }
	  });
	};
	
	/**
	 * @method preload
	 * @signature preload(templatePaths)
	 * @param {String|Array} templatePaths
	 *   [en]Set of HTML file paths containing 'ons-page' elements.[/en]
	 *   [ja][/ja]
	 * @return {Promise}
	 *   [en]Promise that resolves when all the templates are cached.[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]Separated files need to be requested on demand and this can slightly delay pushing new pages. This method requests and caches templates for later use.[/en]
	 *   [ja][/ja]
	 */
	ons$1.preload = function () {
	  var templates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return Promise.all((templates instanceof Array ? templates : [templates]).map(function (template) {
	    if (typeof template !== 'string') {
	      throw new Error('Expected string arguments but got ' + (typeof template === 'undefined' ? 'undefined' : _typeof(template)));
	    }
	    return internal$1.getTemplateHTMLAsync(template);
	  }));
	};
	
	/**
	 * @method createElement
	 * @signature createElement(template, options)
	 * @param {String} template
	 *   [en]Either an HTML file path, a `<template>` id or an HTML string such as `'<div id="foo">hoge</div>'`.[/en]
	 *   [ja][/ja]
	 * @param {Object} [options]
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクト。[/ja]
	 * @param {Boolean|HTMLElement} [options.append]
	 *   [en]Whether or not the element should be automatically appended to the DOM.  Defaults to `false`. If `true` value is given, `document.body` will be used as the target.[/en]
	 *   [ja][/ja]
	 * @param {HTMLElement} [options.insertBefore]
	 *   [en]Reference node that becomes the next sibling of the new node (`options.append` element).[/en]
	 *   [ja][/ja]
	 * @return {HTMLElement|Promise}
	 *   [en]If the provided template was an inline HTML string, it returns the new element. Otherwise, it returns a promise that resolves to the new element.[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]Create a new element from a template. Both inline HTML and external files are supported although the return value differs.[/en]
	 *   [ja][/ja]
	 */
	ons$1.createElement = function (template) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  template = template.trim();
	
	  var create = function create(html) {
	    var element = ons$1._util.createElement(html);
	    element.remove();
	
	    if (options.append) {
	      var target = options.append instanceof HTMLElement ? options.append : document.body;
	      target.insertBefore(element, options.insertBefore || null);
	      options.link instanceof Function && options.link(element);
	    }
	
	    return element;
	  };
	
	  return template.charAt(0) === '<' ? create(template) : internal$1.getPageHTMLAsync(template).then(create);
	};
	
	/**
	 * @method createPopover
	 * @signature createPopover(page, [options])
	 * @param {String} page
	 *   [en]Page name. Can be either an HTML file or a <template> containing a <ons-dialog> component.[/en]
	 *   [ja]pageのURLか、もしくは`<template>`で宣言したテンプレートのid属性の値を指定できます。[/ja]
	 * @param {Object} [options]
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクト。[/ja]
	 * @param {Object} [options.parentScope]
	 *   [en]Parent scope of the dialog. Used to bind models and access scope methods from the dialog.[/en]
	 *   [ja]ダイアログ内で利用する親スコープを指定します。ダイアログからモデルやスコープのメソッドにアクセスするのに使います。このパラメータはAngularJSバインディングでのみ利用できます。[/ja]
	 * @return {Promise}
	 *   [en]Promise object that resolves to the popover component object.[/en]
	 *   [ja]ポップオーバーのコンポーネントオブジェクトを解決するPromiseオブジェクトを返します。[/ja]
	 * @description
	 *   [en]Create a popover instance from a template.[/en]
	 *   [ja]テンプレートからポップオーバーのインスタンスを生成します。[/ja]
	 */
	/**
	 * @method createDialog
	 * @signature createDialog(page, [options])
	 * @param {String} page
	 *   [en]Page name. Can be either an HTML file or an `<template>` containing a <ons-dialog> component.[/en]
	 *   [ja]pageのURLか、もしくは`<template>`で宣言したテンプレートのid属性の値を指定できます。[/ja]
	 * @param {Object} [options]
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクト。[/ja]
	 * @return {Promise}
	 *   [en]Promise object that resolves to the dialog component object.[/en]
	 *   [ja]ダイアログのコンポーネントオブジェクトを解決するPromiseオブジェクトを返します。[/ja]
	 * @description
	 *   [en]Create a dialog instance from a template.[/en]
	 *   [ja]テンプレートからダイアログのインスタンスを生成します。[/ja]
	 */
	/**
	 * @method createAlertDialog
	 * @signature createAlertDialog(page, [options])
	 * @param {String} page
	 *   [en]Page name. Can be either an HTML file or an `<template>` containing a <ons-alert-dialog> component.[/en]
	 *   [ja]pageのURLか、もしくは`<template>`で宣言したテンプレートのid属性の値を指定できます。[/ja]
	 * @param {Object} [options]
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクト。[/ja]
	 * @return {Promise}
	 *   [en]Promise object that resolves to the alert dialog component object.[/en]
	 *   [ja]ダイアログのコンポーネントオブジェクトを解決するPromiseオブジェクトを返します。[/ja]
	 * @description
	 *   [en]Create a alert dialog instance from a template.[/en]
	 *   [ja]テンプレートからアラートダイアログのインスタンスを生成します。[/ja]
	 */
	ons$1.createPopover = ons$1.createDialog = ons$1.createAlertDialog = function (template) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return ons$1.createElement(template, _extends({ append: true }, options));
	};
	
	/**
	 * @method openActionSheet
	 * @signature openActionSheet(options)
	 * @description
	 *   [en]Shows an instant Action Sheet and lets the user choose an action.[/en]
	 *   [ja][/ja]
	 * @param {Object} [options]
	 *   [en]Parameter object.[/en]
	 *   [ja]オプションを指定するオブジェクト。[/ja]
	 * @param {Array} [options.buttons]
	 *   [en]Represent each button of the action sheet following the specified order. Every item can be either a string label or an object containing `label`, `icon` and `modifier` properties.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.title]
	 *   [en]Optional title for the action sheet.[/en]
	 *   [ja][/ja]
	 * @param {Number} [options.destructive]
	 *   [en]Optional index of the "destructive" button (only for iOS). It can be specified in the button array as well.[/en]
	 *   [ja][/ja]
	 * @param {Boolean} [options.cancelable]
	 *   [en]Whether the action sheet can be canceled by tapping on the background mask or not.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.modifier]
	 *   [en]Modifier attribute of the action sheet. E.g. `'destructive'`.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.maskColor]
	 *   [en]Optionally change the background mask color.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.id]
	 *   [en]The element's id attribute.[/en]
	 *   [ja][/ja]
	 * @param {String} [options.class]
	 *   [en]The element's class attribute.[/en]
	 *   [ja][/ja]
	 * @return {Promise}
	 *   [en]Will resolve when the action sheet is closed. The resolve value is either the index of the tapped button or -1 when canceled.[/en]
	 *   [ja][/ja]
	 */
	ons$1.openActionSheet = actionSheet;
	
	/**
	 * @method resolveLoadingPlaceholder
	 * @signature resolveLoadingPlaceholder(page)
	 * @param {String} page
	 *   [en]Page name. Can be either an HTML file or a `<template>` id.[/en]
	 *   [ja]pageのURLか、もしくは`<template>`で宣言したテンプレートのid属性の値を指定できます。[/ja]
	 * @description
	 *   [en]If no page is defined for the `ons-loading-placeholder` attribute it will wait for this method being called before loading the page.[/en]
	 *   [ja]ons-loading-placeholderの属性値としてページが指定されていない場合は、ページロード前に呼ばれるons.resolveLoadingPlaceholder処理が行われるまで表示されません。[/ja]
	 */
	ons$1.resolveLoadingPlaceholder = function (page, link) {
	  var elements = ons$1._util.arrayFrom(window.document.querySelectorAll('[ons-loading-placeholder]'));
	  if (elements.length === 0) {
	    throw new Error('No ons-loading-placeholder exists.');
	  }
	
	  elements.filter(function (element) {
	    return !element.getAttribute('page');
	  }).forEach(function (element) {
	    element.setAttribute('ons-loading-placeholder', page);
	    ons$1._resolveLoadingPlaceholder(element, page, link);
	  });
	};
	
	ons$1._setupLoadingPlaceHolders = function () {
	  ons$1.ready(function () {
	    var elements = ons$1._util.arrayFrom(window.document.querySelectorAll('[ons-loading-placeholder]'));
	
	    elements.forEach(function (element) {
	      var page = element.getAttribute('ons-loading-placeholder');
	      if (typeof page === 'string') {
	        ons$1._resolveLoadingPlaceholder(element, page);
	      }
	    });
	  });
	};
	
	ons$1._resolveLoadingPlaceholder = function (parent, page) {
	  var link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (el, done) {
	    return done();
	  };
	
	  page && ons$1.createElement(page).then(function (element) {
	    element.style.display = 'none';
	    parent.appendChild(element);
	    link(element, function () {
	      while (parent.firstChild && parent.firstChild !== element) {
	        parent.removeChild(parent.firstChild);
	      }
	      element.style.display = '';
	    });
	  }).catch(function (error) {
	    return Promise.reject('Unabled to resolve placeholder: ' + error);
	  });
	};
	
	function waitDeviceReady() {
	  var unlockDeviceReady = ons$1._readyLock.lock();
	  window.addEventListener('DOMContentLoaded', function () {
	    if (ons$1.isWebView()) {
	      window.document.addEventListener('deviceready', unlockDeviceReady, false);
	    } else {
	      unlockDeviceReady();
	    }
	  }, false);
	}
	
	/**
	 * @method getScriptPage
	 * @signature getScriptPage()
	 * @description
	 *   [en]Access the last created page from the current `script` scope. Only works inside `<script></script>` tags that are direct children of `ons-page` element. Use this to add lifecycle hooks to a page.[/en]
	 *   [ja][/ja]
	 * @return {HTMLElement}
	 *   [en]Returns the corresponding page element.[/en]
	 *   [ja][/ja]
	 */
	var getCS = 'currentScript' in document ? function () {
	  return document.currentScript;
	} : function () {
	  return document.scripts[document.scripts.length - 1];
	};
	ons$1.getScriptPage = function () {
	  return getCS() && /ons-page/i.test(getCS().parentElement.tagName) && getCS().parentElement || null;
	};
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var fastclick = createCommonjsModule(function (module) {
		(function () {
			function FastClick(layer, options) {
				var oldOnClick;
	
				options = options || {};
	
				/**
	    * Whether a click is currently being tracked.
	    *
	    * @type boolean
	    */
				this.trackingClick = false;
	
				/**
	    * Timestamp for when click tracking started.
	    *
	    * @type number
	    */
				this.trackingClickStart = 0;
	
				/**
	    * The element being tracked for a click.
	    *
	    * @type EventTarget
	    */
				this.targetElement = null;
	
				/**
	    * X-coordinate of touch start event.
	    *
	    * @type number
	    */
				this.touchStartX = 0;
	
				/**
	    * Y-coordinate of touch start event.
	    *
	    * @type number
	    */
				this.touchStartY = 0;
	
				/**
	    * ID of the last touch, retrieved from Touch.identifier.
	    *
	    * @type number
	    */
				this.lastTouchIdentifier = 0;
	
				/**
	    * Touchmove boundary, beyond which a click will be cancelled.
	    *
	    * @type number
	    */
				this.touchBoundary = options.touchBoundary || 10;
	
				/**
	    * The FastClick layer.
	    *
	    * @type Element
	    */
				this.layer = layer;
	
				/**
	    * The minimum time between tap(touchstart and touchend) events
	    *
	    * @type number
	    */
				this.tapDelay = options.tapDelay || 200;
	
				/**
	    * The maximum time for a tap
	    *
	    * @type number
	    */
				this.tapTimeout = options.tapTimeout || 700;
	
				if (FastClick.notNeeded(layer)) {
					return;
				}
	
				// Some old versions of Android don't have Function.prototype.bind
				function bind(method, context) {
					return function () {
						return method.apply(context, arguments);
					};
				}
	
				var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
				var context = this;
				for (var i = 0, l = methods.length; i < l; i++) {
					context[methods[i]] = bind(context[methods[i]], context);
				}
	
				// Set up event handlers as required
				if (deviceIsAndroid) {
					layer.addEventListener('mouseover', this.onMouse, true);
					layer.addEventListener('mousedown', this.onMouse, true);
					layer.addEventListener('mouseup', this.onMouse, true);
				}
	
				layer.addEventListener('click', this.onClick, true);
				layer.addEventListener('touchstart', this.onTouchStart, false);
				layer.addEventListener('touchmove', this.onTouchMove, false);
				layer.addEventListener('touchend', this.onTouchEnd, false);
				layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
				// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
				// layer when they are cancelled.
				if (!Event.prototype.stopImmediatePropagation) {
					layer.removeEventListener = function (type, callback, capture) {
						var rmv = Node.prototype.removeEventListener;
						if (type === 'click') {
							rmv.call(layer, type, callback.hijacked || callback, capture);
						} else {
							rmv.call(layer, type, callback, capture);
						}
					};
	
					layer.addEventListener = function (type, callback, capture) {
						var adv = Node.prototype.addEventListener;
						if (type === 'click') {
							adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
								if (!event.propagationStopped) {
									callback(event);
								}
							}), capture);
						} else {
							adv.call(layer, type, callback, capture);
						}
					};
				}
	
				// If a handler is already declared in the element's onclick attribute, it will be fired before
				// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
				// adding it as listener.
				if (typeof layer.onclick === 'function') {
	
					// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
					// - the old one won't work if passed to addEventListener directly.
					oldOnClick = layer.onclick;
					layer.addEventListener('click', function (event) {
						oldOnClick(event);
					}, false);
					layer.onclick = null;
				}
			}
	
			/**
	  * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	  *
	  * @type boolean
	  */
			var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
			/**
	   * Android requires exceptions.
	   *
	   * @type boolean
	   */
			var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
			/**
	   * iOS requires exceptions.
	   *
	   * @type boolean
	   */
			var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
			/**
	   * iOS 4 requires an exception for select elements.
	   *
	   * @type boolean
	   */
			var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);
	
			/**
	   * iOS 6.0-7.* requires the target element to be manually derived
	   *
	   * @type boolean
	   */
			var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);
	
			/**
	   * BlackBerry requires exceptions.
	   *
	   * @type boolean
	   */
			var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
			/**
	   * Valid types for text inputs
	   *
	   * @type array
	   */
			var textFields = ['email', 'number', 'password', 'search', 'tel', 'text', 'url'];
	
			/**
	   * Determine whether a given element requires a native click.
	   *
	   * @param {EventTarget|Element} target Target DOM element
	   * @returns {boolean} Returns true if the element needs a native click
	   */
			FastClick.prototype.needsClick = function (target) {
				switch (target.nodeName.toLowerCase()) {
	
					// Don't send a synthetic click to disabled inputs (issue #62)
					case 'button':
					case 'select':
					case 'textarea':
						if (target.disabled) {
							return true;
						}
	
						break;
					case 'input':
	
						// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
						if (deviceIsIOS && target.type === 'file' || target.disabled) {
							return true;
						}
	
						break;
					case 'label':
					case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
					case 'video':
						return true;
				}
	
				return (/\bneedsclick\b/.test(target.className)
				);
			};
	
			/**
	   * Determine whether a given element requires a call to focus to simulate click into element.
	   *
	   * @param {EventTarget|Element} target Target DOM element
	   * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	   */
			FastClick.prototype.needsFocus = function (target) {
				switch (target.nodeName.toLowerCase()) {
					case 'textarea':
						return true;
					case 'select':
						return !deviceIsAndroid;
					case 'input':
						switch (target.type) {
							case 'button':
							case 'checkbox':
							case 'file':
							case 'image':
							case 'radio':
							case 'submit':
								return false;
						}
	
						// No point in attempting to focus disabled inputs
						return !target.disabled && !target.readOnly;
					default:
						return (/\bneedsfocus\b/.test(target.className)
						);
				}
			};
	
			/**
	   * Send a click event to the specified element.
	   *
	   * @param {EventTarget|Element} targetElement
	   * @param {Event} event
	   */
			FastClick.prototype.sendClick = function (targetElement, event) {
				var clickEvent, touch;
	
				// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
				if (document.activeElement && document.activeElement !== targetElement) {
					document.activeElement.blur();
				}
	
				touch = event.changedTouches[0];
	
				// Synthesise a click event, with an extra attribute so it can be tracked
				clickEvent = document.createEvent('MouseEvents');
				clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
				clickEvent.forwardedTouchEvent = true;
				targetElement.dispatchEvent(clickEvent);
			};
	
			FastClick.prototype.determineEventType = function (targetElement) {
	
				//Issue #159: Android Chrome Select Box does not open with a synthetic click event
				if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
					return 'mousedown';
				}
	
				return 'click';
			};
	
			/**
	   * @param {EventTarget|Element} targetElement
	   */
			FastClick.prototype.focus = function (targetElement) {
				var length;
	
				// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
				if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email' && targetElement.type !== 'number') {
					length = targetElement.value.length;
					targetElement.setSelectionRange(length, length);
				} else {
					targetElement.focus();
				}
			};
	
			/**
	   * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	   *
	   * @param {EventTarget|Element} targetElement
	   */
			FastClick.prototype.updateScrollParent = function (targetElement) {
				var scrollParent, parentElement;
	
				scrollParent = targetElement.fastClickScrollParent;
	
				// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
				// target element was moved to another parent.
				if (!scrollParent || !scrollParent.contains(targetElement)) {
					parentElement = targetElement;
					do {
						if (parentElement.scrollHeight > parentElement.offsetHeight) {
							scrollParent = parentElement;
							targetElement.fastClickScrollParent = parentElement;
							break;
						}
	
						parentElement = parentElement.parentElement;
					} while (parentElement);
				}
	
				// Always update the scroll top tracker if possible.
				if (scrollParent) {
					scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
				}
			};
	
			/**
	   * @param {EventTarget} targetElement
	   * @returns {Element|EventTarget}
	   */
			FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {
	
				// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
				if (eventTarget.nodeType === Node.TEXT_NODE) {
					return eventTarget.parentNode;
				}
	
				return eventTarget;
			};
	
			/**
	   * @param {EventTarget} targetElement
	   * @returns {boolean}
	   */
			FastClick.prototype.isTextField = function (targetElement) {
				return targetElement.tagName.toLowerCase() === 'textarea' || textFields.indexOf(targetElement.type) !== -1;
			};
	
			/**
	   * On touch start, record the position and scroll offset.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.onTouchStart = function (event) {
				var targetElement, touch;
	
				// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
				if (event.targetTouches.length > 1) {
					return true;
				}
	
				targetElement = this.getTargetElementFromEventTarget(event.target);
				touch = event.targetTouches[0];
	
				// Ignore touches on contenteditable elements to prevent conflict with text selection.
				// (For details: https://github.com/ftlabs/fastclick/pull/211 )
				if (targetElement.isContentEditable) {
					return true;
				}
	
				if (deviceIsIOS) {
					// Ignore touchstart in focused text field
					// Allows normal text selection and commands (select/paste/cut) when a field has focus, while still allowing fast tap-to-focus.
					// Without this fix, user needs to tap-and-hold a text field for context menu, and double-tap to select text doesn't work at all.
					if (targetElement === document.activeElement && this.isTextField(targetElement)) {
						return true;
					}
	
					if (!deviceIsIOS4) {
	
						// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
						// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
						// with the same identifier as the touch event that previously triggered the click that triggered the alert.
						// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
						// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
						// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
						// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
						// random integers, it's safe to to continue if the identifier is 0 here.
						if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
							event.preventDefault();
							return false;
						}
	
						this.lastTouchIdentifier = touch.identifier;
	
						// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
						// 1) the user does a fling scroll on the scrollable layer
						// 2) the user stops the fling scroll with another tap
						// then the event.target of the last 'touchend' event will be the element that was under the user's finger
						// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
						// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
						this.updateScrollParent(targetElement);
					}
				}
	
				this.trackingClick = true;
				this.trackingClickStart = event.timeStamp;
				this.targetElement = targetElement;
	
				this.touchStartX = touch.pageX;
				this.touchStartY = touch.pageY;
	
				// Prevent phantom clicks on fast double-tap (issue #36)
				if (event.timeStamp - this.lastClickTime < this.tapDelay && event.timeStamp - this.lastClickTime > -1) {
					event.preventDefault();
				}
	
				return true;
			};
	
			/**
	   * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.touchHasMoved = function (event) {
				var touch = event.changedTouches[0],
				    boundary = this.touchBoundary;
	
				if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
					return true;
				}
	
				return false;
			};
	
			/**
	   * Update the last position.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.onTouchMove = function (event) {
				if (!this.trackingClick) {
					return true;
				}
	
				// If the touch has moved, cancel the click tracking
				if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
					this.trackingClick = false;
					this.targetElement = null;
				}
	
				return true;
			};
	
			/**
	   * Attempt to find the labelled control for the given label element.
	   *
	   * @param {EventTarget|HTMLLabelElement} labelElement
	   * @returns {Element|null}
	   */
			FastClick.prototype.findControl = function (labelElement) {
	
				// Fast path for newer browsers supporting the HTML5 control attribute
				if (labelElement.control !== undefined) {
					return labelElement.control;
				}
	
				// All browsers under test that support touch events also support the HTML5 htmlFor attribute
				if (labelElement.htmlFor) {
					return document.getElementById(labelElement.htmlFor);
				}
	
				// If no for attribute exists, attempt to retrieve the first labellable descendant element
				// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
				return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
			};
	
			/**
	   * On touch end, determine whether to send a click event at once.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.onTouchEnd = function (event) {
				var forElement,
				    trackingClickStart,
				    targetTagName,
				    scrollParent,
				    touch,
				    targetElement = this.targetElement;
	
				if (!this.trackingClick) {
					return true;
				}
	
				// Prevent phantom clicks on fast double-tap (issue #36)
				if (event.timeStamp - this.lastClickTime < this.tapDelay && event.timeStamp - this.lastClickTime > -1) {
					this.cancelNextClick = true;
					return true;
				}
	
				if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
					return true;
				}
	
				// Reset to prevent wrong click cancel on input (issue #156).
				this.cancelNextClick = false;
	
				this.lastClickTime = event.timeStamp;
	
				trackingClickStart = this.trackingClickStart;
				this.trackingClick = false;
				this.trackingClickStart = 0;
	
				// On some iOS devices, the targetElement supplied with the event is invalid if the layer
				// is performing a transition or scroll, and has to be re-detected manually. Note that
				// for this to function correctly, it must be called *after* the event target is checked!
				// See issue #57; also filed as rdar://13048589 .
				if (deviceIsIOSWithBadTarget) {
					touch = event.changedTouches[0];
	
					// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
					targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
					targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
				}
	
				targetTagName = targetElement.tagName.toLowerCase();
				if (targetTagName === 'label') {
					forElement = this.findControl(targetElement);
					if (forElement) {
						this.focus(targetElement);
						if (deviceIsAndroid) {
							return false;
						}
	
						targetElement = forElement;
					}
				} else if (this.needsFocus(targetElement)) {
	
					// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
					// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
					if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
						this.targetElement = null;
						return false;
					}
	
					this.focus(targetElement);
					this.sendClick(targetElement, event);
	
					// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
					// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
					if (!deviceIsIOS || targetTagName !== 'select') {
						this.targetElement = null;
						event.preventDefault();
					}
	
					return false;
				}
	
				if (deviceIsIOS && !deviceIsIOS4) {
	
					// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
					// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
					scrollParent = targetElement.fastClickScrollParent;
					if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
						return true;
					}
				}
	
				// Prevent the actual click from going though - unless the target node is marked as requiring
				// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
				if (!this.needsClick(targetElement)) {
					event.preventDefault();
					this.sendClick(targetElement, event);
				}
	
				return false;
			};
	
			/**
	   * On touch cancel, stop tracking the click.
	   *
	   * @returns {void}
	   */
			FastClick.prototype.onTouchCancel = function () {
				this.trackingClick = false;
				this.targetElement = null;
			};
	
			/**
	   * Determine mouse events which should be permitted.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.onMouse = function (event) {
	
				// If a target element was never set (because a touch event was never fired) allow the event
				if (!this.targetElement) {
					return true;
				}
	
				if (event.forwardedTouchEvent) {
					return true;
				}
	
				// Programmatically generated events targeting a specific element should be permitted
				if (!event.cancelable) {
					return true;
				}
	
				// Derive and check the target element to see whether the mouse event needs to be permitted;
				// unless explicitly enabled, prevent non-touch click events from triggering actions,
				// to prevent ghost/doubleclicks.
				if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
					// Prevent any user-added listeners declared on FastClick element from being fired.
					if (event.stopImmediatePropagation) {
						event.stopImmediatePropagation();
					} else {
	
						// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
						event.propagationStopped = true;
					}
	
					// Cancel the event
					event.stopPropagation();
					event.preventDefault();
	
					return false;
				}
	
				// If the mouse event is permitted, return true for the action to go through.
				return true;
			};
	
			/**
	   * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	   * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	   * an actual click which should be permitted.
	   *
	   * @param {Event} event
	   * @returns {boolean}
	   */
			FastClick.prototype.onClick = function (event) {
				var permitted;
	
				// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
				if (this.trackingClick) {
					this.targetElement = null;
					this.trackingClick = false;
					return true;
				}
	
				// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
				if (event.target.type === 'submit' && event.detail === 0) {
					return true;
				}
	
				permitted = this.onMouse(event);
	
				// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
				if (!permitted) {
					this.targetElement = null;
				}
	
				// If clicks are permitted, return true for the action to go through.
				return permitted;
			};
	
			/**
	   * Remove all FastClick's event listeners.
	   *
	   * @returns {void}
	   */
			FastClick.prototype.destroy = function () {
				var layer = this.layer;
	
				if (deviceIsAndroid) {
					layer.removeEventListener('mouseover', this.onMouse, true);
					layer.removeEventListener('mousedown', this.onMouse, true);
					layer.removeEventListener('mouseup', this.onMouse, true);
				}
	
				layer.removeEventListener('click', this.onClick, true);
				layer.removeEventListener('touchstart', this.onTouchStart, false);
				layer.removeEventListener('touchmove', this.onTouchMove, false);
				layer.removeEventListener('touchend', this.onTouchEnd, false);
				layer.removeEventListener('touchcancel', this.onTouchCancel, false);
			};
	
			/**
	   * Check whether FastClick is needed.
	   *
	   * @param {Element} layer The layer to listen on
	   */
			FastClick.notNeeded = function (layer) {
				var metaViewport;
				var chromeVersion;
				var blackberryVersion;
				var firefoxVersion;
	
				// Devices that don't support touch don't need FastClick
				if (typeof window.ontouchstart === 'undefined') {
					return true;
				}
	
				// Chrome version - zero for other browsers
				chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
	
				if (chromeVersion) {
	
					if (deviceIsAndroid) {
						metaViewport = document.querySelector('meta[name=viewport]');
	
						if (metaViewport) {
							// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
							if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
								return true;
							}
							// Chrome 32 and above with width=device-width or less don't need FastClick
							if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
								return true;
							}
						}
	
						// Chrome desktop doesn't need FastClick (issue #15)
					} else {
						return true;
					}
				}
	
				if (deviceIsBlackBerry10) {
					blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
					// BlackBerry 10.3+ does not require Fastclick library.
					// https://github.com/ftlabs/fastclick/issues/251
					if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
						metaViewport = document.querySelector('meta[name=viewport]');
	
						if (metaViewport) {
							// user-scalable=no eliminates click delay.
							if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
								return true;
							}
							// width=device-width (or less than device-width) eliminates click delay.
							if (document.documentElement.scrollWidth <= window.outerWidth) {
								return true;
							}
						}
					}
				}
	
				// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
				if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
					return true;
				}
	
				// Firefox version - zero for other browsers
				firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
	
				if (firefoxVersion >= 27) {
					// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
					metaViewport = document.querySelector('meta[name=viewport]');
					if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
						return true;
					}
				}
	
				// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
				// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
				if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
					return true;
				}
	
				return false;
			};
	
			/**
	   * Factory method for creating a FastClick object
	   *
	   * @param {Element} layer The layer to listen on
	   * @param {Object} [options={}] The options to override the defaults
	   */
			FastClick.attach = function (layer, options) {
				return new FastClick(layer, options);
			};
	
			if (false) {
	
				// AMD. Register as an anonymous module.
				undefined(function () {
					return FastClick;
				});
			} else if ('object' !== 'undefined' && module.exports) {
				module.exports = FastClick.attach;
				module.exports.FastClick = FastClick;
			} else {
				window.FastClick = FastClick;
			}
		})();
	});
	
	var fastclick_1 = fastclick.FastClick;
	
	// For @onsenui/custom-elements
	if (window.customElements) {
	    // even if native CE1 impl exists, use polyfill
	    window.customElements.forcePolyfill = true;
	}
	
	var _global = createCommonjsModule(function (module) {
	  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});
	
	var _core = createCommonjsModule(function (module) {
	  var core = module.exports = { version: '2.5.1' };
	  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	
	var _core_1 = _core.version;
	
	var _isObject = function _isObject(it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};
	
	var _anObject = function _anObject(it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	var _fails = function _fails(exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});
	
	var document$1 = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document$1) && _isObject(document$1.createElement);
	var _domCreate = function _domCreate(it) {
	  return is ? document$1.createElement(it) : {};
	};
	
	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function _toPrimitive(it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	var dP = Object.defineProperty;
	
	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	var _objectDp = {
	  f: f
	};
	
	var _propertyDesc = function _propertyDesc(bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function _has(it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	var id = 0;
	var px = Math.random();
	var _uid = function _uid(key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	var _redefine = createCommonjsModule(function (module) {
	  var SRC = _uid('src');
	  var TO_STRING = 'toString';
	  var $toString = Function[TO_STRING];
	  var TPL = ('' + $toString).split(TO_STRING);
	
	  _core.inspectSource = function (it) {
	    return $toString.call(it);
	  };
	
	  (module.exports = function (O, key, val, safe) {
	    var isFunction = typeof val == 'function';
	    if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
	    if (O[key] === val) return;
	    if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    if (O === _global) {
	      O[key] = val;
	    } else if (!safe) {
	      delete O[key];
	      _hide(O, key, val);
	    } else if (O[key]) {
	      O[key] = val;
	    } else {
	      _hide(O, key, val);
	    }
	    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	  })(Function.prototype, TO_STRING, function toString() {
	    return typeof this == 'function' && this[SRC] || $toString.call(this);
	  });
	});
	
	var _aFunction = function _aFunction(it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	// optional / simple context binding
	
	var _ctx = function _ctx(fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () /* ...args */{
	    return fn.apply(that, arguments);
	  };
	};
	
	var PROTOTYPE = 'prototype';
	
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) _redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) _hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1; // forced
	$export.G = 2; // global
	$export.S = 4; // static
	$export.P = 8; // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	$export.U = 64; // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;
	
	var f$2 = {}.propertyIsEnumerable;
	
	var _objectPie = {
		f: f$2
	};
	
	var toString = {}.toString;
	
	var _cof = function _cof(it) {
	  return toString.call(it).slice(8, -1);
	};
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	
	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function _defined(it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	
	
	var _toIobject = function _toIobject(it) {
	  return _iobject(_defined(it));
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var f$1 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = _toIobject(O);
	  P = _toPrimitive(P, true);
	  if (_ie8DomDefine) try {
	    return gOPD(O, P);
	  } catch (e) {/* empty */}
	  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
	};
	
	var _objectGopd = {
	  f: f$1
	};
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	
	var check = function check(O, proto) {
	  _anObject(O);
	  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	var _setProto = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	  function (test, buggy, set) {
	    try {
	      set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	
	_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });
	
	var setPrototypeOf = _core.Object.setPrototypeOf;
	
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});
	var _shared = function _shared(key) {
	  return store[key] || (store[key] = {});
	};
	
	var _wks = createCommonjsModule(function (module) {
	  var store = _shared('wks');
	
	  var _Symbol = _global.Symbol;
	  var USE_SYMBOL = typeof _Symbol == 'function';
	
	  var $exports = module.exports = function (name) {
	    return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : _uid)('Symbol.' + name));
	  };
	
	  $exports.store = store;
	});
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	
	var TAG = _wks('toStringTag');
	// ES3 wrong here
	var ARG = _cof(function () {
	  return arguments;
	}()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {/* empty */}
	};
	
	var _classof = function _classof(it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	  // builtinTag case
	  : ARG ? _cof(O)
	  // ES3 arguments fallback
	  : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	// 19.1.3.6 Object.prototype.toString()
	
	var test = {};
	test[_wks('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  _redefine(Object.prototype, 'toString', function toString() {
	    return '[object ' + _classof(this) + ']';
	  }, true);
	}
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function _toInteger(it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function _stringAt(TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	var _library = false;
	
	var _iterators = {};
	
	// 7.1.15 ToLength
	
	var min = Math.min;
	var _toLength = function _toLength(it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function _toAbsoluteIndex(index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};
	
	// false -> Array#indexOf
	// true  -> Array#includes
	
	
	var _arrayIncludes = function _arrayIncludes(IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};
	
	var shared = _shared('keys');
	
	var _sharedKey = function _sharedKey(key) {
	  return shared[key] || (shared[key] = _uid(key));
	};
	
	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	
	var _objectKeysInternal = function _objectKeysInternal(object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO$1) _has(O, key) && result.push(key);
	  } // Don't enum bug & hidden keys
	  while (names.length > i) {
	    if (_has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};
	
	// IE 8- don't enum bug keys
	var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	
	
	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};
	
	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    _objectDp.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};
	
	var document$2 = _global.document;
	var _html = document$2 && document$2.documentElement;
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	
	
	var IE_PROTO = _sharedKey('IE_PROTO');
	var Empty = function Empty() {/* empty */};
	var PROTOTYPE$1 = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var _createDict = function createDict() {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  }return _createDict();
	};
	
	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};
	
	var def = _objectDp.f;
	
	var TAG$1 = _wks('toStringTag');
	
	var _setToStringTag = function _setToStringTag(it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, { configurable: true, value: tag });
	};
	
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	_hide(IteratorPrototype, _wks('iterator'), function () {
	  return this;
	});
	
	var _iterCreate = function _iterCreate(Constructor, NAME, next) {
	  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
	  _setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	// 7.1.13 ToObject(argument)
	
	var _toObject = function _toObject(it) {
	  return Object(_defined(it));
	};
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	
	
	var IE_PROTO$2 = _sharedKey('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	var _objectGpo = Object.getPrototypeOf || function (O) {
	  O = _toObject(O);
	  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }return O instanceof Object ? ObjectProto : null;
	};
	
	var ITERATOR = _wks('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function returnThis() {
	  return this;
	};
	
	var _iterDefine = function _iterDefine(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  _iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      _setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!_library && !_has(IteratorPrototype, ITERATOR)) _hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  // Define iterator
	  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    _hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  _iterators[NAME] = $default;
	  _iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) _redefine(proto, key, methods[key]);
	    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	var $at = _stringAt(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	_iterDefine(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0; // next index
	  // 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = _wks('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
	var _addToUnscopables = function _addToUnscopables(key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	var _iterStep = function _iterStep(done, value) {
	  return { value: value, done: !!done };
	};
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
	  this._t = _toIobject(iterated); // target
	  this._i = 0; // next index
	  this._k = kind; // kind
	  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return _iterStep(1);
	  }
	  if (kind == 'keys') return _iterStep(0, index);
	  if (kind == 'values') return _iterStep(0, O[index]);
	  return _iterStep(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	_iterators.Arguments = _iterators.Array;
	
	_addToUnscopables('keys');
	_addToUnscopables('values');
	_addToUnscopables('entries');
	
	var ITERATOR$1 = _wks('iterator');
	var TO_STRING_TAG = _wks('toStringTag');
	var ArrayValues = _iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = _global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR$1]) _hide(proto, ITERATOR$1, ArrayValues);
	    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
	    _iterators[NAME] = ArrayValues;
	    if (explicit) for (key in es6_array_iterator) {
	      if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
	    }
	  }
	}
	
	var _redefineAll = function _redefineAll(target, src, safe) {
	  for (var key in src) {
	    _redefine(target, key, src[key], safe);
	  }return target;
	};
	
	var _anInstance = function _anInstance(it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }return it;
	};
	
	// call something on iterator step with safe closing on error
	
	var _iterCall = function _iterCall(iterator, fn, value, entries) {
	  try {
	    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
	    // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) _anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	// check on default Array iterator
	
	var ITERATOR$2 = _wks('iterator');
	var ArrayProto$1 = Array.prototype;
	
	var _isArrayIter = function _isArrayIter(it) {
	  return it !== undefined && (_iterators.Array === it || ArrayProto$1[ITERATOR$2] === it);
	};
	
	var ITERATOR$3 = _wks('iterator');
	
	var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR$3] || it['@@iterator'] || _iterators[_classof(it)];
	};
	
	var _forOf = createCommonjsModule(function (module) {
	  var BREAK = {};
	  var RETURN = {};
	  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	    var iterFn = ITERATOR ? function () {
	      return iterable;
	    } : core_getIteratorMethod(iterable);
	    var f = _ctx(fn, that, entries ? 2 : 1);
	    var index = 0;
	    var length, step, iterator, result;
	    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	    // fast case for arrays with default iterator
	    if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
	      result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	      if (result === BREAK || result === RETURN) return result;
	    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	      result = _iterCall(iterator, f, step.value, entries);
	      if (result === BREAK || result === RETURN) return result;
	    }
	  };
	  exports.BREAK = BREAK;
	  exports.RETURN = RETURN;
	});
	
	var SPECIES = _wks('species');
	
	var _setSpecies = function _setSpecies(KEY) {
	  var C = _global[KEY];
	  if (_descriptors && C && !C[SPECIES]) _objectDp.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};
	
	var _meta = createCommonjsModule(function (module) {
	  var META = _uid('meta');
	
	  var setDesc = _objectDp.f;
	  var id = 0;
	  var isExtensible = Object.isExtensible || function () {
	    return true;
	  };
	  var FREEZE = !_fails(function () {
	    return isExtensible(Object.preventExtensions({}));
	  });
	  var setMeta = function setMeta(it) {
	    setDesc(it, META, { value: {
	        i: 'O' + ++id, // object ID
	        w: {} // weak collections IDs
	      } });
	  };
	  var fastKey = function fastKey(it, create) {
	    // return primitive with prefix
	    if (!_isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	    if (!_has(it, META)) {
	      // can't set metadata to uncaught frozen object
	      if (!isExtensible(it)) return 'F';
	      // not necessary to add metadata
	      if (!create) return 'E';
	      // add missing metadata
	      setMeta(it);
	      // return object ID
	    }return it[META].i;
	  };
	  var getWeak = function getWeak(it, create) {
	    if (!_has(it, META)) {
	      // can't set metadata to uncaught frozen object
	      if (!isExtensible(it)) return true;
	      // not necessary to add metadata
	      if (!create) return false;
	      // add missing metadata
	      setMeta(it);
	      // return hash weak collections IDs
	    }return it[META].w;
	  };
	  // add metadata on freeze-family methods calling
	  var onFreeze = function onFreeze(it) {
	    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
	    return it;
	  };
	  var meta = module.exports = {
	    KEY: META,
	    NEED: false,
	    fastKey: fastKey,
	    getWeak: getWeak,
	    onFreeze: onFreeze
	  };
	});
	
	var _meta_1 = _meta.KEY;
	var _meta_2 = _meta.NEED;
	var _meta_3 = _meta.fastKey;
	var _meta_4 = _meta.getWeak;
	var _meta_5 = _meta.onFreeze;
	
	var _validateCollection = function _validateCollection(it, TYPE) {
	  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};
	
	var dP$1 = _objectDp.f;
	
	var fastKey = _meta.fastKey;
	
	var SIZE = _descriptors ? '_s' : 'size';
	
	var getEntry = function getEntry(that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	var _collectionStrong = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      _anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = _objectCreate(null); // index
	      that._f = undefined; // first entry
	      that._l = undefined; // last entry
	      that[SIZE] = 0; // size
	      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    _redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function _delete(key) {
	        var that = _validateCollection(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        }return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        _validateCollection(this, NAME);
	        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) {
	            entry = entry.p;
	          }
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(_validateCollection(this, NAME), key);
	      }
	    });
	    if (_descriptors) dP$1(C.prototype, 'size', {
	      get: function get() {
	        return _validateCollection(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	      // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key, // <- key
	        v: value, // <- value
	        p: prev = that._l, // <- previous entry
	        n: undefined, // <- next entry
	        r: false // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    }return that;
	  },
	  getEntry: getEntry,
	  setStrong: function setStrong(C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    _iterDefine(C, NAME, function (iterated, kind) {
	      this._t = _validateCollection(iterated, NAME); // target
	      this._k = kind; // kind
	      this._l = undefined; // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) {
	        entry = entry.p;
	      } // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return _iterStep(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return _iterStep(0, entry.k);
	      if (kind == 'values') return _iterStep(0, entry.v);
	      return _iterStep(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    _setSpecies(NAME);
	  }
	};
	
	var ITERATOR$4 = _wks('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR$4]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  // eslint-disable-next-line no-throw-literal
	  
	} catch (e) {/* empty */}
	
	var _iterDetect = function _iterDetect(exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR$4]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR$4] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {/* empty */}
	  return safe;
	};
	
	var setPrototypeOf$2 = _setProto.set;
	var _inheritIfRequired = function _inheritIfRequired(that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf$2) {
	    setPrototypeOf$2(that, P);
	  }return that;
	};
	
	var _collection = function _collection(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = _global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    _redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    _redefineAll(C.prototype, methods);
	    _meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = _fails(function () {
	      instance.has(1);
	    });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = _iterDetect(function (iter) {
	      new C(iter);
	    }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && _fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        _anInstance(target, C, NAME);
	        var that = _inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  _setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  _export(_export.G + _export.W + _export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};
	
	var SET = 'Set';
	
	// 23.2 Set Objects
	var es6_set = _collection(SET, function (get) {
	  return function Set() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, _collectionStrong);
	
	var _arrayFromIterable = function _arrayFromIterable(iter, ITERATOR) {
	  var result = [];
	  _forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	
	
	var _collectionToJson = function _collectionToJson(NAME) {
	  return function toJSON() {
	    if (_classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return _arrayFromIterable(this);
	  };
	};
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	
	
	_export(_export.P + _export.R, 'Set', { toJSON: _collectionToJson('Set') });
	
	// https://tc39.github.io/proposal-setmap-offrom/
	
	
	var _setCollectionOf = function _setCollectionOf(COLLECTION) {
	  _export(_export.S, COLLECTION, { of: function of() {
	      var length = arguments.length;
	      var A = Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    } });
	};
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	_setCollectionOf('Set');
	
	// https://tc39.github.io/proposal-setmap-offrom/
	
	
	var _setCollectionFrom = function _setCollectionFrom(COLLECTION) {
	  _export(_export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      _aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) _aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = _ctx(mapFn, arguments[2], 2);
	        _forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        _forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    } });
	};
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	_setCollectionFrom('Set');
	
	var set$1 = _core.Set;
	
	var MAP = 'Map';
	
	// 23.1 Map Objects
	var es6_map = _collection(MAP, function (get) {
	  return function Map() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, _collectionStrong, true);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	
	
	_export(_export.P + _export.R, 'Map', { toJSON: _collectionToJson('Map') });
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	_setCollectionOf('Map');
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	_setCollectionFrom('Map');
	
	var map = _core.Map;
	
	// 7.2.2 IsArray(argument)
	
	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};
	
	var SPECIES$1 = _wks('species');
	
	var _arraySpeciesConstructor = function _arraySpeciesConstructor(original) {
	  var C;
	  if (_isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
	    if (_isObject(C)) {
	      C = C[SPECIES$1];
	      if (C === null) C = undefined;
	    }
	  }return C === undefined ? Array : C;
	};
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	
	
	var _arraySpeciesCreate = function _arraySpeciesCreate(original, length) {
	  return new (_arraySpeciesConstructor(original))(length);
	};
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	
	
	var _arrayMethods = function _arrayMethods(TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || _arraySpeciesCreate;
	  return function ($this, callbackfn, that) {
	    var O = _toObject($this);
	    var self = _iobject(O);
	    var f = _ctx(callbackfn, that, 3);
	    var length = _toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res; // map
	          else if (res) switch (TYPE) {
	              case 3:
	                return true; // some
	              case 5:
	                return val; // find
	              case 6:
	                return index; // findIndex
	              case 2:
	                result.push(val); // filter
	            } else if (IS_EVERY) return false; // every
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	var f$3 = Object.getOwnPropertySymbols;
	
	var _objectGops = {
		f: f$3
	};
	
	// 19.1.2.1 Object.assign(target, source, ...)
	
	
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	var _objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars
	  var T = _toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = _objectGops.f;
	  var isEnum = _objectPie.f;
	  while (aLen > index) {
	    var S = _iobject(arguments[index++]);
	    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	    }
	  }return T;
	} : $assign;
	
	var getWeak = _meta.getWeak;
	
	var arrayFind = _arrayMethods(5);
	var arrayFindIndex = _arrayMethods(6);
	var id$1 = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	var _collectionWeak = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      _anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = id$1++; // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    _redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function _delete(key) {
	        if (!_isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME))['delete'](key);
	        return data && _has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!_isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME)).has(key);
	        return data && _has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(_anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};
	
	var es6_weakMap = createCommonjsModule(function (module) {
	  var each = _arrayMethods(0);
	
	  var WEAK_MAP = 'WeakMap';
	  var getWeak = _meta.getWeak;
	  var isExtensible = Object.isExtensible;
	  var uncaughtFrozenStore = _collectionWeak.ufstore;
	  var tmp = {};
	  var InternalMap;
	
	  var wrapper = function wrapper(get) {
	    return function WeakMap() {
	      return get(this, arguments.length > 0 ? arguments[0] : undefined);
	    };
	  };
	
	  var methods = {
	    // 23.3.3.3 WeakMap.prototype.get(key)
	    get: function get(key) {
	      if (_isObject(key)) {
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(_validateCollection(this, WEAK_MAP)).get(key);
	        return data ? data[this._i] : undefined;
	      }
	    },
	    // 23.3.3.5 WeakMap.prototype.set(key, value)
	    set: function set(key, value) {
	      return _collectionWeak.def(_validateCollection(this, WEAK_MAP), key, value);
	    }
	  };
	
	  // 23.3 WeakMap Objects
	  var $WeakMap = module.exports = _collection(WEAK_MAP, wrapper, methods, _collectionWeak, true, true);
	
	  // IE11 WeakMap frozen keys fix
	  if (_fails(function () {
	    return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
	  })) {
	    InternalMap = _collectionWeak.getConstructor(wrapper, WEAK_MAP);
	    _objectAssign(InternalMap.prototype, methods);
	    _meta.NEED = true;
	    each(['delete', 'has', 'get', 'set'], function (key) {
	      var proto = $WeakMap.prototype;
	      var method = proto[key];
	      _redefine(proto, key, function (a, b) {
	        // store frozen objects on internal weakmap shim
	        if (_isObject(a) && !isExtensible(a)) {
	          if (!this._f) this._f = new InternalMap();
	          var result = this._f[key](a, b);
	          return key == 'set' ? this : result;
	          // store all the rest on native weakmap
	        }return method.call(this, a, b);
	      });
	    });
	  }
	});
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	_setCollectionOf('WeakMap');
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	_setCollectionFrom('WeakMap');
	
	var weakMap = _core.WeakMap;
	
	var _createProperty = function _createProperty(object, index, value) {
	  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));else object[index] = value;
	};
	
	_export(_export.S + _export.F * !_iterDetect(function (iter) {
	  
	}), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = _toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = core_getIteratorMethod(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = _toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});
	
	var from$1 = _core.Array.from;
	
	var reservedTagList = new Set(['annotation-xml', 'color-profile', 'font-face', 'font-face-src', 'font-face-uri', 'font-face-format', 'font-face-name', 'missing-glyph']);
	
	/**
	 * @param {string} localName
	 * @returns {boolean}
	 */
	function isValidCustomElementName(localName) {
	  var reserved = reservedTagList.has(localName);
	  var validForm = /^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(localName);
	  return !reserved && validForm;
	}
	
	/**
	 * @private
	 * @param {!Node} node
	 * @return {boolean}
	 */
	function isConnected(node) {
	  // Use `Node#isConnected`, if defined.
	  var nativeValue = node.isConnected;
	  if (nativeValue !== undefined) {
	    return nativeValue;
	  }
	
	  /** @type {?Node|undefined} */
	  var current = node;
	  while (current && !(current.__CE_isImportDocument || current instanceof Document)) {
	    current = current.parentNode || (window.ShadowRoot && current instanceof ShadowRoot ? current.host : undefined);
	  }
	  return !!(current && (current.__CE_isImportDocument || current instanceof Document));
	}
	
	/**
	 * @param {!Node} root
	 * @param {!Node} start
	 * @return {?Node}
	 */
	function nextSiblingOrAncestorSibling(root, start) {
	  var node = start;
	  while (node && node !== root && !node.nextSibling) {
	    node = node.parentNode;
	  }
	  return !node || node === root ? null : node.nextSibling;
	}
	
	/**
	 * @param {!Node} root
	 * @param {!Node} start
	 * @return {?Node}
	 */
	function nextNode(root, start) {
	  return start.firstChild ? start.firstChild : nextSiblingOrAncestorSibling(root, start);
	}
	
	/**
	 * @param {!Node} root
	 * @param {!function(!Element)} callback
	 * @param {!Set<Node>=} visitedImports
	 */
	function walkDeepDescendantElements(root, callback) {
	  var visitedImports = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
	
	  var node = root;
	  while (node) {
	    if (node.nodeType === Node.ELEMENT_NODE) {
	      var element = /** @type {!Element} */node;
	
	      callback(element);
	
	      var localName = element.localName;
	      if (localName === 'link' && element.getAttribute('rel') === 'import') {
	        // If this import (polyfilled or not) has it's root node available,
	        // walk it.
	        var importNode = /** @type {!Node} */element.import;
	        if (importNode instanceof Node && !visitedImports.has(importNode)) {
	          // Prevent multiple walks of the same import root.
	          visitedImports.add(importNode);
	
	          for (var child = importNode.firstChild; child; child = child.nextSibling) {
	            walkDeepDescendantElements(child, callback, visitedImports);
	          }
	        }
	
	        // Ignore descendants of import links to prevent attempting to walk the
	        // elements created by the HTML Imports polyfill that we just walked
	        // above.
	        node = nextSiblingOrAncestorSibling(root, element);
	        continue;
	      } else if (localName === 'template') {
	        // Ignore descendants of templates. There shouldn't be any descendants
	        // because they will be moved into `.content` during construction in
	        // browsers that support template but, in case they exist and are still
	        // waiting to be moved by a polyfill, they will be ignored.
	        node = nextSiblingOrAncestorSibling(root, element);
	        continue;
	      }
	
	      // Walk shadow roots.
	      var shadowRoot = element.__CE_shadowRoot;
	      if (shadowRoot) {
	        for (var _child = shadowRoot.firstChild; _child; _child = _child.nextSibling) {
	          walkDeepDescendantElements(_child, callback, visitedImports);
	        }
	      }
	    }
	
	    node = nextNode(root, node);
	  }
	}
	
	/**
	 * Used to suppress Closure's "Modifying the prototype is only allowed if the
	 * constructor is in the same scope" warning without using
	 * `@suppress {newCheckTypes, duplicate}` because `newCheckTypes` is too broad.
	 *
	 * @param {!Object} destination
	 * @param {string} name
	 * @param {*} value
	 */
	function setPropertyUnchecked(destination, name, value) {
	  destination[name] = value;
	}
	
	/**
	 * @enum {number}
	 */
	var CustomElementState = {
	  custom: 1,
	  failed: 2
	};
	
	var CustomElementInternals = function () {
	  function CustomElementInternals() {
	    classCallCheck(this, CustomElementInternals);
	
	    /** @type {!Map<string, !CustomElementDefinition>} */
	    this._localNameToDefinition = new Map();
	
	    /** @type {!Map<!Function, !CustomElementDefinition>} */
	    this._constructorToDefinition = new Map();
	
	    /** @type {!Array<!function(!Node)>} */
	    this._patches = [];
	
	    /** @type {boolean} */
	    this._hasPatches = false;
	  }
	
	  /**
	   * @param {string} localName
	   * @param {!CustomElementDefinition} definition
	   */
	
	
	  createClass(CustomElementInternals, [{
	    key: 'setDefinition',
	    value: function setDefinition(localName, definition) {
	      this._localNameToDefinition.set(localName, definition);
	      this._constructorToDefinition.set(definition.constructor, definition);
	    }
	
	    /**
	     * @param {string} localName
	     * @return {!CustomElementDefinition|undefined}
	     */
	
	  }, {
	    key: 'localNameToDefinition',
	    value: function localNameToDefinition(localName) {
	      return this._localNameToDefinition.get(localName);
	    }
	
	    /**
	     * @param {!Function} constructor
	     * @return {!CustomElementDefinition|undefined}
	     */
	
	  }, {
	    key: 'constructorToDefinition',
	    value: function constructorToDefinition(constructor) {
	      return this._constructorToDefinition.get(constructor);
	    }
	
	    /**
	     * @param {!function(!Node)} listener
	     */
	
	  }, {
	    key: 'addPatch',
	    value: function addPatch(listener) {
	      this._hasPatches = true;
	      this._patches.push(listener);
	    }
	
	    /**
	     * @param {!Node} node
	     */
	
	  }, {
	    key: 'patchTree',
	    value: function patchTree(node) {
	      var _this = this;
	
	      if (!this._hasPatches) return;
	
	      walkDeepDescendantElements(node, function (element) {
	        return _this.patch(element);
	      });
	    }
	
	    /**
	     * @param {!Node} node
	     */
	
	  }, {
	    key: 'patch',
	    value: function patch(node) {
	      if (!this._hasPatches) return;
	
	      if (node.__CE_patched) return;
	      node.__CE_patched = true;
	
	      for (var i = 0; i < this._patches.length; i++) {
	        this._patches[i](node);
	      }
	    }
	
	    /**
	     * @param {!Node} root
	     */
	
	  }, {
	    key: 'connectTree',
	    value: function connectTree(root) {
	      var elements = [];
	
	      walkDeepDescendantElements(root, function (element) {
	        return elements.push(element);
	      });
	
	      for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.__CE_state === CustomElementState.custom) {
	          if (isConnected(element)) {
	            this.connectedCallback(element);
	          }
	        } else {
	          this.upgradeElement(element);
	        }
	      }
	    }
	
	    /**
	     * @param {!Node} root
	     */
	
	  }, {
	    key: 'disconnectTree',
	    value: function disconnectTree(root) {
	      var elements = [];
	
	      walkDeepDescendantElements(root, function (element) {
	        return elements.push(element);
	      });
	
	      for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.__CE_state === CustomElementState.custom) {
	          this.disconnectedCallback(element);
	        }
	      }
	    }
	
	    /**
	     * Upgrades all uncustomized custom elements at and below a root node for
	     * which there is a definition. When custom element reaction callbacks are
	     * assumed to be called synchronously (which, by the current DOM / HTML spec
	     * definitions, they are *not*), callbacks for both elements customized
	     * synchronously by the parser and elements being upgraded occur in the same
	     * relative order.
	     *
	     * NOTE: This function, when used to simulate the construction of a tree that
	     * is already created but not customized (i.e. by the parser), does *not*
	     * prevent the element from reading the 'final' (true) state of the tree. For
	     * example, the element, during truly synchronous parsing / construction would
	     * see that it contains no children as they have not yet been inserted.
	     * However, this function does not modify the tree, the element will
	     * (incorrectly) have children. Additionally, self-modification restrictions
	     * for custom element constructors imposed by the DOM spec are *not* enforced.
	     *
	     *
	     * The following nested list shows the steps extending down from the HTML
	     * spec's parsing section that cause elements to be synchronously created and
	     * upgraded:
	     *
	     * The "in body" insertion mode:
	     * https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	     * - Switch on token:
	     *   .. other cases ..
	     *   -> Any other start tag
	     *      - [Insert an HTML element](below) for the token.
	     *
	     * Insert an HTML element:
	     * https://html.spec.whatwg.org/multipage/syntax.html#insert-an-html-element
	     * - Insert a foreign element for the token in the HTML namespace:
	     *   https://html.spec.whatwg.org/multipage/syntax.html#insert-a-foreign-element
	     *   - Create an element for a token:
	     *     https://html.spec.whatwg.org/multipage/syntax.html#create-an-element-for-the-token
	     *     - Will execute script flag is true?
	     *       - (Element queue pushed to the custom element reactions stack.)
	     *     - Create an element:
	     *       https://dom.spec.whatwg.org/#concept-create-element
	     *       - Sync CE flag is true?
	     *         - Constructor called.
	     *         - Self-modification restrictions enforced.
	     *       - Sync CE flag is false?
	     *         - (Upgrade reaction enqueued.)
	     *     - Attributes appended to element.
	     *       (`attributeChangedCallback` reactions enqueued.)
	     *     - Will execute script flag is true?
	     *       - (Element queue popped from the custom element reactions stack.
	     *         Reactions in the popped stack are invoked.)
	     *   - (Element queue pushed to the custom element reactions stack.)
	     *   - Insert the element:
	     *     https://dom.spec.whatwg.org/#concept-node-insert
	     *     - Shadow-including descendants are connected. During parsing
	     *       construction, there are no shadow-*excluding* descendants.
	     *       However, the constructor may have validly attached a shadow
	     *       tree to itself and added descendants to that shadow tree.
	     *       (`connectedCallback` reactions enqueued.)
	     *   - (Element queue popped from the custom element reactions stack.
	     *     Reactions in the popped stack are invoked.)
	     *
	     * @param {!Node} root
	     * @param {!Set<Node>=} visitedImports
	     */
	
	  }, {
	    key: 'patchAndUpgradeTree',
	    value: function patchAndUpgradeTree(root) {
	      var _this2 = this;
	
	      var visitedImports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
	
	      var elements = [];
	
	      var gatherElements = function gatherElements(element) {
	        if (element.localName === 'link' && element.getAttribute('rel') === 'import') {
	          // The HTML Imports polyfill sets a descendant element of the link to
	          // the `import` property, specifically this is *not* a Document.
	          var importNode = /** @type {?Node} */element.import;
	
	          if (importNode instanceof Node && importNode.readyState === 'complete') {
	            importNode.__CE_isImportDocument = true;
	
	            // Connected links are associated with the registry.
	            importNode.__CE_hasRegistry = true;
	          } else {
	            // If this link's import root is not available, its contents can't be
	            // walked. Wait for 'load' and walk it when it's ready.
	            element.addEventListener('load', function () {
	              var importNode = /** @type {!Node} */element.import;
	
	              if (importNode.__CE_documentLoadHandled) return;
	              importNode.__CE_documentLoadHandled = true;
	
	              importNode.__CE_isImportDocument = true;
	
	              // Connected links are associated with the registry.
	              importNode.__CE_hasRegistry = true;
	
	              // Clone the `visitedImports` set that was populated sync during
	              // the `patchAndUpgradeTree` call that caused this 'load' handler to
	              // be added. Then, remove *this* link's import node so that we can
	              // walk that import again, even if it was partially walked later
	              // during the same `patchAndUpgradeTree` call.
	              visitedImports.delete(importNode);
	
	              _this2.patchAndUpgradeTree(importNode, visitedImports);
	            });
	          }
	        } else {
	          elements.push(element);
	        }
	      };
	
	      // `walkDeepDescendantElements` populates (and internally checks against)
	      // `visitedImports` when traversing a loaded import.
	      walkDeepDescendantElements(root, gatherElements, visitedImports);
	
	      if (this._hasPatches) {
	        for (var i = 0; i < elements.length; i++) {
	          this.patch(elements[i]);
	        }
	      }
	
	      for (var _i = 0; _i < elements.length; _i++) {
	        this.upgradeElement(elements[_i]);
	      }
	    }
	
	    /**
	     * @param {!Element} element
	     */
	
	  }, {
	    key: 'upgradeElement',
	    value: function upgradeElement(element) {
	      var currentState = element.__CE_state;
	      if (currentState !== undefined) return;
	
	      var definition = this.localNameToDefinition(element.localName);
	      if (!definition) return;
	
	      definition.constructionStack.push(element);
	
	      var constructor = definition.constructor;
	      try {
	        try {
	          var result = new constructor();
	          if (result !== element) {
	            throw new Error('The custom element constructor did not produce the element being upgraded.');
	          }
	        } finally {
	          definition.constructionStack.pop();
	        }
	      } catch (e) {
	        element.__CE_state = CustomElementState.failed;
	        throw e;
	      }
	
	      element.__CE_state = CustomElementState.custom;
	      element.__CE_definition = definition;
	
	      if (definition.attributeChangedCallback) {
	        var observedAttributes = definition.observedAttributes;
	        for (var i = 0; i < observedAttributes.length; i++) {
	          var name = observedAttributes[i];
	          var value = element.getAttribute(name);
	          if (value !== null) {
	            this.attributeChangedCallback(element, name, null, value, null);
	          }
	        }
	      }
	
	      if (isConnected(element)) {
	        this.connectedCallback(element);
	      }
	    }
	
	    /**
	     * @param {!Element} element
	     */
	
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback(element) {
	      var definition = element.__CE_definition;
	      if (definition.connectedCallback) {
	        definition.connectedCallback.call(element);
	      }
	
	      element.__CE_isConnectedCallbackCalled = true;
	    }
	
	    /**
	     * @param {!Element} element
	     */
	
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback(element) {
	      if (!element.__CE_isConnectedCallbackCalled) {
	        this.connectedCallback(element);
	      }
	
	      var definition = element.__CE_definition;
	      if (definition.disconnectedCallback) {
	        definition.disconnectedCallback.call(element);
	      }
	
	      element.__CE_isConnectedCallbackCalled = undefined;
	    }
	
	    /**
	     * @param {!Element} element
	     * @param {string} name
	     * @param {?string} oldValue
	     * @param {?string} newValue
	     * @param {?string} namespace
	     */
	
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(element, name, oldValue, newValue, namespace) {
	      var definition = element.__CE_definition;
	      if (definition.attributeChangedCallback && definition.observedAttributes.indexOf(name) > -1) {
	        definition.attributeChangedCallback.call(element, name, oldValue, newValue, namespace);
	      }
	    }
	  }]);
	  return CustomElementInternals;
	}();
	
	var DocumentConstructionObserver = function () {
	  function DocumentConstructionObserver(internals, doc) {
	    classCallCheck(this, DocumentConstructionObserver);
	
	    /**
	     * @type {!CustomElementInternals}
	     */
	    this._internals = internals;
	
	    /**
	     * @type {!Document}
	     */
	    this._document = doc;
	
	    /**
	     * @type {MutationObserver|undefined}
	     */
	    this._observer = undefined;
	
	    // Simulate tree construction for all currently accessible nodes in the
	    // document.
	    this._internals.patchAndUpgradeTree(this._document);
	
	    if (this._document.readyState === 'loading') {
	      this._observer = new MutationObserver(this._handleMutations.bind(this));
	
	      // Nodes created by the parser are given to the observer *before* the next
	      // task runs. Inline scripts are run in a new task. This means that the
	      // observer will be able to handle the newly parsed nodes before the inline
	      // script is run.
	      this._observer.observe(this._document, {
	        childList: true,
	        subtree: true
	      });
	    }
	  }
	
	  createClass(DocumentConstructionObserver, [{
	    key: 'disconnect',
	    value: function disconnect() {
	      if (this._observer) {
	        this._observer.disconnect();
	      }
	    }
	
	    /**
	     * @param {!Array<!MutationRecord>} mutations
	     */
	
	  }, {
	    key: '_handleMutations',
	    value: function _handleMutations(mutations) {
	      // Once the document's `readyState` is 'interactive' or 'complete', all new
	      // nodes created within that document will be the result of script and
	      // should be handled by patching.
	      var readyState = this._document.readyState;
	      if (readyState === 'interactive' || readyState === 'complete') {
	        this.disconnect();
	      }
	
	      for (var i = 0; i < mutations.length; i++) {
	        var addedNodes = mutations[i].addedNodes;
	        for (var j = 0; j < addedNodes.length; j++) {
	          var node = addedNodes[j];
	          this._internals.patchAndUpgradeTree(node);
	        }
	      }
	    }
	  }]);
	  return DocumentConstructionObserver;
	}();
	
	/**
	 * @template T
	 */
	var Deferred = function () {
	  function Deferred() {
	    var _this = this;
	
	    classCallCheck(this, Deferred);
	
	    /**
	     * @private
	     * @type {T|undefined}
	     */
	    this._value = undefined;
	
	    /**
	     * @private
	     * @type {Function|undefined}
	     */
	    this._resolve = undefined;
	
	    /**
	     * @private
	     * @type {!Promise<T>}
	     */
	    this._promise = new Promise(function (resolve) {
	      _this._resolve = resolve;
	
	      if (_this._value) {
	        resolve(_this._value);
	      }
	    });
	  }
	
	  /**
	   * @param {T} value
	   */
	
	
	  createClass(Deferred, [{
	    key: 'resolve',
	    value: function resolve(value) {
	      if (this._value) {
	        throw new Error('Already resolved.');
	      }
	
	      this._value = value;
	
	      if (this._resolve) {
	        this._resolve(value);
	      }
	    }
	
	    /**
	     * @return {!Promise<T>}
	     */
	
	  }, {
	    key: 'toPromise',
	    value: function toPromise() {
	      return this._promise;
	    }
	  }]);
	  return Deferred;
	}();
	
	/**
	 * @unrestricted
	 */
	
	var CustomElementRegistry = function () {
	
	  /**
	   * @param {!CustomElementInternals} internals
	   */
	  function CustomElementRegistry(internals) {
	    classCallCheck(this, CustomElementRegistry);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this._elementDefinitionIsRunning = false;
	
	    /**
	     * @private
	     * @type {!CustomElementInternals}
	     */
	    this._internals = internals;
	
	    /**
	     * @private
	     * @type {!Map<string, !Deferred<undefined>>}
	     */
	    this._whenDefinedDeferred = new Map();
	
	    /**
	     * The default flush callback triggers the document walk synchronously.
	     * @private
	     * @type {!Function}
	     */
	    this._flushCallback = function (fn) {
	      return fn();
	    };
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this._flushPending = false;
	
	    /**
	     * @private
	     * @type {!Array<string>}
	     */
	    this._unflushedLocalNames = [];
	
	    /**
	     * @private
	     * @type {!DocumentConstructionObserver}
	     */
	    this._documentConstructionObserver = new DocumentConstructionObserver(internals, document);
	  }
	
	  /**
	   * @param {string} localName
	   * @param {!Function} constructor
	   */
	
	
	  createClass(CustomElementRegistry, [{
	    key: 'define',
	    value: function define(localName, constructor) {
	      var _this = this;
	
	      if (!(constructor instanceof Function)) {
	        throw new TypeError('Custom element constructors must be functions.');
	      }
	
	      if (!isValidCustomElementName(localName)) {
	        throw new SyntaxError('The element name \'' + localName + '\' is not valid.');
	      }
	
	      if (this._internals.localNameToDefinition(localName)) {
	        throw new Error('A custom element with name \'' + localName + '\' has already been defined.');
	      }
	
	      if (this._elementDefinitionIsRunning) {
	        throw new Error('A custom element is already being defined.');
	      }
	      this._elementDefinitionIsRunning = true;
	
	      var connectedCallback = void 0;
	      var disconnectedCallback = void 0;
	      var adoptedCallback = void 0;
	      var attributeChangedCallback = void 0;
	      var observedAttributes = void 0;
	      try {
	        var getCallback = function getCallback(name) {
	          var callbackValue = prototype[name];
	          if (callbackValue !== undefined && !(callbackValue instanceof Function)) {
	            throw new Error('The \'' + name + '\' callback must be a function.');
	          }
	          return callbackValue;
	        };
	
	        /** @type {!Object} */
	        var prototype = constructor.prototype;
	        if (!(prototype instanceof Object)) {
	          throw new TypeError('The custom element constructor\'s prototype is not an object.');
	        }
	
	        connectedCallback = getCallback('connectedCallback');
	        disconnectedCallback = getCallback('disconnectedCallback');
	        adoptedCallback = getCallback('adoptedCallback');
	        attributeChangedCallback = getCallback('attributeChangedCallback');
	        observedAttributes = constructor['observedAttributes'] || [];
	      } catch (e) {
	        return;
	      } finally {
	        this._elementDefinitionIsRunning = false;
	      }
	
	      var definition = {
	        localName: localName,
	        constructor: constructor,
	        connectedCallback: connectedCallback,
	        disconnectedCallback: disconnectedCallback,
	        adoptedCallback: adoptedCallback,
	        attributeChangedCallback: attributeChangedCallback,
	        observedAttributes: observedAttributes,
	        constructionStack: []
	      };
	
	      this._internals.setDefinition(localName, definition);
	
	      this._unflushedLocalNames.push(localName);
	
	      // If we've already called the flush callback and it hasn't called back yet,
	      // don't call it again.
	      if (!this._flushPending) {
	        this._flushPending = true;
	        this._flushCallback(function () {
	          return _this._flush();
	        });
	      }
	    }
	  }, {
	    key: '_flush',
	    value: function _flush() {
	      // If no new definitions were defined, don't attempt to flush. This could
	      // happen if a flush callback keeps the function it is given and calls it
	      // multiple times.
	      if (this._flushPending === false) return;
	
	      this._flushPending = false;
	      this._internals.patchAndUpgradeTree(document);
	
	      while (this._unflushedLocalNames.length > 0) {
	        var localName = this._unflushedLocalNames.shift();
	        var deferred = this._whenDefinedDeferred.get(localName);
	        if (deferred) {
	          deferred.resolve(undefined);
	        }
	      }
	    }
	
	    /**
	     * @param {string} localName
	     * @return {Function|undefined}
	     */
	
	  }, {
	    key: 'get',
	    value: function get$$1(localName) {
	      var definition = this._internals.localNameToDefinition(localName);
	      if (definition) {
	        return definition.constructor;
	      }
	
	      return undefined;
	    }
	
	    /**
	     * @param {string} localName
	     * @return {!Promise<undefined>}
	     */
	
	  }, {
	    key: 'whenDefined',
	    value: function whenDefined(localName) {
	      if (!isValidCustomElementName(localName)) {
	        return Promise.reject(new SyntaxError('\'' + localName + '\' is not a valid custom element name.'));
	      }
	
	      var prior = this._whenDefinedDeferred.get(localName);
	      if (prior) {
	        return prior.toPromise();
	      }
	
	      var deferred = new Deferred();
	      this._whenDefinedDeferred.set(localName, deferred);
	
	      var definition = this._internals.localNameToDefinition(localName);
	      // Resolve immediately only if the given local name has a definition *and*
	      // the full document walk to upgrade elements with that local name has
	      // already happened.
	      if (definition && this._unflushedLocalNames.indexOf(localName) === -1) {
	        deferred.resolve(undefined);
	      }
	
	      return deferred.toPromise();
	    }
	  }, {
	    key: 'polyfillWrapFlushCallback',
	    value: function polyfillWrapFlushCallback(outer) {
	      this._documentConstructionObserver.disconnect();
	      var inner = this._flushCallback;
	      this._flushCallback = function (flush) {
	        return outer(function () {
	          return inner(flush);
	        });
	      };
	    }
	  }]);
	  return CustomElementRegistry;
	}();
	
	window['CustomElementRegistry'] = CustomElementRegistry;
	CustomElementRegistry.prototype['define'] = CustomElementRegistry.prototype.define;
	CustomElementRegistry.prototype['get'] = CustomElementRegistry.prototype.get;
	CustomElementRegistry.prototype['whenDefined'] = CustomElementRegistry.prototype.whenDefined;
	CustomElementRegistry.prototype['polyfillWrapFlushCallback'] = CustomElementRegistry.prototype.polyfillWrapFlushCallback;
	
	var Native = {
	  Document_createElement: window.Document.prototype.createElement,
	  Document_createElementNS: window.Document.prototype.createElementNS,
	  Document_importNode: window.Document.prototype.importNode,
	  Document_prepend: window.Document.prototype['prepend'],
	  Document_append: window.Document.prototype['append'],
	  Node_cloneNode: window.Node.prototype.cloneNode,
	  Node_appendChild: window.Node.prototype.appendChild,
	  Node_insertBefore: window.Node.prototype.insertBefore,
	  Node_removeChild: window.Node.prototype.removeChild,
	  Node_replaceChild: window.Node.prototype.replaceChild,
	  Node_textContent: Object.getOwnPropertyDescriptor(window.Node.prototype, 'textContent'),
	  Element_attachShadow: window.Element.prototype['attachShadow'],
	  Element_innerHTML: Object.getOwnPropertyDescriptor(window.Element.prototype, 'innerHTML'),
	  Element_getAttribute: window.Element.prototype.getAttribute,
	  Element_setAttribute: window.Element.prototype.setAttribute,
	  Element_removeAttribute: window.Element.prototype.removeAttribute,
	  Element_getAttributeNS: window.Element.prototype.getAttributeNS,
	  Element_setAttributeNS: window.Element.prototype.setAttributeNS,
	  Element_removeAttributeNS: window.Element.prototype.removeAttributeNS,
	  Element_insertAdjacentElement: window.Element.prototype['insertAdjacentElement'],
	  Element_prepend: window.Element.prototype['prepend'],
	  Element_append: window.Element.prototype['append'],
	  Element_before: window.Element.prototype['before'],
	  Element_after: window.Element.prototype['after'],
	  Element_replaceWith: window.Element.prototype['replaceWith'],
	  Element_remove: window.Element.prototype['remove'],
	  HTMLElement: window.HTMLElement,
	  HTMLElement_innerHTML: Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, 'innerHTML'),
	  HTMLElement_insertAdjacentElement: window.HTMLElement.prototype['insertAdjacentElement']
	};
	
	/**
	 * This class exists only to work around Closure's lack of a way to describe
	 * singletons. It represents the 'already constructed marker' used in custom
	 * element construction stacks.
	 *
	 * https://html.spec.whatwg.org/#concept-already-constructed-marker
	 */
	var AlreadyConstructedMarker = function AlreadyConstructedMarker() {
	  classCallCheck(this, AlreadyConstructedMarker);
	};
	
	var AlreadyConstructedMarker$1 = new AlreadyConstructedMarker();
	
	/**
	 * @param {!CustomElementInternals} internals
	 */
	var PatchHTMLElement = function (internals) {
	  window['HTMLElement'] = function () {
	    /**
	     * @type {function(new: HTMLElement): !HTMLElement}
	     */
	    function HTMLElement() {
	      // This should really be `new.target` but `new.target` can't be emulated
	      // in ES5. Assuming the user keeps the default value of the constructor's
	      // prototype's `constructor` property, this is equivalent.
	      /** @type {!Function} */
	      var constructor = this.constructor;
	
	      var definition = internals.constructorToDefinition(constructor);
	      if (!definition) {
	        throw new Error('The custom element being constructed was not registered with `customElements`.');
	      }
	
	      var constructionStack = definition.constructionStack;
	
	      if (constructionStack.length === 0) {
	        var _element = Native.Document_createElement.call(document, definition.localName);
	        Object.setPrototypeOf(_element, constructor.prototype);
	        _element.__CE_state = CustomElementState.custom;
	        _element.__CE_definition = definition;
	        internals.patch(_element);
	        return _element;
	      }
	
	      var lastIndex = constructionStack.length - 1;
	      var element = constructionStack[lastIndex];
	      if (element === AlreadyConstructedMarker$1) {
	        throw new Error('The HTMLElement constructor was either called reentrantly for this constructor or called multiple times.');
	      }
	      constructionStack[lastIndex] = AlreadyConstructedMarker$1;
	
	      Object.setPrototypeOf(element, constructor.prototype);
	      internals.patch( /** @type {!HTMLElement} */element);
	
	      return element;
	    }
	
	    HTMLElement.prototype = Native.HTMLElement.prototype;
	
	    return HTMLElement;
	  }();
	};
	
	/**
	 * @param {!CustomElementInternals} internals
	 * @param {!Object} destination
	 * @param {!ParentNodeNativeMethods} builtIn
	 */
	var PatchParentNode = function (internals, destination, builtIn) {
	  /**
	   * @param {...(!Node|string)} nodes
	   */
	  destination['prepend'] = function () {
	    for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	      nodes[_key] = arguments[_key];
	    }
	
	    // TODO: Fix this for when one of `nodes` is a DocumentFragment!
	    var connectedBefore = /** @type {!Array<!Node>} */nodes.filter(function (node) {
	      // DocumentFragments are not connected and will not be added to the list.
	      return node instanceof Node && isConnected(node);
	    });
	
	    builtIn.prepend.apply(this, nodes);
	
	    for (var i = 0; i < connectedBefore.length; i++) {
	      internals.disconnectTree(connectedBefore[i]);
	    }
	
	    if (isConnected(this)) {
	      for (var _i = 0; _i < nodes.length; _i++) {
	        var node = nodes[_i];
	        if (node instanceof Element) {
	          internals.connectTree(node);
	        }
	      }
	    }
	  };
	
	  /**
	   * @param {...(!Node|string)} nodes
	   */
	  destination['append'] = function () {
	    for (var _len2 = arguments.length, nodes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      nodes[_key2] = arguments[_key2];
	    }
	
	    // TODO: Fix this for when one of `nodes` is a DocumentFragment!
	    var connectedBefore = /** @type {!Array<!Node>} */nodes.filter(function (node) {
	      // DocumentFragments are not connected and will not be added to the list.
	      return node instanceof Node && isConnected(node);
	    });
	
	    builtIn.append.apply(this, nodes);
	
	    for (var i = 0; i < connectedBefore.length; i++) {
	      internals.disconnectTree(connectedBefore[i]);
	    }
	
	    if (isConnected(this)) {
	      for (var _i2 = 0; _i2 < nodes.length; _i2++) {
	        var node = nodes[_i2];
	        if (node instanceof Element) {
	          internals.connectTree(node);
	        }
	      }
	    }
	  };
	};
	
	/**
	 * @param {!CustomElementInternals} internals
	 */
	var PatchDocument = function (internals) {
	  setPropertyUnchecked(Document.prototype, 'createElement',
	  /**
	   * @this {Document}
	   * @param {string} localName
	   * @return {!Element}
	   */
	  function (localName) {
	    // Only create custom elements if this document is associated with the registry.
	    if (this.__CE_hasRegistry) {
	      var definition = internals.localNameToDefinition(localName);
	      if (definition) {
	        return new definition.constructor();
	      }
	    }
	
	    var result = /** @type {!Element} */
	    Native.Document_createElement.call(this, localName);
	    internals.patch(result);
	    return result;
	  });
	
	  setPropertyUnchecked(Document.prototype, 'importNode',
	  /**
	   * @this {Document}
	   * @param {!Node} node
	   * @param {boolean=} deep
	   * @return {!Node}
	   */
	  function (node, deep) {
	    var clone = Native.Document_importNode.call(this, node, deep);
	    // Only create custom elements if this document is associated with the registry.
	    if (!this.__CE_hasRegistry) {
	      internals.patchTree(clone);
	    } else {
	      internals.patchAndUpgradeTree(clone);
	    }
	    return clone;
	  });
	
	  var NS_HTML = "http://www.w3.org/1999/xhtml";
	
	  setPropertyUnchecked(Document.prototype, 'createElementNS',
	  /**
	   * @this {Document}
	   * @param {?string} namespace
	   * @param {string} localName
	   * @return {!Element}
	   */
	  function (namespace, localName) {
	    // Only create custom elements if this document is associated with the registry.
	    if (this.__CE_hasRegistry && (namespace === null || namespace === NS_HTML)) {
	      var definition = internals.localNameToDefinition(localName);
	      if (definition) {
	        return new definition.constructor();
	      }
	    }
	
	    var result = /** @type {!Element} */
	    Native.Document_createElementNS.call(this, namespace, localName);
	    internals.patch(result);
	    return result;
	  });
	
	  PatchParentNode(internals, Document.prototype, {
	    prepend: Native.Document_prepend,
	    append: Native.Document_append
	  });
	};
	
	/**
	 * @param {!CustomElementInternals} internals
	 */
	var PatchNode = function (internals) {
	  // `Node#nodeValue` is implemented on `Attr`.
	  // `Node#textContent` is implemented on `Attr`, `Element`.
	
	  setPropertyUnchecked(Node.prototype, 'insertBefore',
	  /**
	   * @this {Node}
	   * @param {!Node} node
	   * @param {?Node} refNode
	   * @return {!Node}
	   */
	  function (node, refNode) {
	    if (node instanceof DocumentFragment) {
	      var insertedNodes = Array.prototype.slice.apply(node.childNodes);
	      var _nativeResult = Native.Node_insertBefore.call(this, node, refNode);
	
	      // DocumentFragments can't be connected, so `disconnectTree` will never
	      // need to be called on a DocumentFragment's children after inserting it.
	
	      if (isConnected(this)) {
	        for (var i = 0; i < insertedNodes.length; i++) {
	          internals.connectTree(insertedNodes[i]);
	        }
	      }
	
	      return _nativeResult;
	    }
	
	    var nodeWasConnected = isConnected(node);
	    var nativeResult = Native.Node_insertBefore.call(this, node, refNode);
	
	    if (nodeWasConnected) {
	      internals.disconnectTree(node);
	    }
	
	    if (isConnected(this)) {
	      internals.connectTree(node);
	    }
	
	    return nativeResult;
	  });
	
	  setPropertyUnchecked(Node.prototype, 'appendChild',
	  /**
	   * @this {Node}
	   * @param {!Node} node
	   * @return {!Node}
	   */
	  function (node) {
	    if (node instanceof DocumentFragment) {
	      var insertedNodes = Array.prototype.slice.apply(node.childNodes);
	      var _nativeResult2 = Native.Node_appendChild.call(this, node);
	
	      // DocumentFragments can't be connected, so `disconnectTree` will never
	      // need to be called on a DocumentFragment's children after inserting it.
	
	      if (isConnected(this)) {
	        for (var i = 0; i < insertedNodes.length; i++) {
	          internals.connectTree(insertedNodes[i]);
	        }
	      }
	
	      return _nativeResult2;
	    }
	
	    var nodeWasConnected = isConnected(node);
	    var nativeResult = Native.Node_appendChild.call(this, node);
	
	    if (nodeWasConnected) {
	      internals.disconnectTree(node);
	    }
	
	    if (isConnected(this)) {
	      internals.connectTree(node);
	    }
	
	    return nativeResult;
	  });
	
	  setPropertyUnchecked(Node.prototype, 'cloneNode',
	  /**
	   * @this {Node}
	   * @param {boolean=} deep
	   * @return {!Node}
	   */
	  function (deep) {
	    var clone = Native.Node_cloneNode.call(this, deep);
	    // Only create custom elements if this element's owner document is
	    // associated with the registry.
	    if (!this.ownerDocument.__CE_hasRegistry) {
	      internals.patchTree(clone);
	    } else {
	      internals.patchAndUpgradeTree(clone);
	    }
	    return clone;
	  });
	
	  setPropertyUnchecked(Node.prototype, 'removeChild',
	  /**
	   * @this {Node}
	   * @param {!Node} node
	   * @return {!Node}
	   */
	  function (node) {
	    var nodeWasConnected = isConnected(node);
	    var nativeResult = Native.Node_removeChild.call(this, node);
	
	    if (nodeWasConnected) {
	      internals.disconnectTree(node);
	    }
	
	    return nativeResult;
	  });
	
	  setPropertyUnchecked(Node.prototype, 'replaceChild',
	  /**
	   * @this {Node}
	   * @param {!Node} nodeToInsert
	   * @param {!Node} nodeToRemove
	   * @return {!Node}
	   */
	  function (nodeToInsert, nodeToRemove) {
	    if (nodeToInsert instanceof DocumentFragment) {
	      var insertedNodes = Array.prototype.slice.apply(nodeToInsert.childNodes);
	      var _nativeResult3 = Native.Node_replaceChild.call(this, nodeToInsert, nodeToRemove);
	
	      // DocumentFragments can't be connected, so `disconnectTree` will never
	      // need to be called on a DocumentFragment's children after inserting it.
	
	      if (isConnected(this)) {
	        internals.disconnectTree(nodeToRemove);
	        for (var i = 0; i < insertedNodes.length; i++) {
	          internals.connectTree(insertedNodes[i]);
	        }
	      }
	
	      return _nativeResult3;
	    }
	
	    var nodeToInsertWasConnected = isConnected(nodeToInsert);
	    var nativeResult = Native.Node_replaceChild.call(this, nodeToInsert, nodeToRemove);
	    var thisIsConnected = isConnected(this);
	
	    if (thisIsConnected) {
	      internals.disconnectTree(nodeToRemove);
	    }
	
	    if (nodeToInsertWasConnected) {
	      internals.disconnectTree(nodeToInsert);
	    }
	
	    if (thisIsConnected) {
	      internals.connectTree(nodeToInsert);
	    }
	
	    return nativeResult;
	  });
	
	  function patch_textContent(destination, baseDescriptor) {
	    Object.defineProperty(destination, 'textContent', {
	      enumerable: baseDescriptor.enumerable,
	      configurable: true,
	      get: baseDescriptor.get,
	      set: /** @this {Node} */function set(assignedValue) {
	        // If this is a text node then there are no nodes to disconnect.
	        if (this.nodeType === Node.TEXT_NODE) {
	          baseDescriptor.set.call(this, assignedValue);
	          return;
	        }
	
	        var removedNodes = undefined;
	        // Checking for `firstChild` is faster than reading `childNodes.length`
	        // to compare with 0.
	        if (this.firstChild) {
	          // Using `childNodes` is faster than `children`, even though we only
	          // care about elements.
	          var childNodes = this.childNodes;
	          var childNodesLength = childNodes.length;
	          if (childNodesLength > 0 && isConnected(this)) {
	            // Copying an array by iterating is faster than using slice.
	            removedNodes = new Array(childNodesLength);
	            for (var i = 0; i < childNodesLength; i++) {
	              removedNodes[i] = childNodes[i];
	            }
	          }
	        }
	
	        baseDescriptor.set.call(this, assignedValue);
	
	        if (removedNodes) {
	          for (var _i = 0; _i < removedNodes.length; _i++) {
	            internals.disconnectTree(removedNodes[_i]);
	          }
	        }
	      }
	    });
	  }
	
	  if (Native.Node_textContent && Native.Node_textContent.get) {
	    patch_textContent(Node.prototype, Native.Node_textContent);
	  } else {
	    internals.addPatch(function (element) {
	      patch_textContent(element, {
	        enumerable: true,
	        configurable: true,
	        // NOTE: This implementation of the `textContent` getter assumes that
	        // text nodes' `textContent` getter will not be patched.
	        get: /** @this {Node} */function get() {
	          /** @type {!Array<string>} */
	          var parts = [];
	
	          for (var i = 0; i < this.childNodes.length; i++) {
	            parts.push(this.childNodes[i].textContent);
	          }
	
	          return parts.join('');
	        },
	        set: /** @this {Node} */function set(assignedValue) {
	          while (this.firstChild) {
	            Native.Node_removeChild.call(this, this.firstChild);
	          }
	          Native.Node_appendChild.call(this, document.createTextNode(assignedValue));
	        }
	      });
	    });
	  }
	};
	
	/**
	 * @param {!CustomElementInternals} internals
	 * @param {!Object} destination
	 * @param {!ChildNodeNativeMethods} builtIn
	 */
	var PatchChildNode = function (internals, destination, builtIn) {
	  /**
	   * @param {...(!Node|string)} nodes
	   */
	  destination['before'] = function () {
	    for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	      nodes[_key] = arguments[_key];
	    }
	
	    // TODO: Fix this for when one of `nodes` is a DocumentFragment!
	    var connectedBefore = /** @type {!Array<!Node>} */nodes.filter(function (node) {
	      // DocumentFragments are not connected and will not be added to the list.
	      return node instanceof Node && isConnected(node);
	    });
	
	    builtIn.before.apply(this, nodes);
	
	    for (var i = 0; i < connectedBefore.length; i++) {
	      internals.disconnectTree(connectedBefore[i]);
	    }
	
	    if (isConnected(this)) {
	      for (var _i = 0; _i < nodes.length; _i++) {
	        var node = nodes[_i];
	        if (node instanceof Element) {
	          internals.connectTree(node);
	        }
	      }
	    }
	  };
	
	  /**
	   * @param {...(!Node|string)} nodes
	   */
	  destination['after'] = function () {
	    for (var _len2 = arguments.length, nodes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      nodes[_key2] = arguments[_key2];
	    }
	
	    // TODO: Fix this for when one of `nodes` is a DocumentFragment!
	    var connectedBefore = /** @type {!Array<!Node>} */nodes.filter(function (node) {
	      // DocumentFragments are not connected and will not be added to the list.
	      return node instanceof Node && isConnected(node);
	    });
	
	    builtIn.after.apply(this, nodes);
	
	    for (var i = 0; i < connectedBefore.length; i++) {
	      internals.disconnectTree(connectedBefore[i]);
	    }
	
	    if (isConnected(this)) {
	      for (var _i2 = 0; _i2 < nodes.length; _i2++) {
	        var node = nodes[_i2];
	        if (node instanceof Element) {
	          internals.connectTree(node);
	        }
	      }
	    }
	  };
	
	  /**
	   * @param {...(!Node|string)} nodes
	   */
	  destination['replaceWith'] = function () {
	    for (var _len3 = arguments.length, nodes = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      nodes[_key3] = arguments[_key3];
	    }
	
	    // TODO: Fix this for when one of `nodes` is a DocumentFragment!
	    var connectedBefore = /** @type {!Array<!Node>} */nodes.filter(function (node) {
	      // DocumentFragments are not connected and will not be added to the list.
	      return node instanceof Node && isConnected(node);
	    });
	
	    var wasConnected = isConnected(this);
	
	    builtIn.replaceWith.apply(this, nodes);
	
	    for (var i = 0; i < connectedBefore.length; i++) {
	      internals.disconnectTree(connectedBefore[i]);
	    }
	
	    if (wasConnected) {
	      internals.disconnectTree(this);
	      for (var _i3 = 0; _i3 < nodes.length; _i3++) {
	        var node = nodes[_i3];
	        if (node instanceof Element) {
	          internals.connectTree(node);
	        }
	      }
	    }
	  };
	
	  destination['remove'] = function () {
	    var wasConnected = isConnected(this);
	
	    builtIn.remove.call(this);
	
	    if (wasConnected) {
	      internals.disconnectTree(this);
	    }
	  };
	};
	
	/**
	 * @param {!CustomElementInternals} internals
	 */
	var PatchElement = function (internals) {
	  if (Native.Element_attachShadow) {
	    setPropertyUnchecked(Element.prototype, 'attachShadow',
	    /**
	     * @this {Element}
	     * @param {!{mode: string}} init
	     * @return {ShadowRoot}
	     */
	    function (init) {
	      var shadowRoot = Native.Element_attachShadow.call(this, init);
	      this.__CE_shadowRoot = shadowRoot;
	      return shadowRoot;
	    });
	  } else {
	    console.warn('Custom Elements: `Element#attachShadow` was not patched.');
	  }
	
	  function patch_innerHTML(destination, baseDescriptor) {
	    Object.defineProperty(destination, 'innerHTML', {
	      enumerable: baseDescriptor.enumerable,
	      configurable: true,
	      get: baseDescriptor.get,
	      set: /** @this {Element} */function set(htmlString) {
	        var _this = this;
	
	        var isConnected$$1 = isConnected(this);
	
	        // NOTE: In IE11, when using the native `innerHTML` setter, all nodes
	        // that were previously descendants of the context element have all of
	        // their children removed as part of the set - the entire subtree is
	        // 'disassembled'. This work around walks the subtree *before* using the
	        // native setter.
	        /** @type {!Array<!Element>|undefined} */
	        var removedElements = undefined;
	        if (isConnected$$1) {
	          removedElements = [];
	          walkDeepDescendantElements(this, function (element) {
	            if (element !== _this) {
	              removedElements.push(element);
	            }
	          });
	        }
	
	        baseDescriptor.set.call(this, htmlString);
	
	        if (removedElements) {
	          for (var i = 0; i < removedElements.length; i++) {
	            var element = removedElements[i];
	            if (element.__CE_state === CustomElementState.custom) {
	              internals.disconnectedCallback(element);
	            }
	          }
	        }
	
	        // Only create custom elements if this element's owner document is
	        // associated with the registry.
	        if (!this.ownerDocument.__CE_hasRegistry) {
	          internals.patchTree(this);
	        } else {
	          internals.patchAndUpgradeTree(this);
	        }
	        return htmlString;
	      }
	    });
	  }
	
	  if (Native.Element_innerHTML && Native.Element_innerHTML.get) {
	    patch_innerHTML(Element.prototype, Native.Element_innerHTML);
	  } else if (Native.HTMLElement_innerHTML && Native.HTMLElement_innerHTML.get) {
	    patch_innerHTML(HTMLElement.prototype, Native.HTMLElement_innerHTML);
	  } else {
	
	    /** @type {HTMLDivElement} */
	    var rawDiv = Native.Document_createElement.call(document, 'div');
	
	    internals.addPatch(function (element) {
	      patch_innerHTML(element, {
	        enumerable: true,
	        configurable: true,
	        // Implements getting `innerHTML` by performing an unpatched `cloneNode`
	        // of the element and returning the resulting element's `innerHTML`.
	        // TODO: Is this too expensive?
	        get: /** @this {Element} */function get() {
	          return Native.Node_cloneNode.call(this, true).innerHTML;
	        },
	        // Implements setting `innerHTML` by creating an unpatched element,
	        // setting `innerHTML` of that element and replacing the target
	        // element's children with those of the unpatched element.
	        set: /** @this {Element} */function set(assignedValue) {
	          // NOTE: re-route to `content` for `template` elements.
	          // We need to do this because `template.appendChild` does not
	          // route into `template.content`.
	          /** @type {!Node} */
	          var content = this.localName === 'template' ? /** @type {!HTMLTemplateElement} */this.content : this;
	          rawDiv.innerHTML = assignedValue;
	
	          while (content.childNodes.length > 0) {
	            Native.Node_removeChild.call(content, content.childNodes[0]);
	          }
	          while (rawDiv.childNodes.length > 0) {
	            Native.Node_appendChild.call(content, rawDiv.childNodes[0]);
	          }
	        }
	      });
	    });
	  }
	
	  setPropertyUnchecked(Element.prototype, 'setAttribute',
	  /**
	   * @this {Element}
	   * @param {string} name
	   * @param {string} newValue
	   */
	  function (name, newValue) {
	    // Fast path for non-custom elements.
	    if (this.__CE_state !== CustomElementState.custom) {
	      return Native.Element_setAttribute.call(this, name, newValue);
	    }
	
	    var oldValue = Native.Element_getAttribute.call(this, name);
	    Native.Element_setAttribute.call(this, name, newValue);
	    newValue = Native.Element_getAttribute.call(this, name);
	    internals.attributeChangedCallback(this, name, oldValue, newValue, null);
	  });
	
	  setPropertyUnchecked(Element.prototype, 'setAttributeNS',
	  /**
	   * @this {Element}
	   * @param {?string} namespace
	   * @param {string} name
	   * @param {string} newValue
	   */
	  function (namespace, name, newValue) {
	    // Fast path for non-custom elements.
	    if (this.__CE_state !== CustomElementState.custom) {
	      return Native.Element_setAttributeNS.call(this, namespace, name, newValue);
	    }
	
	    var oldValue = Native.Element_getAttributeNS.call(this, namespace, name);
	    Native.Element_setAttributeNS.call(this, namespace, name, newValue);
	    newValue = Native.Element_getAttributeNS.call(this, namespace, name);
	    internals.attributeChangedCallback(this, name, oldValue, newValue, namespace);
	  });
	
	  setPropertyUnchecked(Element.prototype, 'removeAttribute',
	  /**
	   * @this {Element}
	   * @param {string} name
	   */
	  function (name) {
	    // Fast path for non-custom elements.
	    if (this.__CE_state !== CustomElementState.custom) {
	      return Native.Element_removeAttribute.call(this, name);
	    }
	
	    var oldValue = Native.Element_getAttribute.call(this, name);
	    Native.Element_removeAttribute.call(this, name);
	    if (oldValue !== null) {
	      internals.attributeChangedCallback(this, name, oldValue, null, null);
	    }
	  });
	
	  setPropertyUnchecked(Element.prototype, 'removeAttributeNS',
	  /**
	   * @this {Element}
	   * @param {?string} namespace
	   * @param {string} name
	   */
	  function (namespace, name) {
	    // Fast path for non-custom elements.
	    if (this.__CE_state !== CustomElementState.custom) {
	      return Native.Element_removeAttributeNS.call(this, namespace, name);
	    }
	
	    var oldValue = Native.Element_getAttributeNS.call(this, namespace, name);
	    Native.Element_removeAttributeNS.call(this, namespace, name);
	    // In older browsers, `Element#getAttributeNS` may return the empty string
	    // instead of null if the attribute does not exist. For details, see;
	    // https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNS#Notes
	    var newValue = Native.Element_getAttributeNS.call(this, namespace, name);
	    if (oldValue !== newValue) {
	      internals.attributeChangedCallback(this, name, oldValue, newValue, namespace);
	    }
	  });
	
	  function patch_insertAdjacentElement(destination, baseMethod) {
	    setPropertyUnchecked(destination, 'insertAdjacentElement',
	    /**
	     * @this {Element}
	     * @param {string} where
	     * @param {!Element} element
	     * @return {?Element}
	     */
	    function (where, element) {
	      var wasConnected = isConnected(element);
	      var insertedElement = /** @type {!Element} */
	      baseMethod.call(this, where, element);
	
	      if (wasConnected) {
	        internals.disconnectTree(element);
	      }
	
	      if (isConnected(insertedElement)) {
	        internals.connectTree(element);
	      }
	      return insertedElement;
	    });
	  }
	
	  if (Native.HTMLElement_insertAdjacentElement) {
	    patch_insertAdjacentElement(HTMLElement.prototype, Native.HTMLElement_insertAdjacentElement);
	  } else if (Native.Element_insertAdjacentElement) {
	    patch_insertAdjacentElement(Element.prototype, Native.Element_insertAdjacentElement);
	  } else {
	    console.warn('Custom Elements: `Element#insertAdjacentElement` was not patched.');
	  }
	
	  PatchParentNode(internals, Element.prototype, {
	    prepend: Native.Element_prepend,
	    append: Native.Element_append
	  });
	
	  PatchChildNode(internals, Element.prototype, {
	    before: Native.Element_before,
	    after: Native.Element_after,
	    replaceWith: Native.Element_replaceWith,
	    remove: Native.Element_remove
	  });
	};
	
	/**
	 * @license
	 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
	 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
	 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
	 * Code distributed by Google as part of the polymer project is also
	 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
	 */
	
	var priorCustomElements = window['customElements'];
	
	if (!priorCustomElements || priorCustomElements['forcePolyfill'] || typeof priorCustomElements['define'] != 'function' || typeof priorCustomElements['get'] != 'function') {
	  /** @type {!CustomElementInternals} */
	  var internals = new CustomElementInternals();
	
	  PatchHTMLElement(internals);
	  PatchDocument(internals);
	  PatchNode(internals);
	  PatchElement(internals);
	
	  // The main document is always associated with the registry.
	  document.__CE_hasRegistry = true;
	
	  /** @type {!CustomElementRegistry} */
	  var customElements$1 = new CustomElementRegistry(internals);
	
	  Object.defineProperty(window, 'customElements', {
	    configurable: true,
	    enumerable: true,
	    value: customElements$1
	  });
	}
	
	/**
	 * @license
	 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
	 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
	 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
	 * Code distributed by Google as part of the polymer project is also
	 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
	 */
	// @version 0.7.22
	
	(function (global) {
	  if (global.JsMutationObserver) {
	    return;
	  }
	  var registrationsTable = new WeakMap();
	  var setImmediate;
	  if (/Trident|Edge/.test(navigator.userAgent)) {
	    setImmediate = setTimeout;
	  } else if (window.setImmediate) {
	    setImmediate = window.setImmediate;
	  } else {
	    var setImmediateQueue = [];
	    var sentinel = String(Math.random());
	    window.addEventListener("message", function (e) {
	      if (e.data === sentinel) {
	        var queue = setImmediateQueue;
	        setImmediateQueue = [];
	        queue.forEach(function (func) {
	          func();
	        });
	      }
	    });
	    setImmediate = function setImmediate(func) {
	      setImmediateQueue.push(func);
	      window.postMessage(sentinel, "*");
	    };
	  }
	  var isScheduled = false;
	  var scheduledObservers = [];
	  function scheduleCallback(observer) {
	    scheduledObservers.push(observer);
	    if (!isScheduled) {
	      isScheduled = true;
	      setImmediate(dispatchCallbacks);
	    }
	  }
	  function wrapIfNeeded(node) {
	    return window.ShadowDOMPolyfill && window.ShadowDOMPolyfill.wrapIfNeeded(node) || node;
	  }
	  function dispatchCallbacks() {
	    isScheduled = false;
	    var observers = scheduledObservers;
	    scheduledObservers = [];
	    observers.sort(function (o1, o2) {
	      return o1.uid_ - o2.uid_;
	    });
	    var anyNonEmpty = false;
	    observers.forEach(function (observer) {
	      var queue = observer.takeRecords();
	      removeTransientObserversFor(observer);
	      if (queue.length) {
	        observer.callback_(queue, observer);
	        anyNonEmpty = true;
	      }
	    });
	    if (anyNonEmpty) dispatchCallbacks();
	  }
	  function removeTransientObserversFor(observer) {
	    observer.nodes_.forEach(function (node) {
	      var registrations = registrationsTable.get(node);
	      if (!registrations) return;
	      registrations.forEach(function (registration) {
	        if (registration.observer === observer) registration.removeTransientObservers();
	      });
	    });
	  }
	  function forEachAncestorAndObserverEnqueueRecord(target, callback) {
	    for (var node = target; node; node = node.parentNode) {
	      var registrations = registrationsTable.get(node);
	      if (registrations) {
	        for (var j = 0; j < registrations.length; j++) {
	          var registration = registrations[j];
	          var options = registration.options;
	          if (node !== target && !options.subtree) continue;
	          var record = callback(options);
	          if (record) registration.enqueue(record);
	        }
	      }
	    }
	  }
	  var uidCounter = 0;
	  function JsMutationObserver(callback) {
	    this.callback_ = callback;
	    this.nodes_ = [];
	    this.records_ = [];
	    this.uid_ = ++uidCounter;
	  }
	  JsMutationObserver.prototype = {
	    observe: function observe(target, options) {
	      target = wrapIfNeeded(target);
	      if (!options.childList && !options.attributes && !options.characterData || options.attributeOldValue && !options.attributes || options.attributeFilter && options.attributeFilter.length && !options.attributes || options.characterDataOldValue && !options.characterData) {
	        throw new SyntaxError();
	      }
	      var registrations = registrationsTable.get(target);
	      if (!registrations) registrationsTable.set(target, registrations = []);
	      var registration;
	      for (var i = 0; i < registrations.length; i++) {
	        if (registrations[i].observer === this) {
	          registration = registrations[i];
	          registration.removeListeners();
	          registration.options = options;
	          break;
	        }
	      }
	      if (!registration) {
	        registration = new Registration(this, target, options);
	        registrations.push(registration);
	        this.nodes_.push(target);
	      }
	      registration.addListeners();
	    },
	    disconnect: function disconnect() {
	      this.nodes_.forEach(function (node) {
	        var registrations = registrationsTable.get(node);
	        for (var i = 0; i < registrations.length; i++) {
	          var registration = registrations[i];
	          if (registration.observer === this) {
	            registration.removeListeners();
	            registrations.splice(i, 1);
	            break;
	          }
	        }
	      }, this);
	      this.records_ = [];
	    },
	    takeRecords: function takeRecords() {
	      var copyOfRecords = this.records_;
	      this.records_ = [];
	      return copyOfRecords;
	    }
	  };
	  function MutationRecord(type, target) {
	    this.type = type;
	    this.target = target;
	    this.addedNodes = [];
	    this.removedNodes = [];
	    this.previousSibling = null;
	    this.nextSibling = null;
	    this.attributeName = null;
	    this.attributeNamespace = null;
	    this.oldValue = null;
	  }
	  function copyMutationRecord(original) {
	    var record = new MutationRecord(original.type, original.target);
	    record.addedNodes = original.addedNodes.slice();
	    record.removedNodes = original.removedNodes.slice();
	    record.previousSibling = original.previousSibling;
	    record.nextSibling = original.nextSibling;
	    record.attributeName = original.attributeName;
	    record.attributeNamespace = original.attributeNamespace;
	    record.oldValue = original.oldValue;
	    return record;
	  }
	  var currentRecord, recordWithOldValue;
	  function getRecord(type, target) {
	    return currentRecord = new MutationRecord(type, target);
	  }
	  function getRecordWithOldValue(oldValue) {
	    if (recordWithOldValue) return recordWithOldValue;
	    recordWithOldValue = copyMutationRecord(currentRecord);
	    recordWithOldValue.oldValue = oldValue;
	    return recordWithOldValue;
	  }
	  function clearRecords() {
	    currentRecord = recordWithOldValue = undefined;
	  }
	  function recordRepresentsCurrentMutation(record) {
	    return record === recordWithOldValue || record === currentRecord;
	  }
	  function selectRecord(lastRecord, newRecord) {
	    if (lastRecord === newRecord) return lastRecord;
	    if (recordWithOldValue && recordRepresentsCurrentMutation(lastRecord)) return recordWithOldValue;
	    return null;
	  }
	  function Registration(observer, target, options) {
	    this.observer = observer;
	    this.target = target;
	    this.options = options;
	    this.transientObservedNodes = [];
	  }
	  Registration.prototype = {
	    enqueue: function enqueue(record) {
	      var records = this.observer.records_;
	      var length = records.length;
	      if (records.length > 0) {
	        var lastRecord = records[length - 1];
	        var recordToReplaceLast = selectRecord(lastRecord, record);
	        if (recordToReplaceLast) {
	          records[length - 1] = recordToReplaceLast;
	          return;
	        }
	      } else {
	        scheduleCallback(this.observer);
	      }
	      records[length] = record;
	    },
	    addListeners: function addListeners() {
	      this.addListeners_(this.target);
	    },
	    addListeners_: function addListeners_(node) {
	      var options = this.options;
	      if (options.attributes) node.addEventListener("DOMAttrModified", this, true);
	      if (options.characterData) node.addEventListener("DOMCharacterDataModified", this, true);
	      if (options.childList) node.addEventListener("DOMNodeInserted", this, true);
	      if (options.childList || options.subtree) node.addEventListener("DOMNodeRemoved", this, true);
	    },
	    removeListeners: function removeListeners() {
	      this.removeListeners_(this.target);
	    },
	    removeListeners_: function removeListeners_(node) {
	      var options = this.options;
	      if (options.attributes) node.removeEventListener("DOMAttrModified", this, true);
	      if (options.characterData) node.removeEventListener("DOMCharacterDataModified", this, true);
	      if (options.childList) node.removeEventListener("DOMNodeInserted", this, true);
	      if (options.childList || options.subtree) node.removeEventListener("DOMNodeRemoved", this, true);
	    },
	    addTransientObserver: function addTransientObserver(node) {
	      if (node === this.target) return;
	      this.addListeners_(node);
	      this.transientObservedNodes.push(node);
	      var registrations = registrationsTable.get(node);
	      if (!registrations) registrationsTable.set(node, registrations = []);
	      registrations.push(this);
	    },
	    removeTransientObservers: function removeTransientObservers() {
	      var transientObservedNodes = this.transientObservedNodes;
	      this.transientObservedNodes = [];
	      transientObservedNodes.forEach(function (node) {
	        this.removeListeners_(node);
	        var registrations = registrationsTable.get(node);
	        for (var i = 0; i < registrations.length; i++) {
	          if (registrations[i] === this) {
	            registrations.splice(i, 1);
	            break;
	          }
	        }
	      }, this);
	    },
	    handleEvent: function handleEvent(e) {
	      e.stopImmediatePropagation();
	      switch (e.type) {
	        case "DOMAttrModified":
	          var name = e.attrName;
	          var namespace = e.relatedNode.namespaceURI;
	          var target = e.target;
	          var record = new getRecord("attributes", target);
	          record.attributeName = name;
	          record.attributeNamespace = namespace;
	          var oldValue = e.attrChange === MutationEvent.ADDITION ? null : e.prevValue;
	          forEachAncestorAndObserverEnqueueRecord(target, function (options) {
	            if (!options.attributes) return;
	            if (options.attributeFilter && options.attributeFilter.length && options.attributeFilter.indexOf(name) === -1 && options.attributeFilter.indexOf(namespace) === -1) {
	              return;
	            }
	            if (options.attributeOldValue) return getRecordWithOldValue(oldValue);
	            return record;
	          });
	          break;
	
	        case "DOMCharacterDataModified":
	          var target = e.target;
	          var record = getRecord("characterData", target);
	          var oldValue = e.prevValue;
	          forEachAncestorAndObserverEnqueueRecord(target, function (options) {
	            if (!options.characterData) return;
	            if (options.characterDataOldValue) return getRecordWithOldValue(oldValue);
	            return record;
	          });
	          break;
	
	        case "DOMNodeRemoved":
	          this.addTransientObserver(e.target);
	
	        case "DOMNodeInserted":
	          var changedNode = e.target;
	          var addedNodes, removedNodes;
	          if (e.type === "DOMNodeInserted") {
	            addedNodes = [changedNode];
	            removedNodes = [];
	          } else {
	            addedNodes = [];
	            removedNodes = [changedNode];
	          }
	          var previousSibling = changedNode.previousSibling;
	          var nextSibling = changedNode.nextSibling;
	          var record = getRecord("childList", e.target.parentNode);
	          record.addedNodes = addedNodes;
	          record.removedNodes = removedNodes;
	          record.previousSibling = previousSibling;
	          record.nextSibling = nextSibling;
	          forEachAncestorAndObserverEnqueueRecord(e.relatedNode, function (options) {
	            if (!options.childList) return;
	            return record;
	          });
	      }
	      clearRecords();
	    }
	  };
	  global.JsMutationObserver = JsMutationObserver;
	  if (!global.MutationObserver) {
	    global.MutationObserver = JsMutationObserver;
	    JsMutationObserver._isPolyfilled = true;
	  }
	})(self);
	
	/*
	Copyright (c) 2012 Barnesandnoble.com, llc, Donavon West, and Domenic Denicola
	
	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	*/
	(function (global, undefined) {
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var setImmediate;
	
	    function addFromSetImmediateArguments(args) {
	        tasksByHandle[nextHandle] = partiallyApplied.apply(undefined, args);
	        return nextHandle++;
	    }
	
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    function partiallyApplied(handler) {
	        var args = [].slice.call(arguments, 1);
	        return function () {
	            if (typeof handler === "function") {
	                handler.apply(undefined, args);
	            } else {
	                new Function("" + handler)();
	            }
	        };
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(partiallyApplied(runIfPresent, handle), 0);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    task();
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function installNextTickImplementation() {
	        setImmediate = function setImmediate() {
	            var handle = addFromSetImmediateArguments(arguments);
	            process.nextTick(partiallyApplied(runIfPresent, handle));
	            return handle;
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        setImmediate = function setImmediate() {
	            var handle = addFromSetImmediateArguments(arguments);
	            global.postMessage(messagePrefix + handle, "*");
	            return handle;
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        setImmediate = function setImmediate() {
	            var handle = addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        setImmediate = function setImmediate() {
	            var handle = addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        setImmediate = function setImmediate() {
	            var handle = addFromSetImmediateArguments(arguments);
	            setTimeout(partiallyApplied(runIfPresent, handle), 0);
	            return handle;
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(self);
	
	// Caution:
	// Do not replace this import statement with codes.
	//
	// If you replace this import statement with codes,
	// the codes will be executed after the following polyfills are imported
	// because import statements are hoisted during compilation.
	// Polyfill ECMAScript standard features with global namespace pollution
	// Polyfill Custom Elements v1 with global namespace pollution
	// Polyfill MutationObserver with global namespace pollution
	// Polyfill setImmediate with global namespace pollution
	
	(function () {
	  var DEFAULT_VIEWPORT = 'width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no';
	
	  var Viewport = {
	    ensureViewportElement: function ensureViewportElement() {
	      var viewportElement = document.querySelector('meta[name=viewport]');
	
	      if (!viewportElement) {
	        viewportElement = document.createElement('meta');
	        viewportElement.name = 'viewport';
	        document.head.appendChild(viewportElement);
	      }
	
	      return viewportElement;
	    },
	
	    setup: function setup() {
	      var viewportElement = Viewport.ensureViewportElement();
	
	      if (!viewportElement) {
	        return;
	      }
	
	      if (!viewportElement.hasAttribute('content')) {
	        viewportElement.setAttribute('content', DEFAULT_VIEWPORT);
	      }
	    }
	  };
	
	  window.Viewport = Viewport;
	})();
	
	function setup$1(ons) {
	  if (window._onsLoaded) {
	    ons._util.warn('Onsen UI is loaded more than once.');
	  }
	  window._onsLoaded = true;
	
	  // fastclick
	  window.addEventListener('load', function () {
	    ons.fastClick = fastclick_1.attach(document.body);
	
	    var supportTouchAction = 'touch-action' in document.body.style;
	
	    ons.platform._runOnActualPlatform(function () {
	      if (ons.platform.isAndroid()) {
	        // In Android4.4+, correct viewport settings can remove click delay.
	        // So disable FastClick on Android.
	        ons.fastClick.destroy();
	      } else if (ons.platform.isIOS()) {
	        if (supportTouchAction && (ons.platform.isIOSSafari() || ons.platform.isWKWebView())) {
	          // If 'touch-action' supported in iOS Safari or WKWebView, disable FastClick.
	          ons.fastClick.destroy();
	        } else {
	          // Do nothing. 'touch-action: manipulation' has no effect on UIWebView.
	        }
	      }
	    });
	  }, false);
	
	  ons.ready(function () {
	    ons.enableDeviceBackButtonHandler();
	    ons._defaultDeviceBackButtonHandler = ons._internal.dbbDispatcher.createHandler(window.document.body, function () {
	      if (Object.hasOwnProperty.call(navigator, 'app')) {
	        navigator.app.exitApp();
	      } else {
	        console.warn('Could not close the app. Is \'cordova.js\' included?\nError: \'window.navigator.app\' is undefined.');
	      }
	    });
	    document.body._gestureDetector = new ons.GestureDetector(document.body, { passive: true });
	
	    // Simulate Device Back Button on ESC press
	    if (!ons.platform.isWebView()) {
	      document.body.addEventListener('keydown', function (event) {
	        if (event.keyCode === 27) {
	          ons.fireDeviceBackButtonEvent();
	        }
	      });
	    }
	
	    // setup loading placeholder
	    ons._setupLoadingPlaceHolders();
	  });
	
	  // viewport.js
	  Viewport.setup();
	}
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	function getElementClass() {
	  if (typeof HTMLElement !== 'function') {
	    // case of Safari
	    var _BaseElement = function _BaseElement() {};
	    _BaseElement.prototype = document.createElement('div');
	    return _BaseElement;
	  } else {
	    return HTMLElement;
	  }
	}
	
	var BaseElement = function (_getElementClass) {
	  inherits(BaseElement, _getElementClass);
	
	  function BaseElement() {
	    classCallCheck(this, BaseElement);
	    return possibleConstructorReturn(this, (BaseElement.__proto__ || Object.getPrototypeOf(BaseElement)).call(this));
	  }
	
	  return BaseElement;
	}(getElementClass());
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-template
	 * @category util
	 * @description
	 *   [en]
	 *     Define a separate HTML fragment and use as a template. These templates can be loaded as pages in `<ons-navigator>`, `<ons-tabbar>` and `<ons-splitter>`. They can also be used to generate dialogs. Since Onsen UI 2.4.0, the native `<template>` element can be used instead of `<ons-template>` for better performance and features. `<ons-template>` is still supported for backward compatibility.
	 *   [/en]
	 *   [ja]テンプレートとして使用するためのHTMLフラグメントを定義します。この要素でHTMLを宣言すると、id属性に指定した名前をpageのURLとしてons-navigatorなどのコンポーネントから参照できます。[/ja]
	 * @seealso ons-navigator
	 *   [en]The `<ons-navigator>` component enables stack based navigation.[/en]
	 *   [ja][/ja]
	 * @seealso ons-tabbar
	 *   [en]The `<ons-tabbar>` component is used to add tab navigation.[/en]
	 *   [ja][/ja]
	 * @seealso ons-splitter
	 *   [en]The `<ons-splitter>` component can be used to create a draggable menu or column based layout.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-template id="foobar.html">
	 *   <ons-page>
	 *     Page content
	 *   </ons-page>
	 * </ons-template>
	 *
	 * <ons-navigator page="foobar.html"></ons-navigator>
	 */
	
	var TemplateElement = function (_BaseElement) {
	  inherits(TemplateElement, _BaseElement);
	
	  /**
	   * @property template
	   * @type {String}
	   * @description
	   *  [en]Template content. This property can not be used with AngularJS bindings.[/en]
	   *  [ja][/ja]
	   */
	
	  function TemplateElement() {
	    classCallCheck(this, TemplateElement);
	
	    var _this = possibleConstructorReturn(this, (TemplateElement.__proto__ || Object.getPrototypeOf(TemplateElement)).call(this));
	
	    _this.template = _this.innerHTML;
	
	    while (_this.firstChild) {
	      _this.removeChild(_this.firstChild);
	    }
	    return _this;
	  }
	
	  createClass(TemplateElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      if (this.parentNode) {
	        // Note: this.parentNode is not set in some CE0/CE1 polyfills.
	        // Show warning when the ons-template is not located just under document.body
	        if (this.parentNode !== document.body) {
	          // if the parent is not document.body
	          util.warn('ons-template (id = ' + this.getAttribute('id') + ') must be located just under document.body' + (this.parentNode.outerHTML ? ':\n\n' + this.parentNode.outerHTML : '.'));
	        }
	      }
	
	      var event = new CustomEvent('_templateloaded', { bubbles: true, cancelable: true });
	      event.template = this.template;
	      event.templateId = this.getAttribute('id');
	
	      this.dispatchEvent(event);
	    }
	  }]);
	  return TemplateElement;
	}(BaseElement);
	
	onsElements.Template = TemplateElement;
	customElements.define('ons-template', TemplateElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-if
	 * @category conditional
	 * @tutorial vanilla/Reference/if
	 * @description
	 *   [en]
	 *     Conditionally display content depending on the platform, device orientation or both.
	 *
	 *     Sometimes it is useful to conditionally hide or show certain components based on platform. When running on iOS the `<ons-if>` element can be used to hide the `<ons-fab>` element.
	 *   [/en]
	 *   [ja][/ja]
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja]Information about cross platform styling[/ja]
	 * @example
	 * <ons-page>
	 *   <ons-if orientation="landscape">
	 *     Landscape view!
	 *   </ons-if>
	 *   <ons-if platform="android">
	 *     This is Android.
	 *   </ons-if>
	 *   <ons-if platform="ios other">
	 *     This is not Android.
	 *   </ons-if>
	 * </ons-page>
	 */
	
	var IfElement = function (_BaseElement) {
	  inherits(IfElement, _BaseElement);
	
	  /**
	   * @attribute platform
	   * @initonly
	   * @type {string}
	   * @description
	   *  [en]Space-separated platform names. Possible values are `"ios"`, `"android"`, `"windows"` and `"other"`.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute orientation
	   * @type {string}
	   * @description
	   *  [en]Either `"portrait"` or `"landscape"`.[/en]
	   *  [ja]portraitもしくはlandscapeを指定します[/ja]
	   */
	
	  function IfElement() {
	    classCallCheck(this, IfElement);
	
	    var _this = possibleConstructorReturn(this, (IfElement.__proto__ || Object.getPrototypeOf(IfElement)).call(this));
	
	    contentReady(_this, function () {
	      if (platform._getSelectedPlatform() !== null) {
	        _this._platformUpdate();
	      } else if (!_this._isAllowedPlatform()) {
	        while (_this.childNodes[0]) {
	          _this.childNodes[0].remove();
	        }
	        _this._platformUpdate();
	      }
	    });
	
	    _this._onOrientationChange();
	    return _this;
	  }
	
	  createClass(IfElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      orientation.on('change', this._onOrientationChange.bind(this));
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name) {
	      if (name === 'orientation') {
	        this._onOrientationChange();
	      }
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      orientation.off('change', this._onOrientationChange);
	    }
	  }, {
	    key: '_platformUpdate',
	    value: function _platformUpdate() {
	      this.style.display = this._isAllowedPlatform() ? '' : 'none';
	    }
	  }, {
	    key: '_isAllowedPlatform',
	    value: function _isAllowedPlatform() {
	      return !this.getAttribute('platform') || this.getAttribute('platform').split(/\s+/).indexOf(platform.getMobileOS()) >= 0;
	    }
	  }, {
	    key: '_onOrientationChange',
	    value: function _onOrientationChange() {
	      if (this.hasAttribute('orientation') && this._isAllowedPlatform()) {
	        var conditionalOrientation = this.getAttribute('orientation').toLowerCase();
	        var currentOrientation = orientation.isPortrait() ? 'portrait' : 'landscape';
	
	        this.style.display = conditionalOrientation === currentOrientation ? '' : 'none';
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['orientation'];
	    }
	  }]);
	  return IfElement;
	}(BaseElement);
	
	onsElements.If = IfElement;
	customElements.define('ons-if', IfElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var BaseAnimator = function () {
	
	  /**
	   * @param {Object} options
	   * @param {String} options.timing
	   * @param {Number} options.duration
	   * @param {Number} options.delay
	   */
	  function BaseAnimator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, BaseAnimator);
	
	    this.timing = options.timing || 'linear';
	    this.duration = options.duration || 0;
	    this.delay = options.delay || 0;
	  }
	
	  createClass(BaseAnimator, null, [{
	    key: 'extend',
	    value: function extend() {
	      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var extendedAnimator = this;
	      var newAnimator = function newAnimator() {
	        extendedAnimator.apply(this, arguments);
	        util.extend(this, properties);
	      };
	
	      newAnimator.prototype = this.prototype;
	      return newAnimator;
	    }
	  }]);
	  return BaseAnimator;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	// This object should not be exposed to users. Please keep this private.
	var iPhoneXPatch = {};
	
	iPhoneXPatch.isIPhoneXPortraitPatchActive = function () {
	  return document.documentElement.getAttribute('onsflag-iphonex-portrait') != null && window.innerWidth < window.innerHeight;
	};
	
	iPhoneXPatch.isIPhoneXLandscapePatchActive = function () {
	  // If width === height, treat it as landscape
	  return document.documentElement.getAttribute('onsflag-iphonex-landscape') != null && window.innerWidth >= window.innerHeight;
	};
	
	/**
	 * Returns the safe area lengths based on the current state of the safe areas.
	 */
	iPhoneXPatch.getSafeAreaLengths = function () {
	  var safeAreaLengths = void 0;
	  if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	    safeAreaLengths = {
	      top: 44,
	      right: 0,
	      bottom: 34,
	      left: 0
	    };
	  } else if (iPhoneXPatch.isIPhoneXLandscapePatchActive()) {
	    safeAreaLengths = {
	      top: 0,
	      right: 44,
	      bottom: 21,
	      left: 44
	    };
	  } else {
	    safeAreaLengths = {
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0
	    };
	  }
	
	  return safeAreaLengths;
	};
	
	/**
	 * Returns the safe area rect based on the current state of the safe areas.
	 */
	iPhoneXPatch.getSafeAreaDOMRect = function () {
	  var safeAreaRect = void 0;
	  if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	    safeAreaRect = {
	      x: 0,
	      y: 44, /* 0 + 44 (top safe area) */
	      width: window.innerWidth,
	      height: window.innerHeight - 78 /* height - 44 (top safe area) - 34 (bottom safe area) */
	    };
	  } else if (iPhoneXPatch.isIPhoneXLandscapePatchActive()) {
	    safeAreaRect = {
	      x: 44, /* 0 + 44 (left safe area) */
	      y: 0,
	      width: window.innerWidth - 88, /* width - 44 (left safe area) - 34 (right safe area) */
	      height: window.innerHeight - 21 /* height - 21 (bottom safe area) */
	    };
	  } else {
	    safeAreaRect = {
	      x: 0,
	      y: 0,
	      width: window.innerWidth,
	      height: window.innerHeight
	    };
	  }
	
	  return _extends({}, safeAreaRect, {
	    left: safeAreaRect.x,
	    top: safeAreaRect.y,
	    right: safeAreaRect.x + safeAreaRect.width,
	    bottom: safeAreaRect.y + safeAreaRect.height
	  });
	};
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var ActionSheetAnimator = function (_BaseAnimator) {
	  inherits(ActionSheetAnimator, _BaseAnimator);
	
	  function ActionSheetAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, ActionSheetAnimator);
	    return possibleConstructorReturn(this, (ActionSheetAnimator.__proto__ || Object.getPrototypeOf(ActionSheetAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} dialog
	   * @param {Function} done
	   */
	
	
	  createClass(ActionSheetAnimator, [{
	    key: 'show',
	    value: function show(dialog, done) {
	      done();
	    }
	
	    /**
	     * @param {HTMLElement} dialog
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, done) {
	      done();
	    }
	  }]);
	  return ActionSheetAnimator;
	}(BaseAnimator);
	
	/**
	 * Android style animator for Action Sheet.
	 */
	var MDActionSheetAnimator = function (_ActionSheetAnimator) {
	  inherits(MDActionSheetAnimator, _ActionSheetAnimator);
	
	  function MDActionSheetAnimator() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$timing = _ref2.timing,
	        timing = _ref2$timing === undefined ? 'ease' : _ref2$timing,
	        _ref2$delay = _ref2.delay,
	        delay = _ref2$delay === undefined ? 0 : _ref2$delay,
	        _ref2$duration = _ref2.duration,
	        duration = _ref2$duration === undefined ? 0.4 : _ref2$duration;
	
	    classCallCheck(this, MDActionSheetAnimator);
	
	    var _this2 = possibleConstructorReturn(this, (MDActionSheetAnimator.__proto__ || Object.getPrototypeOf(MDActionSheetAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this2.maskTiming = 'linear';
	    _this2.maskDuration = 0.2;
	    return _this2;
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(MDActionSheetAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.maskDuration,
	        timing: this.maskTiming
	      }), Animit(dialog._sheet).saveStyle().queue({
	        css: {
	          transform: 'translate3d(0, 80%, 0)',
	          opacity: 0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(0, 0, 0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.maskDuration,
	        timing: this.maskTiming
	      }), Animit(dialog._sheet).saveStyle().queue({
	        css: {
	          transform: 'translate3d(0, 0, 0)',
	          opacity: 1.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(0, 80%, 0)',
	          opacity: 0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	  }]);
	  return MDActionSheetAnimator;
	}(ActionSheetAnimator);
	
	/**
	 * iOS style animator for dialog.
	 */
	var IOSActionSheetAnimator = function (_ActionSheetAnimator2) {
	  inherits(IOSActionSheetAnimator, _ActionSheetAnimator2);
	
	  function IOSActionSheetAnimator() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$timing = _ref3.timing,
	        timing = _ref3$timing === undefined ? 'ease' : _ref3$timing,
	        _ref3$delay = _ref3.delay,
	        delay = _ref3$delay === undefined ? 0 : _ref3$delay,
	        _ref3$duration = _ref3.duration,
	        duration = _ref3$duration === undefined ? 0.3 : _ref3$duration;
	
	    classCallCheck(this, IOSActionSheetAnimator);
	
	    var _this3 = possibleConstructorReturn(this, (IOSActionSheetAnimator.__proto__ || Object.getPrototypeOf(IOSActionSheetAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this3.maskTiming = 'linear';
	    _this3.maskDuration = 0.2;
	    if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	      _this3.liftAmount = 'calc(100% + 48px)';
	    } else if (iPhoneXPatch.isIPhoneXLandscapePatchActive()) {
	      _this3.liftAmount = 'calc(100% + 33px)';
	    } else {
	      _this3.liftAmount = document.body.clientHeight / 2.0 - 1 + 'px'; // avoid Forced Synchronous Layout
	    }
	    return _this3;
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(IOSActionSheetAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.maskDuration,
	        timing: this.maskTiming
	      }), Animit(dialog._sheet).saveStyle().queue({
	        css: {
	          transform: 'translate3d(0, ' + this.liftAmount + ', 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(0, 0, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.maskDuration,
	        timing: this.maskTiming
	      }), Animit(dialog._sheet).saveStyle().queue({
	        css: {
	          transform: 'translate3d(0, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(0, ' + this.liftAmount + ', 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	  }]);
	  return IOSActionSheetAnimator;
	}(ActionSheetAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var BaseDialogElement = function (_BaseElement) {
	  inherits(BaseDialogElement, _BaseElement);
	  createClass(BaseDialogElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      throw new Error('_updateAnimatorFactory method must be implemented.');
	    }
	  }, {
	    key: '_toggleStyle',
	    value: function _toggleStyle(shouldShow) {
	      this.style.display = shouldShow ? 'block' : 'none';
	    }
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      throw new Error('_scheme getter must be implemented.');
	    }
	  }]);
	
	  function BaseDialogElement() {
	    classCallCheck(this, BaseDialogElement);
	
	    var _this = possibleConstructorReturn(this, (BaseDialogElement.__proto__ || Object.getPrototypeOf(BaseDialogElement)).call(this));
	
	    _this._visible = false;
	    _this._doorLock = new DoorLock();
	    _this._cancel = _this._cancel.bind(_this);
	    _this._selfCamelName = util.camelize(_this.tagName.slice(4));
	    _this._defaultDBB = function (e) {
	      return _this.cancelable ? _this._cancel() : e.callParentHandler();
	    };
	    _this._animatorFactory = _this._updateAnimatorFactory();
	    return _this;
	  }
	
	  createClass(BaseDialogElement, [{
	    key: '_cancel',
	    value: function _cancel() {
	      var _this2 = this;
	
	      if (this.cancelable && !this._running) {
	        this._running = true;
	        this.hide().then(function () {
	          _this2._running = false;
	          util.triggerElementEvent(_this2, 'dialog-cancel');
	        }, function () {
	          return _this2._running = false;
	        });
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return this._setVisible.apply(this, [true].concat(args));
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return this._setVisible.apply(this, [false].concat(args));
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return this._setVisible.apply(this, [!this.visible].concat(args));
	    }
	  }, {
	    key: '_setVisible',
	    value: function _setVisible(shouldShow) {
	      var _util$triggerElementE,
	          _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var action = shouldShow ? 'show' : 'hide';
	
	      options = _extends({}, options);
	      options.animationOptions = util.extend(options.animationOptions || {}, AnimatorFactory.parseAnimationOptionsString(this.getAttribute('animation-options')));
	
	      var canceled = false;
	      util.triggerElementEvent(this, 'pre' + action, (_util$triggerElementE = {}, defineProperty(_util$triggerElementE, this._selfCamelName, this), defineProperty(_util$triggerElementE, 'cancel', function cancel() {
	        return canceled = true;
	      }), _util$triggerElementE));
	
	      if (canceled) {
	        return Promise.reject('Canceled in pre' + action + ' event.');
	      }
	
	      return new Promise(function (resolve) {
	        _this3._doorLock.waitUnlock(function () {
	          var unlock = _this3._doorLock.lock();
	          var animator = _this3._animatorFactory.newAnimator(options);
	
	          shouldShow && _this3._toggleStyle(true, options);
	          _this3._visible = shouldShow;
	          util.iosPageScrollFix(shouldShow);
	
	          contentReady(_this3, function () {
	            animator[action](_this3, function () {
	              !shouldShow && _this3._toggleStyle(false, options);
	
	              unlock();
	
	              util.propagateAction(_this3, '_' + action);
	              util.triggerElementEvent(_this3, 'post' + action, defineProperty({}, _this3._selfCamelName, _this3)); // postshow posthide
	
	              if (options.callback instanceof Function) {
	                options.callback(_this3);
	              }
	
	              resolve(_this3);
	            });
	          });
	        });
	      });
	    }
	  }, {
	    key: '_updateMask',
	    value: function _updateMask() {
	      var _this4 = this;
	
	      contentReady(this, function () {
	        if (_this4._mask && _this4.getAttribute('mask-color')) {
	          _this4._mask.style.backgroundColor = _this4.getAttribute('mask-color');
	        }
	      });
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this5 = this;
	
	      this.onDeviceBackButton = this._defaultDBB.bind(this);
	
	      contentReady(this, function () {
	        if (_this5._mask) {
	          _this5._mask.addEventListener('click', _this5._cancel, false);
	          util.iosMaskScrollFix(_this5._mask, true);
	        }
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._backButtonHandler.destroy();
	      this._backButtonHandler = null;
	
	      if (this._mask) {
	        this._mask.removeEventListener('click', this._cancel, false);
	        util.iosMaskScrollFix(this._mask, false);
	      }
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, this._scheme);
	          break;
	        case 'animation':
	          this._animatorFactory = this._updateAnimatorFactory();
	          break;
	        case 'mask-color':
	          this._updateMask();
	          break;
	      }
	    }
	  }, {
	    key: 'onDeviceBackButton',
	    get: function get$$1() {
	      return this._backButtonHandler;
	    },
	    set: function set$$1(callback) {
	      if (this._backButtonHandler) {
	        this._backButtonHandler.destroy();
	      }
	
	      this._backButtonHandler = deviceBackButtonDispatcher.createHandler(this, callback);
	    }
	  }, {
	    key: 'visible',
	    get: function get$$1() {
	      return this._visible;
	    }
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }, {
	    key: 'cancelable',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'cancelable', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('cancelable');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'animation', 'mask-color'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['preshow', 'postshow', 'prehide', 'posthide', 'dialog-cancel'];
	    }
	  }]);
	  return BaseDialogElement;
	}(BaseElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme = {
	  '.action-sheet': 'action-sheet--*',
	  '.action-sheet-mask': 'action-sheet-mask--*',
	  '.action-sheet-title': 'action-sheet-title--*'
	};
	
	var _animatorDict = {
	  'default': function _default() {
	    return platform.isAndroid() ? MDActionSheetAnimator : IOSActionSheetAnimator;
	  },
	  'none': ActionSheetAnimator
	};
	
	/**
	 * @element ons-action-sheet
	 * @category dialog
	 * @description
	 *   [en]
	 *     Action/bottom sheet that is displayed on top of current screen.
	 *
	 *     This element can either be attached directly to the `<body>` or dynamically created from a template using the `ons.createElement(template, { append: true })` utility function and the `<template>` tag.
	 *
	 *     The action sheet is useful for displaying a list of options and asking the user to make a decision. A `ons-action-sheet-button` is provided for this purpose, although it can contain any type of content.
	 *
	 *     It will automatically be displayed as Material Design (bottom sheet) when running on an Android device.
	 *   [/en]
	 *   [ja]
	 *     アクションシート、もしくはボトムシートを現在のスクリーン上に表示します。
	 *
	 *     この要素は、`<body>`要素に直接アタッチされるか、もしくは`ons.createElement(template, { append: true })`と`<template>`タグを使ってテンプレートから動的に生成されます。
	 *
	 *     アクションシートは、選択肢のリストを表示してユーザーに尋ねるのに便利です。`ons-action-sheet-button`は、この要素の中に置くために提供されていますが、それ以外にも他のどのような要素を含むことができます。
	 *
	 *     Androidデバイスで実行されるときには、自動的にマテリアルデザイン(ボトムシート)として表示されます。
	 *   [/ja]
	 * @modifier material
	 *   [en]Display a Material Design bottom sheet.[/en]
	 *   [ja]マテリアルデザインのボトムシートを表示します。[/ja]
	 * @tutorial vanilla/reference/action-sheet
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @seealso ons-popover
	 *   [en]`<ons-popover>` component[/en]
	 *   [ja]ons-popoverコンポーネント[/ja]
	 * @seealso ons-modal
	 *   [en]`<ons-modal>` component[/en]
	 *   [ja]ons-modalコンポーネント[/ja]
	 * @example
	 * <ons-action-sheet id="sheet">
	 *   <ons-action-sheet-button>Label</ons-action-sheet-button>
	 *   <ons-action-sheet-button>Label</ons-action-sheet-button>
	 * </ons-action-sheet>
	 *
	 * <script>
	 *   document.getElementById('sheet').show();
	 * </script>
	 */
	
	var ActionSheetElement = function (_BaseDialogElement) {
	  inherits(ActionSheetElement, _BaseDialogElement);
	
	  /**
	   * @event preshow
	   * @description
	   * [en]Fired just before the action sheet is displayed.[/en]
	   * [ja]ダイアログが表示される直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.actionSheet
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the action sheet from being shown.[/en]
	   *   [ja]この関数を実行すると、ダイアログの表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event postshow
	   * @description
	   * [en]Fired just after the action sheet is displayed.[/en]
	   * [ja]ダイアログが表示された直後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.actionSheet
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event prehide
	   * @description
	   * [en]Fired just before the action sheet is hidden.[/en]
	   * [ja]ダイアログが隠れる直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.actionSheet
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the action sheet from being hidden.[/en]
	   *   [ja]この関数を実行すると、ダイアログの非表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event posthide
	   * @description
	   * [en]Fired just after the action sheet is hidden.[/en]
	   * [ja]ダイアログが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.actionSheet
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute title
	   * @type {String}
	   * @description
	   *  [en]Optional title of the action sheet. A new element will be created containing this string.[/en]
	   *  [ja]アクションシートのタイトルを指定します。ここで指定した文字列を含む新しい要素が作成されます。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the action sheet.[/en]
	   *  [ja]ダイアログの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute cancelable
	   * @description
	   *  [en]If this attribute is set the action sheet can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	   *  [ja]この属性が設定されると、アクションシートの背景やAndroidデバイスのバックボタンを推すことでアクションシートが閉じるようになります。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *  [en]If this attribute is set the action sheet is disabled.[/en]
	   *  [ja]この属性がある時、ダイアログはdisabled状態になります。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default default
	   * @description
	   *  [en]The animation used when showing and hiding the action sheet. Can be either `"none"` or `"default"`.[/en]
	   *  [ja]ダイアログを表示する際のアニメーション名を指定します。"none"もしくは"default"を指定できます。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`[/ja]
	   */
	
	  /**
	   * @attribute mask-color
	   * @type {String}
	   * @default rgba(0, 0, 0, 0.2)
	   * @description
	   *  [en]Color of the background mask. Default is `"rgba(0, 0, 0, 0.2)"`.[/en]
	   *  [ja]背景のマスクの色を指定します。"rgba(0, 0, 0, 0.2)"がデフォルト値です。[/ja]
	   */
	
	  function ActionSheetElement() {
	    classCallCheck(this, ActionSheetElement);
	
	    var _this = possibleConstructorReturn(this, (ActionSheetElement.__proto__ || Object.getPrototypeOf(ActionSheetElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ActionSheetElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      return new AnimatorFactory({
	        animators: _animatorDict,
	        baseClass: ActionSheetAnimator,
	        baseClassName: 'ActionSheetAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.style.display = 'none';
	      this.style.zIndex = 10001;
	
	      /* Expected result:
	       *   <ons-action-sheet>
	       *     <div class="action-sheet-mask"></div>
	       *     <div class="action-sheet">
	       *       <div class="action-sheet-title></div>
	       *       ...
	       *     </div>
	       *   </ons-action-sheet>
	       */
	
	      if (!this._sheet) {
	        var sheet = document.createElement('div');
	        sheet.classList.add('action-sheet');
	
	        while (this.firstChild) {
	          sheet.appendChild(this.firstChild);
	        }
	
	        this.appendChild(sheet);
	      }
	
	      if (!this._title && this.hasAttribute('title')) {
	        var title = document.createElement('div');
	        title.innerHTML = this.getAttribute('title');
	        title.classList.add('action-sheet-title');
	        this._sheet.insertBefore(title, this._sheet.firstChild);
	      }
	
	      if (!this._mask) {
	        var mask = document.createElement('div');
	        mask.classList.add('action-sheet-mask');
	        this.insertBefore(mask, this.firstChild);
	      }
	
	      this._sheet.style.zIndex = 20001;
	      this._mask.style.zIndex = 20000;
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	  }, {
	    key: '_updateTitle',
	    value: function _updateTitle() {
	      if (this._title) {
	        this._title.innerHTML = this.getAttribute('title');
	      }
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	    /**
	     * @method show
	     * @signature show([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"slide"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "slide"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}` [/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the action sheet has been revealed.[/en]
	     *   [ja]ダイアログが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *  [en]Show the action sheet.[/en]
	     *  [ja]ダイアログを開きます。[/ja]
	     * @return {Promise} Resolves to the displayed element.
	     */
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"slide"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "slide"のいずれかを指定できます。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This functions is called after the action sheet has been hidden.[/en]
	     *   [ja]ダイアログが隠れた後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Hide the action sheet.[/en]
	     *   [ja]ダイアログを閉じます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja]隠れた要素を解決します。[/ja]
	     */
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the action sheet is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the action sheet is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property cancelable
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the action sheet is cancelable or not. A cancelable action sheet can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	     *   [ja]アクションシートがキャンセル可能かどうかを設定します。キャンセル可能なアクションシートは、背景をタップしたりAndroidデバイスのバックボタンを推すことで閉じるようになります。[/ja]
	     */
	
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'title') {
	        this._updateTitle();
	      } else {
	        get(ActionSheetElement.prototype.__proto__ || Object.getPrototypeOf(ActionSheetElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	      }
	    }
	
	    /**
	     * @param {String} name
	     * @param {ActionSheetAnimator} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme;
	    }
	  }, {
	    key: '_mask',
	    get: function get$$1() {
	      return util.findChild(this, '.action-sheet-mask');
	    }
	  }, {
	    key: '_sheet',
	    get: function get$$1() {
	      return util.findChild(this, '.action-sheet');
	    }
	  }, {
	    key: '_title',
	    get: function get$$1() {
	      return this.querySelector('.action-sheet-title');
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof ActionSheetAnimator)) {
	        throw new Error('"Animator" param must inherit OnsActionSheetElement.ActionSheetAnimator');
	      }
	      _animatorDict[name] = Animator;
	    }
	  }, {
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(ActionSheetElement.__proto__ || Object.getPrototypeOf(ActionSheetElement), 'observedAttributes', this)), ['title']);
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict;
	    }
	  }, {
	    key: 'ActionSheetAnimator',
	    get: function get$$1() {
	      return ActionSheetAnimator;
	    }
	  }]);
	  return ActionSheetElement;
	}(BaseDialogElement);
	
	onsElements.ActionSheet = ActionSheetElement;
	customElements.define('ons-action-sheet', ActionSheetElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var BaseButtonElement = function (_BaseElement) {
	  inherits(BaseButtonElement, _BaseElement);
	  createClass(BaseButtonElement, [{
	    key: '_scheme',
	    get: function get$$1() {
	      throw new Error('_scheme getter must be implemented.');
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      throw new Error('_defaultClassName getter must be implemented.');
	    }
	  }, {
	    key: '_rippleOpt',
	    get: function get$$1() {
	      return [this];
	    }
	  }]);
	
	  function BaseButtonElement() {
	    classCallCheck(this, BaseButtonElement);
	
	    var _this = possibleConstructorReturn(this, (BaseButtonElement.__proto__ || Object.getPrototypeOf(BaseButtonElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(BaseButtonElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.classList.add(this._defaultClassName);
	
	      if (!this._icon && this.hasAttribute('icon')) {
	        util.checkMissingImport('Icon');
	        var icon = util.createElement('<ons-icon icon="' + this.getAttribute('icon') + '"></ons-icon>');
	        icon.classList.add(this._defaultClassName.replace('button', 'icon'));
	        this.insertBefore(icon, this.firstChild);
	      }
	
	      this._updateRipple();
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	  }, {
	    key: '_updateIcon',
	    value: function _updateIcon() {
	      if (this._icon) {
	        this._icon.setAttribute('icon', this.getAttribute('icon'));
	      }
	    }
	  }, {
	    key: '_updateRipple',
	    value: function _updateRipple() {
	      this._rippleOpt && util.updateRipple.apply(util, toConsumableArray(this._rippleOpt));
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, this._defaultClassName, this._scheme);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, this._scheme);
	          break;
	        case 'icon':
	          this._updateIcon();
	          break;
	        case 'ripple':
	          this.classList.contains(this._defaultClassName) && this._updateRipple();
	          break;
	      }
	    }
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }, {
	    key: '_icon',
	    get: function get$$1() {
	      return util.findChild(this, 'ons-icon');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class', 'icon', 'ripple'];
	    }
	  }]);
	  return BaseButtonElement;
	}(BaseElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-action-sheet-button
	 * @category dialog
	 * @modifier destructive
	 *   [en]Shows a "destructive" button (only for iOS).[/en]
	 *   [ja]"destructive"なボタンを表示します(iOSでのみ有効)。[/ja]
	 * @description
	 *   [en]Component that represent each button of the action sheet.[/en]
	 *   [ja]アクションシートに表示される各ボタンを表現するコンポーネントです。[/ja]
	 * @seealso ons-action-sheet
	 *   [en]The `<ons-action-sheet>` component[/en]
	 *   [ja]ons-action-sheetコンポーネント[/ja]
	 * @seealso ons-list-item
	 *   [en]The `<ons-list-item>` component[/en]
	 *   [ja]ons-list-itemコンポーネント[/ja]
	 * @seealso ons-icon
	 *   [en]The `<ons-icon>` component[/en]
	 *   [ja]ons-iconコンポーネント[/ja]
	 * @tutorial vanilla/Reference/action-sheet
	 * @guide appsize.html#removing-icon-packs [en]Removing icon packs.[/en][ja][/ja]
	 * @guide faq.html#how-can-i-use-custom-icon-packs [en]Adding custom icon packs.[/en][ja][/ja]
	 * @modifier material
	 *   [en]Display a Material Design action sheet button.[/en]
	 *   [ja]マテリアルデザインのアクションシート用のボタンを表示します。[/ja]
	 * @example
	 * <ons-action-sheet id="sheet">
	 *   <ons-action-sheet-button>Label</ons-action-sheet-button>
	 *   <ons-action-sheet-button>Label</ons-action-sheet-button>
	 * </ons-action-sheet>
	 *
	 * <script>
	 *   document.getElementById('sheet').show();
	 * </script>
	 */
	
	var ActionSheetButtonElement = function (_BaseButtonElement) {
	  inherits(ActionSheetButtonElement, _BaseButtonElement);
	
	  function ActionSheetButtonElement() {
	    classCallCheck(this, ActionSheetButtonElement);
	    return possibleConstructorReturn(this, (ActionSheetButtonElement.__proto__ || Object.getPrototypeOf(ActionSheetButtonElement)).apply(this, arguments));
	  }
	
	  createClass(ActionSheetButtonElement, [{
	    key: '_scheme',
	
	
	    /**
	     * @attribute icon
	     * @type {String}
	     * @description
	     *  [en]Creates an `ons-icon` component with this string. Only visible on Android. Check [See also](#seealso) section for more information.[/en]
	     *  [ja]`ons-icon`コンポーネントを悪性します。Androidでのみ表示されます。[/ja]
	     */
	
	    /**
	     * @attribute modifier
	     * @type {String}
	     * @description
	     *   [en]The appearance of the action sheet button.[/en]
	     *   [ja]アクションシートボタンの見た目を設定します。[/ja]
	     */
	
	    get: function get$$1() {
	      return {
	        '': 'action-sheet-button--*',
	        '.action-sheet-icon': 'action-sheet-icon--*'
	      };
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'action-sheet-button';
	    }
	  }, {
	    key: '_rippleOpt',
	    get: function get$$1() {
	      return undefined;
	    }
	  }]);
	  return ActionSheetButtonElement;
	}(BaseButtonElement);
	
	onsElements.ActionSheetButton = ActionSheetButtonElement;
	customElements.define('ons-action-sheet-button', ActionSheetButtonElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var AlertDialogAnimator = function (_BaseAnimator) {
	  inherits(AlertDialogAnimator, _BaseAnimator);
	
	  function AlertDialogAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, AlertDialogAnimator);
	    return possibleConstructorReturn(this, (AlertDialogAnimator.__proto__ || Object.getPrototypeOf(AlertDialogAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} dialog
	   * @param {Function} done
	   */
	
	
	  createClass(AlertDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, done) {
	      done();
	    }
	
	    /**
	     * @param {HTMLElement} dialog
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, done) {
	      done();
	    }
	  }]);
	  return AlertDialogAnimator;
	}(BaseAnimator);
	
	/**
	 * Android style animator for alert dialog.
	 */
	var AndroidAlertDialogAnimator = function (_AlertDialogAnimator) {
	  inherits(AndroidAlertDialogAnimator, _AlertDialogAnimator);
	
	  function AndroidAlertDialogAnimator() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$timing = _ref2.timing,
	        timing = _ref2$timing === undefined ? 'cubic-bezier(.1, .7, .4, 1)' : _ref2$timing,
	        _ref2$duration = _ref2.duration,
	        duration = _ref2$duration === undefined ? 0.2 : _ref2$duration,
	        _ref2$delay = _ref2.delay,
	        delay = _ref2$delay === undefined ? 0 : _ref2$delay;
	
	    classCallCheck(this, AndroidAlertDialogAnimator);
	    return possibleConstructorReturn(this, (AndroidAlertDialogAnimator.__proto__ || Object.getPrototypeOf(AndroidAlertDialogAnimator)).call(this, { duration: duration, timing: timing, delay: delay }));
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(AndroidAlertDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(0.9, 0.9, 1.0)',
	          opacity: 0.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(1.0, 1.0, 1.0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(1.0, 1.0, 1.0)',
	          opacity: 1.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(0.9, 0.9, 1.0)',
	          opacity: 0.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return AndroidAlertDialogAnimator;
	}(AlertDialogAnimator);
	
	/**
	 * iOS style animator for alert dialog.
	 */
	var IOSAlertDialogAnimator = function (_AlertDialogAnimator2) {
	  inherits(IOSAlertDialogAnimator, _AlertDialogAnimator2);
	
	  function IOSAlertDialogAnimator() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$timing = _ref3.timing,
	        timing = _ref3$timing === undefined ? 'cubic-bezier(.1, .7, .4, 1)' : _ref3$timing,
	        _ref3$duration = _ref3.duration,
	        duration = _ref3$duration === undefined ? 0.2 : _ref3$duration,
	        _ref3$delay = _ref3.delay,
	        delay = _ref3$delay === undefined ? 0 : _ref3$delay;
	
	    classCallCheck(this, IOSAlertDialogAnimator);
	    return possibleConstructorReturn(this, (IOSAlertDialogAnimator.__proto__ || Object.getPrototypeOf(IOSAlertDialogAnimator)).call(this, { duration: duration, timing: timing, delay: delay }));
	  }
	
	  /*
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(IOSAlertDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(1.3, 1.3, 1.0)',
	          opacity: 0.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0) scale3d(1.0, 1.0, 1.0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          opacity: 1.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          opacity: 0.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return IOSAlertDialogAnimator;
	}(AlertDialogAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$1 = {
	  '.alert-dialog': 'alert-dialog--*',
	  '.alert-dialog-container': 'alert-dialog-container--*',
	  '.alert-dialog-title': 'alert-dialog-title--*',
	  '.alert-dialog-content': 'alert-dialog-content--*',
	  '.alert-dialog-footer': 'alert-dialog-footer--*',
	  '.alert-dialog-footer--rowfooter': 'alert-dialog-footer--rowfooter--*',
	  '.alert-dialog-button--rowfooter': 'alert-dialog-button--rowfooter--*',
	  '.alert-dialog-button--primal': 'alert-dialog-button--primal--*',
	  '.alert-dialog-button': 'alert-dialog-button--*',
	  'ons-alert-dialog-button': 'alert-dialog-button--*',
	  '.alert-dialog-mask': 'alert-dialog-mask--*',
	  '.text-input': 'text-input--*'
	};
	
	var _animatorDict$1 = {
	  'none': AlertDialogAnimator,
	  'default': function _default() {
	    return platform.isAndroid() ? AndroidAlertDialogAnimator : IOSAlertDialogAnimator;
	  },
	  'fade': function fade() {
	    return platform.isAndroid() ? AndroidAlertDialogAnimator : IOSAlertDialogAnimator;
	  }
	};
	
	/**
	 * @element ons-alert-dialog
	 * @category dialog
	 * @description
	 *   [en]
	 *     Alert dialog that is displayed on top of the current screen. Useful for displaying questions, warnings or error messages to the user. The title, content and buttons can be easily customized and it will automatically switch style based on the platform.
	 *
	 *     To use the element it can either be attached directly to the `<body>` element or dynamically created from a template using the `ons.createAlertDialog(template)` utility function and the `<template>` tag.
	 *   [/en]
	 *   [ja]
	 *     現在のスクリーンの上に表示するアラートダイアログです。ユーザに対する問いかけ、警告、エラーメッセージを表示するのに利用できます。タイトルやコンテンツやボタンは簡単にカスタマイズでき、実行しているプラットフォームに併せてスタイルが自動的に切り替わります。
	 *   [/ja]
	 * @codepen Qwwxyp
	 * @tutorial vanilla/Reference/dialog
	 * @modifier material
	 *   [en]Material Design style[/en]
	 *   [ja]マテリアルデザインのスタイル[/ja]
	 * @modifier rowfooter
	 *   [en]Horizontally aligns the footer buttons.[/en]
	 *   [ja]フッターの複数のボタンを水平に配置[/ja]
	 * @seealso ons-dialog
	 *   [en]ons-dialog component[/en]
	 *   [ja]ons-dialogコンポーネント[/ja]
	 * @seealso ons-popover
	 *   [en]ons-popover component[/en]
	 *   [ja]ons-dialogコンポーネント[/ja]
	 * @seealso ons.notification
	 *   [en]Using ons.notification utility functions.[/en]
	 *   [ja]アラートダイアログを表示するには、ons.notificationオブジェクトのメソッドを使うこともできます。[/ja]
	 * @example
	 * <ons-alert-dialog id="alert-dialog">
	 *   <div class="alert-dialog-title">Warning!</div>
	 *   <div class="alert-dialog-content">
	 *     An error has occurred!
	 *   </div>
	 *   <div class="alert-dialog-footer">
	 *     <button id="alert-dialog-button" class="alert-dialog-button">OK</button>
	 *   </div>
	 * </ons-alert-dialog>
	 * <script>
	 *   document.getElementById('alert-dialog').show();
	 * </script>
	 */
	
	var AlertDialogElement = function (_BaseDialogElement) {
	  inherits(AlertDialogElement, _BaseDialogElement);
	
	  /**
	   * @event preshow
	   * @description
	   *   [en]Fired just before the alert dialog is displayed.[/en]
	   *   [ja]アラートダイアログが表示される直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.alertDialog
	   *   [en]Alert dialog object.[/en]
	   *   [ja]アラートダイアログのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute to stop the dialog from showing.[/en]
	   *   [ja]この関数を実行すると、アラートダイアログの表示を止めます。[/ja]
	   */
	
	  /**
	   * @event postshow
	   * @description
	   *   [en]Fired just after the alert dialog is displayed.[/en]
	   *   [ja]アラートダイアログが表示された直後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.alertDialog
	   *   [en]Alert dialog object.[/en]
	   *   [ja]アラートダイアログのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event prehide
	   * @description
	   *   [en]Fired just before the alert dialog is hidden.[/en]
	   *   [ja]アラートダイアログが隠れる直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.alertDialog
	   *   [en]Alert dialog object.[/en]
	   *   [ja]アラートダイアログのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute to stop the dialog from hiding.[/en]
	   *   [ja]この関数を実行すると、アラートダイアログが閉じようとするのを止めます。[/ja]
	   */
	
	  /**
	   * @event posthide
	   * @description
	   * [en]Fired just after the alert dialog is hidden.[/en]
	   * [ja]アラートダイアログが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.alertDialog
	   *   [en]Alert dialog object.[/en]
	   *   [ja]アラートダイアログのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja]ダイアログの見た目を指定します。[/ja]
	   */
	
	  /**
	   * @attribute cancelable
	   * @description
	   *  [en]If this attribute is set the dialog can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	   *  [ja]この属性を設定すると、ダイアログの背景をタップしたりAndroidデバイスのバックボタンを押すとダイアログが閉じるようになります。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *  [en]If this attribute is set the dialog is disabled.[/en]
	   *  [ja]この属性がある時、アラートダイアログはdisabled状態になります。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default default
	   * @description
	   *  [en]The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.[/en]
	   *  [ja]ダイアログを表示する際のアニメーション名を指定します。デフォルトでは"none"か"default"が指定できます。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。例：{duration: 0.2, delay: 1, timing: 'ease-in'}[/ja]
	   */
	
	  /**
	   * @attribute mask-color
	   * @type {String}
	   * @default rgba(0, 0, 0, 0.2)
	   * @description
	   *  [en]Color of the background mask. Default is "rgba(0, 0, 0, 0.2)".[/en]
	   *  [ja]背景のマスクの色を指定します。"rgba(0, 0, 0, 0.2)"がデフォルト値です。[/ja]
	   */
	
	  function AlertDialogElement() {
	    classCallCheck(this, AlertDialogElement);
	
	    var _this = possibleConstructorReturn(this, (AlertDialogElement.__proto__ || Object.getPrototypeOf(AlertDialogElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(AlertDialogElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      return new AnimatorFactory({
	        animators: _animatorDict$1,
	        baseClass: AlertDialogAnimator,
	        baseClassName: 'AlertDialogAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.style.display = 'none';
	      this.style.zIndex = 10001;
	
	      /**
	       * Expected result after compile:
	       *
	       * <ons-alert-dialog style="none">
	       *   <div class="alert-dialog-mask"></div>
	       *   <div class="alert-dialog">
	       *     <div class="alert-dialog-container">...</div>
	       *   </div>
	       * </ons-alert-dialog>
	       */
	
	      var content = document.createDocumentFragment();
	
	      if (!this._mask && !this._dialog) {
	        while (this.firstChild) {
	          content.appendChild(this.firstChild);
	        }
	      }
	
	      if (!this._mask) {
	        var mask = document.createElement('div');
	        mask.classList.add('alert-dialog-mask');
	        this.insertBefore(mask, this.children[0]);
	      }
	
	      if (!this._dialog) {
	        var dialog = document.createElement('div');
	        dialog.classList.add('alert-dialog');
	        this.insertBefore(dialog, null);
	      }
	
	      if (!util.findChild(this._dialog, '.alert-dialog-container')) {
	        var container = document.createElement('div');
	        container.classList.add('alert-dialog-container');
	        this._dialog.appendChild(container);
	      }
	
	      this._dialog.children[0].appendChild(content);
	
	      this._dialog.style.zIndex = 20001;
	      this._mask.style.zIndex = 20000;
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property cancelable
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the dialog is cancelable or not. A cancelable dialog can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	     *   [ja]そのダイアログがキャンセル可能かどうかを表します。キャンセル可能なダイアログは、背景をタップするかAndroidデバイスのバックボタンを押すことで閉じることが出来るようになります。[/ja]
	     */
	
	    /**
	     * @method show
	     * @signature show([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクトです。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"fade"` and `"none"`.[/en]
	     *   [ja]アニメーション名を指定します。指定できるのは、"fade", "none"のいずれかです。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. <code>{duration: 0.2, delay: 0.4, timing: 'ease-in'}</code> [/ja]
	     * @param {Function} [options.callback]
	     *   [en]Function to execute after the dialog has been revealed.[/en]
	     *   [ja]ダイアログが表示され終わった時に呼び出されるコールバックを指定します。[/ja]
	     * @description
	     *   [en]Show the alert dialog.[/en]
	     *   [ja]ダイアログを表示します。[/ja]
	     * @return {Promise}
	     *   [en]A `Promise` object that resolves to the displayed element.[/en]
	     *   [ja]表示される要素を解決する`Promise`オブジェクトを返します。[/ja]
	     */
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"fade"` and `"none"`.[/en]
	     *   [ja]アニメーション名を指定します。"fade", "none"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g.  <code>{duration: 0.2, delay: 0.4, timing: 'ease-in'}</code>[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. <code>{duration: 0.2, delay: 0.4, timing: 'ease-in'}</code> [/ja]
	     * @param {Function} [options.callback]
	     *   [en]Function to execute after the dialog has been hidden.[/en]
	     *   [ja]このダイアログが閉じた時に呼び出されるコールバックを指定します。[/ja]
	     * @description
	     *   [en]Hide the alert dialog.[/en]
	     *   [ja]ダイアログを閉じます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja]隠れた要素を解決する`Promise`オブジェクトを返します。[/ja]
	     */
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the dialog is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	    /**
	     * @param {String} name
	     * @param {DialogAnimator} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$1;
	    }
	
	    /**
	     * @return {Element}
	     */
	
	  }, {
	    key: '_mask',
	    get: function get$$1() {
	      return util.findChild(this, '.alert-dialog-mask');
	    }
	
	    /**
	     * @return {Element}
	     */
	
	  }, {
	    key: '_dialog',
	    get: function get$$1() {
	      return util.findChild(this, '.alert-dialog');
	    }
	
	    /**
	     * @return {Element}
	     */
	
	  }, {
	    key: '_titleElement',
	    get: function get$$1() {
	      return util.findChild(this._dialog.children[0], '.alert-dialog-title');
	    }
	
	    /**
	     * @return {Element}
	     */
	
	  }, {
	    key: '_contentElement',
	    get: function get$$1() {
	      return util.findChild(this._dialog.children[0], '.alert-dialog-content');
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof AlertDialogAnimator)) {
	        throw new Error('"Animator" param must inherit OnsAlertDialogElement.AlertDialogAnimator');
	      }
	      _animatorDict$1[name] = Animator;
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$1;
	    }
	  }, {
	    key: 'AlertDialogAnimator',
	    get: function get$$1() {
	      return AlertDialogAnimator;
	    }
	  }]);
	  return AlertDialogElement;
	}(BaseDialogElement);
	
	onsElements.AlertDialog = AlertDialogElement;
	customElements.define('ons-alert-dialog', AlertDialogElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-alert-dialog-button
	 * @modifier material
	 *   [en]Material Design alert-dialog button.[/en]
	 *   [ja]マテリアルデザインのボタンを表示します。[/ja]
	 * @description
	 *   [en][/en]
	 *   [ja][/ja]
	 * @seealso ons-alert-dialog
	 *   [en]The `<ons-alert-dialog>` component displays a alert dialog.[/en]
	 *   [ja]ons-alert-dialogコンポーネント[/ja]
	 * @example
	 *  <ons-alert-dialog>
	 *    <div class="alert-dialog-title">Warning!</div>
	 *    <div class="alert-dialog-content">
	 *      An error has occurred!
	 *    </div>
	 *    <div class="alert-dialog-footer">
	 *      <alert-dialog-button onclick="app.close()">Cancel</alert-dialog-button>
	 *      <alert-dialog-button class="alert-dialog-button" onclick="app.close()">OK</alert-dialog-button>
	 *    </div>
	 *  </ons-alert-dialog>
	 */
	
	var AlertDialogButtonElement = function (_BaseButtonElement) {
	  inherits(AlertDialogButtonElement, _BaseButtonElement);
	
	  function AlertDialogButtonElement() {
	    classCallCheck(this, AlertDialogButtonElement);
	    return possibleConstructorReturn(this, (AlertDialogButtonElement.__proto__ || Object.getPrototypeOf(AlertDialogButtonElement)).apply(this, arguments));
	  }
	
	  createClass(AlertDialogButtonElement, [{
	    key: '_scheme',
	
	
	    /**
	     * @attribute modifier
	     * @type {String}
	     * @description
	     *   [en]The appearance of the button.[/en]
	     *   [ja]ボタンの表現を指定します。[/ja]
	     */
	
	    /**
	     * @attribute disabled
	     * @description
	     *   [en]Specify if button should be disabled.[/en]
	     *   [ja]ボタンを無効化する場合は指定してください。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    get: function get$$1() {
	      return { '': 'alert-dialog-button--*' };
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'alert-dialog-button';
	    }
	  }, {
	    key: '_rippleOpt',
	    get: function get$$1() {
	      return [this, undefined, { 'modifier': 'light-gray' }];
	    }
	  }]);
	  return AlertDialogButtonElement;
	}(BaseButtonElement);
	
	onsElements.AlertDialogButton = AlertDialogButtonElement;
	customElements.define('ons-alert-dialog-button', AlertDialogButtonElement);
	
	var iosBackButtonIcon = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"13px\" height=\"21px\" viewBox=\"0 0 13 21\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>ios-back-button-icon</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"toolbar-back-button\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"ios\" transform=\"translate(-34.000000, -30.000000)\">\n            <polygon id=\"ios-back-button-icon\" points=\"34 40.5 44.5 30 46.5 32 38 40.5 46.5 49 44.5 51\"></polygon>\n        </g>\n    </g>\n</svg>\n";
	
	var mdBackButtonIcon = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>md-back-button-icon</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"toolbar-back-button\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"android\" transform=\"translate(-32.000000, -32.000000)\" fill-rule=\"nonzero\">\n            <polygon id=\"md-back-button-icon\" points=\"48 39 35.83 39 41.42 33.41 40 32 32 40 40 48 41.41 46.59 35.83 41 48 41\"></polygon>\n        </g>\n    </g>\n</svg>\n";
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName = 'back-button';
	
	var scheme$2 = {
	  '': 'back-button--*',
	  '.back-button__icon': 'back-button--*__icon',
	  '.back-button__label': 'back-button--*__label'
	};
	
	/**
	 * @element ons-back-button
	 * @category navigation
	 * @description
	 *   [en]
	 *     Back button component for `<ons-toolbar>`. Put it in the left part of the `<ons-toolbar>`.
	 *
	 *     It will find the parent `<ons-navigator>` element and pop a page when clicked. This behavior can be overriden by specifying the `onClick` property.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen aHmGL
	 * @tutorial vanilla/Reference/navigator
	 * @modifier material
	 *   [en]Material Design style[/en]
	 *   [ja][/ja]
	 * @seealso ons-toolbar
	 *   [en]ons-toolbar component[/en]
	 *   [ja]ons-toolbarコンポーネント[/ja]
	 * @seealso ons-navigator
	 *   [en]ons-navigator component[/en]
	 *   [ja]ons-navigatorコンポーネント[/ja]
	 * @example
	 * <ons-toolbar>
	 *   <div class="left">
	 *     <ons-back-button>Back</ons-back-button>
	 *   </div>
	 *   <div class="center">
	 *     Title
	 *   <div>
	 * </ons-toolbar>
	 */
	
	var BackButtonElement = function (_BaseElement) {
	  inherits(BackButtonElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the back button.[/en]
	   *  [ja]バックボタンの見た目を指定します。[/ja]
	   */
	
	  function BackButtonElement() {
	    classCallCheck(this, BackButtonElement);
	
	    var _this = possibleConstructorReturn(this, (BackButtonElement.__proto__ || Object.getPrototypeOf(BackButtonElement)).call(this));
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	
	    _this._options = {};
	    _this._boundOnClick = _this._onClick.bind(_this);
	    return _this;
	  }
	
	  createClass(BackButtonElement, [{
	    key: '_updateIcon',
	    value: function _updateIcon() {
	      var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : util.findChild(this, '.back-button__icon');
	
	      icon.innerHTML = autoStyle.getPlatform(this) === 'android' || util.hasModifier(this, 'material') ? mdBackButtonIcon : iosBackButtonIcon;
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.classList.add(defaultClassName);
	
	      if (!util.findChild(this, '.back-button__label')) {
	        var label = util.create('span.back-button__label');
	
	        while (this.childNodes[0]) {
	          label.appendChild(this.childNodes[0]);
	        }
	        this.appendChild(label);
	      }
	
	      if (!util.findChild(this, '.back-button__icon')) {
	        var icon = util.create('span.back-button__icon');
	        this._updateIcon(icon);
	
	        this.insertBefore(icon, this.children[0]);
	      }
	
	      util.updateRipple(this, undefined, { center: '', 'size': 'contain', 'background': 'transparent' });
	
	      ModifierUtil.initModifier(this, scheme$2);
	    }
	
	    /**
	     * @property options
	     * @type {Object}
	     * @description
	     *   [en]Options object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     */
	
	    /**
	     * @property options.animation
	     * @type {String}
	     * @description
	     *   [en]Animation name. Available animations are "slide", "lift", "fade" and "none".
	     *     These are platform based animations. For fixed animations, add "-ios" or "-md"
	     *     suffix to the animation name. E.g. "lift-ios", "lift-md". Defaults values are "slide-ios" and "fade-md".
	     *   [/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property options.animationOptions
	     * @type {String}
	     * @description
	     *   [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}` [/ja]
	     */
	
	    /**
	     * @property options.callback
	     * @type {String}
	     * @description
	     *   [en]Function that is called when the transition has ended.[/en]
	     *   [ja]このメソッドによる画面遷移が終了した際に呼び出される関数オブジェクトを指定します。[/ja]
	     */
	
	  }, {
	    key: '_onClick',
	
	
	    /**
	     * @property onClick
	     * @type {Function}
	     * @description
	     *   [en]Used to override the default back button behavior.[/en]
	     *   [ja][/ja]
	     */
	    value: function _onClick() {
	      if (this.onClick) {
	        this.onClick.apply(this);
	      } else {
	        var navigator = util.findParent(this, 'ons-navigator');
	        if (navigator) {
	          navigator.popPage(this.options);
	        }
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this.addEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName, scheme$2);
	          break;
	
	        case 'modifier':
	          {
	            ModifierUtil.onModifierChanged(last, current, this, scheme$2) && this._updateIcon();
	            break;
	          }
	      }
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this.removeEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.style.display = 'inline-block';
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.style.display = 'none';
	    }
	  }, {
	    key: 'options',
	    get: function get$$1() {
	      return this._options;
	    },
	    set: function set$$1(object) {
	      this._options = object;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return BackButtonElement;
	}(BaseElement);
	
	onsElements.BackButton = BackButtonElement;
	customElements.define('ons-back-button', BackButtonElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$1 = 'bottom-bar';
	var scheme$3 = { '': 'bottom-bar--*' };
	
	/**
	 * @element ons-bottom-toolbar
	 * @category page
	 * @description
	 *   [en]Toolbar component that is positioned at the bottom of the page. Since bottom toolbars are very versatile elements, `ons-bottom-toolbar` does not provide any specific layout syntax for its children. Modifiers or custom CSS must be used.[/en]
	 *   [ja]ページ下部に配置されるツールバー用コンポーネントです。[/ja]
	 * @modifier transparent
	 *   [en]Make the toolbar transparent.[/en]
	 *   [ja]ツールバーの背景を透明にして表示します。[/ja]
	 * @modifier aligned
	 *   [en]Vertically aligns its children and applies flexbox for block elements. `justify-content` CSS rule can be used to change horizontal align.[/en]
	 *   [ja]ツールバーの背景を透明にして表示します。[/ja]
	 * @seealso ons-toolbar [en]ons-toolbar component[/en][ja]ons-toolbarコンポーネント[/ja]
	 * @example
	 * <ons-bottom-toolbar>
	 *   Content
	 * </ons-bottom-toolbar>
	 */
	
	var BottomToolbarElement = function (_BaseElement) {
	  inherits(BottomToolbarElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the toolbar.[/en]
	   *   [ja]ツールバーの見た目の表現を指定します。[/ja]
	   */
	
	  function BottomToolbarElement() {
	    classCallCheck(this, BottomToolbarElement);
	
	    var _this = possibleConstructorReturn(this, (BottomToolbarElement.__proto__ || Object.getPrototypeOf(BottomToolbarElement)).call(this));
	
	    _this.classList.add(defaultClassName$1);
	    ModifierUtil.initModifier(_this, scheme$3);
	    return _this;
	  }
	
	  createClass(BottomToolbarElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      if (util.match(this.parentNode, 'ons-page')) {
	        this.parentNode.classList.add('page-with-bottom-toolbar');
	      }
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$1, scheme$3);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$3);
	          break;
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return BottomToolbarElement;
	}(BaseElement);
	
	onsElements.BottomToolbar = BottomToolbarElement;
	customElements.define('ons-bottom-toolbar', BottomToolbarElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-button
	 * @category form
	 * @modifier outline
	 *   [en]Button with outline and transparent background[/en]
	 *   [ja]アウトラインを持ったボタンを表示します。[/ja]
	 * @modifier light
	 *   [en]Button that doesn't stand out.[/en]
	 *   [ja]目立たないボタンを表示します。[/ja]
	 * @modifier quiet
	 *   [en]Button with no outline and or background..[/en]
	 *   [ja]枠線や背景が無い文字だけのボタンを表示します。[/ja]
	 * @modifier cta
	 *   [en]Button that really stands out.[/en]
	 *   [ja]目立つボタンを表示します。[/ja]
	 * @modifier large
	 *   [en]Large button that covers the width of the screen.[/en]
	 *   [ja]横いっぱいに広がる大きなボタンを表示します。[/ja]
	 * @modifier large--quiet
	 *   [en]Large quiet button.[/en]
	 *   [ja]横いっぱいに広がるquietボタンを表示します。[/ja]
	 * @modifier large--cta
	 *   [en]Large call to action button.[/en]
	 *   [ja]横いっぱいに広がるctaボタンを表示します。[/ja]
	 * @modifier material
	 *   [en]Material Design button[/en]
	 *   [ja]マテリアルデザインのボタン[/ja]
	 * @modifier material--flat
	 *   [en]Material Design flat button[/en]
	 *   [ja]マテリアルデザインのフラットボタン[/ja]
	 * @description
	 *   [en]
	 *     Button component. If you want to place a button in a toolbar, use `<ons-toolbar-button>` or `<ons-back-button>` instead.
	 *
	 *     Will automatically display as a Material Design button with a ripple effect on Android.
	 *   [/en]
	 *   [ja]ボタン用コンポーネント。ツールバーにボタンを設置する場合は、ons-toolbar-buttonもしくはons-back-buttonコンポーネントを使用します。[/ja]
	 * @codepen hLayx
	 * @tutorial vanilla/Reference/button
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja]Information about cross platform styling[/ja]
	 * @example
	 * <ons-button modifier="large--cta">
	 *   Tap Me
	 * </ons-button>
	 */
	
	var ButtonElement = function (_BaseButtonElement) {
	  inherits(ButtonElement, _BaseButtonElement);
	
	  function ButtonElement() {
	    classCallCheck(this, ButtonElement);
	    return possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
	  }
	
	  createClass(ButtonElement, [{
	    key: '_scheme',
	
	
	    /**
	     * @attribute modifier
	     * @type {String}
	     * @description
	     *  [en]The appearance of the button.[/en]
	     *  [ja]ボタンの表現を指定します。[/ja]
	     */
	
	    /**
	     * @attribute ripple
	     * @description
	     *  [en]If this attribute is defined, the button will have a ripple effect.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @attribute disabled
	     * @description
	     *   [en]Specify if button should be disabled.[/en]
	     *   [ja]ボタンを無効化する場合は指定します。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the button is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    get: function get$$1() {
	      return { '': 'button--*' };
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'button';
	    }
	  }]);
	  return ButtonElement;
	}(BaseButtonElement);
	
	onsElements.Button = ButtonElement;
	customElements.define('ons-button', ButtonElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$2 = 'card';
	var scheme$4 = {
	  '': 'card--*',
	  '.card__title': 'card--*__title',
	  '.card__content': 'card--*__content'
	};
	
	/**
	 * @element ons-card
	 * @category visual
	 * @modifier material
	 *   [en]A card with material design.[/en]
	 *   [ja]リストの上下のボーダーが無いリストを表示します。[/ja]
	 * @description
	 *   [en]
	 *    Component to create a card that displays some information.
	 *
	 *    The card may be composed by divs with specially prepared classes `title` and/or `content`. You can also add your own content as you please.[/en]
	 *   [ja][/ja]
	 * @tutorial vanilla/Reference/card
	 * @example
	 * <ons-card>
	 *   <p>Some content</p>
	 * </ons-card>
	 */
	
	var CardElement = function (_BaseElement) {
	  inherits(CardElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the card.[/en]
	   *   [ja]リストの表現を指定します。[/ja]
	   */
	
	  function CardElement() {
	    classCallCheck(this, CardElement);
	
	    var _this = possibleConstructorReturn(this, (CardElement.__proto__ || Object.getPrototypeOf(CardElement)).call(this));
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(CardElement, [{
	    key: '_compile',
	    value: function _compile() {
	      for (var i = 0; i < this.children.length; i++) {
	        var el = this.children[i];
	
	        if (el.classList.contains('title')) {
	          el.classList.add('card__title');
	          
	        } else if (el.classList.contains('content')) {
	          el.classList.add('card__content');
	          
	        }
	      }
	
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$2);
	      ModifierUtil.initModifier(this, scheme$4);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$2, scheme$4);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$4);
	          break;
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return CardElement;
	}(BaseElement);
	
	onsElements.Card = CardElement;
	customElements.define('ons-card', CardElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$5 = { '': 'carousel-item--*' };
	
	/**
	 * @element ons-carousel-item
	 * @category carousel
	 * @description
	 *   [en]
	 *     Carousel item component. Used as a child of the `<ons-carousel>` element.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen xbbzOQ
	 * @tutorial vanilla/Reference/carousel
	 * @seealso ons-carousel
	 *   [en]`<ons-carousel>` components[/en]
	 *   [ja]<ons-carousel>コンポーネント[/ja]
	 * @example
	 * <ons-carousel style="width: 100%; height: 200px">
	 *   <ons-carousel-item>
	 *    ...
	 *   </ons-carousel-item>
	 *   <ons-carousel-item>
	 *    ...
	 *   </ons-carousel-item>
	 * </ons-carousel>
	 */
	
	var CarouselItemElement = function (_BaseElement) {
	  inherits(CarouselItemElement, _BaseElement);
	
	  function CarouselItemElement() {
	    classCallCheck(this, CarouselItemElement);
	
	    var _this = possibleConstructorReturn(this, (CarouselItemElement.__proto__ || Object.getPrototypeOf(CarouselItemElement)).call(this));
	
	    _this.style.width = '100%';
	    ModifierUtil.initModifier(_this, scheme$5);
	    return _this;
	  }
	
	  createClass(CarouselItemElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'modifier') {
	        return ModifierUtil.onModifierChanged(last, current, this, scheme$5);
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier'];
	    }
	  }]);
	  return CarouselItemElement;
	}(BaseElement);
	
	onsElements.CarouselItem = CarouselItemElement;
	customElements.define('ons-carousel-item', CarouselItemElement);
	
	var directionMap = {
	  vertical: {
	    axis: 'Y',
	    size: 'Height',
	    dir: ['up', 'down'],
	    t3d: ['0px, ', 'px, 0px']
	  },
	  horizontal: {
	    axis: 'X',
	    size: 'Width',
	    dir: ['left', 'right'],
	    t3d: ['', 'px, 0px, 0px']
	  }
	};
	
	var Swiper = function () {
	  function Swiper(params) {
	    var _this = this;
	
	    classCallCheck(this, Swiper);
	
	    // Parameters
	    var FALSE = function FALSE() {
	      return false;
	    };
	    'getInitialIndex getBubbleWidth isVertical isOverScrollable isCentered\n    isAutoScrollable refreshHook preChangeHook postChangeHook overScrollHook'.split(/\s+/).forEach(function (key) {
	      return _this[key] = params[key] || FALSE;
	    });
	
	    this.getElement = params.getElement; // Required
	    this.scrollHook = params.scrollHook; // Optional
	    this.itemSize = params.itemSize || '100%';
	
	    this.getAutoScrollRatio = function () {
	      var ratio = params.getAutoScrollRatio && params.getAutoScrollRatio.apply(params, arguments);
	      ratio = typeof ratio === 'number' && ratio === ratio ? ratio : .5;
	      if (ratio < 0.0 || ratio > 1.0) {
	        throw new Error('Invalid auto-scroll-ratio ' + ratio + '. Must be between 0 and 1');
	      }
	      return ratio;
	    };
	
	    // Prevent clicks only on desktop
	    this.shouldBlock = util.globals.actualMobileOS === 'other';
	
	    // Bind handlers
	    this.onDragStart = this.onDragStart.bind(this);
	    this.onDrag = this.onDrag.bind(this);
	    this.onDragEnd = this.onDragEnd.bind(this);
	    this.onResize = this.onResize.bind(this);
	
	    this._shouldFixScroll = util.globals.actualMobileOS === 'ios';
	  }
	
	  createClass(Swiper, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          swipeable = _ref.swipeable,
	          autoRefresh = _ref.autoRefresh;
	
	      this.initialized = true;
	      this.target = this.getElement().children[0];
	      this.blocker = this.getElement().children[1];
	      if (!this.target || !this.blocker) {
	        throw new Error('Expected "target" and "blocker" elements to exist before initializing Swiper.');
	      }
	
	      if (!this.shouldBlock) {
	        this.blocker.style.display = 'none';
	      }
	
	      // Add classes
	      this.getElement().classList.add('ons-swiper');
	      this.target.classList.add('ons-swiper-target');
	      this.blocker.classList.add('ons-swiper-blocker');
	
	      // Setup listeners
	      this._gestureDetector = new GestureDetector(this.getElement(), { dragMinDistance: 1, dragLockToAxis: true, passive: !this._shouldFixScroll });
	      this._mutationObserver = new MutationObserver(function () {
	        return _this2.refresh();
	      });
	      this.updateSwipeable(swipeable);
	      this.updateAutoRefresh(autoRefresh);
	
	      // Setup initial layout
	      this._scroll = this._offset = this._lastActiveIndex = 0;
	      this._updateLayout();
	      this._setupInitialIndex();
	      setImmediate(function () {
	        return _this2.initialized && _this2._setupInitialIndex();
	      });
	
	      // Fix rendering glitch on Android 4.1
	      if (this.offsetHeight === 0) {
	        setImmediate(function () {
	          return _this2.refresh();
	        });
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.initialized = false;
	      this.updateSwipeable(false);
	      this.updateAutoRefresh(false);
	
	      this._gestureDetector && this._gestureDetector.dispose();
	      this.target = this.blocker = this._gestureDetector = this._mutationObserver = null;
	
	      this.setupResize(false);
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      var i = this._scroll / this.targetSize;
	      this._reset();
	      this.setActiveIndex(i);
	      this.refresh();
	    }
	  }, {
	    key: '_calculateItemSize',
	    value: function _calculateItemSize() {
	      var matches = this.itemSize.match(/^(\d+)(px|%)/);
	
	      if (!matches) {
	        throw new Error('Invalid state: swiper\'s size unit must be \'%\' or \'px\'');
	      }
	
	      var value = parseInt(matches[1], 10);
	      return matches[2] === '%' ? Math.round(value / 100 * this.targetSize) : value;
	    }
	  }, {
	    key: '_setupInitialIndex',
	    value: function _setupInitialIndex() {
	      this._reset();
	      this._lastActiveIndex = Math.max(Math.min(Number(this.getInitialIndex()), this.itemCount), 0);
	      this._scroll = this._offset + this.itemNumSize * this._lastActiveIndex;
	      this._scrollTo(this._scroll);
	    }
	  }, {
	    key: 'setActiveIndex',
	    value: function setActiveIndex(index) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      index = Math.max(0, Math.min(index, this.itemCount - 1));
	      var scroll = Math.max(0, Math.min(this.maxScroll, this._offset + this.itemNumSize * index));
	
	      if (platform.isUIWebView()) {
	        /* Dirty fix for #2231(https://github.com/OnsenUI/OnsenUI/issues/2231). begin */
	        var concat = function concat(arrayOfArray) {
	          return Array.prototype.concat.apply([], arrayOfArray);
	        };
	        var contents = concat(util.arrayFrom(this.target.children).map(function (page) {
	          return util.arrayFrom(page.children).filter(function (child) {
	            return child.classList.contains('page__content');
	          });
	        }));
	
	        var map = new Map();
	        return new Promise(function (resolve) {
	          contents.forEach(function (content) {
	            map.set(content, content.getAttribute('class'));
	            content.classList.add('page__content--suppress-layer-creation');
	          });
	          requestAnimationFrame(resolve);
	        }).then(function () {
	          return _this3._changeTo(scroll, options);
	        }).then(function () {
	          return new Promise(function (resolve) {
	            contents.forEach(function (content) {
	              content.setAttribute('class', map.get(content));
	            });
	            requestAnimationFrame(resolve);
	          });
	        });
	        /* end */
	      } else {
	        return this._changeTo(scroll, options);
	      }
	    }
	  }, {
	    key: 'getActiveIndex',
	    value: function getActiveIndex() {
	      var scroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._scroll;
	
	      scroll -= this._offset;
	      var count = this.itemCount,
	          size = this.itemNumSize;
	
	      if (this.itemNumSize === 0 || !util.isInteger(scroll)) {
	        return this._lastActiveIndex;
	      }
	
	      if (scroll <= 0) {
	        return 0;
	      }
	
	      for (var i = 0; i < count; i++) {
	        if (size * i <= scroll && size * (i + 1) > scroll) {
	          return i;
	        }
	      }
	
	      return count - 1;
	    }
	  }, {
	    key: 'setupResize',
	    value: function setupResize(add) {
	      window[(add ? 'add' : 'remove') + 'EventListener']('resize', this.onResize, true);
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.setupResize(true);
	      this.onResize();
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.setupResize(false);
	    }
	  }, {
	    key: 'updateSwipeable',
	    value: function updateSwipeable(shouldUpdate) {
	      if (this._gestureDetector) {
	        var action = shouldUpdate ? 'on' : 'off';
	        this._gestureDetector[action]('drag', this.onDrag);
	        this._gestureDetector[action]('dragstart', this.onDragStart);
	        this._gestureDetector[action]('dragend', this.onDragEnd);
	      }
	    }
	  }, {
	    key: 'updateAutoRefresh',
	    value: function updateAutoRefresh(shouldWatch) {
	      if (this._mutationObserver) {
	        shouldWatch ? this._mutationObserver.observe(this.target, { childList: true }) : this._mutationObserver.disconnect();
	      }
	    }
	  }, {
	    key: 'updateItemSize',
	    value: function updateItemSize(newSize) {
	      this.itemSize = newSize || '100%';
	      this.refresh();
	    }
	  }, {
	    key: 'toggleBlocker',
	    value: function toggleBlocker(block) {
	      this.blocker.style.pointerEvents = block ? 'auto' : 'none';
	    }
	  }, {
	    key: '_canConsumeGesture',
	    value: function _canConsumeGesture(gesture) {
	      var d = gesture.direction;
	      var isFirst = this._scroll === 0 && !this.isOverScrollable();
	      var isLast = this._scroll === this.maxScroll && !this.isOverScrollable();
	
	      return this.isVertical() ? d === 'down' && !isFirst || d === 'up' && !isLast : d === 'right' && !isFirst || d === 'left' && !isLast;
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      var _this4 = this;
	
	      this._ignoreDrag = event.consumed || !util.isValidGesture(event);
	
	      if (!this._ignoreDrag) {
	        var consume = event.consume;
	        event.consume = function () {
	          consume && consume();_this4._ignoreDrag = true;
	        };
	
	        if (this._canConsumeGesture(event.gesture)) {
	          var startX = event.gesture.center && event.gesture.center.clientX || 0,
	              distFromEdge = this.getBubbleWidth() || 0,
	              start = function start() {
	            consume && consume();
	            event.consumed = true;
	            _this4._started = true; // Avoid starting drag from outside
	            _this4.shouldBlock && _this4.toggleBlocker(true);
	            util.iosPreventScroll(_this4._gestureDetector);
	          };
	
	          // Let parent elements consume the gesture or consume it right away
	          startX < distFromEdge || startX > this.targetSize - distFromEdge ? setImmediate(function () {
	            return !_this4._ignoreDrag && start();
	          }) : start();
	        }
	      }
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(event) {
	      if (!event.gesture || this._ignoreDrag || !this._started) {
	        return;
	      }
	
	      this._continued = true; // Fix for random 'dragend' without 'drag'
	      event.stopPropagation();
	
	      this._scrollTo(this._scroll - this._getDelta(event), { throttle: true });
	    }
	  }, {
	    key: 'onDragEnd',
	    value: function onDragEnd(event) {
	      this._started = false;
	      if (!event.gesture || this._ignoreDrag || !this._continued) {
	        this._ignoreDrag = true; // onDragEnd might fire before onDragStart's setImmediate
	        return;
	      }
	
	      this._continued = false;
	      event.stopPropagation();
	
	      var scroll = this._scroll - this._getDelta(event);
	      var normalizedScroll = this._normalizeScroll(scroll);
	      scroll === normalizedScroll ? this._startMomentumScroll(scroll, event) : this._killOverScroll(normalizedScroll);
	      this.shouldBlock && this.toggleBlocker(false);
	    }
	  }, {
	    key: '_startMomentumScroll',
	    value: function _startMomentumScroll(scroll, event) {
	      var velocity = this._getVelocity(event),
	          matchesDirection = event.gesture.interimDirection === this.dM.dir[this._getDelta(event) < 0 ? 0 : 1];
	
	      var nextScroll = this._getAutoScroll(scroll, velocity, matchesDirection);
	      var duration = Math.abs(nextScroll - scroll) / (velocity + 0.01) / 1000;
	      duration = Math.min(.25, Math.max(.1, duration));
	
	      this._changeTo(nextScroll, { swipe: true, animationOptions: { duration: duration, timing: 'cubic-bezier(.4, .7, .5, 1)' } });
	    }
	  }, {
	    key: '_killOverScroll',
	    value: function _killOverScroll(scroll) {
	      var _this5 = this;
	
	      this._scroll = scroll;
	      var direction = this.dM.dir[Number(scroll > 0)];
	      var killOverScroll = function killOverScroll() {
	        return _this5._changeTo(scroll, { animationOptions: { duration: .4, timing: 'cubic-bezier(.1, .4, .1, 1)' } });
	      };
	      this.overScrollHook({ direction: direction, killOverScroll: killOverScroll }) || killOverScroll();
	    }
	  }, {
	    key: '_changeTo',
	    value: function _changeTo(scroll) {
	      var _this6 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var e = { activeIndex: this.getActiveIndex(scroll), lastActiveIndex: this._lastActiveIndex, swipe: options.swipe || false };
	      var change = e.activeIndex !== e.lastActiveIndex;
	      var canceled = change ? this.preChangeHook(e) : false;
	
	      this._scroll = canceled ? this._offset + e.lastActiveIndex * this.itemNumSize : scroll;
	      this._lastActiveIndex = canceled ? e.lastActiveIndex : e.activeIndex;
	
	      return this._scrollTo(this._scroll, options).then(function () {
	        if (scroll === _this6._scroll && !canceled) {
	          change && _this6.postChangeHook(e);
	        } else if (options.reject) {
	          return Promise.reject('Canceled');
	        }
	      });
	    }
	  }, {
	    key: '_scrollTo',
	    value: function _scrollTo(scroll) {
	      var _this7 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (options.throttle) {
	        var ratio = 0.35;
	        if (scroll < 0) {
	          scroll = this.isOverScrollable() ? Math.round(scroll * ratio) : 0;
	        } else {
	          var maxScroll = this.maxScroll;
	          if (maxScroll < scroll) {
	            scroll = this.isOverScrollable() ? maxScroll + Math.round((scroll - maxScroll) * ratio) : maxScroll;
	          }
	        }
	      }
	
	      var opt = options.animation === 'none' ? {} : options.animationOptions;
	      this.scrollHook && this.itemNumSize > 0 && this.scrollHook((scroll / this.itemNumSize).toFixed(2), options.animationOptions || {});
	
	      return new Promise(function (resolve) {
	        return Animit(_this7.target).queue({ transform: _this7._getTransform(scroll) }, opt).play(resolve);
	      });
	    }
	  }, {
	    key: '_getAutoScroll',
	    value: function _getAutoScroll(scroll, velocity, matchesDirection) {
	      var max = this.maxScroll,
	          offset = this._offset,
	          size = this.itemNumSize;
	
	      if (!this.isAutoScrollable()) {
	        return Math.max(0, Math.min(max, scroll));
	      }
	
	      var arr = [];
	      for (var s = offset; s < max; s += size) {
	        arr.push(s);
	      }
	      arr.push(max);
	
	      arr = arr.sort(function (left, right) {
	        return Math.abs(left - scroll) - Math.abs(right - scroll);
	      }).filter(function (item, pos) {
	        return !pos || item !== arr[pos - 1];
	      });
	
	      var result = arr[0];
	      var lastScroll = this._lastActiveIndex * size + offset;
	      var scrollRatio = Math.abs(scroll - lastScroll) / size;
	
	      if (scrollRatio <= this.getAutoScrollRatio(matchesDirection, velocity, size)) {
	        result = lastScroll;
	      } else {
	        if (scrollRatio < 1.0 && arr[0] === lastScroll && arr.length > 1) {
	          result = arr[1];
	        }
	      }
	      return Math.max(0, Math.min(max, result));
	    }
	  }, {
	    key: '_reset',
	    value: function _reset() {
	      this._targetSize = this._itemNumSize = undefined;
	    }
	  }, {
	    key: '_normalizeScroll',
	    value: function _normalizeScroll(scroll) {
	      return Math.max(Math.min(scroll, this.maxScroll), 0);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this._reset();
	      this._updateLayout();
	
	      if (util.isInteger(this._scroll)) {
	        var scroll = this._normalizeScroll(this._scroll);
	        scroll !== this._scroll ? this._killOverScroll(scroll) : this._changeTo(scroll);
	      } else {
	        this._setupInitialIndex();
	      }
	
	      this.refreshHook();
	    }
	  }, {
	    key: '_getDelta',
	    value: function _getDelta(event) {
	      return event.gesture['delta' + this.dM.axis];
	    }
	  }, {
	    key: '_getVelocity',
	    value: function _getVelocity(event) {
	      return event.gesture['velocity' + this.dM.axis];
	    }
	  }, {
	    key: '_getTransform',
	    value: function _getTransform(scroll) {
	      return 'translate3d(' + this.dM.t3d[0] + -scroll + this.dM.t3d[1] + ')';
	    }
	  }, {
	    key: '_updateLayout',
	    value: function _updateLayout() {
	      this.dM = directionMap[this.isVertical() ? 'vertical' : 'horizontal'];
	      this.target.classList.toggle('ons-swiper-target--vertical', this.isVertical());
	
	      for (var c = this.target.children[0]; c; c = c.nextElementSibling) {
	        c.style[this.dM.size.toLowerCase()] = this.itemSize;
	      }
	
	      if (this.isCentered()) {
	        this._offset = (this.targetSize - this.itemNumSize) / -2 || 0;
	      }
	    }
	  }, {
	    key: 'itemCount',
	    get: function get$$1() {
	      return this.target.children.length;
	    }
	  }, {
	    key: 'itemNumSize',
	    get: function get$$1() {
	      if (typeof this._itemNumSize !== 'number' || this._itemNumSize !== this._itemNumSize) {
	        this._itemNumSize = this._calculateItemSize();
	      }
	      return this._itemNumSize;
	    }
	  }, {
	    key: 'maxScroll',
	    get: function get$$1() {
	      var max = this.itemCount * this.itemNumSize - this.targetSize;
	      return Math.ceil(max < 0 ? 0 : max); // Need to return an integer value.
	    }
	  }, {
	    key: 'targetSize',
	    get: function get$$1() {
	      if (!this._targetSize) {
	        this._targetSize = this.target['offset' + this.dM.size];
	      }
	      return this._targetSize;
	    }
	  }]);
	  return Swiper;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-carousel
	 * @category carousel
	 * @description
	 *   [en]
	 *     Carousel component. A carousel can be used to display several items in the same space.
	 *
	 *     The component supports displaying content both horizontally and vertically. The user can scroll through the items by dragging and it can also be controller programmatically.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen xbbzOQ
	 * @tutorial vanilla/Reference/carousel
	 * @seealso ons-carousel-item
	 *   [en]`<ons-carousel-item>` component[/en]
	 *   [ja]ons-carousel-itemコンポーネント[/ja]
	 * @example
	 * <ons-carousel style="width: 100%; height: 200px">
	 *   <ons-carousel-item>
	 *    ...
	 *   </ons-carousel-item>
	 *   <ons-carousel-item>
	 *    ...
	 *   </ons-carousel-item>
	 * </ons-carousel>
	 */
	
	var CarouselElement = function (_BaseElement) {
	  inherits(CarouselElement, _BaseElement);
	
	  /**
	   * @event postchange
	   * @description
	   *   [en]Fired just after the current carousel item has changed.[/en]
	   *   [ja]現在表示しているカルーセルの要素が変わった時に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.carousel
	   *   [en]Carousel object.[/en]
	   *   [ja]イベントが発火したCarouselオブジェクトです。[/ja]
	   * @param {Number} event.activeIndex
	   *   [en]Current active index.[/en]
	   *   [ja]現在アクティブになっている要素のインデックス。[/ja]
	   * @param {Number} event.lastActiveIndex
	   *   [en]Previous active index.[/en]
	   *   [ja]以前アクティブだった要素のインデックス。[/ja]
	   */
	
	  /**
	   * @event refresh
	   * @description
	   *   [en]Fired when the carousel has been refreshed.[/en]
	   *   [ja]カルーセルが更新された時に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.carousel
	   *   [en]Carousel object.[/en]
	   *   [ja]イベントが発火したCarouselオブジェクトです。[/ja]
	   */
	
	  /**
	   * @event overscroll
	   * @description
	   *   [en]Fired when the carousel has been overscrolled.[/en]
	   *   [ja]カルーセルがオーバースクロールした時に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.carousel
	   *   [en]Fired when the carousel has been refreshed.[/en]
	   *   [ja]カルーセルが更新された時に発火します。[/ja]
	   * @param {Number} event.activeIndex
	   *   [en]Current active index.[/en]
	   *   [ja]現在アクティブになっている要素のインデックス。[/ja]
	   * @param {String} event.direction
	   *   [en]Can be one of either "up", "down", "left" or "right".[/en]
	   *   [ja]オーバースクロールされた方向が得られます。"up", "down", "left", "right"のいずれかの方向が渡されます。[/ja]
	   * @param {Function} event.waitToReturn
	   *   [en]Takes a <code>Promise</code> object as an argument. The carousel will not scroll back until the promise has been resolved or rejected.[/en]
	   *   [ja]この関数はPromiseオブジェクトを引数として受け取ります。渡したPromiseオブジェクトがresolveされるかrejectされるまで、カルーセルはスクロールバックしません。[/ja]
	   */
	
	  /**
	   * @attribute direction
	   * @type {String}
	   * @description
	   *   [en]The direction of the carousel. Can be either "horizontal" or "vertical". Default is "horizontal".[/en]
	   *   [ja]カルーセルの方向を指定します。"horizontal"か"vertical"を指定できます。"horizontal"がデフォルト値です。[/ja]
	   */
	
	  /**
	   * @attribute fullscreen
	   * @description
	   *   [en]If this attribute is set the carousel will cover the whole screen.[/en]
	   *   [ja]この属性があると、absoluteポジションを使ってカルーセルが自動的に画面いっぱいに広がります。[/ja]
	   */
	
	  /**
	   * @attribute overscrollable
	   * @description
	   *   [en]If this attribute is set the carousel will be scrollable over the edge. It will bounce back when released.[/en]
	   *   [ja]この属性がある時、タッチやドラッグで端までスクロールした時に、バウンドするような効果が当たります。[/ja]
	   */
	
	  /**
	   * @attribute centered
	   * @description
	   *   [en]If this attribute is set the carousel then the selected item will be in the center of the carousel instead of the beginning. Useful only when the items are smaller than the carousel. [/en]
	   *   [ja]この属性がある時、選んでいるons-carousel-itemはカルーセルの真ん中へ行きます。項目がカルーセルよりも小さい場合にのみ、これは便利です。[/ja]
	   */
	
	  /**
	   * @attribute item-width
	   * @type {String}
	   * @description
	   *    [en]ons-carousel-item's width. Only works when the direction is set to "horizontal".[/en]
	   *    [ja]ons-carousel-itemの幅を指定します。この属性は、direction属性に"horizontal"を指定した時のみ有効になります。[/ja]
	   */
	
	  /**
	   * @attribute item-height
	   * @type {String}
	   * @description
	   *   [en]ons-carousel-item's height. Only works when the direction is set to "vertical".[/en]
	   *   [ja]ons-carousel-itemの高さを指定します。この属性は、direction属性に"vertical"を指定した時のみ有効になります。[/ja]
	   */
	
	  /**
	   * @attribute auto-scroll
	   * @description
	   *   [en]If this attribute is set the carousel will be automatically scrolled to the closest item border when released.[/en]
	   *   [ja]この属性がある時、一番近いcarousel-itemの境界まで自動的にスクロールするようになります。[/ja]
	   */
	
	  /**
	   * @attribute auto-scroll-ratio
	   * @type {Number}
	   * @description
	   *    [en]A number between 0.0 and 1.0 that specifies how much the user must drag the carousel in order for it to auto scroll to the next item.[/en]
	   *    [ja]0.0から1.0までの値を指定します。カルーセルの要素をどれぐらいの割合までドラッグすると次の要素に自動的にスクロールするかを指定します。[/ja]
	   */
	
	  /**
	   * @attribute swipeable
	   * @description
	   *   [en]If this attribute is set the carousel can be scrolled by drag or swipe.[/en]
	   *   [ja]この属性がある時、カルーセルをスワイプやドラッグで移動できるようになります。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]If this attribute is set the carousel is disabled.[/en]
	   *   [ja]この属性がある時、dragやtouchやswipeを受け付けなくなります。[/ja]
	   */
	
	  /**
	   * @attribute initial-index
	   * @initonly
	   * @default 0
	   * @type {Number}
	   * @description
	   *   [en]Specify the index of the ons-carousel-item to show initially. Default is 0.[/en]
	   *   [ja]最初に表示するons-carousel-itemを0始まりのインデックスで指定します。デフォルト値は 0 です。[/ja]
	   */
	
	  /**
	   * @attribute auto-refresh
	   * @description
	   *   [en]When this attribute is set the carousel will automatically refresh when the number of child nodes change.[/en]
	   *   [ja]この属性がある時、子要素の数が変わるとカルーセルは自動的に更新されるようになります。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @description
	   *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *   [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *   [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。例：{duration: 0.2, delay: 1, timing: 'ease-in'}[/ja]
	   */
	
	  function CarouselElement() {
	    classCallCheck(this, CarouselElement);
	
	    var _this = possibleConstructorReturn(this, (CarouselElement.__proto__ || Object.getPrototypeOf(CarouselElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(CarouselElement, [{
	    key: '_compile',
	    value: function _compile() {
	      var target = this.children[0] && this.children[0].tagName !== 'ONS-CAROUSEL-ITEM' && this.children[0] || document.createElement('div');
	      if (!target.parentNode) {
	        while (this.firstChild) {
	          target.appendChild(this.firstChild);
	        }
	        this.appendChild(target);
	      }
	
	      !this.children[1] && this.appendChild(document.createElement('div'));
	
	      this.appendChild = this.appendChild.bind(target);
	      this.insertBefore = this.insertBefore.bind(target);
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      if (!this._swiper) {
	        this._swiper = new Swiper({
	          getElement: function getElement() {
	            return _this2;
	          },
	          getInitialIndex: function getInitialIndex() {
	            return _this2.getAttribute('initial-index');
	          },
	          getAutoScrollRatio: function getAutoScrollRatio() {
	            return _this2.autoScrollRatio;
	          },
	          isVertical: function isVertical() {
	            return _this2.vertical;
	          },
	          isOverScrollable: function isOverScrollable() {
	            return _this2.overscrollable;
	          },
	          isCentered: function isCentered() {
	            return _this2.centered;
	          },
	          isAutoScrollable: function isAutoScrollable() {
	            return _this2.autoScroll;
	          },
	          itemSize: this.itemSize,
	          overScrollHook: this._onOverScroll.bind(this),
	          preChangeHook: this._onChange.bind(this, 'prechange'),
	          postChangeHook: this._onChange.bind(this, 'postchange'),
	          refreshHook: this._onRefresh.bind(this),
	          scrollHook: function scrollHook() {
	            return _this2._onSwipe && _this2._onSwipe.apply(_this2, arguments);
	          }
	        });
	
	        contentReady(this, function () {
	          return _this2._swiper.init({
	            swipeable: _this2.hasAttribute('swipeable'),
	            autoRefresh: _this2.hasAttribute('auto-refresh')
	          });
	        });
	      }
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      if (this._swiper && this._swiper.initialized) {
	        this._swiper.dispose();
	        this._swiper = null;
	      }
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (!this._swiper) {
	        return;
	      }
	
	      switch (name) {
	        case 'swipeable':
	          this._swiper.updateSwipeable(this.hasAttribute('swipeable'));
	          break;
	        case 'auto-refresh':
	          this._swiper.updateAutoRefresh(this.hasAttribute('auto-refresh'));
	          break;
	        case 'item-height':
	          this.vertical && this._swiper.updateItemSize(this.itemSize);
	          break;
	        case 'item-width':
	          this.vertical || this._swiper.updateItemSize(this.itemSize);
	          break;
	        case 'direction':
	          this._swiper.refresh();
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      this._swiper.show();
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      this._swiper.hide();
	    }
	  }, {
	    key: '_onOverScroll',
	    value: function _onOverScroll(_ref) {
	      var direction = _ref.direction,
	          killOverScroll = _ref.killOverScroll;
	
	      var waitForAction = false;
	      util.triggerElementEvent(this, 'overscroll', {
	        carousel: this,
	        activeIndex: this.getActiveIndex(),
	        direction: direction,
	        waitToReturn: function waitToReturn(promise) {
	          waitForAction = true;
	          promise.then(killOverScroll);
	        }
	      });
	
	      return waitForAction;
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(eventName, _ref2) {
	      var activeIndex = _ref2.activeIndex,
	          lastActiveIndex = _ref2.lastActiveIndex;
	
	      util.triggerElementEvent(this, eventName, { carousel: this, activeIndex: activeIndex, lastActiveIndex: lastActiveIndex });
	    }
	  }, {
	    key: '_onRefresh',
	    value: function _onRefresh() {
	      util.triggerElementEvent(this, 'refresh', { carousel: this });
	    }
	
	    /**
	     * @method setActiveIndex
	     * @signature setActiveIndex(index, [options])
	     * @param {Number} index
	     *   [en]The index that the carousel should be set to.[/en]
	     *   [ja]carousel要素のインデックスを指定します。[/ja]
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja][/ja]
	     * @param {Function} [options.callback]
	     *   [en]A function that will be called after the animation is finished.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options.animationOptions]
	     *   [en]An object that can be used to specify duration, delay and timing function of the animation.[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Specify the index of the `<ons-carousel-item>` to show.[/en]
	     *   [ja]表示するons-carousel-itemをindexで指定します。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the carousel element.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'setActiveIndex',
	    value: function setActiveIndex(index) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) != 'object') {
	        throw new Error('options must be an object. You supplied ' + options);
	      }
	
	      options.animation = options.animation || this.getAttribute('animation');
	      options.animationOptions = util.extend({ duration: .3, timing: 'cubic-bezier(.4, .7, .5, 1)' }, options.animationOptions || {}, this.hasAttribute('animation-options') ? util.animationOptionsParse(this.getAttribute('animation-options')) : {});
	
	      return this._swiper.setActiveIndex(index, options).then(function () {
	        options.callback instanceof Function && options.callback(_this3);
	        return Promise.resolve(_this3);
	      });
	    }
	
	    /**
	     * @method getActiveIndex
	     * @signature getActiveIndex()
	     * @return {Number}
	     *   [en]The current carousel item index.[/en]
	     *   [ja]現在表示しているカルーセル要素のインデックスが返されます。[/ja]
	     * @description
	     *   [en]Returns the index of the currently visible `<ons-carousel-item>`.[/en]
	     *   [ja]現在表示されているons-carousel-item要素のインデックスを返します。[/ja]
	     */
	
	  }, {
	    key: 'getActiveIndex',
	    value: function getActiveIndex() {
	      return this._swiper.getActiveIndex();
	    }
	
	    /**
	     * @method next
	     * @signature next([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja][/ja]
	     * @param {Function} [options.callback]
	     *   [en]A function that will be executed after the animation has finished.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options.animationOptions]
	     *   [en]An object that can be used to specify the duration, delay and timing function of the animation.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the carousel element[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Show next `<ons-carousel-item>`.[/en]
	     *   [ja]次のons-carousel-itemを表示します。[/ja]
	     */
	
	  }, {
	    key: 'next',
	    value: function next(options) {
	      return this.setActiveIndex(this.getActiveIndex() + 1, options);
	    }
	
	    /**
	     * @method prev
	     * @signature prev([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja][/ja]
	     * @param {Function} [options.callback]
	     *   [en]A function that will be executed after the animation has finished.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options.animationOptions]
	     *   [en]An object that can be used to specify the duration, delay and timing function of the animation.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the carousel element[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Show previous `<ons-carousel-item>`.[/en]
	     *   [ja]前のons-carousel-itemを表示します。[/ja]
	     */
	
	  }, {
	    key: 'prev',
	    value: function prev(options) {
	      return this.setActiveIndex(this.getActiveIndex() - 1, options);
	    }
	
	    /**
	     * @method first
	     * @signature first()
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja][/ja]
	     * @param {Function} [options.callback]
	     *   [en]A function that will be executed after the animation has finished.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this is set to `"none"`, the transitions will not be animated.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options.animationOptions]
	     *   [en]An object that can be used to specify the duration, delay and timing function of the animation.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the carousel element[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Show first `<ons-carousel-item>`.[/en]
	     *   [ja]最初のons-carousel-itemを表示します。[/ja]
	     */
	
	  }, {
	    key: 'first',
	    value: function first(options) {
	      return this.setActiveIndex(0, options);
	    }
	
	    /**
	     * @method last
	     * @signature last()
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja][/ja]
	     * @param {Function} [options.callback]
	     *   [en]A function that will be executed after the animation has finished.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options.animationOptions]
	     *   [en]An object that can be used to specify the duration, delay and timing function of the animation.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the carousel element[/en]
	     *   [ja]Resolves to the carousel element[/ja]
	     * @description
	     *   [en]Show last ons-carousel item.[/en]
	     *   [ja]最後のons-carousel-itemを表示します。[/ja]
	     */
	
	  }, {
	    key: 'last',
	    value: function last(options) {
	      this.setActiveIndex(Math.max(this.itemCount - 1, 0), options);
	    }
	
	    /**
	     * @method refresh
	     * @signature refresh()
	     * @description
	     *   [en]Update the layout of the carousel. Used when adding `<ons-carousel-items>` dynamically or to automatically adjust the size.[/en]
	     *   [ja]レイアウトや内部の状態を最新のものに更新します。ons-carousel-itemを動的に増やしたり、ons-carouselの大きさを動的に変える際に利用します。[/ja]
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this._swiper.refresh();
	    }
	
	    /**
	     * @property itemCount
	     * @readonly
	     * @type {Number}
	     * @description
	     *   [en]The number of carousel items.[/en]
	     *   [ja]カルーセル要素の数です。[/ja]
	     */
	
	  }, {
	    key: 'itemCount',
	    get: function get$$1() {
	      return this._swiper.itemCount;
	    }
	
	    /**
	     * @property swipeable
	     * @type {Boolean}
	     * @description
	     *   [en]true if the carousel is swipeable.[/en]
	     *   [ja]swipeableであればtrueを返します。[/ja]
	     */
	
	  }, {
	    key: 'swipeable',
	    get: function get$$1() {
	      return this.hasAttribute('swipeable');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'swipeable', value);
	    }
	
	    /**
	     * @property onSwipe
	     * @type {Function}
	     * @description
	     *   [en]Hook called whenever the user slides the carousel. It gets a decimal index and an animationOptions object as arguments.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'onSwipe',
	    get: function get$$1() {
	      return this._onSwipe;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onSwipe\' must be a function.');
	      }
	      this._onSwipe = value;
	    }
	
	    /**
	     * @property autoScroll
	     * @type {Boolean}
	     * @description
	     *   [en]true if auto scroll is enabled.[/en]
	     *   [ja]オートスクロールが有効であればtrueを返します。[/ja]
	     */
	
	  }, {
	    key: 'autoScroll',
	    get: function get$$1() {
	      return this.hasAttribute('auto-scroll');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'auto-scroll', value);
	    }
	  }, {
	    key: 'vertical',
	    get: function get$$1() {
	      return this.getAttribute('direction') === 'vertical';
	    }
	  }, {
	    key: 'itemSize',
	    get: function get$$1() {
	      var itemSizeAttr = (this.getAttribute('item-' + (this.vertical ? 'height' : 'width')) || '').trim();
	      return itemSizeAttr.match(/^\d+(px|%)$/) ? itemSizeAttr : '100%';
	    }
	
	    /**
	     * @property autoScrollRatio
	     * @type {Number}
	     * @description
	     *   [en]The current auto scroll ratio. [/en]
	     *   [ja]現在のオートスクロールのratio値。[/ja]
	     */
	
	  }, {
	    key: 'autoScrollRatio',
	    get: function get$$1() {
	      return parseFloat(this.getAttribute('auto-scroll-ratio'));
	    },
	    set: function set$$1(ratio) {
	      this.setAttribute('auto-scroll-ratio', ratio);
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the carousel is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'disabled',
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    }
	
	    /**
	     * @property overscrollable
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the carousel is overscrollable or not.[/en]
	     *   [ja]overscrollできればtrueを返します。[/ja]
	     */
	
	  }, {
	    key: 'overscrollable',
	    get: function get$$1() {
	      return this.hasAttribute('overscrollable');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'overscrollable', value);
	    }
	
	    /**
	     * @property centered
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the carousel is centered or not.[/en]
	     *   [ja]centered状態になっていればtrueを返します。[/ja]
	     */
	
	  }, {
	    key: 'centered',
	    get: function get$$1() {
	      return this.hasAttribute('centered');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'centered', value);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['swipeable', 'auto-refresh', 'direction', 'item-height', 'item-width'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['postchange', 'refresh', 'overscroll'];
	    }
	  }]);
	  return CarouselElement;
	}(BaseElement);
	
	onsElements.Carousel = CarouselElement;
	customElements.define('ons-carousel', CarouselElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-col
	 * @category grid
	 * @description
	 *   [en]Represents a column in the grid system. Use with `<ons-row>` to layout components.[/en]
	 *   [ja]グリッドシステムにて列を定義します。ons-rowとともに使用し、コンポーネントのレイアウトに利用します。[/ja]
	 * @note
	 *   [en]For Android 4.3 and earlier, and iOS6 and earlier, when using mixed alignment with ons-row and ons-column, they may not be displayed correctly. You can use only one alignment.[/en]
	 *   [ja]Android 4.3以前、もしくはiOS 6以前のOSの場合、ons-rowとons-columnを組み合わせた場合に描画が崩れる場合があります。[/ja]
	 * @codepen GgujC {wide}
	 * @guide theming.html [en]Layouting guide[/en][ja]レイアウト機能[/ja]
	 * @seealso ons-row
	 *   [en]The `<ons-row>` component is the parent of `<ons-col>`.[/en]
	 *   [ja]ons-rowコンポーネント[/ja]
	 * @example
	 * <ons-row>
	 *   <ons-col width="50px"><ons-icon icon="fa-twitter"></ons-icon></ons-col>
	 *   <ons-col>Text</ons-col>
	 * </ons-row>
	 */
	
	/**
	 * @attribute vertical-align
	 * @type {String}
	 * @description
	 *   [en]Vertical alignment of the column. Valid values are "top", "center", and "bottom".[/en]
	 *   [ja]縦の配置を指定する。"top", "center", "bottom"のいずれかを指定します。[/ja]
	 */
	
	/**
	 * @attribute width
	 * @type {String}
	 * @description
	 *   [en]The width of the column. Valid values are css width values ("10%", "50px").[/en]
	 *   [ja]カラムの横幅を指定する。パーセントもしくはピクセルで指定します（10%や50px）。[/ja]
	 */
	
	var ColElement = function (_BaseElement) {
	  inherits(ColElement, _BaseElement);
	
	  function ColElement() {
	    classCallCheck(this, ColElement);
	
	    var _this = possibleConstructorReturn(this, (ColElement.__proto__ || Object.getPrototypeOf(ColElement)).call(this));
	
	    if (_this.getAttribute('width')) {
	      _this._updateWidth();
	    }
	    return _this;
	  }
	
	  createClass(ColElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'width') {
	        this._updateWidth();
	      }
	    }
	  }, {
	    key: '_updateWidth',
	    value: function _updateWidth() {
	      var width = this.getAttribute('width');
	      if (!width) {
	        styler.clear(this, 'flex maxWidth');
	      } else {
	        width = width.trim().match(/^\d+$/) ? width + '%' : width;
	
	        styler(this, {
	          flex: '0 0 ' + width,
	          maxWidth: width
	        });
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['width'];
	    }
	  }]);
	  return ColElement;
	}(BaseElement);
	
	onsElements.Col = ColElement;
	customElements.define('ons-col', ColElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var DialogAnimator = function (_BaseAnimator) {
	  inherits(DialogAnimator, _BaseAnimator);
	
	  function DialogAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, DialogAnimator);
	    return possibleConstructorReturn(this, (DialogAnimator.__proto__ || Object.getPrototypeOf(DialogAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} dialog
	   * @param {Function} done
	   */
	
	
	  createClass(DialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, done) {
	      done();
	    }
	
	    /**
	     * @param {HTMLElement} dialog
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, done) {
	      done();
	    }
	  }]);
	  return DialogAnimator;
	}(BaseAnimator);
	
	/**
	 * Android style animator for dialog.
	 */
	var AndroidDialogAnimator = function (_DialogAnimator) {
	  inherits(AndroidDialogAnimator, _DialogAnimator);
	
	  function AndroidDialogAnimator() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$timing = _ref2.timing,
	        timing = _ref2$timing === undefined ? 'ease-in-out' : _ref2$timing,
	        _ref2$delay = _ref2.delay,
	        delay = _ref2$delay === undefined ? 0 : _ref2$delay,
	        _ref2$duration = _ref2.duration,
	        duration = _ref2$duration === undefined ? 0.3 : _ref2$duration;
	
	    classCallCheck(this, AndroidDialogAnimator);
	    return possibleConstructorReturn(this, (AndroidDialogAnimator.__proto__ || Object.getPrototypeOf(AndroidDialogAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(AndroidDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -60%, 0)',
	          opacity: 0.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0)',
	          opacity: 1.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -60%, 0)',
	          opacity: 0.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return AndroidDialogAnimator;
	}(DialogAnimator);
	
	/**
	 * iOS style animator for dialog.
	 */
	var IOSDialogAnimator = function (_DialogAnimator2) {
	  inherits(IOSDialogAnimator, _DialogAnimator2);
	
	  function IOSDialogAnimator() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$timing = _ref3.timing,
	        timing = _ref3$timing === undefined ? 'ease-in-out' : _ref3$timing,
	        _ref3$delay = _ref3.delay,
	        delay = _ref3$delay === undefined ? 0 : _ref3$delay,
	        _ref3$duration = _ref3.duration,
	        duration = _ref3$duration === undefined ? 0.2 : _ref3$duration;
	
	    classCallCheck(this, IOSDialogAnimator);
	
	    var _this3 = possibleConstructorReturn(this, (IOSDialogAnimator.__proto__ || Object.getPrototypeOf(IOSDialogAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this3.bodyHeight = document.body.clientHeight; // avoid Forced Synchronous Layout
	    return _this3;
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(IOSDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, ' + (this.bodyHeight / 2.0 - 1) + 'px, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3d(-50%, -50%, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3d(-50%, ' + (this.bodyHeight / 2.0 - 1) + 'px, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return IOSDialogAnimator;
	}(DialogAnimator);
	
	/**
	 * Slide animator for dialog.
	 */
	var SlideDialogAnimator = function (_DialogAnimator3) {
	  inherits(SlideDialogAnimator, _DialogAnimator3);
	
	  function SlideDialogAnimator() {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$timing = _ref4.timing,
	        timing = _ref4$timing === undefined ? 'cubic-bezier(.1, .7, .4, 1)' : _ref4$timing,
	        _ref4$delay = _ref4.delay,
	        delay = _ref4$delay === undefined ? 0 : _ref4$delay,
	        _ref4$duration = _ref4.duration,
	        duration = _ref4$duration === undefined ? 0.2 : _ref4$duration;
	
	    classCallCheck(this, SlideDialogAnimator);
	
	    var _this4 = possibleConstructorReturn(this, (SlideDialogAnimator.__proto__ || Object.getPrototypeOf(SlideDialogAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this4.bodyHeight = document.body.clientHeight; // avoid Forced Synchronous Layout
	    return _this4;
	  }
	
	  /**
	   * @param {Object} dialog
	   * @param {Function} callback
	   */
	
	
	  createClass(SlideDialogAnimator, [{
	    key: 'show',
	    value: function show(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          // FIXME: This should avoid Forced Synchronous Layout. Otherwise, fade animation of mask will be broken.
	          transform: 'translate3d(-50%, ' + (-(this.bodyHeight / 2.0) + 1 - dialog._dialog.clientHeight) + 'px, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(-50%, -50%, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} dialog
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(dialog, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit.runAll(Animit(dialog._mask).queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(dialog._dialog).saveStyle().queue({
	        css: {
	          transform: 'translate3D(-50%, -50%, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          // FIXME: This should avoid Forced Synchronous Layout. Otherwise, fade animation of mask will be broken.
	          transform: 'translate3d(-50%, ' + (-(this.bodyHeight / 2.0) + 1 - dialog._dialog.clientHeight) + 'px, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return SlideDialogAnimator;
	}(DialogAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$6 = {
	  '.dialog': 'dialog--*',
	  '.dialog-container': 'dialog-container--*',
	  '.dialog-mask': 'dialog-mask--*'
	};
	
	var _animatorDict$2 = {
	  'default': function _default() {
	    return platform.isAndroid() ? AndroidDialogAnimator : IOSDialogAnimator;
	  },
	  'slide': SlideDialogAnimator,
	  'none': DialogAnimator
	};
	
	/**
	 * @element ons-dialog
	 * @category dialog
	 * @description
	 *   [en]
	 *     Dialog that is displayed on top of current screen. As opposed to the `<ons-alert-dialog>` element, this component can contain any kind of content.
	 *
	 *     To use the element it can either be attached directly to the `<body>` element or dynamically created from a template using the `ons.createDialog(template)` utility function and the `<template>` tag.
	 *
	 *     The dialog is useful for displaying menus, additional information or to ask the user to make a decision.
	 *
	 *     It will automatically be displayed as Material Design when running on an Android device.
	 *   [/en]
	 *   [ja][/ja]
	 * @modifier material
	 *   [en]Display a Material Design dialog.[/en]
	 *   [ja]マテリアルデザインのダイアログを表示します。[/ja]
	 * @codepen zxxaGa
	 * @tutorial vanilla/Reference/dialog
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @seealso ons-alert-dialog
	 *   [en]`<ons-alert-dialog>` component[/en]
	 *   [ja]ons-alert-dialogコンポーネント[/ja]
	 * @seealso ons-popover
	 *   [en]`<ons-popover>` component[/en]
	 *   [ja]ons-popoverコンポーネント[/ja]
	 * @seealso ons-modal
	 *   [en]`<ons-modal>` component[/en]
	 *   [ja]ons-modalコンポーネント[/ja]
	 * @example
	 * <ons-dialog id="dialog">
	 *   <p>This is a dialog!</p>
	 * </ons-dialog>
	 *
	 * <script>
	 *   document.getElementById('dialog').show();
	 * </script>
	 */
	
	var DialogElement = function (_BaseDialogElement) {
	  inherits(DialogElement, _BaseDialogElement);
	
	  /**
	   * @event preshow
	   * @description
	   * [en]Fired just before the dialog is displayed.[/en]
	   * [ja]ダイアログが表示される直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.dialog
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the dialog from being shown.[/en]
	   *   [ja]この関数を実行すると、ダイアログの表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event postshow
	   * @description
	   * [en]Fired just after the dialog is displayed.[/en]
	   * [ja]ダイアログが表示された直後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.dialog
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event prehide
	   * @description
	   * [en]Fired just before the dialog is hidden.[/en]
	   * [ja]ダイアログが隠れる直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.dialog
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the dialog from being hidden.[/en]
	   *   [ja]この関数を実行すると、ダイアログの非表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event posthide
	   * @description
	   * [en]Fired just after the dialog is hidden.[/en]
	   * [ja]ダイアログが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.dialog
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja]ダイアログの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute cancelable
	   * @description
	   *  [en]If this attribute is set the dialog can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *  [en]If this attribute is set the dialog is disabled.[/en]
	   *  [ja]この属性がある時、ダイアログはdisabled状態になります。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default default
	   * @description
	   *  [en]The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.[/en]
	   *  [ja]ダイアログを表示する際のアニメーション名を指定します。"none"もしくは"default"を指定できます。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`[/ja]
	   */
	
	  /**
	   * @attribute mask-color
	   * @type {String}
	   * @default rgba(0, 0, 0, 0.2)
	   * @description
	   *  [en]Color of the background mask. Default is `"rgba(0, 0, 0, 0.2)"`.[/en]
	   *  [ja]背景のマスクの色を指定します。"rgba(0, 0, 0, 0.2)"がデフォルト値です。[/ja]
	   */
	
	  function DialogElement() {
	    classCallCheck(this, DialogElement);
	
	    var _this = possibleConstructorReturn(this, (DialogElement.__proto__ || Object.getPrototypeOf(DialogElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(DialogElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      return new AnimatorFactory({
	        animators: _animatorDict$2,
	        baseClass: DialogAnimator,
	        baseClassName: 'DialogAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.style.display = 'none';
	      this.style.zIndex = 10001;
	
	      /* Expected result:
	       *   <ons-dialog>
	       *     <div class="dialog-mask"></div>
	       *     <div class="dialog">
	       *       <div class="dialog-container">...</div>
	       *     </div>
	       *   </ons-dialog>
	       */
	
	      if (!this._dialog) {
	        var dialog = document.createElement('div');
	        dialog.classList.add('dialog');
	
	        var container = document.createElement('div');
	        container.classList.add('dialog-container');
	        while (this.firstChild) {
	          container.appendChild(this.firstChild);
	        }
	        dialog.appendChild(container);
	
	        this.appendChild(dialog);
	      }
	
	      if (!this._mask) {
	        var mask = document.createElement('div');
	        mask.classList.add('dialog-mask');
	        this.insertBefore(mask, this.firstChild);
	      }
	
	      this._dialog.style.zIndex = 20001;
	      this._mask.style.zIndex = 20000;
	
	      this.setAttribute('status-bar-fill', '');
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	    /**
	     * @method show
	     * @signature show([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"slide"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "slide"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}` [/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the dialog has been revealed.[/en]
	     *   [ja]ダイアログが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *  [en]Show the dialog.[/en]
	     *  [ja]ダイアログを開きます。[/ja]
	     * @return {Promise} Resolves to the displayed element.
	     */
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"slide"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "slide"のいずれかを指定できます。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This functions is called after the dialog has been hidden.[/en]
	     *   [ja]ダイアログが隠れた後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Hide the dialog.[/en]
	     *   [ja]ダイアログを閉じます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the dialog is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the dialog is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property cancelable
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the dialog is cancelable or not. A cancelable dialog can be closed by tapping the background or by pressing the back button on Android devices.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @param {String} name
	     * @param {DialogAnimator} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$6;
	    }
	  }, {
	    key: '_mask',
	    get: function get$$1() {
	      return util.findChild(this, '.dialog-mask');
	    }
	  }, {
	    key: '_dialog',
	    get: function get$$1() {
	      return util.findChild(this, '.dialog');
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof DialogAnimator)) {
	        throw new Error('"Animator" param must inherit OnsDialogElement.DialogAnimator');
	      }
	      _animatorDict$2[name] = Animator;
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$2;
	    }
	  }, {
	    key: 'DialogAnimator',
	    get: function get$$1() {
	      return DialogAnimator;
	    }
	  }]);
	  return DialogElement;
	}(BaseDialogElement);
	
	onsElements.Dialog = DialogElement;
	customElements.define('ons-dialog', DialogElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var defaultClassName$3 = 'fab';
	
	var scheme$7 = {
	  '': 'fab--*',
	  '.fab__icon': 'fab--*__icon'
	};
	
	/**
	 * @element ons-fab
	 * @category form
	 * @description
	 *   [en]
	 *     The Floating action button is a circular button defined in the [Material Design specification](https://www.google.com/design/spec/components/buttons-floating-action-button.html). They are often used to promote the primary action of the app.
	 *
	 *     It can be displayed either as an inline element or in one of the corners. Normally it will be positioned in the lower right corner of the screen.
	 *   [/en]
	 *   [ja][/ja]
	 * @tutorial vanilla/Reference/fab
	 * @modifier mini
	 *   [en]Makes the `ons-fab` smaller.[/en]
	 *   [ja][/ja]
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja]Information about cross platform styling[/ja]
	 * @seealso ons-speed-dial
	 *   [en]The `<ons-speed-dial>` component is a Floating action button that displays a menu when tapped.[/en]
	 *   [ja][/ja]
	 */
	
	var FabElement = function (_BaseElement) {
	  inherits(FabElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the button.[/en]
	   *  [ja]ボタンの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute ripple
	   * @description
	   *  [en]If this attribute is defined, the button will have a ripple effect when tapped.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute position
	   * @type {String}
	   * @description
	   *  [en]The position of the button. Should be a string like `"bottom right"` or `"top left"`. If this attribute is not defined it will be displayed as an inline element.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]Specify if button should be disabled.[/en]
	   *   [ja]ボタンを無効化する場合は指定します。[/ja]
	   */
	
	  function FabElement() {
	    classCallCheck(this, FabElement);
	
	    // The following statements can be executed before contentReady
	    // since these do not access the children
	    var _this = possibleConstructorReturn(this, (FabElement.__proto__ || Object.getPrototypeOf(FabElement)).call(this));
	
	    _this.hide();
	    _this.classList.add(defaultClassName$3);
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(FabElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      if (!util.findChild(this, '.fab__icon')) {
	        var content = document.createElement('span');
	        content.classList.add('fab__icon');
	
	        util.arrayFrom(this.childNodes).forEach(function (element) {
	          if (!element.tagName || element.tagName.toLowerCase() !== 'ons-ripple') {
	            content.appendChild(element);
	          }
	        });
	        this.appendChild(content);
	      }
	
	      this._updateRipple();
	
	      ModifierUtil.initModifier(this, scheme$7);
	
	      this._updatePosition();
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      setImmediate(function () {
	        return _this2.show();
	      });
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$3, scheme$7);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$7);
	          break;
	        case 'ripple':
	          this._updateRipple();
	          break;
	        case 'position':
	          this._updatePosition();
	          break;
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      this.show();
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var _this3 = this;
	
	      setImmediate(function () {
	        return _this3.hide();
	      });
	    }
	  }, {
	    key: '_updateRipple',
	    value: function _updateRipple() {
	      util.updateRipple(this);
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition() {
	      var position = this.getAttribute('position');
	      this.classList.remove('fab--top__left', 'fab--bottom__right', 'fab--bottom__left', 'fab--top__right', 'fab--top__center', 'fab--bottom__center');
	      switch (position) {
	        case 'top right':
	        case 'right top':
	          this.classList.add('fab--top__right');
	          break;
	        case 'top left':
	        case 'left top':
	          this.classList.add('fab--top__left');
	          break;
	        case 'bottom right':
	        case 'right bottom':
	          this.classList.add('fab--bottom__right');
	          break;
	        case 'bottom left':
	        case 'left bottom':
	          this.classList.add('fab--bottom__left');
	          break;
	        case 'center top':
	        case 'top center':
	          this.classList.add('fab--top__center');
	          break;
	        case 'center bottom':
	        case 'bottom center':
	          this.classList.add('fab--bottom__center');
	          break;
	        default:
	          break;
	      }
	    }
	
	    /**
	     * @method show
	     * @signature show()
	     * @description
	     *  [en]Show the floating action button.[/en]
	     *  [ja][/ja]
	     */
	
	  }, {
	    key: 'show',
	    value: function show() {
	      this.toggle(true);
	    }
	
	    /**
	     * @method hide
	     * @signature hide()
	     * @description
	     *  [en]Hide the floating action button.[/en]
	     *  [ja][/ja]
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.toggle(false);
	    }
	
	    /**
	     * @method toggle
	     * @signature toggle()
	     * @description
	     *   [en]Toggle the visibility of the button.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.visible;
	
	      var isBottom = (this.getAttribute('position') || '').indexOf('bottom') >= 0;
	      var translate = isBottom ? 'translate3d(0px, -' + (util.globals.fabOffset || 0) + 'px, 0px)' : '';
	
	      styler(this, { transform: translate + ' scale(' + Number(action) + ')' });
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'visible',
	    get: function get$$1() {
	      return this.style.transform.indexOf('scale(0)') === -1 && this.style.display !== 'none';
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'ripple', 'position', 'class'];
	    }
	  }]);
	  return FabElement;
	}(BaseElement);
	
	onsElements.Fab = FabElement;
	customElements.define('ons-fab', FabElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-gesture-detector
	 * @category gesture
	 * @description
	 *   [en]
	 *     Component to detect finger gestures within the wrapped element. Following gestures are supported:
	 *     - Drag gestures: `drag`, `dragleft`, `dragright`, `dragup`, `dragdown`
	 *     - Hold gestures: `hold`, `release`
	 *     - Swipe gestures: `swipe`, `swipeleft`, `swiperight`, `swipeup`, `swipedown`
	 *     - Tap gestures: `tap`, `doubletap`
	 *     - Pinch gestures: `pinch`, `pinchin`, `pinchout`
	 *     - Other gestures: `touch`, `transform`, `rotate`
	 *   [/en]
	 *   [ja]要素内のジェスチャー操作を検知します。詳しくはガイドを参照してください。[/ja]
	 * @guide features.html#gesture-detection
	 *   [en]Detecting finger gestures[/en]
	 *   [ja]ジェスチャー操作の検知[/ja]
	 * @example
	 * <ons-gesture-detector>
	 *   <div id="detect-area" style="width: 100px; height: 100px;">
	 *     Swipe Here
	 *   </div>
	 * </ons-gesture-detector>
	 *
	 * <script>
	 *   document.addEventListener('swipeleft', function(event) {
	 *     if (event.target.matches('#detect-area')) {
	 *       console.log('Swipe left is detected.');
	 *     }
	 *   });
	 * </script>
	 */
	
	var GestureDetectorElement = function (_BaseElement) {
	  inherits(GestureDetectorElement, _BaseElement);
	
	  function GestureDetectorElement() {
	    classCallCheck(this, GestureDetectorElement);
	
	    var _this = possibleConstructorReturn(this, (GestureDetectorElement.__proto__ || Object.getPrototypeOf(GestureDetectorElement)).call(this));
	
	    _this._gestureDetector = new GestureDetector(_this, { passive: true });
	    return _this;
	  }
	
	  return GestureDetectorElement;
	}(BaseElement);
	
	onsElements.GestureDetector = GestureDetectorElement;
	customElements.define('ons-gesture-detector', GestureDetectorElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var autoPrefix = 'fa'; // FIXME: To be removed in v3
	
	/**
	 * @element ons-icon
	 * @category visual
	 * @description
	 *   [en]
	 *     Displays an icon. The following icon suites are available:
	 *
	 *     * [Font Awesome](https://fortawesome.github.io/Font-Awesome/)
	 *     * [Ionicons](http://ionicons.com/)
	 *     * [Material Design Iconic Font](http://zavoloklom.github.io/material-design-iconic-font/)
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen xAhvg
	 * @tutorial vanilla/Reference/icon
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja][/ja]
	 * @guide appsize.html#removing-icon-packs [en]Removing icon packs.[/en][ja][/ja]
	 * @guide faq.html#how-can-i-use-custom-icon-packs [en]Adding custom icon packs.[/en][ja][/ja]
	 * @example
	 * <ons-icon
	 *   icon="md-car"
	 *   size="20px"
	 *   style="color: red">
	 * </ons-icon>
	 *
	 * <ons-button>
	 *   <ons-icon icon="md-car"></ons-icon>
	 *   Car
	 * </ons-button>
	 */
	
	var IconElement = function (_BaseElement) {
	  inherits(IconElement, _BaseElement);
	
	  /**
	   * @attribute icon
	   * @type {String}
	   * @description
	   *   [en]
	   *     The icon name. `"md-"` prefix for Material Icons, `"fa-"` for Font Awesome and `"ion-"` prefix for Ionicons.
	   *
	   *     See all available icons on the element description (at the top).
	   *
	   *     Icons can also be styled based on modifier presence. Add comma-separated icons with `"modifierName:"` prefix.
	   *
	   *     The code `<ons-icon icon="ion-edit, material:md-edit"></ons-icon>` will display `"md-edit"` for Material Design and `"ion-edit"` as the default icon.
	   *
	   *     `fa-` prefix is added automatically if none is provided. Check [See also](#seealso) section for more information.
	   *   [/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute size
	   * @type {String}
	   * @description
	   *   [en]
	   *     The sizes of the icon. Valid values are lg, 2x, 3x, 4x, 5x, or in the size in pixels.
	   *     Icons can also be styled based on modifier presence. Add comma-separated icons with `"modifierName:"` prefix.
	   *
	   *     The code:
	   *
	   *     ```
	   *     <ons-icon
	   *       icon="ion-edit"
	   *       size="32px, material:24px">
	   *     </ons-icon>
	   *     ```
	   *
	   *     will render as a `24px` icon if the `"material"` modifier is present and `32px` otherwise.
	   *   [/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute rotate
	   * @type {Number}
	   * @description
	   *   [en]Number of degrees to rotate the icon. Valid values are 90, 180 and 270.[/en]
	   *   [ja]アイコンを回転して表示します。90, 180, 270から指定できます。[/ja]
	   */
	
	  /**
	   * @attribute fixed-width
	   * @type {Boolean}
	   * @default false
	   * @description
	   *  [en]When used in a list, you want the icons to have the same width so that they align vertically by defining this attribute.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute spin
	   * @description
	   *   [en]Specify whether the icon should be spinning.[/en]
	   *   [ja]アイコンを回転するかどうかを指定します。[/ja]
	   */
	
	  function IconElement() {
	    classCallCheck(this, IconElement);
	
	    var _this = possibleConstructorReturn(this, (IconElement.__proto__ || Object.getPrototypeOf(IconElement)).call(this));
	
	    _this._compile();
	    return _this;
	  }
	
	  createClass(IconElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      this._cleanClassAttribute(name === 'icon' ? last : this.getAttribute('icon'), name === 'modifier' ? last : undefined);
	      this._update();
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this._update();
	    }
	  }, {
	    key: '_update',
	    value: function _update() {
	      var _this2 = this;
	
	      var _buildClassAndStyle2 = this._buildClassAndStyle(this._parseAttr('icon'), this._parseAttr('size')),
	          classList = _buildClassAndStyle2.classList,
	          style = _buildClassAndStyle2.style;
	
	      util.extend(this.style, style);
	
	      classList.forEach(function (className) {
	        return _this2.classList.add(className);
	      });
	    }
	  }, {
	    key: '_parseAttr',
	    value: function _parseAttr(attrName) {
	      var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getAttribute('modifier') || '';
	
	      var attr = this.getAttribute(attrName) || attrName || '';
	      var parts = attr.split(/\s*,\s*/);
	      var def = parts[0];
	      var md = parts[1];
	      md = (md || '').split(/\s*:\s*/);
	
	      return (modifier && RegExp('(^|\\s+)' + md[0] + '($|\\s+)', 'i').test(modifier) ? md[1] : def) || '';
	    }
	
	    /**
	     * Remove unneeded class value.
	     */
	
	  }, {
	    key: '_cleanClassAttribute',
	    value: function _cleanClassAttribute(lastIcon, lastModifier) {
	      var _this3 = this;
	
	      var _prefixIcon2 = this._prefixIcon(this._parseAttr(lastIcon, lastModifier)),
	          className = _prefixIcon2.className,
	          prefix = _prefixIcon2.prefix;
	
	      var customPrefixRE = className !== prefix ? '|' + prefix + '$|' + prefix + '-' : '|' + className + '$' || '';
	      var re = new RegExp('^(fa$|fa-|ion-|zmdi$|zmdi-|ons-icon--' + customPrefixRE + ')');
	
	      util.arrayFrom(this.classList).filter(function (className) {
	        return re.test(className);
	      }).forEach(function (className) {
	        return _this3.classList.remove(className);
	      });
	    }
	  }, {
	    key: '_prefixIcon',
	    value: function _prefixIcon(iconName) {
	      var className = autoPrefix + (autoPrefix ? '-' : '') + iconName;
	      return { className: className, prefix: className.split('-')[0] };
	    }
	  }, {
	    key: '_buildClassAndStyle',
	    value: function _buildClassAndStyle(iconName, size) {
	      var classList = ['ons-icon'];
	      var style = {};
	
	      // Icon
	      if (iconName.indexOf('ion-') === 0) {
	        classList.push(iconName);
	        classList.push('ons-icon--ion');
	      } else if (iconName.indexOf('fa-') === 0) {
	        classList.push(iconName);
	        classList.push('fa');
	      } else if (iconName.indexOf('md-') === 0) {
	        classList.push('zmdi');
	        classList.push('zmdi-' + iconName.split(/-(.+)?/)[1]);
	      } else {
	        var _prefixIcon3 = this._prefixIcon(iconName),
	            className = _prefixIcon3.className,
	            prefix = _prefixIcon3.prefix;
	
	        prefix && classList.push(prefix);
	        className && classList.push(className);
	      }
	
	      // Size
	      if (size.match(/^[1-5]x|lg$/)) {
	        classList.push('ons-icon--' + size);
	        this.style.removeProperty('font-size');
	      } else {
	        style.fontSize = size;
	      }
	
	      return {
	        classList: classList,
	        style: style
	      };
	    }
	  }], [{
	    key: 'setAutoPrefix',
	    value: function setAutoPrefix(prefix) {
	      autoPrefix = prefix ? typeof prefix === 'string' && prefix || 'fa' : '';
	    }
	  }, {
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['icon', 'size', 'modifier', 'class'];
	    }
	  }]);
	  return IconElement;
	}(BaseElement);
	
	onsElements.Icon = IconElement;
	customElements.define('ons-icon', IconElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var LazyRepeatDelegate = function () {
	  function LazyRepeatDelegate(userDelegate) {
	    var templateElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    classCallCheck(this, LazyRepeatDelegate);
	
	    if ((typeof userDelegate === 'undefined' ? 'undefined' : _typeof(userDelegate)) !== 'object' || userDelegate === null) {
	      throw Error('"delegate" parameter must be an object.');
	    }
	    this._userDelegate = userDelegate;
	
	    if (!(templateElement instanceof Element) && templateElement !== null) {
	      throw Error('"templateElement" parameter must be an instance of Element or null.');
	    }
	    this._templateElement = templateElement;
	  }
	
	  createClass(LazyRepeatDelegate, [{
	    key: 'hasRenderFunction',
	
	
	    /**
	     * @return {Boolean}
	     */
	    value: function hasRenderFunction() {
	      return this._userDelegate._render instanceof Function;
	    }
	
	    /**
	     * @return {void}
	     */
	
	  }, {
	    key: '_render',
	    value: function _render() {
	      this._userDelegate._render.apply(this._userDelegate, arguments);
	    }
	
	    /**
	     * @param {Number} index
	     * @param {Function} done A function that take item object as parameter.
	     */
	
	  }, {
	    key: 'loadItemElement',
	    value: function loadItemElement(index, done) {
	      if (this._userDelegate.loadItemElement instanceof Function) {
	        this._userDelegate.loadItemElement(index, done);
	      } else {
	        var element = this._userDelegate.createItemContent(index, this._templateElement);
	        if (!(element instanceof Element)) {
	          throw Error('createItemContent() must return an instance of Element.');
	        }
	
	        done({ element: element });
	      }
	    }
	
	    /**
	     * @return {Number}
	     */
	
	  }, {
	    key: 'countItems',
	    value: function countItems() {
	      var count = this._userDelegate.countItems();
	      if (typeof count !== 'number') {
	        throw Error('countItems() must return a number.');
	      }
	      return count;
	    }
	
	    /**
	     * @param {Number} index
	     * @param {Object} item
	     * @param {Element} item.element
	     */
	
	  }, {
	    key: 'updateItem',
	    value: function updateItem(index, item) {
	      if (this._userDelegate.updateItemContent instanceof Function) {
	        this._userDelegate.updateItemContent(index, item);
	      }
	    }
	
	    /**
	     * @return {Number}
	     */
	
	  }, {
	    key: 'calculateItemHeight',
	    value: function calculateItemHeight(index) {
	      if (this._userDelegate.calculateItemHeight instanceof Function) {
	        var height = this._userDelegate.calculateItemHeight(index);
	
	        if (typeof height !== 'number') {
	          throw Error('calculateItemHeight() must return a number.');
	        }
	
	        return height;
	      }
	
	      return 0;
	    }
	
	    /**
	     * @param {Number} index
	     * @param {Object} item
	     */
	
	  }, {
	    key: 'destroyItem',
	    value: function destroyItem(index, item) {
	      if (this._userDelegate.destroyItem instanceof Function) {
	        this._userDelegate.destroyItem(index, item);
	      }
	    }
	
	    /**
	     * @return {void}
	     */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this._userDelegate.destroy instanceof Function) {
	        this._userDelegate.destroy();
	      }
	
	      this._userDelegate = this._templateElement = null;
	    }
	  }, {
	    key: 'itemHeight',
	    get: function get$$1() {
	      return this._userDelegate.itemHeight;
	    }
	  }]);
	  return LazyRepeatDelegate;
	}();
	
	/**
	 * This class provide core functions for ons-lazy-repeat.
	 */
	var LazyRepeatProvider = function () {
	
	  /**
	   * @param {Element} wrapperElement
	   * @param {LazyRepeatDelegate} delegate
	   */
	  function LazyRepeatProvider(wrapperElement, delegate) {
	    classCallCheck(this, LazyRepeatProvider);
	
	    if (!(delegate instanceof LazyRepeatDelegate)) {
	      throw Error('"delegate" parameter must be an instance of LazyRepeatDelegate.');
	    }
	
	    this._wrapperElement = wrapperElement;
	    this._delegate = delegate;
	    this._insertIndex = this._wrapperElement.children[0] && this._wrapperElement.children[0].tagName === 'ONS-LAZY-REPEAT' ? 1 : 0;
	
	    if (wrapperElement.tagName.toLowerCase() === 'ons-list') {
	      wrapperElement.classList.add('lazy-list');
	    }
	
	    this._pageContent = this._findPageContentElement(wrapperElement);
	
	    if (!this._pageContent) {
	      throw new Error('ons-lazy-repeat must be a descendant of an <ons-page> or an element.');
	    }
	
	    this.lastScrollTop = this._pageContent.scrollTop;
	    this.padding = 0;
	    this._topPositions = [0];
	    this._renderedItems = {};
	
	    if (!this._delegate.itemHeight && !this._delegate.calculateItemHeight(0)) {
	      this._unknownItemHeight = true;
	    }
	
	    this._addEventListeners();
	    this._onChange();
	  }
	
	  createClass(LazyRepeatProvider, [{
	    key: '_findPageContentElement',
	    value: function _findPageContentElement(wrapperElement) {
	      var pageContent = util.findParent(wrapperElement, '.page__content');
	
	      if (pageContent) {
	        return pageContent;
	      }
	
	      var page = util.findParent(wrapperElement, 'ons-page');
	      if (page) {
	        var content = util.findChild(page, '.content');
	        if (content) {
	          return content;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: '_checkItemHeight',
	    value: function _checkItemHeight(callback) {
	      var _this = this;
	
	      this._delegate.loadItemElement(0, function (item) {
	        if (!_this._unknownItemHeight) {
	          throw Error('Invalid state');
	        }
	
	        _this._wrapperElement.appendChild(item.element);
	
	        var done = function done() {
	          _this._delegate.destroyItem(0, item);
	          item.element && item.element.remove();
	          delete _this._unknownItemHeight;
	          callback();
	        };
	
	        _this._itemHeight = item.element.offsetHeight;
	
	        if (_this._itemHeight > 0) {
	          done();
	          return;
	        }
	
	        // retry to measure offset height
	        // dirty fix for angular2 directive
	        _this._wrapperElement.style.visibility = 'hidden';
	        item.element.style.visibility = 'hidden';
	
	        setImmediate(function () {
	          _this._itemHeight = item.element.offsetHeight;
	          if (_this._itemHeight == 0) {
	            throw Error('Invalid state: this._itemHeight must be greater than zero.');
	          }
	          _this._wrapperElement.style.visibility = '';
	          done();
	        });
	      });
	    }
	  }, {
	    key: '_countItems',
	    value: function _countItems() {
	      return this._delegate.countItems();
	    }
	  }, {
	    key: '_getItemHeight',
	    value: function _getItemHeight(i) {
	      // Item is rendered
	      if (this._renderedItems.hasOwnProperty(i)) {
	        if (!this._renderedItems[i].hasOwnProperty('height')) {
	          this._renderedItems[i].height = this._renderedItems[i].element.offsetHeight;
	        }
	        return this._renderedItems[i].height;
	      }
	
	      // Item is not rendered, scroll up
	      if (this._topPositions[i + 1] && this._topPositions[i]) {
	        return this._topPositions[i + 1] - this._topPositions[i];
	      }
	      // Item is not rendered, scroll down
	      return this.staticItemHeight || this._delegate.calculateItemHeight(i);
	    }
	  }, {
	    key: '_calculateRenderedHeight',
	    value: function _calculateRenderedHeight() {
	      var _this2 = this;
	
	      return Object.keys(this._renderedItems).reduce(function (a, b) {
	        return a + _this2._getItemHeight(+b);
	      }, 0);
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange() {
	      this._render();
	    }
	  }, {
	    key: '_lastItemRendered',
	    value: function _lastItemRendered() {
	      return Math.max.apply(Math, toConsumableArray(Object.keys(this._renderedItems)));
	    }
	  }, {
	    key: '_firstItemRendered',
	    value: function _firstItemRendered() {
	      return Math.min.apply(Math, toConsumableArray(Object.keys(this._renderedItems)));
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var forceRender = { forceScrollDown: true };
	      var lastItemIndex = Math.min(this._lastItemRendered(), this._countItems() - 1);
	      var firstItemIndex = this._firstItemRendered();
	
	      if (util.isInteger(lastItemIndex)) {
	        forceRender.forceLastIndex = lastItemIndex;
	      }
	
	      if (util.isInteger(firstItemIndex)) {
	        this._wrapperElement.style.height = this._topPositions[firstItemIndex] + this._calculateRenderedHeight() + 'px';
	        this.padding = this._topPositions[firstItemIndex];
	        forceRender.forceFirstIndex = firstItemIndex;
	      }
	
	      this._removeAllElements();
	      this._render(forceRender);
	      this._wrapperElement.style.height = 'inherit';
	    }
	  }, {
	    key: '_render',
	    value: function _render() {
	      var _this3 = this;
	
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$forceScrollDown = _ref.forceScrollDown,
	          forceScrollDown = _ref$forceScrollDown === undefined ? false : _ref$forceScrollDown,
	          forceFirstIndex = _ref.forceFirstIndex,
	          forceLastIndex = _ref.forceLastIndex;
	
	      if (this._unknownItemHeight) {
	        return this._checkItemHeight(this._render.bind(this, arguments[0]));
	      }
	
	      var isScrollUp = !forceScrollDown && this.lastScrollTop > this._pageContent.scrollTop;
	      this.lastScrollTop = this._pageContent.scrollTop;
	      var keep = {};
	
	      var offset = this._wrapperElement.getBoundingClientRect().top;
	      var limit = 4 * window.innerHeight - offset;
	      var count = this._countItems();
	
	      var start = forceFirstIndex || Math.max(0, this._calculateStartIndex(offset) - 30); // Recalculate for 0 or undefined
	      var i = start;
	
	      for (var top = this._topPositions[i]; i < count && top < limit; i++) {
	        if (i >= this._topPositions.length) {
	          // perf optimization
	          this._topPositions.length += 100;
	        }
	
	        this._topPositions[i] = top;
	        top += this._getItemHeight(i);
	      }
	
	      if (this._delegate.hasRenderFunction && this._delegate.hasRenderFunction()) {
	        return this._delegate._render(start, i, function () {
	          _this3.padding = _this3._topPositions[start];
	        });
	      }
	
	      if (isScrollUp) {
	        for (var j = i - 1; j >= start; j--) {
	          keep[j] = true;
	          this._renderElement(j, isScrollUp);
	        }
	      } else {
	        var lastIndex = forceLastIndex || Math.max.apply(Math, [i - 1].concat(toConsumableArray(Object.keys(this._renderedItems)))); // Recalculate for 0 or undefined
	        for (var _j = start; _j <= lastIndex; _j++) {
	          keep[_j] = true;
	          this._renderElement(_j, isScrollUp);
	        }
	      }
	
	      Object.keys(this._renderedItems).forEach(function (key) {
	        return keep[key] || _this3._removeElement(key, isScrollUp);
	      });
	    }
	
	    /**
	     * @param {Number} index
	     * @param {Boolean} isScrollUp
	     */
	
	  }, {
	    key: '_renderElement',
	    value: function _renderElement(index, isScrollUp) {
	      var _this4 = this;
	
	      var item = this._renderedItems[index];
	      if (item) {
	        this._delegate.updateItem(index, item); // update if it exists
	        return;
	      }
	
	      this._delegate.loadItemElement(index, function (item) {
	        if (isScrollUp) {
	          _this4._wrapperElement.insertBefore(item.element, _this4._wrapperElement.children[_this4._insertIndex]);
	          _this4.padding = _this4._topPositions[index];
	          item.height = _this4._topPositions[index + 1] - _this4._topPositions[index];
	        } else {
	          _this4._wrapperElement.appendChild(item.element);
	        }
	
	        _this4._renderedItems[index] = item;
	      });
	    }
	
	    /**
	     * @param {Number} index
	     * @param {Boolean} isScrollUp
	     */
	
	  }, {
	    key: '_removeElement',
	    value: function _removeElement(index) {
	      var isScrollUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      index = +index;
	      var item = this._renderedItems[index];
	      this._delegate.destroyItem(index, item);
	
	      if (isScrollUp) {
	        this._topPositions[index + 1] = undefined;
	      } else {
	        this.padding = this.padding + this._getItemHeight(index);
	      }
	
	      if (item.element.parentElement) {
	        item.element.parentElement.removeChild(item.element);
	      }
	
	      delete this._renderedItems[index];
	    }
	  }, {
	    key: '_removeAllElements',
	    value: function _removeAllElements() {
	      var _this5 = this;
	
	      Object.keys(this._renderedItems).forEach(function (key) {
	        return _this5._removeElement(key);
	      });
	    }
	  }, {
	    key: '_recalculateTopPositions',
	    value: function _recalculateTopPositions(start, end) {
	      for (var i = start; i <= end; i++) {
	        this._topPositions[i + 1] = this._topPositions[i] + this._getItemHeight(i);
	      }
	    }
	  }, {
	    key: '_calculateStartIndex',
	    value: function _calculateStartIndex(current) {
	      var firstItemIndex = this._firstItemRendered();
	      var lastItemIndex = this._lastItemRendered();
	
	      // Fix for Safari scroll and Angular 2
	      this._recalculateTopPositions(firstItemIndex, lastItemIndex);
	
	      var start = 0;
	      var end = this._countItems() - 1;
	
	      // Binary search for index at top of screen so we can speed up rendering.
	      for (;;) {
	        var middle = Math.floor((start + end) / 2);
	        var value = current + this._topPositions[middle];
	
	        if (end < start) {
	          return 0;
	        } else if (value <= 0 && value + this._getItemHeight(middle) > 0) {
	          return middle;
	        } else if (isNaN(value) || value >= 0) {
	          end = middle - 1;
	        } else {
	          start = middle + 1;
	        }
	      }
	    }
	  }, {
	    key: '_debounce',
	    value: function _debounce(func, wait, immediate) {
	      var timeout = void 0;
	      return function () {
	        var _this6 = this,
	            _arguments = arguments;
	
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        if (callNow) {
	          func.apply(this, arguments);
	        } else {
	          timeout = setTimeout(function () {
	            timeout = null;
	            func.apply(_this6, _arguments);
	          }, wait);
	        }
	      };
	    }
	  }, {
	    key: '_doubleFireOnTouchend',
	    value: function _doubleFireOnTouchend() {
	      this._render();
	      this._debounce(this._render.bind(this), 100);
	    }
	  }, {
	    key: '_addEventListeners',
	    value: function _addEventListeners() {
	      util.bindListeners(this, ['_onChange', '_doubleFireOnTouchend']);
	
	      if (platform.isIOS()) {
	        this._boundOnChange = this._debounce(this._boundOnChange, 30);
	      }
	
	      this._pageContent.addEventListener('scroll', this._boundOnChange, true);
	
	      if (platform.isIOS()) {
	        util.addEventListener(this._pageContent, 'touchmove', this._boundOnChange, { capture: true, passive: true });
	        this._pageContent.addEventListener('touchend', this._boundDoubleFireOnTouchend, true);
	      }
	
	      window.document.addEventListener('resize', this._boundOnChange, true);
	    }
	  }, {
	    key: '_removeEventListeners',
	    value: function _removeEventListeners() {
	      this._pageContent.removeEventListener('scroll', this._boundOnChange, true);
	
	      if (platform.isIOS()) {
	        util.removeEventListener(this._pageContent, 'touchmove', this._boundOnChange, { capture: true, passive: true });
	        this._pageContent.removeEventListener('touchend', this._boundDoubleFireOnTouchend, true);
	      }
	
	      window.document.removeEventListener('resize', this._boundOnChange, true);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this._removeAllElements();
	      this._delegate.destroy();
	      this._parentElement = this._delegate = this._renderedItems = null;
	      this._removeEventListeners();
	    }
	  }, {
	    key: 'padding',
	    get: function get$$1() {
	      return parseInt(this._wrapperElement.style.paddingTop, 10);
	    },
	    set: function set$$1(newValue) {
	      this._wrapperElement.style.paddingTop = newValue + 'px';
	    }
	  }, {
	    key: 'staticItemHeight',
	    get: function get$$1() {
	      return this._delegate.itemHeight || this._itemHeight;
	    }
	  }]);
	  return LazyRepeatProvider;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * @element ons-lazy-repeat
	 * @category list
	 * @description
	 *   [en]
	 *     Using this component a list with millions of items can be rendered without a drop in performance.
	 *     It does that by "lazily" loading elements into the DOM when they come into view and
	 *     removing items from the DOM when they are not visible.
	 *   [/en]
	 *   [ja]
	 *     このコンポーネント内で描画されるアイテムのDOM要素の読み込みは、画面に見えそうになった時まで自動的に遅延され、
	 *     画面から見えなくなった場合にはその要素は動的にアンロードされます。
	 *     このコンポーネントを使うことで、パフォーマンスを劣化させること無しに巨大な数の要素を描画できます。
	 *   [/ja]
	 * @codepen QwrGBm
	 * @tutorial vanilla/Reference/lazy-repeat
	 * @seealso ons-list
	 *   [en]The `<ons-list>` element is used to render a list.[/en]
	 *   [ja]`<ons-list>`要素はリストを描画するのに使われます。[/ja]
	 * @example
	 * <script>
	 *   window.addEventListener('load', function() {
	 *     var lazyRepeat = document.querySelector('#list');
	 *     lazyRepeat.delegate = {
	 *      createItemContent: function(i, template) {
	 *        var dom = template.cloneNode(true);
	 *        dom.innerText = i;
	 *
	 *        return dom;
	 *      },
	 *      countItems: function() {
	 *        return 10000000;
	 *      },
	 *      destroyItem: function(index, item) {
	 *        console.log('Destroyed item with index: ' + index);
	 *      }
	 *     };
	 *   });
	 * </script>
	 *
	 * <ons-list id="list">
	 *   <ons-lazy-repeat>
	 *     <ons-list-item></ons-list-item>
	 *   </ons-lazy-repeat>
	 * </ons-list>
	 */
	
	var LazyRepeatElement = function (_BaseElement) {
	  inherits(LazyRepeatElement, _BaseElement);
	
	  function LazyRepeatElement() {
	    classCallCheck(this, LazyRepeatElement);
	    return possibleConstructorReturn(this, (LazyRepeatElement.__proto__ || Object.getPrototypeOf(LazyRepeatElement)).apply(this, arguments));
	  }
	
	  createClass(LazyRepeatElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      // not very good idea and also not documented
	      if (this.hasAttribute('delegate')) {
	        this.delegate = window[this.getAttribute('delegate')];
	      }
	    }
	
	    /**
	     * @property delegate
	     * @type {Object}
	     * @description
	     *  [en]Specify a delegate object to load and unload item elements.[/en]
	     *  [ja]要素のロード、アンロードなどの処理を委譲するオブジェクトを指定します。[/ja]
	     */
	
	    /**
	     * @property delegate.createItemContent
	     * @type {Function}
	     * @description
	     *   [en]
	     *     This function should return a `HTMLElement`.
	     *
	     *     To help rendering the element, the current index and a template is supplied as arguments. The template is the initial content of the `<ons-lazy-repeat>` element.
	     *   [/en]
	     *   [ja]
	     *     この関数は`HTMLElement`を返してください。
	     *     要素を生成しやすくするために、現在のアイテムのインデックスとテンプレートが引数に渡されます。
	     *     このテンプレートは、`<ons-lazy-repeat>`要素のコンテンツが渡されます。
	     *   [/ja]
	     */
	
	    /**
	     * @property delegate.countItems
	     * @type {Function}
	     * @description
	     *   [en]Should return the number of items in the list.[/en]
	     *   [ja]リスト内のアイテム数を返してください。[/ja]
	     */
	
	    /**
	     * @property delegate.calculateItemHeight
	     * @type {Function}
	     * @description
	     *   [en]
	     *     Should return the height of an item. The index is provided as an argument.
	     *
	     *     This is important when rendering lists where the items have different height.
	     *
	     *     The function is optional and if it isn't present the height of the first item will be automatically calculated and used for all other items.
	     *   [/en]
	     *   [ja]
	     *     アイテムの高さ(ピクセル)を返してください。アイテムのインデックス値は引数で渡されます。
	     *     この関数は、それぞれのアイムが違った高さを持つリストをレンダリングする際に重要です。
	     *     この関数はオプショナルです。もしこの関数が無い場合には、
	     *     最初のアイテムの高さが他のすべてのアイテムの高さとして利用されます。
	     *   [/ja]
	     */
	
	    /**
	     * @property delegate.destroyItem
	     * @type {Function}
	     * @description
	     *   [en]
	     *     This function is used called when an item is removed from the DOM. The index and DOM element is provided as arguments.
	     *
	     *     The function is optional but may be important in order to avoid memory leaks.
	     *   [/en]
	     *   [ja]
	     *     この関数は、あるアイテムがDOMツリーから除かれた時に呼び出されます。
	     *     アイテムのインデックス値とDOM要素が引数として渡されます。
	     *     この関数はオプショナルですが、各アイテムの後処理が必要な場合にはメモリーリークを避けるために重要です。
	     *   [/ja]
	     */
	
	  }, {
	    key: 'refresh',
	
	
	    /**
	     * @method refresh
	     * @signature refresh()
	     * @description
	     *   [en]Refresh the list. Use this method when the data has changed.[/en]
	     *   [ja]リストを更新します。もしデータが変わった場合にはこのメソッドを使ってください。[/ja]
	     */
	    value: function refresh() {
	      this._lazyRepeatProvider && this._lazyRepeatProvider.refresh();
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {}
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      if (this._lazyRepeatProvider) {
	        this._lazyRepeatProvider.destroy();
	        this._lazyRepeatProvider = null;
	      }
	    }
	  }, {
	    key: 'delegate',
	    set: function set$$1(userDelegate) {
	      this._lazyRepeatProvider && this._lazyRepeatProvider.destroy();
	
	      if (!this._templateElement && this.children[0]) {
	        this._templateElement = this.removeChild(this.children[0]);
	      }
	
	      var delegate = new LazyRepeatDelegate(userDelegate, this._templateElement || null);
	      this._lazyRepeatProvider = new LazyRepeatProvider(this.parentElement, delegate);
	    },
	    get: function get$$1() {
	      throw new Error('This property can only be used to set the delegate object.');
	    }
	  }]);
	  return LazyRepeatElement;
	}(BaseElement);
	
	internal$1.LazyRepeatDelegate = LazyRepeatDelegate;
	internal$1.LazyRepeatProvider = LazyRepeatProvider;
	
	onsElements.LazyRepeat = LazyRepeatElement;
	customElements.define('ons-lazy-repeat', LazyRepeatElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$4 = 'list-header';
	var scheme$8 = { '': 'list-header--*' };
	
	/**
	 * @element ons-list-header
	 * @category list
	 * @description
	 *   [en]Header element for list items. Must be put inside the `<ons-list>` component.[/en]
	 *   [ja]リスト要素に使用するヘッダー用コンポーネント。ons-listと共に使用します。[/ja]
	 * @seealso ons-list
	 *   [en]The `<ons-list>` component[/en]
	 *   [ja]ons-listコンポーネント[/ja]
	 * @seealso ons-list-item
	 *   [en]The `<ons-list-item>` component[/en]
	 *   [ja]ons-list-itemコンポーネント[/ja]
	 * @codepen yxcCt
	 * @tutorial vanilla/Reference/list
	 * @modifier material
	 *   [en]Display a Material Design list header.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-list>
	 *   <ons-list-header>Header Text</ons-list-header>
	 *   <ons-list-item>Item</ons-list-item>
	 *   <ons-list-item>Item</ons-list-item>
	 * </ons-list>
	 */
	
	var ListHeaderElement = function (_BaseElement) {
	  inherits(ListHeaderElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the list header.[/en]
	   *   [ja]ヘッダーの表現を指定します。[/ja]
	   */
	
	  function ListHeaderElement() {
	    classCallCheck(this, ListHeaderElement);
	
	    var _this = possibleConstructorReturn(this, (ListHeaderElement.__proto__ || Object.getPrototypeOf(ListHeaderElement)).call(this));
	
	    _this._compile();
	    return _this;
	  }
	
	  createClass(ListHeaderElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$4);
	      ModifierUtil.initModifier(this, scheme$8);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$4, scheme$8);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$8);
	          break;
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return ListHeaderElement;
	}(BaseElement);
	
	onsElements.ListHeader = ListHeaderElement;
	customElements.define('ons-list-header', ListHeaderElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$5 = 'list-title';
	var scheme$9 = { '': 'list-title--*' };
	
	/**
	 * @element ons-list-title
	 * @category list
	 * @description
	 *   [en]Represents a list title.[/en]
	 *   [ja]リストのタイトルを表現します。[/ja]
	 * @example
	 * <ons-list-title>List Title</ons-list-title>
	 * <ons-list>
	 *   <ons-list-item>Item</ons-list-item>
	 * </ons-list>
	 * @modifier material
	 *   [en]Display a Material Design list title.[/en]
	 *   [ja][/ja]
	 */
	
	var ListTitleElement = function (_BaseElement) {
	  inherits(ListTitleElement, _BaseElement);
	
	  function ListTitleElement() {
	    classCallCheck(this, ListTitleElement);
	
	    var _this = possibleConstructorReturn(this, (ListTitleElement.__proto__ || Object.getPrototypeOf(ListTitleElement)).call(this));
	
	    _this._compile();
	    return _this;
	  }
	
	  createClass(ListTitleElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$5);
	      ModifierUtil.initModifier(this, scheme$9);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$5, scheme$9);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$9);
	          break;
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return ListTitleElement;
	}(BaseElement);
	
	onsElements.ListTitle = ListTitleElement;
	customElements.define('ons-list-title', ListTitleElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$6 = 'list-item';
	var scheme$10 = {
	  '.list-item': 'list-item--*',
	  '.list-item__left': 'list-item--*__left',
	  '.list-item__center': 'list-item--*__center',
	  '.list-item__right': 'list-item--*__right',
	  '.list-item__label': 'list-item--*__label',
	  '.list-item__title': 'list-item--*__title',
	  '.list-item__subtitle': 'list-item--*__subtitle',
	  '.list-item__thumbnail': 'list-item--*__thumbnail',
	  '.list-item__icon': 'list-item--*__icon'
	};
	
	/**
	 * @element ons-list-item
	 * @category list
	 * @modifier tappable
	 *   [en]Make the list item change appearance when it's tapped. On iOS it is better to use the "tappable" and "tap-background-color" attribute for better behavior when scrolling.[/en]
	 *   [ja]タップやクリックした時に効果が表示されるようになります。[/ja]
	 * @modifier chevron
	 *   [en]Display a chevron at the right end of the list item and make it change appearance when tapped.[/en]
	 *   [ja][/ja]
	 * @modifier longdivider
	 *   [en]Displays a long horizontal divider between items.[/en]
	 *   [ja][/ja]
	 * @modifier nodivider
	 *   [en]Removes the divider between list items.[/en]
	 *   [ja][/ja]
	 * @modifier material
	 *   [en]Display a Material Design list item.[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]
	 *     Component that represents each item in a list. The list item is composed of three parts that are represented with the `left`, `center` and `right` classes. These classes can be used to ensure that the content of the list items is properly aligned.
	 *
	 *     ```
	 *     <ons-list-item>
	 *       <div class="left">Left</div>
	 *       <div class="center">Center</div>
	 *       <div class="right">Right</div>
	 *     </ons-list-item>
	 *     ```
	 *
	 *     There is also a number of classes (prefixed with `list-item__*`) that help when putting things like icons and thumbnails into the list items.
	 *   [/en]
	 *   [ja][/ja]
	 * @seealso ons-list
	 *   [en]ons-list component[/en]
	 *   [ja]ons-listコンポーネント[/ja]
	 * @seealso ons-list-header
	 *   [en]ons-list-header component[/en]
	 *   [ja]ons-list-headerコンポーネント[/ja]
	 * @codepen yxcCt
	 * @tutorial vanilla/Reference/list
	 * @example
	 * <ons-list-item>
	 *   <div class="left">
	 *     <ons-icon icon="md-face" class="list-item__icon"></ons-icon>
	 *   </div>
	 *   <div class="center">
	 *     <div class="list-item__title">Title</div>
	 *     <div class="list-item__subtitle">Subtitle</div>
	 *   </div>
	 *   <div class="right">
	 *     <ons-switch></ons-switch>
	 *   </div>
	 * </ons-list-item>
	 */
	
	var ListItemElement = function (_BaseElement) {
	  inherits(ListItemElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the list item.[/en]
	   *   [ja]各要素の表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute lock-on-drag
	   * @type {String}
	   * @description
	   *   [en]Prevent vertical scrolling when the user drags horizontally.[/en]
	   *   [ja]この属性があると、ユーザーがこの要素を横方向にドラッグしている時に、縦方向のスクロールが起きないようになります。[/ja]
	   */
	
	  /**
	   * @attribute tappable
	   * @type {Boolean}
	   * @description
	   *   [en]Makes the element react to taps. `prevent-tap` attribute can be added to child elements like buttons or inputs to prevent this effect. `ons-*` elements are ignored by default.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute tap-background-color
	   * @type {Color}
	   * @description
	   *   [en] Changes the background color when tapped. For this to work, the attribute "tappable" needs to be set. The default color is "#d9d9d9". It will display as a ripple effect on Android.[/en]
	   *   [ja][/ja]
	   */
	
	  function ListItemElement() {
	    classCallCheck(this, ListItemElement);
	
	    // Elements ignored when tapping
	    var _this = possibleConstructorReturn(this, (ListItemElement.__proto__ || Object.getPrototypeOf(ListItemElement)).call(this));
	
	    var re = /^ons-(?!col$|row$|if$)/i;
	    _this._shouldIgnoreTap = function (e) {
	      return e.hasAttribute('prevent-tap') || re.test(e.tagName);
	    };
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ListItemElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.classList.add(defaultClassName$6);
	
	      var left = void 0,
	          center = void 0,
	          right = void 0;
	
	      for (var i = 0; i < this.children.length; i++) {
	        var el = this.children[i];
	
	        if (el.classList.contains('left')) {
	          el.classList.add('list-item__left');
	          left = el;
	        } else if (el.classList.contains('center')) {
	          center = el;
	        } else if (el.classList.contains('right')) {
	          el.classList.add('list-item__right');
	          right = el;
	        }
	      }
	
	      if (!center) {
	        center = document.createElement('div');
	
	        if (!left && !right) {
	          while (this.childNodes[0]) {
	            center.appendChild(this.childNodes[0]);
	          }
	        } else {
	          for (var _i = this.childNodes.length - 1; _i >= 0; _i--) {
	            var _el = this.childNodes[_i];
	            if (_el !== left && _el !== right) {
	              center.insertBefore(_el, center.firstChild);
	            }
	          }
	        }
	
	        this.insertBefore(center, right || null);
	      }
	
	      center.classList.add('center');
	      center.classList.add('list-item__center');
	
	      util.updateRipple(this);
	
	      ModifierUtil.initModifier(this, scheme$10);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$6, scheme$10);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$10);
	          break;
	        case 'ripple':
	          util.updateRipple(this);
	          break;
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this._setupListeners(true);
	      this._originalBackgroundColor = this.style.backgroundColor;
	      this.tapped = false;
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._setupListeners(false);
	    }
	  }, {
	    key: '_setupListeners',
	    value: function _setupListeners(add) {
	      var action = (add ? 'add' : 'remove') + 'EventListener';
	      util[action](this, 'touchstart', this._onTouch, { passive: true });
	      util[action](this, 'touchmove', this._onRelease, { passive: true });
	      this[action]('touchcancel', this._onRelease);
	      this[action]('touchend', this._onRelease);
	      this[action]('touchleave', this._onRelease);
	      this[action]('drag', this._onDrag);
	      this[action]('mousedown', this._onTouch);
	      this[action]('mouseup', this._onRelease);
	      this[action]('mouseout', this._onRelease);
	    }
	  }, {
	    key: '_onDrag',
	    value: function _onDrag(event) {
	      var gesture = event.gesture;
	      // Prevent vertical scrolling if the users pans left or right.
	      if (this.hasAttribute('lock-on-drag') && ['left', 'right'].indexOf(gesture.direction) > -1) {
	        gesture.preventDefault();
	      }
	    }
	  }, {
	    key: '_onTouch',
	    value: function _onTouch(e) {
	      var _this2 = this;
	
	      if (this.tapped || this !== e.target && (this._shouldIgnoreTap(e.target) || util.findParent(e.target, this._shouldIgnoreTap, function (p) {
	        return p === _this2;
	      }))) {
	        return; // Ignore tap
	      }
	
	      this.tapped = true;
	      var touchStyle = { transition: 'background-color 0.0s linear 0.02s, box-shadow 0.0s linear 0.02s' };
	
	      if (this.hasAttribute('tappable')) {
	        if (this.style.backgroundColor) {
	          this._originalBackgroundColor = this.style.backgroundColor;
	        }
	
	        touchStyle.backgroundColor = this.getAttribute('tap-background-color') || '#d9d9d9';
	        touchStyle.boxShadow = '0px -1px 0px 0px ' + touchStyle.backgroundColor;
	      }
	
	      styler(this, touchStyle);
	    }
	  }, {
	    key: '_onRelease',
	    value: function _onRelease() {
	      this.tapped = false;
	      this.style.backgroundColor = this._originalBackgroundColor || '';
	      styler.clear(this, 'transition boxShadow');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class', 'ripple'];
	    }
	  }]);
	  return ListItemElement;
	}(BaseElement);
	
	onsElements.ListItem = ListItemElement;
	customElements.define('ons-list-item', ListItemElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$7 = 'list';
	var scheme$11 = { '': 'list--*' };
	
	/**
	 * @element ons-list
	 * @category list
	 * @modifier inset
	 *   [en]Inset list that doesn't cover the whole width of the parent.[/en]
	 *   [ja]親要素の画面いっぱいに広がらないリストを表示します。[/ja]
	 * @modifier noborder
	 *   [en]A list with no borders at the top and bottom.[/en]
	 *   [ja]リストの上下のボーダーが無いリストを表示します。[/ja]
	 * @description
	 *   [en]Component to define a list, and the container for ons-list-item(s).[/en]
	 *   [ja]リストを表現するためのコンポーネント。ons-list-itemのコンテナとして使用します。[/ja]
	 * @seealso ons-list-item
	 *   [en]ons-list-item component[/en]
	 *   [ja]ons-list-itemコンポーネント[/ja]
	 * @seealso ons-list-header
	 *   [en]ons-list-header component[/en]
	 *   [ja]ons-list-headerコンポーネント[/ja]
	 * @seealso ons-lazy-repeat
	 *   [en]ons-lazy-repeat component[/en]
	 *   [ja]ons-lazy-repeatコンポーネント[/ja]
	 * @codepen yxcCt
	 * @tutorial vanilla/Reference/list
	 * @example
	 * <ons-list>
	 *   <ons-list-header>Header Text</ons-list-header>
	 *   <ons-list-item>Item</ons-list-item>
	 *   <ons-list-item>Item</ons-list-item>
	 * </ons-list>
	 */
	
	var ListElement = function (_BaseElement) {
	  inherits(ListElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the list.[/en]
	   *   [ja]リストの表現を指定します。[/ja]
	   */
	
	  function ListElement() {
	    classCallCheck(this, ListElement);
	
	    var _this = possibleConstructorReturn(this, (ListElement.__proto__ || Object.getPrototypeOf(ListElement)).call(this));
	
	    _this._compile();
	    return _this;
	  }
	
	  createClass(ListElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$7);
	      ModifierUtil.initModifier(this, scheme$11);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$7, scheme$11);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$11);
	          break;
	      }
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return ListElement;
	}(BaseElement);
	
	onsElements.List = ListElement;
	customElements.define('ons-list', ListElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var INPUT_ATTRIBUTES = ['autocapitalize', 'autocomplete', 'autocorrect', 'autofocus', 'disabled', 'inputmode', 'max', 'maxlength', 'min', 'minlength', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'size', 'step', 'validator', 'value'];
	
	var BaseInputElement = function (_BaseElement) {
	  inherits(BaseInputElement, _BaseElement);
	  createClass(BaseInputElement, [{
	    key: '_update',
	    value: function _update() {} // Optionally implemented
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      throw new Error('_scheme getter must be implemented.');
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      throw new Error('_template getter must be implemented.');
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      throw new Error('type getter must be implemented.');
	    }
	  }]);
	
	  function BaseInputElement() {
	    classCallCheck(this, BaseInputElement);
	
	    var _this = possibleConstructorReturn(this, (BaseInputElement.__proto__ || Object.getPrototypeOf(BaseInputElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    _this._boundDelegateEvent = _this._delegateEvent.bind(_this);
	    return _this;
	  }
	
	  createClass(BaseInputElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this._defaultClassName && this.classList.add(this._defaultClassName);
	
	      if (this.children.length !== 0) {
	        return;
	      }
	
	      this.appendChild(util.createFragment(this._template));
	
	      this._setInputId();
	      this._updateBoundAttributes();
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	  }, {
	    key: '_updateBoundAttributes',
	    value: function _updateBoundAttributes() {
	      var _this2 = this;
	
	      INPUT_ATTRIBUTES.forEach(function (attr) {
	        if (_this2.hasAttribute(attr)) {
	          _this2._input.setAttribute(attr, _this2.getAttribute(attr));
	        } else {
	          _this2._input.removeAttribute(attr);
	        }
	      });
	
	      this._update();
	    }
	  }, {
	    key: '_delegateEvent',
	    value: function _delegateEvent(event) {
	      var e = new CustomEvent(event.type, {
	        bubbles: false,
	        cancelable: true
	      });
	
	      return this.dispatchEvent(e);
	    }
	  }, {
	    key: '_setInputId',
	    value: function _setInputId() {
	      if (this.hasAttribute('input-id')) {
	        this._input.id = this.getAttribute('input-id');
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this3 = this;
	
	      contentReady(this, function () {
	        _this3._input.addEventListener('focus', _this3._boundDelegateEvent);
	        _this3._input.addEventListener('blur', _this3._boundDelegateEvent);
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      var _this4 = this;
	
	      contentReady(this, function () {
	        _this4._input.removeEventListener('focus', _this4._boundDelegateEvent);
	        _this4._input.removeEventListener('blur', _this4._boundDelegateEvent);
	      });
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this5 = this;
	
	      switch (name) {
	        case 'modifier':
	          contentReady(this, function () {
	            return ModifierUtil.onModifierChanged(last, current, _this5, _this5._scheme);
	          });
	          break;
	        case 'input-id':
	          contentReady(this, function () {
	            return _this5._setInputId();
	          });
	          break;
	        case 'class':
	          util.restoreClass(this, this._defaultClassName, this._scheme);
	          break;
	      }
	
	      if (INPUT_ATTRIBUTES.indexOf(name) >= 0) {
	        contentReady(this, function () {
	          return _this5._updateBoundAttributes();
	        });
	      }
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return '';
	    }
	  }, {
	    key: '_input',
	    get: function get$$1() {
	      return this.querySelector('input');
	    }
	  }, {
	    key: 'value',
	    get: function get$$1() {
	      return this._input === null ? this.getAttribute('value') : this._input.value;
	    },
	    set: function set$$1(val) {
	      var _this6 = this;
	
	      contentReady(this, function () {
	        if (val instanceof Date) {
	          val = val.toISOString().substring(0, 10);
	        }
	        _this6._input.value = val;
	        _this6._update();
	      });
	    }
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'input-id', 'class'].concat(INPUT_ATTRIBUTES);
	    }
	  }]);
	  return BaseInputElement;
	}(BaseElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var scheme$12 = {
	  '.text-input': 'text-input--*',
	  '.text-input__label': 'text-input--*__label'
	};
	
	/**
	 * @element ons-input
	 * @category form
	 * @modifier material
	 *  [en]Displays a Material Design input.[/en]
	 *  [ja][/ja]
	 * @modifier underbar
	 *  [en]Displays a horizontal line underneath a text input.[/en]
	 *  [ja][/ja]
	 * @modifier transparent
	 *  [en]Displays a transparent input. Works for Material Design.[/en]
	 *  [ja][/ja]
	 * @description
	 *  [en]
	 *    An input element. The `type` attribute can be used to change the input type. All text input types are supported.
	 *
	 *    The component will automatically render as a Material Design input on Android devices.
	 *
	 *    Most attributes that can be used for a normal `<input>` element can also be used on the `<ons-input>` element.
	 *  [/en]
	 *  [ja][/ja]
	 * @tutorial vanilla/Reference/input
	 * @seealso ons-checkbox
	 *   [en]The `<ons-checkbox>` element is used to display a checkbox.[/en]
	 *   [ja][/ja]
	 * @seealso ons-radio
	 *   [en]The `<ons-radio>` element is used to display a radio button.[/en]
	 *   [ja][/ja]
	 * @seealso ons-range
	 *   [en]The `<ons-range>` element is used to display a range slider.[/en]
	 *   [ja][/ja]
	 * @seealso ons-switch
	 *   [en]The `<ons-switch>` element is used to display a draggable toggle switch.[/en]
	 *   [ja][/ja]
	 * @seealso ons-select
	 *   [en]The `<ons-select>` element is used to display a select box.[/en]
	 *   [ja][/ja]
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-input placeholder="Username" float></ons-input>
	 */
	
	var InputElement = function (_BaseInputElement) {
	  inherits(InputElement, _BaseInputElement);
	
	  function InputElement() {
	    classCallCheck(this, InputElement);
	
	    var _this = possibleConstructorReturn(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).call(this));
	
	    _this._boundOnInput = _this._update.bind(_this);
	    _this._boundOnFocusin = _this._update.bind(_this);
	    return _this;
	  }
	
	  /* Inherited props */
	
	  createClass(InputElement, [{
	    key: '_update',
	    value: function _update() {
	      this._updateLabel();
	      this._updateLabelClass();
	    }
	  }, {
	    key: '_updateLabel',
	
	
	    /* Own props */
	
	    value: function _updateLabel() {
	      var label = this.getAttribute('placeholder') || '';
	
	      if (typeof this._helper.textContent !== 'undefined') {
	        this._helper.textContent = label;
	      } else {
	        this._helper.innerText = label;
	      }
	    }
	  }, {
	    key: '_updateLabelClass',
	    value: function _updateLabelClass() {
	      if (this.value === '') {
	        this._helper.classList.remove('text-input--material__label--active');
	      } else {
	        this._helper.classList.add('text-input--material__label--active');
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      get(InputElement.prototype.__proto__ || Object.getPrototypeOf(InputElement.prototype), 'connectedCallback', this).call(this);
	
	      contentReady(this, function () {
	        _this2._input.addEventListener('input', _this2._boundOnInput);
	        _this2._input.addEventListener('focusin', _this2._boundOnFocusin);
	      });
	
	      var type = this.getAttribute('type');
	      if (['checkbox', 'radio'].indexOf(type) >= 0) {
	        util.warn('Warn: <ons-input type="' + type + '"> is deprecated since v2.4.0. Use <ons-' + type + '> instead.');
	      }
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      var _this3 = this;
	
	      get(InputElement.prototype.__proto__ || Object.getPrototypeOf(InputElement.prototype), 'disconnectedCallback', this).call(this);
	
	      contentReady(this, function () {
	        _this3._input.removeEventListener('input', _this3._boundOnInput);
	        _this3._input.removeEventListener('focusin', _this3._boundOnFocusin);
	      });
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this4 = this;
	
	      switch (name) {
	        case 'type':
	          contentReady(this, function () {
	            return _this4._input.setAttribute('type', _this4.type);
	          });
	          break;
	        default:
	          get(InputElement.prototype.__proto__ || Object.getPrototypeOf(InputElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	      }
	    }
	
	    /**
	     * @attribute placeholder
	     * @type {String}
	     * @description
	     *   [en]Placeholder text. In Material Design, this placeholder will be a floating label.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @attribute float
	     * @description
	     *  [en]If this attribute is present, the placeholder will be animated in Material Design.[/en]
	     *  [ja]この属性が設定された時、ラベルはアニメーションするようになります。[/ja]
	     */
	
	    /**
	     * @attribute type
	     * @type {String}
	     * @description
	     *  [en]
	     *    Specify the input type. This is the same as the "type" attribute for normal inputs. It expects strict text types such as `text`, `password`, etc. For checkbox, radio button, select or range, please have a look at the corresponding elements.
	     *
	     *    Please take a look at [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-type) for an exhaustive list of possible values. Depending on the platform and browser version some of these might not work.
	     *  [/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @attribute input-id
	     * @type {String}
	     * @description
	     *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @property value
	     * @type {String}
	     * @description
	     *   [en]The current value of the input.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the input is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$12;
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      return '\n      <input type="' + this.type + '" class="text-input">\n      <span class="text-input__label"></span>\n    ';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      var type = this.getAttribute('type');
	      return ['checkbox', 'radio'].indexOf(type) < 0 && type || 'text';
	    }
	  }, {
	    key: '_helper',
	    get: function get$$1() {
	      return this.querySelector('span');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(InputElement.__proto__ || Object.getPrototypeOf(InputElement), 'observedAttributes', this)), ['type']);
	    }
	  }]);
	  return InputElement;
	}(BaseInputElement);
	
	onsElements.Input = InputElement;
	customElements.define('ons-input', InputElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var BaseCheckboxElement = function (_BaseInputElement) {
	  inherits(BaseCheckboxElement, _BaseInputElement);
	
	  function BaseCheckboxElement() {
	    classCallCheck(this, BaseCheckboxElement);
	
	    var _this = possibleConstructorReturn(this, (BaseCheckboxElement.__proto__ || Object.getPrototypeOf(BaseCheckboxElement)).call(this));
	
	    contentReady(_this, function () {
	      _this.attributeChangedCallback('checked', null, _this.getAttribute('checked'));
	    });
	    return _this;
	  }
	
	  /* Inherited props */
	
	  createClass(BaseCheckboxElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'checked':
	          this.checked = current !== null;
	          break;
	        default:
	          get(BaseCheckboxElement.prototype.__proto__ || Object.getPrototypeOf(BaseCheckboxElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	      }
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      return '\n      <input type="' + this.type + '" class="' + this._defaultClassName + '__input">\n      <span class="' + this._defaultClassName + '__checkmark"></span>\n    ';
	    }
	
	    /* Own props */
	
	  }, {
	    key: '_helper',
	    get: function get$$1() {
	      return this.querySelector('span');
	    }
	  }, {
	    key: 'checked',
	    get: function get$$1() {
	      return this._input.checked;
	    },
	    set: function set$$1(val) {
	      var _this2 = this;
	
	      contentReady(this, function () {
	        _this2._input.checked = val;
	      });
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(BaseCheckboxElement.__proto__ || Object.getPrototypeOf(BaseCheckboxElement), 'observedAttributes', this)), ['checked']);
	    }
	  }]);
	  return BaseCheckboxElement;
	}(BaseInputElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var scheme$13 = {
	  '.checkbox': 'checkbox--*',
	  '.checkbox__input': 'checkbox--*__input',
	  '.checkbox__checkmark': 'checkbox--*__checkmark'
	};
	
	/**
	 * @element ons-checkbox
	 * @category form
	 * @modifier material
	 *  [en]Displays a Material Design checkbox.[/en]
	 *  [ja][/ja]
	 * @modifier noborder
	 *  [en]iOS borderless checkbox.[/en]
	 *  [ja][/ja]
	 * @description
	 *  [en]
	 *    A checkbox element. The component will automatically render as a Material Design checkbox on Android devices.
	 *
	 *    Most attributes that can be used for a normal `<input type="checkbox">` element can also be used on the `<ons-checkbox>` element.
	 *  [/en]
	 *  [ja][/ja]
	 * @tutorial vanilla/Reference/input
	 * @seealso ons-switch
	 *   [en]The `<ons-switch>` element is used to display a draggable toggle switch.[/en]
	 *   [ja][/ja]
	 * @seealso ons-radio
	 *   [en]The `<ons-radio>` element is used to display a radio button.[/en]
	 *   [ja][/ja]
	 * @seealso ons-input
	 *   [en]The `<ons-input>` element is used to display a text input.[/en]
	 *   [ja][/ja]
	 * @seealso ons-search-input
	 *   [en]The `<ons-search-input>` element is used to display a search input.[/en]
	 *   [ja][/ja]
	 * @seealso ons-range
	 *   [en]The `<ons-range>` element is used to display a range slider.[/en]
	 *   [ja][/ja]
	 * @seealso ons-select
	 *   [en]The `<ons-select>` element is used to display a select box.[/en]
	 *   [ja][/ja]
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-checkbox checked></ons-checkbox>
	 */
	
	var CheckboxElement = function (_BaseCheckboxElement) {
	  inherits(CheckboxElement, _BaseCheckboxElement);
	
	  function CheckboxElement() {
	    classCallCheck(this, CheckboxElement);
	    return possibleConstructorReturn(this, (CheckboxElement.__proto__ || Object.getPrototypeOf(CheckboxElement)).apply(this, arguments));
	  }
	
	  createClass(CheckboxElement, [{
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$13;
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'checkbox';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      return 'checkbox';
	    }
	
	    /**
	     * @attribute input-id
	     * @type {String}
	     * @description
	     *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @property value
	     * @type {String}
	     * @description
	     *   [en]The current value of the checkbox.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property checked
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the checkbox is checked or not.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the checkbox is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }]);
	  return CheckboxElement;
	}(BaseCheckboxElement);
	
	onsElements.Checkbox = CheckboxElement;
	customElements.define('ons-checkbox', CheckboxElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var scheme$14 = {
	  '.radio-button': 'radio-button--*',
	  '.radio-button__input': 'radio-button--*__input',
	  '.radio-button__checkmark': 'radio-button--*__checkmark'
	};
	
	/**
	 * @element ons-radio
	 * @category form
	 * @modifier material
	 *  [en]Displays a Material Design radio button.[/en]
	 *  [ja][/ja]
	 * @description
	 *  [en]
	 *    A radio button element. The component will automatically render as a Material Design radio button on Android devices.
	 *
	 *    Most attributes that can be used for a normal `<input type="radio">` element can also be used on the `<ons-radio>` element.
	 *  [/en]
	 *  [ja][/ja]
	 * @tutorial vanilla/Reference/input
	 * @seealso ons-select
	 *   [en]The `<ons-select>` element is used to display a select box.[/en]
	 *   [ja][/ja]
	 * @seealso ons-checkbox
	 *   [en]The `<ons-checkbox>` element is used to display a checkbox.[/en]
	 *   [ja][/ja]
	 * @seealso ons-switch
	 *   [en]The `<ons-switch>` element is used to display a draggable toggle switch.[/en]
	 *   [ja][/ja]
	 * @seealso ons-input
	 *   [en]The `<ons-input>` element is used to display a text input.[/en]
	 *   [ja][/ja]
	 * @seealso ons-search-input
	 *   [en]The `<ons-search-input>` element is used to display a search input.[/en]
	 *   [ja][/ja]
	 * @seealso ons-range
	 *   [en]The `<ons-range>` element is used to display a range slider.[/en]
	 *   [ja][/ja]
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-radio checked></ons-radio>
	 */
	
	var RadioElement = function (_BaseCheckboxElement) {
	  inherits(RadioElement, _BaseCheckboxElement);
	
	  function RadioElement() {
	    classCallCheck(this, RadioElement);
	    return possibleConstructorReturn(this, (RadioElement.__proto__ || Object.getPrototypeOf(RadioElement)).apply(this, arguments));
	  }
	
	  createClass(RadioElement, [{
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$14;
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'radio-button';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      return 'radio';
	    }
	
	    /**
	     * @attribute input-id
	     * @type {String}
	     * @description
	     *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @property value
	     * @type {String}
	     * @description
	     *   [en]The current value of the radio button.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property checked
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the radio button is checked or not.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the radio button is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }]);
	  return RadioElement;
	}(BaseCheckboxElement);
	
	onsElements.Radio = RadioElement;
	customElements.define('ons-radio', RadioElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var scheme$15 = {
	  '.search-input': 'search-input--*'
	};
	
	/**
	 * @element ons-search-input
	 * @category form
	 * @modifier material
	 *  [en]Displays a Material Design search input.[/en]
	 *  [ja][/ja]
	 * @description
	 *  [en]
	 *    A search input element. The component will automatically render as a Material Design search input on Android devices.
	 *
	 *    Most attributes that can be used for a normal `<input>` element can also be used on the `<ons-search-input>` element.
	 *  [/en]
	 *  [ja][/ja]
	 * @tutorial vanilla/Reference/input
	 * @seealso ons-input
	 *   [en]The `<ons-input>` element is used to display a text input.[/en]
	 *   [ja][/ja]
	 * @seealso ons-range
	 *   [en]The `<ons-range>` element is used to display a range slider.[/en]
	 *   [ja][/ja]
	 * @seealso ons-switch
	 *   [en]The `<ons-switch>` element is used to display a draggable toggle switch.[/en]
	 *   [ja][/ja]
	 * @seealso ons-select
	 *   [en]The `<ons-select>` element is used to display a select box.[/en]
	 *   [ja][/ja]
	 * @seealso ons-checkbox
	 *   [en]The `<ons-checkbox>` element is used to display a checkbox.[/en]
	 *   [ja][/ja]
	 * @seealso ons-radio
	 *   [en]The `<ons-radio>` element is used to display a radio button.[/en]
	 *   [ja][/ja]
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-search-input placeholder="Search"></ons-search-input>
	 */
	
	var SearchInputElement = function (_BaseInputElement) {
	  inherits(SearchInputElement, _BaseInputElement);
	
	  function SearchInputElement() {
	    classCallCheck(this, SearchInputElement);
	    return possibleConstructorReturn(this, (SearchInputElement.__proto__ || Object.getPrototypeOf(SearchInputElement)).apply(this, arguments));
	  }
	
	  createClass(SearchInputElement, [{
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$15;
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      return '\n      <input type="' + this.type + '" class="search-input">\n    ';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      return 'search';
	    }
	
	    /**
	     * @attribute input-id
	     * @type {String}
	     * @description
	     *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @property value
	     * @type {String}
	     * @description
	     *   [en]The current value of the input.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the input is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }]);
	  return SearchInputElement;
	}(BaseInputElement);
	
	onsElements.SearchInput = SearchInputElement;
	customElements.define('ons-search-input', SearchInputElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var ModalAnimator = function (_BaseAnimator) {
	  inherits(ModalAnimator, _BaseAnimator);
	
	  /**
	   * @param {Object} options
	   * @param {String} options.timing
	   * @param {Number} options.duration
	   * @param {Number} options.delay
	   */
	  function ModalAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, ModalAnimator);
	    return possibleConstructorReturn(this, (ModalAnimator.__proto__ || Object.getPrototypeOf(ModalAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} modal
	   * @param {Function} callback
	   */
	
	
	  createClass(ModalAnimator, [{
	    key: 'show',
	    value: function show(modal, callback) {
	      callback();
	    }
	
	    /**
	     * @param {HTMLElement} modal
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(modal, callback) {
	      callback();
	    }
	  }]);
	  return ModalAnimator;
	}(BaseAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * iOS style animator for dialog.
	 */
	
	var FadeModalAnimator = function (_ModalAnimator) {
	  inherits(FadeModalAnimator, _ModalAnimator);
	
	  function FadeModalAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.3 : _ref$duration;
	
	    classCallCheck(this, FadeModalAnimator);
	    return possibleConstructorReturn(this, (FadeModalAnimator.__proto__ || Object.getPrototypeOf(FadeModalAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} modal
	   * @param {Function} callback
	   */
	
	
	  createClass(FadeModalAnimator, [{
	    key: 'show',
	    value: function show(modal, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(modal).queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	
	    /**
	     * @param {HTMLElement} modal
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(modal, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(modal).queue({
	        opacity: 1
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	  }]);
	  return FadeModalAnimator;
	}(ModalAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * iOS style animator for modal.
	 */
	
	var LiftModalAnimator = function (_ModalAnimator) {
	  inherits(LiftModalAnimator, _ModalAnimator);
	
	  function LiftModalAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier( .1, .7, .1, 1)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.4 : _ref$duration;
	
	    classCallCheck(this, LiftModalAnimator);
	    return possibleConstructorReturn(this, (LiftModalAnimator.__proto__ || Object.getPrototypeOf(LiftModalAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} modal
	   * @param {Function} callback
	   */
	
	
	  createClass(LiftModalAnimator, [{
	    key: 'show',
	    value: function show(modal, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(modal).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	
	    /**
	     * @param {HTMLElement} modal
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(modal, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(modal).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	  }]);
	  return LiftModalAnimator;
	}(ModalAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$16 = {
	  '': 'modal--*',
	  'modal__content': 'modal--*__content'
	};
	
	var defaultClassName$8 = 'modal';
	
	var _animatorDict$3 = {
	  'default': ModalAnimator,
	  'fade': FadeModalAnimator,
	  'lift': LiftModalAnimator,
	  'none': ModalAnimator
	};
	
	/**
	 * @element ons-modal
	 * @category dialog
	 * @description
	 *   [en]
	 *     Modal component that masks current screen. Underlying components are not subject to any events while the modal component is shown.
	 *
	 *     This component can be used to block user input while some operation is running or to show some information to the user.
	 *   [/en]
	 *   [ja]
	 *     画面全体をマスクするモーダル用コンポーネントです。下側にあるコンポーネントは、
	 *     モーダルが表示されている間はイベント通知が行われません。
	 *   [/ja]
	 * @seealso ons-dialog
	 *   [en]The `<ons-dialog>` component can be used to create a modal dialog.[/en]
	 *   [ja][/ja]
	 * @codepen devIg
	 * @tutorial vanilla/reference/modal
	 * @example
	 * <ons-modal id="modal">
	 *   Modal content
	 * </ons-modal>
	 * <script>
	 *   var modal = document.getElementById('modal');
	 *   modal.show();
	 * </script>
	 */
	
	var ModalElement = function (_BaseDialogElement) {
	  inherits(ModalElement, _BaseDialogElement);
	
	  /**
	   * @event preshow
	   * @description
	   * [en]Fired just before the modal is displayed.[/en]
	   * [ja]モーダルが表示される直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.modal
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the modal from being shown.[/en]
	   *   [ja]この関数を実行すると、ダイアログの表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event postshow
	   * @description
	   * [en]Fired just after the modal is displayed.[/en]
	   * [ja]モーダルが表示された直後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.modal
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event prehide
	   * @description
	   * [en]Fired just before the modal is hidden.[/en]
	   * [ja]モーダルが隠れる直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.modal
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Execute this function to stop the modal from being hidden.[/en]
	   *   [ja]この関数を実行すると、ダイアログの非表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event posthide
	   * @description
	   * [en]Fired just after the modal is hidden.[/en]
	   * [ja]モーダルが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.modal
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default default
	   * @description
	   *  [en]The animation used when showing and hiding the modal. Can be either `"none"`, `"fade"` or `"lift"`.[/en]
	   *  [ja]モーダルを表示する際のアニメーション名を指定します。"none"もしくは"fade","lift"を指定できます。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. <code>{duration: 0.2, delay: 1, timing: 'ease-in'}</code>[/ja]
	   */
	
	  function ModalElement() {
	    classCallCheck(this, ModalElement);
	
	    var _this = possibleConstructorReturn(this, (ModalElement.__proto__ || Object.getPrototypeOf(ModalElement)).call(this));
	
	    _this._defaultDBB = function () {
	      return undefined;
	    };
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ModalElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      return new AnimatorFactory({
	        animators: _animatorDict$3,
	        baseClass: ModalAnimator,
	        baseClassName: 'ModalAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      this.style.display = 'none';
	      this.style.zIndex = 10001;
	      this.classList.add(defaultClassName$8);
	
	      if (!util.findChild(this, '.modal__content')) {
	        var content = document.createElement('div');
	        content.classList.add('modal__content');
	
	        while (this.childNodes[0]) {
	          var node = this.childNodes[0];
	          this.removeChild(node);
	          content.insertBefore(node, null);
	        }
	
	        this.appendChild(content);
	      }
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	  }, {
	    key: '_toggleStyle',
	    value: function _toggleStyle(shouldShow) {
	      this.style.display = shouldShow ? 'table' : 'none';
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      get(ModalElement.prototype.__proto__ || Object.getPrototypeOf(ModalElement.prototype), 'connectedCallback', this).call(this);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      get(ModalElement.prototype.__proto__ || Object.getPrototypeOf(ModalElement.prototype), 'disconnectedCallback', this).call(this);
	    }
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @method show
	     * @signature show([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"fade"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "fade"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the modal has been revealed.[/en]
	     *   [ja]モーダルが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Show modal.[/en]
	     *   [ja]モーダルを表示します。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the displayed element[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @method toggle
	     * @signature toggle([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"fade"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "fade"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the modal has been revealed.[/en]
	     *   [ja]モーダルが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Toggle modal visibility.[/en]
	     *   [ja]モーダルの表示を切り替えます。[/ja]
	     */
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"none"` and `"fade"`.[/en]
	     *   [ja]アニメーション名を指定します。"none", "fade"のいずれかを指定します。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the modal has been revealed.[/en]
	     *   [ja]モーダルが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Hide modal.[/en]
	     *   [ja]モーダルを非表示にします。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'class') {
	        util.restoreClass(this, defaultClassName$8, scheme$16);
	      } else {
	        get(ModalElement.prototype.__proto__ || Object.getPrototypeOf(ModalElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	      }
	    }
	
	    /**
	     * @param {String} name
	     * @param {Function} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$16;
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof ModalAnimator)) {
	        throw new Error('"Animator" param must inherit OnsModalElement.ModalAnimator');
	      }
	      _animatorDict$3[name] = Animator;
	    }
	  }, {
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(ModalElement.__proto__ || Object.getPrototypeOf(ModalElement), 'observedAttributes', this)), ['class']);
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$3;
	    }
	  }, {
	    key: 'ModalAnimator',
	    get: function get$$1() {
	      return ModalAnimator;
	    }
	  }]);
	  return ModalElement;
	}(BaseDialogElement);
	
	onsElements.Modal = ModalElement;
	customElements.define('ons-modal', ModalElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var widthToPx = function widthToPx(width) {
	  var _ref = [parseInt(width, 10), /px/.test(width)],
	      value = _ref[0],
	      px = _ref[1];
	
	  return px ? value : Math.round(document.body.offsetWidth * value / 100);
	};
	
	var SwipeReveal = function () {
	  function SwipeReveal(params) {
	    var _this = this;
	
	    classCallCheck(this, SwipeReveal);
	
	    'element ignoreSwipe isInitialState onDragCallback swipeMax swipeMin swipeMid'.split(/\s+/).forEach(function (key) {
	      return _this[key] = params[key];
	    });
	
	    this.elementHandler = params.elementHandler || params.element;
	    this.getThreshold = params.getThreshold || function () {
	      return .5;
	    };
	    this.getSide = params.getSide || function () {
	      return 'left';
	    };
	
	    this.handleGesture = this.handleGesture.bind(this);
	
	    this._shouldFixScroll = util.globals.actualMobileOS === 'ios';
	  }
	
	  createClass(SwipeReveal, [{
	    key: 'update',
	    value: function update() {
	      var swipeable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element.hasAttribute('swipeable');
	
	      if (!this.gestureDetector) {
	        this.gestureDetector = new GestureDetector(this.elementHandler, { dragMinDistance: 1, passive: !this._shouldFixScroll });
	      }
	
	      var action = swipeable ? 'on' : 'off';
	      this.gestureDetector[action]('drag dragstart dragend', this.handleGesture);
	    }
	  }, {
	    key: 'handleGesture',
	    value: function handleGesture(e) {
	      if (e.gesture) {
	        if (e.type === 'dragstart') {
	          this.onDragStart(e);
	        } else if (!this._ignoreDrag) {
	          e.type === 'dragend' ? this.onDragEnd(e) : this.onDrag(e);
	        }
	      }
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      var _this2 = this;
	
	      var getDistance = function getDistance() {
	        return _this2.getSide() === 'left' ? event.gesture.center.clientX : window.innerWidth - event.gesture.center.clientX;
	      };
	      this._ignoreDrag = event.consumed || !util.isValidGesture(event) || this.ignoreSwipe(event, getDistance());
	
	      if (!this._ignoreDrag) {
	        event.consume && event.consume();
	        event.consumed = true;
	
	        this._width = widthToPx(this.element.style.width || '100%');
	        this._startDistance = this._distance = !(this.isInitialState instanceof Function) || this.isInitialState() ? 0 : this._width;
	
	        util.iosPreventScroll(this.gestureDetector);
	      }
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(event) {
	      event.stopPropagation();
	
	      var delta = this.getSide() === 'left' ? event.gesture.deltaX : -event.gesture.deltaX;
	      var distance = Math.max(0, Math.min(this._width, this._startDistance + delta));
	      if (distance !== this._distance) {
	        this._distance = distance;
	        this.swipeMid(this._distance, this._width);
	      }
	    }
	  }, {
	    key: 'onDragEnd',
	    value: function onDragEnd(event) {
	      event.stopPropagation();
	
	      var direction = event.gesture.interimDirection;
	      var isSwipeMax = this.getSide() !== direction && this._distance > this._width * this.getThreshold();
	      isSwipeMax ? this.swipeMax() : this.swipeMin();
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.gestureDetector && this.gestureDetector.dispose();
	      this.gestureDetector = this.element = this.elementHandler = null;
	    }
	  }]);
	  return SwipeReveal;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var NavigatorAnimator = function (_BaseAnimator) {
	  inherits(NavigatorAnimator, _BaseAnimator);
	
	  /**
	   * @param {Object} options
	   * @param {String} options.timing
	   * @param {Number} options.duration
	   * @param {Number} options.delay
	   */
	  function NavigatorAnimator(options) {
	    classCallCheck(this, NavigatorAnimator);
	
	    options = util.extend({
	      timing: 'linear',
	      duration: '0.4',
	      delay: '0'
	    }, options || {});
	
	    return possibleConstructorReturn(this, (NavigatorAnimator.__proto__ || Object.getPrototypeOf(NavigatorAnimator)).call(this, options));
	  }
	
	  createClass(NavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      callback();
	    }
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      callback();
	    }
	  }, {
	    key: 'block',
	    value: function block(page) {
	      var blocker = util.createElement('\n      <div style="position: absolute; background-color: transparent; width: 100%; height: 100%; z-index: 100000"></div>\n    ');
	      page.parentNode.appendChild(blocker);
	      return function () {
	        return blocker.remove();
	      };
	    }
	  }]);
	  return NavigatorAnimator;
	}(BaseAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Slide animator for navigator transition like iOS's screen slide transition.
	 */
	
	var IOSSlideNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(IOSSlideNavigatorAnimator, _NavigatorAnimator);
	
	  function IOSSlideNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(0.3, .4, 0, .9)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.4 : _ref$duration;
	
	    classCallCheck(this, IOSSlideNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (IOSSlideNavigatorAnimator.__proto__ || Object.getPrototypeOf(IOSSlideNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.backgroundMask = util.createElement('\n      <div style="position: absolute; width: 100%; height: 100%;\n        background-color: black; z-index: 2"></div>\n    ');
	
	    return _this;
	  }
	
	  createClass(IOSSlideNavigatorAnimator, [{
	    key: '_decompose',
	    value: function _decompose(page) {
	      var toolbar = page._getToolbarElement();
	      var left = toolbar._getToolbarLeftItemsElement();
	      var right = toolbar._getToolbarRightItemsElement();
	
	      var excludeBackButton = function excludeBackButton(elements) {
	        var result = [];
	
	        for (var i = 0; i < elements.length; i++) {
	          if (elements[i].nodeName.toLowerCase() !== 'ons-back-button') {
	            result.push(elements[i]);
	          }
	        }
	
	        return result;
	      };
	
	      var other = [].concat(left.children.length === 0 ? left : excludeBackButton(left.children)).concat(right.children.length === 0 ? right : excludeBackButton(right.children));
	
	      return {
	        toolbarCenter: toolbar._getToolbarCenterItemsElement(),
	        backButtonIcon: toolbar._getToolbarBackButtonIconElement(),
	        backButtonLabel: toolbar._getToolbarBackButtonLabelElement(),
	        other: other,
	        content: page._getContentElement(),
	        background: page._getBackgroundElement(),
	        toolbar: toolbar,
	        bottomToolbar: page._getBottomToolbarElement()
	      };
	    }
	  }, {
	    key: '_shouldAnimateToolbar',
	    value: function _shouldAnimateToolbar(enterPage, leavePage) {
	      var enterToolbar = enterPage._getToolbarElement();
	      var leaveToolbar = leavePage._getToolbarElement();
	
	      var toolbars = enterPage._canAnimateToolbar() && leavePage._canAnimateToolbar();
	      var material = util.hasModifier(enterToolbar, 'material') || util.hasModifier(leaveToolbar, 'material');
	      var transparent = util.hasModifier(enterToolbar, 'transparent') || util.hasModifier(leaveToolbar, 'transparent');
	
	      return toolbars && !material && !transparent;
	    }
	  }, {
	    key: '_calculateDelta',
	    value: function _calculateDelta(element, decomposition) {
	      var title = void 0,
	          label = void 0;
	
	      var pageRect = element.getBoundingClientRect();
	      if (decomposition.backButtonLabel.classList.contains('back-button__label')) {
	        var labelRect = decomposition.backButtonLabel.getBoundingClientRect();
	        title = Math.round(pageRect.width / 2 - labelRect.width / 2 - labelRect.left);
	      } else {
	        title = Math.round(pageRect.width / 2 * 0.6);
	      }
	
	      if (decomposition.backButtonIcon.classList.contains('back-button__icon')) {
	        label = decomposition.backButtonIcon.getBoundingClientRect().right - 2;
	      }
	
	      return { title: title, label: label };
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var _this2 = this;
	
	      this.backgroundMask.remove();
	      leavePage.parentNode.insertBefore(this.backgroundMask, leavePage);
	
	      var unblock = get(IOSSlideNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSSlideNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      contentReady(enterPage, function () {
	        var enterPageTarget = util.findToolbarPage(enterPage) || enterPage;
	        var leavePageTarget = util.findToolbarPage(leavePage) || leavePage;
	        var enterPageDecomposition = _this2._decompose(enterPageTarget);
	        var leavePageDecomposition = _this2._decompose(leavePageTarget);
	
	        var delta = _this2._calculateDelta(leavePage, enterPageDecomposition);
	
	        var shouldAnimateToolbar = _this2._shouldAnimateToolbar(enterPageTarget, leavePageTarget);
	
	        if (shouldAnimateToolbar) {
	
	          Animit.runAll(Animit([enterPageDecomposition.content, enterPageDecomposition.bottomToolbar, enterPageDecomposition.background]).saveStyle().queue({
	            css: {
	              transform: 'translate3D(100%, 0px, 0px)'
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3D(0px, 0px, 0px)'
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle(), Animit(enterPageDecomposition.toolbar).saveStyle().queue({
	            css: {
	              opacity: 0
	            },
	            duration: 0
	          }).queue({
	            css: {
	              opacity: 1
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle(), Animit(enterPageDecomposition.toolbarCenter).saveStyle().queue({
	            css: {
	              transform: 'translate3d(125%, 0, 0)',
	              opacity: 1
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3d(0, 0, 0)',
	              opacity: 1
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle(), Animit(enterPageDecomposition.backButtonLabel).saveStyle().queue({
	            css: {
	              transform: 'translate3d(' + delta.title + 'px, 0, 0)',
	              opacity: 0
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3d(0, 0, 0)',
	              opacity: 1.0,
	              transition: 'opacity ' + _this2.duration + 's linear, transform ' + _this2.duration + 's ' + _this2.timing
	            },
	            duration: _this2.duration
	          }).restoreStyle(), Animit(enterPageDecomposition.other).saveStyle().queue({
	            css: { opacity: 0 },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: { opacity: 1 },
	            duration: _this2.duration,
	            timing: 'linear'
	          }).restoreStyle(), Animit([leavePageDecomposition.content, leavePageDecomposition.bottomToolbar, leavePageDecomposition.background]).saveStyle().queue({
	            css: {
	              transform: 'translate3D(0, 0, 0)',
	              opacity: 1
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3D(-25%, 0px, 0px)',
	              opacity: 0.9
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle().queue(function (done) {
	            _this2.backgroundMask.remove();
	            unblock();
	            callback();
	            done();
	          }), Animit(leavePageDecomposition.toolbarCenter).saveStyle().queue({
	            css: {
	              transform: 'translate3d(0, 0, 0)',
	              opacity: 1.0
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3d(-' + delta.title + 'px, 0, 0)',
	              opacity: 0,
	              transition: 'opacity ' + _this2.duration + 's linear, transform ' + _this2.duration + 's ' + _this2.timing
	            },
	            duration: _this2.duration
	          }).restoreStyle(), Animit(leavePageDecomposition.backButtonLabel).saveStyle().queue({
	            css: {
	              transform: 'translate3d(0, 0, 0)',
	              opacity: 1.0
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3d(-' + delta.label + 'px, 0, 0)',
	              opacity: 0
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle(), Animit(leavePageDecomposition.other).saveStyle().queue({
	            css: { opacity: 1 },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: { opacity: 0 },
	            duration: _this2.duration,
	            timing: 'linear'
	          }).restoreStyle());
	        } else {
	
	          Animit.runAll(Animit(enterPage).saveStyle().queue({
	            css: {
	              transform: 'translate3D(100%, 0px, 0px)'
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3D(0px, 0px, 0px)'
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle(), Animit(leavePage).saveStyle().queue({
	            css: {
	              transform: 'translate3D(0, 0, 0)',
	              opacity: 1
	            },
	            duration: 0
	          }).wait(_this2.delay).queue({
	            css: {
	              transform: 'translate3D(-25%, 0px, 0px)',
	              opacity: 0.9
	            },
	            duration: _this2.duration,
	            timing: _this2.timing
	          }).restoreStyle().queue(function (done) {
	            _this2.backgroundMask.remove();
	            unblock();
	            callback();
	            done();
	          }));
	        }
	      });
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var _this3 = this;
	
	      this.backgroundMask.remove();
	      enterPage.parentNode.insertBefore(this.backgroundMask, enterPage);
	
	      var unblock = get(IOSSlideNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSSlideNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      var enterPageTarget = util.findToolbarPage(enterPage) || enterPage;
	      var leavePageTarget = util.findToolbarPage(leavePage) || leavePage;
	      var enterPageDecomposition = this._decompose(enterPageTarget);
	      var leavePageDecomposition = this._decompose(leavePageTarget);
	
	      var delta = this._calculateDelta(leavePage, leavePageDecomposition);
	
	      var shouldAnimateToolbar = this._shouldAnimateToolbar(enterPageTarget, leavePageTarget);
	
	      if (shouldAnimateToolbar) {
	        Animit.runAll(Animit([enterPageDecomposition.content, enterPageDecomposition.bottomToolbar, enterPageDecomposition.background]).saveStyle().queue({
	          css: {
	            transform: 'translate3D(-25%, 0px, 0px)',
	            opacity: 0.9
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)',
	            opacity: 1
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).restoreStyle(), Animit(enterPageDecomposition.toolbarCenter).saveStyle().queue({
	          css: {
	            transform: 'translate3d(-' + delta.title + 'px, 0, 0)',
	            opacity: 0
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3d(0, 0, 0)',
	            opacity: 1.0,
	            transition: 'opacity ' + this.duration + 's linear, transform ' + this.duration + 's ' + this.timing
	          },
	          duration: this.duration
	        }).restoreStyle(), Animit(enterPageDecomposition.backButtonLabel).saveStyle().queue({
	          css: {
	            transform: 'translate3d(-' + delta.label + 'px, 0, 0)'
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3d(0, 0, 0)'
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).restoreStyle(), Animit(enterPageDecomposition.other).saveStyle().queue({
	          css: { opacity: 0 },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: { opacity: 1 },
	          duration: this.duration,
	          timing: 'linear'
	        }).restoreStyle(), Animit([leavePageDecomposition.content, leavePageDecomposition.bottomToolbar, leavePageDecomposition.background]).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)'
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3D(100%, 0px, 0px)'
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).wait(0).queue(function (done) {
	          _this3.backgroundMask.remove();
	          unblock();
	          callback();
	          done();
	        }), Animit(leavePageDecomposition.toolbar).queue({
	          css: {
	            opacity: 1
	          },
	          duration: 0
	        }).queue({
	          css: {
	            opacity: 0
	          },
	          duration: this.duration,
	          timing: this.timing
	        }), Animit(leavePageDecomposition.toolbarCenter).queue({
	          css: {
	            transform: 'translate3d(0, 0, 0)'
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3d(125%, 0, 0)'
	          },
	          duration: this.duration,
	          timing: this.timing
	        }), Animit(leavePageDecomposition.backButtonLabel).queue({
	          css: {
	            transform: 'translate3d(0, 0, 0)',
	            opacity: 1
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3d(' + delta.title + 'px, 0, 0)',
	            opacity: 0,
	            transition: 'opacity ' + this.duration + 's linear, transform ' + this.duration + 's ' + this.timing
	          },
	          duration: this.duration
	        }));
	      } else {
	        Animit.runAll(Animit(enterPage).saveStyle().queue({
	          css: {
	            transform: 'translate3D(-25%, 0px, 0px)',
	            opacity: 0.9
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)',
	            opacity: 1.0
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).restoreStyle(), Animit(leavePage).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)'
	          },
	          duration: 0
	        }).wait(this.delay).queue({
	          css: {
	            transform: 'translate3D(100%, 0px, 0px)'
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).queue(function (done) {
	          _this3.backgroundMask.remove();
	          unblock();
	          callback();
	          done();
	        }));
	      }
	    }
	  }]);
	  return IOSSlideNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Swipe animator for iOS navigator transition.
	 */
	
	var IOSSwipeNavigatorAnimator = function (_IOSSlideNavigatorAni) {
	  inherits(IOSSwipeNavigatorAnimator, _IOSSlideNavigatorAni);
	
	  function IOSSwipeNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.15 : _ref$duration,
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay;
	
	    classCallCheck(this, IOSSwipeNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (IOSSwipeNavigatorAnimator.__proto__ || Object.getPrototypeOf(IOSSwipeNavigatorAnimator)).call(this, { duration: duration, timing: timing, delay: delay }));
	
	    _this.durationRestore = 0.1;
	
	    _this.swipeShadow = util.createElement('\n      <div style="position: absolute; height: 100%; width: 12px; right: 100%; top: 0; bottom: 0; z-index: -1;\n        background: linear-gradient(to right, transparent 0, rgba(0,0,0,.04) 40%, rgba(0,0,0,.12) 80%, rgba(0,0,0,.16) 100%);"></div>\n    ');
	
	    _this.isDragStart = true;
	    return _this;
	  }
	
	  createClass(IOSSwipeNavigatorAnimator, [{
	    key: '_dragStartSetup',
	    value: function _dragStartSetup(enterPage, leavePage) {
	      this.isDragStart = false;
	
	      // Avoid content clicks
	      this.unblock = get(IOSSwipeNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSSwipeNavigatorAnimator.prototype), 'block', this).call(this, leavePage);
	
	      // Mask
	      enterPage.parentElement.insertBefore(this.backgroundMask, enterPage);
	
	      // Decomposition
	      this.target = {
	        enter: util.findToolbarPage(enterPage) || enterPage,
	        leave: util.findToolbarPage(leavePage) || leavePage
	      };
	      this.decomp = {
	        enter: this._decompose(this.target.enter),
	        leave: this._decompose(this.target.leave)
	      };
	
	      // Animation values
	      this.delta = this._calculateDelta(leavePage, this.decomp.leave);
	      this.shouldAnimateToolbar = this._shouldAnimateToolbar(this.target.enter, this.target.leave);
	
	      // Shadow && styles
	      if (this.shouldAnimateToolbar) {
	        this.swipeShadow.style.top = this.decomp.leave.toolbar.offsetHeight + 'px';
	        this.target.leave.appendChild(this.swipeShadow);
	        this._saveStyle(this.target.enter, this.target.leave);
	      } else {
	        leavePage.appendChild(this.swipeShadow);
	        this._saveStyle(enterPage, leavePage);
	      }
	      leavePage.classList.add('overflow-visible');
	      this.overflowElement = leavePage;
	      this.decomp.leave.content.classList.add('content-swiping');
	    }
	  }, {
	    key: 'translate',
	    value: function translate(distance, maxWidth, enterPage, leavePage) {
	      if (enterPage.style.display === 'none') {
	        enterPage.style.display = '';
	      }
	
	      if (this.isDragStart) {
	        this.maxWidth = maxWidth;
	        this._dragStartSetup(enterPage, leavePage);
	      }
	
	      var swipeRatio = (distance - maxWidth) / maxWidth;
	
	      if (this.shouldAnimateToolbar) {
	
	        Animit.runAll(
	
	        /* Enter page */
	
	        Animit([this.decomp.enter.content, this.decomp.enter.bottomToolbar, this.decomp.enter.background]).queue({
	          transform: 'translate3d(' + swipeRatio * 25 + '%, 0, 0)',
	          opacity: 1 + swipeRatio * 10 / 100 // 0.9 -> 1
	        }), Animit(this.decomp.enter.toolbarCenter).queue({
	          transform: 'translate3d(' + this.delta.title * swipeRatio + 'px, 0, 0)',
	          opacity: 1 + swipeRatio // 0 -> 1
	        }), Animit(this.decomp.enter.backButtonLabel).queue({
	          opacity: 1 + swipeRatio * 10 / 100, // 0.9 -> 1
	          transform: 'translate3d(' + this.delta.label * swipeRatio + 'px, 0, 0)'
	        }), Animit(this.decomp.enter.other).queue({
	          opacity: 1 + swipeRatio // 0 -> 1
	        }),
	
	        /* Leave page */
	
	        Animit([this.decomp.leave.content, this.decomp.leave.bottomToolbar, this.decomp.leave.background, this.swipeShadow]).queue({
	          transform: 'translate3d(' + distance + 'px, 0px, 0px)'
	        }), Animit(this.decomp.leave.toolbar).queue({
	          opacity: -1 * swipeRatio // 1 -> 0
	        }), Animit(this.decomp.leave.toolbarCenter).queue({
	          transform: 'translate3d(' + (1 + swipeRatio) * 125 + '%, 0, 0)'
	        }), Animit(this.decomp.leave.backButtonLabel).queue({
	          opacity: -1 * swipeRatio, // 1 -> 0
	          transform: 'translate3d(' + this.delta.title * (1 + swipeRatio) + 'px, 0, 0)'
	        }),
	
	        /* Other */
	
	        Animit(this.swipeShadow).queue({
	          opacity: -1 * swipeRatio // 1 -> 0
	        }));
	      } else {
	        Animit.runAll(Animit(leavePage).queue({
	          transform: 'translate3d(' + distance + 'px, 0px, 0px)'
	        }), Animit(enterPage).queue({
	          transform: 'translate3d(' + swipeRatio * 25 + '%, 0, 0)',
	          opacity: 1 + swipeRatio * 10 / 100 // 0.9 -> 1
	        }), Animit(this.swipeShadow).queue({
	          opacity: -1 * swipeRatio // 1 -> 0
	        }));
	      }
	    }
	  }, {
	    key: 'restore',
	    value: function restore(enterPage, leavePage, callback) {
	      var _this2 = this;
	
	      if (this.isDragStart) {
	        return;
	      }
	
	      if (this.shouldAnimateToolbar) {
	
	        Animit.runAll(
	
	        /* Enter page */
	
	        Animit([this.decomp.enter.content, this.decomp.enter.bottomToolbar, this.decomp.enter.background]).queue({
	          transform: 'translate3d(-25%, 0, 0)',
	          opacity: 0.9
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(this.decomp.enter.toolbarCenter).queue({
	          transform: 'translate3d(-' + this.delta.title + 'px, 0, 0)',
	          transition: 'opacity ' + this.durationRestore + 's linear, transform ' + this.durationRestore + 's ' + this.timing,
	          opacity: 0
	        }), Animit(this.decomp.enter.backButtonLabel).queue({
	          transform: 'translate3d(-' + this.delta.label + 'px, 0, 0)'
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(this.decomp.enter.other).queue({
	          opacity: 0
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }),
	
	        /* Leave page */
	
	        Animit([this.decomp.leave.content, this.decomp.leave.bottomToolbar, this.decomp.leave.background, this.swipeShadow]).queue({
	          transform: 'translate3d(0, 0px, 0px)'
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(this.decomp.leave.toolbar).queue({
	          opacity: 1
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(this.decomp.leave.toolbarCenter).queue({
	          transform: 'translate3d(0, 0, 0)'
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(this.decomp.leave.backButtonLabel).queue({
	          opacity: 1,
	          transform: 'translate3d(0, 0, 0)',
	          transition: 'opacity ' + this.durationRestore + 's linear, transform ' + this.durationRestore + 's ' + this.timing
	        }),
	
	        /* Other */
	
	        Animit(this.swipeShadow).queue({
	          opacity: 0
	        }, {
	          timing: this.timing,
	          duration: this.durationRestore
	        }).queue(function (done) {
	          _this2._reset(_this2.target.enter, _this2.target.leave);
	          enterPage.style.display = 'none';
	          callback && callback();
	          done();
	        }));
	      } else {
	        Animit.runAll(Animit(enterPage).queue({
	          css: {
	            transform: 'translate3D(-25%, 0px, 0px)',
	            opacity: 0.9
	          },
	          timing: this.timing,
	          duration: this.durationRestore
	        }), Animit(leavePage).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)'
	          },
	          timing: this.timing,
	          duration: this.durationRestore
	        }).queue(function (done) {
	          _this2._reset(enterPage, leavePage);
	          enterPage.style.display = 'none';
	          callback && callback();
	          done();
	        }));
	      }
	    }
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var _this3 = this;
	
	      if (this.isDragStart) {
	        return;
	      }
	
	      if (this.shouldAnimateToolbar) {
	
	        Animit.runAll(
	
	        /* Enter page */
	
	        Animit([this.decomp.enter.content, this.decomp.enter.bottomToolbar, this.decomp.enter.background]).queue({
	          transform: 'translate3d(0, 0, 0)',
	          opacity: 1
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }), Animit(this.decomp.enter.toolbarCenter).queue({
	          transform: 'translate3d(0, 0, 0)',
	          transition: 'opacity ' + this.duration + 's linear, transform ' + this.duration + 's ' + this.timing,
	          opacity: 1
	        }), Animit(this.decomp.enter.backButtonLabel).queue({
	          transform: 'translate3d(0, 0, 0)'
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }), Animit(this.decomp.enter.other).queue({
	          opacity: 1
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }),
	
	        /* Leave page */
	
	        Animit([this.decomp.leave.content, this.decomp.leave.bottomToolbar, this.decomp.leave.background]).queue({
	          transform: 'translate3d(100%, 0px, 0px)'
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }), Animit(this.decomp.leave.toolbar).queue({
	          opacity: 0
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }), Animit(this.decomp.leave.toolbarCenter).queue({
	          transform: 'translate3d(125%, 0, 0)'
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }), Animit(this.decomp.leave.backButtonLabel).queue({
	          opacity: 0,
	          transform: 'translate3d(' + this.delta.title + 'px, 0, 0)',
	          transition: 'opacity ' + this.duration + 's linear, transform ' + this.duration + 's ' + this.timing
	        }),
	
	        /* Other */
	
	        Animit(this.swipeShadow).queue({
	          opacity: 0,
	          transform: 'translate3d(' + this.maxWidth + 'px, 0px, 0px)'
	        }, {
	          timing: this.timing,
	          duration: this.duration
	        }).queue(function (done) {
	          _this3._reset(_this3.target.enter, _this3.target.leave);
	          callback && callback();
	          done();
	        }));
	      } else {
	        Animit.runAll(Animit(enterPage).queue({
	          css: {
	            transform: 'translate3D(0px, 0px, 0px)',
	            opacity: 1.0
	          },
	          duration: this.duration,
	          timing: this.timing
	        }), Animit(leavePage).queue({
	          css: {
	            transform: 'translate3D(100%, 0px, 0px)'
	          },
	          duration: this.duration,
	          timing: this.timing
	        }).queue(function (done) {
	          _this3._reset(enterPage, leavePage);
	          callback && callback();
	          done();
	        }));
	      }
	    }
	  }, {
	    key: '_saveStyle',
	    value: function _saveStyle() {
	      var _this4 = this;
	
	      this._savedStyle = new WeakMap();
	      var save = function save(el) {
	        return _this4._savedStyle.set(el, el.getAttribute('style'));
	      };
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      args.forEach(save);
	
	      Object.keys(this.decomp).forEach(function (p) {
	        Object.keys(_this4.decomp[p]).forEach(function (k) {
	          (_this4.decomp[p][k] instanceof Array ? _this4.decomp[p][k] : [_this4.decomp[p][k]]).forEach(save);
	        });
	      });
	    }
	  }, {
	    key: '_restoreStyle',
	    value: function _restoreStyle() {
	      var _this5 = this;
	
	      var restore = function restore(el) {
	        _this5._savedStyle.get(el) === null ? el.removeAttribute('style') : el.setAttribute('style', _this5._savedStyle.get(el));
	        _this5._savedStyle.delete(el);
	      };
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      args.forEach(restore);
	
	      Object.keys(this.decomp).forEach(function (p) {
	        Object.keys(_this5.decomp[p]).forEach(function (k) {
	          (_this5.decomp[p][k] instanceof Array ? _this5.decomp[p][k] : [_this5.decomp[p][k]]).forEach(restore);
	        });
	      });
	    }
	  }, {
	    key: '_reset',
	    value: function _reset() {
	      this._savedStyle && this._restoreStyle.apply(this, arguments);
	      this.unblock && this.unblock();
	      this.swipeShadow.remove();
	      this.backgroundMask.remove();
	      this.overflowElement.classList.remove('overflow-visible');
	      this.decomp.leave.content.classList.remove('content-swiping');
	      this.decomp = this.target = this.overflowElement = this._savedStyle = null;
	      this.isDragStart = true;
	    }
	  }]);
	  return IOSSwipeNavigatorAnimator;
	}(IOSSlideNavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Lift screen transition.
	 */
	
	var IOSLiftNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(IOSLiftNavigatorAnimator, _NavigatorAnimator);
	
	  function IOSLiftNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(.1, .7, .1, 1)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.4 : _ref$duration;
	
	    classCallCheck(this, IOSLiftNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (IOSLiftNavigatorAnimator.__proto__ || Object.getPrototypeOf(IOSLiftNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.backgroundMask = util.createElement('\n      <div style="position: absolute; width: 100%; height: 100%;\n        background: linear-gradient(black, white);"></div>\n    ');
	    return _this;
	  }
	
	  /**
	   * @param {Object} enterPage
	   * @param {Object} leavePage
	   * @param {Function} callback
	   */
	
	
	  createClass(IOSLiftNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var _this2 = this;
	
	      this.backgroundMask.remove();
	      leavePage.parentNode.insertBefore(this.backgroundMask, leavePage);
	
	      var unblock = get(IOSLiftNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSLiftNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        _this2.backgroundMask.remove();
	        unblock();
	        callback();
	        done();
	      }), Animit(leavePage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1.0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, -10%, 0)',
	          opacity: 0.9
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle());
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var _this3 = this;
	
	      this.backgroundMask.remove();
	      enterPage.parentNode.insertBefore(this.backgroundMask, enterPage);
	
	      var unblock = get(IOSLiftNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSLiftNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, -43px, 0)', // Smaller than iOS toolbar - fixes glitch
	          opacity: 0.9
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        _this3.backgroundMask.remove();
	        unblock();
	        callback();
	        done();
	      }), Animit(leavePage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle());
	    }
	  }]);
	  return IOSLiftNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Fade-in screen transition.
	 */
	
	var IOSFadeNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(IOSFadeNavigatorAnimator, _NavigatorAnimator);
	
	  function IOSFadeNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.4 : _ref$duration;
	
	    classCallCheck(this, IOSFadeNavigatorAnimator);
	    return possibleConstructorReturn(this, (IOSFadeNavigatorAnimator.__proto__ || Object.getPrototypeOf(IOSFadeNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {Object} enterPage
	   * @param {Object} leavePage
	   * @param {Function} callback
	   */
	
	
	  createClass(IOSFadeNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var unblock = get(IOSFadeNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSFadeNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit([enterPage._getContentElement(), enterPage._getBackgroundElement()]).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }), Animit(enterPage._getToolbarElement()).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle());
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var unblock = get(IOSFadeNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(IOSFadeNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit([leavePage._getContentElement(), leavePage._getBackgroundElement()]).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }), Animit(leavePage._getToolbarElement()).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }));
	    }
	  }]);
	  return IOSFadeNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Slide animator for navigator transition.
	 */
	
	var MDSlideNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(MDSlideNavigatorAnimator, _NavigatorAnimator);
	
	  function MDSlideNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(.1, .7, .4, 1)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.3 : _ref$duration;
	
	    classCallCheck(this, MDSlideNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (MDSlideNavigatorAnimator.__proto__ || Object.getPrototypeOf(MDSlideNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.backgroundMask = util.createElement('\n      <div style="position: absolute; width: 100%; height: 100%; z-index: 2;\n        background-color: black; opacity: 0;"></div>\n    ');
	    _this.blackMaskOpacity = 0.4;
	    return _this;
	  }
	
	  /**
	   * @param {Object} enterPage
	   * @param {Object} leavePage
	   * @param {Function} callback
	   */
	
	
	  createClass(MDSlideNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var _this2 = this;
	
	      this.backgroundMask.remove();
	      leavePage.parentElement.insertBefore(this.backgroundMask, leavePage.nextSibling);
	
	      var unblock = get(MDSlideNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDSlideNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(this.backgroundMask).saveStyle().queue({
	        opacity: 0,
	        transform: 'translate3d(0, 0, 0)'
	      }).wait(this.delay).queue({
	        opacity: this.blackMaskOpacity
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        _this2.backgroundMask.remove();
	        done();
	      }), Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(100%, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle(), Animit(leavePage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(-45%, 0px, 0px)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().wait(0.2).queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var _this3 = this;
	
	      this.backgroundMask.remove();
	      enterPage.parentNode.insertBefore(this.backgroundMask, enterPage.nextSibling);
	
	      var unblock = get(MDSlideNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDSlideNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(this.backgroundMask).saveStyle().queue({
	        opacity: this.blackMaskOpacity,
	        transform: 'translate3d(0, 0, 0)'
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        _this3.backgroundMask.remove();
	        done();
	      }), Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(-45%, 0px, 0px)',
	          opacity: 0.9
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0px, 0px, 0px)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle(), Animit(leavePage).queue({
	        css: {
	          transform: 'translate3D(0px, 0px, 0px)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(100%, 0px, 0px)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).wait(0.2).queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return MDSlideNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Lift screen transition.
	 */
	
	var MDLiftNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(MDLiftNavigatorAnimator, _NavigatorAnimator);
	
	  function MDLiftNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(.1, .7, .1, 1)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0.05 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.4 : _ref$duration;
	
	    classCallCheck(this, MDLiftNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (MDLiftNavigatorAnimator.__proto__ || Object.getPrototypeOf(MDLiftNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.backgroundMask = util.createElement('\n      <div style="position: absolute; width: 100%; height: 100%;\n        background-color: black;"></div>\n    ');
	    return _this;
	  }
	
	  /**
	   * @param {Object} enterPage
	   * @param {Object} leavePage
	   * @param {Function} callback
	   */
	
	
	  createClass(MDLiftNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var _this2 = this;
	
	      this.backgroundMask.remove();
	      leavePage.parentNode.insertBefore(this.backgroundMask, leavePage);
	
	      var unblock = get(MDLiftNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDLiftNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      var maskClear = Animit(this.backgroundMask).wait(this.delay + this.duration).queue(function (done) {
	        _this2.backgroundMask.remove();
	        done();
	      });
	
	      Animit.runAll(maskClear, Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }), Animit(leavePage).queue({
	        css: {
	          opacity: 1.0
	        },
	        duration: 0
	      }).queue({
	        css: {
	          opacity: 0.4
	        },
	        duration: this.duration,
	        timing: this.timing
	      }));
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var _this3 = this;
	
	      this.backgroundMask.remove();
	      enterPage.parentNode.insertBefore(this.backgroundMask, enterPage);
	
	      var unblock = get(MDLiftNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDLiftNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(this.backgroundMask).wait(this.delay + this.duration).queue(function (done) {
	        _this3.backgroundMask.remove();
	        done();
	      }), Animit(enterPage).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 0.4
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1.0
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }), Animit(leavePage).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)'
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 100%, 0)'
	        },
	        duration: this.duration,
	        timing: this.timing
	      }));
	    }
	  }]);
	  return MDLiftNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Fade-in + Lift screen transition.
	 */
	
	var MDFadeNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(MDFadeNavigatorAnimator, _NavigatorAnimator);
	
	  function MDFadeNavigatorAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(0.4, 0.0, 0.2, 1)' : _ref$timing,
	        _ref$timingOnPop = _ref.timingOnPop,
	        timingOnPop = _ref$timingOnPop === undefined ? 'cubic-bezier(0.4, 0.0, 1, 1)' : _ref$timingOnPop,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, MDFadeNavigatorAnimator);
	
	    var _this = possibleConstructorReturn(this, (MDFadeNavigatorAnimator.__proto__ || Object.getPrototypeOf(MDFadeNavigatorAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.timingOnPop = timingOnPop;
	    return _this;
	  }
	
	  /**
	   * @param {Object} enterPage
	   * @param {Object} leavePage
	   * @param {Function} callback
	   */
	
	
	  createClass(MDFadeNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      var unblock = get(MDFadeNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDFadeNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(enterPage).saveStyle().queue({
	        css: {
	          transform: 'translate3D(0, 42px, 0)',
	          opacity: 0
	        },
	        duration: 0
	      }).wait(this.delay).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {Object} enterPage
	     * @param {Object} leavePage
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      var unblock = get(MDFadeNavigatorAnimator.prototype.__proto__ || Object.getPrototypeOf(MDFadeNavigatorAnimator.prototype), 'block', this).call(this, enterPage);
	
	      Animit.runAll(Animit(leavePage).queue({
	        css: {
	          transform: 'translate3D(0, 0, 0)',
	          opacity: 1
	        },
	        duration: 0
	      }).wait(0.15).queue({
	        css: {
	          transform: 'translate3D(0, 38px, 0)',
	          opacity: 0
	        },
	        duration: this.duration,
	        timing: this.timingOnPop
	      }).queue(function (done) {
	        unblock();
	        callback();
	        done();
	      }));
	    }
	  }]);
	  return MDFadeNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var NoneNavigatorAnimator = function (_NavigatorAnimator) {
	  inherits(NoneNavigatorAnimator, _NavigatorAnimator);
	
	  function NoneNavigatorAnimator(options) {
	    classCallCheck(this, NoneNavigatorAnimator);
	    return possibleConstructorReturn(this, (NoneNavigatorAnimator.__proto__ || Object.getPrototypeOf(NoneNavigatorAnimator)).call(this, options));
	  }
	
	  createClass(NoneNavigatorAnimator, [{
	    key: 'push',
	    value: function push(enterPage, leavePage, callback) {
	      callback();
	    }
	  }, {
	    key: 'pop',
	    value: function pop(enterPage, leavePage, callback) {
	      callback();
	    }
	  }]);
	  return NoneNavigatorAnimator;
	}(NavigatorAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var _animatorDict$4 = {
	  'default': function _default() {
	    return platform.isAndroid() ? MDFadeNavigatorAnimator : IOSSlideNavigatorAnimator;
	  },
	  'slide': function slide() {
	    return platform.isAndroid() ? MDSlideNavigatorAnimator : IOSSlideNavigatorAnimator;
	  },
	  'lift': function lift() {
	    return platform.isAndroid() ? MDLiftNavigatorAnimator : IOSLiftNavigatorAnimator;
	  },
	  'fade': function fade() {
	    return platform.isAndroid() ? MDFadeNavigatorAnimator : IOSFadeNavigatorAnimator;
	  },
	  'slide-ios': IOSSlideNavigatorAnimator,
	  'slide-md': MDSlideNavigatorAnimator,
	  'lift-ios': IOSLiftNavigatorAnimator,
	  'lift-md': MDLiftNavigatorAnimator,
	  'fade-ios': IOSFadeNavigatorAnimator,
	  'fade-md': MDFadeNavigatorAnimator,
	  'none': NoneNavigatorAnimator
	};
	
	var rewritables = {
	  /**
	   * @param {Element} navigatorSideElement
	   * @param {Function} callback
	   */
	  ready: function ready(navigatorElement, callback) {
	    callback();
	  }
	};
	
	/**
	 * @element ons-navigator
	 * @category navigation
	 * @description
	 *   [en]
	 *     A component that provides page stack management and navigation. Stack navigation is the most common navigation pattern for mobile apps.
	 *
	 *     When a page is pushed on top of the stack it is displayed with a transition animation. When the user returns to the previous page the top page will be popped from the top of the stack and hidden with an opposite transition animation.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen yrhtv
	 * @tutorial vanilla/Reference/navigator
	 * @guide lifecycle.html#events
	 *   [en]Overview of page events[/en]
	 *   [ja]Overview of page events[/ja]
	 * @seealso ons-toolbar
	 *   [en]The `<ons-toolbar>` component is used to display a toolbar on the top of a page.[/en]
	 *   [ja][/ja]
	 * @seealso ons-back-button
	 *   [en]The `<ons-back-button>` component lets the user return to the previous page.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-navigator id="navigator">
	 *   <ons-page>
	 *     <ons-toolbar>
	 *       <div class="center">
	 *         Title
	 *       </div>
	 *     </ons-toolbar>
	 *     <p>
	 *       <ons-button
	 *         onclick="document.getElementById('navigator').pushPage('page.html')">
	 *         Push page
	 *       </ons-button>
	 *     </p>
	 *   </ons-page>
	 * </ons-navigator>
	 *
	 * <template id="page.html">
	 *   <ons-page>
	 *     <ons-toolbar>
	 *       <div class="left">
	 *         <ons-back-button>Back</ons-back-button>
	 *       </div>
	 *       <div class="center">
	 *         Another page
	 *       </div>
	 *     </ons-toolbar>
	 *   </ons-page>
	 * </template>
	 */
	
	var NavigatorElement = function (_BaseElement) {
	  inherits(NavigatorElement, _BaseElement);
	  createClass(NavigatorElement, [{
	    key: 'animatorFactory',
	
	
	    /**
	     * @attribute page
	     * @initonly
	     * @type {String}
	     * @description
	     *   [en]First page to show when navigator is initialized.[/en]
	     *   [ja]ナビゲーターが初期化された時に表示するページを指定します。[/ja]
	     */
	
	    /**
	     * @attribute swipeable
	     * @type {Boolean}
	     * @description
	     *   [en]Enable iOS "swipe to pop" feature.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @attribute swipe-target-width
	     * @type {String}
	     * @default 20px
	     * @description
	     *   [en]The width of swipeable area calculated from the edge (in pixels). Use this to enable swipe only when the finger touch on the screen edge.[/en]
	     *   [ja]スワイプの判定領域をピクセル単位で指定します。画面の端から指定した距離に達するとページが表示されます。[/ja]
	     */
	
	    /**
	     * @attribute swipe-threshold
	     * @type {Number}
	     * @default 0.2
	     * @description
	     *  [en]Specify how much the page needs to be swiped before popping. A value between `0` and `1`.[/en]
	     *  [ja][/ja]
	     */
	
	    /**
	     * @attribute animation
	     * @type {String}
	     * @default default
	     * @description
	     *   [en]
	     *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	     *
	     *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"` depending on the platform.
	     *   [/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @attribute animation-options
	     * @type {Expression}
	     * @description
	     *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`[/en]
	     *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`[/ja]
	     */
	
	    /**
	     * @event prepush
	     * @description
	     *   [en]Fired just before a page is pushed.[/en]
	     *   [ja]pageがpushされる直前に発火されます。[/ja]
	     * @param {Object} event [en]Event object.[/en]
	     * @param {Object} event.navigator
	     *   [en]Component object.[/en]
	     *   [ja]コンポーネントのオブジェクト。[/ja]
	     * @param {Object} event.currentPage
	     *   [en]Current page object.[/en]
	     *   [ja]現在のpageオブジェクト。[/ja]
	     * @param {Function} event.cancel
	     *   [en]Call this function to cancel the push.[/en]
	     *   [ja]この関数を呼び出すと、push処理がキャンセルされます。[/ja]
	     */
	
	    /**
	     * @event prepop
	     * @description
	     *   [en]Fired just before a page is popped.[/en]
	     *   [ja]pageがpopされる直前に発火されます。[/ja]
	     * @param {Object} event [en]Event object.[/en]
	     * @param {Object} event.navigator
	     *   [en]Component object.[/en]
	     *   [ja]コンポーネントのオブジェクト。[/ja]
	     * @param {Object} event.currentPage
	     *   [en]Current page object.[/en]
	     *   [ja]現在のpageオブジェクト。[/ja]
	     * @param {Function} event.cancel
	     *   [en]Call this function to cancel the pop.[/en]
	     *   [ja]この関数を呼び出すと、pageのpopがキャンセルされます。[/ja]
	     */
	
	    /**
	     * @event postpush
	     * @description
	     *   [en]Fired just after a page is pushed.[/en]
	     *   [ja]pageがpushされてアニメーションが終了してから発火されます。[/ja]
	     * @param {Object} event [en]Event object.[/en]
	     * @param {Object} event.navigator
	     *   [en]Component object.[/en]
	     *   [ja]コンポーネントのオブジェクト。[/ja]
	     * @param {Object} event.enterPage
	     *   [en]Object of the next page.[/en]
	     *   [ja]pushされたpageオブジェクト。[/ja]
	     * @param {Object} event.leavePage
	     *   [en]Object of the previous page.[/en]
	     *   [ja]以前のpageオブジェクト。[/ja]
	     */
	
	    /**
	     * @event postpop
	     * @description
	     *   [en]Fired just after a page is popped.[/en]
	     *   [ja]pageがpopされてアニメーションが終わった後に発火されます。[/ja]
	     * @param {Object} event [en]Event object.[/en]
	     * @param {Object} event.navigator
	     *   [en]Component object.[/en]
	     *   [ja]コンポーネントのオブジェクト。[/ja]
	     * @param {Object} event.enterPage
	     *   [en]Object of the next page.[/en]
	     *   [ja]popされて表示されるページのオブジェクト。[/ja]
	     * @param {Object} event.leavePage
	     *   [en]Object of the previous page.[/en]
	     *   [ja]popされて消えるページのオブジェクト。[/ja]
	     */
	
	    get: function get$$1() {
	      return this._animatorFactory;
	    }
	  }]);
	
	  function NavigatorElement() {
	    classCallCheck(this, NavigatorElement);
	
	    var _this = possibleConstructorReturn(this, (NavigatorElement.__proto__ || Object.getPrototypeOf(NavigatorElement)).call(this));
	
	    _this._isRunning = false;
	    _this._initialized = false;
	    _this._pageLoader = defaultPageLoader;
	    _this._pageMap = new WeakMap();
	
	    _this._updateAnimatorFactory();
	    return _this;
	  }
	
	  /**
	   * @property pageLoader
	   * @type {PageLoader}
	   * @description
	   *   [en]PageLoader instance. It can be overriden to change the way pages are loaded by this element. Useful for lib developers.[/en]
	   *   [ja]PageLoaderインスタンスを格納しています。[/ja]
	   */
	
	
	  createClass(NavigatorElement, [{
	    key: '_getPageTarget',
	    value: function _getPageTarget() {
	      return this._page || this.getAttribute('page');
	    }
	
	    /**
	     * @property page
	     * @type {*}
	     * @description
	     *   [en]Specify the page to be loaded during initialization. This value takes precedence over the `page` attribute. Useful for lib developers.[/en]
	     *   [ja]初期化時に読み込むページを指定します。`page`属性で指定した値よりも`page`プロパティに指定した値を優先します。[/ja]
	     */
	
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      this.onDeviceBackButton = this._onDeviceBackButton.bind(this);
	
	      if (!platform.isAndroid() || this.getAttribute('swipeable') === 'force') {
	        this._swipeAnimator = new IOSSwipeNavigatorAnimator();
	        var pushAnimation = { duration: this._swipeAnimator.duration, timing: this._swipeAnimator.timing };
	        var popAnimation = { duration: this._swipeAnimator.durationRestore, timing: this._swipeAnimator.timing };
	
	        this._swipe = new SwipeReveal({
	          element: this,
	          swipeMax: function swipeMax() {
	            _this2._onSwipe && _this2._onSwipe(1, pushAnimation);
	            _this2[_this2.swipeMax ? 'swipeMax' : 'popPage']({ animator: _this2._swipeAnimator });
	          },
	          swipeMid: function swipeMid(distance, width) {
	            _this2._onSwipe && _this2._onSwipe(distance / width);
	            _this2._swipeAnimator.translate(distance, width, _this2.topPage.previousElementSibling, _this2.topPage);
	          },
	          swipeMin: function swipeMin() {
	            _this2._onSwipe && _this2._onSwipe(0, popAnimation);
	            _this2._swipeAnimator.restore(_this2.topPage.previousElementSibling, _this2.topPage);
	          },
	          getThreshold: function getThreshold() {
	            return Math.max(0.2, parseFloat(_this2.getAttribute('swipe-threshold')) || 0);
	          },
	          ignoreSwipe: function ignoreSwipe(event, distance) {
	            if (/ons-back-button/i.test(event.target.tagName) || util.findParent(event.target, 'ons-back-button', function (p) {
	              return (/ons-page/i.test(p.tagName)
	              );
	            })) {
	              return true;
	            }
	            var area = parseInt(_this2.getAttribute('swipe-target-width') || 25, 10);
	            return event.gesture.direction !== 'right' || area <= distance || _this2._isRunning || _this2.children.length <= 1;
	          }
	        });
	
	        this.attributeChangedCallback('swipeable');
	      }
	
	      if (this._initialized) {
	        return;
	      }
	
	      this._initialized = true;
	
	      var deferred = util.defer();
	      this.loaded = deferred.promise;
	
	      rewritables.ready(this, function () {
	        var show = !util.hasAnyComponentAsParent(_this2);
	        var options = { animation: 'none', show: show };
	
	        if (_this2.pages.length === 0 && _this2._getPageTarget()) {
	          _this2.pushPage(_this2._getPageTarget(), options).then(function () {
	            return deferred.resolve();
	          });
	        } else if (_this2.pages.length > 0) {
	          for (var i = 0; i < _this2.pages.length; i++) {
	            if (_this2.pages[i].nodeName !== 'ONS-PAGE') {
	              throw new Error('The children of <ons-navigator> need to be of type <ons-page>');
	            }
	          }
	
	          if (_this2.topPage) {
	            contentReady(_this2.topPage, function () {
	              return setTimeout(function () {
	                deferred.resolve();
	                show && _this2.topPage._show();
	                _this2._updateLastPageBackButton();
	              }, 0);
	            });
	          }
	        } else {
	          contentReady(_this2, function () {
	            if (_this2.pages.length === 0 && _this2._getPageTarget()) {
	              _this2.pushPage(_this2._getPageTarget(), options).then(function () {
	                return deferred.resolve();
	              });
	            } else {
	              deferred.resolve();
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      this._animatorFactory = new AnimatorFactory({
	        animators: _animatorDict$4,
	        baseClass: NavigatorAnimator,
	        baseClassName: 'NavigatorAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._backButtonHandler.destroy();
	      this._backButtonHandler = null;
	
	      this._swipe && this._swipe.dispose();
	      this._swipe = this._swipeAnimator = null;
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'animation':
	          this._updateAnimatorFactory();
	          break;
	        case 'swipeable':
	          this._swipe && this._swipe.update();
	          break;
	      }
	    }
	
	    /**
	     * @method popPage
	     * @signature popPage([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]
	     *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	     *
	     *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"`.
	     *   [/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]Function that is called when the transition has ended.[/en]
	     *   [ja]このメソッドによる画面遷移が終了した際に呼び出される関数オブジェクトを指定します。[/ja]
	     * @param {Object} [options.data]
	     *   [en]Custom data that will be stored in the new page element.[/en]
	     *   [ja][/ja]
	     * @param {Number} [options.times]
	     *   [en]Number of pages to be popped. Only one animation will be shown.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Pops the current page from the page stack. The previous page will be displayed.[/en]
	     *   [ja]現在表示中のページをページスタックから取り除きます。一つ前のページに戻ります。[/ja]
	     */
	
	  }, {
	    key: 'popPage',
	    value: function popPage() {
	      var _this3 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _preparePageAndOption = this._preparePageAndOptions(null, options);
	
	      options = _preparePageAndOption.options;
	
	
	      if (util.isInteger(options.times) && options.times > 1) {
	        this._removePages(options.times);
	      }
	
	      var popUpdate = function popUpdate() {
	        return new Promise(function (resolve) {
	          _this3._pageLoader.unload(_this3.pages[_this3.pages.length - 1]);
	          resolve();
	        });
	      };
	
	      return this._popPage(options, popUpdate);
	    }
	  }, {
	    key: '_popPage',
	    value: function _popPage(options) {
	      var _this4 = this;
	
	      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return Promise.resolve();
	      };
	
	      if (this._isRunning) {
	        return Promise.reject('popPage is already running.');
	      }
	
	      if (this.pages.length <= 1) {
	        return Promise.reject('ons-navigator\'s page stack is empty.');
	      }
	
	      if (this._emitPrePopEvent()) {
	        return Promise.reject('Canceled in prepop event.');
	      }
	
	      var length = this.pages.length;
	
	      this._isRunning = true;
	
	      this.pages[length - 2].updateBackButton(length - 2 > 0);
	
	      return new Promise(function (resolve) {
	        var leavePage = _this4.pages[length - 1];
	        var enterPage = _this4.pages[length - 2];
	
	        options = util.extend({}, _this4.options || {}, leavePage.pushedOptions || {}, options);
	
	        if (options.data) {
	          enterPage.data = util.extend({}, enterPage.data || {}, options.data || {});
	        }
	
	        var done = function done() {
	          update().then(function () {
	            _this4._isRunning = false;
	
	            enterPage._show();
	            util.triggerElementEvent(_this4, 'postpop', { leavePage: leavePage, enterPage: enterPage, navigator: _this4 });
	
	            options.callback && options.callback(enterPage);
	
	            resolve(enterPage);
	          });
	        };
	
	        leavePage._hide();
	        enterPage.style.display = '';
	
	        var animator = options.animator || _this4._animatorFactory.newAnimator(options);
	        animator.pop(_this4.pages[length - 2], _this4.pages[length - 1], done);
	      }).catch(function () {
	        return _this4._isRunning = false;
	      });
	    }
	
	    /**
	     * @method pushPage
	     * @signature pushPage(page, [options])
	     * @param {String} page
	     *   [en]Page URL. Can be either a HTML document or a template defined with the `<template>` tag.[/en]
	     *   [ja]pageのURLか、もしくは`<template>`で宣言したテンプレートのid属性の値を指定できます。[/ja]
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.page]
	     *   [en]Page URL. Only necessary if `page` parameter is null or undefined.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.pageHTML]
	     *   [en]HTML code that will be computed as a new page. Overwrites `page` parameter.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]
	     *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	     *
	     *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"`.
	     *   [/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}` [/ja]
	     * @param {Function} [options.callback]
	     *   [en]Function that is called when the transition has ended.[/en]
	     *   [ja]pushPage()による画面遷移が終了した時に呼び出される関数オブジェクトを指定します。[/ja]
	     * @param {Object} [options.data]
	     *   [en]Custom data that will be stored in the new page element.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the pushed page.[/en]
	     *   [ja]追加したページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Pushes the specified page into the stack.[/en]
	     *   [ja]指定したpageを新しいページスタックに追加します。新しいページが表示されます。[/ja]
	     */
	
	  }, {
	    key: 'pushPage',
	    value: function pushPage(page) {
	      var _this5 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var _preparePageAndOption2 = this._preparePageAndOptions(page, options);
	
	      page = _preparePageAndOption2.page;
	      options = _preparePageAndOption2.options;
	
	
	      var prepare = function prepare(pageElement) {
	        _this5._verifyPageElement(pageElement);
	        _this5._pageMap.set(pageElement, page);
	        pageElement = util.extend(pageElement, {
	          data: options.data
	        });
	        pageElement.style.visibility = 'hidden';
	      };
	
	      if (options.pageHTML) {
	        return this._pushPage(options, function () {
	          return new Promise(function (resolve) {
	            instantPageLoader.load({ page: options.pageHTML, parent: _this5, params: options.data }, function (pageElement) {
	              prepare(pageElement);
	              resolve();
	            });
	          });
	        });
	      }
	
	      return this._pushPage(options, function () {
	        return new Promise(function (resolve) {
	          _this5._pageLoader.load({ page: page, parent: _this5, params: options.data }, function (pageElement) {
	            prepare(pageElement);
	            resolve();
	          });
	        });
	      });
	    }
	  }, {
	    key: '_pushPage',
	    value: function _pushPage() {
	      var _this6 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return Promise.resolve();
	      };
	
	      if (this._isRunning) {
	        return Promise.reject('pushPage is already running.');
	      }
	
	      if (this._emitPrePushEvent()) {
	        return Promise.reject('Canceled in prepush event.');
	      }
	
	      this._isRunning = true;
	
	      var animationOptions = AnimatorFactory.parseAnimationOptionsString(this.getAttribute('animation-options'));
	      options = util.extend({}, this.options || {}, { animationOptions: animationOptions }, options);
	
	      var animator = this._animatorFactory.newAnimator(options);
	
	      return update().then(function () {
	        var pageLength = _this6.pages.length;
	
	        var enterPage = _this6.pages[pageLength - 1];
	        var leavePage = options.leavePage || _this6.pages[pageLength - 2];
	
	        if (enterPage.nodeName !== 'ONS-PAGE') {
	          throw new Error('Only elements of type <ons-page> can be pushed to the navigator');
	        }
	
	        enterPage.updateBackButton(pageLength > (options._replacePage ? 2 : 1));
	
	        enterPage.pushedOptions = util.extend({}, enterPage.pushedOptions || {}, options || {});
	        enterPage.data = util.extend({}, enterPage.data || {}, options.data || {});
	        enterPage.unload = enterPage.unload || options.unload;
	
	        return new Promise(function (resolve) {
	          var done = function done() {
	            _this6._isRunning = false;
	
	            options.show !== false && setImmediate(function () {
	              return enterPage._show();
	            });
	            util.triggerElementEvent(_this6, 'postpush', { leavePage: leavePage, enterPage: enterPage, navigator: _this6 });
	
	            if (leavePage) {
	              leavePage.style.display = 'none';
	            }
	
	            options.callback && options.callback(enterPage);
	
	            resolve(enterPage);
	          };
	
	          enterPage.style.visibility = '';
	          if (leavePage) {
	            leavePage._hide();
	            animator.push(enterPage, leavePage, done);
	          } else {
	            done();
	          }
	        });
	      }).catch(function (error) {
	        _this6._isRunning = false;
	        throw error;
	      });
	    }
	
	    /**
	     * @method replacePage
	     * @signature replacePage(page, [options])
	     * @return {Promise}
	     *   [en]Promise which resolves to the new page.[/en]
	     *   [ja]新しいページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Replaces the current top page with the specified one. Extends `pushPage()` parameters.[/en]
	     *   [ja]現在表示中のページをを指定したページに置き換えます。[/ja]
	     */
	
	  }, {
	    key: 'replacePage',
	    value: function replacePage(page) {
	      var _this7 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.pushPage(page, options).then(function (resolvedValue) {
	        if (_this7.pages.length > 1) {
	          _this7._pageLoader.unload(_this7.pages[_this7.pages.length - 2]);
	        }
	        _this7._updateLastPageBackButton();
	
	        return Promise.resolve(resolvedValue);
	      });
	    }
	
	    /**
	     * @method insertPage
	     * @signature insertPage(index, page, [options])
	     * @param {Number} index
	     *   [en]The index where it should be inserted.[/en]
	     *   [ja]スタックに挿入する位置のインデックスを指定します。[/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the inserted page.[/en]
	     *   [ja]指定したページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Insert the specified page into the stack with at a position defined by the `index` argument. Extends `pushPage()` parameters.[/en]
	     *   [ja]指定したpageをページスタックのindexで指定した位置に追加します。[/ja]
	     */
	
	  }, {
	    key: 'insertPage',
	    value: function insertPage(index, page) {
	      var _this8 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var _preparePageAndOption3 = this._preparePageAndOptions(page, options);
	
	      page = _preparePageAndOption3.page;
	      options = _preparePageAndOption3.options;
	
	      index = this._normalizeIndex(index);
	
	      if (index >= this.pages.length) {
	        return this.pushPage(page, options);
	      }
	
	      page = typeof options.pageHTML === 'string' ? options.pageHTML : page;
	      var loader = typeof options.pageHTML === 'string' ? instantPageLoader : this._pageLoader;
	
	      return new Promise(function (resolve) {
	        loader.load({ page: page, parent: _this8 }, function (pageElement) {
	          _this8._verifyPageElement(pageElement);
	          _this8._pageMap.set(pageElement, page);
	          pageElement = util.extend(pageElement, {
	            data: options.data,
	            pushedOptions: options
	          });
	
	          options.animationOptions = util.extend({}, AnimatorFactory.parseAnimationOptionsString(_this8.getAttribute('animation-options')), options.animationOptions || {});
	
	          pageElement.style.display = 'none';
	          _this8.insertBefore(pageElement, _this8.pages[index]);
	          _this8.topPage.updateBackButton(true);
	
	          setTimeout(function () {
	            pageElement = null;
	            resolve(_this8.pages[index]);
	          }, 1000 / 60);
	        });
	      });
	    }
	
	    /**
	     * @method removePage
	     * @signature removePage(index, [options])
	     * @param {Number} index
	     *   [en]The index where it should be removed.[/en]
	     *   [ja]スタックから削除するページのインデックスを指定します。[/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the revealed page.[/en]
	     *   [ja]削除によって表示されたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Remove the specified page at a position in the stack defined by the `index` argument. Extends `popPage()` parameters.[/en]
	     *   [ja]指定したインデックスにあるページを削除します。[/ja]
	     */
	
	  }, {
	    key: 'removePage',
	    value: function removePage(index) {
	      var _this9 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      index = this._normalizeIndex(index);
	
	      if (index < this.pages.length - 1) {
	        return new Promise(function (resolve) {
	          var leavePage = _this9.pages[index];
	          var enterPage = _this9.topPage;
	
	          _this9._pageMap.delete(leavePage);
	          _this9._pageLoader.unload(leavePage);
	          if (_this9.pages.length === 1) {
	            // edge case
	            _this9.topPage.updateBackButton(false);
	          }
	
	          resolve(enterPage);
	        });
	      } else {
	        return this.popPage(options);
	      }
	    }
	
	    /**
	     * @method resetToPage
	     * @signature resetToPage(page, [options])
	     * @return {Promise}
	     *   [en]Promise which resolves to the new top page.[/en]
	     *   [ja]新しいトップページを解決するPromiseを返します。[/ja]
	     * @param {Boolean} [options.pop]
	     *   [en]Performs 'pop' effect if `true` instead of 'push' or none. This also sets `options.animation` value to `default` instead of `none`.[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Clears page stack and adds the specified page to the stack. Extends `pushPage()` parameters.[/en]
	     *   [ja]ページスタックをリセットし、指定したページを表示します。[/ja]
	     */
	
	  }, {
	    key: 'resetToPage',
	    value: function resetToPage(page) {
	      var _this10 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var _preparePageAndOption4 = this._preparePageAndOptions(page, options);
	
	      page = _preparePageAndOption4.page;
	      options = _preparePageAndOption4.options;
	
	
	      if (!options.animator && !options.animation && !options.pop) {
	        options.animation = 'none';
	      }
	
	      if (!options.page && !options.pageHTML && this._getPageTarget()) {
	        page = options.page = this._getPageTarget();
	      }
	
	      if (options.pop) {
	        this._removePages();
	        return this.insertPage(0, page, { data: options.data }).then(function () {
	          return _this10.popPage(options);
	        });
	      }
	
	      // Tip: callback runs before resolved promise
	      var callback = options.callback;
	      options.callback = function (newPage) {
	        _this10._removePages();
	        newPage.updateBackButton(false);
	        callback && callback(newPage);
	      };
	
	      return this.pushPage(page, options);
	    }
	
	    /**
	     * @method bringPageTop
	     * @signature bringPageTop(item, [options])
	     * @param {String|Number} item
	     *   [en]Page URL or index of an existing page in navigator's stack.[/en]
	     *   [ja]ページのURLかもしくはons-navigatorのページスタックのインデックス値を指定します。[/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the new top page.[/en]
	     *   [ja]新しいトップページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Brings the given page to the top of the page stack if it already exists or pushes it into the stack if doesn't. Extends `pushPage()` parameters.[/en]
	     *   [ja]指定したページをページスタックの一番上に移動します。もし指定したページが無かった場合新しくpushされます。[/ja]
	     */
	
	  }, {
	    key: 'bringPageTop',
	    value: function bringPageTop(item) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (['number', 'string'].indexOf(typeof item === 'undefined' ? 'undefined' : _typeof(item)) === -1) {
	        throw new Error('First argument must be a page name or the index of an existing page. You supplied ' + item);
	      }
	      var index = typeof item === 'number' ? this._normalizeIndex(item) : this._lastIndexOfPage(item);
	      var page = this.pages[index];
	
	      if (index < 0) {
	        return this.pushPage(item, options);
	      }
	
	      var _preparePageAndOption5 = this._preparePageAndOptions(page, options);
	
	      options = _preparePageAndOption5.options;
	
	
	      if (index === this.pages.length - 1) {
	        return Promise.resolve(page);
	      }
	      if (!page) {
	        throw new Error('Failed to find item ' + item);
	      }
	      if (this._isRunning) {
	        return Promise.reject('pushPage is already running.');
	      }
	      if (this._emitPrePushEvent()) {
	        return Promise.reject('Canceled in prepush event.');
	      }
	
	      page.style.display = '';
	      page.style.visibility = 'hidden';
	      page.parentNode.appendChild(page);
	      return this._pushPage(options);
	    }
	  }, {
	    key: '_preparePageAndOptions',
	    value: function _preparePageAndOptions(page) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) != 'object') {
	        throw new Error('options must be an object. You supplied ' + options);
	      }
	
	      if ((page === null || page === undefined) && options.page) {
	        page = options.page;
	      }
	
	      options = util.extend({}, this.options || {}, options, { page: page });
	
	      return { page: page, options: options };
	    }
	  }, {
	    key: '_removePages',
	    value: function _removePages(times) {
	      var pages = this.pages;
	      var until = times === undefined ? 0 : pages.length - times;
	      until = until < 0 ? 1 : until;
	
	      for (var i = pages.length - 2; i >= until; i--) {
	        this._pageMap.delete(pages[i]);
	        this._pageLoader.unload(pages[i]);
	      }
	    }
	  }, {
	    key: '_updateLastPageBackButton',
	    value: function _updateLastPageBackButton() {
	      var index = this.pages.length - 1;
	      if (index >= 0) {
	        this.pages[index].updateBackButton(index > 0);
	      }
	    }
	  }, {
	    key: '_normalizeIndex',
	    value: function _normalizeIndex(index) {
	      return index >= 0 ? index : Math.abs(this.pages.length + index) % this.pages.length;
	    }
	  }, {
	    key: '_onDeviceBackButton',
	    value: function _onDeviceBackButton(event) {
	      if (this.pages.length > 1) {
	        this.popPage();
	      } else {
	        event.callParentHandler();
	      }
	    }
	  }, {
	    key: '_lastIndexOfPage',
	    value: function _lastIndexOfPage(pageName) {
	      var index = void 0;
	      for (index = this.pages.length - 1; index >= 0; index--) {
	        if (!this._pageMap.has(this.pages[index])) {
	          throw Error('This is bug.');
	        }
	
	        if (pageName === this._pageMap.get(this.pages[index])) {
	          break;
	        }
	      }
	      return index;
	    }
	  }, {
	    key: '_emitPreEvent',
	    value: function _emitPreEvent(name) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var isCanceled = false;
	
	      util.triggerElementEvent(this, 'pre' + name, util.extend({
	        navigator: this,
	        currentPage: this.pages[this.pages.length - 1],
	        cancel: function cancel() {
	          return isCanceled = true;
	        }
	      }, data));
	
	      return isCanceled;
	    }
	  }, {
	    key: '_emitPrePushEvent',
	    value: function _emitPrePushEvent() {
	      return this._emitPreEvent('push');
	    }
	  }, {
	    key: '_emitPrePopEvent',
	    value: function _emitPrePopEvent() {
	      var l = this.pages.length;
	      return this._emitPreEvent('pop', {
	        leavePage: this.pages[l - 1],
	        enterPage: this.pages[l - 2]
	      });
	    }
	
	    // TODO: 書き直す
	
	  }, {
	    key: '_createPageElement',
	    value: function _createPageElement(templateHTML) {
	      var pageElement = util.createElement(internal$1.normalizePageHTML(templateHTML));
	      this._verifyPageElement(pageElement);
	      return pageElement;
	    }
	
	    /**
	     * @param {Element} element
	     */
	
	  }, {
	    key: '_verifyPageElement',
	    value: function _verifyPageElement(element) {
	      if (element.nodeName.toLowerCase() !== 'ons-page') {
	        throw new Error('You must supply an "ons-page" element to "ons-navigator".');
	      }
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: '_show',
	    value: function _show() {
	      var _this11 = this;
	
	      this.loaded.then(function () {
	        return _this11.topPage && _this11.topPage._show();
	      });
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      this.topPage && this.topPage._hide();
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      for (var i = this.pages.length - 1; i >= 0; i--) {
	        this._pageLoader.unload(this.pages[i]);
	      }
	
	      this.remove();
	    }
	
	    /**
	     * @param {String} name
	     * @param {Function} Animator
	     */
	
	  }, {
	    key: 'pageLoader',
	    get: function get$$1() {
	      return this._pageLoader;
	    },
	    set: function set$$1(pageLoader) {
	      if (!(pageLoader instanceof PageLoader)) {
	        throw Error('First parameter must be an instance of PageLoader.');
	      }
	      this._pageLoader = pageLoader;
	    }
	  }, {
	    key: 'page',
	    get: function get$$1() {
	      return this._page;
	    },
	    set: function set$$1(page) {
	      this._page = page;
	    }
	  }, {
	    key: 'onDeviceBackButton',
	    get: function get$$1() {
	      return this._backButtonHandler;
	    },
	    set: function set$$1(callback) {
	      if (this._backButtonHandler) {
	        this._backButtonHandler.destroy();
	      }
	
	      this._backButtonHandler = deviceBackButtonDispatcher.createHandler(this, callback);
	    }
	
	    /**
	     * @property topPage
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]Current top page element. Use this method to access options passed by `pushPage()`-like methods.[/en]
	     *   [ja]現在のページを取得します。pushPage()やresetToPage()メソッドの引数を取得できます。[/ja]
	     */
	
	  }, {
	    key: 'topPage',
	    get: function get$$1() {
	      var last = this.lastElementChild;
	      while (last && last.tagName !== 'ONS-PAGE') {
	        last = last.previousElementSibling;
	      }
	      return last;
	    }
	
	    /**
	     * @property pages
	     * @readonly
	     * @type {Array}
	     * @description
	     *   [en]Copy of the navigator's page stack.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'pages',
	    get: function get$$1() {
	      return util.arrayFrom(this.children).filter(function (element) {
	        return element.tagName === 'ONS-PAGE';
	      });
	    }
	
	    /**
	     * @property onSwipe
	     * @type {Function}
	     * @description
	     *   [en]Hook called whenever the user slides the navigator (swipe-to-pop). It gets a decimal ratio (0-1) and an animationOptions object as arguments.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'onSwipe',
	    get: function get$$1() {
	      return this._onSwipe;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onSwipe\' must be a function.');
	      }
	      this._onSwipe = value;
	    }
	
	    /**
	     * @property options
	     * @type {Object}
	     * @description
	     *   [en]Default options object. Attributes have priority over this property.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property options.animation
	     * @type {String}
	     * @description
	     *   [en]
	     *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	     *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"`.
	     *   [/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property options.animationOptions
	     * @type {String}
	     * @description
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}` [/ja]
	     */
	
	    /**
	     * @property options.callback
	     * @type {String}
	     * @description
	     *   [en]Function that is called when the transition has ended.[/en]
	     *   [ja]このメソッドによる画面遷移が終了した際に呼び出される関数オブジェクトを指定します。[/ja]
	     */
	
	  }, {
	    key: 'options',
	    get: function get$$1() {
	      return this._options;
	    },
	    set: function set$$1(object) {
	      this._options = object;
	    }
	  }, {
	    key: '_isRunning',
	    set: function set$$1(value) {
	      this.setAttribute('_is-running', value ? 'true' : 'false');
	    },
	    get: function get$$1() {
	      return JSON.parse(this.getAttribute('_is-running'));
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof NavigatorAnimator)) {
	        throw new Error('"Animator" param must inherit NavigatorElement.NavigatorAnimator');
	      }
	
	      _animatorDict$4[name] = Animator;
	    }
	  }, {
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['animation', 'swipeable'];
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$4;
	    }
	  }, {
	    key: 'NavigatorAnimator',
	    get: function get$$1() {
	      return NavigatorAnimator;
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['prepush', 'postpush', 'prepop', 'postpop'];
	    }
	  }, {
	    key: 'rewritables',
	    get: function get$$1() {
	      return rewritables;
	    }
	  }]);
	  return NavigatorElement;
	}(BaseElement);
	
	onsElements.Navigator = NavigatorElement;
	customElements.define('ons-navigator', NavigatorElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$10 = 'toolbar';
	
	var scheme$18 = {
	  '': 'toolbar--*',
	  '.toolbar__left': 'toolbar--*__left',
	  '.toolbar__center': 'toolbar--*__center',
	  '.toolbar__right': 'toolbar--*__right'
	};
	
	/**
	 * @element ons-toolbar
	 * @category page
	 * @modifier material
	 *   [en]Material Design toolbar.[/en]
	 *   [ja][/ja]
	 * @modifier transparent
	 *   [en]Transparent toolbar.[/en]
	 *   [ja]透明な背景を持つツールバーを表示します。[/ja]
	 * @modifier cover-content
	 *   [en]Displays the toolbar on top of the page's content. Should be combined with `transparent` modifier.[/en]
	 *   [ja][/ja]
	 * @modifier noshadow
	 *   [en]Toolbar without shadow.[/en]
	 *   [ja]ツールバーに影を付けずに表示します。[/ja]
	 * @description
	 *   [en]
	 *     Toolbar component that can be used with navigation.
	 *
	 *     Left, center and right container can be specified by class names.
	 *
	 *     This component will automatically displays as a Material Design toolbar when running on Android devices.
	 *   [/en]
	 *   [ja]ナビゲーションで使用するツールバー用コンポーネントです。クラス名により、左、中央、右のコンテナを指定できます。[/ja]
	 * @codepen aHmGL
	 * @tutorial vanilla/Reference/page
	 * @guide compilation.html#toolbar-compilation [en]Adding a toolbar[/en][ja]ツールバーの追加[/ja]
	 * @seealso ons-bottom-toolbar
	 *   [en]The `<ons-bottom-toolbar>` displays a toolbar on the bottom of the page.[/en]
	 *   [ja]ons-bottom-toolbarコンポーネント[/ja]
	 * @seealso ons-back-button
	 *   [en]The `<ons-back-button>` component displays a back button inside the toolbar.[/en]
	 *   [ja]ons-back-buttonコンポーネント[/ja]
	 * @seealso ons-toolbar-button
	 *   [en]The `<ons-toolbar-button>` component displays a toolbar button inside the toolbar.[/en]
	 *   [ja]ons-toolbar-buttonコンポーネント[/ja]
	 * @example
	 * <ons-page>
	 *   <ons-toolbar>
	 *     <div class="left">
	 *       <ons-back-button>
	 *         Back
	 *       </ons-back-button>
	 *     </div>
	 *     <div class="center">
	 *       Title
	 *     </div>
	 *     <div class="right">
	 *       <ons-toolbar-button>
	 *         <ons-icon icon="md-menu"></ons-icon>
	 *       </ons-toolbar-button>
	 *     </div>
	 *   </ons-toolbar>
	 * </ons-page>
	 */
	
	var ToolbarElement = function (_BaseElement) {
	  inherits(ToolbarElement, _BaseElement);
	
	  /**
	   * @attribute inline
	   * @initonly
	   * @description
	   *   [en]Display the toolbar as an inline element.[/en]
	   *   [ja]ツールバーをインラインに置きます。スクロール領域内にそのまま表示されます。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @description
	   *   [en]The appearance of the toolbar.[/en]
	   *   [ja]ツールバーの表現を指定します。[/ja]
	   */
	
	  function ToolbarElement() {
	    classCallCheck(this, ToolbarElement);
	
	    var _this = possibleConstructorReturn(this, (ToolbarElement.__proto__ || Object.getPrototypeOf(ToolbarElement)).call(this));
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ToolbarElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$10, scheme$18);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$18);
	          break;
	      }
	    }
	
	    /**
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_getToolbarLeftItemsElement',
	    value: function _getToolbarLeftItemsElement() {
	      return this.querySelector('.left') || internal$1.nullElement;
	    }
	
	    /**
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_getToolbarCenterItemsElement',
	    value: function _getToolbarCenterItemsElement() {
	      return this.querySelector('.center') || internal$1.nullElement;
	    }
	
	    /**
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_getToolbarRightItemsElement',
	    value: function _getToolbarRightItemsElement() {
	      return this.querySelector('.right') || internal$1.nullElement;
	    }
	
	    /**
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_getToolbarBackButtonLabelElement',
	    value: function _getToolbarBackButtonLabelElement() {
	      return this.querySelector('ons-back-button .back-button__label') || internal$1.nullElement;
	    }
	
	    /**
	     * @return {HTMLElement}
	     */
	
	  }, {
	    key: '_getToolbarBackButtonIconElement',
	    value: function _getToolbarBackButtonIconElement() {
	      return this.querySelector('ons-back-button .back-button__icon') || internal$1.nullElement;
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$10);
	      this._ensureToolbarItemElements();
	      ModifierUtil.initModifier(this, scheme$18);
	    }
	  }, {
	    key: '_ensureToolbarItemElements',
	    value: function _ensureToolbarItemElements() {
	      for (var i = this.childNodes.length - 1; i >= 0; i--) {
	        // case of not element
	        if (this.childNodes[i].nodeType != 1) {
	          this.removeChild(this.childNodes[i]);
	        }
	      }
	
	      var center = this._ensureToolbarElement('center');
	      center.classList.add('toolbar__title');
	
	      if (this.children.length !== 1 || !this.children[0].classList.contains('center')) {
	        var left = this._ensureToolbarElement('left');
	        var right = this._ensureToolbarElement('right');
	
	        if (this.children[0] !== left || this.children[1] !== center || this.children[2] !== right) {
	          this.appendChild(left);
	          this.appendChild(center);
	          this.appendChild(right);
	        }
	      }
	    }
	  }, {
	    key: '_ensureToolbarElement',
	    value: function _ensureToolbarElement(name) {
	      if (util.findChild(this, '.toolbar__' + name)) {
	        var _element = util.findChild(this, '.toolbar__' + name);
	        _element.classList.add(name);
	        return _element;
	      }
	
	      var element = util.findChild(this, '.' + name) || util.create('.' + name);
	      element.classList.add('toolbar__' + name);
	
	      return element;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'];
	    }
	  }]);
	  return ToolbarElement;
	}(BaseElement);
	
	onsElements.Toolbar = ToolbarElement;
	customElements.define('ons-toolbar', ToolbarElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$9 = 'page';
	var scheme$17 = {
	  '': 'page--*',
	  '.page__content': 'page--*__content',
	  '.page__background': 'page--*__background'
	};
	
	/**
	 * @element ons-page
	 * @category page
	 * @modifier material
	 *   [en]Material Design style[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]
	 *     This component defines the root of each page. If the content is large it will become scrollable.
	 *
	 *     A navigation bar can be added to the top of the page using the `<ons-toolbar>` element.
	 *   [/en]
	 *   [ja]ページ定義のためのコンポーネントです。このコンポーネントの内容はスクロールが許可されます。[/ja]
	 * @tutorial vanilla/Reference/page
	 * @guide lifecycle.html#events
	 *   [en]Overview of page events[/en]
	 *   [ja]Overview of page events[/ja]
	 * @guide fundamentals.html#managing-pages
	 *   [en]Managing multiple pages[/en]
	 *   [ja]複数のページを管理する[/ja]
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @seealso ons-toolbar
	 *   [en]Use the `<ons-toolbar>` element to add a navigation bar to the top of the page.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-page>
	 *   <ons-toolbar>
	 *     <div class="left">
	 *       <ons-back-button>Back</ons-back-button>
	 *     </div>
	 *     <div class="center">Title</div>
	 *     <div class="right">
	 *       <ons-toolbar-button>
	 *         <ons-icon icon="md-menu"></ons-icon>
	 *       </ons-toolbar-button>
	 *     </div>
	 *   </ons-toolbar>
	 *
	 *   <p>Page content</p>
	 * </ons-page>
	 *
	 * @example
	 * <script>
	 *   myApp.handler = function(done) {
	 *     loadMore().then(done);
	 *   }
	 * </script>
	 *
	 * <ons-page on-infinite-scroll="myApp.handler">
	 *   <ons-toolbar>
	 *     <div class="center">List</div>
	 *   </ons-toolbar>
	 *
	 *   <ons-list>
	 *     <ons-list-item>#1</ons-list-item>
	 *     <ons-list-item>#2</ons-list-item>
	 *     <ons-list-item>#3</ons-list-item>
	 *     ...
	 *   </ons-list>
	 * </ons-page>
	 */
	
	var PageElement = function (_BaseElement) {
	  inherits(PageElement, _BaseElement);
	
	  /**
	   * @event init
	   * @description
	   *   [en]Fired right after the page is attached.[/en]
	   *   [ja]ページがアタッチされた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   */
	
	  /**
	   * @event show
	   * @description
	   *   [en]Fired right after the page is shown.[/en]
	   *   [ja]ページが表示された後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   */
	
	  /**
	   * @event hide
	   * @description
	   *   [en]Fired right after the page is hidden.[/en]
	   *   [ja]ページが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   */
	
	  /**
	   * @event destroy
	   * @description
	   *   [en]Fired right before the page is destroyed.[/en]
	   *   [ja]ページが破棄される前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]Specify modifier name to specify custom styles.[/en]
	   *   [ja]スタイル定義をカスタマイズするための名前を指定します。[/ja]
	   */
	
	  /**
	   * @attribute on-infinite-scroll
	   * @type {String}
	   * @description
	   *   [en]Path of the function to be executed on infinite scrolling. Example: `app.loadData`. The function receives a done callback that must be called when it's finished.[/en]
	   *   [ja][/ja]
	   */
	
	  function PageElement() {
	    classCallCheck(this, PageElement);
	
	    var _this = possibleConstructorReturn(this, (PageElement.__proto__ || Object.getPrototypeOf(PageElement)).call(this));
	
	    _this._deriveHooks();
	
	    _this._defaultClassName = defaultClassName$9;
	    _this.classList.add(defaultClassName$9);
	
	    _this._initialized = false;
	
	    contentReady(_this, function () {
	      _this._compile();
	
	      _this._isShown = false;
	      _this._contentElement = _this._getContentElement();
	      _this._backgroundElement = _this._getBackgroundElement();
	    });
	    return _this;
	  }
	
	  createClass(PageElement, [{
	    key: '_compile',
	    value: function _compile() {
	      var _this2 = this;
	
	      autoStyle.prepare(this);
	
	      var toolbar = util.findChild(this, 'ons-toolbar');
	
	      var background = util.findChild(this, '.page__background') || util.findChild(this, '.background') || document.createElement('div');
	      background.classList.add('page__background');
	      this.insertBefore(background, !toolbar && this.firstChild || toolbar && toolbar.nextSibling);
	
	      var content = util.findChild(this, '.page__content') || util.findChild(this, '.content') || document.createElement('div');
	      content.classList.add('page__content');
	      if (!content.parentElement) {
	        util.arrayFrom(this.childNodes).forEach(function (node) {
	          if (node.nodeType !== 1 || _this2._elementShouldBeMoved(node)) {
	            content.appendChild(node); // Can trigger detached connectedCallbacks
	          }
	        });
	      }
	
	      this._tryToFillStatusBar(content); // Must run before child pages try to fill status bar.
	      this.insertBefore(content, background.nextSibling); // Can trigger attached connectedCallbacks
	
	      if ((!toolbar || !util.hasModifier(toolbar, 'transparent')) && content.children.length === 1 && util.isPageControl(content.children[0])) {
	        this._defaultClassName += ' page--wrapper';
	        this.attributeChangedCallback('class');
	      }
	
	      ModifierUtil.initModifier(this, scheme$17);
	    }
	  }, {
	    key: '_elementShouldBeMoved',
	    value: function _elementShouldBeMoved(el) {
	      if (el.classList.contains('page__background')) {
	        return false;
	      }
	      var tagName = el.tagName.toLowerCase();
	      if (tagName === 'ons-fab') {
	        return !el.hasAttribute('position');
	      }
	      var fixedElements = ['script', 'ons-toolbar', 'ons-bottom-toolbar', 'ons-modal', 'ons-speed-dial', 'ons-dialog', 'ons-alert-dialog', 'ons-popover', 'ons-action-sheet'];
	      return el.hasAttribute('inline') || fixedElements.indexOf(tagName) === -1;
	    }
	  }, {
	    key: '_tryToFillStatusBar',
	    value: function _tryToFillStatusBar() {
	      var _this3 = this;
	
	      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._contentElement;
	
	      internal$1.autoStatusBarFill(function () {
	        util.toggleAttribute(_this3, 'status-bar-fill', !util.findParent(_this3, function (e) {
	          return e.hasAttribute('status-bar-fill');
	        }) // Not already filled
	        && (_this3._canAnimateToolbar(content) || !util.findChild(content, util.isPageControl)) // Has toolbar or cannot delegate
	        );
	      });
	    }
	  }, {
	    key: '_canAnimateToolbar',
	    value: function _canAnimateToolbar() {
	      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._contentElement;
	
	      if (util.findChild(this, 'ons-toolbar')) {
	        return true;
	      }
	      return !!util.findChild(content, function (el) {
	        return util.match(el, 'ons-toolbar') && !el.hasAttribute('inline');
	      });
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this4 = this;
	
	      if (!util.isAttached(this)) {
	        // Avoid detached calls
	        return;
	      }
	
	      contentReady(this, function () {
	        _this4._tryToFillStatusBar(); // Ensure status bar when the element was compiled before connected
	
	        if (_this4.hasAttribute('on-infinite-scroll')) {
	          _this4.attributeChangedCallback('on-infinite-scroll', null, _this4.getAttribute('on-infinite-scroll'));
	        }
	
	        if (!_this4._initialized) {
	          _this4._initialized = true;
	
	          setImmediate(function () {
	            _this4.onInit && _this4.onInit();
	            util.triggerElementEvent(_this4, 'init');
	          });
	
	          if (!util.hasAnyComponentAsParent(_this4)) {
	            setImmediate(function () {
	              return _this4._show();
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateBackButton',
	    value: function updateBackButton(show) {
	      if (this.backButton) {
	        show ? this.backButton.show() : this.backButton.hide();
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll() {
	      var _this5 = this;
	
	      var c = this._contentElement,
	          overLimit = (c.scrollTop + c.clientHeight) / c.scrollHeight >= this._infiniteScrollLimit;
	
	      if (this._onInfiniteScroll && !this._loadingContent && overLimit) {
	        this._loadingContent = true;
	        this._onInfiniteScroll(function () {
	          return _this5._loadingContent = false;
	        });
	      }
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: '_getContentElement',
	    value: function _getContentElement() {
	      var result = util.findChild(this, '.page__content');
	      if (result) {
	        return result;
	      }
	      throw Error('fail to get ".page__content" element.');
	    }
	  }, {
	    key: '_getBackgroundElement',
	    value: function _getBackgroundElement() {
	      var result = util.findChild(this, '.page__background');
	      if (result) {
	        return result;
	      }
	      throw Error('fail to get ".page__background" element.');
	    }
	  }, {
	    key: '_getBottomToolbarElement',
	    value: function _getBottomToolbarElement() {
	      return util.findChild(this, 'ons-bottom-toolbar') || internal$1.nullElement;
	    }
	  }, {
	    key: '_getToolbarElement',
	    value: function _getToolbarElement() {
	      return util.findChild(this, 'ons-toolbar') || document.createElement('ons-toolbar');
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this6 = this;
	
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, this._defaultClassName, scheme$17);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$17);
	          break;
	        case 'on-infinite-scroll':
	          if (current === null) {
	            this.onInfiniteScroll = null;
	          } else {
	            this.onInfiniteScroll = function (done) {
	              var f = util.findFromPath(current);
	              _this6.onInfiniteScroll = f;
	              f(done);
	            };
	          }
	          break;
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      if (!this._isShown && util.isAttached(this)) {
	        this._isShown = true;
	        this.setAttribute('shown', '');
	        this.onShow && this.onShow();
	        util.triggerElementEvent(this, 'show');
	        util.propagateAction(this, '_show');
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      if (this._isShown) {
	        this._isShown = false;
	        this.removeAttribute('shown');
	        this.onHide && this.onHide();
	        util.triggerElementEvent(this, 'hide');
	        util.propagateAction(this, '_hide');
	      }
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      this._hide();
	
	      this.onDestroy && this.onDestroy();
	      util.triggerElementEvent(this, 'destroy');
	
	      if (this.onDeviceBackButton) {
	        this.onDeviceBackButton.destroy();
	      }
	
	      util.propagateAction(this, '_destroy');
	
	      this.remove();
	    }
	  }, {
	    key: '_deriveHooks',
	    value: function _deriveHooks() {
	      var _this7 = this;
	
	      this.constructor.events.forEach(function (event) {
	        var key = 'on' + event.charAt(0).toUpperCase() + event.slice(1);
	        Object.defineProperty(_this7, key, {
	          configurable: true,
	          enumerable: true,
	          get: function get$$1() {
	            return _this7['_' + key];
	          },
	          set: function set$$1(value) {
	            if (!(value instanceof Function)) {
	              throw new Error(key + ' hook must be a function');
	            }
	            _this7['_' + key] = value.bind(_this7);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'name',
	    set: function set$$1(str) {
	      this.setAttribute('name', str);
	    },
	    get: function get$$1() {
	      return this.getAttribute('name');
	    }
	  }, {
	    key: 'backButton',
	    get: function get$$1() {
	      return this.querySelector('ons-back-button');
	    }
	
	    /**
	     * @property onInfiniteScroll
	     * @description
	     *  [en]Function to be executed when scrolling to the bottom of the page. The function receives a done callback as an argument that must be called when it's finished.[/en]
	     *  [ja][/ja]
	     */
	
	  }, {
	    key: 'onInfiniteScroll',
	    set: function set$$1(value) {
	      var _this8 = this;
	
	      if (value && !(value instanceof Function)) {
	        throw new Error('onInfiniteScroll must be a function or null');
	      }
	
	      contentReady(this, function () {
	        if (!value) {
	          _this8._contentElement.removeEventListener('scroll', _this8._boundOnScroll);
	        } else if (!_this8._onInfiniteScroll) {
	          _this8._infiniteScrollLimit = 0.9;
	          _this8._boundOnScroll = _this8._onScroll.bind(_this8);
	          setImmediate(function () {
	            return _this8._contentElement.addEventListener('scroll', _this8._boundOnScroll);
	          });
	        }
	        _this8._onInfiniteScroll = value;
	      });
	    },
	    get: function get$$1() {
	      return this._onInfiniteScroll;
	    }
	  }, {
	    key: 'onDeviceBackButton',
	    get: function get$$1() {
	      return this._backButtonHandler;
	    },
	    set: function set$$1(callback) {
	      if (this._backButtonHandler) {
	        this._backButtonHandler.destroy();
	      }
	
	      this._backButtonHandler = deviceBackButtonDispatcher.createHandler(this, callback);
	    }
	  }, {
	    key: 'scrollTop',
	    get: function get$$1() {
	      return this._contentElement.scrollTop;
	    },
	    set: function set$$1(newValue) {
	      this._contentElement.scrollTop = newValue;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'on-infinite-scroll', 'class'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['init', 'show', 'hide', 'destroy'];
	    }
	
	    /**
	     * @property data
	     * @type {*}
	     * @description
	     *   [en]User's custom data passed to `pushPage()`-like methods.[/en]
	     *   [ja][/ja]
	     */
	
	  }]);
	  return PageElement;
	}(BaseElement);
	
	onsElements.Page = PageElement;
	customElements.define('ons-page', PageElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	var PopoverAnimator = function (_BaseAnimator) {
	  inherits(PopoverAnimator, _BaseAnimator);
	
	  /**
	   * @param {Object} options
	   * @param {String} options.timing
	   * @param {Number} options.duration
	   * @param {Number} options.delay
	   */
	  function PopoverAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(.1, .7, .4, 1)' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, PopoverAnimator);
	    return possibleConstructorReturn(this, (PopoverAnimator.__proto__ || Object.getPrototypeOf(PopoverAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  createClass(PopoverAnimator, [{
	    key: 'show',
	    value: function show(popover, callback) {
	      callback();
	    }
	  }, {
	    key: 'hide',
	    value: function hide(popover, callback) {
	      callback();
	    }
	  }, {
	    key: '_animate',
	    value: function _animate(element, _ref2) {
	      var from = _ref2.from,
	          to = _ref2.to,
	          options = _ref2.options,
	          callback = _ref2.callback,
	          _ref2$restore = _ref2.restore,
	          restore = _ref2$restore === undefined ? false : _ref2$restore,
	          animation = _ref2.animation;
	
	      options = util.extend({}, this.options, options);
	
	      if (animation) {
	        from = animation.from;
	        to = animation.to;
	      }
	
	      animation = Animit(element);
	      if (restore) {
	        animation = animation.saveStyle();
	      }
	      animation = animation.queue(from).wait(this.delay).queue({
	        css: to,
	        duration: this.duration,
	        timing: this.timing
	      });
	      if (restore) {
	        animation = animation.restoreStyle();
	      }
	      if (callback) {
	        animation = animation.queue(function (done) {
	          callback();
	          done();
	        });
	      }
	      return animation;
	    }
	  }, {
	    key: '_animateAll',
	    value: function _animateAll(element, animations) {
	      var _this2 = this;
	
	      Object.keys(animations).forEach(function (key) {
	        return _this2._animate(element[key], animations[key]).play();
	      });
	    }
	  }]);
	  return PopoverAnimator;
	}(BaseAnimator);
	
	var fade = {
	  out: {
	    from: { opacity: 1.0 },
	    to: { opacity: 0 }
	  },
	  in: {
	    from: { opacity: 0 },
	    to: { opacity: 1.0 }
	  }
	};
	
	var MDFadePopoverAnimator = function (_PopoverAnimator) {
	  inherits(MDFadePopoverAnimator, _PopoverAnimator);
	
	  function MDFadePopoverAnimator() {
	    classCallCheck(this, MDFadePopoverAnimator);
	    return possibleConstructorReturn(this, (MDFadePopoverAnimator.__proto__ || Object.getPrototypeOf(MDFadePopoverAnimator)).apply(this, arguments));
	  }
	
	  createClass(MDFadePopoverAnimator, [{
	    key: 'show',
	    value: function show(popover, callback) {
	      this._animateAll(popover, {
	        _mask: fade.in,
	        _popover: { animation: fade.in, restore: true, callback: callback }
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide(popover, callback) {
	      this._animateAll(popover, {
	        _mask: fade.out,
	        _popover: { animation: fade.out, restore: true, callback: callback }
	      });
	    }
	  }]);
	  return MDFadePopoverAnimator;
	}(PopoverAnimator);
	
	var IOSFadePopoverAnimator = function (_MDFadePopoverAnimato) {
	  inherits(IOSFadePopoverAnimator, _MDFadePopoverAnimato);
	
	  function IOSFadePopoverAnimator() {
	    classCallCheck(this, IOSFadePopoverAnimator);
	    return possibleConstructorReturn(this, (IOSFadePopoverAnimator.__proto__ || Object.getPrototypeOf(IOSFadePopoverAnimator)).apply(this, arguments));
	  }
	
	  createClass(IOSFadePopoverAnimator, [{
	    key: 'show',
	    value: function show(popover, callback) {
	      this._animateAll(popover, {
	        _mask: fade.in,
	        _popover: {
	          from: {
	            transform: 'scale3d(1.3, 1.3, 1.0)',
	            opacity: 0
	          },
	          to: {
	            transform: 'scale3d(1.0, 1.0,  1.0)',
	            opacity: 1.0
	          },
	          restore: true,
	          callback: callback
	        }
	      });
	    }
	  }]);
	  return IOSFadePopoverAnimator;
	}(MDFadePopoverAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$19 = {
	  '.popover': 'popover--*',
	  '.popover-mask': 'popover-mask--*',
	  '.popover__content': 'popover--*__content',
	  '.popover__arrow': 'popover--*__arrow'
	};
	
	var _animatorDict$5 = {
	  'default': function _default() {
	    return platform.isAndroid() ? MDFadePopoverAnimator : IOSFadePopoverAnimator;
	  },
	  'none': PopoverAnimator,
	  'fade-ios': IOSFadePopoverAnimator,
	  'fade-md': MDFadePopoverAnimator
	};
	
	var positions = {
	  up: 'bottom',
	  left: 'right',
	  down: 'top',
	  right: 'left'
	};
	
	/**
	 * @element ons-popover
	 * @category dialog
	 * @description
	 *  [en]
	 *    A component that displays a popover next to an element. The popover can be used to display extra information about a component or a tooltip.
	 *
	 *    To use the element it can either be attached directly to the `<body>` element or dynamically created from a template using the `ons.createPopover(template)` utility function and the `<template>` tag.
	 *
	 *    Another common way to use the popover is to display a menu when a button on the screen is tapped. For Material Design, popover looks exactly as a dropdown menu.
	 *  [/en]
	 *  [ja]ある要素を対象とするポップオーバーを表示するコンポーネントです。[/ja]
	 * @codepen ZYYRKo
	 * @tutorial vanilla/Reference/popover
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-button onclick="showPopover(this)">
	 *   Click me!
	 * </ons-button>
	 *
	 * <ons-popover direction="down" id="popover">
	 *   <p>This is a popover!</p>
	 * </ons-popover>
	 *
	 * <script>
	 *   var showPopover = function(element) {
	 *     var popover = document.getElementById('popover');
	 *     popover.show(element);
	 *   };
	 * </script>
	 */
	
	var PopoverElement = function (_BaseDialogElement) {
	  inherits(PopoverElement, _BaseDialogElement);
	
	  /**
	   * @event preshow
	   * @description
	   *   [en]Fired just before the popover is displayed.[/en]
	   *   [ja]ポップオーバーが表示される直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.popover
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Call this function to stop the popover from being shown.[/en]
	   *   [ja]この関数を呼び出すと、ポップオーバーの表示がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event postshow
	   * @description
	   *   [en]Fired just after the popover is displayed.[/en]
	   *   [ja]ポップオーバーが表示された直後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.popover
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event prehide
	   * @description
	   *   [en]Fired just before the popover is hidden.[/en]
	   *   [ja]ポップオーバーが隠れる直前に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.popover
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Call this function to stop the popover from being hidden.[/en]
	   *   [ja]この関数を呼び出すと、ポップオーバーが隠れる処理をキャンセルします。[/ja]
	   */
	
	  /**
	   * @event posthide
	   * @description
	   *   [en]Fired just after the popover is hidden.[/en]
	   *   [ja]ポップオーバーが隠れた後に発火します。[/ja]
	   * @param {Object} event [en]Event object.[/en]
	   * @param {Object} event.popover
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the popover.[/en]
	   *  [ja]ポップオーバーの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute direction
	   * @type {String}
	   * @description
	   *  [en]
	   *    A space separated list of directions. If more than one direction is specified,
	   *    it will be chosen automatically. Valid directions are `"up"`, `"down"`, `"left"` and `"right"`.
	   *  [/en]
	   *  [ja]
	   *    ポップオーバーを表示する方向を空白区切りで複数指定できます。
	   *    指定できる方向は、"up", "down", "left", "right"の4つです。空白区切りで複数指定することもできます。
	   *    複数指定された場合、対象とする要素に合わせて指定した値から自動的に選択されます。
	   *  [/ja]
	   */
	
	  /**
	   * @attribute cancelable
	   * @description
	   *   [en]If this attribute is set the popover can be closed by tapping the background or by pressing the back button.[/en]
	   *   [ja]この属性があると、ポップオーバーが表示された時に、背景やバックボタンをタップした時にをポップオーバー閉じます。[/ja]
	   */
	
	  /**
	   * @attribute cover-target
	   * @description
	   *   [en]If set the popover will cover the target on the screen.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @description
	   *   [en]The animation used when showing an hiding the popover. Can be either `"none"`, `"default"`, `"fade-ios"` or `"fade-md"`.[/en]
	   *   [ja]ポップオーバーを表示する際のアニメーション名を指定します。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. {duration: 0.2, delay: 1, timing: 'ease-in'}[/ja]
	   */
	
	  /**
	   * @attribute mask-color
	   * @type {Color}
	   * @description
	   *   [en]Color of the background mask. Default is `"rgba(0, 0, 0, 0.2)"`.[/en]
	   *   [ja]背景のマスクの色を指定します。デフォルトは"rgba(0, 0, 0, 0.2)"です。[/ja]
	   */
	
	  function PopoverElement() {
	    classCallCheck(this, PopoverElement);
	
	    var _this = possibleConstructorReturn(this, (PopoverElement.__proto__ || Object.getPrototypeOf(PopoverElement)).call(this));
	
	    _this._boundOnChange = _this._onChange.bind(_this);
	
	    contentReady(_this, function () {
	      _this._compile();
	      _this.style.display = 'none';
	    });
	    return _this;
	  }
	
	  createClass(PopoverElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      return new AnimatorFactory({
	        animators: _animatorDict$5,
	        baseClass: PopoverAnimator,
	        baseClassName: 'PopoverAnimator',
	        defaultAnimation: this.getAttribute('animation') || 'default'
	      });
	    }
	  }, {
	    key: '_toggleStyle',
	    value: function _toggleStyle(shouldShow) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (shouldShow) {
	        this.style.display = 'block';
	        this._currentTarget = options.target;
	        this._positionPopover(options.target);
	      } else {
	        this.style.display = 'none';
	        this._clearStyles();
	      }
	    }
	  }, {
	    key: '_positionPopover',
	    value: function _positionPopover(target) {
	      var radius = this._radius,
	          contentElement = this._content,
	          margin = this._margin;
	
	      var safeAreaLengths = iPhoneXPatch.getSafeAreaLengths();
	      var safeAreaRect = iPhoneXPatch.getSafeAreaDOMRect();
	      var targetRect = target.getBoundingClientRect();
	      var isMD = util.hasModifier(this, 'material');
	      var cover = isMD && this.hasAttribute('cover-target');
	
	      // Distance from each side of the safe area (with margin) to the target element
	      var targetDistance = {
	        top: targetRect.top - (safeAreaRect.top + margin),
	        left: targetRect.left - (safeAreaRect.left + margin),
	        bottom: safeAreaRect.bottom - margin - targetRect.bottom,
	        right: safeAreaRect.right - margin - targetRect.right
	      };
	
	      // Distance from each side of the safe area (with margin) to the geometric center of the target element
	      var targetCenterDistanceFrom = {
	        top: targetRect.top + Math.round(targetRect.height / 2) - (safeAreaRect.top + margin),
	        left: targetRect.left + Math.round(targetRect.width / 2) - (safeAreaRect.left + margin),
	        bottom: safeAreaRect.bottom - margin - targetRect.bottom + Math.round(targetRect.height / 2),
	        right: safeAreaRect.right - margin - targetRect.right + Math.round(targetRect.width / 2)
	      };
	
	      var _calculateDirections2 = this._calculateDirections(targetDistance),
	          vertical = _calculateDirections2.vertical,
	          primaryDirection = _calculateDirections2.primary,
	          secondaryDirection = _calculateDirections2.secondary;
	
	      this._currentDirection = primaryDirection;
	      util.addModifier(this, primaryDirection);
	
	      var sizeName = vertical ? 'width' : 'height';
	      // Get .popover__content size
	      var contentSize = function (style) {
	        return {
	          width: parseInt(style.getPropertyValue('width'), 10),
	          height: parseInt(style.getPropertyValue('height'), 10)
	        };
	      }(window.getComputedStyle(contentElement));
	
	      // Setting .popover position.
	      var targetAndArrowLength = cover ? 0 : (vertical ? targetRect.height : targetRect.width) + (isMD ? 0 : 14);
	      var primaryOffset = Math.max(safeAreaLengths[primaryDirection] + margin, safeAreaLengths[primaryDirection] + margin + targetDistance[primaryDirection] + targetAndArrowLength);
	      var secondaryOffset = Math.max(safeAreaLengths[secondaryDirection] + margin, safeAreaLengths[secondaryDirection] + margin + targetCenterDistanceFrom[secondaryDirection] - contentSize[sizeName] / 2);
	      this._popover.style[primaryDirection] = primaryOffset + 'px';
	      this._popover.style[secondaryDirection] = secondaryOffset + 'px';
	
	      // Setting .popover__arrow position.
	      this._arrow.style[secondaryDirection] = Math.max(radius, safeAreaLengths[secondaryDirection] + margin + targetCenterDistanceFrom[secondaryDirection] - secondaryOffset) + 'px';
	    }
	  }, {
	    key: '_calculateDirections',
	    value: function _calculateDirections(distance) {
	      var options = (this.getAttribute('direction') || 'up down left right').split(/\s+/).map(function (e) {
	        return positions[e];
	      });
	      var primary = options.sort(function (a, b) {
	        return distance[a] - distance[b];
	      })[0];
	      var vertical = 'top' == primary || 'bottom' == primary;
	      var secondary = void 0;
	
	      if (vertical) {
	        secondary = distance.left < distance.right ? 'left' : 'right';
	      } else {
	        secondary = distance.top < distance.bottom ? 'top' : 'bottom';
	      }
	
	      return { vertical: vertical, primary: primary, secondary: secondary };
	    }
	  }, {
	    key: '_clearStyles',
	    value: function _clearStyles() {
	      var _this2 = this;
	
	      this._currentDirection = null;
	      ['top', 'bottom', 'left', 'right'].forEach(function (e) {
	        _this2._arrow.style[e] = _this2._content.style[e] = _this2._popover.style[e] = '';
	        util.removeModifier(_this2, e);
	      });
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange() {
	      var _this3 = this;
	
	      setImmediate(function () {
	        if (_this3._currentTarget) {
	          _this3._positionPopover(_this3._currentTarget);
	        }
	      });
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      if (this._popover && this._mask) {
	        return;
	      }
	
	      var hasDefaultContainer = this._popover && this._content;
	
	      if (hasDefaultContainer) {
	
	        if (!this._mask) {
	          var mask = document.createElement('div');
	          mask.classList.add('popover-mask');
	          this.insertBefore(mask, this.firstChild);
	        }
	
	        if (!this._arrow) {
	          var arrow = document.createElement('div');
	          arrow.classList.add('popover__arrow');
	          this._popover.appendChild(arrow);
	        }
	      } else {
	
	        var template = util.createFragment('\n        <div class="popover-mask"></div>\n        <div class="popover">\n          <div class="popover__content"></div>\n          <div class="popover__arrow"></div>\n        </div>\n      ');
	        var content = template.querySelector('.popover__content');
	
	        while (this.childNodes[0]) {
	          content.appendChild(this.childNodes[0]);
	        }
	
	        this.appendChild(template);
	      }
	
	      // FIXME!
	      if (this.hasAttribute('style')) {
	        this._popover.setAttribute('style', this.getAttribute('style'));
	        this.removeAttribute('style');
	      }
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	
	    /**
	     * @method show
	     * @signature show(target, [options])
	     * @param {String|Event|HTMLElement} target
	     *   [en]Target element. Can be either a CSS selector, an event object or a DOM element. It can be also provided as 'options.target' instead. [/en]
	     *   [ja]ポップオーバーのターゲットとなる要素を指定します。CSSセレクタかeventオブジェクトかDOM要素のいずれかを渡せます。[/ja]
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name.  Use one of `"fade-ios"`, `"fade-md"`, `"none"` and `"default"`.[/en]
	     *   [ja]アニメーション名を指定します。"fade-ios", "fade-md", "none", "default"のいずれかを指定できます。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function is called after the popover has been revealed.[/en]
	     *   [ja]ポップオーバーが表示され終わった後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Open the popover and point it at a target. The target can be either an event, a CSS selector or a DOM element..[/en]
	     *   [ja]対象とする要素にポップオーバーを表示します。target引数には、$eventオブジェクトやDOMエレメントやCSSセレクタを渡すことが出来ます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the displayed element[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'show',
	    value: function show(target) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // Copy options and include options.target
	      if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && !(target instanceof Event) && !(target instanceof HTMLElement)) {
	        options = _extends({}, target);
	      } else {
	        options = _extends({}, options, { target: target });
	      }
	
	      if (typeof options.target === 'string') {
	        options.target = document.querySelector(options.target);
	      } else if (options.target instanceof Event) {
	        options.target = options.target.target;
	      }
	
	      if (typeof options.target === 'undefined') {
	        throw new Error('A target or options.target argument must be defined for the popover.');
	      }
	
	      if (!(options.target instanceof HTMLElement)) {
	        throw new Error('Invalid target for popover.');
	      }
	
	      return get(PopoverElement.prototype.__proto__ || Object.getPrototypeOf(PopoverElement.prototype), 'show', this).call(this, options);
	    }
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name.  Use one of `"fade-ios"`, `"fade-md"`, `"none"` and `"default"`.[/en]
	     *   [ja]アニメーション名を指定します。"fade-ios", "fade-md", "none", "default"のいずれかを指定できます。[/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This functions is called after the popover has been hidden.[/en]
	     *   [ja]ポップオーバーが隠れた後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Close the popover.[/en]
	     *   [ja]ポップオーバーを閉じます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @property cancelable
	     * @type {Boolean}
	     * @description
	     *   [en]
	     *     A boolean value that specifies whether the popover is cancelable or not.
	     *
	     *     When the popover is cancelable it can be closed by tapping the background or by pressing the back button on Android devices.
	     *   [/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this4 = this;
	
	      get(PopoverElement.prototype.__proto__ || Object.getPrototypeOf(PopoverElement.prototype), 'connectedCallback', this).call(this);
	
	      window.addEventListener('resize', this._boundOnChange, false);
	      this._margin = this._margin || parseInt(window.getComputedStyle(this).getPropertyValue('top'));
	      this._margin = this._margin || 6; // Fix for iframes
	
	      contentReady(this, function () {
	        _this4._radius = parseInt(window.getComputedStyle(_this4._content).getPropertyValue('border-top-left-radius'));
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      get(PopoverElement.prototype.__proto__ || Object.getPrototypeOf(PopoverElement.prototype), 'disconnectedCallback', this).call(this);
	      window.removeEventListener('resize', this._boundOnChange, false);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'direction') {
	        return this._boundOnChange();
	      } else if (name === 'modifier') {
	        this._currentDirection && util.addModifier(this, this._currentDirection);
	      }
	      get(PopoverElement.prototype.__proto__ || Object.getPrototypeOf(PopoverElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	    }
	
	    /**
	     * @param {String} name
	     * @param {PopoverAnimator} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$19;
	    }
	  }, {
	    key: '_mask',
	    get: function get$$1() {
	      return util.findChild(this, '.popover-mask');
	    }
	  }, {
	    key: '_popover',
	    get: function get$$1() {
	      return util.findChild(this, '.popover');
	    }
	  }, {
	    key: '_content',
	    get: function get$$1() {
	      return util.findChild(this._popover, '.popover__content');
	    }
	  }, {
	    key: '_arrow',
	    get: function get$$1() {
	      return util.findChild(this._popover, '.popover__arrow');
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof PopoverAnimator)) {
	        throw new Error('"Animator" param must inherit PopoverAnimator');
	      }
	      _animatorDict$5[name] = Animator;
	    }
	  }, {
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(PopoverElement.__proto__ || Object.getPrototypeOf(PopoverElement), 'observedAttributes', this)), ['direction']);
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$5;
	    }
	  }, {
	    key: 'PopoverAnimator',
	    get: function get$$1() {
	      return PopoverAnimator;
	    }
	  }]);
	  return PopoverElement;
	}(BaseDialogElement);
	
	onsElements.Popover = PopoverElement;
	customElements.define('ons-popover', PopoverElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$20 = {
	  '.progress-bar': 'progress-bar--*',
	  '.progress-bar__primary': 'progress-bar--*__primary',
	  '.progress-bar__secondary': 'progress-bar--*__secondary'
	};
	
	var template = util.createElement('\n  <div class="progress-bar">\n    <div class="progress-bar__secondary"></div>\n    <div class="progress-bar__primary"></div>\n  </div>\n');
	
	var INDET = 'indeterminate';
	
	/**
	 * @element ons-progress-bar
	 * @category visual
	 * @description
	 *   [en]
	 *     The component is used to display a linear progress bar. It can either display a progress bar that shows the user how much of a task has been completed. In the case where the percentage is not known it can be used to display an animated progress bar so the user can see that an operation is in progress.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen zvQbGj
	 * @tutorial vanilla/Reference/progress
	 * @seealso ons-progress-circular
	 *   [en]The `<ons-progress-circular>` component displays a circular progress indicator.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-progress-bar
	 *  value="55"
	 *  secondary-value="87">
	 * </ons-progress-bar>
	 *
	 * <ons-progress-bar
	 *  indeterminate>
	 * </ons-progress-bar>
	 */
	
	var ProgressBarElement = function (_BaseElement) {
	  inherits(ProgressBarElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]Change the appearance of the progress indicator.[/en]
	   *   [ja]プログレスインジケータの見た目を変更します。[/ja]
	   */
	
	  /**
	   * @attribute value
	   * @type {Number}
	   * @description
	   *   [en]Current progress. Should be a value between 0 and 100.[/en]
	   *   [ja]現在の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	   */
	
	  /**
	   * @attribute secondary-value
	   * @type {Number}
	   * @description
	   *   [en]Current secondary progress. Should be a value between 0 and 100.[/en]
	   *   [ja]現在の２番目の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	   */
	
	  /**
	   * @attribute indeterminate
	   * @description
	   *   [en]If this attribute is set, an infinite looping animation will be shown.[/en]
	   *   [ja]この属性が設定された場合、ループするアニメーションが表示されます。[/ja]
	   */
	
	  function ProgressBarElement() {
	    classCallCheck(this, ProgressBarElement);
	
	    var _this = possibleConstructorReturn(this, (ProgressBarElement.__proto__ || Object.getPrototypeOf(ProgressBarElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ProgressBarElement, [{
	    key: '_compile',
	    value: function _compile() {
	      if (!this._isCompiled()) {
	        this._template = template.cloneNode(true);
	      } else {
	        this._template = util.findChild(this, '.progress-bar');
	      }
	
	      this._primary = util.findChild(this._template, '.progress-bar__primary');
	      this._secondary = util.findChild(this._template, '.progress-bar__secondary');
	
	      this._updateDeterminate();
	      this._updateValue();
	
	      this.appendChild(this._template);
	
	      autoStyle.prepare(this);
	      ModifierUtil.initModifier(this, scheme$20);
	    }
	  }, {
	    key: '_isCompiled',
	    value: function _isCompiled() {
	      if (!util.findChild(this, '.progress-bar')) {
	        return false;
	      }
	
	      var barElement = util.findChild(this, '.progress-bar');
	
	      if (!util.findChild(barElement, '.progress-bar__secondary')) {
	        return false;
	      }
	
	      if (!util.findChild(barElement, '.progress-bar__primary')) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'modifier') {
	        ModifierUtil.onModifierChanged(last, current, this, scheme$20);
	        this.hasAttribute(INDET) && this._updateDeterminate();
	      } else if (name === 'value' || name === 'secondary-value') {
	        this._updateValue();
	      } else if (name === INDET) {
	        this._updateDeterminate();
	      }
	    }
	  }, {
	    key: '_updateDeterminate',
	    value: function _updateDeterminate() {
	      var _this2 = this;
	
	      contentReady(this, function () {
	        return util.toggleModifier(_this2, INDET, { force: _this2.hasAttribute(INDET) });
	      });
	    }
	  }, {
	    key: '_updateValue',
	    value: function _updateValue() {
	      var _this3 = this;
	
	      contentReady(this, function () {
	        _this3._primary.style.width = _this3.hasAttribute('value') ? _this3.getAttribute('value') + '%' : '0%';
	        _this3._secondary.style.width = _this3.hasAttribute('secondary-value') ? _this3.getAttribute('secondary-value') + '%' : '0%';
	      });
	    }
	
	    /**
	     * @property value
	     * @type {Number}
	     * @description
	     *   [en]Current progress. Should be a value between 0 and 100.[/en]
	     *   [ja]現在の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	     */
	
	  }, {
	    key: 'value',
	    set: function set$$1(value) {
	      if (typeof value !== 'number' || value < 0 || value > 100) {
	        throw new Error('Invalid value');
	      }
	
	      this.setAttribute('value', Math.floor(value));
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('value') || '0');
	    }
	
	    /**
	     * @property secondaryValue
	     * @type {Number}
	     * @description
	     *   [en]Current secondary progress. Should be a value between 0 and 100.[/en]
	     *   [ja]現在の２番目の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	     */
	
	  }, {
	    key: 'secondaryValue',
	    set: function set$$1(value) {
	      if (typeof value !== 'number' || value < 0 || value > 100) {
	        throw new Error('Invalid value');
	      }
	
	      this.setAttribute('secondary-value', Math.floor(value));
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('secondary-value') || '0');
	    }
	
	    /**
	     * @property indeterminate
	     * @type {Boolean}
	     * @description
	     *   [en]If this property is `true`, an infinite looping animation will be shown.[/en]
	     *   [ja]この属性が設定された場合、ループするアニメーションが表示されます。[/ja]
	     */
	
	  }, {
	    key: 'indeterminate',
	    set: function set$$1(value) {
	      if (value) {
	        this.setAttribute(INDET, '');
	      } else {
	        this.removeAttribute(INDET);
	      }
	    },
	    get: function get$$1() {
	      return this.hasAttribute(INDET);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'value', 'secondary-value', INDET];
	    }
	  }]);
	  return ProgressBarElement;
	}(BaseElement);
	
	onsElements.ProgressBar = ProgressBarElement;
	customElements.define('ons-progress-bar', ProgressBarElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$21 = {
	  '.progress-circular': 'progress-circular--*',
	  '.progress-circular__background': 'progress-circular--*__background',
	  '.progress-circular__primary': 'progress-circular--*__primary',
	  '.progress-circular__secondary': 'progress-circular--*__secondary'
	};
	
	var template$1 = util.createElement('\n  <svg class="progress-circular">\n    <circle class="progress-circular__background" />\n    <circle class="progress-circular__secondary" cx="50%" cy="50%" r="40%" />\n    <circle class="progress-circular__primary" cx="50%" cy="50%" r="40%" />\n  </svg>\n');
	
	var INDET$1 = 'indeterminate';
	
	/**
	 * @element ons-progress-circular
	 * @category visual
	 * @description
	 *   [en]
	 *     This component displays a circular progress indicator. It can either be used to show how much of a task has been completed or to show a looping animation to indicate that an operation is currently running.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen EVzMjR
	 * @tutorial vanilla/Reference/progress
	 * @seealso ons-progress-bar
	 *   [en]The `<ons-progress-bar>` component displays a bar progress indicator.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-progress-circular
	 *  value="55"
	 *  secondary-value="87">
	 * </ons-progress-circular>
	 *
	 * <ons-progress-circular
	 *  indeterminate>
	 * </ons-progress-circular>
	 */
	
	var ProgressCircularElement = function (_BaseElement) {
	  inherits(ProgressCircularElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]Change the appearance of the progress indicator.[/en]
	   *   [ja]プログレスインジケータの見た目を変更します。[/ja]
	   */
	
	  /**
	   * @attribute value
	   * @type {Number}
	   * @description
	   *   [en]Current progress. Should be a value between 0 and 100.[/en]
	   *   [ja]現在の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	   */
	
	  /**
	   * @attribute secondary-value
	   * @type {Number}
	   * @description
	   *   [en]Current secondary progress. Should be a value between 0 and 100.[/en]
	   *   [ja]現在の２番目の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	   */
	
	  /**
	   * @attribute indeterminate
	   * @description
	   *   [en]If this attribute is set, an infinite looping animation will be shown.[/en]
	   *   [ja]この属性が設定された場合、ループするアニメーションが表示されます。[/ja]
	   */
	
	  function ProgressCircularElement() {
	    classCallCheck(this, ProgressCircularElement);
	
	    var _this = possibleConstructorReturn(this, (ProgressCircularElement.__proto__ || Object.getPrototypeOf(ProgressCircularElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ProgressCircularElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'modifier') {
	        ModifierUtil.onModifierChanged(last, current, this, scheme$21);
	        this.hasAttribute(INDET$1) && this._updateDeterminate();
	      } else if (name === 'value' || name === 'secondary-value') {
	        this._updateValue();
	      } else if (name === INDET$1) {
	        this._updateDeterminate();
	      }
	    }
	  }, {
	    key: '_updateDeterminate',
	    value: function _updateDeterminate() {
	      var _this2 = this;
	
	      contentReady(this, function () {
	        return util.toggleModifier(_this2, INDET$1, { force: _this2.hasAttribute(INDET$1) });
	      });
	    }
	  }, {
	    key: '_updateValue',
	    value: function _updateValue() {
	      var _this3 = this;
	
	      if (this.hasAttribute('value')) {
	        contentReady(this, function () {
	          var per = Math.ceil(_this3.getAttribute('value') * 251.32 * 0.01);
	          _this3._primary.style['stroke-dasharray'] = per + '%, 251.32%';
	        });
	      }
	      if (this.hasAttribute('secondary-value')) {
	        contentReady(this, function () {
	          var per = Math.ceil(_this3.getAttribute('secondary-value') * 251.32 * 0.01);
	          _this3._secondary.style.display = null;
	          _this3._secondary.style['stroke-dasharray'] = per + '%, 251.32%';
	        });
	      } else {
	        contentReady(this, function () {
	          _this3._secondary.style.display = 'none';
	        });
	      }
	    }
	
	    /**
	     * @property value
	     * @type {Number}
	     * @description
	     *   [en]Current progress. Should be a value between 0 and 100.[/en]
	     *   [ja]現在の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	     */
	
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      if (this._isCompiled()) {
	        this._template = util.findChild(this, '.progress-circular');
	      } else {
	        this._template = template$1.cloneNode(true);
	      }
	
	      this._primary = util.findChild(this._template, '.progress-circular__primary');
	      this._secondary = util.findChild(this._template, '.progress-circular__secondary');
	
	      this._updateDeterminate();
	      this._updateValue();
	
	      this.appendChild(this._template);
	
	      autoStyle.prepare(this);
	      ModifierUtil.initModifier(this, scheme$21);
	    }
	  }, {
	    key: '_isCompiled',
	    value: function _isCompiled() {
	      if (!util.findChild(this, '.progress-circular')) {
	        return false;
	      }
	
	      var svg = util.findChild(this, '.progress-circular');
	
	      if (!util.findChild(svg, '.progress-circular__secondary')) {
	        return false;
	      }
	
	      if (!util.findChild(svg, '.progress-circular__primary')) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'value',
	    set: function set$$1(value) {
	      if (typeof value !== 'number' || value < 0 || value > 100) {
	        throw new Error('Invalid value');
	      }
	
	      this.setAttribute('value', Math.floor(value));
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('value') || '0');
	    }
	
	    /**
	     * @property secondaryValue
	     * @type {Number}
	     * @description
	     *   [en]Current secondary progress. Should be a value between 0 and 100.[/en]
	     *   [ja]現在の２番目の進行状況の値を指定します。0から100の間の値を指定して下さい。[/ja]
	     */
	
	  }, {
	    key: 'secondaryValue',
	    set: function set$$1(value) {
	      if (typeof value !== 'number' || value < 0 || value > 100) {
	        throw new Error('Invalid value');
	      }
	
	      this.setAttribute('secondary-value', Math.floor(value));
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('secondary-value') || '0');
	    }
	
	    /**
	     * @property indeterminate
	     * @type {Boolean}
	     * @description
	     *   [en]If this property is `true`, an infinite looping animation will be shown.[/en]
	     *   [ja]この属性が設定された場合、ループするアニメーションが表示されます。[/ja]
	     */
	
	  }, {
	    key: 'indeterminate',
	    set: function set$$1(value) {
	      if (value) {
	        this.setAttribute(INDET$1, '');
	      } else {
	        this.removeAttribute(INDET$1);
	      }
	    },
	    get: function get$$1() {
	      return this.hasAttribute(INDET$1);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'value', 'secondary-value', INDET$1];
	    }
	  }]);
	  return ProgressCircularElement;
	}(BaseElement);
	
	onsElements.ProgressCircular = ProgressCircularElement;
	customElements.define('ons-progress-circular', ProgressCircularElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var STATE_INITIAL = 'initial';
	var STATE_PREACTION = 'preaction';
	var STATE_ACTION = 'action';
	
	/**
	 * @element ons-pull-hook
	 * @category control
	 * @description
	 *   [en]
	 *     Component that adds **Pull to refresh** functionality to an `<ons-page>` element.
	 *
	 *     It can be used to perform a task when the user pulls down at the top of the page. A common usage is to refresh the data displayed in a page.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen WbJogM
	 * @tutorial vanilla/Reference/pull-hook
	 * @example
	 * <ons-page>
	 *   <ons-pull-hook>
	 *     Release to refresh
	 *   </ons-pull-hook>
	 * </ons-page>
	 *
	 * <script>
	 *   document.querySelector('ons-pull-hook').onAction = function(done) {
	 *     setTimeout(done, 1000);
	 *   };
	 * </script>
	 */
	
	var PullHookElement = function (_BaseElement) {
	  inherits(PullHookElement, _BaseElement);
	
	  /**
	   * @event changestate
	   * @description
	   *   [en]Fired when the state is changed. The state can be either "initial", "preaction" or "action".[/en]
	   *   [ja]コンポーネントの状態が変わった場合に発火します。状態は、"initial", "preaction", "action"のいずれかです。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクト。[/ja]
	   * @param {Object} event.pullHook
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {String} event.state
	   *   [en]Current state.[/en]
	   *   [ja]現在の状態名を参照できます。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]If this attribute is set the "pull-to-refresh" functionality is disabled.[/en]
	   *   [ja]この属性がある時、disabled状態になりアクションが実行されなくなります[/ja]
	   */
	
	  /**
	   * @attribute height
	   * @type {String}
	   * @description
	   *   [en]Specify the height of the component. When pulled down further than this value it will switch to the "preaction" state. The default value is "64px".[/en]
	   *   [ja]コンポーネントの高さを指定します。この高さ以上にpull downすると"preaction"状態に移行します。デフォルトの値は"64px"です。[/ja]
	   */
	
	  /**
	   * @attribute threshold-height
	   * @type {String}
	   * @description
	   *   [en]Specify the threshold height. The component automatically switches to the "action" state when pulled further than this value. The default value is "96px". A negative value will disable this property. If this value is lower than the height, it will skip "preaction" state.[/en]
	   *   [ja]閾値となる高さを指定します。この値で指定した高さよりもpull downすると、このコンポーネントは自動的に"action"状態に移行します。[/ja]
	   */
	
	  /**
	   * @attribute fixed-content
	   * @description
	   *   [en]If this attribute is set the content of the page will not move when pulling.[/en]
	   *   [ja]この属性がある時、プルフックが引き出されている時にもコンテンツは動きません。[/ja]
	   */
	
	  function PullHookElement() {
	    classCallCheck(this, PullHookElement);
	
	    var _this = possibleConstructorReturn(this, (PullHookElement.__proto__ || Object.getPrototypeOf(PullHookElement)).call(this));
	
	    _this._shouldFixScroll = util.globals.actualMobileOS !== 'other';
	
	    _this._onDrag = _this._onDrag.bind(_this);
	    _this._onDragStart = _this._onDragStart.bind(_this);
	    _this._onDragEnd = _this._onDragEnd.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._preventScroll = _this._preventScroll.bind(_this);
	
	    _this._setState(STATE_INITIAL, true);
	    _this._hide(); // Fix for transparent toolbar transitions
	    return _this;
	  }
	
	  createClass(PullHookElement, [{
	    key: '_setStyle',
	    value: function _setStyle() {
	      var height = this.height + 'px';
	      styler(this, { height: height, lineHeight: height });
	      this.style.display === '' && this._show();
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      var element = this._pageElement;
	
	      if (element.scrollTop < 0) {
	        element.scrollTop = 0;
	      }
	    }
	  }, {
	    key: '_canConsumeGesture',
	    value: function _canConsumeGesture(gesture) {
	      return gesture.direction === 'up' || gesture.direction === 'down';
	    }
	  }, {
	    key: '_onDragStart',
	    value: function _onDragStart(event) {
	      var _this2 = this;
	
	      if (!event.gesture || this.disabled) {
	        return;
	      }
	
	      this._ignoreDrag = event.consumed;
	
	      if (!this._ignoreDrag) {
	        var consume = event.consume;
	        event.consume = function () {
	          consume && consume();
	          _this2._ignoreDrag = true;
	          // This elements resizes .page__content so it is safer
	          // to hide it when other components are dragged.
	          _this2._hide();
	        };
	
	        if (this._canConsumeGesture(event.gesture)) {
	          consume && consume();
	          event.consumed = true;
	          this._show(); // Not enough due to 'dragLockAxis'
	        }
	      }
	
	      this._startScroll = this._pageElement.scrollTop;
	    }
	  }, {
	    key: '_onDrag',
	    value: function _onDrag(event) {
	      var _this3 = this;
	
	      if (!event.gesture || this.disabled || this._ignoreDrag || !this._canConsumeGesture(event.gesture)) {
	        return;
	      }
	
	      // Necessary due to 'dragLockAxis' (25px)
	      if (this.style.display === 'none') {
	        this._show();
	      }
	
	      event.stopPropagation();
	
	      // Hack to make it work on Android 4.4 WebView and iOS UIWebView. Scrolls manually
	      // near the top of the page so there will be no inertial scroll when scrolling down.
	      // Allowing default scrolling will kill all 'touchmove' events.
	      if (this._shouldFixScroll) {
	        this._pageElement.scrollTop = this._startScroll - event.gesture.deltaY;
	        if (this._pageElement.scrollTop < window.innerHeight && event.gesture.direction !== 'up') {
	          event.gesture.preventDefault();
	        }
	      }
	
	      var scroll = Math.max(event.gesture.deltaY - this._startScroll, 0);
	      if (scroll !== this._currentTranslation) {
	
	        var th = this.thresholdHeight;
	        if (th > 0 && scroll >= th) {
	          event.gesture.stopDetect();
	          setImmediate(function () {
	            return _this3._finish();
	          });
	        } else if (scroll >= this.height) {
	          this._setState(STATE_PREACTION);
	        } else {
	          this._setState(STATE_INITIAL);
	        }
	
	        if (!this._pulling && this._shouldFixScroll) {
	          this._pulling = true;
	          this._gestureDetector.on('touchmove', this._preventScroll);
	        }
	
	        this._translateTo(scroll);
	      }
	    }
	  }, {
	    key: '_onDragEnd',
	    value: function _onDragEnd(event) {
	      if (this._pulling && this._shouldFixScroll) {
	        this._pulling = false;
	        this._gestureDetector.off('touchmove', this._preventScroll);
	      }
	
	      if (!event.gesture || this.disabled || this._ignoreDrag) {
	        return;
	      }
	
	      event.stopPropagation();
	
	      if (this._currentTranslation > 0) {
	        var scroll = this._currentTranslation;
	
	        if (scroll > this.height) {
	          this._finish();
	        } else {
	          this._translateTo(0, { animate: true });
	        }
	      }
	    }
	  }, {
	    key: '_preventScroll',
	    value: function _preventScroll(event) {
	      // Fix for Android & iOS when starting from scrollTop > 0 or pulling back
	      event.cancelable && event.preventDefault();
	    }
	
	    /**
	     * @property onAction
	     * @type {Function}
	     * @description
	     *   [en]This will be called in the `action` state if it exists. The function will be given a `done` callback as it's first argument.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: '_finish',
	    value: function _finish() {
	      var _this4 = this;
	
	      this._setState(STATE_ACTION);
	      this._translateTo(this.height, { animate: true });
	      var action = this.onAction || function (done) {
	        return done();
	      };
	      action(function () {
	        _this4._translateTo(0, { animate: true });
	        _this4._setState(STATE_INITIAL);
	      });
	    }
	
	    /**
	     * @property height
	     * @type {Number}
	     * @description
	     *   [en]The height of the pull hook in pixels. The default value is `64px`.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: '_setState',
	    value: function _setState(state, noEvent) {
	      var lastState = this.state;
	
	      this.setAttribute('state', state);
	
	      if (!noEvent && lastState !== this.state) {
	        util.triggerElementEvent(this, 'changestate', {
	          pullHook: this,
	          state: state,
	          lastState: lastState
	        });
	      }
	    }
	
	    /**
	     * @property state
	     * @readonly
	     * @type {String}
	     * @description
	     *   [en]Current state of the element.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: '_show',
	    value: function _show() {
	      var _this5 = this;
	
	      // Run asyncrhonously to avoid conflicts with Animit's style clean
	      setImmediate(function () {
	        _this5.style.display = '';
	        if (_this5._pageElement) {
	          _this5._pageElement.style.marginTop = '-' + _this5.height + 'px';
	        }
	      });
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      this.style.display = 'none';
	      if (this._pageElement) {
	        this._pageElement.style.marginTop = '';
	      }
	    }
	
	    /**
	     * @param {Number} scroll
	     * @param {Object} options
	     * @param {Function} [options.callback]
	     */
	
	  }, {
	    key: '_translateTo',
	    value: function _translateTo(scroll) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this._currentTranslation == 0 && scroll == 0) {
	        return;
	      }
	
	      this._currentTranslation = scroll;
	      var opt = options.animate ? { duration: .3, timing: 'cubic-bezier(.1, .7, .1, 1)' } : {};
	      this._onPull && this._onPull((scroll / this.height).toFixed(2), opt);
	      var scrollElement = this.hasAttribute('fixed-content') ? this : this._pageElement;
	
	      Animit(scrollElement).queue({ transform: 'translate3d(0px, ' + scroll + 'px, 0px)' }, opt).play(function () {
	        scroll === 0 && styler.clear(scrollElement, 'transition transform');
	        options.callback instanceof Function && options.callback();
	      });
	    }
	  }, {
	    key: '_disableDragLock',
	    value: function _disableDragLock() {
	      // e2e tests need it
	      this._dragLockDisabled = true;
	      this._setupListeners(true);
	    }
	  }, {
	    key: '_setupListeners',
	    value: function _setupListeners(add) {
	      var _this6 = this;
	
	      var scrollToggle = function scrollToggle(action) {
	        return _this6._pageElement[action + 'EventListener']('scroll', _this6._onScroll, false);
	      };
	      var gdToggle = function gdToggle(action) {
	        var passive = { passive: true };
	        _this6._gestureDetector[action]('drag', _this6._onDrag, passive);
	        _this6._gestureDetector[action]('dragstart', _this6._onDragStart, passive);
	        _this6._gestureDetector[action]('dragend', _this6._onDragEnd, passive);
	      };
	
	      if (this._gestureDetector) {
	        gdToggle('off');
	        this._gestureDetector.dispose();
	        this._gestureDetector = null;
	      }
	      scrollToggle('remove');
	
	      if (add) {
	        this._gestureDetector = new GestureDetector(this._pageElement, {
	          dragMinDistance: 1,
	          dragDistanceCorrection: false,
	          dragLockToAxis: !this._dragLockDisabled,
	          passive: !this._shouldFixScroll
	        });
	
	        gdToggle('on');
	        scrollToggle('add');
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this._currentTranslation = 0;
	      this._pageElement = this.parentNode;
	
	      this._setupListeners(true);
	      this._setStyle();
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._hide();
	      this._setupListeners(false);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'height' && this._pageElement) {
	        this._setStyle();
	      }
	    }
	  }, {
	    key: 'onAction',
	    get: function get$$1() {
	      return this._onAction;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onAction\' must be a function or null');
	      }
	      this._onAction = value;
	    }
	
	    /**
	     * @property onPull
	     * @type {Function}
	     * @description
	     *   [en]Hook called whenever the user pulls the element. It gets the pulled distance ratio (scroll / height) and an animationOptions object as arguments.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'onPull',
	    get: function get$$1() {
	      return this._onPull;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onPull\' must be a function or null.');
	      }
	      this._onPull = value;
	    }
	  }, {
	    key: 'height',
	    set: function set$$1(value) {
	      if (!util.isInteger(value)) {
	        throw new Error('The height must be an integer');
	      }
	
	      this.setAttribute('height', value + 'px');
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('height') || '64', 10);
	    }
	
	    /**
	     * @property thresholdHeight
	     * @type {Number}
	     * @description
	     *   [en]The thresholdHeight of the pull hook in pixels. The default value is `96px`.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'thresholdHeight',
	    set: function set$$1(value) {
	      if (!util.isInteger(value)) {
	        throw new Error('The threshold height must be an integer');
	      }
	
	      this.setAttribute('threshold-height', value + 'px');
	    },
	    get: function get$$1() {
	      return parseInt(this.getAttribute('threshold-height') || '96', 10);
	    }
	  }, {
	    key: 'state',
	    get: function get$$1() {
	      return this.getAttribute('state');
	    }
	
	    /**
	     * @property pullDistance
	     * @readonly
	     * @type {Number}
	     * @description
	     *   [en]The current number of pixels the pull hook has moved.[/en]
	     *   [ja]現在のプルフックが引き出された距離をピクセル数。[/ja]
	     */
	
	  }, {
	    key: 'pullDistance',
	    get: function get$$1() {
	      return this._currentTranslation;
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['height'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['changestate'];
	    }
	  }]);
	  return PullHookElement;
	}(BaseElement);
	
	onsElements.PullHook = PullHookElement;
	customElements.define('ons-pull-hook', PullHookElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var scheme$22 = {
	  '': 'range--*',
	  '.range__input': 'range--*__input',
	  '.range__focus-ring': 'range--*__focus-ring'
	};
	
	var activeClassToken = 'range__input--active';
	
	/**
	 * @element ons-range
	 * @category form
	 * @modifier material
	 *   [en]Material Design slider[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]
	 *     Range input component. Used to display a draggable slider.
	 *
	 *     Works very similar to the `<input type="range">` element.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen xZQomM
	 * @tutorial vanilla/Reference/range
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @seealso ons-input
	 *   [en]The `<ons-input>` component is used to display text inputs, radio buttons and checkboxes.[/en]
	 *   [ja][/ja]
	 * @example
	 * <ons-range value="20"></ons-range>
	 * <ons-range modifier="material" value="10"></range>
	 */
	
	var RangeElement = function (_BaseInputElement) {
	  inherits(RangeElement, _BaseInputElement);
	
	  function RangeElement() {
	    classCallCheck(this, RangeElement);
	
	    var _this = possibleConstructorReturn(this, (RangeElement.__proto__ || Object.getPrototypeOf(RangeElement)).call(this));
	
	    _this._onMouseDown = _this._onMouseDown.bind(_this);
	    _this._onMouseUp = _this._onMouseUp.bind(_this);
	    _this._onTouchStart = _this._onTouchStart.bind(_this);
	    _this._onTouchEnd = _this._onTouchEnd.bind(_this);
	    _this._onInput = _this._update.bind(_this);
	    _this._onDragstart = _this._onDragstart.bind(_this);
	    _this._onDragend = _this._onDragend.bind(_this);
	    return _this;
	  }
	
	  createClass(RangeElement, [{
	    key: '_compile',
	    value: function _compile() {
	      get(RangeElement.prototype.__proto__ || Object.getPrototypeOf(RangeElement.prototype), '_compile', this).call(this);
	      this._updateDisabled(this.hasAttribute('disabled'));
	    }
	
	    /* Inherited props */
	
	  }, {
	    key: '_update',
	    value: function _update() {
	      var input = this._input;
	      var focusRing = this._focusRing;
	
	      input.style.backgroundSize = 100 * this._ratio + '% 2px';
	      focusRing.value = this.value;
	
	      // NOTE: "_zero" attribute is used for CSS styling.
	      if (input.min === '' && input.value === '0' || input.min === input.value) {
	        input.setAttribute('_zero', '');
	      } else {
	        input.removeAttribute('_zero');
	      }
	
	      ['min', 'max'].forEach(function (attr) {
	        return focusRing[attr] = input[attr];
	      });
	    }
	  }, {
	    key: '_onMouseDown',
	
	
	    /* Own props */
	
	    value: function _onMouseDown(e) {
	      var _this2 = this;
	
	      this._input.classList.add(activeClassToken);
	      setImmediate(function () {
	        return _this2._input.focus();
	      });
	    }
	  }, {
	    key: '_onTouchStart',
	    value: function _onTouchStart(e) {
	      this._onMouseDown();
	    }
	  }, {
	    key: '_onMouseUp',
	    value: function _onMouseUp(e) {
	      this._input.classList.remove(activeClassToken);
	    }
	  }, {
	    key: '_onTouchEnd',
	    value: function _onTouchEnd(e) {
	      this._onMouseUp(e);
	    }
	  }, {
	    key: '_onDragstart',
	    value: function _onDragstart(e) {
	      e.consumed = true;
	      e.gesture.stopPropagation();
	      this._input.classList.add(activeClassToken);
	      this.addEventListener('drag', this._onDrag);
	    }
	  }, {
	    key: '_onDrag',
	    value: function _onDrag(e) {
	      e.stopPropagation();
	    }
	  }, {
	    key: '_onDragend',
	    value: function _onDragend(e) {
	      this._input.classList.remove(activeClassToken);
	      this.removeEventListener('drag', this._onDrag);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'disabled') {
	        this._updateDisabled(current);
	      }
	      get(RangeElement.prototype.__proto__ || Object.getPrototypeOf(RangeElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	    }
	
	    /**
	     * @param {boolean} disabled
	     */
	
	  }, {
	    key: '_updateDisabled',
	    value: function _updateDisabled(disabled) {
	      if (disabled) {
	        this.classList.add('range--disabled');
	      } else {
	        this.classList.remove('range--disabled');
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this._setupListeners(true);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._setupListeners(false);
	    }
	  }, {
	    key: '_setupListeners',
	    value: function _setupListeners(add) {
	      var action = (add ? 'add' : 'remove') + 'EventListener';
	      util[action](this, 'touchstart', this._onTouchStart, { passive: true });
	      this[action]('mousedown', this._onMouseDown);
	      this[action]('mouseup', this._onMouseUp);
	      this[action]('touchend', this._onTouchEnd);
	      this[action]('dragstart', this._onDragstart);
	      this[action]('dragend', this._onDragend);
	      this[action]('input', this._onInput);
	    }
	
	    /**
	     * @attribute disabled
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property value
	     * @type {Number}
	     * @description
	     *   [en]Current value.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$22;
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      return '\n      <input type="' + this.type + '" class="' + this._defaultClassName + '__input">\n      <input type="range" class="range__focus-ring" tabIndex="-1">\n    ';
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'range';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      return 'range';
	    }
	  }, {
	    key: '_focusRing',
	    get: function get$$1() {
	      return this.children[1];
	    }
	  }, {
	    key: '_ratio',
	    get: function get$$1() {
	      // Returns the current ratio.
	      var min = this._input.min === '' ? 0 : parseInt(this._input.min);
	      var max = this._input.max === '' ? 100 : parseInt(this._input.max);
	
	      return (this.value - min) / (max - min);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['disabled'].concat(toConsumableArray(BaseInputElement.observedAttributes));
	    }
	  }]);
	  return RangeElement;
	}(BaseInputElement);
	
	onsElements.Range = RangeElement;
	customElements.define('ons-range', RangeElement);
	
	/*
	Copyright 2013-2016 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @class AnimatorCSS - implementation of Animator class using css transitions
	 */
	
	var AnimatorCSS = function () {
	  createClass(AnimatorCSS, [{
	    key: 'animate',
	
	
	    /**
	     * @method animate
	     * @desc main animation function
	     * @param {Element} element
	     * @param {Object} finalCSS
	     * @param {number} [duration=200] - duration in milliseconds
	     * @return {Object} result
	     * @return {Function} result.then(callback) - sets a callback to be executed after the animation has stopped
	     * @return {Function} result.stop(options) - stops the animation; if options.stopNext is true then it doesn't call the callback
	     * @return {Function} result.finish(ms) - finishes the animation in the specified time in milliseconds
	     * @return {Function} result.speed(ms) - sets the animation speed so that it finishes as if the original duration was the one specified here
	     * @example
	     * ````
	     *  var result = animator.animate(el, {opacity: 0.5}, 1000);
	     *
	     *  el.addEventListener('click', function(e){
	     *    result.speed(200).then(function(){
	     *      console.log('done');
	     *    });
	     *  }, 300);
	     * ````
	     */
	    value: function animate(el, final) {
	      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	
	      var start = new Date().getTime(),
	          initial = {},
	          stopped = false,
	          next = false,
	          timeout = false,
	          properties = Object.keys(final);
	
	      var updateStyles = function updateStyles() {
	        var s = window.getComputedStyle(el);
	        properties.forEach(s.getPropertyValue.bind(s));
	        s = el.offsetHeight;
	      };
	
	      var result = {
	        stop: function stop() {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          timeout && clearTimeout(timeout);
	          var k = Math.min(1, (new Date().getTime() - start) / duration);
	          properties.forEach(function (i) {
	            el.style[i] = (1 - k) * initial[i] + k * final[i] + (i == 'opacity' ? '' : 'px');
	          });
	          el.style.transitionDuration = '0s';
	
	          if (options.stopNext) {
	            next = false;
	          } else if (!stopped) {
	            stopped = true;
	            next && next();
	          }
	          return result;
	        },
	        then: function then(cb) {
	          next = cb;
	          if (stopped) {
	            next && next();
	          }
	          return result;
	        },
	        speed: function speed(newDuration) {
	          if (internal$1.config.animationsDisabled) {
	            newDuration = 0;
	          }
	          if (!stopped) {
	            timeout && clearTimeout(timeout);
	
	            var passed = new Date().getTime() - start;
	            var k = passed / duration;
	            var remaining = newDuration * (1 - k);
	
	            properties.forEach(function (i) {
	              el.style[i] = (1 - k) * initial[i] + k * final[i] + (i == 'opacity' ? '' : 'px');
	            });
	
	            updateStyles();
	
	            start = el.speedUpTime;
	            duration = remaining;
	
	            el.style.transitionDuration = duration / 1000 + 's';
	
	            properties.forEach(function (i) {
	              el.style[i] = final[i] + (i == 'opacity' ? '' : 'px');
	            });
	
	            timeout = setTimeout(result.stop, remaining);
	          }
	          return result;
	        },
	        finish: function finish() {
	          var milliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
	
	          var k = (new Date().getTime() - start) / duration;
	
	          result.speed(milliseconds / (1 - k));
	          return result;
	        }
	      };
	
	      if (el.hasAttribute('disabled') || stopped || internal$1.config.animationsDisabled) {
	        return result;
	      }
	
	      var style = window.getComputedStyle(el);
	      properties.forEach(function (e) {
	        var v = parseFloat(style.getPropertyValue(e));
	        initial[e] = isNaN(v) ? 0 : v;
	      });
	
	      if (!stopped) {
	        el.style.transitionProperty = properties.join(',');
	        el.style.transitionDuration = duration / 1000 + 's';
	
	        properties.forEach(function (e) {
	          el.style[e] = final[e] + (e == 'opacity' ? '' : 'px');
	        });
	      }
	
	      timeout = setTimeout(result.stop, duration);
	      this._onStopAnimations(el, result.stop);
	
	      return result;
	    }
	  }]);
	
	  function AnimatorCSS() {
	    classCallCheck(this, AnimatorCSS);
	
	    this._queue = [];
	    this._index = 0;
	  }
	
	  createClass(AnimatorCSS, [{
	    key: '_onStopAnimations',
	    value: function _onStopAnimations(el, listener) {
	      var queue = this._queue;
	      var i = this._index++;
	      queue[el] = queue[el] || [];
	      queue[el][i] = function (options) {
	        delete queue[el][i];
	        if (queue[el] && queue[el].length == 0) {
	          delete queue[el];
	        }
	        return listener(options);
	      };
	    }
	
	    /**
	    * @method stopAnimations
	    * @desc stops active animations on a specified element
	    * @param {Element|Array} element - element or array of elements
	    * @param {Object} [options={}]
	    * @param {Boolean} [options.stopNext] - the callbacks after the animations won't be called if this option is true
	    */
	
	  }, {
	    key: 'stopAnimations',
	    value: function stopAnimations(el) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (Array.isArray(el)) {
	        return el.forEach(function (el) {
	          _this.stopAnimations(el, options);
	        });
	      }
	
	      (this._queue[el] || []).forEach(function (e) {
	        e(options || {});
	      });
	    }
	
	    /**
	    * @method stopAll
	    * @desc stops all active animations
	    * @param {Object} [options={}]
	    * @param {Boolean} [options.stopNext] - the callbacks after the animations won't be called if this option is true
	    */
	
	  }, {
	    key: 'stopAll',
	    value: function stopAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.stopAnimations(Object.keys(this._queue), options);
	    }
	
	    /**
	    * @method fade
	    * @desc fades the element (short version for animate(el, {opacity: 0}))
	    * @param {Element} element
	    * @param {number} [duration=200]
	    */
	
	  }, {
	    key: 'fade',
	    value: function fade(el) {
	      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	
	      return this.animate(el, { opacity: 0 }, duration);
	    }
	  }]);
	  return AnimatorCSS;
	}();
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$11 = 'ripple';
	var scheme$23 = {
	  '': 'ripple--*',
	  '.ripple__wave': 'ripple--*__wave',
	  '.ripple__background': 'ripple--*__background'
	};
	
	/**
	 * @element ons-ripple
	 * @category visual
	 * @description
	 *   [en]
	 *     Adds a Material Design "ripple" effect to an element. The ripple effect will spread from the position where the user taps.
	 *
	 *     Some elements such as `<ons-button>` and `<ons-fab>`  support a `ripple` attribute.
	 *   [/en]
	 *   [ja]マテリアルデザインのリップル効果をDOM要素に追加します。[/ja]
	 * @codepen wKQWdZ
	 * @tutorial vanilla/Reference/ripple
	 * @modifier light-gray
	 *   [en]Change the color of effects to light gray.[/en]
	 *   [ja]エフェクトの色が明るい灰色になります。[/ja]
	 * @guide theming.html#cross-platform-styling-autostyling
	 *  [en]Cross platform styling[/en]
	 *  [ja]Cross platform styling[/ja]
	 * @example
	 * <div class="my-div">
	 *  <ons-ripple></ons-ripple>
	 * </div>
	 *
	 * @example
	 * <ons-button ripple>Click me!</ons-button>
	 */
	
	var RippleElement = function (_BaseElement) {
	  inherits(RippleElement, _BaseElement);
	
	  /**
	   * @attribute color
	   * @type {String}
	   * @description
	   *   [en]Color of the ripple effect.[/en]
	   *   [ja]リップルエフェクトの色を指定します。[/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the ripple effect.[/en]
	   *   [ja]エフェクトの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute background
	   * @type {String}
	   * @description
	   *   [en]Color of the background.[/en]
	   *   [ja]背景の色を設定します。[/ja]
	   */
	
	  /**
	   * @attribute size
	   * @type {String}
	   * @description
	   *   [en]Sizing of the wave on ripple effect. Set "cover" or "contain". Default is "cover".[/en]
	   *   [ja]エフェクトのサイズを指定します。"cover"もしくは"contain"を指定します。デフォルトは"cover"です。[/ja]
	   */
	
	  /**
	   * @attribute center
	   * @type {Boolean}
	   * @description
	   *   [en]If this attribute presents, change the position of wave effect to center of the target element.[/en]
	   *   [ja]この要素を設定すると、エフェクトの位置が要素の真ん中から始まります。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]If this attribute is set, the ripple effect will be disabled.[/en]
	   *   [ja]この属性が設定された場合、リップルエフェクトは無効になります。[/ja]
	   */
	
	  function RippleElement() {
	    classCallCheck(this, RippleElement);
	
	    var _this = possibleConstructorReturn(this, (RippleElement.__proto__ || Object.getPrototypeOf(RippleElement)).call(this));
	
	    _this._onTap = _this._onTap.bind(_this);
	    _this._onHold = _this._onHold.bind(_this);
	    _this._onDragStart = _this._onDragStart.bind(_this);
	    _this._onRelease = _this._onRelease.bind(_this);
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	
	    _this._animator = new AnimatorCSS();
	
	    ['color', 'center', 'start-radius', 'background', 'modifier'].forEach(function (e) {
	      _this.attributeChangedCallback(e, null, _this.getAttribute(e));
	    });
	    return _this;
	  }
	
	  createClass(RippleElement, [{
	    key: '_compile',
	    value: function _compile() {
	      this.classList.add(defaultClassName$11);
	
	      this._wave = this.getElementsByClassName('ripple__wave')[0];
	      this._background = this.getElementsByClassName('ripple__background')[0];
	
	      if (!(this._background && this._wave)) {
	        this._wave = util.create('.ripple__wave');
	        this._background = util.create('.ripple__background');
	
	        this.appendChild(this._wave);
	        this.appendChild(this._background);
	      }
	
	      ModifierUtil.initModifier(this, scheme$23);
	    }
	  }, {
	    key: '_getEffectSize',
	    value: function _getEffectSize() {
	      var sizes = ['cover', 'contain'];
	      if (this.hasAttribute('size')) {
	        var size = this.getAttribute('size');
	        if (sizes.indexOf(size) !== -1) {
	          return size;
	        }
	      }
	
	      return 'cover';
	    }
	  }, {
	    key: '_calculateCoords',
	    value: function _calculateCoords(e) {
	      var x = void 0,
	          y = void 0,
	          h = void 0,
	          w = void 0,
	          r = void 0;
	      var b = this.getBoundingClientRect();
	      var size = this._getEffectSize();
	
	      if (this._center) {
	        x = b.width / 2;
	        y = b.height / 2;
	
	        if (size === 'cover') {
	          r = Math.sqrt(x * x + y * y);
	        } else if (size === 'contain') {
	          r = Math.min(x, y);
	        } else {
	          throw Error('Invalid state. If this errors is shown, leport to GitHub issues.');
	        }
	      } else {
	        x = (typeof e.clientX === 'number' ? e.clientX : e.changedTouches[0].clientX) - b.left;
	        y = (typeof e.clientY === 'number' ? e.clientY : e.changedTouches[0].clientY) - b.top;
	        h = Math.max(y, b.height - y);
	        w = Math.max(x, b.width - x);
	
	        if (size === 'cover') {
	          r = Math.sqrt(h * h + w * w);
	        } else if (size === 'contain') {
	          r = Math.min(Math.round(h / 2), Math.round(w / 2));
	        } else {
	          throw Error('Invalid state. If this errors is shown, leport to GitHub issues.');
	        }
	      }
	
	      return { x: x, y: y, r: r };
	    }
	  }, {
	    key: '_rippleAnimation',
	    value: function _rippleAnimation(e) {
	      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
	      var _animator = this._animator,
	          _wave = this._wave,
	          _background = this._background,
	          _minR = this._minR;
	
	      var _calculateCoords2 = this._calculateCoords(e),
	          x = _calculateCoords2.x,
	          y = _calculateCoords2.y,
	          r = _calculateCoords2.r;
	
	      _animator.stopAll({ stopNext: 1 });
	      _animator.animate(_background, { opacity: 1 }, duration);
	
	      util.extend(_wave.style, {
	        opacity: 1,
	        top: y - _minR + 'px',
	        left: x - _minR + 'px',
	        width: 2 * _minR + 'px',
	        height: 2 * _minR + 'px'
	      });
	
	      return _animator.animate(_wave, {
	        top: y - r,
	        left: x - r,
	        height: 2 * r,
	        width: 2 * r
	      }, duration);
	    }
	  }, {
	    key: '_updateParent',
	    value: function _updateParent() {
	      if (!this._parentUpdated && this.parentNode) {
	        var computedStyle = window.getComputedStyle(this.parentNode);
	        if (computedStyle.getPropertyValue('position') === 'static') {
	          this.parentNode.style.position = 'relative';
	        }
	        this._parentUpdated = true;
	      }
	    }
	  }, {
	    key: '_onTap',
	    value: function _onTap(e) {
	      var _this2 = this;
	
	      if (!this.disabled && !e.ripple) {
	        e.ripple = true;
	        this._updateParent();
	        this._rippleAnimation(e.gesture.srcEvent).then(function () {
	          _this2._animator.fade(_this2._wave);
	          _this2._animator.fade(_this2._background);
	        });
	      }
	    }
	  }, {
	    key: '_onHold',
	    value: function _onHold(e) {
	      if (!this.disabled && !e.ripple) {
	        e.ripple = true;
	        this._updateParent();
	        this._holding = this._rippleAnimation(e.gesture.srcEvent, 2000);
	        document.addEventListener('release', this._onRelease);
	      }
	    }
	  }, {
	    key: '_onRelease',
	    value: function _onRelease(e) {
	      var _this3 = this;
	
	      if (this._holding && !e.ripple) {
	        e.ripple = true;
	        this._holding.speed(300).then(function () {
	          _this3._animator.stopAll({ stopNext: true });
	          _this3._animator.fade(_this3._wave);
	          _this3._animator.fade(_this3._background);
	        });
	
	        this._holding = false;
	      }
	
	      document.removeEventListener('release', this._onRelease);
	    }
	  }, {
	    key: '_onDragStart',
	    value: function _onDragStart(e) {
	      if (this._holding) {
	        return this._onRelease(e);
	      }
	      if (['left', 'right'].indexOf(e.gesture.direction) != -1) {
	        this._onTap(e);
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this._parentNode = this.parentNode;
	
	      if (internal$1.config.animationsDisabled) {
	        this.disabled = true;
	      } else {
	        this._parentNode.addEventListener('tap', this._onTap);
	        this._parentNode.addEventListener('hold', this._onHold);
	        this._parentNode.addEventListener('dragstart', this._onDragStart);
	      }
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      var pn = this._parentNode || this.parentNode;
	      pn.removeEventListener('tap', this._onTap);
	      pn.removeEventListener('hold', this._onHold);
	      pn.removeEventListener('dragstart', this._onDragStart);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this4 = this;
	
	      switch (name) {
	
	        case 'class':
	          util.restoreClass(this, defaultClassName$11, scheme$23);
	          break;
	
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$23);
	          break;
	
	        case 'start-radius':
	          this._minR = Math.max(0, parseFloat(current) || 0);
	          break;
	
	        case 'color':
	          if (current) {
	            contentReady(this, function () {
	              _this4._wave.style.background = current;
	              if (!_this4.hasAttribute('background')) {
	                _this4._background.style.background = current;
	              }
	            });
	          }
	          break;
	
	        case 'background':
	          if (current || last) {
	            if (current === 'none') {
	              contentReady(this, function () {
	                _this4._background.setAttribute('disabled', 'disabled');
	                _this4._background.style.background = 'transparent';
	              });
	            } else {
	              contentReady(this, function () {
	                if (_this4._background.hasAttribute('disabled')) {
	                  _this4._background.removeAttribute('disabled');
	                }
	                _this4._background.style.background = current;
	              });
	            }
	          }
	          break;
	
	        case 'center':
	          if (name === 'center') {
	            this._center = current != null && current != 'false';
	          }
	          break;
	
	      }
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['start-radius', 'color', 'background', 'center', 'class', 'modifier'];
	    }
	  }]);
	  return RippleElement;
	}(BaseElement);
	
	onsElements.Ripple = RippleElement;
	customElements.define('ons-ripple', RippleElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-row
	 * @category grid
	 * @description
	 *   [en]Represents a row in the grid system. Use with `<ons-col>` to layout components.[/en]
	 *   [ja]グリッドシステムにて行を定義します。ons-colとともに使用し、コンポーネントの配置に使用します。[/ja]
	 * @codepen GgujC {wide}
	 * @guide theming.html
	 *   [en]Layouting guide[/en]
	 *   [ja]レイアウト調整[/ja]
	 * @seealso ons-col
	 *   [en]The `<ons-col>` component is used as children of `<ons-row>`.[/en]
	 *   [ja]ons-colコンポーネント[/ja]
	 * @note
	 *   [en]For Android 4.3 and earlier, and iOS6 and earlier, when using mixed alignment with ons-row and ons-col, they may not be displayed correctly. You can use only one vertical-align.[/en]
	 *   [ja]Android 4.3以前、もしくはiOS 6以前のOSの場合、ons-rowとons-colを組み合わせてそれぞれのons-col要素のvertical-align属性の値に別々の値を指定すると、描画が崩れる場合があります。vertical-align属性の値には一つの値だけを指定できます。[/ja]
	 * @example
	 * <ons-row>
	 *   <ons-col width="50px"><ons-icon icon="fa-twitter"></ons-icon></ons-col>
	 *   <ons-col>Text</ons-col>
	 * </ons-row>
	 */
	
	/**
	 * @attribute vertical-align
	 * @type {String}
	 * @description
	 *   [en]Short hand attribute for aligning vertically. Valid values are top, bottom, and center.[/en]
	 *   [ja]縦に整列するために指定します。top、bottom、centerのいずれかを指定できます。[/ja]
	 */
	
	var RowElement = function (_BaseElement) {
	  inherits(RowElement, _BaseElement);
	
	  function RowElement() {
	    classCallCheck(this, RowElement);
	    return possibleConstructorReturn(this, (RowElement.__proto__ || Object.getPrototypeOf(RowElement)).apply(this, arguments));
	  }
	
	  return RowElement;
	}(BaseElement);
	
	onsElements.Row = RowElement;
	customElements.define('ons-row', RowElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$12 = 'segment';
	var scheme$24 = {
	  '': 'segment--*',
	  '.segment__item': 'segment--*__item',
	  '.segment__input': 'segment--*__input',
	  '.segment__button': 'segment--*__button'
	};
	
	var generateId$1 = function () {
	  var i = 0;
	  return function () {
	    return 'ons-segment-gen-' + i++;
	  };
	}();
	
	/**
	 * @element ons-segment
	 * @category control
	 * @modifier material
	 *   [en]Material Design segment[/en]
	 *   [ja][/ja]
	 * @description
	 *   [en]
	 *     Segment component. Use this component to have a button bar with automatic styles that switch on click of another button.
	 *
	 *     Will automatically display as a Material Design segment on Android.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen hLayx
	 * @tutorial vanilla/Reference/segment
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja]Information about cross platform styling[/ja]
	 * @example
	 * <ons-segment>
	 *   <ons-button>Label 1</ons-button>
	 *   <ons-button>Label 2</ons-button>
	 *   <ons-button>Label 3</ons-button>
	 * </ons-segment>
	 */
	
	var SegmentElement = function (_BaseElement) {
	  inherits(SegmentElement, _BaseElement);
	
	  /**
	   * @event postchange
	   * @description
	   *   [en]Fires after the active button is changed.[/en]
	   *   [ja][/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja][/ja]
	   * @param {Number} event.index
	   *   [en]Tapped button index.[/en]
	   *   [ja][/ja]
	   * @param {Object} event.segmentItem
	   *   [en]Segment item object.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *  [en]The appearance of the segment.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute tabbar-id
	   * @initonly
	   * @type {String}
	   * @description
	   *  [en]ID of the tabbar element to "connect" to the segment. Must be inside the same page.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute active-index
	   * @initonly
	   * @default 0
	   * @type {Number}
	   * @description
	   *  [en]Index of the first active button, only works if there is no connected tabbar (in which case the active tab sets the active button).[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]Specify if segment should be disabled.[/en]
	   *   [ja]ボタンを無効化する場合は指定します。[/ja]
	   */
	
	  function SegmentElement() {
	    classCallCheck(this, SegmentElement);
	
	    var _this = possibleConstructorReturn(this, (SegmentElement.__proto__ || Object.getPrototypeOf(SegmentElement)).call(this));
	
	    _this._segmentId = generateId$1();
	    _this._tabbar = null;
	    _this._onChange = _this._onChange.bind(_this);
	    _this._onTabbarPreChange = _this._onTabbarPreChange.bind(_this);
	
	    contentReady(_this, function () {
	      _this._compile();
	      setImmediate(function () {
	        return _this._lastActiveIndex = _this._tabbar ? _this._tabbar.getActiveTabIndex() : _this.getActiveButtonIndex();
	      });
	    });
	    return _this;
	  }
	
	  createClass(SegmentElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$12);
	
	      for (var index = this.children.length - 1; index >= 0; index--) {
	        var item = this.children[index];
	        item.classList.add('segment__item');
	
	        var input = util.findChild(item, '.segment__input') || util.create('input.segment__input');
	        input.type = 'radio';
	        input.value = index;
	        input.name = input.name || this._segmentId;
	        input.checked = !this.hasAttribute('tabbar-id') && index === (parseInt(this.getAttribute('active-index')) || 0);
	
	        var button = util.findChild(item, '.segment__button') || util.create('.segment__button');
	        if (button.parentElement !== item) {
	          while (item.firstChild) {
	            button.appendChild(item.firstChild);
	          }
	        }
	
	        item.appendChild(input);
	        item.appendChild(button);
	      }
	
	      ModifierUtil.initModifier(this, scheme$24);
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      if (this.hasAttribute('tabbar-id')) {
	        contentReady(this, function () {
	          var page = util.findParent(_this2, 'ons-page');
	          _this2._tabbar = page && page.querySelector('#' + _this2.getAttribute('tabbar-id'));
	          if (!_this2._tabbar || _this2._tabbar.tagName !== 'ONS-TABBAR') {
	            throw new Error('<ons-segment> error: no tabbar with id ' + _this2.getAttribute('tabbar-id') + ' was found.');
	          }
	
	          _this2._tabbar.setAttribute('hide-tabs', '');
	          setImmediate(function () {
	            return _this2._setChecked(_this2._tabbar.getActiveTabIndex());
	          });
	
	          _this2._tabbar.addEventListener('prechange', _this2._onTabbarPreChange);
	        });
	      }
	
	      this.addEventListener('change', this._onChange);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      var _this3 = this;
	
	      contentReady(this, function () {
	        if (_this3._tabbar) {
	          _this3._tabbar.removeEventListener('prechange', _this3._onTabbarPreChange);
	          _this3._tabbar = null;
	        }
	      });
	      this.removeEventListener('change', this._onChange);
	    }
	  }, {
	    key: '_setChecked',
	    value: function _setChecked(index) {
	      this.children[index].firstElementChild.checked = true;
	    }
	
	    /**
	     * @method setActiveButton
	     * @signature setActiveButton(index, [options])
	     * @param {Number} index
	     *   [en]Button index.[/en]
	     *   [ja][/ja]
	     * @param {Object} [options]
	     *   [en]Parameter object, works only if there is a connected tabbar. Supports the same options as `ons-tabbar`'s `setActiveTab` method.[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Make button with the specified index active. If there is a connected tabbar it shows the corresponding tab page. In this case animations and their options can be specified by the second parameter.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the selected index or to the new page element if there is a connected tabbar.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'setActiveButton',
	    value: function setActiveButton(index, options) {
	      if (this._tabbar) {
	        return this._tabbar.setActiveTab(index, options);
	      }
	
	      this._setChecked(index);
	      this._postChange(index);
	      return Promise.resolve(index);
	    }
	
	    /**
	     * @method getActiveButtonIndex
	     * @signature getActiveButtonIndex()
	     * @return {Number}
	     *   [en]The index of the currently active button.[/en]
	     *   [ja][/ja]
	     * @description
	     *   [en]Returns button index of current active button. If active button is not found, returns -1.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'getActiveButtonIndex',
	    value: function getActiveButtonIndex() {
	      for (var i = this.children.length - 1; i >= 0; i--) {
	        // Array.findIndex
	        if (this.children[i].firstElementChild.checked) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(event) {
	      event.stopPropagation();
	      this._tabbar ? this._tabbar.setActiveTab(this.getActiveButtonIndex(), { reject: false }) : this._postChange(this.getActiveButtonIndex());
	    }
	  }, {
	    key: '_onTabbarPreChange',
	    value: function _onTabbarPreChange(event) {
	      var _this4 = this;
	
	      setImmediate(function () {
	        if (!event.detail.canceled) {
	          _this4._setChecked(event.index);
	          _this4._postChange(event.index);
	        }
	      });
	    }
	  }, {
	    key: '_postChange',
	    value: function _postChange(index) {
	      util.triggerElementEvent(this, 'postchange', {
	        index: index,
	        activeIndex: index,
	        lastActiveIndex: this._lastActiveIndex,
	        segmentItem: this.children[index]
	      });
	      this._lastActiveIndex = index;
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the segment is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$12, scheme$24);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$24);
	          break;
	      }
	    }
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['class', 'modifier'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['postchange'];
	    }
	  }]);
	  return SegmentElement;
	}(BaseElement);
	
	onsElements.Segment = SegmentElement;
	customElements.define('ons-segment', SegmentElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$25 = {
	  '': 'select-* select--*',
	  '.select-input': 'select-input--*'
	};
	
	var defaultClassName$13 = 'select';
	
	var INPUT_ATTRIBUTES$1 = ['autofocus', 'disabled', 'form', 'multiple', 'name', 'required', 'size'];
	
	/**
	 * @element ons-select
	 * @category form
	 * @modifier material
	 *  [en]Displays a Material Design select input.[/en]
	 *  [ja][/ja]
	 * @modifier underbar
	 *  [en]Displays a horizontal line underneath a select input.[/en]
	 *  [ja][/ja]
	 * @description
	 *   [en]
	 *     Select component. If you want to place a select with an ID of `my-id` on a page, use `<ons-select select-id="my-id">`.
	 *
	 *     The component will automatically display as a Material Design select on Android.
	 *
	 *     Most attributes that can be used for a normal `<select>` element can also be used on the `<ons-select>` element.
	 *   [/en]
	 *   [ja]セレクトボックスを表示するコンポーネントです。`select` 要素に使用できる属性の多くが `ons-select` 要素でも利用できます。[/ja]
	 * @codepen hLayx
	 * @tutorial vanilla/Reference/select
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @guide theming.html#cross-platform-styling-autostyling [en]Information about cross platform styling[/en][ja]Information about cross platform styling[/ja]
	 * @example
	 * <ons-select>
	 *   <option value="1">1</option>
	 *   <option value="2">2nd</option>
	 *   <option value="3">3rd option</option>
	 * </ons-select>
	 */
	
	var SelectElement = function (_BaseElement) {
	  inherits(SelectElement, _BaseElement);
	
	  /**
	   * @attribute autofocus
	   * @type {Boolean}
	   * @default false
	   * @description
	   *  [en]Element automatically gains focus on page load.[/en]
	   *  [ja]ページロード時にこのセレクトボックスにフォーカスが移るようにします。[/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @type {Boolean}
	   * @default false
	   * @description
	   *   [en]Specify if select input should be disabled.[/en]
	   *   [ja]このセレクトボックスを無効化する場合に指定します。[/ja]
	   */
	
	  /**
	   * @attribute form
	   * @type {String}
	   * @description
	   *   [en]Associate a select element to an existing form on the page, even if not nested.[/en]
	   *   [ja]このセレクトボックスを、指定した `form` 要素に紐付けます。セレクトボックスを `form` 要素の外側に配置する際に使用します。[/ja]
	   */
	
	  /**
	   * @attribute multiple
	   * @type {Boolean}
	   * @default false
	   * @description
	   *  [en]If this attribute is defined, multiple options can be selected at once.[/en]
	   *  [ja]選択肢の複数選択を有効にします。[/ja]
	   */
	
	  /**
	   * @attribute name
	   * @type {String}
	   * @description
	   *   [en]Name the select element, useful for instance if it is part of a form.[/en]
	   *   [ja]このセレクトボックスの名前を指定します。通常 `form` 要素と共に使用します。[/ja]
	   */
	
	  /**
	   * @attribute required
	   * @type {Boolean}
	   * @description
	   *   [en]Make the select input required for submitting the form it is part of.[/en]
	   *   [ja]このセレクトボックスを入力必須にする場合に指定します。通常 `form` 要素と共に使用します。[/ja]
	   */
	
	  /**
	   * @attribute select-id
	   * @type {String}
	   * @description
	   *   [en]ID given to the inner select, useful for dynamic manipulation.[/en]
	   *   [ja]このセレクトボックスが内部に持つ select 要素に与える ID を指定します。セレクトボックスの内容を動的に変更する必要がある場合に使用します。[/ja]
	   */
	
	  /**
	   * @attribute size
	   * @type {Number}
	   * @default 1
	   * @description
	   *   [en]How many options are displayed; if there are more than the size then a scroll appears to navigate them.[/en]
	   *   [ja]一度に表示する選択肢の個数を指定します。選択肢がこの属性で指定した個数よりも多い場合、スクロールが有効になります。[/ja]
	   */
	
	  function SelectElement() {
	    classCallCheck(this, SelectElement);
	
	    var _this = possibleConstructorReturn(this, (SelectElement.__proto__ || Object.getPrototypeOf(SelectElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	
	    _this._deriveGetters();
	    return _this;
	  }
	
	  createClass(SelectElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this2 = this;
	
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$13, scheme$25);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$25);
	          break;
	      }
	
	      if (INPUT_ATTRIBUTES$1.indexOf(name) >= 0) {
	        contentReady(this, function () {
	          return _this2._updateBoundAttributes();
	        });
	      }
	    }
	  }, {
	    key: '_updateBoundAttributes',
	    value: function _updateBoundAttributes() {
	      var _this3 = this;
	
	      INPUT_ATTRIBUTES$1.forEach(function (attr) {
	        if (_this3.hasAttribute(attr)) {
	          _this3._select.setAttribute(attr, _this3.getAttribute(attr));
	        } else {
	          _this3._select.removeAttribute(attr);
	        }
	      });
	    }
	
	    /**
	     * @property length
	     * @description
	     *   [en]Number of options in the select box.[/en]
	     *   [ja]このセレクトボックスに含まれる選択肢の個数を返します。 `select` 要素[/ja]
	     */
	
	    /**
	     * @property options
	     * @description
	     *   [en]Several options for handling the select DOM object.[/en]
	     *   [ja]このセレクトボックスに含まれる `option` 要素の配列を返します。[/ja]
	     */
	
	    /**
	     * @property selectedIndex
	     * @description
	     *   [en]Index of the currently selected option.[/en]
	     *   [ja]現在選択されている選択肢のインデックスを返します。[/ja]
	     */
	
	    /**
	     * @property value
	     * @description
	     *   [en]Value of the currently selected option.[/en]
	     *   [ja]現在選択されている選択肢の値を返します。[/ja]
	     */
	
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.classList.add(defaultClassName$13);
	      var sel = this._select || document.createElement('select');
	      if (!sel.id && this.hasAttribute('select-id')) {
	        sel.id = this.getAttribute('select-id');
	      }
	      sel.classList.add('select-input');
	      if (!this._select) {
	        util.arrayFrom(this.childNodes).forEach(function (element) {
	          return sel.appendChild(element);
	        });
	        this.appendChild(sel);
	      }
	
	      ModifierUtil.initModifier(this, scheme$25);
	    }
	  }, {
	    key: '_deriveGetters',
	    value: function _deriveGetters() {
	      var _this4 = this;
	
	      ['disabled', 'length', 'multiple', 'name', 'options', 'selectedIndex', 'size', 'value', 'form', 'type'].forEach(function (key) {
	        Object.defineProperty(_this4, key, {
	          configurable: true,
	          enumerable: true,
	          get: function get$$1() {
	            return _this4._select[key];
	          },
	          set: ['form', 'type'].indexOf(key) === -1 ? function (value) {
	            return _this4._select[key] = value;
	          } : undefined
	        });
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(option) {
	      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this._select.add(option, index);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(index) {
	      this._select.remove(index);
	    }
	  }, {
	    key: '_select',
	    get: function get$$1() {
	      return this.querySelector('select');
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'class'].concat(INPUT_ATTRIBUTES$1);
	    }
	  }]);
	  return SelectElement;
	}(BaseElement);
	
	onsElements.Select = SelectElement;
	customElements.define('ons-select', SelectElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var defaultClassName$14 = 'fab fab--mini speed-dial__item';
	
	var scheme$26 = {
	  '': 'fab--* speed-dial__item--*'
	};
	
	/**
	 * @element ons-speed-dial-item
	 * @category control
	 * @description
	 *   [en]
	 *     This component displays the child elements of the Material Design Speed dial component.
	 *   [/en]
	 *   [ja]
	 *     Material DesignのSpeed dialの子要素を表現する要素です。
	 *   [/ja]
	 * @codepen dYQYLg
	 * @tutorial vanilla/Reference/speed-dial
	 * @seealso ons-speed-dial
	 *   [en]The `<ons-speed-dial>` component.[/en]
	 *   [ja]ons-speed-dialコンポーネント[/ja]
	 * @seealso ons-fab
	 *   [en]ons-fab component[/en]
	 *   [ja]ons-fabコンポーネント[/ja]
	 * @example
	 * <ons-speed-dial position="left bottom">
	 *   <ons-fab>
	 *     <ons-icon icon="fa-twitter"></ons-icon>
	 *   </ons-fab>
	 *   <ons-speed-dial-item>A</ons-speed-dial-item>
	 *   <ons-speed-dial-item>B</ons-speed-dial-item>
	 *   <ons-speed-dial-item>C</ons-speed-dial-item>
	 * </ons-speed-dial>
	 */
	
	var SpeedDialItemElement = function (_BaseElement) {
	  inherits(SpeedDialItemElement, _BaseElement);
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the component.[/en]
	   *   [ja]このコンポーネントの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute ripple
	   * @description
	   *  [en]If this attribute is defined, the button will have a ripple effect when tapped.[/en]
	   *  [ja][/ja]
	   */
	
	  function SpeedDialItemElement() {
	    classCallCheck(this, SpeedDialItemElement);
	
	    var _this = possibleConstructorReturn(this, (SpeedDialItemElement.__proto__ || Object.getPrototypeOf(SpeedDialItemElement)).call(this));
	
	    _this._compile();
	    _this._boundOnClick = _this._onClick.bind(_this);
	    return _this;
	  }
	
	  createClass(SpeedDialItemElement, [{
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$14, scheme$26);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$26);
	          util.addModifier(this, 'mini');
	          break;
	        case 'ripple':
	          this._updateRipple();
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this.addEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this.removeEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: '_updateRipple',
	    value: function _updateRipple() {
	      util.updateRipple(this);
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(e) {
	      e.stopPropagation();
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      var _this2 = this;
	
	      autoStyle.prepare(this);
	
	      defaultClassName$14.split(/\s+/).forEach(function (token) {
	        return _this2.classList.add(token);
	      });
	
	      util.addModifier(this, 'mini');
	      this._updateRipple();
	
	      ModifierUtil.initModifier(this, scheme$26);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'ripple', 'class'];
	    }
	  }]);
	  return SpeedDialItemElement;
	}(BaseElement);
	
	onsElements.SpeedDialItem = SpeedDialItemElement;
	customElements.define('ons-speed-dial-item', SpeedDialItemElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var defaultClassName$15 = 'speed-dial';
	var scheme$27 = {
	  '': 'speed-dial--*'
	};
	
	/**
	 * @element ons-speed-dial
	 * @category control
	 * @description
	 *   [en]
	 *     Element that displays a Material Design Speed Dialog component. It is useful when there are more than one primary action that can be performed in a page.
	 *
	 *     The Speed dial looks like a `<ons-fab>` element but will expand a menu when tapped.
	 *   [/en]
	 *   [ja][/ja]
	 * @codepen dYQYLg
	 * @tutorial vanilla/Reference/speed-dial
	 * @seealso ons-speed-dial-item
	 *   [en]The `<ons-speed-dial-item>` represents a menu item.[/en]
	 *   [ja]ons-speed-dial-itemコンポーネント[/ja]
	 * @seealso ons-fab
	 *   [en]ons-fab component[/en]
	 *   [ja]ons-fabコンポーネント[/ja]
	 * @example
	 * <ons-speed-dial position="left bottom">
	 *   <ons-fab>
	 *     <ons-icon icon="fa-twitter"></ons-icon>
	 *   </ons-fab>
	 *   <ons-speed-dial-item>A</ons-speed-dial-item>
	 *   <ons-speed-dial-item>B</ons-speed-dial-item>
	 *   <ons-speed-dial-item>C</ons-speed-dial-item>
	 * </ons-speed-dial>
	 */
	
	var SpeedDialElement = function (_BaseElement) {
	  inherits(SpeedDialElement, _BaseElement);
	
	  /**
	   * @event open
	   * @description
	   *   [en]Fired when the menu items are shown.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @event close
	   * @description
	   *   [en]Fired when the menu items are hidden.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the component.[/en]
	   *   [ja]このコンポーネントの表現を指定します。[/ja]
	   */
	
	  /**
	   * @attribute ripple
	   * @description
	   *  [en]If this attribute is defined, the button will have a ripple effect when tapped.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute position
	   * @type {String}
	   * @description
	   *   [en]
	   *     Specify the vertical and horizontal position of the component.
	   *     I.e. to display it in the top right corner specify "right top".
	   *     Choose from "right", "left", "top" and "bottom".
	   *   [/en]
	   *   [ja]
	   *     この要素を表示する左右と上下の位置を指定します。
	   *     例えば、右上に表示する場合には"right top"を指定します。
	   *     左右と上下の位置の指定には、rightとleft、topとbottomがそれぞれ指定できます。
	   *   [/ja]
	   */
	
	  /**
	   * @attribute direction
	   * @type {String}
	   * @description
	   *   [en]Specify the direction the items are displayed. Possible values are "up", "down", "left" and "right".[/en]
	   *   [ja]
	   *     要素が表示する方向を指定します。up, down, left, rightが指定できます。
	   *   [/ja]
	   */
	
	  /**
	   * @attribute disabled
	   * @description
	   *   [en]Specify if button should be disabled.[/en]
	   *   [ja]無効化する場合に指定します。[/ja]
	   */
	
	  function SpeedDialElement() {
	    classCallCheck(this, SpeedDialElement);
	
	    var _this = possibleConstructorReturn(this, (SpeedDialElement.__proto__ || Object.getPrototypeOf(SpeedDialElement)).call(this));
	
	    contentReady(_this, function () {
	      _this._compile();
	    });
	
	    _this._itemShown = false;
	    _this._boundOnClick = _this._onClick.bind(_this);
	    return _this;
	  }
	
	  createClass(SpeedDialElement, [{
	    key: '_compile',
	    value: function _compile() {
	      this.classList.add(defaultClassName$15);
	      autoStyle.prepare(this);
	      this._updateRipple();
	      ModifierUtil.initModifier(this, scheme$27);
	
	      if (this.hasAttribute('direction')) {
	        this._updateDirection(this.getAttribute('direction'));
	      } else {
	        this._updateDirection('up');
	      }
	
	      this._updatePosition();
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this2 = this;
	
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$15, scheme$27);
	          break;
	        case 'modifier':
	          ModifierUtil.onModifierChanged(last, current, this, scheme$27);
	          break;
	        case 'ripple':
	          contentReady(this, function () {
	            return _this2._updateRipple();
	          });
	          break;
	        case 'direction':
	          contentReady(this, function () {
	            return _this2._updateDirection(current);
	          });
	          break;
	        case 'position':
	          contentReady(this, function () {
	            return _this2._updatePosition();
	          });
	          break;
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this.addEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this.removeEventListener('click', this._boundOnClick, false);
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(e) {
	      if (this.onClick) {
	        this.onClick.apply(this);
	        return Promise.resolve();
	      } else if (!this.disabled && this.visible) {
	        return this.toggleItems();
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      if (!this.inline) {
	        return this.show();
	      }
	      return Promise.resolve();
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var _this3 = this;
	
	      return new Promise(function (resolve) {
	        if (!_this3.inline) {
	          setImmediate(function () {
	            return _this3.hide().then(resolve);
	          });
	        } else {
	          resolve();
	        }
	      });
	    }
	  }, {
	    key: '_updateRipple',
	    value: function _updateRipple() {
	      if (this._fab) {
	        this.hasAttribute('ripple') ? this._fab.setAttribute('ripple', '') : this._fab.removeAttribute('ripple');
	      }
	    }
	  }, {
	    key: '_updateDirection',
	    value: function _updateDirection(direction) {
	      var children = this.items;
	      for (var i = 0; i < children.length; i++) {
	        styler(children[i], {
	          transitionDelay: 25 * i + 'ms',
	          bottom: 'auto',
	          right: 'auto',
	          top: 'auto',
	          left: 'auto'
	        });
	      }
	      switch (direction) {
	        case 'up':
	          for (var _i = 0; _i < children.length; _i++) {
	            children[_i].style.bottom = 72 + 56 * _i + 'px';
	            children[_i].style.right = '8px';
	          }
	          break;
	        case 'down':
	          for (var _i2 = 0; _i2 < children.length; _i2++) {
	            children[_i2].style.top = 72 + 56 * _i2 + 'px';
	            children[_i2].style.left = '8px';
	          }
	          break;
	        case 'left':
	          for (var _i3 = 0; _i3 < children.length; _i3++) {
	            children[_i3].style.top = '8px';
	            children[_i3].style.right = 72 + 56 * _i3 + 'px';
	          }
	          break;
	        case 'right':
	          for (var _i4 = 0; _i4 < children.length; _i4++) {
	            children[_i4].style.top = '8px';
	            children[_i4].style.left = 72 + 56 * _i4 + 'px';
	          }
	          break;
	        default:
	          throw new Error('Argument must be one of up, down, left or right.');
	      }
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition() {
	      var position = this.getAttribute('position');
	      this.classList.remove('fab--top__left', 'fab--bottom__right', 'fab--bottom__left', 'fab--top__right', 'fab--top__center', 'fab--bottom__center');
	      switch (position) {
	        case 'top right':
	        case 'right top':
	          this.classList.add('fab--top__right');
	          break;
	        case 'top left':
	        case 'left top':
	          this.classList.add('fab--top__left');
	          break;
	        case 'bottom right':
	        case 'right bottom':
	          this.classList.add('fab--bottom__right');
	          break;
	        case 'bottom left':
	        case 'left bottom':
	          this.classList.add('fab--bottom__left');
	          break;
	        case 'center top':
	        case 'top center':
	          this.classList.add('fab--top__center');
	          break;
	        case 'center bottom':
	        case 'bottom center':
	          this.classList.add('fab--bottom__center');
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: '_getTranslate',
	    value: function _getTranslate() {
	      var isBottom = (this.getAttribute('position') || '').indexOf('bottom') >= 0;
	      var translate = isBottom ? 'translate3d(0px, -' + (util.globals.fabOffset || 0) + 'px, 0px) ' : '';
	      return translate;
	    }
	
	    /**
	     * @method show
	     * @signature show()
	     * @description
	     *   [en]Show the speed dial.[/en]
	     *   [ja]Speed dialを表示します。[/ja]
	     */
	
	  }, {
	    key: 'show',
	    value: function show() {
	      this._fab.show();
	      styler(this, { transform: this._getTranslate });
	      return Promise.resolve();
	    }
	
	    /**
	     * @method hide
	     * @signature hide()
	     * @description
	     *   [en]Hide the speed dial.[/en]
	     *   [ja]Speed dialを非表示にします。[/ja]
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this4 = this;
	
	      return this.hideItems().then(function () {
	        return _this4._fab.hide();
	      });
	    }
	
	    /**
	     * @method showItems
	     * @signature showItems()
	     * @description
	     *   [en]Show the speed dial items.[/en]
	     *   [ja]Speed dialの子要素を表示します。[/ja]
	     */
	
	  }, {
	    key: 'showItems',
	    value: function showItems() {
	      if (this.hasAttribute('direction')) {
	        this._updateDirection(this.getAttribute('direction'));
	      } else {
	        this._updateDirection('up');
	      }
	
	      var totalDelay = 0;
	      if (!this._itemShown) {
	        var children = this.items;
	        for (var i = 0; i < children.length; i++) {
	          var delay = 25 * i;
	          totalDelay += delay;
	          styler(children[i], {
	            transform: 'scale(1)',
	            transitionDelay: delay + 'ms'
	          });
	        }
	        totalDelay += 50;
	
	        this._itemShown = true;
	        util.triggerElementEvent(this, 'open');
	      }
	
	      var deferred = util.defer();
	      setTimeout(deferred.resolve, totalDelay);
	      return deferred.promise;
	    }
	
	    /**
	     * @method hideItems
	     * @signature hideItems()
	     * @description
	     *   [en]Hide the speed dial items.[/en]
	     *   [ja]Speed dialの子要素を非表示にします。[/ja]
	     */
	
	  }, {
	    key: 'hideItems',
	    value: function hideItems() {
	      var totalDelay = 0;
	      if (this._itemShown) {
	        var children = this.items;
	        for (var i = 0; i < children.length; i++) {
	          var delay = 25 * (children.length - i);
	          totalDelay += delay;
	          styler(children[i], {
	            transform: 'scale(0)',
	            transitionDelay: delay + 'ms'
	          });
	        }
	        totalDelay += 50;
	
	        this._itemShown = false;
	        util.triggerElementEvent(this, 'close');
	      }
	
	      var deferred = util.defer();
	      setTimeout(deferred.resolve, totalDelay);
	      return deferred.promise;
	    }
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'isOpen',
	
	
	    /**
	     * @method isOpen
	     * @signature isOpen()
	     * @description
	     *   [en]Returns whether the menu is open or not.[/en]
	     *   [ja][/ja]
	     */
	    value: function isOpen() {
	      return this._itemShown;
	    }
	
	    /**
	     * @method toggle
	     * @signature toggle()
	     * @description
	     *   [en]Toggle visibility.[/en]
	     *   [ja]Speed dialの表示非表示を切り替えます。[/ja]
	     */
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      return this.visible ? this.hide() : this.show();
	    }
	
	    /**
	     * @method toggleItems
	     * @signature toggleItems()
	     * @description
	     *   [en]Toggle item visibility.[/en]
	     *   [ja]Speed dialの子要素の表示非表示を切り替えます。[/ja]
	     */
	
	  }, {
	    key: 'toggleItems',
	    value: function toggleItems() {
	      return this.isOpen() ? this.hideItems() : this.showItems();
	    }
	  }, {
	    key: 'items',
	    get: function get$$1() {
	      return util.arrayFrom(this.querySelectorAll('ons-speed-dial-item'));
	    }
	  }, {
	    key: '_fab',
	    get: function get$$1() {
	      return util.findChild(this, 'ons-fab');
	    }
	  }, {
	    key: 'disabled',
	    set: function set$$1(value) {
	      if (value) {
	        this.hideItems();
	      }
	      util.arrayFrom(this.children).forEach(function (e) {
	        util.match(e, '.fab') && util.toggleAttribute(e, 'disabled', value);
	      });
	
	      return util.toggleAttribute(this, 'disabled', value);
	    },
	    get: function get$$1() {
	      return this.hasAttribute('disabled');
	    }
	
	    /**
	     * @property inline
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is inline or not.[/en]
	     *   [ja]インライン要素の場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'inline',
	    get: function get$$1() {
	      return this.hasAttribute('inline');
	    }
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'visible',
	    get: function get$$1() {
	      return this._fab.visible && this.style.display !== 'none';
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['class', 'modifier', 'ripple', 'direction', 'position'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['open', 'close'];
	    }
	  }]);
	  return SpeedDialElement;
	}(BaseElement);
	
	onsElements.SpeedDial = SpeedDialElement;
	customElements.define('ons-speed-dial', SpeedDialElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var rewritables$1 = {
	  /**
	   * @param {Element} element
	   * @param {Function} callback
	   */
	  ready: function ready(element, callback) {
	    setImmediate(callback);
	  }
	};
	
	/**
	 * @element ons-splitter-content
	 * @category menu
	 * @description
	 *  [en]
	 *    The `<ons-splitter-content>` element is used as a child element of `<ons-splitter>`.
	 *
	 *    It contains the main content of the page while `<ons-splitter-side>` contains the list.
	 *  [/en]
	 *  [ja]ons-splitter-content要素は、ons-splitter要素の子要素として利用します。[/ja]
	 * @codepen rOQOML
	 * @tutorial vanilla/Reference/splitter
	 * @guide fundamentals.html#managing-pages
	 *  [en]Managing multiple pages.[/en]
	 *  [ja]複数のページを管理する[/ja]
	 * @seealso ons-splitter
	 *  [en]The `<ons-splitter>` component is the parent element.[/en]
	 *  [ja]ons-splitterコンポーネント[/ja]
	 * @seealso ons-splitter-side
	 *  [en]The `<ons-splitter-side>` component contains the menu.[/en]
	 *  [ja]ons-splitter-sideコンポーネント[/ja]
	 * @example
	 * <ons-splitter>
	 *   <ons-splitter-content>
	 *     ...
	 *   </ons-splitter-content>
	 *
	 *   <ons-splitter-side side="left" width="80%" collapse>
	 *     ...
	 *   </ons-splitter-side>
	 * </ons-splitter>
	 */
	
	var SplitterContentElement = function (_BaseElement) {
	  inherits(SplitterContentElement, _BaseElement);
	
	  /**
	   * @attribute page
	   * @type {String}
	   * @description
	   *   [en]
	   *     The url of the content page. If this attribute is used the content will be loaded from a `<template>` tag or a remote file.
	   *
	   *     It is also possible to put `<ons-page>` element as a child of the element.
	   *   [/en]
	   *   [ja]ons-splitter-content要素に表示するページのURLを指定します。[/ja]
	   */
	
	  function SplitterContentElement() {
	    classCallCheck(this, SplitterContentElement);
	
	    var _this = possibleConstructorReturn(this, (SplitterContentElement.__proto__ || Object.getPrototypeOf(SplitterContentElement)).call(this));
	
	    _this._page = null;
	    _this._pageLoader = defaultPageLoader;
	
	    contentReady(_this, function () {
	      rewritables$1.ready(_this, function () {
	        var page = _this._getPageTarget();
	
	        if (page) {
	          _this.load(page);
	        }
	      });
	    });
	    return _this;
	  }
	
	  createClass(SplitterContentElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      if (!util.match(this.parentNode, 'ons-splitter')) {
	        throw new Error('"ons-splitter-content" must have "ons-splitter" as parentNode.');
	      }
	    }
	  }, {
	    key: '_getPageTarget',
	    value: function _getPageTarget() {
	      return this._page || this.getAttribute('page');
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {}
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {}
	
	    /**
	     * @property page
	     * @type {HTMLElement}
	     * @description
	     *   [en]The page to load in the splitter content.[/en]
	     *   [ja]この要素内に表示するページを指定します。[/ja]
	     */
	
	  }, {
	    key: 'load',
	
	
	    /**
	     * @method load
	     * @signature load(page, [options])
	     * @param {String} page, [options]
	     *   [en]Page URL. Can be either an HTML document or an `<template>` id.[/en]
	     *   [ja]pageのURLか、`<template>`で宣言したテンプレートのid属性の値を指定します。[/ja]
	     * @param {Object} [options]
	     * @param {Function} [options.callback]
	     * @description
	     *   [en]Show the page specified in `page` in the content.[/en]
	     *   [ja]指定したURLをメインページを読み込みます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the new `<ons-page>` element[/en]
	     *   [ja]`<ons-page>`要素を解決するPromiseオブジェクトを返します。[/ja]
	     */
	    value: function load(page) {
	      var _this2 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._page = page;
	      var callback = options.callback || function () {};
	
	      return new Promise(function (resolve) {
	        var oldContent = _this2._content || null;
	
	        _this2._pageLoader.load({ page: page, parent: _this2 }, function (pageElement) {
	          if (oldContent) {
	            _this2._pageLoader.unload(oldContent);
	            oldContent = null;
	          }
	
	          setImmediate(function () {
	            return _this2._show();
	          });
	
	          callback(pageElement);
	          resolve(pageElement);
	        });
	      });
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      if (this._content) {
	        this._content._show();
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      if (this._content) {
	        this._content._hide();
	      }
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      if (this._content) {
	        this._pageLoader.unload(this._content);
	      }
	      this.remove();
	    }
	  }, {
	    key: 'page',
	    get: function get$$1() {
	      return this._page;
	    }
	
	    /**
	     * @param {*} page
	     */
	    ,
	    set: function set$$1(page) {
	      this._page = page;
	    }
	  }, {
	    key: '_content',
	    get: function get$$1() {
	      return this.children[0];
	    }
	
	    /**
	     * @property pageLoader
	     * @type {Function}
	     * @description
	     *   [en]Page element loaded in the splitter content.[/en]
	     *   [ja]この要素内に表示するページを指定します。[/ja]
	     */
	
	  }, {
	    key: 'pageLoader',
	    get: function get$$1() {
	      return this._pageLoader;
	    },
	    set: function set$$1(loader) {
	      if (!(loader instanceof PageLoader)) {
	        throw Error('First parameter must be an instance of PageLoader');
	      }
	      this._pageLoader = loader;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [];
	    }
	  }, {
	    key: 'rewritables',
	    get: function get$$1() {
	      return rewritables$1;
	    }
	  }]);
	  return SplitterContentElement;
	}(BaseElement);
	
	onsElements.SplitterContent = SplitterContentElement;
	customElements.define('ons-splitter-content', SplitterContentElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var SplitterMaskElement = function (_BaseElement) {
	  inherits(SplitterMaskElement, _BaseElement);
	
	  function SplitterMaskElement() {
	    classCallCheck(this, SplitterMaskElement);
	
	    var _this = possibleConstructorReturn(this, (SplitterMaskElement.__proto__ || Object.getPrototypeOf(SplitterMaskElement)).call(this));
	
	    _this._boundOnClick = _this._onClick.bind(_this);
	    contentReady(_this, function () {
	      if (_this.parentNode._sides.every(function (side) {
	        return side.mode === 'split';
	      })) {
	        _this.setAttribute('style', 'display: none !important');
	      }
	    });
	    return _this;
	  }
	
	  createClass(SplitterMaskElement, [{
	    key: '_onClick',
	    value: function _onClick(event) {
	      if (this.onClick instanceof Function) {
	        this.onClick();
	      } else if (util.match(this.parentNode, 'ons-splitter')) {
	        this.parentNode._sides.forEach(function (side) {
	          return side.close('left').catch(function () {});
	        });
	      }
	      event.stopPropagation();
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {}
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this.addEventListener('click', this._boundOnClick);
	      util.iosMaskScrollFix(this, true);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this.removeEventListener('click', this._boundOnClick);
	      util.iosMaskScrollFix(this, false);
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [];
	    }
	  }]);
	  return SplitterMaskElement;
	}(BaseElement);
	
	onsElements.SplitterMask = SplitterMaskElement;
	customElements.define('ons-splitter-mask', SplitterMaskElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var SplitterAnimator$1 = function (_BaseAnimator) {
	  inherits(SplitterAnimator, _BaseAnimator);
	
	  function SplitterAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'cubic-bezier(.1, .7, .1, 1)' : _ref$timing,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.3 : _ref$duration,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay;
	
	    classCallCheck(this, SplitterAnimator);
	    return possibleConstructorReturn(this, (SplitterAnimator.__proto__ || Object.getPrototypeOf(SplitterAnimator)).call(this, { timing: timing, duration: duration, delay: delay }));
	  }
	
	  createClass(SplitterAnimator, [{
	    key: 'updateOptions',
	    value: function updateOptions() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      util.extend(this, {
	        timing: this.timing, duration: this.duration, delay: this.delay
	      }, options);
	    }
	
	    /**
	     * @param {Element} sideElement
	     */
	
	  }, {
	    key: 'activate',
	    value: function activate(sideElement) {
	      var _this2 = this;
	
	      var splitter = sideElement.parentNode;
	
	      contentReady(splitter, function () {
	        _this2._side = sideElement;
	        _this2._oppositeSide = splitter.right !== sideElement && splitter.right || splitter.left !== sideElement && splitter.left;
	        _this2._content = splitter.content;
	        _this2._mask = splitter.mask;
	      });
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this.clearTransition();
	      this._mask && this.clearMask();
	      this._content = this._side = this._oppositeSide = this._mask = null;
	    }
	  }, {
	    key: 'clearTransition',
	    value: function clearTransition() {
	      var _this3 = this;
	
	      'side mask content'.split(/\s+/).forEach(function (e) {
	        return _this3['_' + e] && styler.clear(_this3['_' + e], 'transform transition');
	      });
	    }
	  }, {
	    key: 'clearMask',
	    value: function clearMask() {
	      // Check if the other side needs the mask before clearing
	      if (!this._oppositeSide || this._oppositeSide.mode === 'split' || !this._oppositeSide.isOpen) {
	        this._mask.style.opacity = '';
	        this._mask.style.display = 'none';
	      }
	    }
	
	    /**
	     * @param {Number} distance
	     */
	
	  }, {
	    key: 'translate',
	    value: function translate(distance) {}
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'open',
	    value: function open(done) {
	      done();
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'close',
	    value: function close(done) {
	      done();
	    }
	  }, {
	    key: 'minus',
	    get: function get$$1() {
	      return this._side.side === 'right' ? '-' : '';
	    }
	  }]);
	  return SplitterAnimator;
	}(BaseAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var OverlaySplitterAnimator = function (_SplitterAnimator) {
	  inherits(OverlaySplitterAnimator, _SplitterAnimator);
	
	  function OverlaySplitterAnimator() {
	    classCallCheck(this, OverlaySplitterAnimator);
	    return possibleConstructorReturn(this, (OverlaySplitterAnimator.__proto__ || Object.getPrototypeOf(OverlaySplitterAnimator)).apply(this, arguments));
	  }
	
	  createClass(OverlaySplitterAnimator, [{
	    key: 'translate',
	    value: function translate(distance) {
	      this._mask.style.display = 'block'; // Avoid content clicks
	
	      Animit(this._side).queue({
	        transform: 'translate3d(' + (this.minus + distance) + 'px, 0px, 0px)'
	      }).play();
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'open',
	    value: function open(done) {
	      Animit.runAll(Animit(this._side).wait(this.delay).queue({
	        transform: 'translate3d(' + this.minus + '100%, 0px, 0px)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (callback) {
	        callback();
	        done && done();
	      }), Animit(this._mask).wait(this.delay).queue({
	        display: 'block'
	      }).queue({
	        opacity: '1'
	      }, {
	        duration: this.duration,
	        timing: 'linear'
	      }));
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'close',
	    value: function close(done) {
	
	      Animit.runAll(Animit(this._side).wait(this.delay).queue({
	        transform: 'translate3d(0px, 0px, 0px)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (callback) {
	        done && done();
	        callback();
	      }), Animit(this._mask).wait(this.delay).queue({
	        opacity: '0'
	      }, {
	        duration: this.duration,
	        timing: 'linear'
	      }).queue({
	        display: 'none'
	      }));
	    }
	  }]);
	  return OverlaySplitterAnimator;
	}(SplitterAnimator$1);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var PushSplitterAnimator = function (_SplitterAnimator) {
	  inherits(PushSplitterAnimator, _SplitterAnimator);
	
	  function PushSplitterAnimator() {
	    classCallCheck(this, PushSplitterAnimator);
	    return possibleConstructorReturn(this, (PushSplitterAnimator.__proto__ || Object.getPrototypeOf(PushSplitterAnimator)).apply(this, arguments));
	  }
	
	  createClass(PushSplitterAnimator, [{
	    key: '_getSlidingElements',
	    value: function _getSlidingElements() {
	      var slidingElements = [this._side, this._content];
	      if (this._oppositeSide && this._oppositeSide.mode === 'split') {
	        slidingElements.push(this._oppositeSide);
	      }
	
	      return slidingElements;
	    }
	  }, {
	    key: 'translate',
	    value: function translate(distance) {
	      if (!this._slidingElements) {
	        this._slidingElements = this._getSlidingElements();
	      }
	
	      this._mask.style.display = 'block'; // Avoid content clicks
	
	      Animit(this._slidingElements).queue({
	        transform: 'translate3d(' + (this.minus + distance) + 'px, 0px, 0px)'
	      }).play();
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'open',
	    value: function open(done) {
	      var _this2 = this;
	
	      var max = this._side.offsetWidth;
	      this._slidingElements = this._getSlidingElements();
	
	      Animit.runAll(Animit(this._slidingElements).wait(this.delay).queue({
	        transform: 'translate3d(' + (this.minus + max) + 'px, 0px, 0px)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (callback) {
	        _this2._slidingElements = null;
	        callback();
	        done && done();
	      }), Animit(this._mask).wait(this.delay).queue({
	        display: 'block'
	      }));
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'close',
	    value: function close(done) {
	      var _this3 = this;
	
	      this._slidingElements = this._getSlidingElements();
	
	      Animit.runAll(Animit(this._slidingElements).wait(this.delay).queue({
	        transform: 'translate3d(0px, 0px, 0px)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (callback) {
	        _this3._slidingElements = null;
	        get(PushSplitterAnimator.prototype.__proto__ || Object.getPrototypeOf(PushSplitterAnimator.prototype), 'clearTransition', _this3).call(_this3);
	        done && done();
	        callback();
	      }), Animit(this._mask).wait(this.delay).queue({
	        display: 'none'
	      }));
	    }
	  }]);
	  return PushSplitterAnimator;
	}(SplitterAnimator$1);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var RevealSplitterAnimator = function (_SplitterAnimator) {
	  inherits(RevealSplitterAnimator, _SplitterAnimator);
	
	  function RevealSplitterAnimator() {
	    classCallCheck(this, RevealSplitterAnimator);
	    return possibleConstructorReturn(this, (RevealSplitterAnimator.__proto__ || Object.getPrototypeOf(RevealSplitterAnimator)).apply(this, arguments));
	  }
	
	  createClass(RevealSplitterAnimator, [{
	    key: '_getSlidingElements',
	    value: function _getSlidingElements() {
	      var slidingElements = [this._content, this._mask];
	      if (this._oppositeSide && this._oppositeSide.mode === 'split') {
	        slidingElements.push(this._oppositeSide);
	      }
	
	      return slidingElements;
	    }
	  }, {
	    key: 'activate',
	    value: function activate(sideElement) {
	      get(RevealSplitterAnimator.prototype.__proto__ || Object.getPrototypeOf(RevealSplitterAnimator.prototype), 'activate', this).call(this, sideElement);
	      if (sideElement.mode === 'collapse') {
	        this._setStyles(sideElement);
	      }
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this._side && this._unsetStyles(this._side);
	      get(RevealSplitterAnimator.prototype.__proto__ || Object.getPrototypeOf(RevealSplitterAnimator.prototype), 'deactivate', this).call(this);
	    }
	  }, {
	    key: '_setStyles',
	    value: function _setStyles(sideElement) {
	      styler(sideElement, {
	        left: sideElement.side === 'right' ? 'auto' : 0,
	        right: sideElement.side === 'right' ? 0 : 'auto',
	        zIndex: 0,
	        backgroundColor: 'black',
	        transform: this._generateBehindPageStyle(0).container.transform,
	        display: 'none'
	      });
	
	      var splitter = sideElement.parentElement;
	      contentReady(splitter, function () {
	        return splitter.content && styler(splitter.content, { boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.2)' });
	      });
	    }
	  }, {
	    key: '_unsetStyles',
	    value: function _unsetStyles(sideElement) {
	      styler.clear(sideElement, 'left right zIndex backgroundColor display');
	      if (sideElement._content) {
	        sideElement._content.style.opacity = '';
	      }
	
	      // Check if the other side needs the common styles
	      if (!this._oppositeSide || this._oppositeSide.mode === 'split') {
	        sideElement.parentElement.content && styler.clear(sideElement.parentElement.content, 'boxShadow');
	      }
	    }
	  }, {
	    key: '_generateBehindPageStyle',
	    value: function _generateBehindPageStyle(distance) {
	      var max = this.maxWidth;
	
	      var behindDistance = (distance - max) / max * 10;
	      behindDistance = isNaN(behindDistance) ? 0 : Math.max(Math.min(behindDistance, 0), -10);
	
	      var behindTransform = 'translate3d(' + (this.minus ? -1 : 1) * behindDistance + '%, 0, 0)';
	      var opacity = 1 + behindDistance / 100;
	
	      return {
	        content: {
	          opacity: opacity
	        },
	        container: {
	          transform: behindTransform
	        }
	      };
	    }
	  }, {
	    key: 'translate',
	    value: function translate(distance) {
	      this._side.style.display = '';
	      this._side.style.zIndex = 1;
	      this.maxWidth = this.maxWidth || this._getMaxWidth();
	      var menuStyle = this._generateBehindPageStyle(Math.min(distance, this.maxWidth));
	
	      if (!this._slidingElements) {
	        this._slidingElements = this._getSlidingElements();
	      }
	
	      this._mask.style.display = 'block'; // Avoid content clicks
	
	      Animit.runAll(Animit(this._slidingElements).queue({
	        transform: 'translate3d(' + (this.minus + distance) + 'px, 0px, 0px)'
	      }), Animit(this._side._content).queue(menuStyle.content), Animit(this._side).queue(menuStyle.container));
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'open',
	    value: function open(done) {
	      var _this2 = this;
	
	      this._side.style.display = '';
	      this._side.style.zIndex = 1;
	      this.maxWidth = this.maxWidth || this._getMaxWidth();
	      var menuStyle = this._generateBehindPageStyle(this.maxWidth);
	      this._slidingElements = this._getSlidingElements();
	
	      setTimeout(function () {
	        // Fix: Time to update previous translate3d after changing style.display
	        Animit.runAll(Animit(_this2._slidingElements).wait(_this2.delay).queue({
	          transform: 'translate3d(' + (_this2.minus + _this2.maxWidth) + 'px, 0px, 0px)'
	        }, {
	          duration: _this2.duration,
	          timing: _this2.timing
	        }), Animit(_this2._mask).wait(_this2.delay).queue({
	          display: 'block'
	        }), Animit(_this2._side._content).wait(_this2.delay).queue(menuStyle.content, {
	          duration: _this2.duration,
	          timing: _this2.timing
	        }), Animit(_this2._side).wait(_this2.delay).queue(menuStyle.container, {
	          duration: _this2.duration,
	          timing: _this2.timing
	        }).queue(function (callback) {
	          _this2._slidingElements = null;
	          callback();
	          done && done();
	        }));
	      }, 1000 / 60);
	    }
	
	    /**
	     * @param {Function} done
	     */
	
	  }, {
	    key: 'close',
	    value: function close(done) {
	      var _this3 = this;
	
	      var menuStyle = this._generateBehindPageStyle(0);
	      this._slidingElements = this._getSlidingElements();
	
	      Animit.runAll(Animit(this._slidingElements).wait(this.delay).queue({
	        transform: 'translate3d(0px, 0px, 0px)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(this._mask).wait(this.delay).queue({
	        display: 'none'
	      }), Animit(this._side._content).wait(this.delay).queue(menuStyle.content, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(this._side).wait(this.delay).queue(menuStyle.container, {
	        duration: this.duration,
	        timing: this.timing
	      }).queue(function (callback) {
	        _this3._slidingElements = null;
	        _this3._side.style.zIndex = 0;
	        _this3._side.style.display = 'none';
	        _this3._side._content.style.opacity = '';
	        done && done();
	        callback();
	      }));
	    }
	  }, {
	    key: '_getMaxWidth',
	    value: function _getMaxWidth() {
	      return this._side.offsetWidth;
	    }
	  }]);
	  return RevealSplitterAnimator;
	}(SplitterAnimator$1);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var _animatorDict$6 = {
	  default: OverlaySplitterAnimator,
	  overlay: OverlaySplitterAnimator,
	  push: PushSplitterAnimator,
	  reveal: RevealSplitterAnimator
	};
	
	/**
	 * @element ons-splitter
	 * @category menu
	 * @description
	 *  [en]
	 *    A component that enables responsive layout by implementing both a two-column layout and a sliding menu layout.
	 *
	 *    It can be configured to automatically expand into a column layout on large screens and collapse the menu on smaller screens. When the menu is collapsed the user can open it by swiping.
	 *  [/en]
	 *  [ja][/ja]
	 * @codepen rOQOML
	 * @tutorial vanilla/Reference/splitter
	 * @guide fundamentals.html#managing-pages
	 *  [en]Managing multiple pages.[/en]
	 *  [ja]複数のページを管理する[/ja]
	 * @seealso ons-splitter-content
	 *  [en]The `<ons-splitter-content>` component contains the main content of the page.[/en]
	 *  [ja]ons-splitter-contentコンポーネント[/ja]
	 * @seealso ons-splitter-side
	 *  [en]The `<ons-splitter-side>` component contains the menu.[/en]
	 *  [ja]ons-splitter-sideコンポーネント[/ja]
	 * @example
	 * <ons-splitter id="splitter">
	 *   <ons-splitter-content>
	 *     ...
	 *   </ons-splitter-content>
	 *
	 *   <ons-splitter-side side="left" width="80%" collapse swipeable>
	 *     ...
	 *   </ons-splitter-side>
	 * </ons-splitter>
	 *
	 * <script>
	 *   var splitter = document.getElementById('splitter');
	 *   splitter.left.open();
	 * </script>
	 */
	
	var SplitterElement = function (_BaseElement) {
	  inherits(SplitterElement, _BaseElement);
	  createClass(SplitterElement, [{
	    key: '_getSide',
	    value: function _getSide(side) {
	      var element = util.findChild(this, function (e) {
	        return util.match(e, 'ons-splitter-side') && e.getAttribute('side') === side;
	      });
	      return element;
	    }
	
	    /**
	     * @property left
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]Left `<ons-splitter-side>` element.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: '_onDeviceBackButton',
	    value: function _onDeviceBackButton(event) {
	      this._sides.some(function (s) {
	        return s.isOpen ? s.close() : false;
	      }) || event.callParentHandler();
	    }
	  }, {
	    key: '_onModeChange',
	    value: function _onModeChange(e) {
	      var _this2 = this;
	
	      if (e.target.parentNode) {
	        contentReady(this, function () {
	          _this2._layout();
	        });
	      }
	    }
	  }, {
	    key: '_layout',
	    value: function _layout() {
	      var _this3 = this;
	
	      this._sides.forEach(function (side) {
	        if (_this3.content) {
	          _this3.content.style[side.side] = side.mode === 'split' ? side.style.width : 0;
	        }
	      });
	    }
	  }, {
	    key: 'left',
	    get: function get$$1() {
	      return this._getSide('left');
	    }
	    /**
	     * @property right
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]Right `<ons-splitter-side>` element.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'right',
	    get: function get$$1() {
	      return this._getSide('right');
	    }
	
	    /**
	     * @property side
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]First `<ons-splitter-side>` element regardless the actual side.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'side',
	    get: function get$$1() {
	      return util.findChild(this, 'ons-splitter-side');
	    }
	  }, {
	    key: '_sides',
	    get: function get$$1() {
	      return [this.left, this.right].filter(function (e) {
	        return e;
	      });
	    }
	    /**
	     * @property content
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]The `<ons-splitter-content>` element.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'content',
	    get: function get$$1() {
	      return util.findChild(this, 'ons-splitter-content');
	    }
	  }, {
	    key: 'topPage',
	    get: function get$$1() {
	      return this.content._content;
	    }
	  }, {
	    key: 'mask',
	    get: function get$$1() {
	      return util.findChild(this, 'ons-splitter-mask');
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: 'onDeviceBackButton',
	    get: function get$$1() {
	      return this._backButtonHandler;
	    },
	    set: function set$$1(callback) {
	      if (this._backButtonHandler) {
	        this._backButtonHandler.destroy();
	      }
	
	      this._backButtonHandler = deviceBackButtonDispatcher.createHandler(this, callback);
	    }
	  }]);
	
	  function SplitterElement() {
	    classCallCheck(this, SplitterElement);
	
	    var _this = possibleConstructorReturn(this, (SplitterElement.__proto__ || Object.getPrototypeOf(SplitterElement)).call(this));
	
	    _this._onModeChange = _this._onModeChange.bind(_this);
	
	    contentReady(_this, function () {
	      !_this.mask && _this.appendChild(document.createElement('ons-splitter-mask'));
	      _this._layout();
	    });
	    return _this;
	  }
	
	  createClass(SplitterElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      this.onDeviceBackButton = this._onDeviceBackButton.bind(this);
	      this.addEventListener('modechange', this._onModeChange, false);
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._backButtonHandler.destroy();
	      this._backButtonHandler = null;
	      this.removeEventListener('modechange', this._onModeChange, false);
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {}
	  }, {
	    key: '_show',
	    value: function _show() {
	      util.propagateAction(this, '_show');
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      util.propagateAction(this, '_hide');
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      util.propagateAction(this, '_destroy');
	      this.remove();
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator instanceof SplitterAnimator)) {
	        throw new Error('Animator parameter must be an instance of SplitterAnimator.');
	      }
	      _animatorDict$6[name] = Animator;
	    }
	  }, {
	    key: 'SplitterAnimator',
	    get: function get$$1() {
	      return SplitterAnimator;
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$6;
	    }
	  }]);
	  return SplitterElement;
	}(BaseElement);
	
	onsElements.Splitter = SplitterElement;
	customElements.define('ons-splitter', SplitterElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var SPLIT_MODE = 'split';
	var COLLAPSE_MODE = 'collapse';
	var CLOSED_STATE = 'closed';
	var OPEN_STATE = 'open';
	var CHANGING_STATE = 'changing';
	
	var rewritables$2 = {
	  /**
	   * @param {Element} splitterSideElement
	   * @param {Function} callback
	   */
	  ready: function ready(splitterSideElement, callback) {
	    setImmediate(callback);
	  }
	};
	
	var CollapseDetection = function () {
	  function CollapseDetection(element, target) {
	    classCallCheck(this, CollapseDetection);
	
	    this._element = element;
	    this._onChange = this._onChange.bind(this);
	    target && this.changeTarget(target);
	  }
	
	  createClass(CollapseDetection, [{
	    key: 'changeTarget',
	    value: function changeTarget(target) {
	      this.disable();
	      this._target = target;
	      if (target) {
	        this._orientation = ['portrait', 'landscape'].indexOf(target) !== -1;
	        this.activate();
	      }
	    }
	  }, {
	    key: '_match',
	    value: function _match(value) {
	      if (this._orientation) {
	        return this._target === (value.isPortrait ? 'portrait' : 'landscape');
	      }
	      return value.matches;
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(value) {
	      this._element._updateMode(this._match(value) ? COLLAPSE_MODE : SPLIT_MODE);
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      if (this._orientation) {
	        orientation.on('change', this._onChange);
	        this._onChange({ isPortrait: orientation.isPortrait() });
	      } else {
	        this._queryResult = window.matchMedia(this._target);
	        this._queryResult.addListener(this._onChange);
	        this._onChange(this._queryResult);
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      if (this._orientation) {
	        orientation.off('change', this._onChange);
	      } else if (this._queryResult) {
	        this._queryResult.removeListener(this._onChange);
	        this._queryResult = null;
	      }
	    }
	  }]);
	  return CollapseDetection;
	}();
	
	/**
	 * @element ons-splitter-side
	 * @category menu
	 * @description
	 *  [en]
	 *    The `<ons-splitter-side>` element is used as a child element of `<ons-splitter>`.
	 *
	 *    It will be displayed on either the left or right side of the `<ons-splitter-content>` element.
	 *
	 *    It supports two modes: collapsed and split. When it's in collapsed mode it will be hidden from view and can be displayed when the user swipes the screen or taps a button. In split mode the element is always shown. It can be configured to automatically switch between the two modes depending on the screen size.
	 *  [/en]
	 *  [ja]ons-splitter-side要素は、ons-splitter要素の子要素として利用します。[/ja]
	 * @codepen rOQOML
	 * @tutorial vanilla/Reference/splitter
	 * @guide fundamentals.html#managing-pages
	 *  [en]Managing multiple pages.[/en]
	 *  [ja]複数のページを管理する[/ja]
	 * @seealso ons-splitter
	 *  [en]The `<ons-splitter>` is the parent component.[/en]
	 *  [ja]ons-splitterコンポーネント[/ja]
	 * @seealso ons-splitter-content
	 *  [en]The `<ons-splitter-content>` component contains the main content of the page.[/en]
	 *  [ja]ons-splitter-contentコンポーネント[/ja]
	 * @example
	 * <ons-splitter>
	 *   <ons-splitter-content>
	 *     ...
	 *   </ons-splitter-content>
	 *
	 *   <ons-splitter-side side="left" width="80%" collapse>
	 *     ...
	 *   </ons-splitter-side>
	 * </ons-splitter>
	 */
	
	var SplitterSideElement = function (_BaseElement) {
	  inherits(SplitterSideElement, _BaseElement);
	
	  /**
	   * @event modechange
	   * @description
	   *   [en]Fired just after the component's mode changes.[/en]
	   *   [ja]この要素のモードが変化した際に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.side
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {String} event.mode
	   *   [en]Returns the current mode. Can be either `"collapse"` or `"split"`.[/en]
	   *   [ja]現在のモードを返します。[/ja]
	   */
	
	  /**
	   * @event preopen
	   * @description
	   *   [en]Fired just before the sliding menu is opened.[/en]
	   *   [ja]スライディングメニューが開く前に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Call to cancel opening sliding menu.[/en]
	   *   [ja]スライディングメニューが開くのをキャンセルします。[/ja]
	   * @param {Object} event.side
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event postopen
	   * @description
	   *   [en]Fired just after the sliding menu is opened.[/en]
	   *   [ja]スライディングメニューが開いた後に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.side
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @event preclose
	   * @description
	   *   [en]Fired just before the sliding menu is closed.[/en]
	   *   [ja]スライディングメニューが閉じる前に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.side
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Call to cancel opening sliding-menu.[/en]
	   *   [ja]スライディングメニューが閉じるのをキャンセルします。[/ja]
	   */
	
	  /**
	   * @event postclose
	   * @description
	   *   [en]Fired just after the sliding menu is closed.[/en]
	   *   [ja]スライディングメニューが閉じた後に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクトです。[/ja]
	   * @param {Object} event.side
	   *   [en]Component object.[/en]
	   *   [ja]コンポーネントのオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default  default
	   * @description
	   *  [en]Specify the animation. Use one of `overlay`, `push`, `reveal` or  `default`.[/en]
	   *  [ja]アニメーションを指定します。"overlay", "push", "reveal", "default"のいずれかを指定できます。[/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. {duration: 0.2, delay: 1, timing: 'ease-in'}[/ja]
	   */
	
	  /**
	   * @attribute open-threshold
	   * @type {Number}
	   * @default  0.3
	   * @description
	   *  [en]Specify how much the menu needs to be swiped before opening. A value between `0` and `1`.[/en]
	   *  [ja]どのくらいスワイプすればスライディングメニューを開くかどうかの割合を指定します。0から1の間の数値を指定します。スワイプの距離がここで指定した数値掛けるこの要素の幅よりも大きければ、スワイプが終わった時にこの要素を開きます。デフォルトは0.3です。[/ja]
	   */
	
	  /**
	   * @attribute collapse
	   * @type {String}
	   * @description
	   *   [en]
	   *     Specify the collapse behavior. Valid values are `"portrait"`, `"landscape"` or a media query.
	   *     The strings `"portrait"` and `"landscape"` means the view will collapse when device is in landscape or portrait orientation.
	   *     If the value is a media query, the view will collapse when the media query resolves to `true`.
	   *     If the value is not defined, the view always be in `"collapse"` mode.
	   *   [/en]
	   *   [ja]
	   *     左側のページを非表示にする条件を指定します。portrait, landscape、width #pxもしくはメディアクエリの指定が可能です。
	   *     portraitもしくはlandscapeを指定すると、デバイスの画面が縦向きもしくは横向きになった時に適用されます。
	   *     メディアクエリを指定すると、指定したクエリに適合している場合に適用されます。
	   *     値に何も指定しない場合には、常にcollapseモードになります。
	   *   [/ja]
	   */
	
	  /**
	   * @attribute swipe-target-width
	   * @type {String}
	   * @description
	   *   [en]The width of swipeable area calculated from the edge (in pixels). Use this to enable swipe only when the finger touch on the screen edge.[/en]
	   *   [ja]スワイプの判定領域をピクセル単位で指定します。画面の端から指定した距離に達するとページが表示されます。[/ja]
	   */
	
	  /**
	   * @attribute width
	   * @type {String}
	   * @description
	   *   [en]Can be specified in either pixels or as a percentage, e.g. `90%` or `200px`.[/en]
	   *   [ja]この要素の横幅を指定します。pxと%での指定が可能です。eg. 90%, 200px[/ja]
	   */
	
	  /**
	   * @attribute side
	   * @type {String}
	   * @default left
	   * @description
	   *   [en]Specify which side of the screen the `<ons-splitter-side>` element is located. Possible values are `"left"` and `"right"`.[/en]
	   *   [ja]この要素が左か右かを指定します。指定できる値は"left"か"right"のみです。[/ja]
	   */
	
	  /**
	   * @attribute mode
	   * @type {String}
	   * @description
	   *   [en]Current mode. Possible values are `"collapse"` or `"split"`. This attribute is read only.[/en]
	   *   [ja]現在のモードが設定されます。"collapse"もしくは"split"が指定されます。この属性は読み込み専用です。[/ja]
	   */
	
	  /**
	   * @attribute page
	   * @initonly
	   * @type {String}
	   * @description
	   *   [en]The URL of the menu page.[/en]
	   *   [ja]ons-splitter-side要素に表示するページのURLを指定します。[/ja]
	   */
	
	  /**
	   * @attribute swipeable
	   * @type {Boolean}
	   * @description
	   *   [en]Whether to enable swipe interaction on collapse mode.[/en]
	   *   [ja]collapseモード時にスワイプ操作を有効にする場合に指定します。[/ja]
	   */
	
	  function SplitterSideElement() {
	    classCallCheck(this, SplitterSideElement);
	
	    var _this = possibleConstructorReturn(this, (SplitterSideElement.__proto__ || Object.getPrototypeOf(SplitterSideElement)).call(this));
	
	    _this._page = null;
	    _this._state = CLOSED_STATE;
	    _this._lock = new DoorLock();
	    _this._pageLoader = defaultPageLoader;
	    _this._collapseDetection = new CollapseDetection(_this);
	
	    _this._animatorFactory = new AnimatorFactory({
	      animators: SplitterElement.animators,
	      baseClass: SplitterAnimator$1,
	      baseClassName: 'SplitterAnimator',
	      defaultAnimation: _this.getAttribute('animation')
	    });
	
	    contentReady(_this, function () {
	      // These attributes are used early by the parent element
	      _this.attributeChangedCallback('width');
	      if (!_this.hasAttribute('side')) {
	        _this.setAttribute('side', 'left');
	      }
	
	      rewritables$2.ready(_this, function () {
	        var page = _this._page || _this.getAttribute('page');
	        page && _this.load(page);
	      });
	    });
	    return _this;
	  }
	
	  createClass(SplitterSideElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      if (!util.match(this.parentNode, 'ons-splitter')) {
	        throw new Error('Parent must be an ons-splitter element.');
	      }
	
	      this._swipe = new SwipeReveal({
	        element: this,
	        elementHandler: this.parentElement,
	        swipeMax: function swipeMax() {
	          _this2._onSwipe && _this2._onSwipe(1, _this2._animationOpt);
	          _this2.open();
	        },
	        swipeMid: function swipeMid(distance, width) {
	          _this2._onSwipe && _this2._onSwipe(distance / width);
	          _this2._animator.translate(distance);
	        },
	        swipeMin: function swipeMin() {
	          _this2._onSwipe && _this2._onSwipe(0, _this2._animationOpt);
	          _this2.close();
	        },
	        getThreshold: function getThreshold() {
	          return Math.max(0, Math.min(1, parseFloat(_this2.getAttribute('open-threshold')) || 0.3));
	        },
	        getSide: function getSide() {
	          return _this2.side;
	        },
	        isInitialState: function isInitialState() {
	          var closed = _this2._state === CLOSED_STATE;
	          _this2._state = CHANGING_STATE;
	          return closed;
	        },
	        ignoreSwipe: function ignoreSwipe(event, distance) {
	          var isOpen = _this2.isOpen;
	          var validDrag = function validDrag(d) {
	            return _this2.side === 'left' ? d === 'left' && isOpen || d === 'right' && !isOpen : d === 'left' && !isOpen || d === 'right' && isOpen;
	          };
	
	          var area = Math.max(0, parseInt(_this2.getAttribute('swipe-target-width'), 10) || 0);
	
	          return _this2._mode === SPLIT_MODE || _this2._lock.isLocked() || _this2._isOtherSideOpen() || !validDrag(event.gesture.direction) || !isOpen && area !== 0 && distance > area;
	        }
	      });
	
	      this.attributeChangedCallback('swipeable');
	
	      contentReady(this, function () {
	        _this2.constructor.observedAttributes.forEach(function (attr) {
	          return _this2.attributeChangedCallback(attr, null, _this2.getAttribute(attr));
	        });
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this._swipe && this._swipe.dispose();
	      this._animator = this._animationOpt = this._swipe = null;
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      switch (name) {
	        case 'swipeable':
	          this._swipe && this._swipe.update();
	          break;
	        case 'width':
	          this.style.width = /^\d+(px|%)$/.test(current) ? current : '80%';
	          break;
	        default:
	          this[util.camelize('_update-' + name)](current);
	      }
	    }
	  }, {
	    key: '_emitEvent',
	    value: function _emitEvent(name) {
	      if (name.slice(0, 3) !== 'pre') {
	        return util.triggerElementEvent(this, name, { side: this });
	      }
	      var isCanceled = false;
	
	      util.triggerElementEvent(this, name, {
	        side: this,
	        cancel: function cancel() {
	          return isCanceled = true;
	        }
	      });
	
	      return isCanceled;
	    }
	  }, {
	    key: '_isOtherSideOpen',
	    value: function _isOtherSideOpen() {
	      var _this3 = this;
	
	      return !!util.findChild(this.parentElement, function (el) {
	        return el instanceof _this3.constructor && el !== _this3 && el._mode === COLLAPSE_MODE && el.isOpen;
	      });
	    }
	  }, {
	    key: '_updateCollapse',
	    value: function _updateCollapse() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAttribute('collapse');
	
	      if (value === null || value === 'split') {
	        this._collapseDetection.disable();
	        return this._updateMode(SPLIT_MODE);
	      }
	      if (value === '' || value === 'collapse') {
	        this._collapseDetection.disable();
	        return this._updateMode(COLLAPSE_MODE);
	      }
	
	      this._collapseDetection.changeTarget(value);
	    }
	  }, {
	    key: '_updateMode',
	    value: function _updateMode(mode) {
	      if (mode !== this._mode) {
	        this._mode = mode;
	        this.setAttribute('mode', mode); // readonly attribute for the users
	
	        if (mode === SPLIT_MODE) {
	          this._animator && this._animator.deactivate();
	          this._state = CLOSED_STATE;
	        } else {
	          this._animator && this._animator.activate(this);
	          this._state === OPEN_STATE && this._animator.open();
	        }
	
	        util.triggerElementEvent(this, 'modechange', { side: this, mode: mode });
	      }
	    }
	  }, {
	    key: '_updateAnimation',
	    value: function _updateAnimation() {
	      var animation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAttribute('animation');
	
	      this._animator && this._animator.deactivate();
	      this._animator = this._animatorFactory.newAnimator({ animation: animation });
	      this._animator.activate(this);
	      this._animationOpt = {
	        timing: this._animator.duration,
	        duration: this._animator.duration
	      };
	    }
	  }, {
	    key: '_updateAnimationOptions',
	    value: function _updateAnimationOptions() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAttribute('animation-options');
	
	      this._animator.updateOptions(AnimatorFactory.parseAnimationOptionsString(value));
	    }
	
	    /**
	     * @property page
	     * @type {*}
	     * @description
	     *   [en]Page location to load in the splitter side.[/en]
	     *   [ja]この要素内に表示するページを指定します。[/ja]
	     */
	
	  }, {
	    key: 'open',
	
	
	    /**
	     * @method open
	     * @signature open([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function will be called after the menu has been opened.[/en]
	     *   [ja]メニューが開いた後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Open menu in collapse mode.[/en]
	     *   [ja]collapseモードになっているons-splitter-side要素を開きます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the splitter side element or false if not in collapse mode[/en]
	     *   [ja][/ja]
	     */
	    value: function open(options) {
	      return this.toggle(options, true);
	    }
	
	    /**
	     * @method close
	     * @signature close([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {Function} [options.callback]
	     *   [en]This function will be called after the menu has been closed.[/en]
	     *   [ja]メニューが閉じた後に呼び出される関数オブジェクトを指定します。[/ja]
	     * @description
	     *   [en]Close menu in collapse mode.[/en]
	     *   [ja]collapseモードになっているons-splitter-side要素を閉じます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the splitter side element or false if not in collapse mode[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'close',
	    value: function close(options) {
	      return this.toggle(options, false);
	    }
	
	    /**
	     * @method toggle
	     * @signature toggle([options])
	     * @param {Object} [options]
	     * @description
	     *   [en]Opens if it's closed. Closes if it's open.[/en]
	     *   [ja]開けている場合は要素を閉じますそして開けている場合は要素を開きます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the splitter side element or false if not in collapse mode[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      var _this4 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var force = arguments[1];
	
	      var shouldOpen = typeof force === 'boolean' ? force : !this.isOpen;
	      var action = shouldOpen ? 'open' : 'close',
	          FINAL_STATE = shouldOpen ? OPEN_STATE : CLOSED_STATE;
	
	      if (this._mode === SPLIT_MODE) {
	        return Promise.resolve(false);
	      }
	      if (this._state === FINAL_STATE) {
	        return Promise.resolve(this);
	      }
	      if (this._lock.isLocked()) {
	        return Promise.reject('Another splitter-side action is already running.');
	      }
	      if (shouldOpen && this._isOtherSideOpen()) {
	        return Promise.reject('Another menu is already open.');
	      }
	      if (this._emitEvent('pre' + action)) {
	        return Promise.reject('Canceled in pre' + action + ' event.');
	      }
	
	      var unlock = this._lock.lock();
	      this._state = CHANGING_STATE;
	
	      return new Promise(function (resolve) {
	        _this4._animator[action](function () {
	          util.iosPageScrollFix(shouldOpen);
	          _this4._state = FINAL_STATE;
	          unlock();
	          _this4._emitEvent('post' + action);
	          options.callback instanceof Function && options.callback(_this4);
	          resolve(_this4);
	        });
	      });
	    }
	
	    /**
	     * @method load
	     * @signature load(page, [options])
	     * @param {String} page
	     *   [en]Page URL. Can be either an HTML document or a `<template>`.[/en]
	     *   [ja]pageのURLか、`<template>`で宣言したテンプレートのid属性の値を指定します。[/ja]
	     * @param {Object} [options]
	     * @param {Function} [options.callback]
	     * @description
	     *   [en]Show the page specified in pageUrl in the right section[/en]
	     *   [ja]指定したURLをメインページを読み込みます。[/ja]
	     * @return {Promise}
	     *   [en]Resolves to the new page element[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'load',
	    value: function load(page) {
	      var _this5 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._page = page;
	      var callback = options.callback || function () {};
	
	      return new Promise(function (resolve) {
	        var oldContent = _this5._content || null;
	
	        _this5._pageLoader.load({ page: page, parent: _this5 }, function (pageElement) {
	          if (oldContent) {
	            _this5._pageLoader.unload(oldContent);
	            oldContent = null;
	          }
	
	          setImmediate(function () {
	            return _this5._show();
	          });
	
	          callback(pageElement);
	          resolve(pageElement);
	        });
	      });
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      if (this._content) {
	        this._content._show();
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      if (this._content) {
	        this._content._hide();
	      }
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      if (this._content) {
	        this._pageLoader.unload(this._content);
	      }
	      this.remove();
	    }
	  }, {
	    key: 'side',
	    get: function get$$1() {
	      return this.getAttribute('side') === 'right' ? 'right' : 'left';
	    }
	  }, {
	    key: 'page',
	    get: function get$$1() {
	      return this._page;
	    }
	
	    /**
	     * @param {*} page
	     */
	    ,
	    set: function set$$1(page) {
	      this._page = page;
	    }
	  }, {
	    key: '_content',
	    get: function get$$1() {
	      return this.children[0];
	    }
	
	    /**
	     * @property pageLoader
	     * @description
	     *   [en][/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'pageLoader',
	    get: function get$$1() {
	      return this._pageLoader;
	    },
	    set: function set$$1(loader) {
	      if (!(loader instanceof PageLoader)) {
	        throw Error('First parameter must be an instance of PageLoader.');
	      }
	      this._pageLoader = loader;
	    }
	
	    /**
	     * @property mode
	     * @readonly
	     * @type {String}
	     * @description
	     *   [en]Current mode. Possible values are "split", "collapse", "closed", "open" or "changing".[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'mode',
	    get: function get$$1() {
	      return this._mode;
	    }
	
	    /**
	     * @property onSwipe
	     * @type {Function}
	     * @description
	     *   [en]Hook called whenever the user slides the splitter. It gets a decimal ratio (0-1) and an animationOptions object as arguments.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'onSwipe',
	    get: function get$$1() {
	      return this._onSwipe;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onSwipe\' must be a function.');
	      }
	      this._onSwipe = value;
	    }
	
	    /**
	     * @property isOpen
	     * @type {Boolean}
	     * @readonly
	     * @description
	     *   [en]This value is `true` when the menu is open.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'isOpen',
	    get: function get$$1() {
	      return this._mode === COLLAPSE_MODE && this._state !== CLOSED_STATE;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['animation', 'width', 'collapse', 'swipeable', 'animation-options'];
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['preopen', 'postopen', 'preclose', 'postclose', 'modechange'];
	    }
	  }, {
	    key: 'rewritables',
	    get: function get$$1() {
	      return rewritables$2;
	    }
	  }]);
	  return SplitterSideElement;
	}(BaseElement);
	
	onsElements.SplitterSide = SplitterSideElement;
	customElements.define('ons-splitter-side', SplitterSideElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$28 = {
	  '': 'switch--*',
	  '.switch__input': 'switch--*__input',
	  '.switch__handle': 'switch--*__handle',
	  '.switch__toggle': 'switch--*__toggle'
	};
	
	var locations = {
	  ios: [1, 21],
	  material: [0, 16]
	};
	
	/**
	 * @element ons-switch
	 * @category form
	 * @description
	 *   [en]
	 *     Switch component. The switch can be toggled both by dragging and tapping.
	 *
	 *     Will automatically displays a Material Design switch on Android devices.
	 *   [/en]
	 *   [ja]スイッチを表示するコンポーネントです。[/ja]
	 * @modifier material
	 *   [en]Material Design switch[/en]
	 *   [ja][/ja]
	 * @codepen LpXZQQ
	 * @tutorial vanilla/Reference/switch
	 * @guide theming.html#modifiers [en]More details about the `modifier` attribute[/en][ja]modifier属性の使い方[/ja]
	 * @example
	 * <ons-switch checked></ons-switch>
	 * <ons-switch disabled></ons-switch>
	 * <ons-switch modifier="material"></ons-switch>
	 */
	
	var SwitchElement = function (_BaseCheckboxElement) {
	  inherits(SwitchElement, _BaseCheckboxElement);
	
	  function SwitchElement() {
	    classCallCheck(this, SwitchElement);
	
	    var _this = possibleConstructorReturn(this, (SwitchElement.__proto__ || Object.getPrototypeOf(SwitchElement)).call(this));
	
	    contentReady(_this, function () {
	      _this.attributeChangedCallback('modifier', null, _this.getAttribute('modifier'));
	    });
	
	    _this._onChange = _this._onChange.bind(_this);
	    _this._onRelease = _this._onRelease.bind(_this);
	    return _this;
	  }
	
	  createClass(SwitchElement, [{
	    key: '_getPosition',
	
	
	    /* Own props */
	
	    value: function _getPosition(e) {
	      var l = this._locations;
	      return Math.min(l[1], Math.max(l[0], this._startX + e.gesture.deltaX));
	    }
	  }, {
	    key: '_emitChangeEvent',
	    value: function _emitChangeEvent() {
	      util.triggerElementEvent(this, 'change', {
	        value: this.checked,
	        switch: this,
	        isInteractive: true
	      });
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(event) {
	      if (event && event.stopPropagation) {
	        event.stopPropagation();
	      }
	
	      this._emitChangeEvent();
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(ev) {
	      if (ev.target.classList.contains(this.defaultElementClass + '__touch') || ev.timeStamp === this._lastTimeStamp // Prevent second click triggered by <label>
	      ) {
	          ev.preventDefault();
	        }
	      this._lastTimeStamp = ev.timeStamp;
	    }
	  }, {
	    key: '_onHold',
	    value: function _onHold(e) {
	      if (!this.disabled) {
	        ModifierUtil.addModifier(this, 'active');
	        document.addEventListener('release', this._onRelease);
	      }
	    }
	  }, {
	    key: '_onDragStart',
	    value: function _onDragStart(e) {
	      if (this.disabled || ['left', 'right'].indexOf(e.gesture.direction) === -1) {
	        ModifierUtil.removeModifier(this, 'active');
	        return;
	      }
	
	      e.consumed = true;
	
	      ModifierUtil.addModifier(this, 'active');
	      this._startX = this._locations[this.checked ? 1 : 0]; // - e.gesture.deltaX;
	
	      this.addEventListener('drag', this._onDrag);
	      document.addEventListener('release', this._onRelease);
	    }
	  }, {
	    key: '_onDrag',
	    value: function _onDrag(e) {
	      e.stopPropagation();
	      this._handle.style.left = this._getPosition(e) + 'px';
	    }
	  }, {
	    key: '_onRelease',
	    value: function _onRelease(e) {
	      var l = this._locations;
	      var position = this._getPosition(e);
	      var previousValue = this.checked;
	
	      this.checked = position >= (l[0] + l[1]) / 2;
	
	      if (this.checked !== previousValue) {
	        this._emitChangeEvent();
	      }
	
	      this.removeEventListener('drag', this._onDrag);
	      document.removeEventListener('release', this._onRelease);
	
	      this._handle.style.left = '';
	      ModifierUtil.removeModifier(this, 'active');
	    }
	  }, {
	    key: 'click',
	    value: function click() {
	      if (!this.disabled) {
	        this.checked = !this.checked;
	        this._emitChangeEvent();
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      contentReady(this, function () {
	        _this2._input.addEventListener('change', _this2._onChange);
	      });
	
	      this.addEventListener('dragstart', this._onDragStart);
	      this.addEventListener('hold', this._onHold);
	      this.addEventListener('tap', this.click);
	      this.addEventListener('click', this._onClick);
	      this._gestureDetector = new GestureDetector(this, { dragMinDistance: 1, holdTimeout: 251, passive: true });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      var _this3 = this;
	
	      contentReady(this, function () {
	        _this3._input.removeEventListener('change', _this3._onChange);
	      });
	
	      this.removeEventListener('dragstart', this._onDragStart);
	      this.removeEventListener('hold', this._onHold);
	      this.removeEventListener('tap', this.click);
	      this.removeEventListener('click', this._onClick);
	      if (this._gestureDetector) {
	        this._gestureDetector.dispose();
	      }
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'modifier') {
	        var md = (current || '').indexOf('material') !== -1;
	        this._locations = locations[md ? 'material' : 'ios'];
	      }
	
	      get(SwitchElement.prototype.__proto__ || Object.getPrototypeOf(SwitchElement.prototype), 'attributeChangedCallback', this).call(this, name, last, current);
	    }
	
	    /**
	     * @event change
	     * @description
	     *   [en]Fired when the switch is toggled.[/en]
	     *   [ja]ON/OFFが変わった時に発火します。[/ja]
	     * @param {Object} event
	     *   [en]Event object.[/en]
	     *   [ja]イベントオブジェクト。[/ja]
	     * @param {Object} event.switch
	     *   [en]Switch object.[/en]
	     *   [ja]イベントが発火したSwitchオブジェクトを返します。[/ja]
	     * @param {Boolean} event.value
	     *   [en]Current value.[/en]
	     *   [ja]現在の値を返します。[/ja]
	     * @param {Boolean} event.isInteractive
	     *   [en]True if the change was triggered by the user clicking on the switch.[/en]
	     *   [ja]タップやクリックなどのユーザの操作によって変わった場合にはtrueを返します。[/ja]
	     */
	
	    /**
	     * @attribute modifier
	     * @type {String}
	     * @description
	     *  [en]The appearance of the switch.[/en]
	     *  [ja]スイッチの表現を指定します。[/ja]
	     */
	
	    /**
	     * @attribute disabled
	     * @description
	     *   [en]Whether the switch is be disabled.[/en]
	     *   [ja]スイッチを無効の状態にする場合に指定します。[/ja]
	     */
	
	    /**
	     * @attribute checked
	     * @description
	     *   [en]Whether the switch is checked.[/en]
	     *   [ja]スイッチがONの状態にするときに指定します。[/ja]
	     */
	
	    /**
	     * @attribute input-id
	     * @type {String}
	     * @description
	     *   [en]Specify the `id` attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property checked
	     * @type {Boolean}
	     * @description
	     *   [en]This value is `true` if the switch is checked.[/en]
	     *   [ja]スイッチがONの場合に`true`。[/ja]
	     */
	
	    /**
	     * @property value
	     * @type {String}
	     * @description
	     *   [en]The current value of the input.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    /**
	     * @property checkbox
	     * @readonly
	     * @type {HTMLElement}
	     * @description
	     *   [en]The underlying checkbox element.[/en]
	     *   [ja]コンポーネント内部のcheckbox要素になります。[/ja]
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$28;
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'switch';
	    }
	  }, {
	    key: '_template',
	    get: function get$$1() {
	      return '\n      <input type="' + this.type + '" class="' + this._defaultClassName + '__input">\n      <div class="' + this._defaultClassName + '__toggle">\n        <div class="' + this._defaultClassName + '__handle">\n          <div class="' + this._defaultClassName + '__touch"></div>\n        </div>\n      </div>\n    ';
	    }
	  }, {
	    key: 'type',
	    get: function get$$1() {
	      return 'checkbox';
	    }
	  }, {
	    key: '_handle',
	    get: function get$$1() {
	      return this.querySelector('.' + this._defaultClassName + '__handle');
	    }
	  }, {
	    key: 'checkbox',
	    get: function get$$1() {
	      return this._input;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return [].concat(toConsumableArray(get(SwitchElement.__proto__ || Object.getPrototypeOf(SwitchElement), 'observedAttributes', this)), ['modifier']);
	    }
	  }]);
	  return SwitchElement;
	}(BaseCheckboxElement);
	
	onsElements.Switch = SwitchElement;
	customElements.define('ons-switch', SwitchElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$30 = {
	  '.tabbar__content': 'tabbar--*__content',
	  '.tabbar__border': 'tabbar--*__border',
	  '.tabbar': 'tabbar--*'
	};
	
	var rewritables$3 = {
	  /**
	   * @param {Element} tabbarElement
	   * @param {Function} callback
	   */
	  ready: function ready(tabbarElement, callback) {
	    callback();
	  }
	};
	
	var lerp = function lerp(x0, x1, t) {
	  return (1 - t) * x0 + t * x1;
	};
	
	/**
	 * @element ons-tabbar
	 * @category tabbar
	 * @description
	 *   [en]A component to display a tab bar on the bottom of a page. Used with `<ons-tab>` to manage pages using tabs.[/en]
	 *   [ja]タブバーをページ下部に表示するためのコンポーネントです。ons-tabと組み合わせて使うことで、ページを管理できます。[/ja]
	 * @codepen pGuDL
	 * @tutorial vanilla/Reference/tabbar
	 * @modifier material
	 *   [en]A tabbar in Material Design.[/en]
	 *   [ja][/ja]
	 * @modifier autogrow
	 *   [en]Tabs automatically grow depending on their content instead of having a fixed width.[/en]
	 *   [ja][/ja]
	 * @modifier top-border
	 *   [en]Shows a static border-bottom in tabs for iOS top tabbars.[/en]
	 *   [ja][/ja]
	 * @guide fundamentals.html#managing-pages
	 *  [en]Managing multiple pages.[/en]
	 *  [ja]複数のページを管理する[/ja]
	 * @seealso ons-tab
	 *   [en]The `<ons-tab>` component.[/en]
	 *   [ja]ons-tabコンポーネント[/ja]
	 * @seealso ons-page
	 *   [en]The `<ons-page>` component.[/en]
	 *   [ja]ons-pageコンポーネント[/ja]
	 * @example
	 * <ons-tabbar>
	 *   <ons-tab
	 *     page="home.html"
	 *     label="Home"
	 *     active>
	 *   </ons-tab>
	 *   <ons-tab
	 *     page="settings.html"
	 *     label="Settings"
	 *     active>
	 *   </ons-tab>
	 * </ons-tabbar>
	 *
	 * <template id="home.html">
	 *   ...
	 * </template>
	 *
	 * <template id="settings.html">
	 *   ...
	 * </template>
	 */
	
	var TabbarElement = function (_BaseElement) {
	  inherits(TabbarElement, _BaseElement);
	
	  /**
	   * @event prechange
	   * @description
	   *   [en]Fires just before the tab is changed.[/en]
	   *   [ja]アクティブなタブが変わる前に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクト。[/ja]
	   * @param {Number} event.index
	   *   [en]Current index.[/en]
	   *   [ja]現在アクティブになっているons-tabのインデックスを返します。[/ja]
	   * @param {Object} event.tabItem
	   *   [en]Tab item object.[/en]
	   *   [ja]tabItemオブジェクト。[/ja]
	   * @param {Function} event.cancel
	   *   [en]Call this function to cancel the change event.[/en]
	   *   [ja]この関数を呼び出すと、アクティブなタブの変更がキャンセルされます。[/ja]
	   */
	
	  /**
	   * @event postchange
	   * @description
	   *   [en]Fires just after the tab is changed.[/en]
	   *   [ja]アクティブなタブが変わった後に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクト。[/ja]
	   * @param {Number} event.index
	   *   [en]Current index.[/en]
	   *   [ja]現在アクティブになっているons-tabのインデックスを返します。[/ja]
	   * @param {Object} event.tabItem
	   *   [en]Tab item object.[/en]
	   *   [ja]tabItemオブジェクト。[/ja]
	   */
	
	  /**
	   * @event reactive
	   * @description
	   *   [en]Fires if the already open tab is tapped again.[/en]
	   *   [ja]すでにアクティブになっているタブがもう一度タップやクリックされた場合に発火します。[/ja]
	   * @param {Object} event
	   *   [en]Event object.[/en]
	   *   [ja]イベントオブジェクト。[/ja]
	   * @param {Number} event.index
	   *   [en]Current index.[/en]
	   *   [ja]現在アクティブになっているons-tabのインデックスを返します。[/ja]
	   * @param {Object} event.tabItem
	   *   [en]Tab item object.[/en]
	   *   [ja]tabItemオブジェクト。[/ja]
	   */
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default none
	   * @description
	   *   [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. {duration: 0.2, delay: 1, timing: 'ease-in'}[/ja]
	   */
	
	  /**
	   * @attribute position
	   * @initonly
	   * @type {String}
	   * @default bottom
	   * @description
	   *   [en]Tabbar's position. Available values are `"bottom"` and `"top"`. Use `"auto"` to choose position depending on platform (bottom for iOS flat design, top for Material Design).[/en]
	   *   [ja]タブバーの位置を指定します。"bottom"もしくは"top"を選択できます。デフォルトは"bottom"です。[/ja]
	   */
	
	  /**
	   * @attribute swipeable
	   * @description
	   *   [en]If this attribute is set the tab bar can be scrolled by drag or swipe.[/en]
	   *   [ja]この属性がある時、タブバーをスワイプやドラッグで移動できるようになります。[/ja]
	   */
	
	  /**
	   * @attribute ignore-edge-width
	   * @type {Number}
	   * @default 20
	   * @description
	   *   [en]Distance in pixels from both edges. Swiping on these areas will prioritize parent components such as `ons-splitter` or `ons-navigator`.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute hide-tabs
	   * @description
	   *   [en]Whether to hide the tabs.[/en]
	   *   [ja]タブを非表示にする場合に指定します。[/ja]
	   */
	
	  /**
	   * @attribute tab-border
	   * @description
	   *   [en]If this attribute is set the tabs show a dynamic bottom border. Only works for iOS flat design since the border is always visible in Material Design.[/en]
	   *   [ja][/ja]
	   */
	
	  /**
	   * @attribute modifier
	   * @type {String}
	   * @description
	   *   [en]The appearance of the tabbar.[/en]
	   *   [ja]タブバーの表現を指定します。[/ja]
	   */
	
	  function TabbarElement() {
	    classCallCheck(this, TabbarElement);
	
	    var _this = possibleConstructorReturn(this, (TabbarElement.__proto__ || Object.getPrototypeOf(TabbarElement)).call(this));
	
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    _this._loadInactive = util.defer(); // Improves #2324
	    return _this;
	  }
	
	  createClass(TabbarElement, [{
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this2 = this;
	
	      if (!this._swiper) {
	        this._swiper = new Swiper({
	          getElement: function getElement() {
	            return _this2._contentElement;
	          },
	          getInitialIndex: function getInitialIndex() {
	            return _this2.getAttribute('activeIndex') || _this2.getAttribute('active-index');
	          },
	          getAutoScrollRatio: this._getAutoScrollRatio.bind(this),
	          getBubbleWidth: function getBubbleWidth() {
	            return parseInt(_this2.getAttribute('ignore-edge-width') || 25, 10);
	          },
	          isAutoScrollable: function isAutoScrollable() {
	            return true;
	          },
	          preChangeHook: this._onPreChange.bind(this),
	          postChangeHook: this._onPostChange.bind(this),
	          refreshHook: this._onRefresh.bind(this),
	          scrollHook: this._onScroll.bind(this)
	        });
	
	        contentReady(this, function () {
	          _this2._tabbarBorder = util.findChild(_this2._tabbarElement, '.tabbar__border');
	          _this2._swiper.init({ swipeable: _this2.hasAttribute('swipeable') });
	          setTimeout(function () {
	            return _this2._onRefresh();
	          }, 1000 / 60); // Fix tabbar border in some iframes
	        });
	      }
	
	      contentReady(this, function () {
	        _this2._updatePosition();
	
	        if (!util.findParent(_this2, 'ons-page', function (p) {
	          return p === document.body;
	        })) {
	          _this2._show(); // This tabbar is the top component
	        }
	      });
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      if (this._swiper && this._swiper.initialized) {
	        this._swiper.dispose();
	        this._swiper = null;
	        this._tabbarBorder = null;
	        this._tabsRect = null;
	      }
	    }
	  }, {
	    key: '_normalizeEvent',
	    value: function _normalizeEvent(event) {
	      return _extends({}, event, { index: event.activeIndex, tabItem: this.tabs[event.activeIndex] });
	    }
	  }, {
	    key: '_onPostChange',
	    value: function _onPostChange(event) {
	      event = this._normalizeEvent(event);
	      util.triggerElementEvent(this, 'postchange', event);
	      var page = event.tabItem.pageElement;
	      page && page._show();
	    }
	  }, {
	    key: '_onPreChange',
	    value: function _onPreChange(event) {
	      event = this._normalizeEvent(event);
	      event.cancel = function () {
	        return event.canceled = true;
	      };
	
	      util.triggerElementEvent(this, 'prechange', event);
	
	      if (!event.canceled) {
	        var _event = event,
	            activeIndex = _event.activeIndex,
	            lastActiveIndex = _event.lastActiveIndex;
	
	        var tabs = this.tabs;
	
	        tabs[activeIndex].setActive(true);
	        if (lastActiveIndex >= 0) {
	          var prevTab = tabs[lastActiveIndex];
	          prevTab.setActive(false);
	          prevTab.pageElement && prevTab.pageElement._hide();
	        }
	      }
	
	      return event.canceled;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(index) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this._tabbarBorder) {
	        this._tabbarBorder.style.transition = 'all ' + (options.duration || 0) + 's ' + (options.timing || '');
	
	        if (this._autogrow && this._tabsRect.length > 0) {
	          var a = Math.floor(index),
	              b = Math.ceil(index),
	              r = index % 1;
	          this._tabbarBorder.style.width = lerp(this._tabsRect[a].width, this._tabsRect[b].width, r) + 'px';
	          this._tabbarBorder.style.transform = 'translate3d(' + lerp(this._tabsRect[a].left, this._tabsRect[b].left, r) + 'px, 0, 0)';
	        } else {
	          this._tabbarBorder.style.transform = 'translate3d(' + index * 100 + '%, 0, 0)';
	        }
	      }
	
	      this._onSwipe && this._onSwipe(index, options);
	    }
	  }, {
	    key: '_onRefresh',
	    value: function _onRefresh() {
	      this._autogrow = util.hasModifier(this, 'autogrow');
	      this._tabsRect = this.tabs.map(function (tab) {
	        return tab.getBoundingClientRect();
	      });
	      if (this._tabbarBorder) {
	        this._tabbarBorder.style.display = this.hasAttribute('tab-border') || util.hasModifier(this, 'material') ? 'block' : 'none';
	        var index = this.getActiveTabIndex();
	        if (this._tabsRect.length > 0 && index >= 0) {
	          this._tabbarBorder.style.width = this._tabsRect[index].width + 'px';
	        }
	      }
	    }
	  }, {
	    key: '_getAutoScrollRatio',
	    value: function _getAutoScrollRatio(matches, velocity, size) {
	      var ratio = .6; // Base ratio
	      var modifier = size / 300 * (matches ? -1 : 1); // Based on screen size
	      return Math.min(1, Math.max(0, ratio + velocity * modifier));
	    }
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      var content = this._contentElement || util.create('.tabbar__content');
	      content.classList.add('ons-tabbar__content');
	      var tabbar = this._tabbarElement || util.create('.tabbar');
	      tabbar.classList.add('ons-tabbar__footer');
	
	      if (!tabbar.parentNode) {
	        while (this.firstChild) {
	          tabbar.appendChild(this.firstChild);
	        }
	      }
	
	      var activeIndex = Number(this.getAttribute('activeIndex')); // 0 by default
	      if (tabbar.children.length > activeIndex && !util.findChild(tabbar, '[active]')) {
	        tabbar.children[activeIndex].setAttribute('active', '');
	      }
	
	      this._tabbarBorder = util.findChild(tabbar, '.tabbar__border') || util.create('.tabbar__border');
	      tabbar.appendChild(this._tabbarBorder);
	      tabbar.classList.add('ons-swiper-tabbar'); // Hides material border
	
	      !content.children[0] && content.appendChild(document.createElement('div'));
	      !content.children[1] && content.appendChild(document.createElement('div'));
	      content.appendChild = content.appendChild.bind(content.children[0]);
	      content.insertBefore = content.insertBefore.bind(content.children[0]);
	
	      this.appendChild(content);
	      this.appendChild(tabbar); // Triggers ons-tab connectedCallback
	
	      ModifierUtil.initModifier(this, scheme$30);
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition() {
	      var _this3 = this;
	
	      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAttribute('position');
	
	      var top = this._top = position === 'top' || position === 'auto' && util.hasModifier(this, 'material');
	      var action = top ? util.addModifier : util.removeModifier;
	
	      action(this, 'top');
	
	      var page = util.findParent(this, 'ons-page');
	      if (page) {
	        contentReady(page, function () {
	          var p = 0;
	          if (page.children[0] && util.match(page.children[0], 'ons-toolbar')) {
	            action(page.children[0], 'noshadow');
	            p = 1; // Visual fix for some devices
	          }
	
	          var content = page._getContentElement();
	          var cs = window.getComputedStyle(page._getContentElement(), null);
	
	          _this3.style.top = top ? parseInt(cs.getPropertyValue('padding-top'), 10) - p + 'px' : '';
	
	          // Refresh content top - Fix for iOS 8
	          content.style.top = cs.top;
	          content.style.top = '';
	        });
	      }
	
	      internal$1.autoStatusBarFill(function () {
	        var filled = util.findParent(_this3, function (e) {
	          return e.hasAttribute('status-bar-fill');
	        });
	        util.toggleAttribute(_this3, 'status-bar-fill', top && !filled);
	      });
	    }
	  }, {
	    key: 'setActiveTab',
	
	
	    /**
	     * @method setActiveTab
	     * @signature setActiveTab(index, [options])
	     * @param {Number} index
	     *   [en]Tab index.[/en]
	     *   [ja]タブのインデックスを指定します。[/ja]
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {Function} [options.callback]
	     *   [en]Function that runs when the new page has loaded.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animation]
	     *   [en]If this option is "none", the transition won't slide.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @description
	     *   [en]Show specified tab page. Animations and their options can be specified by the second parameter.[/en]
	     *   [ja]指定したインデックスのタブを表示します。アニメーションなどのオプションを指定できます。[/ja]
	     * @return {Promise}
	     *   [en]A promise that resolves to the new page element.[/en]
	     *   [ja][/ja]
	     */
	    value: function setActiveTab(nextIndex) {
	      var _this4 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var prevIndex = this.getActiveTabIndex();
	      var prevTab = this.tabs[prevIndex],
	          nextTab = this.tabs[nextIndex];
	
	      if (!nextTab) {
	        return Promise.reject('Specified index does not match any tab.');
	      }
	
	      if (nextIndex === prevIndex) {
	        util.triggerElementEvent(this, 'reactive', { index: nextIndex, activeIndex: nextIndex, tabItem: nextTab });
	        return Promise.resolve(nextTab.pageElement);
	      }
	
	      // FIXME: nextTab.loaded is broken in Zone.js promises (Angular2)
	      var nextPage = nextTab.pageElement;
	      return (nextPage ? Promise.resolve(nextPage) : nextTab.loaded).then(function (nextPage) {
	        return _this4._swiper.setActiveIndex(nextIndex, _extends({
	          reject: true
	        }, options, {
	          animation: prevTab && nextPage ? options.animation || _this4.getAttribute('animation') : 'none',
	          animationOptions: util.extend({ duration: .3, timing: 'cubic-bezier(.4, .7, .5, 1)' }, _this4.hasAttribute('animation-options') ? util.animationOptionsParse(_this4.getAttribute('animation-options')) : {}, options.animationOptions || {})
	        })).then(function () {
	          options.callback instanceof Function && options.callback(nextPage);
	          return nextPage;
	        });
	      });
	    }
	
	    /**
	     * @method setTabbarVisibility
	     * @signature setTabbarVisibility(visible)
	     * @param {Boolean} visible
	     * @description
	     *   [en]Used to hide or show the tab bar.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'setTabbarVisibility',
	    value: function setTabbarVisibility(visible) {
	      var _this5 = this;
	
	      contentReady(this, function () {
	        _this5._contentElement.style[_this5._top ? 'top' : 'bottom'] = visible ? '' : '0px';
	        _this5._tabbarElement.style.display = visible ? '' : 'none';
	        visible && _this5._onRefresh();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.setTabbarVisibility(true);
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.setTabbarVisibility(false);
	    }
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the tabbar is visible or not.[/en]
	     *   [ja]タブバーが見える場合に`true`。[/ja]
	     */
	
	  }, {
	    key: 'getActiveTabIndex',
	
	
	    /**
	     * @method getActiveTabIndex
	     * @signature getActiveTabIndex()
	     * @return {Number}
	     *   [en]The index of the currently active tab.[/en]
	     *   [ja]現在アクティブになっているタブのインデックスを返します。[/ja]
	     * @description
	     *   [en]Returns tab index on current active tab. If active tab is not found, returns -1.[/en]
	     *   [ja]現在アクティブになっているタブのインデックスを返します。現在アクティブなタブがない場合には-1を返します。[/ja]
	     */
	    value: function getActiveTabIndex() {
	      var tabs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tabs;
	
	      for (var i = 0; i < tabs.length; i++) {
	        if (tabs[i] && tabs[i].tagName === 'ONS-TAB' && tabs[i].isActive()) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      var _this6 = this;
	
	      this._swiper.show();
	
	      setImmediate(function () {
	        var tabs = _this6.tabs;
	        var activeIndex = _this6.getActiveTabIndex(tabs);
	        _this6._loadInactive.resolve();
	        if (tabs.length > 0 && activeIndex >= 0) {
	          tabs[activeIndex].loaded.then(function (el) {
	            return el && setImmediate(function () {
	              return el._show();
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      this._swiper.hide();
	      var topPage = this.topPage;
	      topPage && topPage._hide();
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy() {
	      this.tabs.forEach(function (tab) {
	        return tab.remove();
	      });
	      this.remove();
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      if (name === 'modifier') {
	        ModifierUtil.onModifierChanged(last, current, this, scheme$30);
	        var isTop = function isTop(m) {
	          return (/(^|\s+)top($|\s+)/i.test(m)
	          );
	        };
	        isTop(last) !== isTop(current) && this._updatePosition();
	      } else if (name === 'position') {
	        util.isAttached(this) && this._updatePosition();
	      } else if (name === 'swipeable') {
	        this._swiper && this._swiper.updateSwipeable(this.hasAttribute('swipeable'));
	      } else if (name === 'hide-tabs') {
	        this.setTabbarVisibility(!this.hasAttribute('hide-tabs') || current === 'false');
	      }
	    }
	  }, {
	    key: '_tabbarElement',
	    get: function get$$1() {
	      return util.findChild(this, '.tabbar');
	    }
	  }, {
	    key: '_contentElement',
	    get: function get$$1() {
	      return util.findChild(this, '.tabbar__content');
	    }
	  }, {
	    key: '_targetElement',
	    get: function get$$1() {
	      var content = this._contentElement;
	      return content && content.children[0] || null;
	    }
	  }, {
	    key: 'topPage',
	    get: function get$$1() {
	      var tabs = this.tabs,
	          index = this.getActiveTabIndex();
	      return tabs[index] ? tabs[index].pageElement || this.pages[0] || null : null;
	    }
	  }, {
	    key: 'pages',
	    get: function get$$1() {
	      return util.arrayFrom(this._targetElement.children);
	    }
	  }, {
	    key: 'tabs',
	    get: function get$$1() {
	      return Array.prototype.filter.call(this._tabbarElement.children, function (e) {
	        return e.tagName === 'ONS-TAB';
	      });
	    }
	  }, {
	    key: 'visible',
	    get: function get$$1() {
	      return this._tabbarElement.style.display !== 'none';
	    }
	
	    /**
	     * @property swipeable
	     * @type {Boolean}
	     * @description
	     *   [en]Enable swipe interaction.[/en]
	     *   [ja]swipeableであればtrueを返します。[/ja]
	     */
	
	  }, {
	    key: 'swipeable',
	    get: function get$$1() {
	      return this.hasAttribute('swipeable');
	    },
	    set: function set$$1(value) {
	      return util.toggleAttribute(this, 'swipeable', value);
	    }
	
	    /**
	     * @property onSwipe
	     * @type {Function}
	     * @description
	     *   [en]Hook called whenever the user slides the tabbar. It gets a decimal index and an animationOptions object as arguments.[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'onSwipe',
	    get: function get$$1() {
	      return this._onSwipe;
	    },
	    set: function set$$1(value) {
	      if (value && !(value instanceof Function)) {
	        throw new Error('\'onSwipe\' must be a function.');
	      }
	      this._onSwipe = value;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'position', 'swipeable', 'tab-border', 'hide-tabs'];
	    }
	  }, {
	    key: 'rewritables',
	    get: function get$$1() {
	      return rewritables$3;
	    }
	  }, {
	    key: 'events',
	    get: function get$$1() {
	      return ['prechange', 'postchange', 'reactive'];
	    }
	  }]);
	  return TabbarElement;
	}(BaseElement);
	
	onsElements.Tabbar = TabbarElement;
	customElements.define('ons-tabbar', TabbarElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var defaultClassName$16 = 'tabbar__item';
	
	var scheme$29 = {
	  '': 'tabbar--*__item',
	  '.tabbar__button': 'tabbar--*__button'
	};
	
	/**
	 * @element ons-tab
	 * @category tabbar
	 * @description
	 *   [en]Represents a tab inside tab bar. Each `<ons-tab>` represents a page.[/en]
	 *   [ja]
	 *     タブバーに配置される各アイテムのコンポーネントです。それぞれのons-tabはページを表します。
	 *     ons-tab要素の中には、タブに表示されるコンテンツを直接記述することが出来ます。
	 *   [/ja]
	 * @codepen pGuDL
	 * @tutorial vanilla/Reference/tabbar
	 * @guide fundamentals.html#managing-pages
	 *   [en]Managing multiple pages.[/en]
	 *   [ja]複数のページを管理する[/ja]]
	 * @guide appsize.html#removing-icon-packs [en]Removing icon packs.[/en][ja][/ja]
	 * @guide faq.html#how-can-i-use-custom-icon-packs [en]Adding custom icon packs.[/en][ja][/ja]
	 * @seealso ons-tabbar
	 *   [en]ons-tabbar component[/en]
	 *   [ja]ons-tabbarコンポーネント[/ja]
	 * @seealso ons-page
	 *   [en]ons-page component[/en]
	 *   [ja]ons-pageコンポーネント[/ja]
	 * @seealso ons-icon
	 *   [en]ons-icon component[/en]
	 *   [ja]ons-iconコンポーネント[/ja]
	 * @example
	 * <ons-tabbar>
	 *   <ons-tab
	 *     page="home.html"
	 *     label="Home"
	 *     active>
	 *   </ons-tab>
	 *   <ons-tab
	 *     page="settings.html"
	 *     label="Settings"
	 *     active>
	 *   </ons-tab>
	 * </ons-tabbar>
	 *
	 * <template id="home.html">
	 *   ...
	 * </template>
	 *
	 * <template id="settings.html">
	 *   ...
	 * </template>
	
	 */
	
	var TabElement = function (_BaseElement) {
	  inherits(TabElement, _BaseElement);
	
	  /**
	   * @attribute page
	   * @initonly
	   * @type {String}
	   * @description
	   *   [en]The page that is displayed when the tab is tapped.[/en]
	   *   [ja]ons-tabが参照するページへのURLを指定します。[/ja]
	   */
	
	  /**
	   * @attribute icon
	   * @type {String}
	   * @description
	   *   [en]
	   *     The icon name for the tab. Can specify the same icon name as `<ons-icon>`. Check [See also](#seealso) section for more information.
	   *   [/en]
	   *   [ja]
	   *     アイコン名を指定します。ons-iconと同じアイコン名を指定できます。
	   *     個別にアイコンをカスタマイズする場合は、background-imageなどのCSSスタイルを用いて指定できます。
	   *   [/ja]
	   */
	
	  /**
	   * @attribute active-icon
	   * @type {String}
	   * @description
	   *   [en]The name of the icon when the tab is active.[/en]
	   *   [ja]アクティブの際のアイコン名を指定します。[/ja]
	   */
	
	  /**
	   * @attribute label
	   * @type {String}
	   * @description
	   *   [en]The label of the tab item.[/en]
	   *   [ja]アイコン下に表示されるラベルを指定します。[/ja]
	   */
	
	  /**
	   * @attribute badge
	   * @type {String}
	   * @description
	   *   [en]Display a notification badge on top of the tab.[/en]
	   *   [ja]バッジに表示する内容を指定します。[/ja]
	   */
	
	  /**
	   * @attribute active
	   * @description
	   *   [en]This attribute should be set to the tab that is active by default.[/en]
	   *   [ja][/ja]
	   */
	
	  function TabElement() {
	    classCallCheck(this, TabElement);
	
	    var _this = possibleConstructorReturn(this, (TabElement.__proto__ || Object.getPrototypeOf(TabElement)).call(this));
	
	    if (['label', 'icon', 'badge'].some(_this.hasAttribute.bind(_this))) {
	      _this._compile();
	    } else {
	      contentReady(_this, function () {
	        return _this._compile();
	      });
	    }
	
	    _this._pageLoader = defaultPageLoader;
	    _this._onClick = _this._onClick.bind(_this);
	    return _this;
	  }
	
	  createClass(TabElement, [{
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	      this.classList.add(defaultClassName$16);
	
	      if (this._button) {
	        return;
	      }
	
	      var button = util.create('button.tabbar__button');
	      while (this.childNodes[0]) {
	        button.appendChild(this.childNodes[0]);
	      }
	
	      var input = util.create('input', { display: 'none' });
	      input.type = 'radio';
	
	      this.appendChild(input);
	      this.appendChild(button);
	
	      this._updateButtonContent();
	      ModifierUtil.initModifier(this, scheme$29);
	      this._updateRipple();
	    }
	  }, {
	    key: '_updateRipple',
	    value: function _updateRipple() {
	      this._button && util.updateRipple(this._button, this.hasAttribute('ripple'));
	    }
	  }, {
	    key: '_updateButtonContent',
	    value: function _updateButtonContent() {
	      var _this2 = this;
	
	      var button = this._button;
	
	      var iconWrapper = this._icon;
	      if (this.hasAttribute('icon')) {
	        iconWrapper = iconWrapper || util.createElement('<div class="tabbar__icon"><ons-icon></ons-icon></div>');
	        var icon = iconWrapper.children[0];
	        var fix = function (last) {
	          return function () {
	            return icon.attributeChangedCallback('icon', last, _this2.getAttribute('icon'));
	          };
	        }(icon.getAttribute('icon'));
	        icon.setAttribute('icon', this.getAttribute('icon'));
	        iconWrapper.parentElement !== button && button.insertBefore(iconWrapper, button.firstChild);
	
	        // dirty fix for https://github.com/OnsenUI/OnsenUI/issues/1654
	        icon.attributeChangedCallback instanceof Function ? fix() : setImmediate(function () {
	          return icon.attributeChangedCallback instanceof Function && fix();
	        });
	      } else {
	        iconWrapper && iconWrapper.remove();
	      }
	
	      ['label', 'badge'].forEach(function (attr, index) {
	        var prop = _this2.querySelector('.tabbar__' + attr);
	        if (_this2.hasAttribute(attr)) {
	          prop = prop || util.create('.tabbar__' + attr + (attr === 'badge' ? ' notification' : ''));
	          prop.textContent = _this2.getAttribute(attr);
	          prop.parentElement !== button && button.appendChild(prop);
	        } else {
	          prop && prop.remove();
	        }
	      });
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick() {
	      if (this.onClick instanceof Function) {
	        this.onClick();
	      } else {
	        this._tabbar.setActiveTab(this.index, { reject: false });
	      }
	    }
	  }, {
	    key: 'setActive',
	    value: function setActive() {
	      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this._input.checked = active;
	      this.classList.toggle('active', active);
	      util.toggleAttribute(this, 'active', active);
	
	      if (this.hasAttribute('icon') && this.hasAttribute('active-icon')) {
	        this._icon.children[0].setAttribute('icon', this.getAttribute(active ? 'active-icon' : 'icon'));
	      }
	    }
	  }, {
	    key: '_loadPageElement',
	    value: function _loadPageElement(parent, page) {
	      var _this3 = this;
	
	      this._hasLoaded = true;
	
	      return new Promise(function (resolve) {
	        _this3._pageLoader.load({ parent: parent, page: page }, function (pageElement) {
	
	          if (!_this3.isActive()) {
	            // Perf, fixes #2324 when active tab is 0
	            pageElement.style.visibility = 'hidden';
	            _this3._tabbar._loadInactive.promise.then(function () {
	              return pageElement.style.visibility = '';
	            });
	          }
	
	          parent.replaceChild(pageElement, parent.children[_this3.index]); // Ensure position
	          _this3._loadedPage = pageElement;
	          resolve(pageElement);
	        });
	      });
	    }
	  }, {
	    key: 'isActive',
	
	
	    /**
	     * @return {Boolean}
	     */
	    value: function isActive() {
	      return this.classList.contains('active');
	    }
	  }, {
	    key: 'disconnectedCallback',
	    value: function disconnectedCallback() {
	      this.removeEventListener('click', this._onClick, false);
	      if (this._loadedPage) {
	        this._pageLoader.unload(this._loadedPage);
	        this._loadedPage = null;
	        this._hasLoaded = false;
	        this.loaded = null;
	      }
	    }
	  }, {
	    key: 'connectedCallback',
	    value: function connectedCallback() {
	      var _this4 = this;
	
	      this.addEventListener('click', this._onClick, false);
	
	      if (!util.isAttached(this) || this.loaded) {
	        return; // ons-tabbar compilation may trigger this
	      }
	
	      var deferred = util.defer();
	      this.loaded = deferred.promise;
	
	      contentReady(this, function () {
	        var index = _this4.index;
	        var tabbar = _this4._tabbar;
	        if (!tabbar) {
	          throw new Error('This ons-tab element must be child of ons-tabbar element.');
	        }
	
	        if (tabbar.hasAttribute('modifier')) {
	          util.addModifier(_this4, tabbar.getAttribute('modifier'));
	        }
	
	        if (!_this4._hasLoaded) {
	          if (_this4.hasAttribute('active')) {
	            _this4.setActive(true);
	            tabbar.setAttribute('activeIndex', index);
	          }
	
	          if (index === tabbar.tabs.length - 1) {
	            tabbar._onRefresh();
	            setImmediate(function () {
	              return tabbar._onRefresh();
	            });
	          }
	
	          TabbarElement.rewritables.ready(tabbar, function () {
	            var pageTarget = _this4.page || _this4.getAttribute('page');
	            if (!_this4.pageElement && pageTarget) {
	              var parentTarget = tabbar._targetElement;
	              var dummyPage = util.create('div', { height: '100%', width: '100%', visibility: 'hidden' });
	              parentTarget.insertBefore(dummyPage, parentTarget.children[index]); // Ensure position
	              return _this4._loadPageElement(parentTarget, pageTarget).then(deferred.resolve);
	            }
	
	            return deferred.resolve(_this4.pageElement);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'attributeChangedCallback',
	    value: function attributeChangedCallback(name, last, current) {
	      var _this5 = this;
	
	      switch (name) {
	        case 'class':
	          util.restoreClass(this, defaultClassName$16, scheme$29);
	          break;
	        case 'modifier':
	          contentReady(this, function () {
	            return ModifierUtil.onModifierChanged(last, current, _this5, scheme$29);
	          });
	          break;
	        case 'ripple':
	          contentReady(this, function () {
	            return _this5._updateRipple();
	          });
	          break;
	        case 'icon':
	        case 'label':
	        case 'badge':
	          contentReady(this, function () {
	            return _this5._updateButtonContent();
	          });
	          break;
	        case 'page':
	          this.page = current || '';
	          break;
	      }
	    }
	  }, {
	    key: 'pageLoader',
	    set: function set$$1(loader) {
	      if (!(loader instanceof PageLoader)) {
	        throw Error('First parameter must be an instance of PageLoader.');
	      }
	      this._pageLoader = loader;
	    },
	    get: function get$$1() {
	      return this._pageLoader;
	    }
	  }, {
	    key: '_input',
	    get: function get$$1() {
	      return util.findChild(this, 'input');
	    }
	  }, {
	    key: '_button',
	    get: function get$$1() {
	      return util.findChild(this, '.tabbar__button');
	    }
	  }, {
	    key: '_icon',
	    get: function get$$1() {
	      return this.querySelector('.tabbar__icon');
	    }
	  }, {
	    key: '_tabbar',
	    get: function get$$1() {
	      return util.findParent(this, 'ons-tabbar');
	    }
	  }, {
	    key: 'index',
	    get: function get$$1() {
	      return Array.prototype.indexOf.call(this.parentElement.children, this);
	    }
	  }, {
	    key: 'pageElement',
	    get: function get$$1() {
	      // It has been loaded by ons-tab
	      if (this._loadedPage) {
	        return this._loadedPage;
	      }
	      // Manually attached to DOM, 1 per tab
	      var tabbar = this._tabbar;
	      if (tabbar.pages.length === tabbar.tabs.length) {
	        return tabbar.pages[this.index];
	      }
	      // Loaded in another way
	      return null;
	    }
	  }], [{
	    key: 'observedAttributes',
	    get: function get$$1() {
	      return ['modifier', 'ripple', 'icon', 'label', 'page', 'badge', 'class'];
	    }
	  }]);
	  return TabElement;
	}(BaseElement);
	
	onsElements.Tab = TabElement;
	customElements.define('ons-tab', TabElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var ToastAnimator = function (_BaseAnimator) {
	  inherits(ToastAnimator, _BaseAnimator);
	
	  /**
	   * @param {Object} options
	   * @param {String} options.timing
	   * @param {Number} options.duration
	   * @param {Number} options.delay
	   */
	  function ToastAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.2 : _ref$duration;
	
	    classCallCheck(this, ToastAnimator);
	    return possibleConstructorReturn(this, (ToastAnimator.__proto__ || Object.getPrototypeOf(ToastAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} modal
	   * @param {Function} callback
	   */
	
	
	  createClass(ToastAnimator, [{
	    key: 'show',
	    value: function show(modal, callback) {
	      callback();
	    }
	
	    /**
	     * @param {HTMLElement} modal
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(modal, callback) {
	      callback();
	    }
	  }]);
	  return ToastAnimator;
	}(BaseAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * iOS style animator for dialog.
	 */
	
	var FadeToastAnimator = function (_ToastAnimator) {
	  inherits(FadeToastAnimator, _ToastAnimator);
	
	  function FadeToastAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'linear' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.3 : _ref$duration;
	
	    classCallCheck(this, FadeToastAnimator);
	    return possibleConstructorReturn(this, (FadeToastAnimator.__proto__ || Object.getPrototypeOf(FadeToastAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	  }
	
	  /**
	   * @param {HTMLElement} toast
	   * @param {Function} callback
	   */
	
	
	  createClass(FadeToastAnimator, [{
	    key: 'show',
	    value: function show(toast, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(toast).saveStyle().queue({
	        opacity: 0
	      }).wait(this.delay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	
	    /**
	     * @param {HTMLElement} toast
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(toast, callback) {
	      callback = callback ? callback : function () {};
	
	      Animit(toast).saveStyle().queue({
	        opacity: 1
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback();
	        done();
	      }).play();
	    }
	  }]);
	  return FadeToastAnimator;
	}(ToastAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Ascend Toast Animator.
	 */
	
	var AscendToastAnimator = function (_ToastAnimator) {
	  inherits(AscendToastAnimator, _ToastAnimator);
	
	  function AscendToastAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'ease' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.25 : _ref$duration;
	
	    classCallCheck(this, AscendToastAnimator);
	
	    var _this = possibleConstructorReturn(this, (AscendToastAnimator.__proto__ || Object.getPrototypeOf(AscendToastAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.messageDelay = _this.duration * 0.4 + _this.delay; // Delay message opacity change
	    if (platform.isAndroid()) {
	      _this.ascension = 48; // Toasts are always 1 line
	    } else {
	      if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	        _this.ascension = 98; // 64 + 34
	      } else if (iPhoneXPatch.isIPhoneXLandscapePatchActive()) {
	        _this.ascension = 85; // 64 + 21
	      } else {
	        _this.ascension = 64;
	      }
	    }
	    return _this;
	  }
	
	  /**
	   * @param {HTMLElement} toast
	   * @param {Function} callback
	   */
	
	
	  createClass(AscendToastAnimator, [{
	    key: 'show',
	    value: function show(toast, callback) {
	      toast = toast._toast;
	      util.globals.fabOffset = this.ascension;
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, ' + this.ascension + 'px, 0)'
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, 0, 0)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }), Animit(this._getFabs()).wait(this.delay).queue({
	        transform: 'translate3d(0, -' + this.ascension + 'px, 0) scale(1)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(util.arrayFrom(toast.children)).saveStyle().queue({
	        opacity: 0
	      }).wait(this.messageDelay).queue({
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle());
	    }
	
	    /**
	     * @param {HTMLElement} toast
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(toast, callback) {
	      toast = toast._toast;
	      util.globals.fabOffset = 0;
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, 0, 0)'
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, ' + this.ascension + 'px, 0)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }), Animit(this._getFabs()).wait(this.delay).queue({
	        transform: 'translate3d(0, 0, 0) scale(1)'
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }), Animit(util.arrayFrom(toast.children)).saveStyle().queue({
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle());
	    }
	  }, {
	    key: '_getFabs',
	    value: function _getFabs() {
	      return util.arrayFrom(document.querySelectorAll('ons-fab[position~=bottom], ons-speed-dial[position~=bottom]')).filter(function (fab) {
	        return fab.visible;
	      });
	    }
	  }]);
	  return AscendToastAnimator;
	}(ToastAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Lift-fade Toast Animator
	 */
	
	var LiftToastAnimator = function (_ToastAnimator) {
	  inherits(LiftToastAnimator, _ToastAnimator);
	
	  function LiftToastAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'ease' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.35 : _ref$duration;
	
	    classCallCheck(this, LiftToastAnimator);
	
	    var _this = possibleConstructorReturn(this, (LiftToastAnimator.__proto__ || Object.getPrototypeOf(LiftToastAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    _this.bodyHeight = document.body.clientHeight; // avoid Forced Synchronous Layout
	    if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	      _this.liftAmount = 'calc(100% + 34px)';
	    } else if (iPhoneXPatch.isIPhoneXLandscapePatchActive()) {
	      _this.liftAmount = 'calc(100% + 21px)';
	    } else {
	      _this.liftAmount = '100%';
	    }
	    return _this;
	  }
	
	  /**
	   * @param {HTMLElement} toast
	   * @param {Function} callback
	   */
	
	
	  createClass(LiftToastAnimator, [{
	    key: 'show',
	    value: function show(toast, callback) {
	      toast = toast._toast;
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, ' + this.liftAmount + ', 0)',
	        opacity: 0
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, 0, 0)',
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {HTMLElement} toast
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(toast, callback) {
	      toast = toast._toast;
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, 0, 0)',
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, ' + this.liftAmount + ', 0)',
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition(toast) {
	      if (parseInt(toast.style.top, 10) === 0) {
	        toast.style.top = toast.style.bottom = '';
	      }
	    }
	  }]);
	  return LiftToastAnimator;
	}(ToastAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * Fall-fade Toast Animator
	 */
	
	var FallToastAnimator = function (_ToastAnimator) {
	  inherits(FallToastAnimator, _ToastAnimator);
	
	  function FallToastAnimator() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$timing = _ref.timing,
	        timing = _ref$timing === undefined ? 'ease' : _ref$timing,
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === undefined ? 0 : _ref$delay,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 0.35 : _ref$duration;
	
	    classCallCheck(this, FallToastAnimator);
	
	    var _this = possibleConstructorReturn(this, (FallToastAnimator.__proto__ || Object.getPrototypeOf(FallToastAnimator)).call(this, { timing: timing, delay: delay, duration: duration }));
	
	    if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	      _this.fallAmount = 'calc(-100% - 44px)';
	    } else {
	      _this.fallAmount = '-100%';
	    }
	    return _this;
	  }
	
	  /**
	   * @param {HTMLElement} toast
	   * @param {Function} callback
	   */
	
	
	  createClass(FallToastAnimator, [{
	    key: 'show',
	    value: function show(toast, callback) {
	      toast = toast._toast;
	      this._updatePosition(toast);
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, ' + this.fallAmount + ', 0)',
	        opacity: 0
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, 0, 0)',
	        opacity: 1.0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        callback && callback();
	        done();
	      }));
	    }
	
	    /**
	     * @param {HTMLElement} toast
	     * @param {Function} callback
	     */
	
	  }, {
	    key: 'hide',
	    value: function hide(toast, callback) {
	      var _this2 = this;
	
	      toast = toast._toast;
	      this._updatePosition(toast);
	
	      Animit.runAll(Animit(toast).saveStyle().queue({
	        transform: 'translate3d(0, 0, 0)',
	        opacity: 1.0
	      }).wait(this.delay).queue({
	        transform: 'translate3d(0, ' + this.fallAmount + ', 0)',
	        opacity: 0
	      }, {
	        duration: this.duration,
	        timing: this.timing
	      }).restoreStyle().queue(function (done) {
	        _this2._updatePosition(toast, true);
	        callback && callback();
	        done();
	      }));
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition(toast, cleanUp) {
	      var correctTop = void 0;
	      if (iPhoneXPatch.isIPhoneXPortraitPatchActive()) {
	        correctTop = '44px';
	      } else {
	        correctTop = '0';
	      }
	
	      if (toast.style.top !== correctTop) {
	        toast.style.top = correctTop;
	        toast.style.bottom = 'initial';
	      }
	    }
	  }]);
	  return FallToastAnimator;
	}(ToastAnimator);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	var scheme$31 = {
	  '.toast': 'toast--*',
	  '.toast__message': 'toast--*__message',
	  '.toast__button': 'toast--*__button'
	};
	
	var defaultClassName$17 = 'toast';
	
	var _animatorDict$7 = {
	  'default': platform.isAndroid() ? AscendToastAnimator : LiftToastAnimator,
	  'fade': FadeToastAnimator,
	  'ascend': AscendToastAnimator,
	  'lift': LiftToastAnimator,
	  'fall': FallToastAnimator,
	  'none': ToastAnimator
	};
	
	/**
	 * @element ons-toast
	 * @category dialog
	 * @description
	 *   [en]
	 *     The Toast or Snackbar component is useful for displaying dismissable information or simple actions at (normally) the bottom of the page.
	 *
	 *     This component does not block user input, allowing the app to continue its flow. For simple toasts, consider `ons.notification.toast` instead.
	 *   [/en]
	 *   [ja][/ja]
	 * @tutorial vanilla/Reference/dialog
	 * @seealso ons-alert-dialog
	 *   [en]The `<ons-alert-dialog>` component is preferred for displaying undismissable information.[/en]
	 *   [ja][/ja]
	 */
	
	var ToastElement = function (_BaseDialogElement) {
	  inherits(ToastElement, _BaseDialogElement);
	
	  /**
	   * @attribute animation
	   * @type {String}
	   * @default default
	   * @description
	   *  [en]The animation used when showing and hiding the toast. Can be either `"default"`, `"ascend"` (Android), `"lift"` (iOS), `"fall"`, `"fade"` or `"none"`.[/en]
	   *  [ja][/ja]
	   */
	
	  /**
	   * @attribute animation-options
	   * @type {Expression}
	   * @description
	   *  [en]Specify the animation's duration, timing and delay with an object literal. E.g. `{duration: 0.2, delay: 1, timing: 'ease-in'}`.[/en]
	   *  [ja]アニメーション時のduration, timing, delayをオブジェクトリテラルで指定します。e.g. <code>{duration: 0.2, delay: 1, timing: 'ease-in'}</code>[/ja]
	   */
	
	  function ToastElement() {
	    classCallCheck(this, ToastElement);
	
	    var _this = possibleConstructorReturn(this, (ToastElement.__proto__ || Object.getPrototypeOf(ToastElement)).call(this));
	
	    _this._defaultDBB = function (e) {
	      return e.callParentHandler();
	    };
	    contentReady(_this, function () {
	      return _this._compile();
	    });
	    return _this;
	  }
	
	  createClass(ToastElement, [{
	    key: '_updateAnimatorFactory',
	    value: function _updateAnimatorFactory() {
	      // Reset position style
	      this._toast && (this._toast.style.top = this._toast.style.bottom = '');
	
	      return new AnimatorFactory({
	        animators: _animatorDict$7,
	        baseClass: ToastAnimator,
	        baseClassName: 'ToastAnimator',
	        defaultAnimation: this.getAttribute('animation')
	      });
	    }
	
	    /**
	     * @property onDeviceBackButton
	     * @type {Object}
	     * @description
	     *   [en]Back-button handler.[/en]
	     *   [ja]バックボタンハンドラ。[/ja]
	     */
	
	  }, {
	    key: '_compile',
	    value: function _compile() {
	      autoStyle.prepare(this);
	
	      this.style.display = 'none';
	      this.style.zIndex = 10000; // Lower than dialogs
	
	      var messageClassName = 'toast__message';
	      var buttonClassName = 'toast__button';
	
	      var toast = util.findChild(this, '.' + defaultClassName$17);
	      if (!toast) {
	        toast = document.createElement('div');
	        toast.classList.add(defaultClassName$17);
	        while (this.childNodes[0]) {
	          toast.appendChild(this.childNodes[0]);
	        }
	      }
	
	      var button = util.findChild(toast, '.' + buttonClassName);
	      if (!button) {
	        button = util.findChild(toast, function (e) {
	          return util.match(e, '.button') || util.match(e, 'button');
	        });
	        if (button) {
	          button.classList.remove('button');
	          button.classList.add(buttonClassName);
	          toast.appendChild(button);
	        }
	      }
	
	      if (!util.findChild(toast, '.' + messageClassName)) {
	        var message = util.findChild(toast, '.message');
	        if (!message) {
	          message = document.createElement('div');
	          for (var i = toast.childNodes.length - 1; i >= 0; i--) {
	            if (toast.childNodes[i] !== button) {
	              message.insertBefore(toast.childNodes[i], message.firstChild);
	            }
	          }
	        }
	        message.classList.add(messageClassName);
	
	        toast.insertBefore(message, toast.firstChild);
	      }
	
	      if (toast.parentNode !== this) {
	        this.appendChild(toast);
	      }
	
	      ModifierUtil.initModifier(this, this._scheme);
	    }
	
	    /**
	     * @property visible
	     * @readonly
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is visible or not.[/en]
	     *   [ja]要素が見える場合に`true`。[/ja]
	     */
	
	    /**
	     * @method show
	     * @signature show([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"default"`, `"ascend"` (Android), `"lift"` (iOS), `"fall"`, `"fade"` or `"none"`.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @description
	     *   [en]Show the element.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the displayed element[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @method toggle
	     * @signature toggle([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"default"`, `"ascend"` (Android), `"lift"` (iOS), `"fall"`, `"fade"` or `"none"`.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @description
	     *   [en]Toggle toast visibility.[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @method hide
	     * @signature hide([options])
	     * @param {Object} [options]
	     *   [en]Parameter object.[/en]
	     *   [ja]オプションを指定するオブジェクト。[/ja]
	     * @param {String} [options.animation]
	     *   [en]Animation name. Available animations are `"default"`, `"ascend"` (Android), `"lift"` (iOS), `"fall"`, `"fade"` or `"none"`.[/en]
	     *   [ja][/ja]
	     * @param {String} [options.animationOptions]
	     *   [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	     *   [ja]アニメーション時のduration, delay, timingを指定します。e.g. {duration: 0.2, delay: 0.4, timing: 'ease-in'}[/ja]
	     * @description
	     *   [en]Hide toast.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Resolves to the hidden element[/en]
	     *   [ja][/ja]
	     */
	
	    /**
	     * @param {String} name
	     * @param {Function} Animator
	     */
	
	  }, {
	    key: '_scheme',
	    get: function get$$1() {
	      return scheme$31;
	    }
	  }, {
	    key: '_toast',
	    get: function get$$1() {
	      return util.findChild(this, '.' + defaultClassName$17);
	    }
	  }], [{
	    key: 'registerAnimator',
	    value: function registerAnimator(name, Animator) {
	      if (!(Animator.prototype instanceof ToastAnimator)) {
	        throw new Error('"Animator" param must inherit OnsToastElement.ToastAnimator');
	      }
	      _animatorDict$7[name] = Animator;
	    }
	  }, {
	    key: 'animators',
	    get: function get$$1() {
	      return _animatorDict$7;
	    }
	  }, {
	    key: 'ToastAnimator',
	    get: function get$$1() {
	      return ToastAnimator;
	    }
	  }]);
	  return ToastElement;
	}(BaseDialogElement);
	
	onsElements.Toast = ToastElement;
	customElements.define('ons-toast', ToastElement);
	
	/*
	Copyright 2013-2015 ASIAL CORPORATION
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	
	*/
	
	/**
	 * @element ons-toolbar-button
	 * @category page
	 * @modifier material
	 *   [en]Material Design toolbar button.[/en]
	 *   [ja][/ja]
	 * @modifier outline
	 *   [en]A button with an outline.[/en]
	 *   [ja]アウトラインをもったボタンを表示します。[/ja]
	 * @description
	 *   [en]Button component for ons-toolbar and ons-bottom-toolbar.[/en]
	 *   [ja]ons-toolbarあるいはons-bottom-toolbarに設置できるボタン用コンポーネントです。[/ja]
	 * @codepen aHmGL
	 * @tutorial vanilla/Reference/page
	 * @guide compilation.html#toolbar-compilation
	 *   [en]Adding a toolbar[/en]
	 *   [ja]ツールバーの追加[/ja]
	 * @seealso ons-toolbar
	 *   [en]The `<ons-toolbar>` component displays a navigation bar at the top of a page.[/en]
	 *   [ja]ons-toolbarコンポーネント[/ja]
	 * @seealso ons-back-button
	 *   [en]The `<ons-back-button>` displays a back button in the navigation bar.[/en]
	 *   [ja]ons-back-buttonコンポーネント[/ja]
	 * @example
	 * <ons-toolbar>
	 *   <div class="left">
	 *     <ons-toolbar-button>
	 *       Button
	 *     </ons-toolbar-button>
	 *   </div>
	 *   <div class="center">
	 *     Title
	 *   </div>
	 *   <div class="right">
	 *     <ons-toolbar-button>
	 *       <ons-icon icon="ion-navicon" size="28px"></ons-icon>
	 *     </ons-toolbar-button>
	 *   </div>
	 * </ons-toolbar>
	 */
	
	var ToolbarButtonElement = function (_BaseButtonElement) {
	  inherits(ToolbarButtonElement, _BaseButtonElement);
	
	  function ToolbarButtonElement() {
	    classCallCheck(this, ToolbarButtonElement);
	    return possibleConstructorReturn(this, (ToolbarButtonElement.__proto__ || Object.getPrototypeOf(ToolbarButtonElement)).apply(this, arguments));
	  }
	
	  createClass(ToolbarButtonElement, [{
	    key: '_scheme',
	
	
	    /**
	     * @attribute modifier
	     * @type {String}
	     * @description
	     *   [en]The appearance of the button.[/en]
	     *   [ja]ボタンの表現を指定します。[/ja]
	     */
	
	    /**
	     * @attribute icon
	     * @type {String}
	     * @description
	     *  [en]Creates an `ons-icon` component with this string.[/en]
	     *  [ja]`ons-icon`コンポーネントを悪性します。[/ja]
	     */
	
	    /**
	     * @attribute disabled
	     * @description
	     *   [en]Specify if button should be disabled.[/en]
	     *   [ja]ボタンを無効化する場合は指定してください。[/ja]
	     */
	
	    /**
	     * @property disabled
	     * @type {Boolean}
	     * @description
	     *   [en]Whether the element is disabled or not.[/en]
	     *   [ja]無効化されている場合に`true`。[/ja]
	     */
	
	    get: function get$$1() {
	      return { '': 'toolbar-button--*' };
	    }
	  }, {
	    key: '_defaultClassName',
	    get: function get$$1() {
	      return 'toolbar-button';
	    }
	  }, {
	    key: '_rippleOpt',
	    get: function get$$1() {
	      return [this, undefined, { center: '', 'size': 'contain', 'background': 'transparent' }];
	    }
	  }]);
	  return ToolbarButtonElement;
	}(BaseButtonElement);
	
	onsElements.ToolbarButton = ToolbarButtonElement;
	customElements.define('ons-toolbar-button', ToolbarButtonElement);
	
	// Add and register Custom Elements
	setup$1(ons$1); // Setup initial listeners
	window._superSecretOns = ons$1;
	
	return ons$1;
	
	})));
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253).setImmediate, __webpack_require__(253).clearImmediate, __webpack_require__(193)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(254);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(193)))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(256);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(261);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(81);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(259);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(260);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(258)();
	}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	var invariant = __webpack_require__(91);
	var ReactPropTypesSecret = __webpack_require__(105);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(81);
	
	var _storeShape = __webpack_require__(259);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(262);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(263);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(260);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(283);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(284);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(264);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(265);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(278);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(280);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(281);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(282);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(279);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(276);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(267),
	    getPrototype = __webpack_require__(273),
	    isObjectLike = __webpack_require__(275);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(268),
	    getRawTag = __webpack_require__(271),
	    objectToString = __webpack_require__(272);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(269);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(270);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(268);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(274);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(277);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)(module)))

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(265);
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(279);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(282);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(264);
	
	var _inputField = __webpack_require__(286);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _chatBody = __webpack_require__(289);
	
	var _chatBody2 = _interopRequireDefault(_chatBody);
	
	var _chatRoot = __webpack_require__(290);
	
	var _chatRoot2 = _interopRequireDefault(_chatRoot);
	
	var _chatHeader = __webpack_require__(292);
	
	var _chatHeader2 = _interopRequireDefault(_chatHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = (0, _redux.combineReducers)({
	  inputField: _inputField2.default,
	  chatBody: _chatBody2.default,
	  chatRoot: _chatRoot2.default,
	  chatHeader: _chatHeader2.default
	});
	
	exports.default = app;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _index.POST_MESSAGE:
	  }
	  return state;
	};
	
	var _index = __webpack_require__(287);
	
	var initialState = {};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMessage = exports.postMessage = exports.postFailed = exports.postSuccess = exports.POST_FAILED = exports.POST_SUCCESS = exports.POST_MESSAGE = undefined;
	
	var _index = __webpack_require__(288);
	
	var POST_MESSAGE = exports.POST_MESSAGE = 'POST_MESSAGE';
	var POST_SUCCESS = exports.POST_SUCCESS = 'POST_SUCCESS';
	var POST_FAILED = exports.POST_FAILED = 'POST_FAILED';
	
	var postSuccess = exports.postSuccess = function postSuccess() {
	  return {
	    type: POST_SUCCESS
	  };
	};
	
	var postFailed = exports.postFailed = function postFailed() {
	  return {
	    type: POST_FAILED
	  };
	};
	
	var postMessage = exports.postMessage = function postMessage(params) {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        chatRoot = _getState.chatRoot;
	
	    new Promise(chatRoot.protocol(params)).then(function (data) {
	      dispatch(postSuccess());
	      dispatch((0, _index.addMessages)(data));
	    }, function () {
	      dispatch(postFailed());
	    });
	
	    return dispatch({
	      type: POST_MESSAGE
	    });
	  };
	};
	
	var sendMessage = exports.sendMessage = function sendMessage(params) {
	  return function (dispatch) {
	    dispatch((0, _index.addMessage)(params));
	    dispatch(postMessage(params));
	  };
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clickOnButton = exports.buttonURLOpen = exports.buttonPostback = exports.buttonClicked = exports.addMessages = exports.addMessage = exports.BUTTON_URL_OPEN = exports.BUTTON_POSTBACK = exports.BUTTON_CLICKED = exports.ADD_MESSAGES = exports.ADD_MESSAGE = undefined;
	
	var _index = __webpack_require__(287);
	
	var ADD_MESSAGE = exports.ADD_MESSAGE = 'ADD_MESSAGE';
	var ADD_MESSAGES = exports.ADD_MESSAGES = 'ADD_MESSAGES';
	var BUTTON_CLICKED = exports.BUTTON_CLICKED = 'BUTTON_CLICK';
	var BUTTON_POSTBACK = exports.BUTTON_POSTBACK = 'BUTTON_POSTBACK';
	var BUTTON_URL_OPEN = exports.BUTTON_URL_OPEN = 'BUTTON_URL_OPEN';
	
	var addMessage = exports.addMessage = function addMessage(message) {
	  return {
	    type: ADD_MESSAGE,
	    message: message
	  };
	};
	
	var addMessages = exports.addMessages = function addMessages(messages) {
	  return {
	    type: ADD_MESSAGES,
	    messages: messages
	  };
	};
	
	var buttonClicked = exports.buttonClicked = function buttonClicked() {
	  return {
	    type: BUTTON_CLICKED
	  };
	};
	
	var buttonPostback = exports.buttonPostback = function buttonPostback() {
	  return {
	    type: BUTTON_POSTBACK
	  };
	};
	
	var buttonURLOpen = exports.buttonURLOpen = function buttonURLOpen() {
	  return {
	    type: BUTTON_URL_OPEN
	  };
	};
	
	var clickOnButton = exports.clickOnButton = function clickOnButton(buttonAttribute) {
	  return function (dispatch) {
	    switch (buttonAttribute.type) {
	      case 'postback':
	        dispatch(buttonClicked());
	        dispatch(buttonPostback());
	        return dispatch((0, _index.sendMessage)({
	          'type': 'postback',
	          'data': buttonAttribute.data
	        }));
	      case 'url':
	        window.open(buttonAttribute.url);
	        dispatch(buttonClicked());
	        return dispatch(buttonURLOpen());
	      case 'message':
	        dispatch(buttonClicked());
	        return dispatch((0, _index.sendMessage)({
	          'type': 'text',
	          'isBot': false,
	          'withIcon': true,
	          'text': buttonAttribute.text,
	          'time': '22:22'
	        }));
	    }
	    return dispatch(buttonClicked());
	  };
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _index.ADD_MESSAGE:
	      if (action.message) {
	        return addMessage(state, action.message);
	      } else {
	        return state;
	      }
	    case _index.ADD_MESSAGES:
	      return addMessages(state, action.messages);
	    case _index.BUTTON_CLICKED:
	    case _index.BUTTON_POSTBACK:
	    case _index.BUTTON_URL_OPEN:
	    default:
	      return state;
	  }
	};
	
	var _index = __webpack_require__(288);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  messages: []
	};
	
	function addMessage(state, message) {
	  return _extends({}, state, { messages: [].concat(_toConsumableArray(state.messages), [message]) });
	}
	
	function addMessages(state, messages) {
	  return _extends({}, state, { messages: state.messages.concat(messages) });
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _index.INIT_APP:
	      return initApp(state, action);
	    case _index.INIT_PROTOCOL:
	      return initProtocol(state, action.protocol);
	  }
	  return state;
	};
	
	var _index = __webpack_require__(291);
	
	var initialState = {
	  title: 'WebPlugin',
	  debugFunc: function debugFunc() {},
	  fullFunc: function fullFunc() {},
	  closeFunc: function closeFunc() {},
	  protocol: function protocol() {}
	};
	
	function initApp(state, params) {
	  return _extends({}, state, {
	    title: params.title || state.title,
	    debugFunc: params.debugFunc || state.debugFunc
	  });
	}
	
	function initProtocol(state, protocol) {
	  return _extends({}, state, { protocol: protocol });
	}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INIT_APP = exports.INIT_APP = 'INIT_APP';
	var INIT_PROTOCOL = exports.INIT_PROTOCOL = 'INIT_PROTOCOL';
	
	var initProtocol = exports.initProtocol = function initProtocol(protocol) {
	  return {
	    type: INIT_PROTOCOL,
	    protocol: protocol
	  };
	};
	
	var initApp = exports.initApp = function initApp(_ref) {
	  var title = _ref.title,
	      debugFunc = _ref.debugFunc,
	      fullFunc = _ref.fullFunc,
	      closeFunc = _ref.closeFunc;
	  return {
	    type: INIT_APP,
	    title: title,
	    debugFunc: debugFunc,
	    fullFunc: fullFunc,
	    closeFunc: closeFunc
	  };
	};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    default:
	      return state;
	  }
	};
	
	var initialState = {};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(255);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactOnsenui = __webpack_require__(294);
	
	__webpack_require__(295);
	
	__webpack_require__(362);
	
	var _chatHeader = __webpack_require__(365);
	
	var _chatHeader2 = _interopRequireDefault(_chatHeader);
	
	var _chatBody = __webpack_require__(370);
	
	var _chatBody2 = _interopRequireDefault(_chatBody);
	
	var _chatFooter = __webpack_require__(381);
	
	var _chatFooter2 = _interopRequireDefault(_chatFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Onsen UI Styling and Icons
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var title = this.props.title;
	
	      return _react2.default.createElement(
	        _reactOnsenui.Page,
	        { renderToolbar: function renderToolbar() {
	            return _react2.default.createElement(_chatHeader2.default, { title: title, mode: ("production") });
	          } },
	        _react2.default.createElement(_chatBody2.default, null),
	        _react2.default.createElement(_chatFooter2.default, null)
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	App.propTypes = {
	  title: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    protocol: state.chatRoot.protocol,
	    title: state.chatRoot.title
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* react-onsenui v1.10.0 - 2018-01-26 */
	
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(81), __webpack_require__(257), __webpack_require__(111), __webpack_require__(252)) :
		typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'react-dom', 'onsenui'], factory) :
		(factory((global.Ons = {}),global.React,global.PropTypes,global.ReactDOM,global.ons));
	}(this, (function (exports,React,PropTypes,ReactDOM,ons) { 'use strict';
	
	React = React && React.hasOwnProperty('default') ? React['default'] : React;
	PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
	var ReactDOM__default = 'default' in ReactDOM ? ReactDOM['default'] : ReactDOM;
	ons = ons && ons.hasOwnProperty('default') ? ons['default'] : ons;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var pixelSize = function pixelSize(item) {
	  return typeof item === 'number' ? item + 'px' : item;
	};
	
	var normalize = function normalize(key) {
	  if (/^is[A-Z]/.test(key)) {
	    key = key.slice(2);
	  }
	  return key.replace(/([a-zA-Z])([A-Z])/g, '$1-$2').toLowerCase();
	};
	
	var convert = function convert(dict, name) {
	  var newName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;
	
	  if (dict.hasOwnProperty(name)) {
	    switch (_typeof(dict[name])) {
	      case 'boolean':
	        if (dict[name]) {
	          dict[newName] = '';
	        } else {
	          delete dict[newName];
	        }
	        break;
	      case 'string':
	      case 'number':
	        dict[newName] = dict[name];
	        break;
	      default:
	        dict[name] = null;
	    }
	
	    if (newName !== name) {
	      dict[name] = null;
	    }
	  }
	
	  return dict;
	};
	
	var Util = {
	  eventToHandler: function eventToHandler(string) {
	    return 'on' + string.charAt(0).toUpperCase() + string.slice(1);
	  },
	  getAttrs: function getAttrs(el) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : el.props;
	    var dict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var attrs = _extends({}, props);
	    var validProps = el.constructor.propTypes || {};
	
	    if (attrs.hasOwnProperty('animationOptions') && typeof attrs.animationOptions !== 'string') {
	      attrs.animationOptions = JSON.stringify(attrs.animationOptions);
	    }
	
	    Object.keys(attrs).forEach(function (key) {
	      if (validProps.hasOwnProperty(key) && ['onClick'].indexOf(key) === -1) {
	        if (['isOpen'].indexOf(key) !== -1) {
	          attrs[key] = null;
	        } else {
	          if (/(height|width)/i.test(key)) {
	            attrs[key] = pixelSize(attrs[key]);
	          }
	          convert(attrs, key, dict[key] || normalize(key));
	        }
	      }
	    });
	
	    return attrs;
	  }
	};
	
	var BaseDialog = function (_React$Component) {
	  inherits(BaseDialog, _React$Component);
	
	  function BaseDialog() {
	    var _ref;
	
	    classCallCheck(this, BaseDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = BaseDialog.__proto__ || Object.getPrototypeOf(BaseDialog)).call.apply(_ref, [this].concat(args)));
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onCancel = callback.bind(_this, 'onCancel');
	    _this.onPreShow = callback.bind(_this, 'onPreShow');
	    _this.onPostShow = callback.bind(_this, 'onPostShow');
	    _this.onPreHide = callback.bind(_this, 'onPreHide');
	    _this.onPostHide = callback.bind(_this, 'onPostHide');
	    return _this;
	  }
	
	  createClass(BaseDialog, [{
	    key: 'show',
	    value: function show() {
	      this.node.firstChild.show();
	    }
	  }, {
	    key: 'updateClasses',
	    value: function updateClasses() {
	      var node = this.node.firstChild;
	
	      if (this.props.className) {
	        if (this.lastClass) {
	          node.className = node.className.replace(this.lastClass, '');
	        }
	
	        this.lastClass = ' ' + this.props.className;
	        node.className += this.lastClass;
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.node.firstChild.hide();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.node = document.createElement('div');
	      document.body.appendChild(this.node);
	
	      this.node.addEventListener('dialog-cancel', this.onCancel);
	      this.node.addEventListener('preshow', this.onPreShow);
	      this.node.addEventListener('postshow', this.onPostShow);
	      this.node.addEventListener('prehide', this.onPreHide);
	      this.node.addEventListener('posthide', this.onPostHide);
	
	      this.renderPortal(this.props, false, this.props.onDeviceBackButton);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      this.renderPortal(newProps, this.props.isOpen);
	      if (newProps.onDeviceBackButton !== undefined) {
	        this.node.firstChild.onDeviceBackButton = newProps.onDeviceBackButton;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      this.node.removeEventListener('dialog-cancel', this.onCancel);
	      this.node.removeEventListener('preshow', this.onPreShow);
	      this.node.removeEventListener('postshow', this.onPostShow);
	      this.node.removeEventListener('prehide', this.onPreHide);
	      this.node.removeEventListener('posthide', this.onPostHide);
	
	      var unmount = function unmount() {
	        ReactDOM__default.unmountComponentAtNode(_this2.node);
	        document.body.removeChild(_this2.node);
	      };
	
	      if (this.node.firstChild.visible === true) {
	        this.node.firstChild.hide().then(unmount);
	      } else {
	        unmount();
	      }
	    }
	  }, {
	    key: '_update',
	    value: function _update(isShown, onDeviceBackButton) {
	      if (this.props.isOpen) {
	        if (!isShown) {
	          this.show();
	        }
	      } else {
	        this.hide();
	      }
	
	      this.updateClasses();
	
	      if (onDeviceBackButton instanceof Function) {
	        this.node.firstChild.onDeviceBackButton = onDeviceBackButton;
	      }
	    }
	  }, {
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      throw new Error('_getDomNodeName is not implemented');
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props, isShown) {
	      var onDeviceBackButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var isOpen = props.isOpen,
	          others = objectWithoutProperties(props, ['isOpen']);
	
	      var attrs = Util.getAttrs(this, others);
	      var DomNodeName = this._getDomNodeName();
	
	      ReactDOM__default.unstable_renderSubtreeIntoContainer(this, React.createElement(DomNodeName, _extends({}, attrs, { children: props.children })), this.node, this._update.bind(this, isShown, onDeviceBackButton));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return BaseDialog;
	}(React.Component);
	
	BaseDialog.propTypes = {
	  onCancel: PropTypes.func,
	  isOpen: PropTypes.bool.isRequired,
	  isCancelable: PropTypes.bool,
	  isDisabled: PropTypes.bool,
	  animation: PropTypes.string,
	  maskColor: PropTypes.string,
	  animationOptions: PropTypes.object,
	  onPreShow: PropTypes.func,
	  onPostShow: PropTypes.func,
	  onPreHide: PropTypes.func,
	  onPostHide: PropTypes.func,
	  onDeviceBackButton: PropTypes.func
	};
	
	BaseDialog.defaultProps = {
	  isCancelable: true,
	  isDisabled: false
	};
	
	/**
	 * @original ons-action-sheet
	 * @category dialog
	 * @tutorial react/Reference/action-sheet
	 * @description
	 * [en]
	 *  Action/bottom sheet that is displayed on top of current screen.
	 *  The action sheet is useful for displaying a list of options and asking the user to make a decision. An ActionSheetButton component is provided for this purpose, although it can contain any type of content.
	 *  It will automatically be displayed as Material Design (bottom sheet) when running on an Android device.
	 * [/en]
	 * [ja][/ja]
	 */
	
	var ActionSheet = function (_BaseDialog) {
	  inherits(ActionSheet, _BaseDialog);
	
	  function ActionSheet() {
	    classCallCheck(this, ActionSheet);
	    return possibleConstructorReturn(this, (ActionSheet.__proto__ || Object.getPrototypeOf(ActionSheet)).apply(this, arguments));
	  }
	
	  createClass(ActionSheet, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-action-sheet';
	    }
	  }]);
	  return ActionSheet;
	}(BaseDialog);
	
	ActionSheet.propTypes = {
	  /**
	   * @name onCancel
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called only if isCancelable is true. It will be called after tapping the background or by pressing the back button on Android devices.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onCancel: PropTypes.func,
	
	  /**
	   * @name isOpen
	   * @type bool
	   * @required true
	   * @description
	   *  [en]
	   *  Indicates whether the dialog is open and shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool.isRequired,
	
	  /**
	   * @name isCancelable
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is cancelable or not.
	   *  A cancelable dialog will call onCancel  when tapping the background or or  pressing the back button on Android devices
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isCancelable: PropTypes.bool,
	
	  /**
	   * @name isDisabled
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isDisabled: PropTypes.bool,
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]
	   *  The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name maskColor
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the background mask. Default is "rgba(0, 0, 0, 0.2)"[/en]
	   *  [ja][/ja]
	   */
	  maskColor: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the action sheet is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the action sheet is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the action sheet is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the action sheet is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	var BasicComponent = function (_React$Component) {
	  inherits(BasicComponent, _React$Component);
	
	  function BasicComponent() {
	    var _ref;
	
	    classCallCheck(this, BasicComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = BasicComponent.__proto__ || Object.getPrototypeOf(BasicComponent)).call.apply(_ref, [this].concat(args)));
	
	    _this.updateClasses = _this.updateClasses.bind(_this);
	    return _this;
	  }
	
	  createClass(BasicComponent, [{
	    key: 'updateClasses',
	    value: function updateClasses() {
	      var node = ReactDOM__default.findDOMNode(this);
	
	      if (!node) {
	        return;
	      }
	
	      if (typeof this.props.className !== 'undefined') {
	        if (this.lastClass) {
	          node.className = node.className.replace(this.lastClass, ' ');
	        }
	
	        this.lastClass = ' ' + this.props.className.trim();
	
	        node.className = node.className.trim() + this.lastClass;
	      }
	
	      if (!ons) {
	        throw new Error("react-onsenui requires `onsenui`, make sure you are loading it with `import onsenui` or `require('onsenui')` before using the components");
	      }
	
	      ons._autoStyle.prepare(node);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateClasses();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateClasses();
	    }
	  }]);
	  return BasicComponent;
	}(React.Component);
	
	var SimpleWrapper = function (_BasicComponent) {
	  inherits(SimpleWrapper, _BasicComponent);
	
	  function SimpleWrapper() {
	    classCallCheck(this, SimpleWrapper);
	    return possibleConstructorReturn(this, (SimpleWrapper.__proto__ || Object.getPrototypeOf(SimpleWrapper)).apply(this, arguments));
	  }
	
	  createClass(SimpleWrapper, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(this._getDomNodeName(), Util.getAttrs(this), this.props.children);
	    }
	  }]);
	  return SimpleWrapper;
	}(BasicComponent);
	
	/**
	 * @original ons-action-sheet-button
	 * @category dialog
	 * @tutorial react/Reference/action-sheet
	 * @description
	 * [en]Component that represent each button of the action sheet.[/en]
	 * [ja][/ja]
	 */
	
	var ActionSheetButton = function (_SimpleWrapper) {
	  inherits(ActionSheetButton, _SimpleWrapper);
	
	  function ActionSheetButton() {
	    classCallCheck(this, ActionSheetButton);
	    return possibleConstructorReturn(this, (ActionSheetButton.__proto__ || Object.getPrototypeOf(ActionSheetButton)).apply(this, arguments));
	  }
	
	  createClass(ActionSheetButton, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-action-sheet-button';
	    }
	  }]);
	  return ActionSheetButton;
	}(SimpleWrapper);
	
	ActionSheetButton.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the action sheet button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name icon
	   * @type string
	   * @description
	   *  [en]Creates an `Icon` component with this string. Only visible on Android.[/en]
	   *  [ja][/ja]
	   */
	  icon: PropTypes.string,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en]This function will be called when the button is clicked.[/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-alert-dialog
	 * @category dialog
	 * @tutorial react/Reference/dialog
	 * @description
	 * [en]
	 *   Alert dialog that is displayed on top of the current screen. Useful for displaying questions, warnings or error messages to the user. The title, content and buttons can be easily customized and it will automatically switch style based on the platform.
	 * [/en]
	 * [ja][/ja]
	 * @example
	   <AlertDialog isOpen={this.state.isOpen} onCancel={this.handleCancel.bind(this)} cancelable>
	     <div className="alert-dialog-title">Warning!</div>
	     <div className="alert-dialog-content">
	       An error has occurred!
	     </div>
	     <div className="alert-dialog-footer">
	       <Button onClick={this.handleCancel.bind(this)} className="alert-dialog-button">
	         Cancel
	       </Button>
	       <Button onClick={this.handleCancel.bind(this)} className="alert-dialog-button">
	         Ok
	       </Button>
	     </div>
	   </AlertDialog>
	 */
	
	var AlertDialog = function (_BaseDialog) {
	  inherits(AlertDialog, _BaseDialog);
	
	  function AlertDialog() {
	    classCallCheck(this, AlertDialog);
	    return possibleConstructorReturn(this, (AlertDialog.__proto__ || Object.getPrototypeOf(AlertDialog)).apply(this, arguments));
	  }
	
	  createClass(AlertDialog, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-alert-dialog';
	    }
	  }]);
	  return AlertDialog;
	}(BaseDialog);
	
	AlertDialog.propTypes = {
	  /**
	   * @name onCancel
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called only if isCancelable is true. It will be called after tapping the background or by pressing the back button on Android devices.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onCancel: PropTypes.func,
	
	  /**
	   * @name isOpen
	   * @type bool
	   * @required true
	   * @description
	   *  [en]
	   *  Indicates whether the dialog is open and shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool.isRequired,
	
	  /**
	   * @name isCancelable
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is cancelable or not.
	   *  A cancelable dialog will call onCancel  when tapping the background or or  pressing the back button on Android devices
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isCancelable: PropTypes.bool,
	
	  /**
	   * @name isDisabled
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isDisabled: PropTypes.bool,
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]
	   *  The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name maskColor
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the background mask. Default is "rgba(0, 0, 0, 0.2)"[/en]
	   *  [ja][/ja]
	   */
	  maskColor: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-alert-dialog-button
	 * @category dialog
	 * @tutorial react/Reference/dialog
	 * @description
	 * [en]Component that represent each button of the alert dialog.[/en]
	 * [ja][/ja]
	 */
	
	var AlertDialogButton = function (_SimpleWrapper) {
	  inherits(AlertDialogButton, _SimpleWrapper);
	
	  function AlertDialogButton() {
	    classCallCheck(this, AlertDialogButton);
	    return possibleConstructorReturn(this, (AlertDialogButton.__proto__ || Object.getPrototypeOf(AlertDialogButton)).apply(this, arguments));
	  }
	
	  createClass(AlertDialogButton, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-alert-dialog-button';
	    }
	  }]);
	  return AlertDialogButton;
	}(SimpleWrapper);
	
	AlertDialogButton.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the alert dialog button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the button is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en]This function will be called when the button is clicked.[/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-back-button
	 * @category navigation
	 * @tutorial react/Reference/navigator
	 * @description
	 * [en]
	 *   Back button component for Toolbar. It enables to automatically to pop the top page of the navigator. When only presented with one page, the button is hidden automatically.
	 *
	 *   The default behavior can be overridden using the `onClick` prop.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Toolbar modifier={this.props.modifier} >
	      <div className="left"><BackButton modifier={this.props.modifier}>Back</BackButton></div>
	      <div className="center">{this.props.title}</div>
	   </Toolbar>
	 */
	
	var BackButton = function (_SimpleWrapper) {
	  inherits(BackButton, _SimpleWrapper);
	
	  function BackButton() {
	    classCallCheck(this, BackButton);
	    return possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).apply(this, arguments));
	  }
	
	  createClass(BackButton, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-back-button';
	    }
	  }, {
	    key: '_updateOnClick',
	    value: function _updateOnClick(props) {
	      var node = ReactDOM__default.findDOMNode(this);
	
	      if (props.onClick) {
	        node.onClick = function () {
	          return null;
	        };
	      } else {
	        delete node.onClick;
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateOnClick(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this._updateOnClick(props);
	    }
	  }]);
	  return BackButton;
	}(SimpleWrapper);
	
	BackButton.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the back button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en]This function will be called ones the button is clicked. It overrides the default behavior of the back button.[/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-bottom-toolbar
	 * @category page
	 * @description
	 * [en]Toolbar component that is positioned at the bottom of the page.[/en]
	 * [ja][/ja]
	 * @example
	 * <BottomToolbar modifier="material"> Content </BottomToolbar>
	 */
	
	var BottomToolbar = function (_SimpleWrapper) {
	  inherits(BottomToolbar, _SimpleWrapper);
	
	  function BottomToolbar() {
	    classCallCheck(this, BottomToolbar);
	    return possibleConstructorReturn(this, (BottomToolbar.__proto__ || Object.getPrototypeOf(BottomToolbar)).apply(this, arguments));
	  }
	
	  createClass(BottomToolbar, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-bottom-toolbar';
	    }
	  }]);
	  return BottomToolbar;
	}(SimpleWrapper);
	
	BottomToolbar.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]Specify modifier name to specify custom styles. Optional.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	/**
	 * @original ons-button
	 * @category form
	 * @tutorial react/Reference/button
	 * @description
	 * [en] Button component. If you want to place a button in a toolbar, use `ToolbarButton` or `BackButton` instead. Will automatically display as a Material Design button with a ripple effect on Android.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <Button modifier="large--cta">
	 *   Tap Me
	 * </Button>
	 */
	
	var Button = function (_SimpleWrapper) {
	  inherits(Button, _SimpleWrapper);
	
	  function Button() {
	    classCallCheck(this, Button);
	    return possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	  }
	
	  createClass(Button, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-button';
	    }
	  }]);
	  return Button;
	}(SimpleWrapper);
	
	Button.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the button is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name ripple
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the button has a ripple effect.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  ripple: PropTypes.bool,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en] This function will be called ones the button is clicked. [/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-card
	 * @category visual
	 * @tutorial react/Reference/visual
	 * @description
	 * [en]Card component that can be used to display content.[/en]
	 * [ja][/ja]
	 * @example
	 *
	<Card>
	  <p>Some content</p>
	</Card>
	 */
	
	var Card = function (_SimpleWrapper) {
	  inherits(Card, _SimpleWrapper);
	
	  function Card() {
	    classCallCheck(this, Card);
	    return possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
	  }
	
	  createClass(Card, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-card';
	    }
	  }]);
	  return Card;
	}(SimpleWrapper);
	
	Card.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	/**
	 * @original ons-carousel
	 * @category carousel
	 * @tutorial react/Reference/carousel
	 * @description
	 * [en] Carousel component. A carousel can be used to display several items in the same space.
	 *     The component supports displaying content both horizontally and vertically. The user can scroll through the items by dragging and it can also be controller programmatically.
	 [/en]
	 * [ja][/ja]
	 * @example
	 *    <Carousel
	          onPostChange={() => console.log('onPostChange')}
	          onOverscroll={() => console.log('onOverscroll')}
	          onRefresh={() => console.log('onRefresh')}
	          ref={(carousel) => { this.carousel = carousel; }}
	          swipeable
	          overscrollable
	          autoScroll
	          fullscreen
	          autoScrollRatio={0.2}
	      >
	          <CarouselItem style={{backgroundColor: 'gray'}}>
	            <div className='item-label'>GRAY</div>
	          </CarouselItem>
	          <CarouselItem style={{backgroundColor: '#085078'}}>
	            <div className='item-label'>BLUE</div>
	          </CarouselItem>
	        </Carousel>
	
	 */
	
	var Carousel = function (_SimpleWrapper) {
	  inherits(Carousel, _SimpleWrapper);
	
	  function Carousel() {
	    var _ref;
	
	    classCallCheck(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args)));
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onChange = callback.bind(_this, 'onPostChange');
	    _this.onRefresh = callback.bind(_this, 'onRefresh');
	    _this.onOverscroll = callback.bind(_this, 'onOverscroll');
	    return _this;
	  }
	
	  createClass(Carousel, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-carousel';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(Carousel.prototype.__proto__ || Object.getPrototypeOf(Carousel.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM.findDOMNode(this);
	      node.addEventListener('postchange', this.onChange);
	      node.addEventListener('refresh', this.onRefresh);
	      node.addEventListener('overscroll', this.onOverscroll);
	      node.onSwipe = this.props.onSwipe || null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = ReactDOM.findDOMNode(this);
	      node.removeEventListener('postchange', this.onPostChange);
	      node.removeEventListener('refresh', this.onRefresh);
	      node.removeEventListener('overscroll', this.onOverscroll);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      var node = ReactDOM.findDOMNode(this);
	
	      if (this.props.index !== node.getActiveIndex()) {
	        node.setActiveIndex(this.props.index, props.animationOptions);
	      }
	
	      if (this.props.children.length !== props.children.length) {
	        node.refresh();
	      }
	
	      if (this.props.onSwipe !== props.onSwipe) {
	        node.onSwipe = this.props.onSwipe;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var attrs = Util.getAttrs(this, this.props, { index: 'initial-index' });
	
	      return React.createElement(
	        'ons-carousel',
	        attrs,
	        React.createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        React.createElement('div', null)
	      );
	    }
	  }]);
	  return Carousel;
	}(SimpleWrapper);
	
	Carousel.propTypes = {
	
	  /**
	   * @name direction
	   * @type string
	   * @required false
	   * @description
	   *  [en]The direction of the carousel. Can be either "horizontal" or "vertical". Default is "horizontal".[/en]
	   *  [ja][/ja]
	   */
	  direction: PropTypes.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @name fullscreen
	   * @type bool
	   * @description
	   *  [en]If true, the carousel will cover the whole screen.[/en]
	   *  [ja][/ja]
	   */
	  fullscreen: PropTypes.bool,
	
	  /**
	   * @name overscrollable
	   * @type bool
	   * @description
	   *  [en]If true, the carousel will be scrollable over the edge. It will bounce back when released.[/en]
	   *  [ja][/ja]
	   */
	  overscrollable: PropTypes.bool,
	
	  /**
	   * @name centered
	   * @type bool
	   * @description
	   *  [en]If true, the carousel then the selected item will be in the center of the carousel instead of the beginning. Useful only when the items are smaller than the carousel.[/en]
	   *  [ja][/ja]
	   */
	  centered: PropTypes.bool,
	
	  /**
	   * @name itemWidth
	   * @type number
	   * @description
	   *  [en]ons-carousel-item's width. Only works when the direction is set to "horizontal".[/en]
	   *  [ja][/ja]
	   */
	  itemWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  /**
	   * @name itemHeight
	   * @type number
	   * @description
	   *  [en]ons-carousel-item's height. Only works when the direction is set to "vertical".[/en]
	   *  [ja][/ja]
	   */
	  itemHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  /**
	   * @name autoScroll
	   * @type bool
	   * @description
	   *  [en]If true, the carousel will be automatically scrolled to the closest item border when released.[/en]
	   *  [ja][/ja]
	   */
	  autoScroll: PropTypes.bool,
	
	  /**
	   * @name autoScrollRatio
	   * @type number
	   * @description
	   *  [en]A number between 0.0 and 1.0 that specifies how much the user must drag the carousel in order for it to auto scroll to the next item.[/en]
	   *  [ja][/ja]
	   */
	  autoScrollRatio: PropTypes.number,
	
	  /**
	   * @name swipeable
	   * @type bool
	   * @description
	   *  [en]If true, the carousel can be scrolled by drag or swipe.[/en]
	   *  [ja][/ja]
	   */
	  swipeable: PropTypes.bool,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]If true, the carousel will be disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name index
	   * @type number
	   * @description
	   *  [en]Specify the index of the ons-carousel-item to show. Default is 0.[/en]
	   *  [ja][/ja]
	   */
	  index: PropTypes.number,
	
	  /**
	   * @name autoRefresh
	   * @type bool
	   * @description
	   *  [en]When this attribute is set the carousel will automatically refresh when the number of child nodes change.[/en]
	   *  [ja][/ja]
	   */
	  autoRefresh: PropTypes.bool,
	
	  /**
	   * @name onPostChange
	   * @type function
	   * @description
	   *  [en]Called just after the current carousel item has changed.  [/en]
	   *  [ja][/ja]
	   */
	  onPostChange: PropTypes.func,
	
	  /**
	   * @name onRefresh
	   * @type function
	   * @description
	   *  [en]Called when the carousel has been refreshed. [/en]
	   *  [ja][/ja]
	   */
	  onRefresh: PropTypes.func,
	
	  /**
	   * @name onOverscroll
	   * @type function
	   * @description
	   *  [en]Called when the carousel has been overscrolled. [/en]
	   *  [ja][/ja]
	   */
	  onOverscroll: PropTypes.func,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onSwipe
	   * @type function
	   * @description
	   *  [en]Hook called whenever the user slides the carousel. It gets a decimal index and an animationOptions object as arguments.[/en]
	   *  [ja][/ja]
	   */
	  onSwipe: PropTypes.func
	};
	
	/**
	 * @original ons-carousel-item
	 * @category carousel
	 * @tutorial react/Reference/carousel
	 * @description
	 * [en] Carousel item component. Used as a child of the `<ons-carousel>` element.
	 [/en]
	 * [ja][/ja]
	 * @example
	*  <Carousel swipeable overscrollable autoScroll fullscreen >
	     <CarouselItem style={{backgroundColor: 'gray'}}>
	       <div className='item-label'>GRAY</div>
	     </CarouselItem>
	     <CarouselItem style={{backgroundColor: '#085078'}}>
	       <div className='item-label'>BLUE</div>
	     </CarouselItem>
	   </Carousel>
	 */
	
	var CarouselItem = function (_SimpleWrapper) {
	  inherits(CarouselItem, _SimpleWrapper);
	
	  function CarouselItem() {
	    classCallCheck(this, CarouselItem);
	    return possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).apply(this, arguments));
	  }
	
	  createClass(CarouselItem, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-carousel-item';
	    }
	  }]);
	  return CarouselItem;
	}(SimpleWrapper);
	
	CarouselItem.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	var BaseInput = function (_BasicComponent) {
	  inherits(BaseInput, _BasicComponent);
	
	  function BaseInput() {
	    var _ref;
	
	    classCallCheck(this, BaseInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = BaseInput.__proto__ || Object.getPrototypeOf(BaseInput)).call.apply(_ref, [this].concat(args)));
	
	    _this.onChange = function (event) {
	      if (_this.props.onChange) {
	        return _this.props.onChange(event);
	      }
	    };
	    return _this;
	  }
	
	  createClass(BaseInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      get(BaseInput.prototype.__proto__ || Object.getPrototypeOf(BaseInput.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM__default.findDOMNode(this);
	
	      if (this.props.value !== undefined) {
	        node.value = this.props.value;
	      }
	
	      this.EVENT_TYPES.forEach(function (eventType) {
	        return node.addEventListener(eventType, _this2.onChange);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      var node = ReactDOM__default.findDOMNode(this);
	      this.EVENT_TYPES.forEach(function (eventType) {
	        return node.removeEventListener(eventType, _this3.onChange);
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var node = ReactDOM__default.findDOMNode(this);
	
	      if (typeof props.value !== 'undefined' && node.value !== props.value) {
	        node.value = props.value;
	      }
	
	      if (typeof props.checked !== 'undefined') {
	        node.checked = props.checked;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          props = objectWithoutProperties(_props, ['onChange']);
	
	      return React.createElement(this._getDomNodeName(), Util.getAttrs(this, props));
	    }
	  }, {
	    key: 'EVENT_TYPES',
	    get: function get$$1() {
	      return ['change', 'input'];
	    }
	  }]);
	  return BaseInput;
	}(BasicComponent);
	
	BaseInput.propTypes = {
	  modifier: PropTypes.string,
	  disabled: PropTypes.bool,
	  onChange: PropTypes.func,
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	  checked: PropTypes.bool,
	  placeholder: PropTypes.string,
	  type: PropTypes.string,
	  inputId: PropTypes.string,
	  float: PropTypes.bool
	};
	
	/**
	 * @original ons-checkbox
	 * @category form
	 * @tutorial react/Reference/input
	 * @description
	 * [en]
	 *  A checkbox element. The component will automatically render as a Material Design checkbox on Android devices.
	 *
	 *  Most attributes that can be used for a normal `<input type="checkbox">` element can also be used on the `<Checkbox>` component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Checkbox
	 *   onChange={event => { this.setState({checked: event.target.checked})} }
	 *   modifier='material' />
	 */
	
	var Checkbox = function (_BaseInput) {
	  inherits(Checkbox, _BaseInput);
	
	  function Checkbox() {
	    classCallCheck(this, Checkbox);
	    return possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  createClass(Checkbox, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-checkbox';
	    }
	  }, {
	    key: 'EVENT_TYPES',
	    get: function get$$1() {
	      return ['change'];
	    }
	  }]);
	  return Checkbox;
	}(BaseInput);
	
	Checkbox.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the checkbox.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the checkbox is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en] Called when the checkbox state changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type string
	   * @description
	   *  [en] Value of the checkbox.[/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	
	  /**
	   * @name checked
	   * @type boolean
	   * @description
	   *  [en]Controls the state of the checkbox.[/en]
	   *  [ja][/ja]
	   */
	  checked: PropTypes.bool,
	
	  /**
	   * @name inputId
	   * @type string
	   * @description
	   *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using <label for="..."> elements.[/en]
	   *  [ja][/ja]
	   */
	  inputId: PropTypes.string
	};
	
	/**
	 * @original ons-col
	 * @category grid
	 * @description
	 * [en]
	 * Represents a column in the grid system. Use with `<ons-row>` to layout components.
	 * [/en]
	 * [ja][/ja]
	 * <Row>
	 *   <Col width={50}>
	  *   <ons-icon icon="fa-twitter"></ons-icon>
	 *   </Col>
	 *   <Col>Text</Col>
	 * </Row>
	 */
	
	var Col = function (_SimpleWrapper) {
	  inherits(Col, _SimpleWrapper);
	
	  function Col() {
	    classCallCheck(this, Col);
	    return possibleConstructorReturn(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
	  }
	
	  createClass(Col, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-col';
	    }
	  }]);
	  return Col;
	}(SimpleWrapper);
	
	Col.propTypes = {
	
	  /**
	  * @name verticalAlign
	  * @type {String}
	  * @description
	  *   [en]Short hand attribute for aligning vertically. Valid values are top, bottom, and center.[/en]
	  *   [ja][/ja]
	  */
	  verticalAlign: PropTypes.oneOf(['top', 'bottom', 'center']),
	
	  /**
	  * @name width
	  * @type {String}
	  * @description
	  *   [en]The width of the column. Valid values are css width values ("10%", 50).[/en]
	  *   [ja][/ja]
	  */
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	};
	
	/**
	 * @original ons-dialog
	 * @category dialog
	 * @tutorial react/Reference/dialog
	 * @description
	 * [en]  Dialog that is displayed on top of current screen. As opposed to the AlertDialog element, this component can contain any kind of content.  The dialog is useful for displaying menus, additional information or to ask the user to make a decision.  It will automatically be displayed as Material Design when running on an Android device.
	 [/en]
	 * [ja][/ja]
	 * @example
	   <Dialog onCancel={this.onCancel}
	     isOpen={this.props.isOpen}
	     style={{height: 250}}  cancelable>
	     <Page>
	       Page Content
	     </Page>
	    </Dialog>
	
	 */
	
	var Dialog = function (_BaseDialog) {
	  inherits(Dialog, _BaseDialog);
	
	  function Dialog() {
	    classCallCheck(this, Dialog);
	    return possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));
	  }
	
	  createClass(Dialog, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-dialog';
	    }
	  }]);
	  return Dialog;
	}(BaseDialog);
	
	Dialog.propTypes = {
	  /**
	   * @name onCancel
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called only if isCancelable is true. It will be called after tapping the background or by pressing the back button on Android devices.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onCancel: PropTypes.func,
	
	  /**
	   * @name isOpen
	   * @type bool
	   * @required true
	   * @description
	   *  [en]
	   *  Indicates whether the dialog is open and shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool.isRequired,
	
	  /**
	   * @name isCancelable
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is cancelable or not.
	   *  A cancelable dialog will call onCancel  when tapping the background or or  pressing the back button on Android devices
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isCancelable: PropTypes.bool,
	
	  /**
	   * @name isDisabled
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isDisabled: PropTypes.bool,
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]
	   *  The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name maskColor
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the background mask. Default is "rgba(0, 0, 0, 0.2)"[/en]
	   *  [ja][/ja]
	   */
	  maskColor: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-fab
	 * @category form
	 * @tutorial react/Reference/fab
	 * @description
	 * [en] The Floating action button is a circular button defined in the [Material Design specification](https://www.google.com/design/spec/components/buttons-floating-action-button.html). They are often used to promote the primary action of the app.
	 *     It can be displayed either as an inline element or in one of the corners. Normally it will be positioned in the lower right corner of the screen.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <SpeedDial disabled={false} direction='right' onClick={() => console.log('test1')} position='left bottom'>
	     <Fab>
	       <Icon icon='fa-twitter' size={26} fixedWidth={false} style={{verticalAlign: 'middle'}} />
	     </Fab>
	     <SpeedDialItem onClick={() => console.log('speed A')}> A </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed B')}> B </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed C')}> C </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed D')}> D </SpeedDialItem>
	   </SpeedDial>
	  */
	
	var Fab = function (_SimpleWrapper) {
	  inherits(Fab, _SimpleWrapper);
	
	  function Fab() {
	    classCallCheck(this, Fab);
	    return possibleConstructorReturn(this, (Fab.__proto__ || Object.getPrototypeOf(Fab)).apply(this, arguments));
	  }
	
	  createClass(Fab, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-fab';
	    }
	  }]);
	  return Fab;
	}(SimpleWrapper);
	
	Fab.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name ripple
	   * @type bool
	   * @description
	   *  [en]If true,  the button will have a ripple effect when tapped.[/en]
	   *  [ja][/ja]
	   */
	  ripple: PropTypes.bool,
	
	  /**
	   * @name position
	   * @type string
	   * @required false
	   * @description
	   *  [en]The position of the button. Should be a string like `"bottom right"` or `"top left"`. If this attribute is not defined it will be displayed as an inline element.[/en]
	   *  [ja][/ja]
	   */
	  position: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en] If true, the button will be disabled. [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en] This function will be called ones the button is clicked. [/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-icon
	 * @category visual
	 * @tutorial react/Reference/icon
	 * @description
	 * [en]
	 * Displays an icon. The following icon suites are available:
	 *   *  [Font Awesome](https://fortawesome.github.io/Font-Awesome/)
	 *   *  [Ionicons](http://ionicons.com/)
	 *   *  [Material Design Iconic Font](http://zavoloklom.github.io/material-design-iconic-font/)
	 * [/en]
	 * [ja][/ja]
	 * @example
	  <Icon
	    size={{default: 32, material: 40}}
	    icon={{default: 'ion-navicon', material: 'md-menu'}}
	  />
	*/
	
	var Icon = function (_SimpleWrapper) {
	  inherits(Icon, _SimpleWrapper);
	
	  function Icon() {
	    classCallCheck(this, Icon);
	    return possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  createClass(Icon, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-icon';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          size = _props.size,
	          others = objectWithoutProperties(_props, ['icon', 'size']);
	
	      var attrs = Util.getAttrs(this, others);
	
	      if (icon) {
	        if (typeof icon === 'string') {
	          attrs.icon = icon;
	        } else {
	          var keys = Object.keys(icon).filter(function (a) {
	            return a !== 'default';
	          });
	          var innerString = keys.map(function (key) {
	            return key + ':' + icon[key] + '';
	          });
	          attrs.icon = icon.default + ', ' + innerString.join(',');
	        }
	      }
	
	      if (size) {
	        if (typeof size === 'number') {
	          attrs.size = size + 'px';
	        } else {
	          var _keys = Object.keys(size).filter(function (a) {
	            return a !== 'default';
	          });
	          var _innerString = _keys.map(function (key) {
	            return key + ':' + size[key] + 'px';
	          });
	          attrs.size = size.default + 'px, ' + _innerString.join(',');
	        }
	      }
	
	      return React.createElement(this._getDomNodeName(), attrs, this.props.children);
	    }
	  }]);
	  return Icon;
	}(SimpleWrapper);
	
	Icon.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the icon.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name icon
	   * @type 'object or string'
	   * @description
	   *  [en] can be either a string or an object. If it is an string, it is set to an specific icon like 'ions-navicon'. If it is an object, it represents a dictionary of the icons depending on the modifier e.g.   `{{default: 'ion-navicon', material: 'md-menu'}}` [/en]
	   *  [ja][/ja]
	   */
	  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]),
	
	  /**
	   * @name size
	   * @type 'object or number'
	   * @description
	   *  [en] can be either a number or an object. If it is an number, it  specifies the icon size with a number in pixels. If it is an object, it represents a dictionary of the icon sizes depending on the modifier e.g.   `{{default: 20, material: 18}}` [/en]
	   *  [ja][/ja]
	   */
	  size: PropTypes.oneOfType([PropTypes.number, PropTypes.objectOf(PropTypes.number)]),
	
	  /**
	   * @name rotate
	   * @type number
	   * @description
	   *  [en] Number of degrees to rotate the icon. Valid values are 90, 180 and 270. [/en]
	   *  [ja][/ja]
	   */
	  rotate: PropTypes.oneOf([0, 90, 180, 270]),
	
	  /**
	   * @name fixedWidth
	   * @type bool
	   * @description
	   * [en] When used in a list, you want the icons to have the same width so that they align vertically by defining this attribute. [/en]
	   *  [ja][/ja]
	   */
	  fixedWidth: PropTypes.bool,
	
	  /**
	   * @name spin
	   * @type bool
	   * @description
	   * [en] Specify whether the icon should be spinning. [/en]
	   *  [ja][/ja]
	   */
	  spin: PropTypes.bool
	
	};
	
	/**
	 * @original ons-input
	 * @category form
	 * @tutorial react/Reference/input
	 * @description
	 * [en]
	 * An input element. The `type` attribute can be used to change the input type. All text input types as well as `checkbox` and `radio` are supported. The component will automatically render as a Material Design input on Android devices. Most attributes that can be used for a normal `<input>` element can also be used on the `<ons-input>` element..
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <Input
	 *   value={this.state.text} float
	 *   onChange={(event) => { this.setState({text: event.target.value})} }
	 *   modifier='material'
	 *   placeholder='Username' />
	 */
	
	var Input = function (_BaseInput) {
	  inherits(Input, _BaseInput);
	
	  function Input() {
	    classCallCheck(this, Input);
	    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	  }
	
	  createClass(Input, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-input';
	    }
	  }]);
	  return Input;
	}(BaseInput);
	
	Input.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the input.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]Specifies whether the input is disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en]Called when the text of the input changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type string
	   * @description
	   *  [en]Content of the input.[/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	
	  /**
	   * @name placehoder
	   * @type string
	   * @description
	   *  [en] Placeholder text. In Material Design this placeholder will be a floating label. [/en]
	   *  [ja][/ja]
	   */
	  placeholder: PropTypes.string,
	
	  /**
	   * @name type
	   * @type string
	   * @description
	   *  [en]
	   *    Specify the input type. This is the same as the "type" attribute for normal inputs. It expects strict text types such as `text`, `password`, etc. For checkbox, radio button, select or range, please have a look at the corresponding components.
	   *
	   *    Please take a look at [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-type) for an exhaustive list of possible values. Depending on the platform and browser version some of these might not work.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  type: PropTypes.string,
	
	  /**
	   * @name inputId
	   * @type string
	   * @description
	   *  [en]  Specify the "id" attribute of the inner `<input>` element. This is useful when using <label for="..."> elements [/en]
	   *  [ja][/ja]
	   */
	  inputId: PropTypes.string,
	
	  /**
	   * @name float
	   * @type bool
	   * @description
	   *  [en]  If this attribute is present, the placeholder will be animated in Material Design.  [/en]
	   *  [ja][/ja]
	   */
	  float: PropTypes.bool
	};
	
	/**
	 * @original ons-lazy-repeat
	 * @category list
	 * @tutorial react/Reference/lazy-list
	 * @description
	 * [en] Using this component a list with millions of items can be rendered without a drop in performance.
	 *     It does that by "lazily" loading elements into the DOM when they come into view and
	 *     removing items from the DOM when they are not visible.
	 [/en]
	 * [ja][/ja]
	 * @example
	 *
	  renderRow(index) {
	    return (
	      <ListItem key={index}>
	        {'Item ' + (index + 1)}
	      </ListItem>
	    );
	  }
	
	  render() {
	    return (
	      <Page renderToolbar={() => <MyToolbar title='LazyList' />} >
	        <div style={{height: 100}}>
	          <LazyList
	            length={1000}
	            renderRow={() =>
	              <ListItem key={index}>
	                {'Item ' + (index + 1)}
	              </ListItem>
	            }
	            calculateItemHeight={() => 44}
	          />
	        </div>
	      </Page>
	    );
	  }
	}
	 */
	
	var LazyList = function (_BasicComponent) {
	  inherits(LazyList, _BasicComponent);
	
	  function LazyList() {
	    var _ref;
	
	    classCallCheck(this, LazyList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = LazyList.__proto__ || Object.getPrototypeOf(LazyList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { children: [] };
	    _this.update = _this.update.bind(_this);
	    return _this;
	  }
	
	  createClass(LazyList, [{
	    key: 'update',
	    value: function update(props) {
	      var self = this;
	
	      this._lazyRepeat.delegate = {
	        calculateItemHeight: function calculateItemHeight(index) {
	          return props.calculateItemHeight(index);
	        },
	        // _render: function(items, newHeight) {
	        _render: function _render(start, limit, updateTop) {
	          var createElement = function createElement(index) {
	            return props.renderRow(index);
	          };
	
	          var el = [];
	          for (var i = start; i < limit; i++) {
	            el.push(createElement(i));
	          }
	
	          self.setState({ children: el }, updateTop);
	        },
	        countItems: function countItems() {
	          return props.length;
	        }
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var helpProps = _extends({}, this.props, newProps);
	      this.update(helpProps);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(LazyList.prototype.__proto__ || Object.getPrototypeOf(LazyList.prototype), 'componentDidMount', this).call(this);
	      this.update(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(
	        'ons-list',
	        _extends({}, this.props, { ref: function ref(list) {
	            _this2._list = list;
	          },
	          'class': 'list', style: { position: 'relative', height: this.state.height }
	        }),
	        React.createElement('ons-lazy-repeat', { ref: function ref(lazyRepeat) {
	            _this2._lazyRepeat = lazyRepeat;
	          } }),
	        this.state.children
	      );
	    }
	  }]);
	  return LazyList;
	}(BasicComponent);
	
	LazyList.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the lazy list.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name length
	   * @type number
	   * @description
	   *  [en]The length of the list.[/en]
	   *  [ja][/ja]
	   */
	  length: PropTypes.number.isRequired,
	
	  /**
	   * @name renderRow
	   * @type function
	   * @description
	   *  [en] A function given the index of the to display row, renders it.[/en]
	   *  [ja][/ja]
	   */
	  renderRow: PropTypes.func.isRequired,
	
	  /**
	   * @name calculateItemHeight
	   * @type function
	   * @description
	   *  [en] A function given the index of the to row, returns the height of it.[/en]
	   *  [ja][/ja]
	   */
	  calculateItemHeight: PropTypes.func.isRequired
	};
	
	/**
	 * @original ons-list
	 * @category list
	 * @tutorial react/Reference/list
	 * @description
	 *   [en]
	 *     Component for representing a list. It takes an array called datasource and calls renderRow(row, index) for every row.  Furthermore, the header and the footer can be specified with `renderRow` and `renderHeader` respectivly. [/en]
	 * [ja][/ja]
	 * @example
	  <List
	    dataSource={['Row 1', 'Row 2']}
	    renderHeader={this.renderHeader}
	    renderRow={(row, idx) => (
	      <ListItem modifier={idx === this.state.data.length - 1 ? 'longdivider' : null}>
	      {row}
	  <Button modifier="quiet" onClick={this.remove.bind(this, idx)}>Remove</Button>
	  </ListItem>
	  )}
	  renderFooter={this.renderFooter}
	  />
	 */
	
	var List = function (_BasicComponent) {
	  inherits(List, _BasicComponent);
	
	  function List() {
	    classCallCheck(this, List);
	    return possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	  }
	
	  createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attrs = Util.getAttrs(this);
	      var pages = this.props.dataSource.map(function (data, idx) {
	        return _this2.props.renderRow(data, idx);
	      });
	
	      return React.createElement(
	        'ons-list',
	        _extends({}, attrs, { ref: function ref(list) {
	            _this2._list = list;
	          } }),
	        this.props.renderHeader(),
	        pages,
	        this.props.children,
	        this.props.renderFooter()
	      );
	    }
	  }]);
	  return List;
	}(BasicComponent);
	
	List.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name dataSource
	   * @type string
	   * @description
	   *  [en]
	   *    Source of the list data. Should be an array.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  dataSource: PropTypes.array,
	
	  /**
	   * @name renderRow
	   * @type function
	   * @description
	   *  [en]
	   *  Function to specify the rendering function for every element in
	   *  in the dataSource.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  renderRow: PropTypes.func,
	
	  /**
	   * @name renderHeader
	   * @type function
	   * @description
	   *  [en]
	   *  Function to specify the rendering function for the header
	   *  [/en]
	   *  [ja][/ja]
	   */
	  renderHeader: PropTypes.func,
	
	  /**
	   * @name renderFooter
	   * @type function
	   * @description
	   *  [en]
	   *  Function to specify the rendering function for the footer
	   *  [/en]
	   *  [ja][/ja]
	   */
	  renderFooter: PropTypes.func
	};
	
	List.defaultProps = {
	  dataSource: [],
	  renderRow: function renderRow() {
	    return null;
	  },
	  renderHeader: function renderHeader() {
	    return null;
	  },
	  renderFooter: function renderFooter() {
	    return null;
	  }
	};
	
	/**
	 * @original ons-list-header
	 * @category list
	 * @tutorial react/Reference/list
	 * @description
	 * [en] Header element for list items. Must be put inside ons-list component.
	 [/en]
	 * [ja][/ja]
	 * @example
	   <List
	     dataSource={this.state.data}
	     renderHeader={() =>
	        <ListHeader style={{fontSize: 15}} className="testClass"> Header Text </ListHeader> }
	    renderRow={(row, idx) => (
	      <ListItem > {row} </ListItem>
	    )}
	  />
	 */
	
	var ListHeader = function (_SimpleWrapper) {
	  inherits(ListHeader, _SimpleWrapper);
	
	  function ListHeader() {
	    classCallCheck(this, ListHeader);
	    return possibleConstructorReturn(this, (ListHeader.__proto__ || Object.getPrototypeOf(ListHeader)).apply(this, arguments));
	  }
	
	  createClass(ListHeader, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-list-header';
	    }
	  }]);
	  return ListHeader;
	}(SimpleWrapper);
	
	ListHeader.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	/**
	 * @original ons-list-item
	 * @category list
	 * @tutorial react/Reference/list
	 * @description
	 *   [en]
	 *   Component that represents each item in the list. Must be put inside the `List` component. The list item is composed of three parts that are represented with the `left`, `center` and `right` classes. These classes can be used to ensure that the content of the list items is properly aligned.
	 *   [/en]
	 * [ja][/ja]
	 * @example
	   <ListItem>
	 *   <div className="left">Left</div>
	 *   <div className="center">Center</div>
	 *   <div className="right">Right</div>
	 * </ListItem>
	 */
	
	var ListItem = function (_SimpleWrapper) {
	  inherits(ListItem, _SimpleWrapper);
	
	  function ListItem() {
	    classCallCheck(this, ListItem);
	    return possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  createClass(ListItem, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-list-item';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'componentDidMount', this).call(this);
	      this.node = ReactDOM__default.findDOMNode(this);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'componentDidUpdate', this).call(this);
	      this.node._compile();
	    }
	  }]);
	  return ListItem;
	}(SimpleWrapper);
	
	ListItem.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en] The appearance of the list item.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name tappable
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the list item is tappable.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  tappable: PropTypes.bool,
	
	  /**
	   * @name tapBackgroundColor
	   * @type string
	   * @description
	   *  [en]
	   *  Changes the background color when tapped. For this to work, the attribute "tappable" needs to be set. The default color is "#d9d9d9". It will display as a ripple effect on Android.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  tapBackgroundColor: PropTypes.string,
	
	  /**
	   * @name lockOnDrag
	   * @type bool
	   * @description
	   *  [en] Prevent vertical scrolling when the user drags horizontally. [/en]
	   *  [ja][/ja]
	   */
	  lockOnDrag: PropTypes.bool
	};
	
	/**
	 * @original ons-list-title
	 * @category list
	 * @tutorial react/Reference/list
	 * @description
	 * [en] Title element for lists. Usually comes before ons-list component.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <ListTitle>List Title</ListTitle>
	   <List
	     dataSource={this.state.data}
	     renderHeader={() =>
	        <ListHeader style={{fontSize: 15}} className="testClass"> Header Text </ListHeader> }
	    renderRow={(row, idx) => (
	      <ListItem > {row} </ListItem>
	    )}
	  />
	 */
	
	var ListTitle = function (_SimpleWrapper) {
	  inherits(ListTitle, _SimpleWrapper);
	
	  function ListTitle() {
	    classCallCheck(this, ListTitle);
	    return possibleConstructorReturn(this, (ListTitle.__proto__ || Object.getPrototypeOf(ListTitle)).apply(this, arguments));
	  }
	
	  createClass(ListTitle, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-list-title';
	    }
	  }]);
	  return ListTitle;
	}(SimpleWrapper);
	
	ListTitle.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	/**
	 * @original ons-navigator
	 * @category navigation
	 * @tutorial react/Reference/navigator
	 * @description
	 * [en] This component is responsible for page transitioning and managing the pages of your OnsenUI application. In order to manage to display the pages, the  navigator needs to define the `renderPage` method, that takes an route and a navigator and  converts it to an page.  [/en]
	 * [ja][/ja]
	 * @example
	  <Navigator
	    renderPage={(route, navigator) =>
	     <MyPage
	       title={route.title}
	       onPop={() => navigator.popPage()}
	       />
	    }
	    initialRoute={{
	        title: 'First Page'
	    }} />
	   }
	 }
	 */
	
	var Navigator = function (_BasicComponent) {
	  inherits(Navigator, _BasicComponent);
	
	  function Navigator() {
	    var _ref;
	
	    classCallCheck(this, Navigator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = Navigator.__proto__ || Object.getPrototypeOf(Navigator)).call.apply(_ref, [this].concat(args)));
	
	    _this.pages = [];
	    _this.state = {};
	    _this._prePush = _this._prePush.bind(_this);
	    _this._postPush = _this._postPush.bind(_this);
	    _this._prePop = _this._prePop.bind(_this);
	    _this._postPop = _this._postPop.bind(_this);
	    return _this;
	  }
	
	  createClass(Navigator, [{
	    key: 'update',
	    value: function update(pages, obj) {
	      var _this2 = this;
	
	      this.pages = pages || [];
	      return new Promise(function (resolve) {
	        _this2.forceUpdate(resolve);
	      });
	    }
	
	    /**
	     * @method resetPage
	     * @signature resetPage(route, options = {})
	     * @param {Object} route
	     *   [en] The route that the page should be reset to.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Resets the current page[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'resetPage',
	    value: function resetPage(route) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.resetPageStack([route], options);
	    }
	
	    /**
	     * @method resetPageStack
	     * @signature resetPageStack(route, options = {})
	     * @param {Array} routes
	     *   [en] The routes that the navigator should be reset to.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Resets the navigator to the current page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'resetPageStack',
	    value: function resetPageStack(routes) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return Promise.reject('Navigator is already running animation.');
	      }
	
	      var hidePages = function hidePages() {
	        var pageElements = _this3._navi.pages;
	        for (var i = pageElements.length - 2; i >= 0; i--) {
	          pageElements[i].style.display = 'none';
	        }
	      };
	
	      if (options.pop) {
	        this.routesBeforePop = this.routes.slice();
	        this.routesAfterPop = routes;
	        this.routes = routes.concat([this.routes[this.routes.length - 1]]);
	
	        var _update = function _update() {
	          _this3.pages.pop();
	          _this3.routes = routes;
	          return new Promise(function (resolve) {
	            return _this3.forceUpdate(resolve);
	          });
	        };
	
	        return this.update(this.pages).then(function () {
	          return _this3._navi._popPage(options, _update);
	        }).then(function () {
	          return hidePages();
	        });
	      }
	
	      var lastRoute = routes[routes.length - 1];
	      var newPage = this.props.renderPage(lastRoute, this);
	      this.routes.push(lastRoute);
	
	      var update = function update() {
	        _this3.pages.push(newPage);
	        return new Promise(function (resolve) {
	          return _this3.forceUpdate(resolve);
	        });
	      };
	
	      return this._navi._pushPage(options, update).then(function () {
	        _this3.routes = routes;
	        _this3.pages = routes.map(function (route) {
	          return _this3.props.renderPage(route, _this3);
	        });
	        return _this3.update(_this3.pages).then(function () {
	          return hidePages();
	        });
	      });
	    }
	
	    /**
	     * @method pushPage
	     * @signature pushPage(route, options = {})
	     * @param {Object} route
	     *   [en] The route that the navigator should push to.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en] Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Pushes a page to the page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'pushPage',
	    value: function pushPage(route) {
	      var _this4 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return Promise.reject('Navigator is already running animation.');
	      }
	
	      return new Promise(function (resolve) {
	        var update = function update() {
	          return new Promise(function (resolve) {
	            _this4.pages.push(_this4.props.renderPage(route, _this4));
	            _this4.forceUpdate(resolve);
	          });
	        };
	
	        _this4.routes.push(route);
	        _this4._navi._pushPage(options, update).then(resolve).catch(function (error) {
	          _this4.routes.pop();
	          _this4.pages.pop();
	          throw error;
	        });
	      });
	    }
	  }, {
	    key: 'isRunning',
	    value: function isRunning() {
	      return this._navi._isRunning;
	    }
	
	    /*
	     * @method replacePage
	     * @signature replacePage(route, [options])
	     * @param {Object} route
	     *   [en] The route that the navigator should replace the top page with.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the new page.[/en]
	     *   [ja]新しいページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Replaces the current top page with the specified one. Extends `pushPage()` parameters.[/en]
	     *   [ja]現在表示中のページをを指定したページに置き換えます。[/ja]
	     */
	
	  }, {
	    key: 'replacePage',
	    value: function replacePage(route) {
	      var _this5 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return Promise.reject('Navigator is already running animation.');
	      }
	
	      return this.pushPage(route, options).then(function () {
	        var pos = _this5.pages.length - 2;
	        _this5.pages.splice(pos, 1);
	        _this5.routes.splice(pos, 1);
	        _this5._navi.topPage.updateBackButton(_this5.pages.length > 1);
	        _this5.forceUpdate();
	      });
	    }
	
	    /**
	     * @method popPage
	     * @signature popPage(options = {})
	     * @return {Promise}
	     *   [en] Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Pops a page out of the page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'popPage',
	    value: function popPage() {
	      var _this6 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (this.isRunning()) {
	        return Promise.reject('Navigator is already running animation.');
	      }
	
	      this.routesBeforePop = this.routes.slice();
	      this.routesAfterPop = this.routesBeforePop.slice(0, this.routesBeforePop.length - 1);
	
	      var update = function update() {
	        return new Promise(function (resolve) {
	          _this6.pages.pop();
	          _this6.routes.pop();
	
	          _this6.forceUpdate(resolve);
	        });
	      };
	
	      return this._navi._popPage(options, update);
	    }
	  }, {
	    key: '_onDeviceBackButton',
	    value: function _onDeviceBackButton(event) {
	      if (this.pages.length > 1) {
	        this.popPage();
	      } else {
	        event.callParentHandler();
	      }
	    }
	  }, {
	    key: '_prePop',
	    value: function _prePop(event) {
	      if (event.target !== this._navi) {
	        return;
	      }
	
	      event.routes = {
	        poppingRoute: this.routesBeforePop[this.routesBeforePop.length - 1],
	        routes: this.routesBeforePop
	      };
	
	      this.props.onPrePop(event);
	    }
	  }, {
	    key: '_postPop',
	    value: function _postPop(event) {
	      if (event.target !== this._navi) {
	        return;
	      }
	
	      event.routes = {
	        poppedRoute: this.routesBeforePop[this.routesBeforePop.length - 1],
	        routes: this.routesAfterPop
	      };
	
	      this.props.onPostPop(event);
	    }
	  }, {
	    key: '_prePush',
	    value: function _prePush(event) {
	      if (event.target !== this._navi) {
	        return;
	      }
	
	      event.routes = {
	        pushingRoute: this.routes[this.routes.length - 1],
	        routes: this.routes.slice(0, this.routes.length - 1)
	      };
	
	      this.props.onPrePush(event);
	    }
	  }, {
	    key: '_postPush',
	    value: function _postPush(event) {
	      if (event.target !== this._navi) {
	        return;
	      }
	
	      event.routes = {
	        pushedRoute: this.routes[this.routes.length - 1],
	        routes: this.routes
	      };
	
	      this.props.onPostPush(event);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this7 = this;
	
	      var node = this._navi;
	      node.popPage = this.popPage.bind(this);
	
	      node.addEventListener('prepush', this._prePush);
	      node.addEventListener('postpush', this._postPush);
	      node.addEventListener('prepop', this._prePop);
	      node.addEventListener('postpop', this._postPop);
	
	      node.swipeMax = this.props.swipePop;
	      node.onDeviceBackButton = this.props.onDeviceBackButton || this._onDeviceBackButton.bind(this);
	
	      if (this.props.initialRoute && this.props.initialRouteStack) {
	        throw new Error('In Navigator either initalRoute or initalRoutes can be set');
	      }
	
	      if (this.props.initialRoute) {
	        this.routes = [this.props.initialRoute];
	      } else if (this.props.initialRouteStack) {
	        this.routes = this.props.initialRouteStack;
	      } else {
	        this.routes = [];
	      }
	
	      this.pages = this.routes.map(function (route) {
	        return _this7.props.renderPage(route, _this7);
	      });
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.onDeviceBackButton !== undefined) {
	        this._navi.onDeviceBackButton = newProps.onDeviceBackButton;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = this._navi;
	      node.removeEventListener('prepush', this.props.onPrePush);
	      node.removeEventListener('postpush', this.props.onPostPush);
	      node.removeEventListener('prepop', this.props.onPrePop);
	      node.removeEventListener('postpop', this.props.onPostPop);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var attrs = Util.getAttrs(this);
	      var pages = this.routes ? this.routes.map(function (route) {
	        return _this8.props.renderPage(route, _this8);
	      }) : null;
	
	      return React.createElement(
	        'ons-navigator',
	        _extends({}, attrs, { ref: function ref(navi) {
	            _this8._navi = navi;
	          } }),
	        pages
	      );
	    }
	  }]);
	  return Navigator;
	}(BasicComponent);
	
	Navigator.propTypes = {
	  /**
	   * @name renderPage
	   * @type function
	   * @required true
	   * @defaultValue null
	   * @description
	   *  [en] This function takes the current route object as a parameter and returns a React component.[/en]
	   *  [ja][/ja]
	   */
	  renderPage: PropTypes.func.isRequired,
	  /**
	   * @name initialRouteStack
	   * @type array
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This array contains the initial routes from the Navigator,
	   *  which will be used to render the initial pages in the `renderPage` method.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  initialRouteStack: PropTypes.array,
	
	  /**
	   * @name initialRoute
	   * @type object
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This array contains the initial route of the navigator,
	   *  which will be used to render the initial pages in the
	   *  renderPage method.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  initialRoute: PropTypes.object,
	
	  /**
	   * @name onPrePush
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before a page is pushed. It gets an event object with route information.[/en]
	   *  [ja][/ja]
	   */
	  onPrePush: PropTypes.func,
	
	  /**
	   * @name onPostPush
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after a page is pushed. It gets an event object with route information.[/en]
	   *  [ja][/ja]
	   */
	  onPostPush: PropTypes.func,
	
	  /**
	   * @name onPrePop
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before a page is popped. It gets an event object with route information.[/en]
	   */
	  onPrePop: PropTypes.func,
	
	  /**
	   * @name onPostPop
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after a page is popped. It gets an event object with route information.[/en]
	   *  [ja][/ja]
	   */
	  onPostPop: PropTypes.func,
	
	  /**
	   * @name animation
	   * @type {String}
	   * @description
	   *   [en]
	   *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	   *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"`.
	   *   [/en]
	   *   [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name swipeable
	   * @type bool|string
	   * @required false
	   * @description
	   *  [en]Enables swipe-to-pop functionality for iOS.[/en]
	   *  [ja][/ja]
	   */
	  swipeable: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	
	  /**
	   * @name swipePop
	   * @type function
	   * @required false
	   * @description
	   *  [en]Optional function called on swipe-to-pop. If provided, must perform a popPage with the given options object.[/en]
	   *  [ja][/ja]
	   */
	  swipePop: PropTypes.func,
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]Custom handler for device back button.[/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	var NOOP = function NOOP() {
	  return null;
	};
	
	Navigator.defaultProps = {
	  onPostPush: NOOP,
	  onPrePush: NOOP,
	  onPrePop: NOOP,
	  onPostPop: NOOP
	};
	
	/**
	 * @original ons-modal
	 * @category dialog
	 * @tutorial react/Reference/modal
	 * @description
	 * [en]
	 *   A modal component covers the entire screen. Underlying components are not
	 *   subject to any events while the modal component is shown.
	 *
	 *   This component can be used to block user input while some operation is
	 *   running or to show some information to the user.
	 * [/en]
	 * [ja]
	 *   画面全体をマスクするモーダル用コンポーネントです。下側にあるコンポーネントは、
	 *   モーダルが表示されている間はイベント通知が行われません
	 * [/ja]
	 * @example
	  <Page>
	    <div> Page content </div>
	
	    <Modal isOpen={this.state.isLoading}>
	      Loading ...
	    </Modal>
	  </Page>
	 */
	
	var Modal = function (_BaseDialog) {
	  inherits(Modal, _BaseDialog);
	
	  function Modal() {
	    classCallCheck(this, Modal);
	    return possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	  }
	
	  createClass(Modal, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-modal';
	    }
	  }]);
	  return Modal;
	}(BaseDialog);
	
	Modal.propTypes = {
	  /**
	   * @name animation
	   * @type {String}
	   * @description
	   *   [en]
	   *     Animation name. Available animations are `"fade"`, `"lift"` and `"none"`.
	   *   [/en]
	   */
	  animation: PropTypes.oneOf(['none', 'fade', 'lift']),
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the modal is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the modal is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the modal is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the modal is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name isOpen
	   * @type boolean
	   * @description
	   *  [en]When `true` the modal will show itself.[/en]
	   */
	  isOpen: PropTypes.bool,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	Modal.defaultProps = {
	  isOpen: false,
	  animation: 'none'
	};
	
	/**
	 * @original ons-page
	 * @category page
	 * @tutorial react/Reference/page
	 * @description
	 * [en]
	 *   This component is handling the entire page. The content can be scrolled.
	 *
	 *   To add fixed content that doesn't scroll with the page the `renderFixed` prop is used.
	 *
	 *   A page toolbar can be added with the `renderToolbar` prop.
	 * [/en]
	 * [ja][/ja]
	 * @example
	  <Page
	    renderFixed={() => <Fab></Fab>}
	    renderToolbar={() => <Toolbar>...</Toolbar>}
	    contentStyle={{padding: 40}}>
	    <div> Page content </div>
	  </Page>
	 */
	
	var Page = function (_BasicComponent) {
	  inherits(Page, _BasicComponent);
	
	  function Page() {
	    var _ref;
	
	    classCallCheck(this, Page);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = Page.__proto__ || Object.getPrototypeOf(Page)).call.apply(_ref, [this].concat(args)));
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onInit = callback.bind(_this, 'onInit');
	    _this.onShow = callback.bind(_this, 'onShow');
	    _this.onHide = callback.bind(_this, 'onHide');
	    return _this;
	  }
	
	  createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM__default.findDOMNode(this);
	      node.addEventListener('init', this.onInit);
	      node.addEventListener('show', this.onShow);
	      node.addEventListener('hide', this.onHide);
	
	      if (this.props.onDeviceBackButton instanceof Function) {
	        node.onDeviceBackButton = this.props.onDeviceBackButton;
	      }
	      if (this.props.onInfiniteScroll instanceof Function) {
	        node.onInfiniteScroll = this.props.onInfiniteScroll;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.onDeviceBackButton !== undefined) {
	        ReactDOM__default.findDOMNode(this).onDeviceBackButton = newProps.onDeviceBackButton;
	      }
	      if (newProps.onInfiniteScroll !== undefined) {
	        ReactDOM__default.findDOMNode(this).onInfiniteScroll = newProps.onInfiniteScroll;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = ReactDOM__default.findDOMNode(this);
	      node.removeEventListener('init', this.onInit);
	      node.removeEventListener('show', this.onShow);
	      node.removeEventListener('hide', this.onHide);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var toolbar = this.props.renderToolbar(this);
	      var bottomToolbar = this.props.renderBottomToolbar(this);
	      var modal = this.props.renderModal(this);
	      var fixed = this.props.renderFixed(this);
	
	      var _props = this.props,
	          contentStyle = _props.contentStyle,
	          other = objectWithoutProperties(_props, ['contentStyle']);
	
	      var attrs = Util.getAttrs(this, other);
	
	      return React.createElement(
	        'ons-page',
	        attrs,
	        toolbar,
	        React.createElement(
	          'div',
	          { className: 'page__background' },
	          ' '
	        ),
	        React.createElement(
	          'div',
	          { className: 'page__content', style: contentStyle },
	          this.props.children
	        ),
	        React.createElement(
	          'div',
	          { className: 'page__extra', style: { zIndex: 10001 } },
	          modal
	        ),
	        fixed,
	        bottomToolbar
	      );
	    }
	  }]);
	  return Page;
	}(BasicComponent);
	
	Page.propTypes = {
	
	  /**
	   * @name contentStyle
	   * @type Object
	   * @description
	   *  [en]
	   *  Specify the style of the page content. Optional.
	   *  [/en]
	   */
	  contentStyle: PropTypes.object,
	
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name renderModal
	   * @type function
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This function renders a modal that masks current screen.[/en]
	   */
	  renderModal: PropTypes.func,
	
	  /**
	   * @name renderToolbar
	   * @type function
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This function renders the toolbar of the page.[/en]
	   *  [ja][/ja]
	   */
	  renderToolbar: PropTypes.func,
	
	  /**
	   * @name renderBottomToolbar
	   * @type function
	   * @defaultValue null
	   * @description
	   *  [en] This function renders the bottom toolbar of the page.[/en]
	   *  [ja][/ja]
	   */
	  renderBottomToolbar: PropTypes.func,
	
	  /**
	   * @name renderFixed
	   * @type function
	   * @defaultValue null
	   * @description
	   *  [en] This function renders fixed content of the page. Can be used to render `Fab` or `SpeedDial` components as well as other components that don't scroll with the page.[/en]
	   *  [ja][/ja]
	   */
	  renderFixed: PropTypes.func,
	
	  /**
	   * @name onInit
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  	Fired right after the page is attached.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onInit: PropTypes.func,
	
	  /**
	   * @name onShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called Fired right after the page is shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onShow: PropTypes.func,
	
	  /**
	   * @name onHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called after the page is hidden.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onHide: PropTypes.func,
	
	  /**
	   * @name onInfiniteScroll
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called when scrolling to the bottom of the page. It gets a 'done' callback (first argument) that must be called when it's finished.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onInfiniteScroll: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	var NOOP$1 = function NOOP() {
	  return null;
	};
	
	Page.defaultProps = {
	  renderToolbar: NOOP$1,
	  renderBottomToolbar: NOOP$1,
	  renderModal: NOOP$1,
	  renderFixed: NOOP$1
	};
	
	/**
	 * @original ons-popover
	 * @category dialog
	 * @tutorial react/Reference/popover
	 * @description
	 *   [en]
	 *     A component that displays a popover next to an element. The popover can be used to display extra information about a component or a tooltip.
	 *    Another common way to use the popover is to display a menu when a button on the screen is tapped.
	 *   [/en]
	 * [ja][/ja]
	 * @example
	 * <Page>
	 *  <Button
	 *    ref={(btn) => { this.btn = btn; }}
	 *    onClick={() =>
	 *      this.setState({target: this.btn, isOpen: true})
	 *    }
	 *  />
	    <Popover
	      isOpen={this.state.isOpen}
	      onCancel={() => this.setState({isOpen: false})}
	      getTarget={() => this.state.target}
	    >
	      <div style={{textAlign: 'center', opacity: 0.5}}>
	        <p>This is a popover!</p>
	          <p><small>Click the background to remove the popover.</small></p>
	        </div>
	        </Popover>
	 * </Page>
	 */
	
	var Popover = function (_BaseDialog) {
	  inherits(Popover, _BaseDialog);
	
	  function Popover() {
	    classCallCheck(this, Popover);
	    return possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
	  }
	
	  createClass(Popover, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-popover';
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var target = this.props.getTarget();
	      target = ReactDOM__default.findDOMNode(target);
	      return this.node.firstChild.show(target);
	    }
	  }]);
	  return Popover;
	}(BaseDialog);
	
	Popover.propTypes = {
	  /**
	   * @name getTarget
	   * @type function
	   * @required true
	   * @description
	   *  [en]
	   *  This function should return react component or a domnode that the popover is showing on.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  getTarget: PropTypes.func.isRequired,
	  /**
	   * @name onCancel
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called only if isCancelable is true. It will be called after tapping the background or by pressing the back button on Android devices.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onCancel: PropTypes.func,
	
	  /**
	   * @name isOpen
	   * @type bool
	   * @required true
	   * @description
	   *  [en]
	   *  Indicates whether the dialog is open and shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool.isRequired,
	
	  /**
	   * @name isCancelable
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is cancelable or not.
	   *  A cancelable dialog will call onCancel  when tapping the background or or  pressing the back button on Android devices
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isCancelable: PropTypes.bool,
	
	  /**
	   * @name isDisabled
	   * @type bool
	   * @required false
	   * @description
	   *  [en]
	   *  Specifies whether the dialog is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isDisabled: PropTypes.bool,
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]
	   *  The animation used when showing and hiding the dialog. Can be either `"none"` or `"default"`.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the dialog.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name maskColor
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the background mask. Default is "rgba(0, 0, 0, 0.2)"[/en]
	   *  [ja][/ja]
	   */
	  maskColor: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the alert dialog is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the alert dialog is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-progress-bar
	 * @category visual
	 * @tutorial react/Reference/progress
	 * @description
	 * [en] The component is used to display a linear progress bar. It can either display a progress bar that shows the user how much of a task has been completed. In the case where the percentage is not known it can be used to display an animated progress bar so the user can see that an operation is in progress.  [/en]
	 * [ja][/ja]
	 * @example
	 *<ProgressBar value={55} secondaryValue={87} />
	 *<ProgressBar indeterminate />
	 */
	
	var ProgressBar = function (_SimpleWrapper) {
	  inherits(ProgressBar, _SimpleWrapper);
	
	  function ProgressBar() {
	    classCallCheck(this, ProgressBar);
	    return possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
	  }
	
	  createClass(ProgressBar, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-progress-bar';
	    }
	  }]);
	  return ProgressBar;
	}(SimpleWrapper);
	
	ProgressBar.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the progress indicator.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name value
	   * @type number
	   * @description
	   *  [en]
	   *  Current progress. Should be a value between 0 and 100.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.number,
	
	  /**
	   * @name secondaryValue
	   * @type bool
	   * @description
	   *  [en]
	   *  Current secondary progress. Should be a value between 0 and 100.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  secondaryValue: PropTypes.number,
	
	  /**
	   * @name indeterminate
	   * @type bool
	   * @description
	   *  [en] If this property is set, an infinite looping animation will be shown. [/en]
	   *  [ja][/ja]
	   */
	  indeterminate: PropTypes.bool
	};
	
	/**
	 * @original ons-progress-circular
	 * @category visual
	 * @tutorial react/Reference/progress
	 * @description
	 * [en] This component displays a circular progress indicator. It can either be used to show how much of a task has been completed or to show a looping animation to indicate that an operation is currently running.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 *<ProgressCircular value={55} secondaryValue={87} />
	 *<ProgressCircular indeterminate />
	 */
	
	var ProgressCircular = function (_SimpleWrapper) {
	  inherits(ProgressCircular, _SimpleWrapper);
	
	  function ProgressCircular() {
	    classCallCheck(this, ProgressCircular);
	    return possibleConstructorReturn(this, (ProgressCircular.__proto__ || Object.getPrototypeOf(ProgressCircular)).apply(this, arguments));
	  }
	
	  createClass(ProgressCircular, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-progress-circular';
	    }
	  }]);
	  return ProgressCircular;
	}(SimpleWrapper);
	
	ProgressCircular.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the progress indicator.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name value
	   * @type number
	   * @description
	   *  [en]
	   *  Current progress. Should be a value between 0 and 100.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.number,
	
	  /**
	   * @name secondaryValue
	   * @type bool
	   * @description
	   *  [en]
	   *  Current secondary progress. Should be a value between 0 and 100.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  secondaryValue: PropTypes.number,
	
	  /**
	   * @name indeterminate
	   * @type bool
	   * @description
	   *  [en] If this property is set, an infinite looping animation will be shown. [/en]
	   *  [ja][/ja]
	   */
	  indeterminate: PropTypes.bool
	};
	
	/**
	 * @original ons-pull-hook
	 * @category control
	 * @tutorial react/Reference/pull-hook
	 * @description
	 * [en]  Component that adds **Pull to refresh** functionality to an `<ons-page>` element.
	 *     It can be used to perform a task when the user pulls down at the top of the page. A common usage is to refresh the data displayed in a page.
	 [/en]
	 * [ja][/ja]
	 * @example
	
	    return (
	      <PullHook onChange={this.onChange} onLoad={this.onLoad}>
	      {
	       (this.state.pullHookState === 'initial') ?
	        <span >
	          <Icon size={35} spin={false} icon='ion-arrow-down-a' />
	          Pull down to refresh
	        </span> :
	        (this.state.pullHookState === 'preaction') ?
	         <span>
	           <Icon size={35} spin={false} icon='ion-arrow-up-a' />
	           Release to refresh
	        </span>
	        :
	        <span><Icon size={35} spin={true} icon='ion-load-d'></Icon> Loading data...</span>
	    }
	      </PullHook>
	    );
	 */
	
	var PullHook = function (_BasicComponent) {
	  inherits(PullHook, _BasicComponent);
	
	  function PullHook() {
	    var _ref;
	
	    classCallCheck(this, PullHook);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = PullHook.__proto__ || Object.getPrototypeOf(PullHook)).call.apply(_ref, [this].concat(args)));
	
	    _this.onChange = function (event) {
	      if (_this.props.onChange) {
	        return _this.props.onChange(event);
	      }
	    };
	    return _this;
	  }
	
	  createClass(PullHook, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(PullHook.prototype.__proto__ || Object.getPrototypeOf(PullHook.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM__default.findDOMNode(this);
	      node.addEventListener('changestate', this.onChange);
	      this._pullHook.onAction = this.props.onLoad || null;
	      this._pullHook.onPull = this.props.onPull || null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = ReactDOM__default.findDOMNode(this);
	      node.removeEventListener('changestate', this.onChange);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.onLoad !== prevProps.onLoad) {
	        this._pullHook.onAction = this.props.onLoad;
	      }
	      if (this.props.onPull !== prevProps.onPull) {
	        this._pullHook.onPull = this.props.onPull;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attrs = Util.getAttrs(this);
	      return React.createElement('ons-pull-hook', _extends({}, attrs, { ref: function ref(pullHook) {
	          _this2._pullHook = pullHook;
	        } }));
	    }
	  }]);
	  return PullHook;
	}(BasicComponent);
	
	PullHook.propTypes = {
	  /**
	   * @name onChange
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called when the pull hook inner state is changed. The state can be either "initial", "preaction" or "action"[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name onLoad
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called when the pull hook is in the `action` state[/en]
	   *  [ja][/ja]
	   */
	  onLoad: PropTypes.func,
	
	  /**
	   * @name onPull
	   * @type function
	   * @required false
	   * @description
	   *  [en]Hook called whenever the user pulls the element. It gets the pulled distance ratio (scroll / height) and an animationOptions object as arguments.[/en]
	   *  [ja][/ja]
	   */
	  onPull: PropTypes.func,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en] When set to true, the pull hook will be disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name height
	   * @type number
	   * @description
	   *  [en] The height of the pull hook in pixels. The default value is 64.[/en]
	   *  [ja][/ja]
	   */
	  height: PropTypes.number,
	
	  /**
	   * @name thresholdHeight
	   * @type number
	   * @description
	   *  [en] The threshold height of the pull hook in pixels. The default value is 96.[/en]
	   *  [ja][/ja]
	   */
	  thresholdHeight: PropTypes.number,
	
	  /**
	   * @name fixedContent
	   * @type number
	   * @description
	   *  [en] If set to true, the content of the page will not move when pulling.[/en]
	   *  [ja][/ja]
	   */
	  fixedContent: PropTypes.bool
	};
	
	/**
	 * @original ons-radio
	 * @category form
	 * @tutorial react/Reference/input
	 * @description
	 * [en]
	 *  A radio button element. The component will automatically render as a Material Design radio button on Android devices.
	 *
	 *  Most attributes that can be used for a normal `<input type="radio">` element can also be used on the `<Radio>` component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Radio
	 *   onChange={event => { this.setState({checked: event.target.checked})} }
	 *   modifier='material' />
	 */
	
	var Radio = function (_BaseInput) {
	  inherits(Radio, _BaseInput);
	
	  function Radio() {
	    classCallCheck(this, Radio);
	    return possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  createClass(Radio, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-radio';
	    }
	  }, {
	    key: 'EVENT_TYPES',
	    get: function get$$1() {
	      return ['change'];
	    }
	  }]);
	  return Radio;
	}(BaseInput);
	
	Radio.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the radio button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the radio button is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en] Called when the radio button state changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type string
	   * @description
	   *  [en] Value of the radio button.[/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	
	  /**
	   * @name checked
	   * @type boolean
	   * @description
	   *  [en]Controls the state of the radio button.[/en]
	   *  [ja][/ja]
	   */
	  checked: PropTypes.bool,
	
	  /**
	   * @name inputId
	   * @type string
	   * @description
	   *  [en]Specify the "id" attribute of the inner `<input>` element. This is useful when using <label for="..."> elements.[/en]
	   *  [ja][/ja]
	   */
	  inputId: PropTypes.string
	};
	
	/**
	 * @original ons-range
	 * @category form
	 * @tutorial react/Reference/range
	 * @description
	 * [en]
	 *   Range input component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Range modifier="material"
	 *   value={this.state.value}
	 *   onChange={(event) => this.setState({value: parseInt(event.target.value)})}
	 *   />
	 */
	
	var Range = function (_BaseInput) {
	  inherits(Range, _BaseInput);
	
	  function Range() {
	    classCallCheck(this, Range);
	    return possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).apply(this, arguments));
	  }
	
	  createClass(Range, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-range';
	    }
	  }]);
	  return Range;
	}(BaseInput);
	
	Range.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the progress indicator.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en] Called when the value of the input changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type number
	   * @description
	   *  [en]
	   *  Current value of the element.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.number,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en] If true, the element is disabled. [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool
	};
	
	/**
	 * @original ons-ripple
	 * @category visual
	 * @tutorial react/Reference/ripple
	 * @description
	 * [en]
	 *   Adds a Material Design "ripple" effect to an element.
	 * [/en]
	 * [ja][/ja]
	 * @example
	   <div className='myList'>
	     <Ripple color='red' />
	   </div>
	 */
	
	var Ripple = function (_SimpleWrapper) {
	  inherits(Ripple, _SimpleWrapper);
	
	  function Ripple() {
	    classCallCheck(this, Ripple);
	    return possibleConstructorReturn(this, (Ripple.__proto__ || Object.getPrototypeOf(Ripple)).apply(this, arguments));
	  }
	
	  createClass(Ripple, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-ripple';
	    }
	  }]);
	  return Ripple;
	}(SimpleWrapper);
	
	Ripple.propTypes = {
	  /**
	   * @name color
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the ripple effect.[/en]
	   *  [ja][/ja]
	   */
	  color: PropTypes.string,
	
	  /**
	   * @name background
	   * @type string
	   * @required false
	   * @description
	   *  [en]Color of the background.[/en]
	   *  [ja][/ja]
	   */
	  background: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Specifies whether the button is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool
	};
	
	/**
	 * @original ons-navigator
	 * @category navigation
	 * @tutorial react/Reference/navigator
	 * @description
	 * [en] This component is responsible for page transitioning and managing the pages of your OnsenUI application. In order to manage to display the pages, the  navigator needs to define the `renderPage` method, that takes an route and a navigator and  converts it to an page.[/en]
	 * [ja][/ja]
	 */
	
	var RouterNavigator = function (_BasicComponent) {
	  inherits(RouterNavigator, _BasicComponent);
	
	  function RouterNavigator() {
	    var _ref;
	
	    classCallCheck(this, RouterNavigator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = RouterNavigator.__proto__ || Object.getPrototypeOf(RouterNavigator)).call.apply(_ref, [this].concat(args)));
	
	    _this.cancelUpdate = false;
	    _this.page = null;
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onPrePush = callback.bind(_this, 'onPrePush');
	    _this.onPostPush = callback.bind(_this, 'onPostPush');
	    _this.onPrePop = callback.bind(_this, 'onPrePop');
	    _this.onPostPop = callback.bind(_this, 'onPostPop');
	    return _this;
	  }
	
	  createClass(RouterNavigator, [{
	    key: 'update',
	    value: function update(cb) {
	      if (!this.cancelUpdate) {
	        this.setState({}, cb);
	      }
	    }
	
	    /**
	     * @method resetPageStack
	     * @signature resetPageStack(route, options = {})
	     * @param {Array} [routes]
	     *   [en] The routes that the navigator should be reset to.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en]Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Resets the navigator to the current page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'resetPageStack',
	    value: function resetPageStack(routes) {
	      var _this2 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return;
	      }
	
	      var update = function update() {
	        return new Promise(function (resolve) {
	          _this2.pages.push(_this2.props.renderPage(routes[routes.length - 1]));
	          _this2.update(resolve);
	        });
	      };
	
	      return this._navi._pushPage(options, update).then(function () {
	        _this2.pages = routes.map(function (route) {
	          return _this2.props.renderPage(route);
	        });
	        _this2.update();
	      });
	    }
	
	    /**
	     * @method pushPage
	     * @signature pushPage(route, options = {})
	     * @param {Array} [routes]
	     *   [en] The routes that the navigator should push to.[/en]
	     *   [ja][/ja]
	     * @return {Promise}
	     *   [en] Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Pushes a page to the page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'pushPage',
	    value: function pushPage(route) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return;
	      }
	
	      var update = function update() {
	        return new Promise(function (resolve) {
	          _this3.page = _this3.props.renderPage(route);
	          _this3.update(resolve);
	        });
	      };
	
	      return this._navi._pushPage(options, update).then(function () {
	        _this3.page = null;
	        _this3.update();
	      });
	    }
	  }, {
	    key: 'isRunning',
	    value: function isRunning() {
	      return this._navi._isRunning;
	    }
	
	    /*
	     * @method replacePage
	     * @signature replacePage(page, [options])
	     * @return {Promise}
	     *   [en]Promise which resolves to the new page.[/en]
	     *   [ja]新しいページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en]Replaces the current top page with the specified one. Extends `pushPage()` parameters.[/en]
	     *   [ja]現在表示中のページをを指定したページに置き換えます。[/ja]
	     */
	
	  }, {
	    key: 'replacePage',
	    value: function replacePage(route) {
	      var _this4 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.isRunning()) {
	        return;
	      }
	
	      var update = function update() {
	        return new Promise(function (resolve) {
	          _this4.pages.push(_this4.props.renderPage(route));
	          _this4.update(resolve);
	        });
	      };
	
	      return this._navi._pushPage(options, update).then(function () {
	        _this4.pages.splice(_this4.pages.length - 2, 1);
	        _this4.update();
	      });
	    }
	
	    /**
	     * @method popPage
	     * @signature popPage(route, options = {})
	     * @return {Promise}
	     *   [en] Promise which resolves to the revealed page.[/en]
	     *   [ja]明らかにしたページを解決するPromiseを返します。[/ja]
	     * @description
	     *   [en] Pops a page out of the page stack[/en]
	     *   [ja][/ja]
	     */
	
	  }, {
	    key: 'popPage',
	    value: function popPage() {
	      var _this5 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (this.isRunning()) {
	        return;
	      }
	
	      var update = function update() {
	        return new Promise(function (resolve) {
	          _this5.pages.pop();
	          _this5.update(resolve);
	        });
	      };
	
	      return this._navi._popPage(options, update);
	    }
	  }, {
	    key: '_onDeviceBackButton',
	    value: function _onDeviceBackButton(event) {
	      if (this.props.routeConfig.routeStack.length > 1) {
	        this.popPage();
	      } else {
	        event.callParentHandler();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this6 = this;
	
	      var node = this._navi;
	
	      this.cancelUpdate = false;
	
	      node.addEventListener('prepush', this.onPrePush);
	      node.addEventListener('postpush', this.onPostPush);
	      node.addEventListener('prepop', this.onPrePop);
	      node.addEventListener('postpop', this.onPostPop);
	
	      if (!this.props.routeConfig) {
	        throw new Error('In RouterNavigator the property routeConfig needs to be set');
	      }
	
	      this.routeConfig = this.props.routeConfig;
	
	      this.pages = this.routeConfig.routeStack.map(function (route) {
	        return _this6.props.renderPage(route, _this6);
	      });
	
	      node.swipeMax = this.props.swipePop;
	      node.onDeviceBackButton = this.props.onDeviceBackButton || this._onDeviceBackButton.bind(this);
	
	      this.update();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var processStack = [].concat(toConsumableArray(newProps.routeConfig.processStack));
	
	      if (newProps.onDeviceBackButton !== undefined) {
	        this._navi.onDeviceBackButton = newProps.onDeviceBackButton;
	      }
	
	      /**
	       * Fix for Redux Timetravel.
	       */
	      if (this.props.routeConfig.processStack.length < newProps.routeConfig.processStack.length && this.props.routeConfig.routeStack.length > newProps.routeConfig.routeStack.length) {
	        return;
	      }
	
	      if (processStack.length > 0) {
	        var _processStack$ = processStack[0],
	            type = _processStack$.type,
	            route = _processStack$.route,
	            options = _processStack$.options;
	
	
	        switch (type) {
	          case 'push':
	            this.pushPage(route, options);
	            break;
	          case 'pop':
	            this.popPage(options);
	            break;
	          case 'reset':
	            if (Array.isArray(route)) {
	              this.resetPageStack(route, options);
	            } else {
	              this.resetPageStack([route], options);
	            }
	            break;
	          case 'replace':
	            this.replacePage(route, options);
	            break;
	          default:
	            throw new Error('Unknown type ' + type + ' in processStack');
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = this._navi;
	      node.removeEventListener('prepush', this.onPrePush);
	      node.removeEventListener('postpush', this.onPostPush);
	      node.removeEventListener('prepop', this.onPrePop);
	      node.removeEventListener('postpop', this.onPostPop);
	      this.cancelUpdate = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var attrs = Util.getAttrs(this);
	
	      return React.createElement(
	        'ons-navigator',
	        _extends({}, attrs, { ref: function ref(navi) {
	            _this7._navi = navi;
	          } }),
	        this.props.routeConfig.routeStack.map(function (route) {
	          return _this7.props.renderPage(route);
	        }),
	        this.page
	      );
	    }
	  }]);
	  return RouterNavigator;
	}(BasicComponent);
	
	RouterNavigator.propTypes = {
	  /**
	   * @name renderPage
	   * @type function
	   * @required true
	   * @defaultValue null
	   * @description
	   *  [en] This function takes the current route object as a parameter and  creates returns a react componen.[/en]
	   *  [ja][/ja]
	   */
	  renderPage: PropTypes.func.isRequired,
	  /**
	   * @name initialRouteStack
	   * @type array
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This array contains the initial routes from the navigator,
	   *  which will be used to render the initial pages in the renderPage method.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  initialRouteStack: PropTypes.array,
	
	  /**
	   * @name initialRoute
	   * @type object
	   * @required false
	   * @defaultValue null
	   * @description
	   *  [en] This array contains the initial route of the navigator,
	   *  which will be used to render the initial pages in the
	   *  renderPage method.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  initialRoute: PropTypes.object,
	
	  /**
	   * @name onPrePush
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before a page is pushed.[/en]
	   */
	  onPrePush: PropTypes.func,
	
	  /**
	   * @name onPostPush
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after a page is pushed.[/en]
	   */
	  onPostPush: PropTypes.func,
	
	  /**
	   * @name onPrePop
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before a page is popped.[/en]
	   */
	  onPrePop: PropTypes.func,
	
	  /**
	   * @name onPostPop
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after a page is popped.[/en]
	   */
	  onPostPop: PropTypes.func,
	
	  /**
	   * @property animation
	   * @type {String}
	   * @description
	   *   [en]
	   *     Animation name. Available animations are `"slide"`, `"lift"`, `"fade"` and `"none"`.
	   *     These are platform based animations. For fixed animations, add `"-ios"` or `"-md"` suffix to the animation name. E.g. `"lift-ios"`, `"lift-md"`. Defaults values are `"slide-ios"` and `"fade-md"`.
	   *   [/en]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name swipeable
	   * @type bool|string
	   * @required false
	   * @description
	   *  [en]
	   *  Enables swipe-to-pop functionality for iOS.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  swipeable: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	
	  /**
	   * @name swipePop
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Function called on swipe-to-pop. Must perform a popPage with the given options object.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  swipePop: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-row
	 * @category grid
	 * @description
	 * [en]
	 * Represents a row in the grid system. Use with `Col` to layout components.
	 * [/en]
	 * [ja][/ja]
	 * <Row>
	 *   <Col width={50}>
	  *   <ons-icon icon="fa-twitter"></ons-icon>
	 *   </Col>
	 *   <Col>Text</Col>
	 * </Row>
	 */
	
	var Row = function (_SimpleWrapper) {
	  inherits(Row, _SimpleWrapper);
	
	  function Row() {
	    classCallCheck(this, Row);
	    return possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
	  }
	
	  createClass(Row, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-row';
	    }
	  }]);
	  return Row;
	}(SimpleWrapper);
	
	Row.propTypes = {
	
	  /**
	  * @name verticalAlign
	  * @type {String}
	  * @description
	  *   [en]Short hand attribute for aligning vertically. Valid values are top, bottom, and center.[/en]
	  *   [ja][/ja]
	  */
	  verticalAlign: PropTypes.oneOf(['top', 'bottom', 'center'])
	
	};
	
	/**
	 * @original ons-search-input
	 * @category form
	 * @tutorial react/Reference/input
	 * @description
	 * [en]
	 *  A search input component. The component will automatically render as a Material Design search input on Android devices.
	 *
	 *  Most attributes that can be used for a normal `<input>` element can also be used on the `<SearchInput>` component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <SearchInput
	 *   value={this.state.text}
	 *   onChange={(event) => { this.setState({text: event.target.value})} }
	 *   modifier='material'
	 *   placeholder='Username' />
	 */
	
	var SearchInput = function (_BaseInput) {
	  inherits(SearchInput, _BaseInput);
	
	  function SearchInput() {
	    classCallCheck(this, SearchInput);
	    return possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).apply(this, arguments));
	  }
	
	  createClass(SearchInput, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-search-input';
	    }
	  }]);
	  return SearchInput;
	}(BaseInput);
	
	SearchInput.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the input.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]Specifies whether the input is disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en]Called when the text of the input changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type string
	   * @description
	   *  [en]Content of the input.[/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	
	  /**
	   * @name inputId
	   * @type string
	   * @description
	   *  [en]  Specify the "id" attribute of the inner `<input>` element. This is useful when using <label for="..."> elements [/en]
	   *  [ja][/ja]
	   */
	  inputId: PropTypes.string
	};
	
	/**
	 * @original ons-segment
	 * @category control
	 * @tutorial react/Reference/segment
	 * @description
	 * [en]
	 *   Segment component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Segment modifier="material">
	 *  <button>Label 1</button>
	 *  <button>Label 2</button>
	 *  <button>Label 3</button>
	 * </Segment>
	 */
	
	var Segment = function (_BasicComponent) {
	  inherits(Segment, _BasicComponent);
	
	  function Segment() {
	    var _ref;
	
	    classCallCheck(this, Segment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = Segment.__proto__ || Object.getPrototypeOf(Segment)).call.apply(_ref, [this].concat(args)));
	
	    _this.onPostChange = function (event) {
	      if (_this.props.onPostChange) {
	        return _this.props.onPostChange(event);
	      }
	    };
	    return _this;
	  }
	
	  createClass(Segment, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-segment';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(Segment.prototype.__proto__ || Object.getPrototypeOf(Segment.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM.findDOMNode(this);
	
	      node.addEventListener('postchange', this.onPostChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = ReactDOM.findDOMNode(this);
	
	      node.removeEventListener('postchange', this.onPostChange);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var node = ReactDOM.findDOMNode(this);
	
	      if (this.props.index !== props.index && props.index !== node.getActiveButtonIndex()) {
	        node.setActiveButton(props.index, { reject: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var attrs = Util.getAttrs(this, this.props, { index: 'active-index' });
	      return React.createElement(this._getDomNodeName(), attrs, this.props.children);
	    }
	  }]);
	  return Segment;
	}(BasicComponent);
	
	Segment.propTypes = {
	  /**
	   * @name index
	   * @type number
	   * @required
	   * @description
	   *  [en] The index of the button to highlight.[/en]
	   *  [ja][/ja]
	   */
	  index: PropTypes.number,
	
	  /**
	   * @name tabbarId
	   * @type string
	   * @description
	   *  [en] ID of the `<Tabbar>` to "connect" to the segment. [/en]
	   *  [ja][/ja]
	   */
	  tabbarId: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the segment.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en] Called when the active button changes.[/en]
	   *  [ja][/ja]
	   */
	  onPostChange: PropTypes.func
	};
	
	/**
	 * @original ons-select
	 * @category form
	 * @tutorial react/Reference/select
	 * @description
	 * [en]
	 *   Select input component.
	 * [/en]
	 * [ja][/ja]
	 * @example
	 * <Select modifier="material"
	 *   value={this.state.value}
	 *   onChange={(event) => this.setState({value: event.target.value})}
	 *   <option value="1">1</option>
	 *   <option value="2">2nd</option>
	 *   <option value="3">3rd option</option>
	 * </Select>
	 */
	
	var Select = function (_BaseInput) {
	  inherits(Select, _BaseInput);
	
	  function Select() {
	    classCallCheck(this, Select);
	    return possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
	  }
	
	  createClass(Select, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange,
	          props = objectWithoutProperties(_props, ['value', 'onChange']);
	
	      var attrs = Util.getAttrs(this, props);
	
	      return React.createElement(
	        'ons-select',
	        attrs,
	        React.createElement(
	          'select',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }, {
	    key: 'EVENT_TYPES',
	    get: function get$$1() {
	      return ['change'];
	    }
	  }]);
	  return Select;
	}(BaseInput);
	
	Select.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]The appearance of the select box.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]Specifies whether the select is disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en]Called when the value of the select changes.[/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name value
	   * @type string
	   * @description
	   *  [en]Use this prop to set the selected option value.[/en]
	   *  [ja][/ja]
	   */
	  value: PropTypes.string,
	
	  /**
	   * @name multiple
	   * @type boolean
	   * @description
	   *  [en]If this attribute is defined, multiple options can be selected at once.[/en]
	   *  [ja][/ja]
	   */
	  multiple: PropTypes.bool,
	
	  /**
	   * @name autofocus
	   * @type boolean
	   * @description
	   *  [en]Element automatically gains focus on page load.[/en]
	   *  [ja][/ja]
	   */
	  autofocus: PropTypes.bool,
	
	  /**
	   * @name required
	   * @type boolean
	   * @description
	   *  [en]Make the select input required for submitting the form it is part of.[/en]
	   *  [ja][/ja]
	   */
	  required: PropTypes.bool,
	
	  /**
	   * @name form
	   * @type string
	   * @description
	   *  [en]Associate a select element to an existing form on the page, even if not nested.[/en]
	   *  [ja][/ja]
	   */
	  form: PropTypes.string,
	
	  /**
	   * @name size
	   * @type string
	   * @description
	   *  [en]How many options are displayed; if there are more than the size then a scroll appears to navigate them[/en]
	   *  [ja][/ja]
	   */
	  size: PropTypes.string
	};
	
	/**
	 * @original ons-speed-dial
	 * @category control
	 * @tutorial react/Reference/speed-dial
	 * @description
	 * [en] Element that displays a Material Design Speed Dialog component. It is useful when there are more than one primary action that can be performed in a page.
	 *  The Speed dial looks like a `Fab` element but will expand a menu when tapped.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <SpeedDial disabled={false} direction='right' onClick={() => console.log('test1')} position='left bottom'>
	     <Fab>
	       <Icon icon='fa-twitter' size={26} fixedWidth={false} style={{verticalAlign: 'middle'}} />
	     </Fab>
	     <SpeedDialItem onClick={() => console.log('speed A')}> A </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed B')}> B </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed C')}> C </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed D')}> D </SpeedDialItem>
	   </SpeedDial>
	 */
	
	var SpeedDial = function (_SimpleWrapper) {
	  inherits(SpeedDial, _SimpleWrapper);
	
	  function SpeedDial() {
	    classCallCheck(this, SpeedDial);
	    return possibleConstructorReturn(this, (SpeedDial.__proto__ || Object.getPrototypeOf(SpeedDial)).apply(this, arguments));
	  }
	
	  createClass(SpeedDial, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-speed-dial';
	    }
	  }]);
	  return SpeedDial;
	}(SimpleWrapper);
	
	SpeedDial.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the speed dial.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name position
	   * @type string
	   * @description
	   *  [en]Specify the vertical and horizontal position of the component.
	   *     I.e. to display it in the top right corner specify "right top".
	   *     Choose from "right", "left", "top" and "bottom".
	  [/en]
	   *  [ja][/ja]
	   */
	  position: PropTypes.string,
	
	  /**
	   * @name direction
	   * @type string
	   * @description
	   *  [en]Specify the direction the items are displayed. Possible values are "up", "down", "left" and "right".[/en]
	   *  [ja][/ja]
	   */
	  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
	
	  /**
	   * @name disabled
	   * @type string
	   * @description
	   *  [en]Specify if button should be disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool
	};
	
	/**
	 * @original ons-speed-dial-item
	 * @category control
	 * @tutorial react/Reference/speed-dial
	 * @description
	 * [en] This component displays the child elements of the Material Design Speed dial component. [/en]
	 * [ja][/ja]
	 * @example
	 * <SpeedDial disabled={false} direction='right' onClick={() => console.log('test1')} position='left bottom'>
	     <Fab>
	       <Icon icon='fa-twitter' size={26} fixedWidth={false} style={{verticalAlign: 'middle'}} />
	     </Fab>
	     <SpeedDialItem onClick={() => console.log('speed A')}> A </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed B')}> B </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed C')}> C </SpeedDialItem>
	     <SpeedDialItem onClick={() => console.log('speed D')}> D </SpeedDialItem>
	   </SpeedDial>
	 */
	
	var SpeedDialItem = function (_SimpleWrapper) {
	  inherits(SpeedDialItem, _SimpleWrapper);
	
	  function SpeedDialItem() {
	    var _ref;
	
	    classCallCheck(this, SpeedDialItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = SpeedDialItem.__proto__ || Object.getPrototypeOf(SpeedDialItem)).call.apply(_ref, [this].concat(args)));
	
	    _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        return _this.props.onClick(event);
	      }
	    };
	    return _this;
	  }
	
	  createClass(SpeedDialItem, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-speed-dial-item';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(SpeedDialItem.prototype.__proto__ || Object.getPrototypeOf(SpeedDialItem.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM__default.findDOMNode(this);
	      node.addEventListener('click', this.onClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = ReactDOM__default.findDOMNode(this);
	      node.removeEventListener('click', this.onClick);
	    }
	  }]);
	  return SpeedDialItem;
	}(SimpleWrapper);
	
	SpeedDialItem.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name onClick
	   * @type function
	   * @description
	   *  [en] This function will be called ones the button is clicked. [/en]
	   *  [ja][/ja]
	   */
	  onClick: PropTypes.func
	};
	
	/**
	 * @original ons-splitter
	 * @category menu
	 * @tutorial react/Reference/splitter
	 * @description
	 * [en]  A component that enables responsive layout by implementing both a two-column layout and a sliding menu layout.
	 *
	 *    It can be configured to automatically expand into a column layout on large screens and collapse the menu on smaller screens. When the menu is collapsed the user can open it by swiping.
	 [/en]
	 * [ja][/ja]
	 * @example
	  <Splitter>
	    <SplitterSide
	      side="left"
	      width={200}
	      isSwipeable={true}>
	      <Page> Page Left </Page>
	    </SplitterSide>
	    <SplitterContent>
	      <Page> Page Content </Page>
	    </SplitterContent>
	    <SplitterSide
	      side="right"
	      width={300}
	      collapse={!this.state.showRight}
	      isOpen={this.state.openRight}
	      onClose={this.handleRightClose.bind(this)}
	      onOpen={this.handleRightOpen.bind(this)}
	      isSwipeable={true}>
	      <Page> Page Right </Page>
	    </SplitterSide>
	  </Splitter>
	 */
	
	var Splitter = function (_SimpleWrapper) {
	  inherits(Splitter, _SimpleWrapper);
	
	  function Splitter() {
	    classCallCheck(this, Splitter);
	    return possibleConstructorReturn(this, (Splitter.__proto__ || Object.getPrototypeOf(Splitter)).apply(this, arguments));
	  }
	
	  createClass(Splitter, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-splitter';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(Splitter.prototype.__proto__ || Object.getPrototypeOf(Splitter.prototype), 'componentDidMount', this).call(this);
	      var node = ReactDOM__default.findDOMNode(this);
	
	      if (this.props.onDeviceBackButton instanceof Function) {
	        node.onDeviceBackButton = this.props.onDeviceBackButton;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.onDeviceBackButton !== undefined) {
	        ReactDOM__default.findDOMNode(this).onDeviceBackButton = newProps.onDeviceBackButton;
	      }
	    }
	  }]);
	  return Splitter;
	}(SimpleWrapper);
	
	Splitter.propTypes = {
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-splitter-content
	 * @category menu
	 * @tutorial react/Reference/splitter
	 * @description
	 * [en]  The SplitterContent  element is used as a child element of Splitter.
	 *    It contains the main content of the page while SplitterSide contains the list.
	 [/en]
	 * [ja][/ja]
	 * @example
	  <Splitter>
	    <SplitterSide
	      side="left"
	      width={200}
	      isSwipeable={true}>
	      <Page> Page Left </Page>
	    </SplitterSide>
	    <SplitterContent>
	      <Page> Page Content </Page>
	    </SplitterContent>
	    <SplitterSide
	      side="right"
	      width={300}
	      collapse={!this.state.showRight}
	      isOpen={this.state.openRight}
	      onClose={this.handleRightClose.bind(this)}
	      onOpen={this.handleRightOpen.bind(this)}
	      isSwipeable={true}>
	      <Page> Page Right </Page>
	    </SplitterSide>
	  </Splitter>
	 */
	
	var SplitterContent = function (_SimpleWrapper) {
	  inherits(SplitterContent, _SimpleWrapper);
	
	  function SplitterContent() {
	    classCallCheck(this, SplitterContent);
	    return possibleConstructorReturn(this, (SplitterContent.__proto__ || Object.getPrototypeOf(SplitterContent)).apply(this, arguments));
	  }
	
	  createClass(SplitterContent, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-splitter-content';
	    }
	  }]);
	  return SplitterContent;
	}(SimpleWrapper);
	
	/**
	 * @original ons-splitter-side
	 * @category menu
	 * @tutorial react/Reference/splitter
	 * @description
	 * [en]  The SplitterContent  element is used as a child element of Splitter.
	 *    It contains the main content of the page while SplitterSide contains the list.
	 [/en]
	 * [ja][/ja]
	 * @example
	  <Splitter>
	    <SplitterSide
	      side="left"
	      width={200}
	      swipeable={true}>
	      <Page> Page Left </Page>
	    </SplitterSide>
	    <SplitterContent>
	      <Page> Page Content </Page>
	    </SplitterContent>
	    <SplitterSide
	      side="right"
	      width={300}
	      collapse={!this.state.showRight}
	      isOpen={this.state.openRight}
	      onClose={this.handleRightClose.bind(this)}
	      onOpen={this.handleRightOpen.bind(this)}
	      swipeable={true}>
	      <Page> Page Right </Page>
	    </SplitterSide>
	  </Splitter>
	 */
	
	var SplitterSide = function (_BasicComponent) {
	  inherits(SplitterSide, _BasicComponent);
	
	  function SplitterSide() {
	    var _ref;
	
	    classCallCheck(this, SplitterSide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = SplitterSide.__proto__ || Object.getPrototypeOf(SplitterSide)).call.apply(_ref, [this].concat(args)));
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onOpen = callback.bind(_this, 'onOpen');
	    _this.onClose = callback.bind(_this, 'onClose');
	    _this.onPreOpen = callback.bind(_this, 'onPreOpen');
	    _this.onPreClose = callback.bind(_this, 'onPreClose');
	    _this.onModeChange = callback.bind(_this, 'onModeChange');
	    return _this;
	  }
	
	  createClass(SplitterSide, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(SplitterSide.prototype.__proto__ || Object.getPrototypeOf(SplitterSide.prototype), 'componentDidMount', this).call(this);
	      this.node = ReactDOM__default.findDOMNode(this);
	      this.componentWillReceiveProps(this.props);
	
	      this.node.addEventListener('postopen', this.onOpen);
	      this.node.addEventListener('postclose', this.onClose);
	      this.node.addEventListener('preopen', this.onPreOpen);
	      this.node.addEventListener('preclose', this.onPreClose);
	      this.node.addEventListener('modechange', this.onModeChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.node.removeEventListener('postopen', this.onOpen);
	      this.node.removeEventListener('postclose', this.onClose);
	      this.node.removeEventListener('preopen', this.onPreOpen);
	      this.node.removeEventListener('preclose', this.onPreClose);
	      this.node.removeEventListener('modechange', this.onModeChange);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.isOpen) {
	        this.node.open();
	      } else {
	        this.node.close();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      ['isCollapsed', 'isSwipeable'].forEach(function (p) {
	        return _this2.props.hasOwnProperty(p) && console.error('The property \'' + p + '\' is deprecated, please use \'' + p.toLowerCase().slice(2) + '\', see https://onsen.io/v2/docs/react/SplitterSide.html.');
	      });
	
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          props = objectWithoutProperties(_props, ['isOpen']);
	
	      var attrs = Util.getAttrs(this, props);
	
	      return React.createElement(
	        'ons-splitter-side',
	        attrs,
	        this.props.children
	      );
	    }
	  }]);
	  return SplitterSide;
	}(BasicComponent);
	
	SplitterSide.propTypes = {
	  /**
	   * @name collapse
	   * @type string
	   * @description
	   *  [en] Specify the collapse behavior. Valid values are `"portrait"`, `"landscape"` or a media query.
	   *     The strings `"portrait"` and `"landscape"` means the view will collapse when device is in landscape or portrait orientation.
	   *     If the value is not defined, the view always be in `"collapse"` mode.
	  [/en]
	   *  [ja][/ja]
	   */
	  collapse: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	
	  /**
	   * @name swipeable
	   * @type bool
	   * @description
	   *  [en]Ennable swipe interaction on collapse mode.[/en]
	   *  [ja][/ja]
	   */
	  swipeable: PropTypes.bool,
	
	  /**
	   * @name isOpen
	   * @type bool
	   * @description
	   *  [en]Specifies whether the menu is open.[/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool,
	
	  /**
	   * @name onOpen
	   * @type function
	   * @description
	   *  [en]Called after the menu is opened.[/en]
	   *  [ja][/ja]
	   */
	  onOpen: PropTypes.func,
	
	  /**
	   * @name onClose
	   * @type function
	   * @description
	   *  [en]Called after the menu is closed.[/en]
	   *  [ja][/ja]
	   */
	  onClose: PropTypes.func,
	
	  /**
	   * @name side
	   * @type string
	   * @description
	   *  [en]Specify which side of the screen the SplitterSide element is located. Possible values are `"left"` and `"right"`.[/en]
	   *  [ja][/ja]
	   */
	  side: PropTypes.oneOf(['left', 'right']),
	
	  /**
	   * @name swipeTargetWidth
	   * @type number
	   * @description
	   *  [en]Specifies the width of the menu with a number (for pixels) or a string (e.g. "20%" for percentage).[/en]
	   *  [ja][/ja]
	   */
	  swipeTargetWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	
	  /**
	   * @name width
	   * @type  number
	   * @description
	   *  [en]Specifies the width of the menu with a number (for pixels) or a string (e.g. "20%" for percentage).[/en]
	   *  [ja][/ja]
	   */
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]Specify the animation. Use one of `overlay`, `push`, `reveal`, or `default`.[/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name openThreshold
	   * @type object
	   * @required false
	   * @description
	   *  [en] Specify how much the menu needs to be swiped before opening. A value between `0` and `1`.  [/en]
	   *  [ja][/ja]
	   */
	  openThreshold: PropTypes.number,
	
	  /**
	   * @name mode
	   * @type string
	   * @required false
	   * @description
	   *  [en] Current mode. Possible values are `"collapse"` or `"split"`. This attribute is read only.  [/en]
	   *  [ja][/ja]
	   */
	  mode: PropTypes.oneOf(['collapse', 'split']),
	
	  /**
	   * @name onPreOpen
	   * @type string
	   * @description
	   *  [en] Called before the menu opens.  [/en]
	   *  [ja][/ja]
	   */
	  onPreOpen: PropTypes.func,
	
	  /**
	   * @name onPreClose
	   * @type string
	   * @description
	   *  [en] Called before the menu closes.  [/en]
	   *  [ja][/ja]
	   */
	  onPreClose: PropTypes.func,
	
	  /**
	   * @name onModeChange
	   * @type string
	   * @description
	   *  [en] Called after the component's mode changes. [/en]
	   *  [ja][/ja]
	   */
	  onModeChange: PropTypes.func
	};
	
	/**
	 * @original ons-switch
	 * @category form
	 * @tutorial react/Reference/switch
	 * @description
	 * [en]   Switch component. The switch can be toggled both by dragging and tapping.
	 *     Will automatically displays a Material Design switch on Android devices.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <Switch checked={this.state.checked} onChange={this.onChange} />
	 */
	
	var Switch = function (_BaseInput) {
	  inherits(Switch, _BaseInput);
	
	  function Switch() {
	    classCallCheck(this, Switch);
	    return possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	  }
	
	  createClass(Switch, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-switch';
	    }
	  }, {
	    key: 'EVENT_TYPES',
	    get: function get$$1() {
	      return ['change'];
	    }
	  }]);
	  return Switch;
	}(BaseInput);
	
	Switch.propTypes = {
	  /**
	   * @name onChange
	   * @type function
	   * @description
	   *  [en] Called when the value of the switch changes (checked/unchecked) [/en]
	   *  [ja][/ja]
	   */
	  onChange: PropTypes.func,
	
	  /**
	   * @name checked
	   * @type bool
	   * @description
	   *  [en] Whether the switch is checked.[/en]
	   *  [ja][/ja]
	   */
	  checked: PropTypes.bool,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en] If set, the switch is disabled.[/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool,
	
	  /**
	   * @name inputId
	   * @type string
	   * @description
	   *  [en] Specify the `id` attribute of the inner `<input>` element. This is useful when using `<label for="...">` elements.[/en]
	   *  [ja][/ja]
	   */
	  inputId: PropTypes.string
	};
	
	/**
	 * @original ons-tab
	 * @category tabbar
	 * @tutorial react/Reference/tabbar
	 * @description
	 * [en] Represents a tab inside tab bar.
	 [/en]
	 * [ja][/ja]
	 * @example
	 * <Tap>
	 *   Home
	 * </Tap>
	 */
	
	var Tab = function (_SimpleWrapper) {
	  inherits(Tab, _SimpleWrapper);
	
	  function Tab() {
	    classCallCheck(this, Tab);
	    return possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
	  }
	
	  createClass(Tab, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-tab';
	    }
	  }]);
	  return Tab;
	}(SimpleWrapper);
	
	/**
	 * @original ons-tabbar
	 * @category tabbar
	 * @tutorial react/Reference/tabbar
	 * @description
	 * [en] Component to display a tabbar on either the top or the bottom of a page.
	 * To define the tabs and the content the property renderTabs need to be implemented, that returns an array of tabs and their content. See the example for specifics. [/en]* [ja][/ja]
	 * @example
	
	  <Page>
	    <Tabbar
	      onPreChange={({index}) => this.setState(index)}
	      onPostChange={() => console.log('postChange')}
	      onReactive={() => console.log('postChange')}
	      position='bottom'
	      index={this.state.index}
	      renderTabs={(activeIndex, tabbar) => [
	        {
	          content: <TabPage title="Home" active={activeIndex === 0} tabbar={tabbar} />,
	          tab: <Tab label="Home" icon="md-home" />
	        },
	        {
	          content: <TabPage title="Settings" active={activeIndex === 1} tabbar={tabbar} />,
	          tab: <Tab label="Settings" icon="md-settings" />
	        }]
	      }
	    />
	  </Page>
	 */
	
	var Tabbar = function (_BasicComponent) {
	  inherits(Tabbar, _BasicComponent);
	
	  function Tabbar() {
	    var _ref;
	
	    classCallCheck(this, Tabbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = possibleConstructorReturn(this, (_ref = Tabbar.__proto__ || Object.getPrototypeOf(Tabbar)).call.apply(_ref, [this].concat(args)));
	
	    var callback = function callback(name, event) {
	      if (_this.props[name]) {
	        return _this.props[name](event);
	      }
	    };
	    _this.onPreChange = callback.bind(_this, 'onPreChange');
	    _this.onPostChange = callback.bind(_this, 'onPostChange');
	    _this.onReactive = callback.bind(_this, 'onReactive');
	    return _this;
	  }
	
	  createClass(Tabbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      get(Tabbar.prototype.__proto__ || Object.getPrototypeOf(Tabbar.prototype), 'componentDidMount', this).call(this);
	      var node = this._tabbar;
	      node.addEventListener('prechange', this.onPreChange);
	      node.addEventListener('postchange', this.onPostChange);
	      node.addEventListener('reactive', this.onReactive);
	      node.onSwipe = this.props.onSwipe || null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var node = this._tabbar;
	      node.removeEventListener('prechange', this.onPreChange);
	      node.removeEventListener('postchange', this.onPostChange);
	      node.removeEventListener('reactive', this.onReactive);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var node = this._tabbar;
	      if (nextProps.index !== this.props.index && nextProps.index !== node.getActiveTabIndex()) {
	        node.setActiveTab(nextProps.index, { reject: false });
	      }
	      if (this.props.onSwipe !== nextProps.onSwipe) {
	        node.onSwipe = nextProps.onSwipe;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attrs = Util.getAttrs(this, this.props, { index: 'activeIndex' });
	      var tabs = this.props.renderTabs(this.props.index, this);
	
	      if (!this.tabPages) {
	        this.tabPages = tabs.map(function (tab) {
	          return tab.content;
	        });
	      } else {
	        this.tabPages[this.props.index] = tabs[this.props.index].content;
	      }
	
	      return React.createElement(
	        'ons-tabbar',
	        _extends({}, attrs, { ref: function ref(tabbar) {
	            _this2._tabbar = tabbar;
	          } }),
	        React.createElement(
	          'div',
	          { className: 'tabbar__content' },
	          React.createElement(
	            'div',
	            null,
	            this.tabPages
	          ),
	          React.createElement('div', null)
	        ),
	        React.createElement(
	          'div',
	          { className: 'tabbar' },
	          tabs.map(function (tab) {
	            return tab.tab;
	          }),
	          React.createElement('div', { className: 'tabbar__border' })
	        )
	      );
	    }
	  }]);
	  return Tabbar;
	}(BasicComponent);
	
	Tabbar.propTypes = {
	  /**
	   * @name index
	   * @type number
	   * @required
	   * @description
	   *  [en] The index of the tab to highlight.[/en]
	   *  [ja][/ja]
	   */
	  index: PropTypes.number.isRequired,
	
	  /**
	   * @name renderTabs
	   * @type function
	   * @description
	   *  [en] Function that returns an array of objects with the keys `content` and `tab`.[/en]
	   *  [ja][/ja]
	   */
	  renderTabs: PropTypes.func.isRequired,
	
	  /**
	   * @name position
	   * @type string
	   * @description
	   *  [en] Tabbar's position. Available values are `"bottom"` and `"top"`. Use `"auto"` to choose position depending on platform (iOS bottom, Android top). [/en]
	   *  [ja][/ja]
	   */
	  position: PropTypes.string,
	
	  /**
	   * @name swipeable
	   * @type bool
	   * @description
	   *  [en]Ennable swipe interaction.[/en]
	   *  [ja][/ja]
	   */
	  swipeable: PropTypes.bool,
	
	  /**
	   * @name ignoreEdgeWidth
	   * @type number
	   * @description
	   *  [en]Distance in pixels from both edges. Swiping on these areas will prioritize parent components such as `Splitter` or `Navigator`.[/en]
	   *  [ja][/ja]
	   */
	  ignoreEdgeWidth: PropTypes.bool,
	
	  /**
	   * @name animation
	   * @type string
	   * @description
	   *  [en]If this attribute is set to `"none"` the transitions will not be animated.[/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.oneOf(['none', 'slide']),
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g. `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name tabBorder
	   * @type bool
	   * @description
	   *  [en]If true, the tabs show a dynamic bottom border. Only works for iOS since the border is always visible in Material Design.[/en]
	   *  [ja][/ja]
	   */
	  tabBorder: PropTypes.bool,
	
	  /**
	   * @name onPreChange
	   * @type function
	   * @description
	   *  [en]Called just before the tab is changed.[/en]
	   *  [ja][/ja]
	   */
	  onPreChange: PropTypes.func,
	
	  /**
	   * @name onPostChange
	   * @type function
	   * @description
	   *  [en]Called just after the tab is changed.[/en]
	   *  [ja][/ja]
	   */
	  onPostChange: PropTypes.func,
	
	  /**
	   * @name onReactive
	   * @type function
	   * @description
	   *  [en]Called if the already open tab is tapped again.[/en]
	   *  [ja][/ja]
	   */
	  onReactive: PropTypes.func,
	
	  /**
	   * @name onSwipe
	   * @type function
	   * @description
	   *  [en]Hook called whenever the user slides the tabbar. It gets a decimal index and an animationOptions object as arguments.[/en]
	   *  [ja][/ja]
	   */
	  onSwipe: PropTypes.func
	};
	
	Tabbar.defaultProps = {
	  index: 0
	};
	
	/**
	 * @original ons-toast
	 * @category dialog
	 * @tutorial react/Reference/dialog
	 * @description
	 * [en]
	 *  The Toast or Snackbar component is useful for displaying dismissable information or simple actions at (normally) the bottom of the page.
	 *
	 *  This component does not block user input, allowing the app to continue its flow. Furthermore, it can be automatically hidden after a timeout.
	 * [/en]
	 * [ja][/ja]
	 */
	
	var Toast = function (_BaseDialog) {
	  inherits(Toast, _BaseDialog);
	
	  function Toast() {
	    classCallCheck(this, Toast);
	    return possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).apply(this, arguments));
	  }
	
	  createClass(Toast, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-toast';
	    }
	  }]);
	  return Toast;
	}(BaseDialog);
	
	Toast.propTypes = {
	  /**
	   * @name isOpen
	   * @type bool
	   * @required true
	   * @description
	   *  [en]
	   *  Indicates whether the toast open and shown.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  isOpen: PropTypes.bool.isRequired,
	
	  /**
	   * @name animation
	   * @type string
	   * @required false
	   * @description
	   *  [en]Animation name. Available animations are `"default"`, `"ascend"` (Android), `"lift"` (iOS), `"fall"`, `"fade"` or `"none"`.[/en]
	   *  [ja][/ja]
	   */
	  animation: PropTypes.string,
	
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the toast.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name animationOptions
	   * @type object
	   * @required false
	   * @description
	   *  [en]Specify the animation's duration, delay and timing. E.g.  `{duration: 0.2, delay: 0.4, timing: 'ease-in'}`.[/en]
	   *  [ja][/ja]
	   */
	  animationOptions: PropTypes.object,
	
	  /**
	   * @name onPreShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just before the toast is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPreShow: PropTypes.func,
	
	  /**
	   * @name onPostShow
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Called just after the toast is displayed.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onPostShow: PropTypes.func,
	
	  /**
	   * @name onPreHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just before the toast is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPreHide: PropTypes.func,
	
	  /**
	   * @name onPostHide
	   * @type function
	   * @required false
	   * @description
	   *  [en]Called just after the toast is hidden.[/en]
	   *  [ja][/ja]
	   */
	  onPostHide: PropTypes.func,
	
	  /**
	   * @name onDeviceBackButton
	   * @type function
	   * @required false
	   * @description
	   *  [en]
	   *  Custom handler for device back button.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  onDeviceBackButton: PropTypes.func
	};
	
	/**
	 * @original ons-toolbar
	 * @category page
	 * @tutorial react/Reference/page
	 * @description
	 * [en]Toolbar component that can be used with navigation. Left, center and right container can be specified by class names. This component will automatically displays as a Material Design toolbar when running on Android devices.[/en]
	 * [ja][/ja]
	 * @example
	 *
	<Page renderToolbar={() =>
	  <Toolbar>
	    <div className="left">
	      <BackButton>
	          Back
	      </BackButton>
	    </div>
	    <div className="center">
	      Title
	    </div>
	    <div className="right">
	      <ToolbarButton>
	        <Icon icon="md-menu" />
	      </ToolbarButton>
	    </div>
	  </Toolbar> }
	/>
	 */
	
	var Toolbar = function (_SimpleWrapper) {
	  inherits(Toolbar, _SimpleWrapper);
	
	  function Toolbar() {
	    classCallCheck(this, Toolbar);
	    return possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  createClass(Toolbar, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-toolbar';
	    }
	  }]);
	  return Toolbar;
	}(SimpleWrapper);
	
	Toolbar.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @description
	   *  [en]
	   *  Specify modifier name to specify custom styles. Optional.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string
	};
	
	/**
	 * @original ons-toolbar-button
	 * @category page
	 * @tutorial react/Reference/page
	 * @description
	 *   [en]
	 *   Button component for the Toolbar. Using this component gives a nice default style.
	 *
	 *
	 *   [/en]
	 * [ja][/ja]
	 * @example
	 * <Page
	     renderToolbar = { () =>
	      <Toolbar>
	        <div className='left'><BackButton>Back</BackButton></div>
	        <div className='center'>Input</div>
	        <div className='right'>
	          <ToolbarButton onClick={this.add} >Add</ToolbarButton>
	        </div>
	      </Toolbar>
	     }>
	      Page Content
	    </Page>
	 */
	
	var ToolbarButton = function (_SimpleWrapper) {
	  inherits(ToolbarButton, _SimpleWrapper);
	
	  function ToolbarButton() {
	    classCallCheck(this, ToolbarButton);
	    return possibleConstructorReturn(this, (ToolbarButton.__proto__ || Object.getPrototypeOf(ToolbarButton)).apply(this, arguments));
	  }
	
	  createClass(ToolbarButton, [{
	    key: '_getDomNodeName',
	    value: function _getDomNodeName() {
	      return 'ons-toolbar-button';
	    }
	  }]);
	  return ToolbarButton;
	}(SimpleWrapper);
	
	ToolbarButton.propTypes = {
	  /**
	   * @name modifier
	   * @type string
	   * @required false
	   * @description
	   *  [en]The appearance of the button.[/en]
	   *  [ja][/ja]
	   */
	  modifier: PropTypes.string,
	
	  /**
	   * @name disabled
	   * @type bool
	   * @description
	   *  [en]
	   *  Indicates whether the button is disabled.
	   *  [/en]
	   *  [ja][/ja]
	   */
	  disabled: PropTypes.bool
	};
	
	/*
	 * routeStack : [userRoute, userRoute2, ...]
	 * processStack: [
	 * { type: push | pop | reset, route: userRoute },
	 * { type: push | pop | reset, route: userRoute2 },
	 * ...
	 * ]
	 */
	
	var RouterUtil = {
	  init: function init(routes) {
	    return {
	      routeStack: [].concat(toConsumableArray(routes)),
	      processStack: []
	    };
	  },
	
	  replace: function replace(_ref) {
	    var routeConfig = _ref.routeConfig,
	        route = _ref.route,
	        options = _ref.options,
	        key = _ref.key;
	
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	
	    if (key == null || processStack.filter(function (el) {
	      return el.key === key;
	    }).length === 0) {
	      var process = {
	        type: 'replace',
	        route: route,
	        options: options,
	        key: key
	      };
	      processStack = [].concat(toConsumableArray(processStack), [process]);
	    }
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  },
	
	  reset: function reset(_ref2) {
	    var routeConfig = _ref2.routeConfig,
	        route = _ref2.route,
	        options = _ref2.options,
	        key = _ref2.key;
	
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	
	    if (key == null || processStack.filter(function (el) {
	      return el.key === key;
	    }).length === 0) {
	      var process = {
	        type: 'reset',
	        route: route,
	        options: options,
	        key: key
	      };
	
	      processStack = [].concat(toConsumableArray(processStack), [process]);
	    }
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  },
	
	  push: function push(_ref3) {
	    var routeConfig = _ref3.routeConfig,
	        route = _ref3.route,
	        options = _ref3.options,
	        key = _ref3.key;
	
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	
	    if (key == null || config.processStack.filter(function (el) {
	      return el.key === key;
	    }).length === 0) {
	      var process = {
	        type: 'push',
	        route: route,
	        options: options,
	        key: key
	      };
	
	      processStack = [].concat(toConsumableArray(processStack), [process]);
	    }
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  },
	
	  pop: function pop(_ref4) {
	    var routeConfig = _ref4.routeConfig,
	        options = _ref4.options,
	        key = _ref4.key;
	
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	
	    /**
	     * Safegaurd to ensure that not
	     * too many pages are popped from
	     * the stack.
	     */
	    var pops = processStack.filter(function (x) {
	      return x.type === 'pop';
	    }).length;
	
	    if (pops + 1 >= routeStack.length) {
	      console.warn('Page stack is already empty');
	      return config;
	    }
	
	    var process = {
	      type: 'pop',
	      key: key,
	      options: options
	    };
	
	    processStack = [].concat(toConsumableArray(processStack), [process]);
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  },
	
	  postPush: function postPush(routeConfig) {
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	
	    var next = processStack.shift();
	    var type = next.type;
	    var route = next.route;
	
	    if (type === 'push') {
	      if (route !== null) {
	        routeStack = [].concat(toConsumableArray(routeStack), [route]);
	      }
	    } else if (type === 'reset') {
	      if (!Array.isArray(route)) route = [route];
	      routeStack = route;
	    } else if (type === 'replace') {
	      routeStack.pop();
	      routeStack.push(route);
	    }
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  },
	
	  postPop: function postPop(routeConfig) {
	    var config = _extends({}, routeConfig);
	    var routeStack = [].concat(toConsumableArray(config.routeStack));
	    var processStack = [].concat(toConsumableArray(config.processStack));
	    routeStack = routeStack.slice(0, routeStack.length - 1);
	    processStack = processStack.slice(1);
	
	    return {
	      routeStack: routeStack,
	      processStack: processStack
	    };
	  }
	};
	
	exports.ActionSheet = ActionSheet;
	exports.ActionSheetButton = ActionSheetButton;
	exports.AlertDialog = AlertDialog;
	exports.AlertDialogButton = AlertDialogButton;
	exports.BackButton = BackButton;
	exports.BottomToolbar = BottomToolbar;
	exports.Button = Button;
	exports.Card = Card;
	exports.Carousel = Carousel;
	exports.CarouselItem = CarouselItem;
	exports.Checkbox = Checkbox;
	exports.Col = Col;
	exports.Dialog = Dialog;
	exports.Fab = Fab;
	exports.Icon = Icon;
	exports.Input = Input;
	exports.LazyList = LazyList;
	exports.List = List;
	exports.ListHeader = ListHeader;
	exports.ListItem = ListItem;
	exports.ListTitle = ListTitle;
	exports.Navigator = Navigator;
	exports.Modal = Modal;
	exports.Page = Page;
	exports.Popover = Popover;
	exports.ProgressBar = ProgressBar;
	exports.ProgressCircular = ProgressCircular;
	exports.PullHook = PullHook;
	exports.Radio = Radio;
	exports.Range = Range;
	exports.Ripple = Ripple;
	exports.RouterNavigator = RouterNavigator;
	exports.RouterUtil = RouterUtil;
	exports.Row = Row;
	exports.SearchInput = SearchInput;
	exports.Segment = Segment;
	exports.Select = Select;
	exports.SpeedDial = SpeedDial;
	exports.SpeedDialItem = SpeedDialItem;
	exports.Splitter = Splitter;
	exports.SplitterContent = SplitterContent;
	exports.SplitterSide = SplitterSide;
	exports.Switch = Switch;
	exports.Tab = Tab;
	exports.Tabbar = Tabbar;
	exports.Toast = Toast;
	exports.Toolbar = Toolbar;
	exports.ToolbarButton = ToolbarButton;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(296);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(361)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(296, function() {
				var newContent = __webpack_require__(296);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.i(__webpack_require__(298), "");
	exports.i(__webpack_require__(315), "");
	
	// module
	exports.push([module.id, "body{text-transform:none}", ""]);
	
	// exports


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.i(__webpack_require__(299), "");
	exports.i(__webpack_require__(304), "");
	exports.i(__webpack_require__(308), "");
	
	// module
	exports.push([module.id, "/*! onsenui - v2.9.1 - 2018-01-26 */ons-gesture-detector,ons-navigator,ons-page,ons-tabbar{display:block;touch-action:manipulation}ons-action-sheet,ons-alert-dialog,ons-dialog,ons-navigator,ons-splitter,ons-tabbar,ons-toast{position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden;touch-action:manipulation}ons-toast{pointer-events:none}ons-toast .toast{pointer-events:auto}ons-tab{-webkit-transform:translateZ(0);transform:translateZ(0)}ons-action-sheet,ons-alert-dialog,ons-dialog,ons-navigator,ons-page,ons-tabbar,ons-toast{z-index:2}ons-fab,ons-speed-dial{z-index:10001}ons-bottom-toolbar,ons-toolbar:not([inline]){position:absolute;left:0;right:0;z-index:10000}ons-toolbar:not([inline]){top:0}ons-bottom-toolbar{bottom:0}.page,.page--material,.page--material__content,.page__content{background-color:transparent!important;background:transparent!important}.page__content{overflow:auto;-webkit-overflow-scrolling:touch;z-index:0;-ms-touch-action:pan-y}.page.overflow-visible,.page.overflow-visible .page,.page.overflow-visible .page__content,.page.overflow-visible ons-navigator,.page.overflow-visible ons-splitter{overflow:visible}.page.overflow-visible .page__content.content-swiping,.page.overflow-visible .page__content.content-swiping .page,.page.overflow-visible .page__content.content-swiping .page__content{overflow:auto}.page[status-bar-fill]>.page__content{top:20px}.page[status-bar-fill]>.toolbar{padding-top:20px;box-sizing:content-box}.page[status-bar-fill]>.toolbar:not(.toolbar--cover-content)+.page__background+.page__content,.page[status-bar-fill]>.toolbar:not(.toolbar--transparent)+.page__background{top:64px}.page[status-bar-fill]>.toolbar--material:not(.toolbar--cover-content)+.page__background+.page__content,.page[status-bar-fill]>.toolbar--material:not(.toolbar-transparent)+.page__background{top:76px}.page[status-bar-fill]>.toolbar.toolbar--transparent+.page__background{top:0}ons-tabbar[status-bar-fill]>.tabbar--top__content{top:71px}ons-tabbar[status-bar-fill]>.tabbar--top{padding-top:22px}.toolbar+.page__background+.page__content ons-tabbar[status-bar-fill]>.tabbar--top,ons-tabbar[position=top] .page[status-bar-fill]>.page__content{top:0}.toolbar+.page__background+.page__content ons-tabbar[status-bar-fill]>.tabbar--top__content{top:49px}.page__content>.list:not(.list--material):first-child{margin-top:-1px}.page--wrapper>.page__background{display:none}ons-action-sheet[disabled],ons-alert-dialog[disabled],ons-dialog[disabled],ons-popover[disabled]{pointer-events:none;opacity:.75}ons-list-item[disabled]{pointer-events:none}ons-range[disabled]{opacity:.3;pointer-events:none}ons-pull-hook{position:relative;display:block;margin:auto;text-align:center;z-index:20002}ons-splitter,ons-splitter-content,ons-splitter-mask,ons-splitter-side{display:block;position:absolute;left:0;right:0;top:0;bottom:0;box-sizing:border-box;z-index:0}ons-splitter-mask{z-index:4;background-color:rgba(0,0,0,.1);display:none;opacity:0}ons-splitter-content{z-index:2}ons-splitter-side{right:auto;z-index:2}ons-splitter-side[side=right]{right:0;left:auto}ons-splitter-side[mode=collapse]{z-index:5;left:auto;right:100%}ons-splitter-side[side=right][mode=collapse]{right:auto;left:100%}ons-splitter-side[mode=split]{z-index:3}ons-toolbar-button>ons-icon[icon*=ion-]{font-size:26px}ons-range,ons-select{display:inline-block}ons-range>input{min-width:50px;width:100%}ons-select>select{width:100%}ons-carousel[disabled]{pointer-events:none;opacity:.75}ons-carousel[fullscreen]{height:100%}.ons-status-bar-mock{position:absolute;width:100%;height:20px;padding:0 16px 0 6px;box-sizing:border-box;z-index:30000;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between;font-size:12px;line-height:20px;font-family:Arial,Helvetica}.ons-status-bar-mock i{padding:0 2px}.ons-status-bar-mock.android{color:#fff;background-color:#222;font-family:Roboto,Arial,Helvetica}.ons-status-bar-mock.android~*{top:20px;bottom:0;position:inherit;width:100%}.ons-ios-scroll-fix .page:not(.page--wrapper)[shown]>.page__content{overflow-y:hidden}.ons-ios-scroll-fix ons-splitter-side>.page:not(.page--wrapper)[shown]>.page__content{overflow-y:auto}ons-row{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;width:100%;box-sizing:border-box}ons-row[align=top],ons-row[vertical-align=top]{-webkit-box-align:start;box-align:start;-ms-flex-align:start;-webkit-align-items:flex-start;-moz-align-items:flex-start;align-items:flex-start}ons-row[align=bottom],ons-row[vertical-align=bottom]{-webkit-box-align:end;box-align:end;-ms-flex-align:end;-webkit-align-items:flex-end;-moz-align-items:flex-end;align-items:flex-end}ons-row[align=center],ons-row[vertical-align=center]{-webkit-box-align:center;box-align:center;-ms-flex-align:center;-webkit-align-items:center;-moz-align-items:center;align-items:center;text-align:inherit}ons-row+ons-row{padding-top:0}ons-col{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;display:block;width:100%;box-sizing:border-box}ons-col[align=top],ons-col[vertical-align=top]{-webkit-align-self:flex-start;-moz-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start}ons-col[align=bottom],ons-col[vertical-align=bottom]{-webkit-align-self:flex-end;-moz-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end}ons-col[align=center],ons-col[vertical-align=center]{-webkit-align-self:center;-moz-align-self:center;-ms-flex-item-align:center;text-align:inherit}.ons-icon{display:inline-block;line-height:inherit;font-style:normal;font-weight:400;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.segment__button .ons-icon{line-height:normal}:not(ons-toolbar-button):not(ons-action-sheet-button):not(.segment__button)>.ons-icon--ion{line-height:.75em;vertical-align:-25%}.ons-icon[spin]{-webkit-animation:ons-icon-spin 2s infinite linear;-moz-animation:ons-icon-spin 2s infinite linear;animation:ons-icon-spin 2s infinite linear}@-moz-keyframes ons-icon-spin{0%{-moz-transform:rotate(0deg)}to{-moz-transform:rotate(359deg)}}@-webkit-keyframes ons-icon-spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes ons-icon-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.ons-icon[rotate=\"90\"]{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);transform:rotate(90deg)}.ons-icon[rotate=\"180\"]{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);transform:rotate(180deg)}.ons-icon[rotate=\"270\"]{-webkit-transform:rotate(270deg);-moz-transform:rotate(270deg);transform:rotate(270deg)}.ons-icon[fixed-width]{width:1.28571429em;text-align:center}.ons-icon--lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.ons-icon--2x{font-size:2em}.ons-icon--3x{font-size:3em}.ons-icon--4x{font-size:4em}.ons-icon--5x{font-size:5em}ons-checkbox,ons-input,ons-radio,ons-search-input{display:inline-block;position:relative}ons-input .text-input,ons-search-input .search-input{width:100%;display:inline-block}ons-input .text-input__label:not(.text-input--material__label),ons-input:not([float]) .text-input--material__label--active{display:none}ons-checkbox[disabled],ons-input[disabled],ons-radio[disabled],ons-search-input[disabled],ons-segment[disabled]{opacity:.5;pointer-events:none}ons-input input.text-input--material::-webkit-input-placeholder{color:transparent}ons-input input.text-input--material::-moz-placeholder{color:transparent}ons-input input.text-input--material:-ms-input-placeholder{color:transparent}@media (orientation:landscape){html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content{padding-right:0}html[onsflag-iphonex-landscape] ons-splitter-side[side=right] .page__content{padding-left:0}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .page__content>ons-progress-bar>.progress-bar{margin-left:-44px;margin-right:-44px;width:calc(100% + 88px)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] ons-splitter-side[side=right] .page__content>.list:not(.list--inset){margin-left:0}html[onsflag-iphonex-landscape] ons-splitter-side[side=right] .page__content>.list:not(.list--inset)>.list-header{padding-left:15px}html[onsflag-iphonex-landscape] ons-splitter-side[side=right] .page__content>.list:not(.list--inset)>.list-item{padding-left:14px}html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content>.list:not(.list--inset){margin-right:0}html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content>.list:not(.list--inset)>.list-item--chevron:before{right:16px}html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content>.list:not(.list--inset)>.list-item>.list-item__center:last-child{padding-right:6px}html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content>.list:not(.list--inset)>.list-item>.list-item__right{padding-right:12px}html[onsflag-iphonex-landscape] ons-splitter-side[side=left] .page__content>.list:not(.list--inset)>.list-item>.list-item--chevron__right{padding-right:30px}}ons-progress-bar{display:block}ons-progress-circular{display:inline-block;width:32px;height:32px}ons-progress-circular>svg.progress-circular{width:100%;height:100%}.ripple{display:block;overflow:hidden}.ripple,.ripple__background{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.ripple__background{background:hsla(0,0%,100%,.2);opacity:0}.ripple__wave{background:hsla(0,0%,100%,.2);width:0;height:0;border-radius:50%;position:absolute;top:0;left:0;z-index:0;pointer-events:none}.button--material--flat .ripple__background,.button--material--flat .ripple__wave,.ripple--light-gray__background,.ripple--light-gray__wave,ons-list-item .ripple__background,ons-list-item .ripple__wave{background:hsla(0,0%,74%,.3)}.ons-swiper{overflow:hidden;display:block;box-sizing:border-box}.ons-swiper-target{display:-webkit-box;display:-webkit-flex;display:flex;height:100%;z-index:1;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}.ons-swiper-target--vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.ons-swiper-target>*{height:inherit;-webkit-flex-shrink:0;flex-shrink:0;box-sizing:border-box;width:100%;position:relative!important}.ons-swiper-tabbar .tabbar--material__button:after{display:none}.ons-swiper-blocker{display:block;position:absolute;top:0;bottom:0;left:0;right:0;pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";/*!\n  Ionicons, v2.0.1\n  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/\n  https://twitter.com/benjsperry  https://twitter.com/ionicframework\n  MIT License: https://github.com/driftyco/ionicons\n\n  Android-style icons originally built by Google’s\n  Material Design Icons: https://github.com/google/material-design-icons\n  used under CC BY http://creativecommons.org/licenses/by/4.0/\n  Modified icons to fit ionicon’s grid from original.\n*/@font-face{font-family:Ionicons;src:url(" + __webpack_require__(300) + ");src:url(" + __webpack_require__(300) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(301) + ") format(\"truetype\"),url(" + __webpack_require__(302) + ") format(\"woff\"),url(" + __webpack_require__(303) + ") format(\"svg\");font-weight:400;font-style:normal}.ion,.ion-alert-circled:before,.ion-alert:before,.ion-android-add-circle:before,.ion-android-add:before,.ion-android-alarm-clock:before,.ion-android-alert:before,.ion-android-apps:before,.ion-android-archive:before,.ion-android-arrow-back:before,.ion-android-arrow-down:before,.ion-android-arrow-dropdown-circle:before,.ion-android-arrow-dropdown:before,.ion-android-arrow-dropleft-circle:before,.ion-android-arrow-dropleft:before,.ion-android-arrow-dropright-circle:before,.ion-android-arrow-dropright:before,.ion-android-arrow-dropup-circle:before,.ion-android-arrow-dropup:before,.ion-android-arrow-forward:before,.ion-android-arrow-up:before,.ion-android-attach:before,.ion-android-bar:before,.ion-android-bicycle:before,.ion-android-boat:before,.ion-android-bookmark:before,.ion-android-bulb:before,.ion-android-bus:before,.ion-android-calendar:before,.ion-android-call:before,.ion-android-camera:before,.ion-android-cancel:before,.ion-android-car:before,.ion-android-cart:before,.ion-android-chat:before,.ion-android-checkbox-blank:before,.ion-android-checkbox-outline-blank:before,.ion-android-checkbox-outline:before,.ion-android-checkbox:before,.ion-android-checkmark-circle:before,.ion-android-clipboard:before,.ion-android-close:before,.ion-android-cloud-circle:before,.ion-android-cloud-done:before,.ion-android-cloud-outline:before,.ion-android-cloud:before,.ion-android-color-palette:before,.ion-android-compass:before,.ion-android-contact:before,.ion-android-contacts:before,.ion-android-contract:before,.ion-android-create:before,.ion-android-delete:before,.ion-android-desktop:before,.ion-android-document:before,.ion-android-done-all:before,.ion-android-done:before,.ion-android-download:before,.ion-android-drafts:before,.ion-android-exit:before,.ion-android-expand:before,.ion-android-favorite-outline:before,.ion-android-favorite:before,.ion-android-film:before,.ion-android-folder-open:before,.ion-android-folder:before,.ion-android-funnel:before,.ion-android-globe:before,.ion-android-hand:before,.ion-android-hangout:before,.ion-android-happy:before,.ion-android-home:before,.ion-android-image:before,.ion-android-laptop:before,.ion-android-list:before,.ion-android-locate:before,.ion-android-lock:before,.ion-android-mail:before,.ion-android-map:before,.ion-android-menu:before,.ion-android-microphone-off:before,.ion-android-microphone:before,.ion-android-more-horizontal:before,.ion-android-more-vertical:before,.ion-android-navigate:before,.ion-android-notifications-none:before,.ion-android-notifications-off:before,.ion-android-notifications:before,.ion-android-open:before,.ion-android-options:before,.ion-android-people:before,.ion-android-person-add:before,.ion-android-person:before,.ion-android-phone-landscape:before,.ion-android-phone-portrait:before,.ion-android-pin:before,.ion-android-plane:before,.ion-android-playstore:before,.ion-android-print:before,.ion-android-radio-button-off:before,.ion-android-radio-button-on:before,.ion-android-refresh:before,.ion-android-remove-circle:before,.ion-android-remove:before,.ion-android-restaurant:before,.ion-android-sad:before,.ion-android-search:before,.ion-android-send:before,.ion-android-settings:before,.ion-android-share-alt:before,.ion-android-share:before,.ion-android-star-half:before,.ion-android-star-outline:before,.ion-android-star:before,.ion-android-stopwatch:before,.ion-android-subway:before,.ion-android-sunny:before,.ion-android-sync:before,.ion-android-textsms:before,.ion-android-time:before,.ion-android-train:before,.ion-android-unlock:before,.ion-android-upload:before,.ion-android-volume-down:before,.ion-android-volume-mute:before,.ion-android-volume-off:before,.ion-android-volume-up:before,.ion-android-walk:before,.ion-android-warning:before,.ion-android-watch:before,.ion-android-wifi:before,.ion-aperture:before,.ion-archive:before,.ion-arrow-down-a:before,.ion-arrow-down-b:before,.ion-arrow-down-c:before,.ion-arrow-expand:before,.ion-arrow-graph-down-left:before,.ion-arrow-graph-down-right:before,.ion-arrow-graph-up-left:before,.ion-arrow-graph-up-right:before,.ion-arrow-left-a:before,.ion-arrow-left-b:before,.ion-arrow-left-c:before,.ion-arrow-move:before,.ion-arrow-resize:before,.ion-arrow-return-left:before,.ion-arrow-return-right:before,.ion-arrow-right-a:before,.ion-arrow-right-b:before,.ion-arrow-right-c:before,.ion-arrow-shrink:before,.ion-arrow-swap:before,.ion-arrow-up-a:before,.ion-arrow-up-b:before,.ion-arrow-up-c:before,.ion-asterisk:before,.ion-at:before,.ion-backspace-outline:before,.ion-backspace:before,.ion-bag:before,.ion-battery-charging:before,.ion-battery-empty:before,.ion-battery-full:before,.ion-battery-half:before,.ion-battery-low:before,.ion-beaker:before,.ion-beer:before,.ion-bluetooth:before,.ion-bonfire:before,.ion-bookmark:before,.ion-bowtie:before,.ion-briefcase:before,.ion-bug:before,.ion-calculator:before,.ion-calendar:before,.ion-camera:before,.ion-card:before,.ion-cash:before,.ion-chatbox-working:before,.ion-chatbox:before,.ion-chatboxes:before,.ion-chatbubble-working:before,.ion-chatbubble:before,.ion-chatbubbles:before,.ion-checkmark-circled:before,.ion-checkmark-round:before,.ion-checkmark:before,.ion-chevron-down:before,.ion-chevron-left:before,.ion-chevron-right:before,.ion-chevron-up:before,.ion-clipboard:before,.ion-clock:before,.ion-close-circled:before,.ion-close-round:before,.ion-close:before,.ion-closed-captioning:before,.ion-cloud:before,.ion-code-download:before,.ion-code-working:before,.ion-code:before,.ion-coffee:before,.ion-compass:before,.ion-compose:before,.ion-connection-bars:before,.ion-contrast:before,.ion-crop:before,.ion-cube:before,.ion-disc:before,.ion-document-text:before,.ion-document:before,.ion-drag:before,.ion-earth:before,.ion-easel:before,.ion-edit:before,.ion-egg:before,.ion-eject:before,.ion-email-unread:before,.ion-email:before,.ion-erlenmeyer-flask-bubbles:before,.ion-erlenmeyer-flask:before,.ion-eye-disabled:before,.ion-eye:before,.ion-female:before,.ion-filing:before,.ion-film-marker:before,.ion-fireball:before,.ion-flag:before,.ion-flame:before,.ion-flash-off:before,.ion-flash:before,.ion-folder:before,.ion-fork-repo:before,.ion-fork:before,.ion-forward:before,.ion-funnel:before,.ion-gear-a:before,.ion-gear-b:before,.ion-grid:before,.ion-hammer:before,.ion-happy-outline:before,.ion-happy:before,.ion-headphone:before,.ion-heart-broken:before,.ion-heart:before,.ion-help-buoy:before,.ion-help-circled:before,.ion-help:before,.ion-home:before,.ion-icecream:before,.ion-image:before,.ion-images:before,.ion-information-circled:before,.ion-information:before,.ion-ionic:before,.ion-ios-alarm-outline:before,.ion-ios-alarm:before,.ion-ios-albums-outline:before,.ion-ios-albums:before,.ion-ios-americanfootball-outline:before,.ion-ios-americanfootball:before,.ion-ios-analytics-outline:before,.ion-ios-analytics:before,.ion-ios-arrow-back:before,.ion-ios-arrow-down:before,.ion-ios-arrow-forward:before,.ion-ios-arrow-left:before,.ion-ios-arrow-right:before,.ion-ios-arrow-thin-down:before,.ion-ios-arrow-thin-left:before,.ion-ios-arrow-thin-right:before,.ion-ios-arrow-thin-up:before,.ion-ios-arrow-up:before,.ion-ios-at-outline:before,.ion-ios-at:before,.ion-ios-barcode-outline:before,.ion-ios-barcode:before,.ion-ios-baseball-outline:before,.ion-ios-baseball:before,.ion-ios-basketball-outline:before,.ion-ios-basketball:before,.ion-ios-bell-outline:before,.ion-ios-bell:before,.ion-ios-body-outline:before,.ion-ios-body:before,.ion-ios-bolt-outline:before,.ion-ios-bolt:before,.ion-ios-book-outline:before,.ion-ios-book:before,.ion-ios-bookmarks-outline:before,.ion-ios-bookmarks:before,.ion-ios-box-outline:before,.ion-ios-box:before,.ion-ios-briefcase-outline:before,.ion-ios-briefcase:before,.ion-ios-browsers-outline:before,.ion-ios-browsers:before,.ion-ios-calculator-outline:before,.ion-ios-calculator:before,.ion-ios-calendar-outline:before,.ion-ios-calendar:before,.ion-ios-camera-outline:before,.ion-ios-camera:before,.ion-ios-cart-outline:before,.ion-ios-cart:before,.ion-ios-chatboxes-outline:before,.ion-ios-chatboxes:before,.ion-ios-chatbubble-outline:before,.ion-ios-chatbubble:before,.ion-ios-checkmark-empty:before,.ion-ios-checkmark-outline:before,.ion-ios-checkmark:before,.ion-ios-circle-filled:before,.ion-ios-circle-outline:before,.ion-ios-clock-outline:before,.ion-ios-clock:before,.ion-ios-close-empty:before,.ion-ios-close-outline:before,.ion-ios-close:before,.ion-ios-cloud-download-outline:before,.ion-ios-cloud-download:before,.ion-ios-cloud-outline:before,.ion-ios-cloud-upload-outline:before,.ion-ios-cloud-upload:before,.ion-ios-cloud:before,.ion-ios-cloudy-night-outline:before,.ion-ios-cloudy-night:before,.ion-ios-cloudy-outline:before,.ion-ios-cloudy:before,.ion-ios-cog-outline:before,.ion-ios-cog:before,.ion-ios-color-filter-outline:before,.ion-ios-color-filter:before,.ion-ios-color-wand-outline:before,.ion-ios-color-wand:before,.ion-ios-compose-outline:before,.ion-ios-compose:before,.ion-ios-contact-outline:before,.ion-ios-contact:before,.ion-ios-copy-outline:before,.ion-ios-copy:before,.ion-ios-crop-strong:before,.ion-ios-crop:before,.ion-ios-download-outline:before,.ion-ios-download:before,.ion-ios-drag:before,.ion-ios-email-outline:before,.ion-ios-email:before,.ion-ios-eye-outline:before,.ion-ios-eye:before,.ion-ios-fastforward-outline:before,.ion-ios-fastforward:before,.ion-ios-filing-outline:before,.ion-ios-filing:before,.ion-ios-film-outline:before,.ion-ios-film:before,.ion-ios-flag-outline:before,.ion-ios-flag:before,.ion-ios-flame-outline:before,.ion-ios-flame:before,.ion-ios-flask-outline:before,.ion-ios-flask:before,.ion-ios-flower-outline:before,.ion-ios-flower:before,.ion-ios-folder-outline:before,.ion-ios-folder:before,.ion-ios-football-outline:before,.ion-ios-football:before,.ion-ios-game-controller-a-outline:before,.ion-ios-game-controller-a:before,.ion-ios-game-controller-b-outline:before,.ion-ios-game-controller-b:before,.ion-ios-gear-outline:before,.ion-ios-gear:before,.ion-ios-glasses-outline:before,.ion-ios-glasses:before,.ion-ios-grid-view-outline:before,.ion-ios-grid-view:before,.ion-ios-heart-outline:before,.ion-ios-heart:before,.ion-ios-help-empty:before,.ion-ios-help-outline:before,.ion-ios-help:before,.ion-ios-home-outline:before,.ion-ios-home:before,.ion-ios-infinite-outline:before,.ion-ios-infinite:before,.ion-ios-information-empty:before,.ion-ios-information-outline:before,.ion-ios-information:before,.ion-ios-ionic-outline:before,.ion-ios-keypad-outline:before,.ion-ios-keypad:before,.ion-ios-lightbulb-outline:before,.ion-ios-lightbulb:before,.ion-ios-list-outline:before,.ion-ios-list:before,.ion-ios-location-outline:before,.ion-ios-location:before,.ion-ios-locked-outline:before,.ion-ios-locked:before,.ion-ios-loop-strong:before,.ion-ios-loop:before,.ion-ios-medical-outline:before,.ion-ios-medical:before,.ion-ios-medkit-outline:before,.ion-ios-medkit:before,.ion-ios-mic-off:before,.ion-ios-mic-outline:before,.ion-ios-mic:before,.ion-ios-minus-empty:before,.ion-ios-minus-outline:before,.ion-ios-minus:before,.ion-ios-monitor-outline:before,.ion-ios-monitor:before,.ion-ios-moon-outline:before,.ion-ios-moon:before,.ion-ios-more-outline:before,.ion-ios-more:before,.ion-ios-musical-note:before,.ion-ios-musical-notes:before,.ion-ios-navigate-outline:before,.ion-ios-navigate:before,.ion-ios-nutrition-outline:before,.ion-ios-nutrition:before,.ion-ios-paper-outline:before,.ion-ios-paper:before,.ion-ios-paperplane-outline:before,.ion-ios-paperplane:before,.ion-ios-partlysunny-outline:before,.ion-ios-partlysunny:before,.ion-ios-pause-outline:before,.ion-ios-pause:before,.ion-ios-paw-outline:before,.ion-ios-paw:before,.ion-ios-people-outline:before,.ion-ios-people:before,.ion-ios-person-outline:before,.ion-ios-person:before,.ion-ios-personadd-outline:before,.ion-ios-personadd:before,.ion-ios-photos-outline:before,.ion-ios-photos:before,.ion-ios-pie-outline:before,.ion-ios-pie:before,.ion-ios-pint-outline:before,.ion-ios-pint:before,.ion-ios-play-outline:before,.ion-ios-play:before,.ion-ios-plus-empty:before,.ion-ios-plus-outline:before,.ion-ios-plus:before,.ion-ios-pricetag-outline:before,.ion-ios-pricetag:before,.ion-ios-pricetags-outline:before,.ion-ios-pricetags:before,.ion-ios-printer-outline:before,.ion-ios-printer:before,.ion-ios-pulse-strong:before,.ion-ios-pulse:before,.ion-ios-rainy-outline:before,.ion-ios-rainy:before,.ion-ios-recording-outline:before,.ion-ios-recording:before,.ion-ios-redo-outline:before,.ion-ios-redo:before,.ion-ios-refresh-empty:before,.ion-ios-refresh-outline:before,.ion-ios-refresh:before,.ion-ios-reload:before,.ion-ios-reverse-camera-outline:before,.ion-ios-reverse-camera:before,.ion-ios-rewind-outline:before,.ion-ios-rewind:before,.ion-ios-rose-outline:before,.ion-ios-rose:before,.ion-ios-search-strong:before,.ion-ios-search:before,.ion-ios-settings-strong:before,.ion-ios-settings:before,.ion-ios-shuffle-strong:before,.ion-ios-shuffle:before,.ion-ios-skipbackward-outline:before,.ion-ios-skipbackward:before,.ion-ios-skipforward-outline:before,.ion-ios-skipforward:before,.ion-ios-snowy:before,.ion-ios-speedometer-outline:before,.ion-ios-speedometer:before,.ion-ios-star-half:before,.ion-ios-star-outline:before,.ion-ios-star:before,.ion-ios-stopwatch-outline:before,.ion-ios-stopwatch:before,.ion-ios-sunny-outline:before,.ion-ios-sunny:before,.ion-ios-telephone-outline:before,.ion-ios-telephone:before,.ion-ios-tennisball-outline:before,.ion-ios-tennisball:before,.ion-ios-thunderstorm-outline:before,.ion-ios-thunderstorm:before,.ion-ios-time-outline:before,.ion-ios-time:before,.ion-ios-timer-outline:before,.ion-ios-timer:before,.ion-ios-toggle-outline:before,.ion-ios-toggle:before,.ion-ios-trash-outline:before,.ion-ios-trash:before,.ion-ios-undo-outline:before,.ion-ios-undo:before,.ion-ios-unlocked-outline:before,.ion-ios-unlocked:before,.ion-ios-upload-outline:before,.ion-ios-upload:before,.ion-ios-videocam-outline:before,.ion-ios-videocam:before,.ion-ios-volume-high:before,.ion-ios-volume-low:before,.ion-ios-wineglass-outline:before,.ion-ios-wineglass:before,.ion-ios-world-outline:before,.ion-ios-world:before,.ion-ipad:before,.ion-iphone:before,.ion-ipod:before,.ion-jet:before,.ion-key:before,.ion-knife:before,.ion-laptop:before,.ion-leaf:before,.ion-levels:before,.ion-lightbulb:before,.ion-link:before,.ion-load-a:before,.ion-load-b:before,.ion-load-c:before,.ion-load-d:before,.ion-location:before,.ion-lock-combination:before,.ion-locked:before,.ion-log-in:before,.ion-log-out:before,.ion-loop:before,.ion-magnet:before,.ion-male:before,.ion-man:before,.ion-map:before,.ion-medkit:before,.ion-merge:before,.ion-mic-a:before,.ion-mic-b:before,.ion-mic-c:before,.ion-minus-circled:before,.ion-minus-round:before,.ion-minus:before,.ion-model-s:before,.ion-monitor:before,.ion-more:before,.ion-mouse:before,.ion-music-note:before,.ion-navicon-round:before,.ion-navicon:before,.ion-navigate:before,.ion-network:before,.ion-no-smoking:before,.ion-nuclear:before,.ion-outlet:before,.ion-paintbrush:before,.ion-paintbucket:before,.ion-paper-airplane:before,.ion-paperclip:before,.ion-pause:before,.ion-person-add:before,.ion-person-stalker:before,.ion-person:before,.ion-pie-graph:before,.ion-pin:before,.ion-pinpoint:before,.ion-pizza:before,.ion-plane:before,.ion-planet:before,.ion-play:before,.ion-playstation:before,.ion-plus-circled:before,.ion-plus-round:before,.ion-plus:before,.ion-podium:before,.ion-pound:before,.ion-power:before,.ion-pricetag:before,.ion-pricetags:before,.ion-printer:before,.ion-pull-request:before,.ion-qr-scanner:before,.ion-quote:before,.ion-radio-waves:before,.ion-record:before,.ion-refresh:before,.ion-reply-all:before,.ion-reply:before,.ion-ribbon-a:before,.ion-ribbon-b:before,.ion-sad-outline:before,.ion-sad:before,.ion-scissors:before,.ion-search:before,.ion-settings:before,.ion-share:before,.ion-shuffle:before,.ion-skip-backward:before,.ion-skip-forward:before,.ion-social-android-outline:before,.ion-social-android:before,.ion-social-angular-outline:before,.ion-social-angular:before,.ion-social-apple-outline:before,.ion-social-apple:before,.ion-social-bitcoin-outline:before,.ion-social-bitcoin:before,.ion-social-buffer-outline:before,.ion-social-buffer:before,.ion-social-chrome-outline:before,.ion-social-chrome:before,.ion-social-codepen-outline:before,.ion-social-codepen:before,.ion-social-css3-outline:before,.ion-social-css3:before,.ion-social-designernews-outline:before,.ion-social-designernews:before,.ion-social-dribbble-outline:before,.ion-social-dribbble:before,.ion-social-dropbox-outline:before,.ion-social-dropbox:before,.ion-social-euro-outline:before,.ion-social-euro:before,.ion-social-facebook-outline:before,.ion-social-facebook:before,.ion-social-foursquare-outline:before,.ion-social-foursquare:before,.ion-social-freebsd-devil:before,.ion-social-github-outline:before,.ion-social-github:before,.ion-social-google-outline:before,.ion-social-google:before,.ion-social-googleplus-outline:before,.ion-social-googleplus:before,.ion-social-hackernews-outline:before,.ion-social-hackernews:before,.ion-social-html5-outline:before,.ion-social-html5:before,.ion-social-instagram-outline:before,.ion-social-instagram:before,.ion-social-javascript-outline:before,.ion-social-javascript:before,.ion-social-linkedin-outline:before,.ion-social-linkedin:before,.ion-social-markdown:before,.ion-social-nodejs:before,.ion-social-octocat:before,.ion-social-pinterest-outline:before,.ion-social-pinterest:before,.ion-social-python:before,.ion-social-reddit-outline:before,.ion-social-reddit:before,.ion-social-rss-outline:before,.ion-social-rss:before,.ion-social-sass:before,.ion-social-skype-outline:before,.ion-social-skype:before,.ion-social-snapchat-outline:before,.ion-social-snapchat:before,.ion-social-tumblr-outline:before,.ion-social-tumblr:before,.ion-social-tux:before,.ion-social-twitch-outline:before,.ion-social-twitch:before,.ion-social-twitter-outline:before,.ion-social-twitter:before,.ion-social-usd-outline:before,.ion-social-usd:before,.ion-social-vimeo-outline:before,.ion-social-vimeo:before,.ion-social-whatsapp-outline:before,.ion-social-whatsapp:before,.ion-social-windows-outline:before,.ion-social-windows:before,.ion-social-wordpress-outline:before,.ion-social-wordpress:before,.ion-social-yahoo-outline:before,.ion-social-yahoo:before,.ion-social-yen-outline:before,.ion-social-yen:before,.ion-social-youtube-outline:before,.ion-social-youtube:before,.ion-soup-can-outline:before,.ion-soup-can:before,.ion-speakerphone:before,.ion-speedometer:before,.ion-spoon:before,.ion-star:before,.ion-stats-bars:before,.ion-steam:before,.ion-stop:before,.ion-thermometer:before,.ion-thumbsdown:before,.ion-thumbsup:before,.ion-toggle-filled:before,.ion-toggle:before,.ion-transgender:before,.ion-trash-a:before,.ion-trash-b:before,.ion-trophy:before,.ion-tshirt-outline:before,.ion-tshirt:before,.ion-umbrella:before,.ion-university:before,.ion-unlocked:before,.ion-upload:before,.ion-usb:before,.ion-videocamera:before,.ion-volume-high:before,.ion-volume-low:before,.ion-volume-medium:before,.ion-volume-mute:before,.ion-wand:before,.ion-waterdrop:before,.ion-wifi:before,.ion-wineglass:before,.ion-woman:before,.ion-wrench:before,.ion-xbox:before,.ionicons{display:inline-block;font-family:Ionicons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;text-rendering:auto;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ion-alert:before{content:\"\\F101\"}.ion-alert-circled:before{content:\"\\F100\"}.ion-android-add:before{content:\"\\F2C7\"}.ion-android-add-circle:before{content:\"\\F359\"}.ion-android-alarm-clock:before{content:\"\\F35A\"}.ion-android-alert:before{content:\"\\F35B\"}.ion-android-apps:before{content:\"\\F35C\"}.ion-android-archive:before{content:\"\\F2C9\"}.ion-android-arrow-back:before{content:\"\\F2CA\"}.ion-android-arrow-down:before{content:\"\\F35D\"}.ion-android-arrow-dropdown:before{content:\"\\F35F\"}.ion-android-arrow-dropdown-circle:before{content:\"\\F35E\"}.ion-android-arrow-dropleft:before{content:\"\\F361\"}.ion-android-arrow-dropleft-circle:before{content:\"\\F360\"}.ion-android-arrow-dropright:before{content:\"\\F363\"}.ion-android-arrow-dropright-circle:before{content:\"\\F362\"}.ion-android-arrow-dropup:before{content:\"\\F365\"}.ion-android-arrow-dropup-circle:before{content:\"\\F364\"}.ion-android-arrow-forward:before{content:\"\\F30F\"}.ion-android-arrow-up:before{content:\"\\F366\"}.ion-android-attach:before{content:\"\\F367\"}.ion-android-bar:before{content:\"\\F368\"}.ion-android-bicycle:before{content:\"\\F369\"}.ion-android-boat:before{content:\"\\F36A\"}.ion-android-bookmark:before{content:\"\\F36B\"}.ion-android-bulb:before{content:\"\\F36C\"}.ion-android-bus:before{content:\"\\F36D\"}.ion-android-calendar:before{content:\"\\F2D1\"}.ion-android-call:before{content:\"\\F2D2\"}.ion-android-camera:before{content:\"\\F2D3\"}.ion-android-cancel:before{content:\"\\F36E\"}.ion-android-car:before{content:\"\\F36F\"}.ion-android-cart:before{content:\"\\F370\"}.ion-android-chat:before{content:\"\\F2D4\"}.ion-android-checkbox:before{content:\"\\F374\"}.ion-android-checkbox-blank:before{content:\"\\F371\"}.ion-android-checkbox-outline:before{content:\"\\F373\"}.ion-android-checkbox-outline-blank:before{content:\"\\F372\"}.ion-android-checkmark-circle:before{content:\"\\F375\"}.ion-android-clipboard:before{content:\"\\F376\"}.ion-android-close:before{content:\"\\F2D7\"}.ion-android-cloud:before{content:\"\\F37A\"}.ion-android-cloud-circle:before{content:\"\\F377\"}.ion-android-cloud-done:before{content:\"\\F378\"}.ion-android-cloud-outline:before{content:\"\\F379\"}.ion-android-color-palette:before{content:\"\\F37B\"}.ion-android-compass:before{content:\"\\F37C\"}.ion-android-contact:before{content:\"\\F2D8\"}.ion-android-contacts:before{content:\"\\F2D9\"}.ion-android-contract:before{content:\"\\F37D\"}.ion-android-create:before{content:\"\\F37E\"}.ion-android-delete:before{content:\"\\F37F\"}.ion-android-desktop:before{content:\"\\F380\"}.ion-android-document:before{content:\"\\F381\"}.ion-android-done:before{content:\"\\F383\"}.ion-android-done-all:before{content:\"\\F382\"}.ion-android-download:before{content:\"\\F2DD\"}.ion-android-drafts:before{content:\"\\F384\"}.ion-android-exit:before{content:\"\\F385\"}.ion-android-expand:before{content:\"\\F386\"}.ion-android-favorite:before{content:\"\\F388\"}.ion-android-favorite-outline:before{content:\"\\F387\"}.ion-android-film:before{content:\"\\F389\"}.ion-android-folder:before{content:\"\\F2E0\"}.ion-android-folder-open:before{content:\"\\F38A\"}.ion-android-funnel:before{content:\"\\F38B\"}.ion-android-globe:before{content:\"\\F38C\"}.ion-android-hand:before{content:\"\\F2E3\"}.ion-android-hangout:before{content:\"\\F38D\"}.ion-android-happy:before{content:\"\\F38E\"}.ion-android-home:before{content:\"\\F38F\"}.ion-android-image:before{content:\"\\F2E4\"}.ion-android-laptop:before{content:\"\\F390\"}.ion-android-list:before{content:\"\\F391\"}.ion-android-locate:before{content:\"\\F2E9\"}.ion-android-lock:before{content:\"\\F392\"}.ion-android-mail:before{content:\"\\F2EB\"}.ion-android-map:before{content:\"\\F393\"}.ion-android-menu:before{content:\"\\F394\"}.ion-android-microphone:before{content:\"\\F2EC\"}.ion-android-microphone-off:before{content:\"\\F395\"}.ion-android-more-horizontal:before{content:\"\\F396\"}.ion-android-more-vertical:before{content:\"\\F397\"}.ion-android-navigate:before{content:\"\\F398\"}.ion-android-notifications:before{content:\"\\F39B\"}.ion-android-notifications-none:before{content:\"\\F399\"}.ion-android-notifications-off:before{content:\"\\F39A\"}.ion-android-open:before{content:\"\\F39C\"}.ion-android-options:before{content:\"\\F39D\"}.ion-android-people:before{content:\"\\F39E\"}.ion-android-person:before{content:\"\\F3A0\"}.ion-android-person-add:before{content:\"\\F39F\"}.ion-android-phone-landscape:before{content:\"\\F3A1\"}.ion-android-phone-portrait:before{content:\"\\F3A2\"}.ion-android-pin:before{content:\"\\F3A3\"}.ion-android-plane:before{content:\"\\F3A4\"}.ion-android-playstore:before{content:\"\\F2F0\"}.ion-android-print:before{content:\"\\F3A5\"}.ion-android-radio-button-off:before{content:\"\\F3A6\"}.ion-android-radio-button-on:before{content:\"\\F3A7\"}.ion-android-refresh:before{content:\"\\F3A8\"}.ion-android-remove:before{content:\"\\F2F4\"}.ion-android-remove-circle:before{content:\"\\F3A9\"}.ion-android-restaurant:before{content:\"\\F3AA\"}.ion-android-sad:before{content:\"\\F3AB\"}.ion-android-search:before{content:\"\\F2F5\"}.ion-android-send:before{content:\"\\F2F6\"}.ion-android-settings:before{content:\"\\F2F7\"}.ion-android-share:before{content:\"\\F2F8\"}.ion-android-share-alt:before{content:\"\\F3AC\"}.ion-android-star:before{content:\"\\F2FC\"}.ion-android-star-half:before{content:\"\\F3AD\"}.ion-android-star-outline:before{content:\"\\F3AE\"}.ion-android-stopwatch:before{content:\"\\F2FD\"}.ion-android-subway:before{content:\"\\F3AF\"}.ion-android-sunny:before{content:\"\\F3B0\"}.ion-android-sync:before{content:\"\\F3B1\"}.ion-android-textsms:before{content:\"\\F3B2\"}.ion-android-time:before{content:\"\\F3B3\"}.ion-android-train:before{content:\"\\F3B4\"}.ion-android-unlock:before{content:\"\\F3B5\"}.ion-android-upload:before{content:\"\\F3B6\"}.ion-android-volume-down:before{content:\"\\F3B7\"}.ion-android-volume-mute:before{content:\"\\F3B8\"}.ion-android-volume-off:before{content:\"\\F3B9\"}.ion-android-volume-up:before{content:\"\\F3BA\"}.ion-android-walk:before{content:\"\\F3BB\"}.ion-android-warning:before{content:\"\\F3BC\"}.ion-android-watch:before{content:\"\\F3BD\"}.ion-android-wifi:before{content:\"\\F305\"}.ion-aperture:before{content:\"\\F313\"}.ion-archive:before{content:\"\\F102\"}.ion-arrow-down-a:before{content:\"\\F103\"}.ion-arrow-down-b:before{content:\"\\F104\"}.ion-arrow-down-c:before{content:\"\\F105\"}.ion-arrow-expand:before{content:\"\\F25E\"}.ion-arrow-graph-down-left:before{content:\"\\F25F\"}.ion-arrow-graph-down-right:before{content:\"\\F260\"}.ion-arrow-graph-up-left:before{content:\"\\F261\"}.ion-arrow-graph-up-right:before{content:\"\\F262\"}.ion-arrow-left-a:before{content:\"\\F106\"}.ion-arrow-left-b:before{content:\"\\F107\"}.ion-arrow-left-c:before{content:\"\\F108\"}.ion-arrow-move:before{content:\"\\F263\"}.ion-arrow-resize:before{content:\"\\F264\"}.ion-arrow-return-left:before{content:\"\\F265\"}.ion-arrow-return-right:before{content:\"\\F266\"}.ion-arrow-right-a:before{content:\"\\F109\"}.ion-arrow-right-b:before{content:\"\\F10A\"}.ion-arrow-right-c:before{content:\"\\F10B\"}.ion-arrow-shrink:before{content:\"\\F267\"}.ion-arrow-swap:before{content:\"\\F268\"}.ion-arrow-up-a:before{content:\"\\F10C\"}.ion-arrow-up-b:before{content:\"\\F10D\"}.ion-arrow-up-c:before{content:\"\\F10E\"}.ion-asterisk:before{content:\"\\F314\"}.ion-at:before{content:\"\\F10F\"}.ion-backspace:before{content:\"\\F3BF\"}.ion-backspace-outline:before{content:\"\\F3BE\"}.ion-bag:before{content:\"\\F110\"}.ion-battery-charging:before{content:\"\\F111\"}.ion-battery-empty:before{content:\"\\F112\"}.ion-battery-full:before{content:\"\\F113\"}.ion-battery-half:before{content:\"\\F114\"}.ion-battery-low:before{content:\"\\F115\"}.ion-beaker:before{content:\"\\F269\"}.ion-beer:before{content:\"\\F26A\"}.ion-bluetooth:before{content:\"\\F116\"}.ion-bonfire:before{content:\"\\F315\"}.ion-bookmark:before{content:\"\\F26B\"}.ion-bowtie:before{content:\"\\F3C0\"}.ion-briefcase:before{content:\"\\F26C\"}.ion-bug:before{content:\"\\F2BE\"}.ion-calculator:before{content:\"\\F26D\"}.ion-calendar:before{content:\"\\F117\"}.ion-camera:before{content:\"\\F118\"}.ion-card:before{content:\"\\F119\"}.ion-cash:before{content:\"\\F316\"}.ion-chatbox:before{content:\"\\F11B\"}.ion-chatbox-working:before{content:\"\\F11A\"}.ion-chatboxes:before{content:\"\\F11C\"}.ion-chatbubble:before{content:\"\\F11E\"}.ion-chatbubble-working:before{content:\"\\F11D\"}.ion-chatbubbles:before{content:\"\\F11F\"}.ion-checkmark:before{content:\"\\F122\"}.ion-checkmark-circled:before{content:\"\\F120\"}.ion-checkmark-round:before{content:\"\\F121\"}.ion-chevron-down:before{content:\"\\F123\"}.ion-chevron-left:before{content:\"\\F124\"}.ion-chevron-right:before{content:\"\\F125\"}.ion-chevron-up:before{content:\"\\F126\"}.ion-clipboard:before{content:\"\\F127\"}.ion-clock:before{content:\"\\F26E\"}.ion-close:before{content:\"\\F12A\"}.ion-close-circled:before{content:\"\\F128\"}.ion-close-round:before{content:\"\\F129\"}.ion-closed-captioning:before{content:\"\\F317\"}.ion-cloud:before{content:\"\\F12B\"}.ion-code:before{content:\"\\F271\"}.ion-code-download:before{content:\"\\F26F\"}.ion-code-working:before{content:\"\\F270\"}.ion-coffee:before{content:\"\\F272\"}.ion-compass:before{content:\"\\F273\"}.ion-compose:before{content:\"\\F12C\"}.ion-connection-bars:before{content:\"\\F274\"}.ion-contrast:before{content:\"\\F275\"}.ion-crop:before{content:\"\\F3C1\"}.ion-cube:before{content:\"\\F318\"}.ion-disc:before{content:\"\\F12D\"}.ion-document:before{content:\"\\F12F\"}.ion-document-text:before{content:\"\\F12E\"}.ion-drag:before{content:\"\\F130\"}.ion-earth:before{content:\"\\F276\"}.ion-easel:before{content:\"\\F3C2\"}.ion-edit:before{content:\"\\F2BF\"}.ion-egg:before{content:\"\\F277\"}.ion-eject:before{content:\"\\F131\"}.ion-email:before{content:\"\\F132\"}.ion-email-unread:before{content:\"\\F3C3\"}.ion-erlenmeyer-flask:before{content:\"\\F3C5\"}.ion-erlenmeyer-flask-bubbles:before{content:\"\\F3C4\"}.ion-eye:before{content:\"\\F133\"}.ion-eye-disabled:before{content:\"\\F306\"}.ion-female:before{content:\"\\F278\"}.ion-filing:before{content:\"\\F134\"}.ion-film-marker:before{content:\"\\F135\"}.ion-fireball:before{content:\"\\F319\"}.ion-flag:before{content:\"\\F279\"}.ion-flame:before{content:\"\\F31A\"}.ion-flash:before{content:\"\\F137\"}.ion-flash-off:before{content:\"\\F136\"}.ion-folder:before{content:\"\\F139\"}.ion-fork:before{content:\"\\F27A\"}.ion-fork-repo:before{content:\"\\F2C0\"}.ion-forward:before{content:\"\\F13A\"}.ion-funnel:before{content:\"\\F31B\"}.ion-gear-a:before{content:\"\\F13D\"}.ion-gear-b:before{content:\"\\F13E\"}.ion-grid:before{content:\"\\F13F\"}.ion-hammer:before{content:\"\\F27B\"}.ion-happy:before{content:\"\\F31C\"}.ion-happy-outline:before{content:\"\\F3C6\"}.ion-headphone:before{content:\"\\F140\"}.ion-heart:before{content:\"\\F141\"}.ion-heart-broken:before{content:\"\\F31D\"}.ion-help:before{content:\"\\F143\"}.ion-help-buoy:before{content:\"\\F27C\"}.ion-help-circled:before{content:\"\\F142\"}.ion-home:before{content:\"\\F144\"}.ion-icecream:before{content:\"\\F27D\"}.ion-image:before{content:\"\\F147\"}.ion-images:before{content:\"\\F148\"}.ion-information:before{content:\"\\F14A\"}.ion-information-circled:before{content:\"\\F149\"}.ion-ionic:before{content:\"\\F14B\"}.ion-ios-alarm:before{content:\"\\F3C8\"}.ion-ios-alarm-outline:before{content:\"\\F3C7\"}.ion-ios-albums:before{content:\"\\F3CA\"}.ion-ios-albums-outline:before{content:\"\\F3C9\"}.ion-ios-americanfootball:before{content:\"\\F3CC\"}.ion-ios-americanfootball-outline:before{content:\"\\F3CB\"}.ion-ios-analytics:before{content:\"\\F3CE\"}.ion-ios-analytics-outline:before{content:\"\\F3CD\"}.ion-ios-arrow-back:before{content:\"\\F3CF\"}.ion-ios-arrow-down:before{content:\"\\F3D0\"}.ion-ios-arrow-forward:before{content:\"\\F3D1\"}.ion-ios-arrow-left:before{content:\"\\F3D2\"}.ion-ios-arrow-right:before{content:\"\\F3D3\"}.ion-ios-arrow-thin-down:before{content:\"\\F3D4\"}.ion-ios-arrow-thin-left:before{content:\"\\F3D5\"}.ion-ios-arrow-thin-right:before{content:\"\\F3D6\"}.ion-ios-arrow-thin-up:before{content:\"\\F3D7\"}.ion-ios-arrow-up:before{content:\"\\F3D8\"}.ion-ios-at:before{content:\"\\F3DA\"}.ion-ios-at-outline:before{content:\"\\F3D9\"}.ion-ios-barcode:before{content:\"\\F3DC\"}.ion-ios-barcode-outline:before{content:\"\\F3DB\"}.ion-ios-baseball:before{content:\"\\F3DE\"}.ion-ios-baseball-outline:before{content:\"\\F3DD\"}.ion-ios-basketball:before{content:\"\\F3E0\"}.ion-ios-basketball-outline:before{content:\"\\F3DF\"}.ion-ios-bell:before{content:\"\\F3E2\"}.ion-ios-bell-outline:before{content:\"\\F3E1\"}.ion-ios-body:before{content:\"\\F3E4\"}.ion-ios-body-outline:before{content:\"\\F3E3\"}.ion-ios-bolt:before{content:\"\\F3E6\"}.ion-ios-bolt-outline:before{content:\"\\F3E5\"}.ion-ios-book:before{content:\"\\F3E8\"}.ion-ios-book-outline:before{content:\"\\F3E7\"}.ion-ios-bookmarks:before{content:\"\\F3EA\"}.ion-ios-bookmarks-outline:before{content:\"\\F3E9\"}.ion-ios-box:before{content:\"\\F3EC\"}.ion-ios-box-outline:before{content:\"\\F3EB\"}.ion-ios-briefcase:before{content:\"\\F3EE\"}.ion-ios-briefcase-outline:before{content:\"\\F3ED\"}.ion-ios-browsers:before{content:\"\\F3F0\"}.ion-ios-browsers-outline:before{content:\"\\F3EF\"}.ion-ios-calculator:before{content:\"\\F3F2\"}.ion-ios-calculator-outline:before{content:\"\\F3F1\"}.ion-ios-calendar:before{content:\"\\F3F4\"}.ion-ios-calendar-outline:before{content:\"\\F3F3\"}.ion-ios-camera:before{content:\"\\F3F6\"}.ion-ios-camera-outline:before{content:\"\\F3F5\"}.ion-ios-cart:before{content:\"\\F3F8\"}.ion-ios-cart-outline:before{content:\"\\F3F7\"}.ion-ios-chatboxes:before{content:\"\\F3FA\"}.ion-ios-chatboxes-outline:before{content:\"\\F3F9\"}.ion-ios-chatbubble:before{content:\"\\F3FC\"}.ion-ios-chatbubble-outline:before{content:\"\\F3FB\"}.ion-ios-checkmark:before{content:\"\\F3FF\"}.ion-ios-checkmark-empty:before{content:\"\\F3FD\"}.ion-ios-checkmark-outline:before{content:\"\\F3FE\"}.ion-ios-circle-filled:before{content:\"\\F400\"}.ion-ios-circle-outline:before{content:\"\\F401\"}.ion-ios-clock:before{content:\"\\F403\"}.ion-ios-clock-outline:before{content:\"\\F402\"}.ion-ios-close:before{content:\"\\F406\"}.ion-ios-close-empty:before{content:\"\\F404\"}.ion-ios-close-outline:before{content:\"\\F405\"}.ion-ios-cloud:before{content:\"\\F40C\"}.ion-ios-cloud-download:before{content:\"\\F408\"}.ion-ios-cloud-download-outline:before{content:\"\\F407\"}.ion-ios-cloud-outline:before{content:\"\\F409\"}.ion-ios-cloud-upload:before{content:\"\\F40B\"}.ion-ios-cloud-upload-outline:before{content:\"\\F40A\"}.ion-ios-cloudy:before{content:\"\\F410\"}.ion-ios-cloudy-night:before{content:\"\\F40E\"}.ion-ios-cloudy-night-outline:before{content:\"\\F40D\"}.ion-ios-cloudy-outline:before{content:\"\\F40F\"}.ion-ios-cog:before{content:\"\\F412\"}.ion-ios-cog-outline:before{content:\"\\F411\"}.ion-ios-color-filter:before{content:\"\\F414\"}.ion-ios-color-filter-outline:before{content:\"\\F413\"}.ion-ios-color-wand:before{content:\"\\F416\"}.ion-ios-color-wand-outline:before{content:\"\\F415\"}.ion-ios-compose:before{content:\"\\F418\"}.ion-ios-compose-outline:before{content:\"\\F417\"}.ion-ios-contact:before{content:\"\\F41A\"}.ion-ios-contact-outline:before{content:\"\\F419\"}.ion-ios-copy:before{content:\"\\F41C\"}.ion-ios-copy-outline:before{content:\"\\F41B\"}.ion-ios-crop:before{content:\"\\F41E\"}.ion-ios-crop-strong:before{content:\"\\F41D\"}.ion-ios-download:before{content:\"\\F420\"}.ion-ios-download-outline:before{content:\"\\F41F\"}.ion-ios-drag:before{content:\"\\F421\"}.ion-ios-email:before{content:\"\\F423\"}.ion-ios-email-outline:before{content:\"\\F422\"}.ion-ios-eye:before{content:\"\\F425\"}.ion-ios-eye-outline:before{content:\"\\F424\"}.ion-ios-fastforward:before{content:\"\\F427\"}.ion-ios-fastforward-outline:before{content:\"\\F426\"}.ion-ios-filing:before{content:\"\\F429\"}.ion-ios-filing-outline:before{content:\"\\F428\"}.ion-ios-film:before{content:\"\\F42B\"}.ion-ios-film-outline:before{content:\"\\F42A\"}.ion-ios-flag:before{content:\"\\F42D\"}.ion-ios-flag-outline:before{content:\"\\F42C\"}.ion-ios-flame:before{content:\"\\F42F\"}.ion-ios-flame-outline:before{content:\"\\F42E\"}.ion-ios-flask:before{content:\"\\F431\"}.ion-ios-flask-outline:before{content:\"\\F430\"}.ion-ios-flower:before{content:\"\\F433\"}.ion-ios-flower-outline:before{content:\"\\F432\"}.ion-ios-folder:before{content:\"\\F435\"}.ion-ios-folder-outline:before{content:\"\\F434\"}.ion-ios-football:before{content:\"\\F437\"}.ion-ios-football-outline:before{content:\"\\F436\"}.ion-ios-game-controller-a:before{content:\"\\F439\"}.ion-ios-game-controller-a-outline:before{content:\"\\F438\"}.ion-ios-game-controller-b:before{content:\"\\F43B\"}.ion-ios-game-controller-b-outline:before{content:\"\\F43A\"}.ion-ios-gear:before{content:\"\\F43D\"}.ion-ios-gear-outline:before{content:\"\\F43C\"}.ion-ios-glasses:before{content:\"\\F43F\"}.ion-ios-glasses-outline:before{content:\"\\F43E\"}.ion-ios-grid-view:before{content:\"\\F441\"}.ion-ios-grid-view-outline:before{content:\"\\F440\"}.ion-ios-heart:before{content:\"\\F443\"}.ion-ios-heart-outline:before{content:\"\\F442\"}.ion-ios-help:before{content:\"\\F446\"}.ion-ios-help-empty:before{content:\"\\F444\"}.ion-ios-help-outline:before{content:\"\\F445\"}.ion-ios-home:before{content:\"\\F448\"}.ion-ios-home-outline:before{content:\"\\F447\"}.ion-ios-infinite:before{content:\"\\F44A\"}.ion-ios-infinite-outline:before{content:\"\\F449\"}.ion-ios-information:before{content:\"\\F44D\"}.ion-ios-information-empty:before{content:\"\\F44B\"}.ion-ios-information-outline:before{content:\"\\F44C\"}.ion-ios-ionic-outline:before{content:\"\\F44E\"}.ion-ios-keypad:before{content:\"\\F450\"}.ion-ios-keypad-outline:before{content:\"\\F44F\"}.ion-ios-lightbulb:before{content:\"\\F452\"}.ion-ios-lightbulb-outline:before{content:\"\\F451\"}.ion-ios-list:before{content:\"\\F454\"}.ion-ios-list-outline:before{content:\"\\F453\"}.ion-ios-location:before{content:\"\\F456\"}.ion-ios-location-outline:before{content:\"\\F455\"}.ion-ios-locked:before{content:\"\\F458\"}.ion-ios-locked-outline:before{content:\"\\F457\"}.ion-ios-loop:before{content:\"\\F45A\"}.ion-ios-loop-strong:before{content:\"\\F459\"}.ion-ios-medical:before{content:\"\\F45C\"}.ion-ios-medical-outline:before{content:\"\\F45B\"}.ion-ios-medkit:before{content:\"\\F45E\"}.ion-ios-medkit-outline:before{content:\"\\F45D\"}.ion-ios-mic:before{content:\"\\F461\"}.ion-ios-mic-off:before{content:\"\\F45F\"}.ion-ios-mic-outline:before{content:\"\\F460\"}.ion-ios-minus:before{content:\"\\F464\"}.ion-ios-minus-empty:before{content:\"\\F462\"}.ion-ios-minus-outline:before{content:\"\\F463\"}.ion-ios-monitor:before{content:\"\\F466\"}.ion-ios-monitor-outline:before{content:\"\\F465\"}.ion-ios-moon:before{content:\"\\F468\"}.ion-ios-moon-outline:before{content:\"\\F467\"}.ion-ios-more:before{content:\"\\F46A\"}.ion-ios-more-outline:before{content:\"\\F469\"}.ion-ios-musical-note:before{content:\"\\F46B\"}.ion-ios-musical-notes:before{content:\"\\F46C\"}.ion-ios-navigate:before{content:\"\\F46E\"}.ion-ios-navigate-outline:before{content:\"\\F46D\"}.ion-ios-nutrition:before{content:\"\\F470\"}.ion-ios-nutrition-outline:before{content:\"\\F46F\"}.ion-ios-paper:before{content:\"\\F472\"}.ion-ios-paper-outline:before{content:\"\\F471\"}.ion-ios-paperplane:before{content:\"\\F474\"}.ion-ios-paperplane-outline:before{content:\"\\F473\"}.ion-ios-partlysunny:before{content:\"\\F476\"}.ion-ios-partlysunny-outline:before{content:\"\\F475\"}.ion-ios-pause:before{content:\"\\F478\"}.ion-ios-pause-outline:before{content:\"\\F477\"}.ion-ios-paw:before{content:\"\\F47A\"}.ion-ios-paw-outline:before{content:\"\\F479\"}.ion-ios-people:before{content:\"\\F47C\"}.ion-ios-people-outline:before{content:\"\\F47B\"}.ion-ios-person:before{content:\"\\F47E\"}.ion-ios-person-outline:before{content:\"\\F47D\"}.ion-ios-personadd:before{content:\"\\F480\"}.ion-ios-personadd-outline:before{content:\"\\F47F\"}.ion-ios-photos:before{content:\"\\F482\"}.ion-ios-photos-outline:before{content:\"\\F481\"}.ion-ios-pie:before{content:\"\\F484\"}.ion-ios-pie-outline:before{content:\"\\F483\"}.ion-ios-pint:before{content:\"\\F486\"}.ion-ios-pint-outline:before{content:\"\\F485\"}.ion-ios-play:before{content:\"\\F488\"}.ion-ios-play-outline:before{content:\"\\F487\"}.ion-ios-plus:before{content:\"\\F48B\"}.ion-ios-plus-empty:before{content:\"\\F489\"}.ion-ios-plus-outline:before{content:\"\\F48A\"}.ion-ios-pricetag:before{content:\"\\F48D\"}.ion-ios-pricetag-outline:before{content:\"\\F48C\"}.ion-ios-pricetags:before{content:\"\\F48F\"}.ion-ios-pricetags-outline:before{content:\"\\F48E\"}.ion-ios-printer:before{content:\"\\F491\"}.ion-ios-printer-outline:before{content:\"\\F490\"}.ion-ios-pulse:before{content:\"\\F493\"}.ion-ios-pulse-strong:before{content:\"\\F492\"}.ion-ios-rainy:before{content:\"\\F495\"}.ion-ios-rainy-outline:before{content:\"\\F494\"}.ion-ios-recording:before{content:\"\\F497\"}.ion-ios-recording-outline:before{content:\"\\F496\"}.ion-ios-redo:before{content:\"\\F499\"}.ion-ios-redo-outline:before{content:\"\\F498\"}.ion-ios-refresh:before{content:\"\\F49C\"}.ion-ios-refresh-empty:before{content:\"\\F49A\"}.ion-ios-refresh-outline:before{content:\"\\F49B\"}.ion-ios-reload:before{content:\"\\F49D\"}.ion-ios-reverse-camera:before{content:\"\\F49F\"}.ion-ios-reverse-camera-outline:before{content:\"\\F49E\"}.ion-ios-rewind:before{content:\"\\F4A1\"}.ion-ios-rewind-outline:before{content:\"\\F4A0\"}.ion-ios-rose:before{content:\"\\F4A3\"}.ion-ios-rose-outline:before{content:\"\\F4A2\"}.ion-ios-search:before{content:\"\\F4A5\"}.ion-ios-search-strong:before{content:\"\\F4A4\"}.ion-ios-settings:before{content:\"\\F4A7\"}.ion-ios-settings-strong:before{content:\"\\F4A6\"}.ion-ios-shuffle:before{content:\"\\F4A9\"}.ion-ios-shuffle-strong:before{content:\"\\F4A8\"}.ion-ios-skipbackward:before{content:\"\\F4AB\"}.ion-ios-skipbackward-outline:before{content:\"\\F4AA\"}.ion-ios-skipforward:before{content:\"\\F4AD\"}.ion-ios-skipforward-outline:before{content:\"\\F4AC\"}.ion-ios-snowy:before{content:\"\\F4AE\"}.ion-ios-speedometer:before{content:\"\\F4B0\"}.ion-ios-speedometer-outline:before{content:\"\\F4AF\"}.ion-ios-star:before{content:\"\\F4B3\"}.ion-ios-star-half:before{content:\"\\F4B1\"}.ion-ios-star-outline:before{content:\"\\F4B2\"}.ion-ios-stopwatch:before{content:\"\\F4B5\"}.ion-ios-stopwatch-outline:before{content:\"\\F4B4\"}.ion-ios-sunny:before{content:\"\\F4B7\"}.ion-ios-sunny-outline:before{content:\"\\F4B6\"}.ion-ios-telephone:before{content:\"\\F4B9\"}.ion-ios-telephone-outline:before{content:\"\\F4B8\"}.ion-ios-tennisball:before{content:\"\\F4BB\"}.ion-ios-tennisball-outline:before{content:\"\\F4BA\"}.ion-ios-thunderstorm:before{content:\"\\F4BD\"}.ion-ios-thunderstorm-outline:before{content:\"\\F4BC\"}.ion-ios-time:before{content:\"\\F4BF\"}.ion-ios-time-outline:before{content:\"\\F4BE\"}.ion-ios-timer:before{content:\"\\F4C1\"}.ion-ios-timer-outline:before{content:\"\\F4C0\"}.ion-ios-toggle:before{content:\"\\F4C3\"}.ion-ios-toggle-outline:before{content:\"\\F4C2\"}.ion-ios-trash:before{content:\"\\F4C5\"}.ion-ios-trash-outline:before{content:\"\\F4C4\"}.ion-ios-undo:before{content:\"\\F4C7\"}.ion-ios-undo-outline:before{content:\"\\F4C6\"}.ion-ios-unlocked:before{content:\"\\F4C9\"}.ion-ios-unlocked-outline:before{content:\"\\F4C8\"}.ion-ios-upload:before{content:\"\\F4CB\"}.ion-ios-upload-outline:before{content:\"\\F4CA\"}.ion-ios-videocam:before{content:\"\\F4CD\"}.ion-ios-videocam-outline:before{content:\"\\F4CC\"}.ion-ios-volume-high:before{content:\"\\F4CE\"}.ion-ios-volume-low:before{content:\"\\F4CF\"}.ion-ios-wineglass:before{content:\"\\F4D1\"}.ion-ios-wineglass-outline:before{content:\"\\F4D0\"}.ion-ios-world:before{content:\"\\F4D3\"}.ion-ios-world-outline:before{content:\"\\F4D2\"}.ion-ipad:before{content:\"\\F1F9\"}.ion-iphone:before{content:\"\\F1FA\"}.ion-ipod:before{content:\"\\F1FB\"}.ion-jet:before{content:\"\\F295\"}.ion-key:before{content:\"\\F296\"}.ion-knife:before{content:\"\\F297\"}.ion-laptop:before{content:\"\\F1FC\"}.ion-leaf:before{content:\"\\F1FD\"}.ion-levels:before{content:\"\\F298\"}.ion-lightbulb:before{content:\"\\F299\"}.ion-link:before{content:\"\\F1FE\"}.ion-load-a:before{content:\"\\F29A\"}.ion-load-b:before{content:\"\\F29B\"}.ion-load-c:before{content:\"\\F29C\"}.ion-load-d:before{content:\"\\F29D\"}.ion-location:before{content:\"\\F1FF\"}.ion-lock-combination:before{content:\"\\F4D4\"}.ion-locked:before{content:\"\\F200\"}.ion-log-in:before{content:\"\\F29E\"}.ion-log-out:before{content:\"\\F29F\"}.ion-loop:before{content:\"\\F201\"}.ion-magnet:before{content:\"\\F2A0\"}.ion-male:before{content:\"\\F2A1\"}.ion-man:before{content:\"\\F202\"}.ion-map:before{content:\"\\F203\"}.ion-medkit:before{content:\"\\F2A2\"}.ion-merge:before{content:\"\\F33F\"}.ion-mic-a:before{content:\"\\F204\"}.ion-mic-b:before{content:\"\\F205\"}.ion-mic-c:before{content:\"\\F206\"}.ion-minus:before{content:\"\\F209\"}.ion-minus-circled:before{content:\"\\F207\"}.ion-minus-round:before{content:\"\\F208\"}.ion-model-s:before{content:\"\\F2C1\"}.ion-monitor:before{content:\"\\F20A\"}.ion-more:before{content:\"\\F20B\"}.ion-mouse:before{content:\"\\F340\"}.ion-music-note:before{content:\"\\F20C\"}.ion-navicon:before{content:\"\\F20E\"}.ion-navicon-round:before{content:\"\\F20D\"}.ion-navigate:before{content:\"\\F2A3\"}.ion-network:before{content:\"\\F341\"}.ion-no-smoking:before{content:\"\\F2C2\"}.ion-nuclear:before{content:\"\\F2A4\"}.ion-outlet:before{content:\"\\F342\"}.ion-paintbrush:before{content:\"\\F4D5\"}.ion-paintbucket:before{content:\"\\F4D6\"}.ion-paper-airplane:before{content:\"\\F2C3\"}.ion-paperclip:before{content:\"\\F20F\"}.ion-pause:before{content:\"\\F210\"}.ion-person:before{content:\"\\F213\"}.ion-person-add:before{content:\"\\F211\"}.ion-person-stalker:before{content:\"\\F212\"}.ion-pie-graph:before{content:\"\\F2A5\"}.ion-pin:before{content:\"\\F2A6\"}.ion-pinpoint:before{content:\"\\F2A7\"}.ion-pizza:before{content:\"\\F2A8\"}.ion-plane:before{content:\"\\F214\"}.ion-planet:before{content:\"\\F343\"}.ion-play:before{content:\"\\F215\"}.ion-playstation:before{content:\"\\F30A\"}.ion-plus:before{content:\"\\F218\"}.ion-plus-circled:before{content:\"\\F216\"}.ion-plus-round:before{content:\"\\F217\"}.ion-podium:before{content:\"\\F344\"}.ion-pound:before{content:\"\\F219\"}.ion-power:before{content:\"\\F2A9\"}.ion-pricetag:before{content:\"\\F2AA\"}.ion-pricetags:before{content:\"\\F2AB\"}.ion-printer:before{content:\"\\F21A\"}.ion-pull-request:before{content:\"\\F345\"}.ion-qr-scanner:before{content:\"\\F346\"}.ion-quote:before{content:\"\\F347\"}.ion-radio-waves:before{content:\"\\F2AC\"}.ion-record:before{content:\"\\F21B\"}.ion-refresh:before{content:\"\\F21C\"}.ion-reply:before{content:\"\\F21E\"}.ion-reply-all:before{content:\"\\F21D\"}.ion-ribbon-a:before{content:\"\\F348\"}.ion-ribbon-b:before{content:\"\\F349\"}.ion-sad:before{content:\"\\F34A\"}.ion-sad-outline:before{content:\"\\F4D7\"}.ion-scissors:before{content:\"\\F34B\"}.ion-search:before{content:\"\\F21F\"}.ion-settings:before{content:\"\\F2AD\"}.ion-share:before{content:\"\\F220\"}.ion-shuffle:before{content:\"\\F221\"}.ion-skip-backward:before{content:\"\\F222\"}.ion-skip-forward:before{content:\"\\F223\"}.ion-social-android:before{content:\"\\F225\"}.ion-social-android-outline:before{content:\"\\F224\"}.ion-social-angular:before{content:\"\\F4D9\"}.ion-social-angular-outline:before{content:\"\\F4D8\"}.ion-social-apple:before{content:\"\\F227\"}.ion-social-apple-outline:before{content:\"\\F226\"}.ion-social-bitcoin:before{content:\"\\F2AF\"}.ion-social-bitcoin-outline:before{content:\"\\F2AE\"}.ion-social-buffer:before{content:\"\\F229\"}.ion-social-buffer-outline:before{content:\"\\F228\"}.ion-social-chrome:before{content:\"\\F4DB\"}.ion-social-chrome-outline:before{content:\"\\F4DA\"}.ion-social-codepen:before{content:\"\\F4DD\"}.ion-social-codepen-outline:before{content:\"\\F4DC\"}.ion-social-css3:before{content:\"\\F4DF\"}.ion-social-css3-outline:before{content:\"\\F4DE\"}.ion-social-designernews:before{content:\"\\F22B\"}.ion-social-designernews-outline:before{content:\"\\F22A\"}.ion-social-dribbble:before{content:\"\\F22D\"}.ion-social-dribbble-outline:before{content:\"\\F22C\"}.ion-social-dropbox:before{content:\"\\F22F\"}.ion-social-dropbox-outline:before{content:\"\\F22E\"}.ion-social-euro:before{content:\"\\F4E1\"}.ion-social-euro-outline:before{content:\"\\F4E0\"}.ion-social-facebook:before{content:\"\\F231\"}.ion-social-facebook-outline:before{content:\"\\F230\"}.ion-social-foursquare:before{content:\"\\F34D\"}.ion-social-foursquare-outline:before{content:\"\\F34C\"}.ion-social-freebsd-devil:before{content:\"\\F2C4\"}.ion-social-github:before{content:\"\\F233\"}.ion-social-github-outline:before{content:\"\\F232\"}.ion-social-google:before{content:\"\\F34F\"}.ion-social-google-outline:before{content:\"\\F34E\"}.ion-social-googleplus:before{content:\"\\F235\"}.ion-social-googleplus-outline:before{content:\"\\F234\"}.ion-social-hackernews:before{content:\"\\F237\"}.ion-social-hackernews-outline:before{content:\"\\F236\"}.ion-social-html5:before{content:\"\\F4E3\"}.ion-social-html5-outline:before{content:\"\\F4E2\"}.ion-social-instagram:before{content:\"\\F351\"}.ion-social-instagram-outline:before{content:\"\\F350\"}.ion-social-javascript:before{content:\"\\F4E5\"}.ion-social-javascript-outline:before{content:\"\\F4E4\"}.ion-social-linkedin:before{content:\"\\F239\"}.ion-social-linkedin-outline:before{content:\"\\F238\"}.ion-social-markdown:before{content:\"\\F4E6\"}.ion-social-nodejs:before{content:\"\\F4E7\"}.ion-social-octocat:before{content:\"\\F4E8\"}.ion-social-pinterest:before{content:\"\\F2B1\"}.ion-social-pinterest-outline:before{content:\"\\F2B0\"}.ion-social-python:before{content:\"\\F4E9\"}.ion-social-reddit:before{content:\"\\F23B\"}.ion-social-reddit-outline:before{content:\"\\F23A\"}.ion-social-rss:before{content:\"\\F23D\"}.ion-social-rss-outline:before{content:\"\\F23C\"}.ion-social-sass:before{content:\"\\F4EA\"}.ion-social-skype:before{content:\"\\F23F\"}.ion-social-skype-outline:before{content:\"\\F23E\"}.ion-social-snapchat:before{content:\"\\F4EC\"}.ion-social-snapchat-outline:before{content:\"\\F4EB\"}.ion-social-tumblr:before{content:\"\\F241\"}.ion-social-tumblr-outline:before{content:\"\\F240\"}.ion-social-tux:before{content:\"\\F2C5\"}.ion-social-twitch:before{content:\"\\F4EE\"}.ion-social-twitch-outline:before{content:\"\\F4ED\"}.ion-social-twitter:before{content:\"\\F243\"}.ion-social-twitter-outline:before{content:\"\\F242\"}.ion-social-usd:before{content:\"\\F353\"}.ion-social-usd-outline:before{content:\"\\F352\"}.ion-social-vimeo:before{content:\"\\F245\"}.ion-social-vimeo-outline:before{content:\"\\F244\"}.ion-social-whatsapp:before{content:\"\\F4F0\"}.ion-social-whatsapp-outline:before{content:\"\\F4EF\"}.ion-social-windows:before{content:\"\\F247\"}.ion-social-windows-outline:before{content:\"\\F246\"}.ion-social-wordpress:before{content:\"\\F249\"}.ion-social-wordpress-outline:before{content:\"\\F248\"}.ion-social-yahoo:before{content:\"\\F24B\"}.ion-social-yahoo-outline:before{content:\"\\F24A\"}.ion-social-yen:before{content:\"\\F4F2\"}.ion-social-yen-outline:before{content:\"\\F4F1\"}.ion-social-youtube:before{content:\"\\F24D\"}.ion-social-youtube-outline:before{content:\"\\F24C\"}.ion-soup-can:before{content:\"\\F4F4\"}.ion-soup-can-outline:before{content:\"\\F4F3\"}.ion-speakerphone:before{content:\"\\F2B2\"}.ion-speedometer:before{content:\"\\F2B3\"}.ion-spoon:before{content:\"\\F2B4\"}.ion-star:before{content:\"\\F24E\"}.ion-stats-bars:before{content:\"\\F2B5\"}.ion-steam:before{content:\"\\F30B\"}.ion-stop:before{content:\"\\F24F\"}.ion-thermometer:before{content:\"\\F2B6\"}.ion-thumbsdown:before{content:\"\\F250\"}.ion-thumbsup:before{content:\"\\F251\"}.ion-toggle:before{content:\"\\F355\"}.ion-toggle-filled:before{content:\"\\F354\"}.ion-transgender:before{content:\"\\F4F5\"}.ion-trash-a:before{content:\"\\F252\"}.ion-trash-b:before{content:\"\\F253\"}.ion-trophy:before{content:\"\\F356\"}.ion-tshirt:before{content:\"\\F4F7\"}.ion-tshirt-outline:before{content:\"\\F4F6\"}.ion-umbrella:before{content:\"\\F2B7\"}.ion-university:before{content:\"\\F357\"}.ion-unlocked:before{content:\"\\F254\"}.ion-upload:before{content:\"\\F255\"}.ion-usb:before{content:\"\\F2B8\"}.ion-videocamera:before{content:\"\\F256\"}.ion-volume-high:before{content:\"\\F257\"}.ion-volume-low:before{content:\"\\F258\"}.ion-volume-medium:before{content:\"\\F259\"}.ion-volume-mute:before{content:\"\\F25A\"}.ion-wand:before{content:\"\\F358\"}.ion-waterdrop:before{content:\"\\F25B\"}.ion-wifi:before{content:\"\\F25C\"}.ion-wineglass:before{content:\"\\F2B9\"}.ion-woman:before{content:\"\\F25D\"}.ion-wrench:before{content:\"\\F2BA\"}.ion-xbox:before{content:\"\\F30C\"}", ""]);
	
	// exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "19e65b89cee273a249fba4c09b951b74.eot";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd4781d1acc57ba4c4808d1b44301201.ttf";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c159d0d05473040b53ec79df8797d32.woff";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aff28a207631f39ee0272d5cdde43ee7.svg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Material-Design-Iconic-Font;src:url(" + __webpack_require__(305) + ") format(\"woff2\"),url(" + __webpack_require__(306) + ") format(\"woff\"),url(" + __webpack_require__(307) + ") format(\"truetype\")}.zmdi{display:inline-block;font:normal normal normal 14px/1 Material-Design-Iconic-Font;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.zmdi-hc-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.zmdi-hc-2x{font-size:2em}.zmdi-hc-3x{font-size:3em}.zmdi-hc-4x{font-size:4em}.zmdi-hc-5x{font-size:5em}.zmdi-hc-fw{width:1.28571429em;text-align:center}.zmdi-hc-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.zmdi-hc-ul>li{position:relative}.zmdi-hc-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.zmdi-hc-li.zmdi-hc-lg{left:-1.85714286em}.zmdi-hc-border{padding:.1em .25em;border:.1em solid #9e9e9e;border-radius:2px}.zmdi-hc-border-circle{padding:.1em .25em;border:.1em solid #9e9e9e;border-radius:50%}.zmdi.pull-left{float:left;margin-right:.15em}.zmdi.pull-right{float:right;margin-left:.15em}.zmdi-hc-spin{-webkit-animation:zmdi-spin 1.5s infinite linear;animation:zmdi-spin 1.5s infinite linear}.zmdi-hc-spin-reverse{-webkit-animation:zmdi-spin-reverse 1.5s infinite linear;animation:zmdi-spin-reverse 1.5s infinite linear}@-webkit-keyframes zmdi-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes zmdi-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@-webkit-keyframes zmdi-spin-reverse{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(-359deg);transform:rotate(-359deg)}}@keyframes zmdi-spin-reverse{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(-359deg);transform:rotate(-359deg)}}.zmdi-hc-rotate-90{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.zmdi-hc-rotate-180{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.zmdi-hc-rotate-270{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.zmdi-hc-flip-horizontal{-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.zmdi-hc-flip-vertical{-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}.zmdi-hc-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.zmdi-hc-stack-1x,.zmdi-hc-stack-2x{position:absolute;left:0;width:100%;text-align:center}.zmdi-hc-stack-1x{line-height:inherit}.zmdi-hc-stack-2x{font-size:2em}.zmdi-hc-inverse{color:#fff}.zmdi-3d-rotation:before{content:\"\\F101\"}.zmdi-airplane-off:before{content:\"\\F102\"}.zmdi-airplane:before{content:\"\\F103\"}.zmdi-album:before{content:\"\\F104\"}.zmdi-archive:before{content:\"\\F105\"}.zmdi-assignment-account:before{content:\"\\F106\"}.zmdi-assignment-alert:before{content:\"\\F107\"}.zmdi-assignment-check:before{content:\"\\F108\"}.zmdi-assignment-o:before{content:\"\\F109\"}.zmdi-assignment-return:before{content:\"\\F10A\"}.zmdi-assignment-returned:before{content:\"\\F10B\"}.zmdi-assignment:before{content:\"\\F10C\"}.zmdi-attachment-alt:before{content:\"\\F10D\"}.zmdi-attachment:before{content:\"\\F10E\"}.zmdi-audio:before{content:\"\\F10F\"}.zmdi-badge-check:before{content:\"\\F110\"}.zmdi-balance-wallet:before{content:\"\\F111\"}.zmdi-balance:before{content:\"\\F112\"}.zmdi-battery-alert:before{content:\"\\F113\"}.zmdi-battery-flash:before{content:\"\\F114\"}.zmdi-battery-unknown:before{content:\"\\F115\"}.zmdi-battery:before{content:\"\\F116\"}.zmdi-bike:before{content:\"\\F117\"}.zmdi-block-alt:before{content:\"\\F118\"}.zmdi-block:before{content:\"\\F119\"}.zmdi-boat:before{content:\"\\F11A\"}.zmdi-book-image:before{content:\"\\F11B\"}.zmdi-book:before{content:\"\\F11C\"}.zmdi-bookmark-outline:before{content:\"\\F11D\"}.zmdi-bookmark:before{content:\"\\F11E\"}.zmdi-brush:before{content:\"\\F11F\"}.zmdi-bug:before{content:\"\\F120\"}.zmdi-bus:before{content:\"\\F121\"}.zmdi-cake:before{content:\"\\F122\"}.zmdi-car-taxi:before{content:\"\\F123\"}.zmdi-car-wash:before{content:\"\\F124\"}.zmdi-car:before{content:\"\\F125\"}.zmdi-card-giftcard:before{content:\"\\F126\"}.zmdi-card-membership:before{content:\"\\F127\"}.zmdi-card-travel:before{content:\"\\F128\"}.zmdi-card:before{content:\"\\F129\"}.zmdi-case-check:before{content:\"\\F12A\"}.zmdi-case-download:before{content:\"\\F12B\"}.zmdi-case-play:before{content:\"\\F12C\"}.zmdi-case:before{content:\"\\F12D\"}.zmdi-cast-connected:before{content:\"\\F12E\"}.zmdi-cast:before{content:\"\\F12F\"}.zmdi-chart-donut:before{content:\"\\F130\"}.zmdi-chart:before{content:\"\\F131\"}.zmdi-city-alt:before{content:\"\\F132\"}.zmdi-city:before{content:\"\\F133\"}.zmdi-close-circle-o:before{content:\"\\F134\"}.zmdi-close-circle:before{content:\"\\F135\"}.zmdi-close:before{content:\"\\F136\"}.zmdi-cocktail:before{content:\"\\F137\"}.zmdi-code-setting:before{content:\"\\F138\"}.zmdi-code-smartphone:before{content:\"\\F139\"}.zmdi-code:before{content:\"\\F13A\"}.zmdi-coffee:before{content:\"\\F13B\"}.zmdi-collection-bookmark:before{content:\"\\F13C\"}.zmdi-collection-case-play:before{content:\"\\F13D\"}.zmdi-collection-folder-image:before{content:\"\\F13E\"}.zmdi-collection-image-o:before{content:\"\\F13F\"}.zmdi-collection-image:before{content:\"\\F140\"}.zmdi-collection-item-1:before{content:\"\\F141\"}.zmdi-collection-item-2:before{content:\"\\F142\"}.zmdi-collection-item-3:before{content:\"\\F143\"}.zmdi-collection-item-4:before{content:\"\\F144\"}.zmdi-collection-item-5:before{content:\"\\F145\"}.zmdi-collection-item-6:before{content:\"\\F146\"}.zmdi-collection-item-7:before{content:\"\\F147\"}.zmdi-collection-item-8:before{content:\"\\F148\"}.zmdi-collection-item-9-plus:before{content:\"\\F149\"}.zmdi-collection-item-9:before{content:\"\\F14A\"}.zmdi-collection-item:before{content:\"\\F14B\"}.zmdi-collection-music:before{content:\"\\F14C\"}.zmdi-collection-pdf:before{content:\"\\F14D\"}.zmdi-collection-plus:before{content:\"\\F14E\"}.zmdi-collection-speaker:before{content:\"\\F14F\"}.zmdi-collection-text:before{content:\"\\F150\"}.zmdi-collection-video:before{content:\"\\F151\"}.zmdi-compass:before{content:\"\\F152\"}.zmdi-cutlery:before{content:\"\\F153\"}.zmdi-delete:before{content:\"\\F154\"}.zmdi-dialpad:before{content:\"\\F155\"}.zmdi-dns:before{content:\"\\F156\"}.zmdi-drink:before{content:\"\\F157\"}.zmdi-edit:before{content:\"\\F158\"}.zmdi-email-open:before{content:\"\\F159\"}.zmdi-email:before{content:\"\\F15A\"}.zmdi-eye-off:before{content:\"\\F15B\"}.zmdi-eye:before{content:\"\\F15C\"}.zmdi-eyedropper:before{content:\"\\F15D\"}.zmdi-favorite-outline:before{content:\"\\F15E\"}.zmdi-favorite:before{content:\"\\F15F\"}.zmdi-filter-list:before{content:\"\\F160\"}.zmdi-fire:before{content:\"\\F161\"}.zmdi-flag:before{content:\"\\F162\"}.zmdi-flare:before{content:\"\\F163\"}.zmdi-flash-auto:before{content:\"\\F164\"}.zmdi-flash-off:before{content:\"\\F165\"}.zmdi-flash:before{content:\"\\F166\"}.zmdi-flip:before{content:\"\\F167\"}.zmdi-flower-alt:before{content:\"\\F168\"}.zmdi-flower:before{content:\"\\F169\"}.zmdi-font:before{content:\"\\F16A\"}.zmdi-fullscreen-alt:before{content:\"\\F16B\"}.zmdi-fullscreen-exit:before{content:\"\\F16C\"}.zmdi-fullscreen:before{content:\"\\F16D\"}.zmdi-functions:before{content:\"\\F16E\"}.zmdi-gas-station:before{content:\"\\F16F\"}.zmdi-gesture:before{content:\"\\F170\"}.zmdi-globe-alt:before{content:\"\\F171\"}.zmdi-globe-lock:before{content:\"\\F172\"}.zmdi-globe:before{content:\"\\F173\"}.zmdi-graduation-cap:before{content:\"\\F174\"}.zmdi-home:before{content:\"\\F175\"}.zmdi-hospital-alt:before{content:\"\\F176\"}.zmdi-hospital:before{content:\"\\F177\"}.zmdi-hotel:before{content:\"\\F178\"}.zmdi-hourglass-alt:before{content:\"\\F179\"}.zmdi-hourglass-outline:before{content:\"\\F17A\"}.zmdi-hourglass:before{content:\"\\F17B\"}.zmdi-http:before{content:\"\\F17C\"}.zmdi-image-alt:before{content:\"\\F17D\"}.zmdi-image-o:before{content:\"\\F17E\"}.zmdi-image:before{content:\"\\F17F\"}.zmdi-inbox:before{content:\"\\F180\"}.zmdi-invert-colors-off:before{content:\"\\F181\"}.zmdi-invert-colors:before{content:\"\\F182\"}.zmdi-key:before{content:\"\\F183\"}.zmdi-label-alt-outline:before{content:\"\\F184\"}.zmdi-label-alt:before{content:\"\\F185\"}.zmdi-label-heart:before{content:\"\\F186\"}.zmdi-label:before{content:\"\\F187\"}.zmdi-labels:before{content:\"\\F188\"}.zmdi-lamp:before{content:\"\\F189\"}.zmdi-landscape:before{content:\"\\F18A\"}.zmdi-layers-off:before{content:\"\\F18B\"}.zmdi-layers:before{content:\"\\F18C\"}.zmdi-library:before{content:\"\\F18D\"}.zmdi-link:before{content:\"\\F18E\"}.zmdi-lock-open:before{content:\"\\F18F\"}.zmdi-lock-outline:before{content:\"\\F190\"}.zmdi-lock:before{content:\"\\F191\"}.zmdi-mail-reply-all:before{content:\"\\F192\"}.zmdi-mail-reply:before{content:\"\\F193\"}.zmdi-mail-send:before{content:\"\\F194\"}.zmdi-mall:before{content:\"\\F195\"}.zmdi-map:before{content:\"\\F196\"}.zmdi-menu:before{content:\"\\F197\"}.zmdi-money-box:before{content:\"\\F198\"}.zmdi-money-off:before{content:\"\\F199\"}.zmdi-money:before{content:\"\\F19A\"}.zmdi-more-vert:before{content:\"\\F19B\"}.zmdi-more:before{content:\"\\F19C\"}.zmdi-movie-alt:before{content:\"\\F19D\"}.zmdi-movie:before{content:\"\\F19E\"}.zmdi-nature-people:before{content:\"\\F19F\"}.zmdi-nature:before{content:\"\\F1A0\"}.zmdi-navigation:before{content:\"\\F1A1\"}.zmdi-open-in-browser:before{content:\"\\F1A2\"}.zmdi-open-in-new:before{content:\"\\F1A3\"}.zmdi-palette:before{content:\"\\F1A4\"}.zmdi-parking:before{content:\"\\F1A5\"}.zmdi-pin-account:before{content:\"\\F1A6\"}.zmdi-pin-assistant:before{content:\"\\F1A7\"}.zmdi-pin-drop:before{content:\"\\F1A8\"}.zmdi-pin-help:before{content:\"\\F1A9\"}.zmdi-pin-off:before{content:\"\\F1AA\"}.zmdi-pin:before{content:\"\\F1AB\"}.zmdi-pizza:before{content:\"\\F1AC\"}.zmdi-plaster:before{content:\"\\F1AD\"}.zmdi-power-setting:before{content:\"\\F1AE\"}.zmdi-power:before{content:\"\\F1AF\"}.zmdi-print:before{content:\"\\F1B0\"}.zmdi-puzzle-piece:before{content:\"\\F1B1\"}.zmdi-quote:before{content:\"\\F1B2\"}.zmdi-railway:before{content:\"\\F1B3\"}.zmdi-receipt:before{content:\"\\F1B4\"}.zmdi-refresh-alt:before{content:\"\\F1B5\"}.zmdi-refresh-sync-alert:before{content:\"\\F1B6\"}.zmdi-refresh-sync-off:before{content:\"\\F1B7\"}.zmdi-refresh-sync:before{content:\"\\F1B8\"}.zmdi-refresh:before{content:\"\\F1B9\"}.zmdi-roller:before{content:\"\\F1BA\"}.zmdi-ruler:before{content:\"\\F1BB\"}.zmdi-scissors:before{content:\"\\F1BC\"}.zmdi-screen-rotation-lock:before{content:\"\\F1BD\"}.zmdi-screen-rotation:before{content:\"\\F1BE\"}.zmdi-search-for:before{content:\"\\F1BF\"}.zmdi-search-in-file:before{content:\"\\F1C0\"}.zmdi-search-in-page:before{content:\"\\F1C1\"}.zmdi-search-replace:before{content:\"\\F1C2\"}.zmdi-search:before{content:\"\\F1C3\"}.zmdi-seat:before{content:\"\\F1C4\"}.zmdi-settings-square:before{content:\"\\F1C5\"}.zmdi-settings:before{content:\"\\F1C6\"}.zmdi-shield-check:before{content:\"\\F1C7\"}.zmdi-shield-security:before{content:\"\\F1C8\"}.zmdi-shopping-basket:before{content:\"\\F1C9\"}.zmdi-shopping-cart-plus:before{content:\"\\F1CA\"}.zmdi-shopping-cart:before{content:\"\\F1CB\"}.zmdi-sign-in:before{content:\"\\F1CC\"}.zmdi-sort-amount-asc:before{content:\"\\F1CD\"}.zmdi-sort-amount-desc:before{content:\"\\F1CE\"}.zmdi-sort-asc:before{content:\"\\F1CF\"}.zmdi-sort-desc:before{content:\"\\F1D0\"}.zmdi-spellcheck:before{content:\"\\F1D1\"}.zmdi-storage:before{content:\"\\F1D2\"}.zmdi-store-24:before{content:\"\\F1D3\"}.zmdi-store:before{content:\"\\F1D4\"}.zmdi-subway:before{content:\"\\F1D5\"}.zmdi-sun:before{content:\"\\F1D6\"}.zmdi-tab-unselected:before{content:\"\\F1D7\"}.zmdi-tab:before{content:\"\\F1D8\"}.zmdi-tag-close:before{content:\"\\F1D9\"}.zmdi-tag-more:before{content:\"\\F1DA\"}.zmdi-tag:before{content:\"\\F1DB\"}.zmdi-thumb-down:before{content:\"\\F1DC\"}.zmdi-thumb-up-down:before{content:\"\\F1DD\"}.zmdi-thumb-up:before{content:\"\\F1DE\"}.zmdi-ticket-star:before{content:\"\\F1DF\"}.zmdi-toll:before{content:\"\\F1E0\"}.zmdi-toys:before{content:\"\\F1E1\"}.zmdi-traffic:before{content:\"\\F1E2\"}.zmdi-translate:before{content:\"\\F1E3\"}.zmdi-triangle-down:before{content:\"\\F1E4\"}.zmdi-triangle-up:before{content:\"\\F1E5\"}.zmdi-truck:before{content:\"\\F1E6\"}.zmdi-turning-sign:before{content:\"\\F1E7\"}.zmdi-wallpaper:before{content:\"\\F1E8\"}.zmdi-washing-machine:before{content:\"\\F1E9\"}.zmdi-window-maximize:before{content:\"\\F1EA\"}.zmdi-window-minimize:before{content:\"\\F1EB\"}.zmdi-window-restore:before{content:\"\\F1EC\"}.zmdi-wrench:before{content:\"\\F1ED\"}.zmdi-zoom-in:before{content:\"\\F1EE\"}.zmdi-zoom-out:before{content:\"\\F1EF\"}.zmdi-alert-circle-o:before{content:\"\\F1F0\"}.zmdi-alert-circle:before{content:\"\\F1F1\"}.zmdi-alert-octagon:before{content:\"\\F1F2\"}.zmdi-alert-polygon:before{content:\"\\F1F3\"}.zmdi-alert-triangle:before{content:\"\\F1F4\"}.zmdi-help-outline:before{content:\"\\F1F5\"}.zmdi-help:before{content:\"\\F1F6\"}.zmdi-info-outline:before{content:\"\\F1F7\"}.zmdi-info:before{content:\"\\F1F8\"}.zmdi-notifications-active:before{content:\"\\F1F9\"}.zmdi-notifications-add:before{content:\"\\F1FA\"}.zmdi-notifications-none:before{content:\"\\F1FB\"}.zmdi-notifications-off:before{content:\"\\F1FC\"}.zmdi-notifications-paused:before{content:\"\\F1FD\"}.zmdi-notifications:before{content:\"\\F1FE\"}.zmdi-account-add:before{content:\"\\F1FF\"}.zmdi-account-box-mail:before{content:\"\\F200\"}.zmdi-account-box-o:before{content:\"\\F201\"}.zmdi-account-box-phone:before{content:\"\\F202\"}.zmdi-account-box:before{content:\"\\F203\"}.zmdi-account-calendar:before{content:\"\\F204\"}.zmdi-account-circle:before{content:\"\\F205\"}.zmdi-account-o:before{content:\"\\F206\"}.zmdi-account:before{content:\"\\F207\"}.zmdi-accounts-add:before{content:\"\\F208\"}.zmdi-accounts-alt:before{content:\"\\F209\"}.zmdi-accounts-list-alt:before{content:\"\\F20A\"}.zmdi-accounts-list:before{content:\"\\F20B\"}.zmdi-accounts-outline:before{content:\"\\F20C\"}.zmdi-accounts:before{content:\"\\F20D\"}.zmdi-face:before{content:\"\\F20E\"}.zmdi-female:before{content:\"\\F20F\"}.zmdi-male-alt:before{content:\"\\F210\"}.zmdi-male-female:before{content:\"\\F211\"}.zmdi-male:before{content:\"\\F212\"}.zmdi-mood-bad:before{content:\"\\F213\"}.zmdi-mood:before{content:\"\\F214\"}.zmdi-run:before{content:\"\\F215\"}.zmdi-walk:before{content:\"\\F216\"}.zmdi-cloud-box:before{content:\"\\F217\"}.zmdi-cloud-circle:before{content:\"\\F218\"}.zmdi-cloud-done:before{content:\"\\F219\"}.zmdi-cloud-download:before{content:\"\\F21A\"}.zmdi-cloud-off:before{content:\"\\F21B\"}.zmdi-cloud-outline-alt:before{content:\"\\F21C\"}.zmdi-cloud-outline:before{content:\"\\F21D\"}.zmdi-cloud-upload:before{content:\"\\F21E\"}.zmdi-cloud:before{content:\"\\F21F\"}.zmdi-download:before{content:\"\\F220\"}.zmdi-file-plus:before{content:\"\\F221\"}.zmdi-file-text:before{content:\"\\F222\"}.zmdi-file:before{content:\"\\F223\"}.zmdi-folder-outline:before{content:\"\\F224\"}.zmdi-folder-person:before{content:\"\\F225\"}.zmdi-folder-star-alt:before{content:\"\\F226\"}.zmdi-folder-star:before{content:\"\\F227\"}.zmdi-folder:before{content:\"\\F228\"}.zmdi-gif:before{content:\"\\F229\"}.zmdi-upload:before{content:\"\\F22A\"}.zmdi-border-all:before{content:\"\\F22B\"}.zmdi-border-bottom:before{content:\"\\F22C\"}.zmdi-border-clear:before{content:\"\\F22D\"}.zmdi-border-color:before{content:\"\\F22E\"}.zmdi-border-horizontal:before{content:\"\\F22F\"}.zmdi-border-inner:before{content:\"\\F230\"}.zmdi-border-left:before{content:\"\\F231\"}.zmdi-border-outer:before{content:\"\\F232\"}.zmdi-border-right:before{content:\"\\F233\"}.zmdi-border-style:before{content:\"\\F234\"}.zmdi-border-top:before{content:\"\\F235\"}.zmdi-border-vertical:before{content:\"\\F236\"}.zmdi-copy:before{content:\"\\F237\"}.zmdi-crop:before{content:\"\\F238\"}.zmdi-format-align-center:before{content:\"\\F239\"}.zmdi-format-align-justify:before{content:\"\\F23A\"}.zmdi-format-align-left:before{content:\"\\F23B\"}.zmdi-format-align-right:before{content:\"\\F23C\"}.zmdi-format-bold:before{content:\"\\F23D\"}.zmdi-format-clear-all:before{content:\"\\F23E\"}.zmdi-format-clear:before{content:\"\\F23F\"}.zmdi-format-color-fill:before{content:\"\\F240\"}.zmdi-format-color-reset:before{content:\"\\F241\"}.zmdi-format-color-text:before{content:\"\\F242\"}.zmdi-format-indent-decrease:before{content:\"\\F243\"}.zmdi-format-indent-increase:before{content:\"\\F244\"}.zmdi-format-italic:before{content:\"\\F245\"}.zmdi-format-line-spacing:before{content:\"\\F246\"}.zmdi-format-list-bulleted:before{content:\"\\F247\"}.zmdi-format-list-numbered:before{content:\"\\F248\"}.zmdi-format-ltr:before{content:\"\\F249\"}.zmdi-format-rtl:before{content:\"\\F24A\"}.zmdi-format-size:before{content:\"\\F24B\"}.zmdi-format-strikethrough-s:before{content:\"\\F24C\"}.zmdi-format-strikethrough:before{content:\"\\F24D\"}.zmdi-format-subject:before{content:\"\\F24E\"}.zmdi-format-underlined:before{content:\"\\F24F\"}.zmdi-format-valign-bottom:before{content:\"\\F250\"}.zmdi-format-valign-center:before{content:\"\\F251\"}.zmdi-format-valign-top:before{content:\"\\F252\"}.zmdi-redo:before{content:\"\\F253\"}.zmdi-select-all:before{content:\"\\F254\"}.zmdi-space-bar:before{content:\"\\F255\"}.zmdi-text-format:before{content:\"\\F256\"}.zmdi-transform:before{content:\"\\F257\"}.zmdi-undo:before{content:\"\\F258\"}.zmdi-wrap-text:before{content:\"\\F259\"}.zmdi-comment-alert:before{content:\"\\F25A\"}.zmdi-comment-alt-text:before{content:\"\\F25B\"}.zmdi-comment-alt:before{content:\"\\F25C\"}.zmdi-comment-edit:before{content:\"\\F25D\"}.zmdi-comment-image:before{content:\"\\F25E\"}.zmdi-comment-list:before{content:\"\\F25F\"}.zmdi-comment-more:before{content:\"\\F260\"}.zmdi-comment-outline:before{content:\"\\F261\"}.zmdi-comment-text-alt:before{content:\"\\F262\"}.zmdi-comment-text:before{content:\"\\F263\"}.zmdi-comment-video:before{content:\"\\F264\"}.zmdi-comment:before{content:\"\\F265\"}.zmdi-comments:before{content:\"\\F266\"}.zmdi-check-all:before{content:\"\\F267\"}.zmdi-check-circle-u:before{content:\"\\F268\"}.zmdi-check-circle:before{content:\"\\F269\"}.zmdi-check-square:before{content:\"\\F26A\"}.zmdi-check:before{content:\"\\F26B\"}.zmdi-circle-o:before{content:\"\\F26C\"}.zmdi-circle:before{content:\"\\F26D\"}.zmdi-dot-circle-alt:before{content:\"\\F26E\"}.zmdi-dot-circle:before{content:\"\\F26F\"}.zmdi-minus-circle-outline:before{content:\"\\F270\"}.zmdi-minus-circle:before{content:\"\\F271\"}.zmdi-minus-square:before{content:\"\\F272\"}.zmdi-minus:before{content:\"\\F273\"}.zmdi-plus-circle-o-duplicate:before{content:\"\\F274\"}.zmdi-plus-circle-o:before{content:\"\\F275\"}.zmdi-plus-circle:before{content:\"\\F276\"}.zmdi-plus-square:before{content:\"\\F277\"}.zmdi-plus:before{content:\"\\F278\"}.zmdi-square-o:before{content:\"\\F279\"}.zmdi-star-circle:before{content:\"\\F27A\"}.zmdi-star-half:before{content:\"\\F27B\"}.zmdi-star-outline:before{content:\"\\F27C\"}.zmdi-star:before{content:\"\\F27D\"}.zmdi-bluetooth-connected:before{content:\"\\F27E\"}.zmdi-bluetooth-off:before{content:\"\\F27F\"}.zmdi-bluetooth-search:before{content:\"\\F280\"}.zmdi-bluetooth-setting:before{content:\"\\F281\"}.zmdi-bluetooth:before{content:\"\\F282\"}.zmdi-camera-add:before{content:\"\\F283\"}.zmdi-camera-alt:before{content:\"\\F284\"}.zmdi-camera-bw:before{content:\"\\F285\"}.zmdi-camera-front:before{content:\"\\F286\"}.zmdi-camera-mic:before{content:\"\\F287\"}.zmdi-camera-party-mode:before{content:\"\\F288\"}.zmdi-camera-rear:before{content:\"\\F289\"}.zmdi-camera-roll:before{content:\"\\F28A\"}.zmdi-camera-switch:before{content:\"\\F28B\"}.zmdi-camera:before{content:\"\\F28C\"}.zmdi-card-alert:before{content:\"\\F28D\"}.zmdi-card-off:before{content:\"\\F28E\"}.zmdi-card-sd:before{content:\"\\F28F\"}.zmdi-card-sim:before{content:\"\\F290\"}.zmdi-desktop-mac:before{content:\"\\F291\"}.zmdi-desktop-windows:before{content:\"\\F292\"}.zmdi-device-hub:before{content:\"\\F293\"}.zmdi-devices-off:before{content:\"\\F294\"}.zmdi-devices:before{content:\"\\F295\"}.zmdi-dock:before{content:\"\\F296\"}.zmdi-floppy:before{content:\"\\F297\"}.zmdi-gamepad:before{content:\"\\F298\"}.zmdi-gps-dot:before{content:\"\\F299\"}.zmdi-gps-off:before{content:\"\\F29A\"}.zmdi-gps:before{content:\"\\F29B\"}.zmdi-headset-mic:before{content:\"\\F29C\"}.zmdi-headset:before{content:\"\\F29D\"}.zmdi-input-antenna:before{content:\"\\F29E\"}.zmdi-input-composite:before{content:\"\\F29F\"}.zmdi-input-hdmi:before{content:\"\\F2A0\"}.zmdi-input-power:before{content:\"\\F2A1\"}.zmdi-input-svideo:before{content:\"\\F2A2\"}.zmdi-keyboard-hide:before{content:\"\\F2A3\"}.zmdi-keyboard:before{content:\"\\F2A4\"}.zmdi-laptop-chromebook:before{content:\"\\F2A5\"}.zmdi-laptop-mac:before{content:\"\\F2A6\"}.zmdi-laptop:before{content:\"\\F2A7\"}.zmdi-mic-off:before{content:\"\\F2A8\"}.zmdi-mic-outline:before{content:\"\\F2A9\"}.zmdi-mic-setting:before{content:\"\\F2AA\"}.zmdi-mic:before{content:\"\\F2AB\"}.zmdi-mouse:before{content:\"\\F2AC\"}.zmdi-network-alert:before{content:\"\\F2AD\"}.zmdi-network-locked:before{content:\"\\F2AE\"}.zmdi-network-off:before{content:\"\\F2AF\"}.zmdi-network-outline:before{content:\"\\F2B0\"}.zmdi-network-setting:before{content:\"\\F2B1\"}.zmdi-network:before{content:\"\\F2B2\"}.zmdi-phone-bluetooth:before{content:\"\\F2B3\"}.zmdi-phone-end:before{content:\"\\F2B4\"}.zmdi-phone-forwarded:before{content:\"\\F2B5\"}.zmdi-phone-in-talk:before{content:\"\\F2B6\"}.zmdi-phone-locked:before{content:\"\\F2B7\"}.zmdi-phone-missed:before{content:\"\\F2B8\"}.zmdi-phone-msg:before{content:\"\\F2B9\"}.zmdi-phone-paused:before{content:\"\\F2BA\"}.zmdi-phone-ring:before{content:\"\\F2BB\"}.zmdi-phone-setting:before{content:\"\\F2BC\"}.zmdi-phone-sip:before{content:\"\\F2BD\"}.zmdi-phone:before{content:\"\\F2BE\"}.zmdi-portable-wifi-changes:before{content:\"\\F2BF\"}.zmdi-portable-wifi-off:before{content:\"\\F2C0\"}.zmdi-portable-wifi:before{content:\"\\F2C1\"}.zmdi-radio:before{content:\"\\F2C2\"}.zmdi-reader:before{content:\"\\F2C3\"}.zmdi-remote-control-alt:before{content:\"\\F2C4\"}.zmdi-remote-control:before{content:\"\\F2C5\"}.zmdi-router:before{content:\"\\F2C6\"}.zmdi-scanner:before{content:\"\\F2C7\"}.zmdi-smartphone-android:before{content:\"\\F2C8\"}.zmdi-smartphone-download:before{content:\"\\F2C9\"}.zmdi-smartphone-erase:before{content:\"\\F2CA\"}.zmdi-smartphone-info:before{content:\"\\F2CB\"}.zmdi-smartphone-iphone:before{content:\"\\F2CC\"}.zmdi-smartphone-landscape-lock:before{content:\"\\F2CD\"}.zmdi-smartphone-landscape:before{content:\"\\F2CE\"}.zmdi-smartphone-lock:before{content:\"\\F2CF\"}.zmdi-smartphone-portrait-lock:before{content:\"\\F2D0\"}.zmdi-smartphone-ring:before{content:\"\\F2D1\"}.zmdi-smartphone-setting:before{content:\"\\F2D2\"}.zmdi-smartphone-setup:before{content:\"\\F2D3\"}.zmdi-smartphone:before{content:\"\\F2D4\"}.zmdi-speaker:before{content:\"\\F2D5\"}.zmdi-tablet-android:before{content:\"\\F2D6\"}.zmdi-tablet-mac:before{content:\"\\F2D7\"}.zmdi-tablet:before{content:\"\\F2D8\"}.zmdi-tv-alt-play:before{content:\"\\F2D9\"}.zmdi-tv-list:before{content:\"\\F2DA\"}.zmdi-tv-play:before{content:\"\\F2DB\"}.zmdi-tv:before{content:\"\\F2DC\"}.zmdi-usb:before{content:\"\\F2DD\"}.zmdi-videocam-off:before{content:\"\\F2DE\"}.zmdi-videocam-switch:before{content:\"\\F2DF\"}.zmdi-videocam:before{content:\"\\F2E0\"}.zmdi-watch:before{content:\"\\F2E1\"}.zmdi-wifi-alt-2:before{content:\"\\F2E2\"}.zmdi-wifi-alt:before{content:\"\\F2E3\"}.zmdi-wifi-info:before{content:\"\\F2E4\"}.zmdi-wifi-lock:before{content:\"\\F2E5\"}.zmdi-wifi-off:before{content:\"\\F2E6\"}.zmdi-wifi-outline:before{content:\"\\F2E7\"}.zmdi-wifi:before{content:\"\\F2E8\"}.zmdi-arrow-left-bottom:before{content:\"\\F2E9\"}.zmdi-arrow-left:before{content:\"\\F2EA\"}.zmdi-arrow-merge:before{content:\"\\F2EB\"}.zmdi-arrow-missed:before{content:\"\\F2EC\"}.zmdi-arrow-right-top:before{content:\"\\F2ED\"}.zmdi-arrow-right:before{content:\"\\F2EE\"}.zmdi-arrow-split:before{content:\"\\F2EF\"}.zmdi-arrows:before{content:\"\\F2F0\"}.zmdi-caret-down-circle:before{content:\"\\F2F1\"}.zmdi-caret-down:before{content:\"\\F2F2\"}.zmdi-caret-left-circle:before{content:\"\\F2F3\"}.zmdi-caret-left:before{content:\"\\F2F4\"}.zmdi-caret-right-circle:before{content:\"\\F2F5\"}.zmdi-caret-right:before{content:\"\\F2F6\"}.zmdi-caret-up-circle:before{content:\"\\F2F7\"}.zmdi-caret-up:before{content:\"\\F2F8\"}.zmdi-chevron-down:before{content:\"\\F2F9\"}.zmdi-chevron-left:before{content:\"\\F2FA\"}.zmdi-chevron-right:before{content:\"\\F2FB\"}.zmdi-chevron-up:before{content:\"\\F2FC\"}.zmdi-forward:before{content:\"\\F2FD\"}.zmdi-long-arrow-down:before{content:\"\\F2FE\"}.zmdi-long-arrow-left:before{content:\"\\F2FF\"}.zmdi-long-arrow-return:before{content:\"\\F300\"}.zmdi-long-arrow-right:before{content:\"\\F301\"}.zmdi-long-arrow-tab:before{content:\"\\F302\"}.zmdi-long-arrow-up:before{content:\"\\F303\"}.zmdi-rotate-ccw:before{content:\"\\F304\"}.zmdi-rotate-cw:before{content:\"\\F305\"}.zmdi-rotate-left:before{content:\"\\F306\"}.zmdi-rotate-right:before{content:\"\\F307\"}.zmdi-square-down:before{content:\"\\F308\"}.zmdi-square-right:before{content:\"\\F309\"}.zmdi-swap-alt:before{content:\"\\F30A\"}.zmdi-swap-vertical-circle:before{content:\"\\F30B\"}.zmdi-swap-vertical:before{content:\"\\F30C\"}.zmdi-swap:before{content:\"\\F30D\"}.zmdi-trending-down:before{content:\"\\F30E\"}.zmdi-trending-flat:before{content:\"\\F30F\"}.zmdi-trending-up:before{content:\"\\F310\"}.zmdi-unfold-less:before{content:\"\\F311\"}.zmdi-unfold-more:before{content:\"\\F312\"}.zmdi-apps:before{content:\"\\F313\"}.zmdi-grid-off:before{content:\"\\F314\"}.zmdi-grid:before{content:\"\\F315\"}.zmdi-view-agenda:before{content:\"\\F316\"}.zmdi-view-array:before{content:\"\\F317\"}.zmdi-view-carousel:before{content:\"\\F318\"}.zmdi-view-column:before{content:\"\\F319\"}.zmdi-view-comfy:before{content:\"\\F31A\"}.zmdi-view-compact:before{content:\"\\F31B\"}.zmdi-view-dashboard:before{content:\"\\F31C\"}.zmdi-view-day:before{content:\"\\F31D\"}.zmdi-view-headline:before{content:\"\\F31E\"}.zmdi-view-list-alt:before{content:\"\\F31F\"}.zmdi-view-list:before{content:\"\\F320\"}.zmdi-view-module:before{content:\"\\F321\"}.zmdi-view-quilt:before{content:\"\\F322\"}.zmdi-view-stream:before{content:\"\\F323\"}.zmdi-view-subtitles:before{content:\"\\F324\"}.zmdi-view-toc:before{content:\"\\F325\"}.zmdi-view-web:before{content:\"\\F326\"}.zmdi-view-week:before{content:\"\\F327\"}.zmdi-widgets:before{content:\"\\F328\"}.zmdi-alarm-check:before{content:\"\\F329\"}.zmdi-alarm-off:before{content:\"\\F32A\"}.zmdi-alarm-plus:before{content:\"\\F32B\"}.zmdi-alarm-snooze:before{content:\"\\F32C\"}.zmdi-alarm:before{content:\"\\F32D\"}.zmdi-calendar-alt:before{content:\"\\F32E\"}.zmdi-calendar-check:before{content:\"\\F32F\"}.zmdi-calendar-close:before{content:\"\\F330\"}.zmdi-calendar-note:before{content:\"\\F331\"}.zmdi-calendar:before{content:\"\\F332\"}.zmdi-time-countdown:before{content:\"\\F333\"}.zmdi-time-interval:before{content:\"\\F334\"}.zmdi-time-restore-setting:before{content:\"\\F335\"}.zmdi-time-restore:before{content:\"\\F336\"}.zmdi-time:before{content:\"\\F337\"}.zmdi-timer-off:before{content:\"\\F338\"}.zmdi-timer:before{content:\"\\F339\"}.zmdi-android-alt:before{content:\"\\F33A\"}.zmdi-android:before{content:\"\\F33B\"}.zmdi-apple:before{content:\"\\F33C\"}.zmdi-behance:before{content:\"\\F33D\"}.zmdi-codepen:before{content:\"\\F33E\"}.zmdi-dribbble:before{content:\"\\F33F\"}.zmdi-dropbox:before{content:\"\\F340\"}.zmdi-evernote:before{content:\"\\F341\"}.zmdi-facebook-box:before{content:\"\\F342\"}.zmdi-facebook:before{content:\"\\F343\"}.zmdi-github-box:before{content:\"\\F344\"}.zmdi-github:before{content:\"\\F345\"}.zmdi-google-drive:before{content:\"\\F346\"}.zmdi-google-earth:before{content:\"\\F347\"}.zmdi-google-glass:before{content:\"\\F348\"}.zmdi-google-maps:before{content:\"\\F349\"}.zmdi-google-pages:before{content:\"\\F34A\"}.zmdi-google-play:before{content:\"\\F34B\"}.zmdi-google-plus-box:before{content:\"\\F34C\"}.zmdi-google-plus:before{content:\"\\F34D\"}.zmdi-google:before{content:\"\\F34E\"}.zmdi-instagram:before{content:\"\\F34F\"}.zmdi-language-css3:before{content:\"\\F350\"}.zmdi-language-html5:before{content:\"\\F351\"}.zmdi-language-javascript:before{content:\"\\F352\"}.zmdi-language-python-alt:before{content:\"\\F353\"}.zmdi-language-python:before{content:\"\\F354\"}.zmdi-lastfm:before{content:\"\\F355\"}.zmdi-linkedin-box:before{content:\"\\F356\"}.zmdi-paypal:before{content:\"\\F357\"}.zmdi-pinterest-box:before{content:\"\\F358\"}.zmdi-pocket:before{content:\"\\F359\"}.zmdi-polymer:before{content:\"\\F35A\"}.zmdi-share:before{content:\"\\F35B\"}.zmdi-stackoverflow:before{content:\"\\F35C\"}.zmdi-steam-square:before{content:\"\\F35D\"}.zmdi-steam:before{content:\"\\F35E\"}.zmdi-twitter-box:before{content:\"\\F35F\"}.zmdi-twitter:before{content:\"\\F360\"}.zmdi-vk:before{content:\"\\F361\"}.zmdi-wikipedia:before{content:\"\\F362\"}.zmdi-windows:before{content:\"\\F363\"}.zmdi-aspect-ratio-alt:before{content:\"\\F364\"}.zmdi-aspect-ratio:before{content:\"\\F365\"}.zmdi-blur-circular:before{content:\"\\F366\"}.zmdi-blur-linear:before{content:\"\\F367\"}.zmdi-blur-off:before{content:\"\\F368\"}.zmdi-blur:before{content:\"\\F369\"}.zmdi-brightness-2:before{content:\"\\F36A\"}.zmdi-brightness-3:before{content:\"\\F36B\"}.zmdi-brightness-4:before{content:\"\\F36C\"}.zmdi-brightness-5:before{content:\"\\F36D\"}.zmdi-brightness-6:before{content:\"\\F36E\"}.zmdi-brightness-7:before{content:\"\\F36F\"}.zmdi-brightness-auto:before{content:\"\\F370\"}.zmdi-brightness-setting:before{content:\"\\F371\"}.zmdi-broken-image:before{content:\"\\F372\"}.zmdi-center-focus-strong:before{content:\"\\F373\"}.zmdi-center-focus-weak:before{content:\"\\F374\"}.zmdi-compare:before{content:\"\\F375\"}.zmdi-crop-16-9:before{content:\"\\F376\"}.zmdi-crop-3-2:before{content:\"\\F377\"}.zmdi-crop-5-4:before{content:\"\\F378\"}.zmdi-crop-7-5:before{content:\"\\F379\"}.zmdi-crop-din:before{content:\"\\F37A\"}.zmdi-crop-free:before{content:\"\\F37B\"}.zmdi-crop-landscape:before{content:\"\\F37C\"}.zmdi-crop-portrait:before{content:\"\\F37D\"}.zmdi-crop-square:before{content:\"\\F37E\"}.zmdi-exposure-alt:before{content:\"\\F37F\"}.zmdi-exposure:before{content:\"\\F380\"}.zmdi-filter-b-and-w:before{content:\"\\F381\"}.zmdi-filter-center-focus:before{content:\"\\F382\"}.zmdi-filter-frames:before{content:\"\\F383\"}.zmdi-filter-tilt-shift:before{content:\"\\F384\"}.zmdi-gradient:before{content:\"\\F385\"}.zmdi-grain:before{content:\"\\F386\"}.zmdi-graphic-eq:before{content:\"\\F387\"}.zmdi-hdr-off:before{content:\"\\F388\"}.zmdi-hdr-strong:before{content:\"\\F389\"}.zmdi-hdr-weak:before{content:\"\\F38A\"}.zmdi-hdr:before{content:\"\\F38B\"}.zmdi-iridescent:before{content:\"\\F38C\"}.zmdi-leak-off:before{content:\"\\F38D\"}.zmdi-leak:before{content:\"\\F38E\"}.zmdi-looks:before{content:\"\\F38F\"}.zmdi-loupe:before{content:\"\\F390\"}.zmdi-panorama-horizontal:before{content:\"\\F391\"}.zmdi-panorama-vertical:before{content:\"\\F392\"}.zmdi-panorama-wide-angle:before{content:\"\\F393\"}.zmdi-photo-size-select-large:before{content:\"\\F394\"}.zmdi-photo-size-select-small:before{content:\"\\F395\"}.zmdi-picture-in-picture:before{content:\"\\F396\"}.zmdi-slideshow:before{content:\"\\F397\"}.zmdi-texture:before{content:\"\\F398\"}.zmdi-tonality:before{content:\"\\F399\"}.zmdi-vignette:before{content:\"\\F39A\"}.zmdi-wb-auto:before{content:\"\\F39B\"}.zmdi-eject-alt:before{content:\"\\F39C\"}.zmdi-eject:before{content:\"\\F39D\"}.zmdi-equalizer:before{content:\"\\F39E\"}.zmdi-fast-forward:before{content:\"\\F39F\"}.zmdi-fast-rewind:before{content:\"\\F3A0\"}.zmdi-forward-10:before{content:\"\\F3A1\"}.zmdi-forward-30:before{content:\"\\F3A2\"}.zmdi-forward-5:before{content:\"\\F3A3\"}.zmdi-hearing:before{content:\"\\F3A4\"}.zmdi-pause-circle-outline:before{content:\"\\F3A5\"}.zmdi-pause-circle:before{content:\"\\F3A6\"}.zmdi-pause:before{content:\"\\F3A7\"}.zmdi-play-circle-outline:before{content:\"\\F3A8\"}.zmdi-play-circle:before{content:\"\\F3A9\"}.zmdi-play:before{content:\"\\F3AA\"}.zmdi-playlist-audio:before{content:\"\\F3AB\"}.zmdi-playlist-plus:before{content:\"\\F3AC\"}.zmdi-repeat-one:before{content:\"\\F3AD\"}.zmdi-repeat:before{content:\"\\F3AE\"}.zmdi-replay-10:before{content:\"\\F3AF\"}.zmdi-replay-30:before{content:\"\\F3B0\"}.zmdi-replay-5:before{content:\"\\F3B1\"}.zmdi-replay:before{content:\"\\F3B2\"}.zmdi-shuffle:before{content:\"\\F3B3\"}.zmdi-skip-next:before{content:\"\\F3B4\"}.zmdi-skip-previous:before{content:\"\\F3B5\"}.zmdi-stop:before{content:\"\\F3B6\"}.zmdi-surround-sound:before{content:\"\\F3B7\"}.zmdi-tune:before{content:\"\\F3B8\"}.zmdi-volume-down:before{content:\"\\F3B9\"}.zmdi-volume-mute:before{content:\"\\F3BA\"}.zmdi-volume-off:before{content:\"\\F3BB\"}.zmdi-volume-up:before{content:\"\\F3BC\"}.zmdi-n-1-square:before{content:\"\\F3BD\"}.zmdi-n-2-square:before{content:\"\\F3BE\"}.zmdi-n-3-square:before{content:\"\\F3BF\"}.zmdi-n-4-square:before{content:\"\\F3C0\"}.zmdi-n-5-square:before{content:\"\\F3C1\"}.zmdi-n-6-square:before{content:\"\\F3C2\"}.zmdi-neg-1:before{content:\"\\F3C3\"}.zmdi-neg-2:before{content:\"\\F3C4\"}.zmdi-plus-1:before{content:\"\\F3C5\"}.zmdi-plus-2:before{content:\"\\F3C6\"}.zmdi-sec-10:before{content:\"\\F3C7\"}.zmdi-sec-3:before{content:\"\\F3C8\"}.zmdi-zero:before{content:\"\\F3C9\"}.zmdi-airline-seat-flat-angled:before{content:\"\\F3CA\"}.zmdi-airline-seat-flat:before{content:\"\\F3CB\"}.zmdi-airline-seat-individual-suite:before{content:\"\\F3CC\"}.zmdi-airline-seat-legroom-extra:before{content:\"\\F3CD\"}.zmdi-airline-seat-legroom-normal:before{content:\"\\F3CE\"}.zmdi-airline-seat-legroom-reduced:before{content:\"\\F3CF\"}.zmdi-airline-seat-recline-extra:before{content:\"\\F3D0\"}.zmdi-airline-seat-recline-normal:before{content:\"\\F3D1\"}.zmdi-airplay:before{content:\"\\F3D2\"}.zmdi-closed-caption:before{content:\"\\F3D3\"}.zmdi-confirmation-number:before{content:\"\\F3D4\"}.zmdi-developer-board:before{content:\"\\F3D5\"}.zmdi-disc-full:before{content:\"\\F3D6\"}.zmdi-explicit:before{content:\"\\F3D7\"}.zmdi-flight-land:before{content:\"\\F3D8\"}.zmdi-flight-takeoff:before{content:\"\\F3D9\"}.zmdi-flip-to-back:before{content:\"\\F3DA\"}.zmdi-flip-to-front:before{content:\"\\F3DB\"}.zmdi-group-work:before{content:\"\\F3DC\"}.zmdi-hd:before{content:\"\\F3DD\"}.zmdi-hq:before{content:\"\\F3DE\"}.zmdi-markunread-mailbox:before{content:\"\\F3DF\"}.zmdi-memory:before{content:\"\\F3E0\"}.zmdi-nfc:before{content:\"\\F3E1\"}.zmdi-play-for-work:before{content:\"\\F3E2\"}.zmdi-power-input:before{content:\"\\F3E3\"}.zmdi-present-to-all:before{content:\"\\F3E4\"}.zmdi-satellite:before{content:\"\\F3E5\"}.zmdi-tap-and-play:before{content:\"\\F3E6\"}.zmdi-vibration:before{content:\"\\F3E7\"}.zmdi-voicemail:before{content:\"\\F3E8\"}.zmdi-group:before{content:\"\\F3E9\"}.zmdi-rss:before{content:\"\\F3EA\"}.zmdi-shape:before{content:\"\\F3EB\"}.zmdi-spinner:before{content:\"\\F3EC\"}.zmdi-ungroup:before{content:\"\\F3ED\"}.zmdi-500px:before{content:\"\\F3EE\"}.zmdi-8tracks:before{content:\"\\F3EF\"}.zmdi-amazon:before{content:\"\\F3F0\"}.zmdi-blogger:before{content:\"\\F3F1\"}.zmdi-delicious:before{content:\"\\F3F2\"}.zmdi-disqus:before{content:\"\\F3F3\"}.zmdi-flattr:before{content:\"\\F3F4\"}.zmdi-flickr:before{content:\"\\F3F5\"}.zmdi-github-alt:before{content:\"\\F3F6\"}.zmdi-google-old:before{content:\"\\F3F7\"}.zmdi-linkedin:before{content:\"\\F3F8\"}.zmdi-odnoklassniki:before{content:\"\\F3F9\"}.zmdi-outlook:before{content:\"\\F3FA\"}.zmdi-paypal-alt:before{content:\"\\F3FB\"}.zmdi-pinterest:before{content:\"\\F3FC\"}.zmdi-playstation:before{content:\"\\F3FD\"}.zmdi-reddit:before{content:\"\\F3FE\"}.zmdi-skype:before{content:\"\\F3FF\"}.zmdi-slideshare:before{content:\"\\F400\"}.zmdi-soundcloud:before{content:\"\\F401\"}.zmdi-tumblr:before{content:\"\\F402\"}.zmdi-twitch:before{content:\"\\F403\"}.zmdi-vimeo:before{content:\"\\F404\"}.zmdi-whatsapp:before{content:\"\\F405\"}.zmdi-xbox:before{content:\"\\F406\"}.zmdi-yahoo:before{content:\"\\F407\"}.zmdi-youtube-play:before{content:\"\\F408\"}.zmdi-youtube:before{content:\"\\F409\"}.zmdi-import-export:before,.zmdi-swap-vertical-:before{content:\"\\F30C\"}.zmdi-airplanemode-inactive:before{content:\"\\F102\"}.zmdi-airplanemode-active:before,.zmdi-rate-review:before{content:\"\\F103\"}.zmdi-comment-sign:before{content:\"\\F25A\"}.zmdi-network-warning:before{content:\"\\F2AD\"}.zmdi-shopping-cart-add:before{content:\"\\F1CA\"}.zmdi-file-add:before{content:\"\\F221\"}.zmdi-network-wifi-scan:before{content:\"\\F2E4\"}.zmdi-collection-add:before{content:\"\\F14E\"}.zmdi-format-playlist-add:before{content:\"\\F3AC\"}.zmdi-format-queue-music:before{content:\"\\F3AB\"}.zmdi-plus-box:before{content:\"\\F277\"}.zmdi-tag-backspace:before{content:\"\\F1D9\"}.zmdi-alarm-add:before{content:\"\\F32B\"}.zmdi-battery-charging:before{content:\"\\F114\"}.zmdi-daydream-setting:before{content:\"\\F217\"}.zmdi-more-horiz:before{content:\"\\F19C\"}.zmdi-book-photo:before{content:\"\\F11B\"}.zmdi-incandescent:before{content:\"\\F189\"}.zmdi-wb-iridescent:before{content:\"\\F38C\"}.zmdi-calendar-remove:before{content:\"\\F330\"}.zmdi-refresh-sync-disabled:before{content:\"\\F1B7\"}.zmdi-refresh-sync-problem:before{content:\"\\F1B6\"}.zmdi-crop-original:before{content:\"\\F17E\"}.zmdi-power-off:before{content:\"\\F1AF\"}.zmdi-power-off-setting:before{content:\"\\F1AE\"}.zmdi-leak-remove:before{content:\"\\F38D\"}.zmdi-star-border:before{content:\"\\F27C\"}.zmdi-brightness-low:before{content:\"\\F36D\"}.zmdi-brightness-medium:before{content:\"\\F36E\"}.zmdi-brightness-high:before{content:\"\\F36F\"}.zmdi-smartphone-portrait:before{content:\"\\F2D4\"}.zmdi-live-tv:before{content:\"\\F2D9\"}.zmdi-format-textdirection-l-to-r:before{content:\"\\F249\"}.zmdi-format-textdirection-r-to-l:before{content:\"\\F24A\"}.zmdi-arrow-back:before{content:\"\\F2EA\"}.zmdi-arrow-forward:before{content:\"\\F2EE\"}.zmdi-arrow-in:before{content:\"\\F2E9\"}.zmdi-arrow-out:before{content:\"\\F2ED\"}.zmdi-rotate-90-degrees-ccw:before{content:\"\\F304\"}.zmdi-adb:before{content:\"\\F33A\"}.zmdi-network-wifi:before{content:\"\\F2E8\"}.zmdi-network-wifi-alt:before{content:\"\\F2E3\"}.zmdi-network-wifi-lock:before{content:\"\\F2E5\"}.zmdi-network-wifi-off:before{content:\"\\F2E6\"}.zmdi-network-wifi-outline:before{content:\"\\F2E7\"}.zmdi-network-wifi-info:before{content:\"\\F2E4\"}.zmdi-layers-clear:before{content:\"\\F18B\"}.zmdi-colorize:before{content:\"\\F15D\"}.zmdi-format-paint:before{content:\"\\F1BA\"}.zmdi-format-quote:before{content:\"\\F1B2\"}.zmdi-camera-monochrome-photos:before{content:\"\\F285\"}.zmdi-sort-by-alpha:before{content:\"\\F1CF\"}.zmdi-folder-shared:before{content:\"\\F225\"}.zmdi-folder-special:before{content:\"\\F226\"}.zmdi-comment-dots:before{content:\"\\F260\"}.zmdi-reorder:before{content:\"\\F31E\"}.zmdi-dehaze:before{content:\"\\F197\"}.zmdi-sort:before{content:\"\\F1CE\"}.zmdi-pages:before{content:\"\\F34A\"}.zmdi-stack-overflow:before{content:\"\\F35C\"}.zmdi-calendar-account:before{content:\"\\F204\"}.zmdi-paste:before{content:\"\\F109\"}.zmdi-cut:before{content:\"\\F1BC\"}.zmdi-save:before{content:\"\\F297\"}.zmdi-smartphone-code:before{content:\"\\F139\"}.zmdi-directions-bike:before{content:\"\\F117\"}.zmdi-directions-boat:before{content:\"\\F11A\"}.zmdi-directions-bus:before{content:\"\\F121\"}.zmdi-directions-car:before{content:\"\\F125\"}.zmdi-directions-railway:before{content:\"\\F1B3\"}.zmdi-directions-run:before{content:\"\\F215\"}.zmdi-directions-subway:before{content:\"\\F1D5\"}.zmdi-directions-walk:before{content:\"\\F216\"}.zmdi-local-hotel:before{content:\"\\F178\"}.zmdi-local-activity:before,.zmdi-local-play:before{content:\"\\F1DF\"}.zmdi-local-airport:before{content:\"\\F103\"}.zmdi-local-atm:before{content:\"\\F198\"}.zmdi-local-bar:before{content:\"\\F137\"}.zmdi-local-cafe:before{content:\"\\F13B\"}.zmdi-local-car-wash:before{content:\"\\F124\"}.zmdi-local-convenience-store:before{content:\"\\F1D3\"}.zmdi-local-dining:before{content:\"\\F153\"}.zmdi-local-drink:before{content:\"\\F157\"}.zmdi-local-florist:before{content:\"\\F168\"}.zmdi-local-gas-station:before{content:\"\\F16F\"}.zmdi-local-grocery-store:before{content:\"\\F1CB\"}.zmdi-local-hospital:before{content:\"\\F177\"}.zmdi-local-laundry-service:before{content:\"\\F1E9\"}.zmdi-local-library:before{content:\"\\F18D\"}.zmdi-local-mall:before{content:\"\\F195\"}.zmdi-local-movies:before{content:\"\\F19D\"}.zmdi-local-offer:before{content:\"\\F187\"}.zmdi-local-parking:before{content:\"\\F1A5\"}.zmdi-local-pharmacy:before{content:\"\\F176\"}.zmdi-local-phone:before{content:\"\\F2BE\"}.zmdi-local-pizza:before{content:\"\\F1AC\"}.zmdi-local-post-office:before{content:\"\\F15A\"}.zmdi-local-printshop:before{content:\"\\F1B0\"}.zmdi-local-see:before{content:\"\\F28C\"}.zmdi-local-shipping:before{content:\"\\F1E6\"}.zmdi-local-store:before{content:\"\\F1D4\"}.zmdi-local-taxi:before{content:\"\\F123\"}.zmdi-local-wc:before{content:\"\\F211\"}.zmdi-my-location:before{content:\"\\F299\"}.zmdi-directions:before{content:\"\\F1E7\"}", ""]);
	
	// exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4d31128b633bc0b1cc1f18a34fb3851.woff2";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d2a55d331bdd1a7ea97a8a1fbb3c569c.woff";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b351bd62abcd96e924d9f44a3da169a7.ttf";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(309) + ");src:url(" + __webpack_require__(310) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(311) + ") format(\"woff2\"),url(" + __webpack_require__(312) + ") format(\"woff\"),url(" + __webpack_require__(313) + ") format(\"truetype\"),url(" + __webpack_require__(314) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 310 */
309,
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.i(__webpack_require__(316), "");
	exports.i(__webpack_require__(317), "");
	exports.i(__webpack_require__(318), "");
	exports.i(__webpack_require__(352), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Copyright 2013-2017 ASIAL CORPORATION\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *    http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n *\n */\n/*!\n * Copyright 2012 Adobe Systems Inc.;\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n *\n */", ""]);
	
	// exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--background-color:#efeff4;--text-color:#1f1f21;--sub-text-color:#999;--highlight-color:#0076ff;--second-highlight-color:#25a6d9;--border-color:#ccc;--button-background-color:var(--highlight-color);--button-cta-background-color:var(--second-highlight-color);--toolbar-background-color:#fafafa;--toolbar-button-color:var(--highlight-color);--toolbar-text-color:#1f1f21;--toolbar-border-color:#b2b2b2;--button-bar-color:var(--highlight-color);--button-bar-active-text-color:#fff;--button-bar-active-background-color:color(var(--button-bar-color) tint(70%));--button-light-color:#000;--segment-color:var(--highlight-color);--segment-active-text-color:#fff;--segment-active-background-color:color(var(--segment-color) tint(70%));--list-background-color:#fff;--list-header-background-color:#eee;--list-tap-active-background-color:#d9d9d9;--list-item-chevron-color:#c7c7cc;--progress-bar-color:var(--highlight-color);--progress-bar-secondary-color:#65adff;--progress-bar-background-color:transparent;--progress-circle-primary-color:var(--highlight-color);--progress-circle-secondary-color:#65adff;--progress-circle-background-color:transparent;--tabbar-background-color:#fafafa;--tabbar-text-color:#999;--tabbar-highlight-text-color:var(--highlight-color);--tabbar-border-color:#ccc;--switch-highlight-color:#44db5e;--switch-border-color:#e5e5e5;--switch-background-color:#fff;--range-track-background-color:#a4aab3;--range-track-background-color-active:var(--highlight-color);--range-thumb-background-color:#fff;--modal-background-color:rgba(0,0,0,.7);--modal-text-color:#fff;--alert-dialog-background-color:#f4f4f4;--alert-dialog-text-color:#1f1f21;--alert-dialog-button-color:var(--highlight-color);--alert-dialog-separator-color:#ddd;--dialog-background-color:#f4f4f4;--dialog-text-color:var(--text-color);--popover-background-color:#fff;--popover-text-color:#1f1f21;--action-sheet-title-color:#8f8e94;--action-sheet-button-separator-color:rgba(0,0,0,.1);--action-sheet-button-color:var(--highlight-color);--action-sheet-button-destructive-color:#fe3824;--action-sheet-button-background-color:hsla(0,0%,100%,.9);--action-sheet-button-active-background-color:#e9e9e9;--action-sheet-cancel-button-background-color:#fff;--notification-background-color:#fe3824;--notification-color:#fff;--search-input-background-color:rgba(3,3,3,.09);--fab-text-color:#fff;--fab-background-color:var(--highlight-color);--fab-active-background-color:color(var(--fab-background-color) a(70%));--card-background-color:#fff;--card-text-color:#030303;--toast-background-color:rgba(0,0,0,.8);--toast-text-color:#fff;--toast-button-text-color:#fff;--select-input-color:var(--text-color);--select-input-border-color:var(--border-color);--material-background-color:#eceff1;--material-text-color:var(--text-color);--material-notification-background-color:#e91e63;--material-notification-color:#fff;--material-switch-active-thumb-color:#37474f;--material-switch-active-background-color:color(#37474f a(50%));--material-switch-inactive-thumb-color:#f1f1f1;--material-switch-inactive-background-color:#b0afaf;--material-range-track-color:#bdbdbd;--material-range-thumb-color:#31313a;--material-range-disabled-thumb-color:#b0b0b0;--material-range-disabled-thumb-border-color:#eee;--material-range-zero-thumb-color:#f2f2f2;--material-toolbar-background-color:#fff;--material-toolbar-text-color:#31313a;--material-toolbar-button-color:#1e88e5;--material-segment-background-color:#fafafa;--material-segment-active-background-color:#c8c8c8;--material-segment-text-color:color(#000 a(38%));--material-segment-active-text-color:#353535;--material-button-background-color:#2979ff;--material-button-text-color:#fff;--material-button-disabled-background-color:color(#4f4f4f a(26%));--material-button-disabled-color:color(#000 a(26%));--material-flat-button-active-background-color:color(#999 a(20%));--material-list-background-color:#fff;--material-list-item-separator-color:#eee;--material-list-header-text-color:#757575;--material-checkbox-active-color:#37474f;--material-checkbox-inactive-color:#717171;--material-checkbox-checkmark-color:#fff;--material-radio-button-active-color:#37474f;--material-radio-button-inactive-color:#717171;--material-radio-button-disabled-color:#afafaf;--material-text-input-text-color:#212121;--material-text-input-active-color:#3d5afe;--material-text-input-inactive-color:#afafaf;--material-search-background-color:#fafafa;--material-dialog-background-color:#fff;--material-dialog-text-color:var(--material-text-color);--material-alert-dialog-background-color:#fff;--material-alert-dialog-title-color:#31313a;--material-alert-dialog-content-color:rgba(49,49,58,.85);--material-alert-dialog-button-color:#37474f;--material-progress-bar-primary-color:#37474f;--material-progress-bar-secondary-color:#548ba7;--material-progress-bar-background-color:transparent;--material-progress-circle-primary-color:var(--material-progress-bar-primary-color);--material-progress-circle-secondary-color:var(--material-progress-bar-secondary-color);--material-progress-circle-background-color:transparent;--material-tabbar-background-color:#fff;--material-tabbar-text-color:#31313a;--material-tabbar-highlight-text-color:#31313a;--material-tabbar-highlight-color:rgba(49,49,58,.1);--material-fab-text-color:#31313a;--material-fab-background-color:#fff;--material-fab-active-background-color:hsla(0,0%,100%,.75);--material-card-background-color:#fff;--material-card-text-color:rgba(0,0,0,.54);--material-toast-background-color:rgba(0,0,0,.8);--material-toast-text-color:#fff;--material-toast-button-text-color:#bbdefb;--material-select-input-color:var(--material-text-color);--material-select-input-active-color:rgba(0,0,0,.15);--material-select-input-inactive-color:rgba(0,0,0,.81);--material-select-border-color:color(#000 a(12%));--material-popover-background-color:#fafafa;--material-popover-text-color:var(--material-text-color);--material-action-sheet-text-color:#686868;--tap-highlight-color:transparent}", ""]);
	
	// exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.i(__webpack_require__(319), "");
	exports.i(__webpack_require__(320), "");
	exports.i(__webpack_require__(321), "");
	exports.i(__webpack_require__(322), "");
	exports.i(__webpack_require__(323), "");
	exports.i(__webpack_require__(324), "");
	exports.i(__webpack_require__(325), "");
	exports.i(__webpack_require__(326), "");
	exports.i(__webpack_require__(327), "");
	exports.i(__webpack_require__(328), "");
	exports.i(__webpack_require__(329), "");
	exports.i(__webpack_require__(330), "");
	exports.i(__webpack_require__(331), "");
	exports.i(__webpack_require__(332), "");
	exports.i(__webpack_require__(333), "");
	exports.i(__webpack_require__(334), "");
	exports.i(__webpack_require__(337), "");
	exports.i(__webpack_require__(338), "");
	exports.i(__webpack_require__(339), "");
	exports.i(__webpack_require__(340), "");
	exports.i(__webpack_require__(341), "");
	exports.i(__webpack_require__(342), "");
	exports.i(__webpack_require__(343), "");
	exports.i(__webpack_require__(344), "");
	exports.i(__webpack_require__(345), "");
	exports.i(__webpack_require__(346), "");
	exports.i(__webpack_require__(348), "");
	exports.i(__webpack_require__(349), "");
	exports.i(__webpack_require__(350), "");
	exports.i(__webpack_require__(351), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--input-bg-color:var(--background-color);--input-border-color:var(--border-color);--input-text-color:var(--text-color);--input-placeholder-color:var(--sub-text-color);--input-invalid-border-color:var(--border-color);--input-invalid-text-color:var(--text-color);--input-border:1px solid var(--input-border-color);--alpha-lighten:70%;--font-size:17px;--font-weight:400;--material-font-size:17px;--material-font-weight:400;--font-size--mini:calc(var(--font-size) - 3px);--font-weight--large:500;--background-color--input:transparent}html{height:100%;width:100%}body{position:absolute;overflow:hidden;top:0;right:0;left:0;bottom:0;padding:0;margin:0;-webkit-text-size-adjust:100%;touch-action:manipulation}a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{user-select:none;-webkit-tap-highlight-color:var(--tap-highlight-color);-webkit-touch-callout:none}input,select,textarea{user-select:auto;-moz-user-select:text;-webkit-touch-callout:none}a,button,input,select,textarea{touch-action:manipulation}input:active,input:focus,select:active,select:focus,textarea:active,textarea:focus{outline:none}h1{font-size:36px}h2{font-size:30px}h3{font-size:24px}h4,h5,h6{font-size:18px}", ""]);
	
	// exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{\\--reset-font:{font-family:-apple-system,Helvetica Neue,Helvetica,Arial,Lucida Grande,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-weight:var(--font-weight)}\\--reset-box-model:{box-sizing:border-box;background-clip:padding-box}\\--reset-base:{padding:0;margin:0;font:inherit;color:inherit;background:transparent;border:none;line-height:normal}\\--reset-input:{@apply(--reset-box-model);padding:0;margin:0;font:inherit;color:inherit;background:transparent;border:none;vertical-align:top;outline:none;line-height:1}\\--hide-input:{position:absolute;right:0;top:0;left:0;bottom:0;padding:0;border:0;background-color:transparent;z-index:1;vertical-align:top;outline:none;width:100%;height:100%;margin:0;appearance:none}\\--hide-input-parent:{position:relative}\\--reset-cursor:{cursor:default;user-select:none}\\--reset-overflow:{white-space:nowrap;overflow:hidden}\\--reset-container:{@apply(--reset-box-model);@apply(--reset-overflow);word-spacing:0}\\--ellipsis:{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}\\--disabled:{opacity:.3;cursor:default;pointer-events:none}\\--input:{@apply(--reset-input);@apply(--reset-font)}\\--transparent:{border:none;background-color:transparent}@custom-media (min-resolution:2dppx),(min-resolution:192dpi),--retina-query (-webkit-min-device-pixel-ratio:2);\\--material-font:{font-family:Roboto,Noto,sans-serif;-webkit-font-smoothing:antialiased;font-weight:var(--material-font-weight)}\\--material-shadow-0:{box-shadow:none}\\--material-shadow-1:{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.2)}\\--material-shadow-2:{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.4)}\\--material-shadow-3:{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.4)}\\--material-shadow-4:{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.4)}\\--material-shadow-5:{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.4)}\\--checkmark:{content:\"\";position:absolute;top:7px;left:4px;opacity:0;width:11px;height:4px;background:transparent;border:2px solid var(--highlight-color);border-top:none;border-right:none;border-radius:0;transform:rotate(-45deg)}}", ""]);
	
	// exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--page-background-color:var(--background-color);--page-material-background-color:var(--material-background-color)}.page{@apply(--reset-font);background-color:var(--page-background-color);position:absolute;top:0;left:0;right:0;bottom:0;overflow-x:visible;overflow-y:hidden;color:var(--text-color);-ms-overflow-style:none;-webkit-font-smoothing:antialiased}.page::-webkit-scrollbar{display:none}.page__background,.page__content{background-color:var(--page-background-color);position:absolute;top:0;left:0;right:0;bottom:0;box-sizing:border-box}.page--material{@apply(--material-font);background-color:var(--page-material-background-color)}.page--material__content{@apply(--material-font);font-weight:var(--font-weight)}.page__content h1,.page__content h2,.page__content h3,.page__content h4,.page__content h5{@apply(--material-font);font-weight:var(--font-weight--large);margin:.6em 0;padding:0}.page__content h1{font-size:28px}.page__content h2{font-size:24px}.page__content h3{font-size:20px}.page--material__content h1,.page--material__content h2,.page--material__content h3,.page--material__content h4,.page--material__content h5{@apply(--material-font);font-weight:var(--font-weight--large);margin:.6em 0;padding:0}.page--material__content h1{font-size:28px}.page--material__content h2{font-size:24px}.page--material__content h3{font-size:20px}.page--material__background{background-color:var(--page-material-background-color)}", ""]);
	
	// exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--switch-checked-background-color:var(--switch-highlight-color);--switch-thumb-background-color:#fff;--switch-thumb-border-color:var(--border-color);--switch-thumb-border-color-active:var(--switch-highlight-color);--switch-height:32px;--switch-width:51px;\\--switch:{display:inline-block;vertical-align:top;@apply(--reset-box-model);@apply(--hide-input-parent);min-width:51px}\\--switch__toggle:{position:relative;display:inline-block;vertical-align:top;@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-cursor)}}.switch{@apply(--switch);font-size:var(--font-size);padding:0 20px;border:none;overflow:visible;width:var(--switch-width);height:var(--switch-height);z-index:0;text-align:left}.switch__input{@apply(--hide-input);z-index:0}.switch__toggle{background-color:var(--switch-background-color);position:absolute;top:0;left:0;right:0;bottom:0;border-radius:30px;transition-property:all;transition-duration:.35s;transition-timing-function:ease-out;box-shadow:inset 0 0 0 2px var(--switch-border-color)}.switch__handle{@apply(--reset-box-model);position:absolute;content:\"\";border-radius:28px;height:28px;width:28px;background-color:var(--switch-thumb-background-color);left:1px;top:2px;transition-property:all;transition-duration:.35s;transition-timing-function:cubic-bezier(.59,.01,.5,.99);box-shadow:0 0 1px 0 rgba(0,0,0,.25),0 3px 2px rgba(0,0,0,.25)}.switch--active__handle{transition:none}:checked+.switch__toggle{box-shadow:inset 0 0 0 2px var(--switch-checked-background-color);background-color:var(--switch-checked-background-color)}:checked+.switch__toggle>.switch__handle{left:21px;box-shadow:0 3px 2px rgba(0,0,0,.25)}:disabled+.switch__toggle{@apply(--disabled)}.switch__touch{position:absolute;top:-5px;bottom:-5px;left:-10px;right:-10px}.switch--material{width:36px;height:24px;padding:0 10px;min-width:36px}.switch--material__toggle{background-color:var(--material-switch-inactive-background-color);margin-top:5px;height:14px;box-shadow:none}.switch--material__input{@apply(--hide-input);z-index:0}.switch--material__handle{background-color:var(--material-switch-inactive-thumb-color);left:0;margin-top:-5px;width:20px;height:20px;@apply(--material-shadow-2)}:checked+.switch--material__toggle{background-color:var(--material-switch-active-background-color);box-shadow:none}:checked+.switch--material__toggle>.switch--material__handle{left:16px;background-color:var(--material-switch-active-thumb-color);@apply(--material-shadow-1)}:disabled+.switch--material__toggle{@apply(--disabled)}.switch--material__handle:before{background:transparent;content:\"\";display:block;width:100%;height:100%;border-radius:50%;z-index:0;box-shadow:0 0 0 0 rgba(0,0,0,.12);transition:box-shadow .1s linear}.switch--material__toggle>.switch--active__handle:before{box-shadow:0 0 0 14px rgba(0,0,0,.12)}:checked+.switch--material__toggle>.switch--active__handle:before{box-shadow:0 0 0 14px color(var(--material-switch-active-thumb-color) alpha(20%))}.switch--material__touch{position:absolute;top:-10px;bottom:-10px;left:-15px;right:-15px}", ""]);
	
	// exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--range-thumb-size:28px;--range-track-height:2px;--material-range-track-height:2px;--material-range-thumb-size:14px;--material-range-thumb-radius:calc(var(--material-range-thumb-size) / 2);--material-range-thumb-vertical-margin:24px;--material-range-thumb-horizontal-margin:2px;\\--range__thumb:{cursor:pointer;position:relative;height:var(--range-thumb-size);width:var(--range-thumb-size);background-color:var(--range-thumb-background-color);border:none;box-shadow:0 0 1px 0 rgba(0,0,0,.25),0 3px 2px rgba(0,0,0,.25);border-radius:50%;margin:0;padding:0}}.range{display:inline-block;width:100px;margin:0;padding:0;background-image:linear-gradient(var(--range-track-background-color),var(--range-track-background-color));background-size:100% var(--range-track-height);background-color:transparent}.range,.range__input{position:relative;height:calc(var(--range-thumb-size) + 2px);background-position:0;background-repeat:no-repeat}.range__input{@apply(--reset-input);appearance:none;background-image:linear-gradient(var(--range-track-background-color-active),var(--range-track-background-color-active));background-size:0 var(--range-track-height);z-index:1;width:100%}.range__input::-moz-range-track{position:relative;border:none;background:none;box-shadow:none;top:0;margin:0;padding:0}.range__input::-ms-track{position:relative;border:none;background-color:var(--range-track-background-color);height:0;border-radius:50%}.range__input::-webkit-slider-thumb{@apply(--range__thumb);box-sizing:border-box;appearance:none;top:0;z-index:1}.range__input::-moz-range-thumb{@apply(--range__thumb)}.range__input::-ms-thumb{@apply(--range__thumb);top:0}.range__input::-ms-fill-lower{height:2px;background-color:var(--range-track-background-color-active)}.range__input::-ms-tooltip{display:none}.range__input:disabled{opacity:1;pointer-events:none}.range__focus-ring{pointer-events:none;top:0;left:0;display:none;@apply(--reset-input);appearance:none;background:none;height:calc(var(--range-thumb-size) + 2px);position:absolute;z-index:0;width:100%}.range--disabled{@apply(--disabled);pointer-events:none}.range--material{position:relative;background-image:linear-gradient(var(--material-range-track-color),var(--material-range-track-color))}.range--material__input{background-image:linear-gradient(var(--material-range-thumb-color),var(--material-range-thumb-color));background-position:0;background-size:0 2px}.range--material__focus-ring{display:block}.range--material__focus-ring::-webkit-slider-thumb{appearance:none;width:var(--material-range-thumb-size);height:var(--material-range-thumb-size);border:none;box-shadow:0 0 0 calc((32px - var(--material-range-thumb-size)) / 2) var(--material-range-thumb-color);background-color:var(--material-range-thumb-color);border-radius:50%;opacity:0;transition:opacity .25s ease-out,transform .25s ease-out}.range--material__input.range__input--active+.range--material__focus-ring::-webkit-slider-thumb{opacity:.2;transform:scale(1.5)}.range--material__input::-webkit-slider-thumb{position:relative;box-sizing:border-box;border:none;background-color:transparent;width:var(--material-range-thumb-size);height:32px;border-radius:0;box-shadow:none;background-image:radial-gradient(circle farthest-corner,var(--material-range-thumb-color) 0,var(--material-range-thumb-color) calc(var(--material-range-thumb-radius) - .4px),transparent var(--material-range-thumb-radius));transition:transform .1s linear;overflow:visible}.range--material__input[_zero]::-webkit-slider-thumb{background-image:radial-gradient(circle farthest-corner,var(--material-range-zero-thumb-color) 0,var(--material-range-zero-thumb-color) 4px,var(--material-range-track-color) 0,var(--material-range-track-color) calc(var(--material-range-thumb-radius) - .6px),transparent calc(var(--material-range-thumb-radius)))}.range--material__input[_zero]+.range--material__focus-ring::-webkit-slider-thumb{box-shadow:0 0 0 calc((32px - var(--material-range-thumb-size)) / 2) var(--material-range-track-color)}.range--material__input::-moz-range-track{background:none}.range--material__input::-moz-range-thumb,.range--material__input:focus::-moz-range-thumb{box-sizing:border-box;border:none;width:var(--material-range-thumb-size);height:32px;border-radius:0;background-color:transparent;background-image:-moz-radial-gradient(circle farthest-corner,var(--material-range-thumb-color) 0,var(--material-range-thumb-color) calc(var(--material-range-thumb-radius) - .4px),transparent var(--material-range-thumb-radius));box-shadow:none}.range--material__input.range__input--active::-webkit-slider-thumb,.range--material__input:active::-webkit-slider-thumb{transform:scale(1.5);transition:transform .1s linear}.range--disabled.range--material{opacity:1}.range--disabled>.range--material__input{background-image:none}.range--material__input:disabled::-webkit-slider-thumb{background-image:radial-gradient(circle farthest-corner,var(--material-range-disabled-thumb-color) 0,var(--material-range-disabled-thumb-color) 4px,var(--material-range-disabled-thumb-border-color) 4.4px,var(--material-range-disabled-thumb-border-color) calc(var(--material-range-thumb-radius) + .6px),transparent calc(var(--material-range-thumb-radius) + .6px));transition:none}.range--material__input:disabled::-moz-range-thumb{background-image:-moz-radial-gradient(circle farthest-corner,var(--material-range-disabled-thumb-color) 0,var(--material-range-disabled-thumb-color) 4px,var(--material-range-disabled-thumb-border-color) 4.4px,var(--material-range-disabled-thumb-border-color) calc(var(--material-range-thumb-radius) + .6px),transparent calc(var(--material-range-thumb-radius) + .6px));transition:none}", ""]);
	
	// exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--notification-border-radius:19px;--notification-width:auto;--notification-height:19px;--notification-min-width:19px;--notification-padding:0 4px;--notification-font-weight:var(--font-weight);--notification-font-size:16px;--material-notification-font-size:16px;--material-notification-font-weight:500}.notification{position:relative;display:inline-block;vertical-align:top;font:inherit;border:none;@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);@apply(--reset-cursor);@apply(--ellipsis);text-decoration:none;margin:0;padding:var(--notification-padding);width:var(--notification-width);height:var(--notification-height);border-radius:var(--notification-border-radius);background-color:var(--notification-background-color);color:var(--notification-color);text-align:center;font-size:var(--notification-font-size);min-width:var(--notification-min-width);line-height:var(--notification-height);font-weight:var(--notification-font-weight)}.notification:empty{display:none}.notification--material{@apply(--material-font);background-color:var(--material-notification-background-color);font-size:var(--material-notification-font-size);font-weight:var(--material-notification-font-weight);color:var(--material-notification-color)}", ""]);
	
	// exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--toolbar-separator-color:var(--toolbar-border-color);--toolbar-color:var(--toolbar-text-color);--toolbar-height:44px;--toolbar-box-shadow:none;--toolbar-padding:0;--toolbar-separator:1px solid var(--toolbar-separator-color);--toolbar-material-height:56px;--material-toolbar-color:var(--material-toolbar-text-color);\\--retina-toolbar-top-border:{border-top:none;background-size:100% 1px;background-repeat:no-repeat;background-position:top;background-image:linear-gradient(180deg,var(--toolbar-separator-color),var(--toolbar-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(180deg,var(--toolbar-separator-color),var(--toolbar-separator-color) 50%,transparent 0)}}\\--retina-toolbar-bottom-border:{border-bottom:none;background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--toolbar-separator-color),var(--toolbar-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(0deg,var(--toolbar-separator-color),var(--toolbar-separator-color) 50%,transparent 0)}}\\--toolbar:{@apply(--reset-font);@apply(--reset-container);@apply(--reset-base);@apply(--reset-cursor);z-index:2}\\--toolbar__item:{@apply(--reset-box-model);@apply(--reset-base)}\\--toolbar--material-font:{@apply(--material-font);font-size:20px;font-weight:500;color:var(--material-toolbar-color)}}.toolbar{@apply(--toolbar);display:flex;align-items:stretch;flex-wrap:nowrap;height:var(--toolbar-height);padding-left:var(--toolbar-padding);padding-right:var(--toolbar-padding);color:var(--toolbar-color);box-shadow:var(--toolbar-box-shadow);font-weight:var(--font-weight);width:100%;white-space:nowrap;@apply(--retina-toolbar-bottom-border)}.toolbar,.toolbar__bg{background:var(--toolbar-background-color)}.toolbar__item{@apply(--toolbar__item);height:var(--toolbar-height);overflow:visible;display:block;vertical-align:middle}.toolbar__left{@apply(--toolbar__item);text-align:left}.toolbar__left,.toolbar__right{max-width:50%;width:27%;line-height:var(--toolbar-height)}.toolbar__right{@apply(--toolbar__item);text-align:right}.toolbar__center{@apply(--toolbar__item);width:46%;text-align:center}.toolbar__center,.toolbar__title{line-height:var(--toolbar-height);font-size:var(--font-size);font-weight:var(--font-weight--large);color:var(--toolbar-color)}.toolbar__title{margin:0;padding:0;overflow:visible}.toolbar__center:first-child:last-child{width:100%}.bottom-bar{@apply(--toolbar);display:block;height:var(--toolbar-height);padding-left:var(--toolbar-padding);padding-right:var(--toolbar-padding);background:var(--toolbar-background-color);color:var(--toolbar-color);box-shadow:var(--toolbar-box-shadow);font-weight:var(--font-weight);border-bottom:none;border-top:var(--toolbar-separator);position:absolute;bottom:0;right:0;left:0;@apply(--retina-toolbar-top-border)}.bottom-bar__line-height{line-height:var(--toolbar-height);padding-bottom:0;padding-top:0}.bottom-bar--aligned{display:flex;flex-wrap:nowrap;line-height:var(--toolbar-height)}.bottom-bar--transparent{background-color:transparent;background-image:none;border:none}.toolbar--material{display:flex;flex-wrap:nowrap;justify-content:space-between;height:var(--toolbar-material-height);border-bottom:0;box-shadow:0 1px 5px rgba(0,0,0,.3);padding:0;background-color:var(--material-toolbar-background-color);background-size:0}.toolbar--noshadow{box-shadow:none;background-image:none;border-bottom:none}.toolbar--material__left,.toolbar--material__right{@apply(--toolbar--material-font);min-width:72px}.toolbar--material__center,.toolbar--material__left,.toolbar--material__right{height:var(--toolbar-material-height);width:auto;line-height:var(--toolbar-material-height)}.toolbar--material__center{@apply(--toolbar--material-font);flex-grow:1;overflow:hidden;text-overflow:ellipsis;text-align:left}.toolbar--material__center:first-child{margin-left:16px}.toolbar--material__center:last-child{margin-right:16px}.toolbar--material__left:empty,.toolbar--material__right:empty{min-width:16px}.toolbar--transparent{background-color:transparent;box-shadow:none;background-image:none;border-bottom:none}", ""]);
	
	// exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--button-text-color:#fff;--button-quiet-color:var(--highlight-color);--button-cta-color:#fff;--button-large-padding:4px 12px;--button-padding:4px 10px;--button-line-height:32px;--button-large-line-height:36px;--button-active-opacity:0.2;--button-border-radius:3px;\\--button--quiet:{background:transparent;border:1px solid transparent;box-shadow:none}\\--button--disabled:{@apply(--disabled)}\\--button--hover:{transition:none}\\--button:{position:relative;display:inline-block;@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);@apply(--reset-cursor);@apply(--ellipsis);height:auto;text-decoration:none;padding:var(--button-padding);font-size:var(--font-size);line-height:var(--button-line-height);letter-spacing:0;color:var(--button-text-color);vertical-align:middle;background-color:var(--button-background-color);border:0 solid currentColor;border-radius:var(--button-border-radius);transition:none}\\--button--focus:{outline:0}\\--button--active:{background-color:var(--button-background-color);transition:none;opacity:var(--button-active-opacity)}\\--button--material:{@apply(--button);@apply(--material-shadow-1);@apply(--material-font);min-height:36px;line-height:36px;padding:0 16px;text-align:center;font-size:14px;transform:translateZ(0);text-transform:uppercase;background-color:var(--material-button-background-color);color:var(--material-button-text-color);font-weight:var(--font-weight--large);transition:background-color .25s linear}}.button{@apply(--button)}.button:hover{@apply(--button--hover)}.button:active{@apply(--button--active)}.button:focus{@apply(--button--focus)}.button:disabled,.button[disabled]{@apply(--button--disabled)}.button--outline{background-color:transparent}.button--outline,.button--outline:active{border:1px solid var(--button-background-color);color:var(--button-background-color)}.button--outline:active{background-color:color(var(--button-background-color) tint(var(--alpha-lighten)));opacity:1}.button--outline:hover{border:1px solid var(--button-background-color);transition:0}.button--light{background-color:transparent}.button--light,.button--light:active{color:color(var(--button-light-color) a(40%));border:1px solid color(var(--button-light-color) a(20%))}.button--light:active{background-color:color(var(--button-light-color) a(5%));opacity:1}.button--quiet{@apply(--button);@apply(--button--quiet);background:transparent;color:var(--button-quiet-color);border:none}.button--quiet:disabled,.button--quiet[disabled]{@apply(--button--disabled);border:none}.button--quiet:hover{@apply(--button--hover)}.button--quiet:focus{@apply(--button--focus)}.button--quiet:active{background-color:transparent;border:none;transition:none;opacity:var(--button-active-opacity);color:var(--button-quiet-color)}.button--cta{@apply(--button);border:none;background-color:var(--button-cta-background-color);color:var(--button-cta-color)}.button--cta:hover{@apply(--button--hover)}.button--cta:focus{@apply(--button--focus)}.button--cta:active{color:var(--button-cta-color);background-color:var(--button-cta-background-color);transition:none;opacity:var(--button-active-opacity)}.button--cta:disabled,.button--cta[disabled]{@apply(--button--disabled)}.button--large{font-size:var(--font-size);font-weight:var(--font-weight--large);line-height:var(--button-large-line-height);padding:var(--button-large-padding);display:block;width:100%;text-align:center}.button--large:active{@apply(--button--active);transition:none}.button--large:disabled,.button--large[disabled]{@apply(--button--disabled)}.button--large:hover{@apply(--button--hover)}.button--large:focus{@apply(--button--focus)}.button--large--quiet{@apply(--button);font-size:var(--font-size);font-weight:var(--font-weight--large);line-height:var(--button-large-line-height);padding:var(--button-large-padding);display:block;width:100%;@apply(--button--quiet);color:var(--button-quiet-color);text-align:center}.button--large--quiet:active{transition:none;opacity:var(--button-active-opacity);color:var(--button-quiet-color);@apply(--button--quiet)}.button--large--quiet:disabled,.button--large--quiet[disabled]{@apply(--button--disabled)}.button--large--quiet:hover{@apply(--button--hover)}.button--large--quiet:focus{outline:0}.button--large--cta{@apply(--button);border:none;background-color:var(--button-cta-background-color);color:var(--button-cta-color);font-size:var(--font-size);font-weight:var(--font-weight--large);line-height:var(--button-large-line-height);padding:var(--button-large-padding);width:100%;text-align:center;display:block}.button--large--cta:hover{@apply(--button--hover)}.button--large--cta:focus{@apply(--button--focus)}.button--large--cta:active{color:var(--button-cta-color);background-color:var(--button-cta-background-color);transition:none;opacity:var(--button-active-opacity)}.button--large--cta:disabled,.button--large--cta[disabled]{@apply(--button--disabled)}.button--material{@apply(--button--material);opacity:1}.button--material,.button--material:active,.button--material:hover{transition:all .25s linear}.button--material:active{@apply(--material-shadow-3);background-color:var(--material-button-background-color);opacity:.9}.button--material:focus{@apply(--button--focus)}.button--material:disabled,.button--material[disabled]{transition:none;@apply(--material-shadow-0);background-color:var(--material-button-disabled-background-color);color:var(--material-button-disabled-color);opacity:1}.button--material--flat{@apply(--button--material);@apply(--material-shadow-0);background-color:transparent;color:var(--material-button-background-color)}.button--material--flat,.button--material--flat:hover{transition:all .25s linear}.button--material--flat:focus{@apply(--material-shadow-0);background-color:transparent}.button--material--flat:active,.button--material--flat:focus{color:var(--material-button-background-color);outline:0;opacity:1;border:none}.button--material--flat:active{@apply(--material-shadow-0);background-color:var(--material-flat-button-active-background-color);transition:all .25s linear}.button--material--flat:disabled,.button--material--flat[disabled]{transition:none;opacity:1;@apply(--material-shadow-0);background-color:transparent;color:var(--material-button-disabled-color)}", ""]);
	
	// exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--button-bar-active-color:var(--button-bar-active-text-color);--button-bar-border-top:1px solid var(--button-bar-color);--button-bar-border-bottom:1px solid var(--button-bar-color);--button-bar-border:0 solid var(--button-bar-color);--button-bar-border-radius:4px;\\--button-bar:{@apply(--reset-font);display:inline-flex;align-items:stretch;align-content:stretch;flex-wrap:nowrap;margin:0;padding:0;border:none}\\--button-bar__item:{@apply(--reset-font);border-radius:0;width:100%;padding:0;margin:0}}.button-bar{@apply(--button-bar)}.button-bar__item{@apply(--button-bar__item);@apply(--hide-input-parent);overflow:hidden;box-sizing:border-box}.button-bar__button{@apply(--reset-font);border-radius:0;background-color:transparent;color:var(--button-bar-color);border:1px solid var(--button-bar-color);border-top-width:1px;border-bottom-width:1px;border-right-width:1px;border-left-width:0;font-weight:var(--font-weight);padding:0;font-size:13px;height:27px;line-height:27px;width:100%;transition:background-color .2s linear,color .2s linear;box-sizing:border-box}.button-bar__button:disabled{@apply(--disabled)}.button-bar__button:hover{transition:none}.button-bar__button:focus{outline:0}:checked+.button-bar__button{background-color:var(--button-bar-color);color:var(--button-bar-active-color);transition:none}.button-bar__button:active,:active+.button-bar__button{background-color:var(--button-bar-active-background-color);border:var(--button-bar-border);border-top:var(--button-bar-border-top);border-bottom:var(--button-bar-border-bottom);border-right:1px solid var(--button-bar-color);font-size:13px;width:100%;transition:none}.button-bar__item:first-child>.button-bar__button{border-left-width:1px;border-radius:var(--button-bar-border-radius) 0 0 var(--button-bar-border-radius)}.button-bar__item:last-child>.button-bar__button{border-right-width:1px;border-radius:0 var(--button-bar-border-radius) var(--button-bar-border-radius) 0}", ""]);
	
	// exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--segment-active-color:var(--segment-active-text-color);--segment-border-top:1px solid var(--segment-color);--segment-border-bottom:1px solid var(--segment-color);--segment-border:0 solid var(--segment-color);--segment-border-radius:4px}.segment{@apply(--reset-font);display:inline-flex;align-items:stretch;align-content:stretch;flex-wrap:nowrap;margin:0;padding:0;border:none}.segment__item{@apply(--reset-font);border-radius:0;width:100%;padding:0;margin:0;@apply(--hide-input-parent);overflow:hidden;box-sizing:border-box;display:block;background-color:transparent;border:none}.segment__input{@apply(--hide-input)}.segment__button{@apply(--reset-font);border-radius:0;background-color:transparent;color:var(--segment-color);border:1px solid var(--segment-color);border-top-width:1px;border-bottom-width:1px;border-right-width:1px;border-left-width:0;font-weight:var(--font-weight);padding:0;font-size:13px;height:29px;line-height:29px;width:100%;transition:background-color .2s linear,color .2s linear;box-sizing:border-box;text-align:center}.segment__item:disabled{@apply(--disabled)}.segment__button:hover{transition:none}.segment__button:focus{outline:0}:active+.segment__button{background-color:var(--segment-active-background-color);border:var(--segment-border);border-top:var(--segment-border-top);border-bottom:var(--segment-border-bottom);border-right:1px solid var(--segment-color);font-size:13px;width:100%;transition:none}:checked+.segment__button{background-color:var(--segment-color);color:var(--segment-active-color);transition:none}.segment__item:first-child>.segment__button{border-left-width:1px;border-radius:var(--segment-border-radius) 0 0 var(--segment-border-radius)}.segment__item:last-child>.segment__button{border-right-width:1px;border-radius:0 var(--segment-border-radius) var(--segment-border-radius) 0}.segment--material{border-radius:2px;overflow:hidden;box-shadow:0 0 2px 0 rgba(0,0,0,.12),0 2px 2px 0 rgba(0,0,0,.24)}.segment--material__button{@apply(--material-font);height:32px;line-height:32px}.segment--material__button,:active+.segment--material__button{font-size:14px;border-width:0;color:var(--material-segment-text-color);border-radius:0;background-color:var(--material-segment-background-color)}:active+.segment--material__button{transition:none}:checked+.segment--material__button{background-color:var(--material-segment-active-background-color);color:var(--material-segment-active-text-color);border-radius:0;border-width:0}.segment--material__item:first-child>.segment--material__button,.segment--material__item:last-child>.segment--material__button{border-radius:0;border-width:0}", ""]);
	
	// exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--tabbar-button-color:var(--tabbar-text-color);--tabbar-active-color:var(--tabbar-highlight-text-color);--material-tabbar-current-color:var(--material-tabbar-highlight-text-color);--tabbar-active-border-top:none;--tabbar-focus-border-top:none;--tabbar-height:49px;--tabbar-button-line-height:49px;--tabbar-button-border:none;--tabbar-active-box-shadow:none;--tabbar-button-focus-box-shadow:none;--tabbar-border-top:1px solid var(--tabbar-border-color);\\--retina-tabbar-top-border:{@media (--retina-query){border-top:none;background-size:100% 1px;background-repeat:no-repeat;background-position:top;background-image:linear-gradient(180deg,var(--tabbar-border-color),var(--tabbar-border-color) 50%,transparent 0)}}\\--retina-tabbar-bottom-border:{@media (--retina-query){border-bottom:none;background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--tabbar-border-color),var(--tabbar-border-color) 50%,transparent 0)}}}.tabbar{@apply(--reset-font);display:flex;position:absolute;bottom:0;left:0;right:0;white-space:nowrap;margin:0;padding:0;height:var(--tabbar-height);background-color:var(--tabbar-background-color);border-top:var(--tabbar-border-top);width:100%;@apply(--retina-tabbar-top-border)}.tabbar__item{@apply(--reset-font);@apply(--hide-input-parent);flex-grow:1;flex-basis:0;width:auto;border-radius:0}.tabbar__item>input{@apply(--hide-input)}.tabbar__button{@apply(--reset-font);@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-cursor);@apply(--ellipsis);position:relative;display:inline-block;text-decoration:none;padding:0;height:var(--tabbar-button-line-height);letter-spacing:0;color:var(--tabbar-button-color);vertical-align:top;background-color:transparent;border-top:var(--tabbar-button-border);width:100%;font-weight:var(--font-weight);line-height:var(--tabbar-button-line-height);@media (--retina-query){border-top:none}}.tabbar__icon{font-size:24px;padding:0;margin:0;line-height:26px;display:block!important;height:28px}.tabbar__label{@apply(--reset-font);display:inline-block}.tabbar__badge.notification{vertical-align:text-bottom;top:-1px;margin-left:5px;z-index:10;font-size:12px;height:16px;min-width:16px;line-height:16px;border-radius:8px}.tabbar__icon~.tabbar__badge.notification{position:absolute;top:5px;margin-left:0}.tabbar__icon+.tabbar__label{display:block;font-size:10px;line-height:1;margin:0;font-weight:var(--font-weight)}.tabbar__label:first-child{font-size:16px;line-height:var(--tabbar-button-line-height);margin:0;padding:0}:checked+.tabbar__button{color:var(--tabbar-active-color);background-color:transparent;box-shadow:var(--tabbar-active-box-shadow);border-top:var(--tabbar-active-border-top)}.tabbar__button:disabled{@apply(--disabled)}.tabbar__button:focus{z-index:1;border-top:var(--tabbar-focus-border-top);box-shadow:var(--tabbar-button-focus-box-shadow);outline:0}.tabbar__content{position:absolute;top:0;left:0;right:0;bottom:var(--tabbar-height);z-index:0}.tabbar--autogrow .tabbar__item{flex-basis:auto}.tabbar--top{position:relative;top:0;left:0;right:0;bottom:auto;border-top:none;border-bottom:var(--tabbar-border-top);@apply(--retina-tabbar-bottom-border)}.tabbar--top__content{top:var(--tabbar-height);left:0;right:0;bottom:0;z-index:0}.tabbar--top-border__button{background-color:transparent;border-bottom:4px solid transparent}:checked+.tabbar--top-border__button{background-color:transparent;border-bottom:4px solid var(--tabbar-active-color)}.tabbar__border{position:absolute;bottom:0;left:0;width:0;height:4px;background-color:var(--tabbar-active-color)}.tabbar--material{background:none;background-color:var(--material-tabbar-background-color);border-bottom-width:0;box-shadow:0 4px 2px -2px rgba(0,0,0,.14),0 3px 5px -2px rgba(0,0,0,.12),0 5px 1px -4px rgba(0,0,0,.2)}.tabbar--material__button{background-color:transparent;color:var(--material-tabbar-text-color);text-transform:uppercase;font-size:14px;font-weight:500;@apply(--material-font)}.tabbar--material__button:after{content:\"\";display:block;width:0;height:2px;bottom:0;position:absolute;margin-top:-2px;background-color:var(--material-tabbar-current-color)}:checked+.tabbar--material__button:after{width:100%;transition:width .2s ease-in-out}:checked+.tabbar--material__button{background-color:transparent;color:var(--material-tabbar-current-color)}.tabbar--material__item:not([ripple]):active{background-color:var(--material-tabbar-highlight-color)}.tabbar--material__border{height:2px;background-color:var(--material-tabbar-current-color)}.tabbar--material__icon{font-size:22px!important;line-height:36px}.tabbar--material__label{@apply(--material-font)}.tabbar--material__label:first-child{@apply(--material-font);letter-spacing:.015em;font-weight:500;font-size:14px}.tabbar--material__icon+.tabbar--material__label{font-size:10px}", ""]);
	
	// exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--toolbar-button-background-color:transparent;--toolbar-button-border-color:var(--toolbar-button-color);--toolbar-button-border-radius:2px;--toolbar-button-padding:4px 10px;--toolbar-button-active-background-color:var(--toolbar-button-background-color);--toolbar-button-border:1px solid var(--toolbar-button-border-color)}.toolbar-button{@apply(--reset-font);padding:var(--toolbar-button-padding);letter-spacing:0;color:var(--toolbar-button-color);background-color:var(--toolbar-button-background-color);border-radius:var(--toolbar-button-border-radius);border:1px solid transparent;font-weight:var(--font-weight);font-size:var(--font-size);transition:none}.toolbar-button:active{background-color:var(--toolbar-button-active-background-color);transition:none;opacity:.2}.toolbar-button:disabled,.toolbar-button[disabled]{@apply(--disabled)}.toolbar-button:focus{outline:0;transition:none}.toolbar-button:hover{transition:none}.toolbar-button--outline{border:var(--toolbar-button-border);margin:auto 8px;padding-left:6px;padding-right:6px}.toolbar-button--material{font-size:22px;color:var(--material-toolbar-button-color);display:inline-block;padding:0 12px;height:100%;margin:0;border:none;border-radius:0;vertical-align:initial;transition:background-color .25s linear}.toolbar-button--material:first-of-type{margin-left:4px}.toolbar-button--material:last-of-type{margin-right:4px}.toolbar-button--material:active{opacity:1;transition:background-color .25s linear}.back-button{height:44px;line-height:44px;padding-left:8px;color:var(--toolbar-button-color);background-color:var(--toolbar-button-background-color);display:inline-block}.back-button:active{opacity:.2}.back-button__label{display:inline-block;height:100%;vertical-align:top;line-height:var(--toolbar-height);font-size:var(--font-size);font-weight:var(--font-weight--large)}.back-button__icon{margin-right:6px;display:inline-flex;fill:var(--toolbar-button-color);align-items:center;height:100%}.back-button--material{font-size:22px;color:var(--material-toolbar-button-color);display:inline-block;padding:0 12px;height:100%;margin:0 0 0 4px;border:none;border-radius:0;vertical-align:initial;line-height:56px}.back-button--material__label{display:none;font-size:20px}.back-button--material__icon{display:inline-flex;fill:var(--material-toolbar-button-color);align-items:center;height:100%}.back-button--material:active{opacity:1}", ""]);
	
	// exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--checkbox-size:22px;--checkbox-border:1px solid #c7c7cd;--checkbox-checked-background-color:var(--highlight-color);--background-color--before--checkbox:var(--checkbox-checked-background-color);--checkmark-border:2px solid #fff;--material-checkbox-size:18px;--material-checkbox-focus-ring-size:40px;--material-checkbox-focus-ring-shadow-size:calc((var(--material-checkbox-focus-ring-size) - var(--material-checkbox-size)) / 2);\\--checkbox:{@apply(--reset-box-model);position:relative;display:inline-block;vertical-align:top;@apply(--reset-cursor);@apply(--reset-font);@apply(--hide-input-parent)}\\--checkbox__label:{position:relative;display:inline-block;vertical-align:top;@apply(--reset-cursor);@apply(--reset-font)}\\--checkbox--disabled:{@apply(--disabled)}\\--checkbox--before:{content:\"\";position:absolute}\\--checkbox--after:{@apply(--checkbox--before)}}.checkbox{@apply(--checkbox__label);line-height:var(--checkbox-size)}.checkbox__checkmark{@apply(--checkbox);height:var(--checkbox-size);width:var(--checkbox-size);pointer-events:none}.checkbox__input,.checkbox__input:checked{@apply(--hide-input)}.checkbox__checkmark:before{@apply(--checkbox--before);@apply(--reset-box-model);width:var(--checkbox-size);height:var(--checkbox-size);background:transparent;border:var(--checkbox-border);border-radius:var(--checkbox-size);left:0}.checkbox__checkmark:after{@apply(--checkbox--after);top:7px;left:5px;width:11px;height:5px;background:transparent;border:var(--checkmark-border);border-width:1px;border-top:none;border-right:none;border-radius:0;transform:rotate(-45deg);opacity:0}:checked+.checkbox__checkmark:before{background:var(--background-color--before--checkbox);border:none}:checked+.checkbox__checkmark:after{opacity:1}:disabled+.checkbox__checkmark{@apply(--checkbox--disabled)}:disabled:active+.checkbox__checkmark:before{background:transparent}.checkbox--noborder{@apply(--checkbox__label);line-height:var(--checkbox-size);@apply(--hide-input-parent)}.checkbox--noborder__input{@apply(--hide-input)}.checkbox--noborder__checkmark{position:relative;display:inline-block;vertical-align:top;@apply(--reset-cursor);@apply(--reset-box-model)}.checkbox--noborder__checkmark,.checkbox--noborder__checkmark:before{width:var(--checkbox-size);height:var(--checkbox-size);background:transparent;border:none}.checkbox--noborder__checkmark:before{content:\"\";position:absolute;border-radius:var(--checkbox-size);left:0}.checkbox--noborder__checkmark:after{@apply(--checkmark)}:checked+.checkbox--noborder__checkmark:before{background:transparent;border:none}:checked+.checkbox--noborder__checkmark:after{opacity:1}:focus+.checkbox--noborder__checkmark:before{border:none}:disabled+.checkbox--noborder__checkmark{@apply(--disabled)}:disabled:active+.checkbox--noborder__checkmark:before{background:transparent;border:none}.checkbox--material{line-height:var(--material-checkbox-size);@apply(--material-font);overflow:visible}.checkbox--material__checkmark,.checkbox--material__checkmark:before{width:var(--material-checkbox-size);height:var(--material-checkbox-size)}.checkbox--material__checkmark:before{border-radius:2px;border:2px solid var(--material-checkbox-inactive-color);transition:background-color .1s linear .2s,border-color .1s linear .2s;background-color:transparent}:checked+.checkbox--material__checkmark:before{border:2px solid var(--material-checkbox-active-color);background-color:var(--material-checkbox-active-color);transition:background-color .1s linear,border-color .1s linear}.checkbox--material__checkmark:after{border-color:var(--material-checkbox-checkmark-color);transition:transform .2s ease 0;width:10px;height:5px;top:4px;left:3px;transform:scale(0) rotate(-45deg);border-width:2px}:checked+.checkbox--material__checkmark:after{transition:transform .2s ease .2s;width:10px;height:5px;top:4px;left:3px;transform:scale(1) rotate(-45deg);border-width:2px}.checkbox--material__input:before{content:\"\";opacity:0;position:absolute;top:0;left:0;width:var(--material-checkbox-size);height:var(--material-checkbox-size);box-shadow:0 0 0 var(--material-checkbox-focus-ring-shadow-size) var(--material-checkbox-inactive-color);box-sizing:border-box;border-radius:50%;background-color:var(--material-checkbox-inactive-color);pointer-events:none;display:block;transform:scale3d(.2,.2,.2);transition:opacity .25s ease-out,transform .1s ease-out}.checkbox--material__input:checked:before{box-shadow:0 0 0 var(--material-checkbox-focus-ring-shadow-size) var(--material-checkbox-active-color);background-color:var(--material-checkbox-active-color)}.checkbox--material__input:active:before{opacity:.15;transform:scaleX(1)}:disabled+.checkbox--material__checkmark{opacity:1}:disabled+.checkbox--material__checkmark:before{border-color:#afafaf}:disabled:checked+.checkbox--material__checkmark:before{background-color:#afafaf}:disabled:checked+.checkbox--material__checkmark:after{border-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--radio-button-background-active:transparent;--radio-button-indicator-color:var(--highlight-color);--radio-button-background:transparent;--radio-button-border:3px solid var(--radio-button-indicator-color);--radio-button-size:24px;--material-radio-button-size:20px;--material-radio-button-shadow-size:calc((48px - var(--material-radio-button-size)) / 2);\\--radio-button:{@apply(--reset-box-model);position:relative;display:inline-block;vertical-align:top;@apply(--reset-cursor);@apply(--reset-font);@apply(--hide-input-parent)}\\--radio-button__label:{position:relative;display:inline-block;vertical-align:top;@apply(--reset-cursor)}\\--radio-button--before:{content:\"\";position:absolute;border-radius:100%;@apply(--reset-box-model)}\\--radio-button--after:{content:\"\";position:absolute;border-radius:100%;top:50%;left:50%;transform:translate(-50%,-50%)}\\--radio-button--disabled:{@apply(--disabled)}}.radio-button__input{@apply(--hide-input)}.radio-button__input:active,.radio-button__input:focus{outline:0;-webkit-tap-highlight-color:rgba(0,0,0,0)}.radio-button{@apply(--radio-button__label);@apply(--hide-input-parent);line-height:var(--radio-button-size);text-align:left}.radio-button__checkmark:before{@apply(--radio-button--before);width:var(--checkbox-size);height:var(--checkbox-size);background:transparent;border:none;border-radius:var(--checkbox-size);left:0}.radio-button__checkmark{@apply(--radio-button);position:relative;width:var(--radio-button-size);height:var(--radio-button-size);background:var(--radio-button-background);pointer-events:none}.radio-button__checkmark:after{@apply(--checkmark)}:checked+.radio-button__checkmark{background:var(--radio-button-background-active)}:checked+.radio-button__checkmark:after{opacity:1}:checked+.radio-button__checkmark:before{background:transparent;border:none}:disabled+.radio-button__checkmark{@apply(--radio-button--disabled)}.radio-button--material{line-height:calc(var(--material-radio-button-size) + 2px);@apply(--material-font)}.radio-button--material__input:before{content:\"\";position:absolute;top:0;left:0;opacity:0;width:var(--material-radio-button-size);height:var(--material-radio-button-size);box-shadow:0 0 0 var(--material-radio-button-shadow-size) var(--material-radio-button-inactive-color);border:none;box-sizing:border-box;border-radius:50%;background-color:var(--material-radio-button-inactive-color);pointer-events:none;display:block;transform:scale3d(.2,.2,.2);transition:opacity .25s ease-out,transform .1s ease-out}.radio-button--material__input:checked:before{box-shadow:0 0 0 var(--material-radio-button-shadow-size) var(--material-radio-button-active-color);background-color:var(--material-radio-button-active-color)}.radio-button--material__input:active:before{opacity:.15;transform:scaleX(1)}.radio-button--material__checkmark{overflow:visible}.radio-button--material__checkmark,.radio-button--material__checkmark:before{width:var(--material-radio-button-size);height:var(--material-radio-button-size)}.radio-button--material__checkmark:before{background:transparent;border:2px solid var(--material-radio-button-inactive-color);box-sizing:border-box;border-radius:50%;transition:border .2s ease}.radio-button--material__checkmark:after{transition:background .2s ease,transform .2s ease;top:calc(var(--material-radio-button-size) / 4);left:calc(var(--material-radio-button-size) / 4);width:calc(var(--material-radio-button-size) / 2);height:calc(var(--material-radio-button-size) / 2);border:none;border-radius:50%;transform:scale(0)}:checked+.radio-button--material__checkmark:before{background:transparent;border:2px solid var(--material-radio-button-active-color)}.radio-button--material__input+.radio-button__checkmark:after{background:var(--material-radio-button-inactive-color);opacity:1;transform:scale(0)}:checked+.radio-button--material__checkmark:after{opacity:1;background:var(--material-radio-button-active-color);transform:scale(1)}:disabled+.radio-button--material__checkmark{opacity:1}:disabled+.radio-button--material__checkmark:after{background-color:var(--material-radio-button-disabled-color)}:disabled+.radio-button--material__checkmark:after,:disabled+.radio-button--material__checkmark:before{border-color:var(--material-radio-button-disabled-color)}", ""]);
	
	// exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--list-item-color:var(--text-color);--list-item-active-background-color:var(--list-tap-active-background-color);--list-item-separator-color:var(--border-color);--list-border:1px solid var(--list-item-separator-color);--list-item-min-height:44px;--list-item-margin:0 0 -1px 0;--list-item-padding:0 0 0 14px;--list-border-top:1px solid var(--list-item-separator-color);--list-border-bottom:1px solid var(--list-item-separator-color);--list-header-color:var(--text-color);--list-header-font-size:12px;--list-header-padding:0 0 0 15px;--list-header-min-height:24px;--list-header-font-weight:var(--font-weight--large);--inset-list-border:1px solid var(--list-item-separator-color);--list-title-color:#6d6d72;--list-title-font-size:13px;--list-title-font-weight:500;--list-title-line-height:24px;--list-title-padding:0 0 0 16px;--material-list-item-min-height:48px;--material-list-item-padding:0 0 0 16px;--material-list-title-color:#757575;--material-list-title-font-size:14px;--material-list-title-font-weight:500;--material-list-title-line-height:24px;--material-list-title-padding:12px 0 12px 16px;\\--retina-list-item-border:{border-bottom:none;background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--list-item-separator-color),var(--list-item-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(0deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0)}}\\--retina-material-list-item-border:{border-bottom:none;background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--material-list-item-separator-color),var(--material-list-item-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(0deg,var(--material-list-item-separator-color),var(--material-list-item-separator-color) 50%,transparent 0)}}\\--retina-list-border:{@media (--retina-query){border:none;background-size:100% 1px,100% 1px;background-repeat:no-repeat;background-position:bottom,top;background-image:linear-gradient(0deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0),linear-gradient(180deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0)}}}.list{@apply(--reset-base);@apply(--reset-cursor);@apply(--reset-font);list-style-type:none;text-align:left;display:block;-webkit-overflow-scrolling:touch;overflow:hidden;background-image:linear-gradient(var(--list-item-separator-color),var(--list-item-separator-color)),linear-gradient(var(--list-item-separator-color),var(--list-item-separator-color));background-size:100% 1px,100% 1px;background-repeat:no-repeat;background-position:bottom,top;border:none;background-color:var(--list-background-color);@media (--retina-query){background-image:linear-gradient(0deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0),linear-gradient(180deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0)}}.list-item{width:100%;position:relative;list-style:none;flex-direction:row;justify-content:flex-start;padding:var(--list-item-padding);margin:var(--list-item-margin);color:var(--list-item-color);transition:background-color .2s linear}.list-item,.list-item__left{box-sizing:border-box;display:flex;align-items:center}.list-item__left{padding:12px 14px 12px 0;order:0;align-self:stretch;line-height:1.2em;min-height:var(--list-item-min-height)}.list-item__left:empty{width:0;min-width:0;padding:0;margin:0}.list-item__center{flex-grow:1;flex-wrap:wrap;flex-direction:row;order:1;margin-right:auto;margin-left:0;@apply(--retina-list-item-border);padding:12px 6px 12px 0}.list-item__center,.list-item__right{box-sizing:border-box;display:flex;align-items:center;align-self:stretch;line-height:1.2em;min-height:var(--list-item-min-height)}.list-item__right{margin-left:auto;padding:12px 12px 12px 0;order:2;@apply(--retina-list-item-border)}.list-header{margin:0;list-style:none;text-align:left;display:block;box-sizing:border-box;padding:var(--list-header-padding);font-size:var(--list-header-font-size);font-weight:var(--list-header-font-weight);color:var(--list-header-color);min-height:var(--list-header-min-height);line-height:calc(1px + var(--list-header-min-height));text-transform:uppercase;position:relative;background-color:var(--list-header-background-color);background-size:100% 1px;background-repeat:no-repeat;background-position:top;background-image:linear-gradient(0deg,var(--list-item-separator-color),var(--list-item-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(180deg,var(--list-item-separator-color),var(--list-item-separator-color) 50%,transparent 0)}}.list--noborder{border-top:none;border-bottom:none;background-image:none}.list-item--tappable:active{transition:none;background-color:var(--list-item-active-background-color)}.list--inset{margin:0 8px;border:var(--inset-list-border);border-radius:4px;background-image:none}.list-item__label{font-size:var(--font-size--mini);padding:0 4px;opacity:.6}.list-item__title{flex-basis:100%;align-self:flex-end;order:0}.list-item__subtitle{opacity:.75;font-size:var(--font-size--mini);order:1;flex-basis:100%;align-self:flex-start}.list-item__thumbnail{width:40px;height:40px;border-radius:6px;display:block;margin:0}.list-item__icon{font-size:22px;padding:0 6px}.list--material{@apply(--material-font);background-image:none;background-color:var(--material-list-background-color)}.list-item--material{border:0;padding:var(--material-list-item-padding);line-height:normal}.list-item--material__subtitle{margin-top:4px}.list-item--material:first-child{box-shadow:none}.list-item--material__left{padding:14px 0;min-width:56px;line-height:1;min-height:var(--material-list-item-min-height)}.list-item--material__center,.list-item--material__left:empty{padding:14px 6px 14px 0;@apply(--retina-material-list-item-border)}.list-item--material__center,.list-item--material__left:empty,.list-item--material__right{border-color:var(--material-list-item-separator-color);min-height:var(--material-list-item-min-height)}.list-item--material__right{padding:14px 16px 14px 0;line-height:1;@apply(--retina-material-list-item-border)}.list-item--material.list-item--longdivider{border-bottom:1px solid var(--material-list-item-separator-color);@apply(--retina-material-list-item-border)}.list-header--material{background:var(--list-background-color);border:none;font-size:14px;text-transform:none;margin:-1px 0 0;color:var(--material-list-header-text-color);font-weight:500;padding:8px 16px}.list-header--material:not(:first-of-type){border-top:none;background-size:100% 1px;background-repeat:no-repeat;background-position:top;background-image:linear-gradient(180deg,var(--material-list-item-separator-color),var(--material-list-item-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(180deg,var(--material-list-item-separator-color),var(--material-list-item-separator-color) 50%,transparent 0)}padding-top:16px}.list-item--material__thumbnail{width:40px;height:40px;border-radius:100%}.list-item--material__icon{font-size:20px;padding:0 4px}.list-item--chevron:before{border-right:2px solid var(--list-item-chevron-color);border-bottom:2px solid var(--list-item-chevron-color);position:absolute;content:\"\";width:7px;height:7px;background-color:transparent;transform:translateY(-50%) rotate(-45deg);right:16px;top:50%;z-index:5}.list-item--chevron__right{padding-right:30px}.list-item--nodivider__center,.list-item--nodivider__right{border:none;background-image:none}.list-item--longdivider{border-bottom:var(--list-border);@apply(--retina-list-item-border)}.list-item--longdivider:last-of-type,.list-item--longdivider__center,.list-item--longdivider__right{border:none;background-image:none}.list-title{@apply(--reset-base);@apply(--reset-cursor);@apply(--reset-font);display:block;color:var(--list-title-color);text-align:left;box-sizing:border-box;padding:var(--list-title-padding);margin:0;font-size:var(--list-title-font-size);font-weight:var(--list-title-font-weight);line-height:var(--list-title-line-height);text-transform:uppercase;letter-spacing:.04em}.list-title--material{@apply(--material-font);color:var(--material-list-title-color);font-size:var(--material-list-title-font-size);margin:0;padding:var(--material-list-title-padding);font-weight:var(--material-list-title-font-weight);line-height:var(--material-list-title-line-height)}", ""]);
	
	// exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--search-icon:url(" + __webpack_require__(335) + ");--search-input-background-image:var(--search-icon);--search-input-color:var(--input-text-color);--search-decoration-margin-right:0;--search-input-border-radius:5.5px;--search-input-height:28px;--search-input-font-size:14px;--search-input-placeholder-color:#7a797b;--material-search-icon:url(" + __webpack_require__(336) + ");\\--search-input:{@apply(--reset-input);@apply(--reset-font);appearance:textfield}\\--search-input--disabled:{@apply(--disabled)}}.search-input{@apply(--search-input);box-sizing:border-box;height:var(--search-input-height);font-size:var(--search-input-font-size);background-color:var(--search-input-background-color);box-shadow:none;color:var(--search-input-color);line-height:1.3;padding:0 8px 0 28px;margin:0;border-radius:var(--search-input-border-radius);background-image:var(--search-input-background-image);background-position:8px;background-repeat:no-repeat;background-size:13px;font-weight:var(--font-weight);display:inline-block;text-indent:0}.search-input::-webkit-search-cancel-button{appearance:textfield;display:none}.search-input::-webkit-search-decoration{display:none}.search-input:focus{outline:none}.search-input::placeholder{color:var(--search-input-placeholder-color);font-size:var(--search-input-font-size);text-indent:0}.search-input:disabled{@apply(--search-input--disabled)}.search-input--material{@apply(--material-font);border-radius:2px;height:48px;background-color:var(--material-search-background-color);background-image:var(--material-search-icon);background-size:18px;background-position:18px;font-size:14px;padding:0 24px 0 64px;box-shadow:0 0 2px 0 rgba(0,0,0,.12),0 2px 2px 0 rgba(0,0,0,.24),inset 0 1px 0 0 hsla(0,0%,100%,.06)}", ""]);
	
	// exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "121708398e3ee97fba5bf0eacee69e53.svg";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba5e7aa9ed8fa3020f6bf1c33d154017.svg";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--text-input-font-size:15px;--text-input-height:31px;--text-input-border-color:var(--input-border-color);--material-text-input-font-size:16px;--material-text-input-color:var(--material-text-input-text-color);\\--text-input:{@apply(--input);@apply(--transparent);letter-spacing:0;box-shadow:none;color:var(--input-text-color);padding:0;margin:0;width:auto;font-size:var(--text-input-font-size);height:var(--text-input-height);font-weight:var(--font-weight);box-sizing:border-box}\\--text-input--disabled:{@apply(--disabled)}\\--input-placeholder:{@apply(--transparent);color:var(--input-placeholder-color)}\\--text-input--invalid:{@apply(--transparent);color:var(--input-invalid-text-color)}\\--text-input-underbar-disabled:{@apply(--input-placeholder);border:none;background-color:transparent}\\--text-input--material-placeholder:{color:var(--material-text-input-inactive-color);line-height:20px}}.text-input{@apply(--text-input)}.text-input::-ms-clear{display:none}.text-input:disabled{@apply(--text-input--disabled)}.text-input::placeholder{color:var(--input-placeholder-color)}.text-input:disabled::placeholder{@apply(--input-placeholder)}.text-input:invalid{@apply(--text-input--invalid)}.text-input--underbar{@apply(--text-input);border:none;background-color:transparent;border-bottom:1px solid var(--text-input-border-color);border-radius:0}.text-input--underbar:disabled{@apply(--text-input--disabled);border:none;background-color:transparent;border-bottom:1px solid var(--text-input-border-color)}.text-input--underbar:disabled::placeholder{@apply(--text-input-underbar-disabled)}.text-input--underbar:invalid{@apply(--text-input--invalid);border:none;background-color:transparent;border-bottom:1px solid var(--input-invalid-border-color)}.text-input--material{@apply(--input);@apply(--material-font);color:var(--material-text-input-color);background-image:linear-gradient(0deg,transparent 1px,var(--material-text-input-inactive-color) 0);background-size:100% 2px;background-repeat:no-repeat;background-position:bottom;background-color:transparent;font-size:var(--material-text-input-font-size);font-weight:400;border:none;padding-bottom:2px;border-radius:0;height:24px;vertical-align:middle;-webkit-transform:translateZ(0)}.text-input--material__label{@apply(--material-font);color:var(--material-text-input-inactive-color);position:absolute;left:0;top:2px;font-size:16px;font-weight:400;pointer-events:none}.text-input--material__label--active{color:var(--material-text-input-active-color);transform:translateY(-75%) scale(.75);transform-origin:left top;transition:transform .1s ease-in,color .1s ease-in}.text-input--material:focus{background-image:linear-gradient(var(--material-text-input-active-color),var(--material-text-input-active-color)),linear-gradient(0deg,transparent 1px,var(--material-text-input-inactive-color) 0);animation:material-text-input-animate .3s forwards}.text-input--material::placeholder{@apply(--text-input--material-placeholder)}@keyframes material-text-input-animate{0%{background-size:0 2px,100% 2px}to{background-size:100% 2px,100% 2px}}", ""]);
	
	// exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--textarea-color:var(--input-text-color);--textarea-border:1px solid var(--input-border-color);--textarea-padding:5px 5px 5px 5px;--textarea-box-shadow:none;--textarea-border-radius:4px}.textarea{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);vertical-align:top;resize:none;outline:none;padding:var(--textarea-padding);font-size:var(--text-input-font-size);font-weight:var(--font-weight);border-radius:var(--textarea-border-radius);border:var(--textarea-border);background-color:var(--input-bg-color);color:var(--textarea-color);letter-spacing:0;box-shadow:var(--textarea-box-shadow);appearance:none;width:auto}.textarea:disabled{@apply(--disabled)}.textarea::placeholder{color:var(--input-placeholder-color)}.textarea--transparent{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);vertical-align:top;resize:none;outline:none;padding:var(--textarea-padding);padding-left:0;padding-right:0;font-size:var(--text-input-font-size);font-weight:var(--font-weight);border-radius:var(--textarea-border-radius);border:none;background-color:transparent;color:var(--textarea-color);letter-spacing:0;box-shadow:var(--textarea-box-shadow);appearance:none;width:auto}.textarea--transparent:disabled{@apply(--disabled)}.textarea--transparent::placeholder{color:var(--input-placeholder-color)}", ""]);
	
	// exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".dialog{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-cursor);@apply(--reset-font);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:auto;overflow:hidden;min-width:270px;min-height:100px;text-align:left}.dialog-container{height:inherit;min-height:inherit;overflow:hidden;border-radius:4px;background-color:var(--dialog-background-color);-webkit-mask-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC\");color:var(--dialog-text-color)}.dialog-mask{@apply(--reset-base);@apply(--reset-cursor);position:absolute;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.2)}.dialog--material{@apply(--material-font);text-align:left;@apply(--material-shadow-5)}.dialog-container--material{border-radius:2px;background-color:var(--material-dialog-background-color);color:var(--material-dialog-text-color)}.dialog-mask--material{background-color:rgba(0,0,0,.3)}", ""]);
	
	// exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{\\--retina-alert-dialog-button-border:{@media (--retina-query){border-top:none;background-size:100% 1px;background-repeat:no-repeat;background-position:top;background-image:linear-gradient(180deg,var(--alert-dialog-separator-color),var(--alert-dialog-separator-color) 50%,transparent 0)}}}.alert-dialog{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-cursor);@apply(--reset-font);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:270px;margin:auto;background-color:var(--alert-dialog-background-color);border-radius:8px;overflow:visible;max-width:95%;color:var(--alert-dialog-text-color)}.alert-dialog-container{height:inherit;padding-top:16px;overflow:hidden}.alert-dialog-title{@apply(--reset-font);font-size:var(--font-size);font-weight:var(--font-weight--large);padding:0 8px}.alert-dialog-content,.alert-dialog-title{text-align:center;color:var(--alert-dialog-text-color)}.alert-dialog-content{@apply(--reset-box-model);padding:4px 12px 8px;font-size:var(--font-size--mini);min-height:36px}.alert-dialog-footer{width:100%}.alert-dialog-button{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);@apply(--reset-cursor);@apply(--ellipsis);text-decoration:none;letter-spacing:0;vertical-align:middle;border:none;border-top:1px solid var(--alert-dialog-separator-color);font-size:calc(var(--font-size) - 1px);padding:0 8px;margin:0;display:block;width:100%;background-color:transparent;text-align:center;height:44px;line-height:44px;outline:none;color:var(--alert-dialog-button-color);@apply(--retina-alert-dialog-button-border)}.alert-dialog-button:active{background-color:rgba(0,0,0,.05)}.alert-dialog-button--primal{font-weight:var(--font-weight--large)}.alert-dialog-footer--rowfooter{white-space:nowrap;display:flex;flex-wrap:wrap}.alert-dialog-button--rowfooter{flex:1;display:block;width:100%;border-left:1px solid var(--alert-dialog-separator-color);@media (--retina-query){border-top:none;border-left:none;background-size:100% 1px,1px 100%;background-repeat:no-repeat;background-position:top,0;background-image:linear-gradient(0deg,transparent,transparent 50%,var(--alert-dialog-separator-color) 0),linear-gradient(90deg,transparent,transparent 50%,var(--alert-dialog-separator-color) 0)}}.alert-dialog-button--rowfooter:first-child{border-left:none;@media (--retina-query){border-top:none;background-size:100% 1px;background-repeat:no-repeat;background-position:top,0;background-image:linear-gradient(0deg,transparent,transparent 50%,var(--alert-dialog-separator-color) 0)}}.alert-dialog-mask{@apply(--reset-base);@apply(--reset-cursor);position:absolute;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.2)}.alert-dialog--material{border-radius:2px;background-color:var(--material-alert-dialog-background-color)}.alert-dialog-container--material{padding:22px 0 0;@apply(--material-shadow-5)}.alert-dialog-title--material{@apply(--material-font);text-align:left;font-size:20px;font-weight:500;padding:0 24px;color:var(--material-alert-dialog-title-color)}.alert-dialog-content--material{@apply(--material-font);text-align:left;font-size:16px;font-weight:400;line-height:20px;padding:0 24px;margin:24px 0 10px;min-height:0;color:var(--material-alert-dialog-content-color)}.alert-dialog-footer--material{display:block;padding:0;height:52px;box-sizing:border-box;margin:0;line-height:1}.alert-dialog-button--material{@apply(--material-font);text-transform:uppercase;display:inline-block;width:auto;float:right;background:none;border:none;border-radius:2px;font-size:14px;font-weight:500;outline:none;height:36px;line-height:36px;padding:0 8px;margin:8px 8px 8px 0;box-sizing:border-box;min-width:50px;color:var(--material-alert-dialog-button-color);@media (--retina-query){background:none}}.alert-dialog-button--material:active{background-color:initial}.alert-dialog-button--rowfooter--material,.alert-dialog-button--rowfooter--material:first-child{border:0;@media (--retina-query){background:none}}.alert-dialog-button--primal--material{font-weight:500;@media (--retina-query){background:none}}.alert-dialog-mask--material{background-color:rgba(0,0,0,.3)}", ""]);
	
	// exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--popover-arrow-size:18px;--popover-arrow-radius:4px;--popover-radius:8px;--popover-margin:6px;--material-popover-radius:2px;--material-popover-margin:4px}.popover{position:absolute;z-index:20001}.popover--bottom{bottom:0}.popover--top{top:0}.popover--left{left:0}.popover--right{right:0}.popover-mask{left:0;right:0;top:0;bottom:0;background-color:rgba(0,0,0,.2);position:absolute;z-index:19999}.popover__content{@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-cursor);@apply(--reset-font);display:block;width:220px;overflow:auto;min-height:100px;max-height:100%;background-color:var(--popover-background-color);border-radius:var(--popover-radius);color:var(--popover-text-color);pointer-events:auto}.popover__arrow{position:absolute;width:var(--popover-arrow-size);height:var(--popover-arrow-size);transform-origin:50% 50% 0;background-color:transparent;background-image:linear-gradient(45deg,var(--popover-background-color),var(--popover-background-color) 50%,transparent 0);border-radius:0 0 0 var(--popover-arrow-radius);margin:0;z-index:20001}.popover--bottom__arrow{transform:translateY(6px) translateX(calc(var(--popover-arrow-size) / -2)) rotate(-45deg);bottom:0;margin-right:-18px}.popover--top__arrow{transform:translateY(-6px) translateX(calc(var(--popover-arrow-size) / -2)) rotate(135deg);top:0;margin-right:-18px}.popover--left__arrow{transform:translateX(-6px) translateY(calc(var(--popover-arrow-size) / -2)) rotate(45deg);left:0;margin-bottom:-18px}.popover--right__arrow{transform:translateX(6px) translateY(calc(var(--popover-arrow-size) / -2)) rotate(225deg);right:0;margin-bottom:-18px}.popover-mask--material{background-color:transparent}.popover--material__content{background-color:var(--material-popover-background-color);border-radius:var(--material-popover-radius);color:var(--material-popover-text-color);@apply(--material-shadow-1)}.popover--material__arrow{display:none}", ""]);
	
	// exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".progress-bar{position:relative;height:2px;display:block;width:100%;background-color:var(--progress-bar-background-color);background-clip:padding-box;margin:0;overflow:hidden;border-radius:4px}.progress-bar__primary,.progress-bar__secondary{position:absolute;background-color:var(--progress-bar-color);top:0;bottom:0;transition:width .3s linear;z-index:100;border-radius:4px}.progress-bar__secondary{background-color:var(--progress-bar-secondary-color);z-index:0}.progress-bar--indeterminate:before{animation:progress-bar__indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.progress-bar--indeterminate:after,.progress-bar--indeterminate:before{content:\"\";position:absolute;background-color:var(--progress-bar-color);top:0;left:0;bottom:0;will-change:left,right;border-radius:4px}.progress-bar--indeterminate:after{animation:progress-bar__indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.15s}@keyframes progress-bar__indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes progress-bar__indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}.progress-bar--material{height:4px;background-color:var(--material-progress-bar-background-color);border-radius:0}.progress-bar--material__primary,.progress-bar--material__secondary{background-color:var(--material-progress-bar-primary-color);border-radius:0}.progress-bar--material__secondary{background-color:var(--material-progress-bar-secondary-color);z-index:0}.progress-bar--material.progress-bar--indeterminate:after,.progress-bar--material.progress-bar--indeterminate:before{background-color:var(--material-progress-bar-primary-color);border-radius:0}", ""]);
	
	// exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".progress-circular{height:32px;position:relative;width:32px;transform:rotate(270deg);animation:none}.progress-circular__background,.progress-circular__primary,.progress-circular__secondary{cx:50%;cy:50%;r:40%;animation:none;fill:none;stroke-width:5%;stroke-miterlimit:10}.progress-circular__background{stroke:var(--progress-circle-background-color)}.progress-circular__primary{stroke-dasharray:1,200;stroke-dashoffset:0;stroke:var(--progress-circle-primary-color);transition:all 1s cubic-bezier(.4,0,.2,1)}.progress-circular__secondary{stroke:var(--progress-circle-secondary-color)}.progress-circular--indeterminate{animation:progress__rotate 2s linear infinite;transform:none}.progress-circular--indeterminate__primary{animation:progress__dash 1.5s ease-in-out infinite}.progress-circular--indeterminate__secondary{display:none}@keyframes progress__rotate{to{transform:rotate(1turn)}}@keyframes progress__dash{0%{stroke-dasharray:10%,241.32%;stroke-dashoffset:0}50%{stroke-dasharray:201%,50.322%;stroke-dashoffset:-100%}to{stroke-dasharray:10%,241.32%;stroke-dashoffset:-251.32%}}.progress-circular--material__background,.progress-circular--material__primary,.progress-circular--material__secondary{stroke-width:9%}.progress-circular--material__background{stroke:var(--material-progress-circle-background-color)}.progress-circular--material__primary{stroke:var(--material-progress-circle-primary-color)}.progress-circular--material__secondary{stroke:var(--material-progress-circle-secondary-color)}", ""]);
	
	// exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--fab-width:56px;--fab-height:56px;--fab-position:absolute;--fab-mini-width:40px;--fab-mini-height:40px;--material-fab-width:56px;--material-fab-height:56px;--material-fab-position:absolute;--material-fab-mini-width:40px;--material-fab-mini-height:40px;\\--fab:{position:relative;display:inline-block;@apply(--reset-box-model);@apply(--reset-base);@apply(--reset-font);@apply(--reset-cursor);width:var(--fab-width);height:var(--fab-height);text-decoration:none;font-size:25px;line-height:var(--fab-height);letter-spacing:0;color:var(--fab-text-color);vertical-align:middle;text-align:center;background-color:var(--fab-background-color);border:0 solid currentColor;border-radius:50%;overflow:hidden;box-shadow:0 3px 6px rgba(0,0,0,.12);transition:all .1s linear}\\--material-fab:{@apply(--fab);@apply(--material-font);width:var(--material-fab-width);height:var(--material-fab-height);text-decoration:none;font-size:25px;line-height:var(--material-fab-height);color:var(--material-fab-text-color);background-color:var(--material-fab-background-color);@apply(--material-shadow-2);transition:all .2s ease-in-out}\\--fab--focus:{outline:0}\\--material-fab--focus:{outline:0}\\--fab--active:{box-shadow:0 3px 6 rgba(0,0,0,.12);background-color:var(--fab-active-background-color);transition:all .2s ease}\\--material-fab--active:{@apply(--material-shadow-4);background-color:var(--material-fab-active-background-color);transition:all .2s ease}\\--fab--disabled:{background-color:color(#000 alpha(50%));@apply(--material-shadow-0);@apply(--disabled)}\\--material-fab--disabled:{background-color:color(#000 alpha(50%));@apply(--material-shadow-0);@apply(--disabled)}}.fab{@apply(--fab)}.fab:active{@apply(--fab--active);box-shadow:0 0 6 rgba(0,0,0,.12)}.fab:focus{@apply(--fab--focus)}.fab__icon{position:relative;overflow:hidden;height:100%;width:100%;display:block;border-radius:100%;padding:0;z-index:100;line-height:var(--material-fab-height)}.fab:disabled,.fab[disabled]{@apply(--material-fab--disabled)}.fab--material{@apply(--material-fab)}.fab--material:active{@apply(--material-fab--active)}.fab--material:focus{@apply(--material-fab--focus)}.fab--material__icon{position:relative;overflow:hidden;height:100%;width:100%;display:block;border-radius:100%;padding:0;z-index:100;line-height:var(--material-fab-height)}.fab--material:disabled,.fab--material[disabled]{@apply(--material-fab--disabled)}.fab--mini{width:var(--fab-mini-width);height:var(--fab-mini-height)}.fab--mini,.fab--mini__icon{line-height:var(--fab-mini-height)}.speed-dial__item{position:absolute;transform:scale(0)}.fab--top__right{top:20px;bottom:auto}.fab--bottom__right,.fab--top__right{right:20px;left:auto;position:var(--fab-position)}.fab--bottom__right{top:auto;bottom:20px}.fab--top__left{top:20px;bottom:auto}.fab--bottom__left,.fab--top__left{right:auto;left:20px;position:var(--fab-position)}.fab--bottom__left{top:auto;bottom:20px}.fab--top__center{top:20px;bottom:auto}.fab--bottom__center,.fab--top__center{margin-left:-28px;left:50%;right:auto;position:var(--fab-position)}.fab--bottom__center{top:auto;bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal{@apply(--reset-container);@apply(--reset-base);@apply(--reset-box-model);@apply(--reset-font);overflow:hidden;background-color:var(--modal-background-color);position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;display:table;z-index:2147483647}.modal__content{@apply(--reset-container);@apply(--reset-base);@apply(--reset-box-model);@apply(--reset-font);display:table-cell;vertical-align:middle;text-align:center;color:var(--modal-text-color);white-space:normal}", ""]);
	
	// exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--select-input-font-size:var(--font-size);--select-input-height:32px;--material-select-input-font-size:15px;\\--select-input:{@apply(--input);@apply(--transparent);position:relative;font-size:var(--select-input-font-size);height:var(--select-input-height);line-height:var(--select-input-height);border-color:var(--select-input-border-color);color:var(--select-input-color);appearance:none;display:inline-block;border-radius:0;border:none}\\--select-input--disabled:{@apply(--disabled);@apply(--transparent)}\\--input-placeholder:{@apply(--transparent);color:var(--input-placeholder-color)}\\--select-input--invalid:{@apply(--transparent);color:var(--input-invalid-text-color)}\\--select-input--material-placeholder:{color:var(--material-select-input-inactive-color);line-height:20px}}.select-input{@apply(--select-input);padding:0 20px 0 0;background-color:transparent;background-image:url(" + __webpack_require__(347) + ");background-repeat:no-repeat;background-position:100%;border-bottom:none}.select-input::-ms-clear{display:none}.select-input::placeholder{color:var(--input-placeholder-color)}.select-input:disabled{@apply(--select-input--disabled)}.select-input:disabled::placeholder{@apply(--input-placeholder)}.select-input:invalid{@apply(--select-input--invalid)}.select-input[multiple]{height:calc(var(--select-input-height) * 2)}.select-input--material{@apply(--material-font);color:var(--material-select-input-color);font-size:var(--material-select-input-font-size);background-image:url(" + __webpack_require__(347) + "),linear-gradient(0deg,var(--material-select-border-color) 50%,var(--material-select-border-color) 0);background-size:auto,100% 1px;background-repeat:no-repeat;background-position:100%,0 100%;border:none;font-weight:400;transform:translateZ(0)}.select-input--material__label{@apply(--material-font);color:var(--material-select-input-inactive-color);position:absolute;left:0;top:2px;font-size:16px;pointer-events:none}.select-input--material__label--active{color:var(--material-select-input-active-color);transform:translateY(-75%) scale(.75);transform-origin:left top;transition:transform .1s ease-in,color .1s ease-in}.select-input--material::placeholder{@apply(--select-input--material-placeholder)}@keyframes material-select-input-animate{0%{background-size:0 2px,100% 2px}to{background-size:100% 2px,100% 2px}}.select-input--underbar,.select-input--underbar:disabled{border:none;border-bottom:1px solid var(--select-input-border-color)}.select-input--underbar:disabled{@apply(--select-input--disabled);background-color:transparent}.select-input--underbar:disabled::placeholder{@apply(--input-placeholder);border:none;background-color:transparent}.select-input--underbar:invalid{@apply(--select-input--invalid);border:none;background-color:transparent;border-bottom:1px solid var(--input-invalid-border-color)}", ""]);
	
	// exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7666ad5100c5b47389a7847f76753883.svg";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--action-sheet-mask-color:rgba(0,0,0,.1);--material-action-sheet-mask-color:rgba(0,0,0,.2)}.action-sheet{@apply(--reset-font);cursor:default;position:absolute;left:10px;right:10px;bottom:10px;z-index:2}.action-sheet-button{box-sizing:border-box;height:56px;font-size:20px;text-align:center;color:var(--action-sheet-button-color);background-color:var(--action-sheet-button-background-color);border-radius:0;line-height:56px;border:none;appearance:none;display:block;width:100%;@apply(--ellipsis);background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--action-sheet-button-separator-color),var(--action-sheet-button-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(0deg,var(--action-sheet-button-separator-color),var(--action-sheet-button-separator-color) 50%,transparent 0)}}.action-sheet-button:first-child{border-top-left-radius:12px;border-top-right-radius:12px}.action-sheet-button:active{background-color:var(--action-sheet-button-active-background-color);background-image:none}.action-sheet-button:focus{outline:none}.action-sheet-button:nth-last-of-type(2){border-bottom-right-radius:12px;border-bottom-left-radius:12px;background-image:none}.action-sheet-button:last-of-type{border-radius:12px;margin:8px 0 0;background-color:var(--action-sheet-cancel-button-background-color);background-image:none;font-weight:600}.action-sheet-button:last-of-type:active{background-color:var(--action-sheet-button-active-background-color)}.action-sheet-button--destructive{color:var(--action-sheet-button-destructive-color)}.action-sheet-title{box-sizing:border-box;height:56px;font-size:13px;color:var(--action-sheet-title-color);text-align:center;background-color:var(--action-sheet-button-background-color);line-height:56px;@apply(--ellipsis);background-size:100% 1px;background-repeat:no-repeat;background-position:bottom;background-image:linear-gradient(0deg,var(--action-sheet-button-separator-color),var(--action-sheet-button-separator-color) 100%);@media (--retina-query){background-image:linear-gradient(0deg,var(--action-sheet-button-separator-color),var(--action-sheet-button-separator-color) 50%,transparent 0)}}.action-sheet-title:first-child{border-top-left-radius:12px;border-top-right-radius:12px}.action-sheet-icon{display:none}.action-sheet-mask{position:absolute;left:0;top:0;right:0;bottom:0;background-color:var(--action-sheet-mask-color);z-index:1}.action-sheet--material{left:0;right:0;bottom:0;@apply(--material-shadow-5)}.action-sheet-title--material{@apply(--material-font);border-radius:0;background-image:none;text-align:left;height:56px;line-height:56px;font-size:16px;padding:0 0 0 16px;color:var(--material-action-sheet-text-color);background-color:#fff;font-weight:400}.action-sheet-title--material:first-child{border-radius:0}.action-sheet-button--material{@apply(--material-font);border-radius:0;background-image:none;height:52px;line-height:52px;text-align:left;font-size:16px;padding:0 0 0 16px;color:var(--material-action-sheet-text-color);font-weight:400;background-color:#fff}.action-sheet-button--material:first-child,.action-sheet-button--material:nth-last-of-type(2){border-radius:0}.action-sheet-button--material:last-of-type{margin:0;border-radius:0;font-weight:400;background-color:#fff}.action-sheet-icon--material{display:inline-block;float:left;height:52px;line-height:52px;margin-right:32px;font-size:26px;width:.8em;text-align:center}.action-sheet-mask--material{background-color:var(--material-action-sheet-mask-color)}", ""]);
	
	// exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--card-text-line-height:1.4;--card-text-font-size:14px;--material-card-text-line-height:1.4;--material-card-text-font-size:14px}.card{@apply(--reset-font);box-shadow:0 1px 2px rgba(0,0,0,.12);border-radius:8px;background-color:var(--card-background-color);box-sizing:border-box;display:block;margin:8px;padding:16px;text-align:left;word-wrap:break-word}.card__content{margin:0;font-size:var(--card-text-font-size);line-height:var(--card-text-line-height);color:var(--card-text-color)}.card__title{@apply(--reset-font);font-weight:400;font-size:20px;margin:4px 0 8px;padding:0;display:block;box-sizing:border-box}.card--material{background-color:var(--material-card-background-color);border-radius:2px;@apply(--material-shadow-1);@apply(--material-font)}.card--material__content{font-size:var(--material-card-text-font-size);line-height:var(--material-card-text-line-height);color:var(--material-card-text-color)}.card--material__title{@apply(--material-font);font-size:24px;margin:8px 0 12px}", ""]);
	
	// exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast{@apply(--reset-font);position:absolute;z-index:2;left:8px;right:8px;bottom:0;margin:8px 0;border-radius:8px;background-color:var(--toast-background-color);display:flex;min-height:48px;line-height:48px;box-sizing:border-box;padding:0 16px}.toast__message{font-size:14px;color:var(--toast-text-color);flex-grow:1;text-align:left;margin:0 16px 0 0;@apply(--ellipsis)}.toast__button{font-size:14px;color:var(--toast-button-text-color);flex-grow:0;appearance:none;border:none;background-color:transparent;cursor:default;text-transform:uppercase}.toast__button:focus{outline:none}.toast__button:active{opacity:.4}.toast--material{left:0;right:0;bottom:0;margin:0;background-color:var(--material-toast-background-color);border-radius:0;padding:0 24px}.toast--material__message{@apply(--material-font);margin:0 24px 0 0}.toast--material__button{@apply(--material-font);color:var(--material-toast-button-text-color)}", ""]);
	
	// exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".toolbar{top:0;padding-top:0}.bottom-bar,.toolbar{box-sizing:border-box}.bottom-bar{bottom:0;padding-bottom:0}.toolbar+.page__background{top:var(--toolbar-height)}.page__content{top:0;padding-top:0;bottom:0}.toolbar+.page__background+.page__content{top:var(--toolbar-height);padding-top:0}.page-with-bottom-toolbar>.page__content{bottom:44px}.toolbar.toolbar--material+.page__background{top:var(--toolbar-material-height)}.toolbar.toolbar--material+.page__background+.page__content{top:var(--toolbar-material-height);padding-top:0}.toolbar.toolbar--transparent+.page__background{top:0}.toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,.toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content{top:0;padding-top:var(--toolbar-height)}.toolbar.toolbar--material.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,.toolbar.toolbar--material.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content{top:0;padding-top:var(--toolbar-material-height)}.tabbar--top{padding-top:0}.tabbar:not(.tabbar--top){padding-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.i(__webpack_require__(353), "");
	exports.i(__webpack_require__(354), "");
	exports.i(__webpack_require__(355), "");
	exports.i(__webpack_require__(356), "");
	exports.i(__webpack_require__(357), "");
	exports.i(__webpack_require__(358), "");
	exports.i(__webpack_require__(359), "");
	exports.i(__webpack_require__(360), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--iphonex-safe-area-inset-top-portrait:44px;--iphonex-safe-area-inset-right-portrait:0;--iphonex-safe-area-inset-bottom-portrait:34px;--iphonex-safe-area-inset-left-portrait:0;--iphonex-safe-area-inset-top-landscape:0;--iphonex-safe-area-inset-right-landscape:44px;--iphonex-safe-area-inset-bottom-landscape:21px;--iphonex-safe-area-inset-left-landscape:44px}", ""]);
	
	// exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:landscape){html[onsflag-iphonex-landscape] .page__content{padding-left:var(--iphonex-safe-area-inset-left-landscape);padding-right:var(--iphonex-safe-area-inset-right-landscape)}html[onsflag-iphonex-landscape] .dialog .page__content,html[onsflag-iphonex-landscape] .modal .page__content{padding-left:0;padding-right:0}}", ""]);
	
	// exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:landscape){html[onsflag-iphonex-landscape] .toolbar__left{padding-left:var(--iphonex-safe-area-inset-left-landscape)}html[onsflag-iphonex-landscape] .bottom-bar,html[onsflag-iphonex-landscape] .toolbar__right{padding-right:var(--iphonex-safe-area-inset-right-landscape)}html[onsflag-iphonex-landscape] .bottom-bar{padding-left:var(--iphonex-safe-area-inset-left-landscape)}}", ""]);
	
	// exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:landscape){html[onsflag-iphonex-landscape] .tabbar{padding-left:var(--iphonex-safe-area-inset-left-landscape);padding-right:var(--iphonex-safe-area-inset-right-landscape);width:calc(100% - var(--iphonex-safe-area-inset-left-landscape) - var(--iphonex-safe-area-inset-right-landscape))}}", ""]);
	
	// exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:portrait){html[onsflag-iphonex-portrait] .fab--top__center,html[onsflag-iphonex-portrait] .fab--top__left,html[onsflag-iphonex-portrait] .fab--top__right{top:calc(var(--iphonex-safe-area-inset-top-portrait) + 20px)}html[onsflag-iphonex-portrait] .fab--bottom__center,html[onsflag-iphonex-portrait] .fab--bottom__left,html[onsflag-iphonex-portrait] .fab--bottom__right{bottom:calc(var(--iphonex-safe-area-inset-bottom-portrait))}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .fab--bottom__center,html[onsflag-iphonex-landscape] .fab--bottom__left,html[onsflag-iphonex-landscape] .fab--bottom__right{bottom:calc(var(--iphonex-safe-area-inset-bottom-landscape))}html[onsflag-iphonex-landscape] .fab--bottom__left,html[onsflag-iphonex-landscape] .fab--top__left{left:calc(var(--iphonex-safe-area-inset-left-landscape))}html[onsflag-iphonex-landscape] .fab--bottom__right,html[onsflag-iphonex-landscape] .fab--top__right{right:calc(var(--iphonex-safe-area-inset-right-landscape))}}", ""]);
	
	// exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:portrait){html[onsflag-iphonex-portrait] .action-sheet{bottom:calc(var(--iphonex-safe-area-inset-bottom-portrait) + 14px)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .action-sheet{left:calc((100vw - (100vh + 20px)) / 2);right:calc((100vw - (100vh + 20px)) / 2);bottom:calc(var(--iphonex-safe-area-inset-bottom-landscape) + 12px)}}", ""]);
	
	// exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:portrait){html[onsflag-iphonex-portrait] .toast{bottom:var(--iphonex-safe-area-inset-bottom-portrait)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .toast{left:calc(var(--iphonex-safe-area-inset-left-landscape) + 8px);right:calc(var(--iphonex-safe-area-inset-right-landscape) + 8px);bottom:var(--iphonex-safe-area-inset-bottom-landscape)}}", ""]);
	
	// exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (orientation:portrait){html[onsflag-iphonex-portrait] .toolbar{top:0;box-sizing:content-box;padding-top:var(--iphonex-safe-area-inset-top-portrait)}html[onsflag-iphonex-portrait] .dialog .toolbar,html[onsflag-iphonex-portrait] .modal .toolbar,html[onsflag-iphonex-portrait] .tabbar--top__content .toolbar,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .toolbar{top:0;box-sizing:border-box;padding-top:0}html[onsflag-iphonex-portrait] .bottom-bar{bottom:0;box-sizing:content-box;padding-bottom:var(--iphonex-safe-area-inset-bottom-portrait)}html[onsflag-iphonex-portrait] .dialog .bottom-bar,html[onsflag-iphonex-portrait] .modal .bottom-bar,html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content .bottom-bar,html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content) .bottom-bar{bottom:0;box-sizing:border-box;padding-bottom:0}html[onsflag-iphonex-portrait] .page__content{top:0;padding-top:var(--iphonex-safe-area-inset-top-portrait);bottom:0;padding-bottom:var(--iphonex-safe-area-inset-bottom-portrait)}html[onsflag-iphonex-portrait] .dialog .page__content,html[onsflag-iphonex-portrait] .modal .page__content,html[onsflag-iphonex-portrait] .tabbar--top__content .page__content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .page__content{top:0;padding-top:0}html[onsflag-iphonex-portrait] .dialog .page__content,html[onsflag-iphonex-portrait] .modal .page__content,html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content .page__content,html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content) .page__content{bottom:0;padding-bottom:0}html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content{top:calc(var(--iphonex-safe-area-inset-top-portrait) + var(--toolbar-height));padding-top:0}html[onsflag-iphonex-portrait] .dialog .toolbar:not(.toolbar--cover-content)+.page__background,html[onsflag-iphonex-portrait] .dialog .toolbar:not(.toolbar--cover-content)+.page__background+.page__content,html[onsflag-iphonex-portrait] .modal .toolbar:not(.toolbar--cover-content)+.page__background,html[onsflag-iphonex-portrait] .modal .toolbar:not(.toolbar--cover-content)+.page__background+.page__content,html[onsflag-iphonex-portrait] .tabbar--top__content .toolbar:not(.toolbar--cover-content)+.page__background,html[onsflag-iphonex-portrait] .tabbar--top__content .toolbar:not(.toolbar--cover-content)+.page__background+.page__content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .toolbar:not(.toolbar--cover-content)+.page__background,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .toolbar:not(.toolbar--cover-content)+.page__background+.page__content{top:var(--toolbar-height);padding-top:0}html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content{bottom:calc(var(--iphonex-safe-area-inset-bottom-portrait) + var(--toolbar-height));padding-bottom:0}html[onsflag-iphonex-portrait] .dialog .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-portrait] .modal .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content) .page-with-bottom-toolbar>.page__content{bottom:var(--toolbar-height);padding-bottom:0}html[onsflag-iphonex-portrait] .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,html[onsflag-iphonex-portrait] .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content{top:0;padding-top:calc(var(--iphonex-safe-area-inset-top-portrait) + var(--toolbar-height))}html[onsflag-iphonex-portrait] .dialog .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,html[onsflag-iphonex-portrait] .dialog .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content,html[onsflag-iphonex-portrait] .modal .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,html[onsflag-iphonex-portrait] .modal .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content,html[onsflag-iphonex-portrait] .tabbar--top__content .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,html[onsflag-iphonex-portrait] .tabbar--top__content .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page_content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .toolbar.toolbar--transparent.toolbar--cover-content+.page__background+.page__content .page__content{top:0;padding-top:var(--toolbar-height)}html[onsflag-iphonex-portrait] .tabbar--top{padding-top:var(--iphonex-safe-area-inset-top-portrait)}html[onsflag-iphonex-portrait] .dialog .tabbar--top,html[onsflag-iphonex-portrait] .modal .tabbar--top,html[onsflag-iphonex-portrait] .tabbar--top__content .tabbar--top,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .tabbar--top{padding-top:0}html[onsflag-iphonex-portrait] .tabbar--top__content{top:calc(var(--iphonex-safe-area-inset-top-portrait) + var(--tabbar-height))}html[onsflag-iphonex-portrait] .dialog .tabbar--top__content,html[onsflag-iphonex-portrait] .modal .tabbar--top__content,html[onsflag-iphonex-portrait] .tabbar--top__content .tabbar--top__content,html[onsflag-iphonex-portrait] .toolbar:not(.toolbar--cover-content)+.page__background+.page__content .tabbar--top__content{top:var(--tabbar-height)}html[onsflag-iphonex-portrait] .tabbar:not(.tabbar--top):not(.tabbar--top){padding-bottom:var(--iphonex-safe-area-inset-bottom-portrait)}html[onsflag-iphonex-portrait] .dialog .tabbar:not(.tabbar--top):not(.tabbar--top),html[onsflag-iphonex-portrait] .modal .tabbar:not(.tabbar--top):not(.tabbar--top),html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content .tabbar:not(.tabbar--top),html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content) .tabbar:not(.tabbar--top){padding-bottom:0}html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content){bottom:calc(var(--iphonex-safe-area-inset-bottom-portrait) + var(--tabbar-height))}html[onsflag-iphonex-portrait] .dialog .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-portrait] .modal .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-portrait] .page-with-bottom-toolbar>.page__content .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-portrait] .tabbar__content:not(.tabbar--top__content) .tabbar__content:not(.tabbar--top__content){bottom:var(--tabbar-height)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .bottom-bar{bottom:0;box-sizing:content-box;padding-bottom:var(--iphonex-safe-area-inset-bottom-landscape)}html[onsflag-iphonex-landscape] .dialog .bottom-bar,html[onsflag-iphonex-landscape] .modal .bottom-bar,html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content .bottom-bar,html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content) .bottom-bar{bottom:0;box-sizing:border-box;padding-bottom:0}html[onsflag-iphonex-landscape] .page__content{bottom:0;padding-bottom:var(--iphonex-safe-area-inset-bottom-landscape)}html[onsflag-iphonex-landscape] .dialog .page__content,html[onsflag-iphonex-landscape] .modal .page__content,html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content .page__content,html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content) .page__content{bottom:0;padding-bottom:0}html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content{bottom:calc(var(--iphonex-safe-area-inset-bottom-landscape) + var(--toolbar-height));padding-bottom:0}html[onsflag-iphonex-landscape] .dialog .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-landscape] .modal .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content .page-with-bottom-toolbar>.page__content,html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content) .page-with-bottom-toolbar>.page__content{bottom:var(--toolbar-height);padding-bottom:0}html[onsflag-iphonex-landscape] .tabbar:not(.tabbar--top){padding-bottom:var(--iphonex-safe-area-inset-bottom-landscape)}html[onsflag-iphonex-landscape] .dialog .tabbar:not(.tabbar--top),html[onsflag-iphonex-landscape] .modal .tabbar:not(.tabbar--top),html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content .tabbar:not(.tabbar--top),html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content) .tabbar:not(.tabbar--top){padding-bottom:0}html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content){bottom:calc(var(--iphonex-safe-area-inset-bottom-landscape) + var(--tabbar-height))}html[onsflag-iphonex-landscape] .dialog .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-landscape] .modal .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-landscape] .page-with-bottom-toolbar>.page__content .tabbar__content:not(.tabbar--top__content),html[onsflag-iphonex-landscape] .tabbar__content:not(.tabbar--top__content) .tabbar__content:not(.tabbar--top__content){bottom:var(--tabbar-height)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset){margin-left:calc(- var(--iphonex-safe-area-inset-left-landscape));margin-right:calc(- var(--iphonex-safe-area-inset-right-landscape))}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-header{padding-left:calc(var(--iphonex-safe-area-inset-left-landscape) + 15px)}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-item{padding-left:calc(var(--iphonex-safe-area-inset-left-landscape) + 14px)}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-item--chevron:before{right:calc(var(--iphonex-safe-area-inset-right-landscape) + 16px)}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-item>.list-item__center:last-child{padding-right:calc(var(--iphonex-safe-area-inset-right-landscape) + 6px)}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-item>.list-item__right{padding-right:calc(var(--iphonex-safe-area-inset-right-landscape) + 12px)}html[onsflag-iphonex-landscape] .page__content>.list:not(.list--inset)>.list-item>.list-item--chevron__right{padding-right:calc(var(--iphonex-safe-area-inset-right-landscape) + 30px)}}@media (orientation:landscape){html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset),html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset){margin-left:0;margin-right:0}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-header,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-header{padding-left:15px}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-item,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-item{padding-left:14px}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-item--chevron:before,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-item--chevron:before{right:16px}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-item>.list-item__center:last-child,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-item>.list-item__center:last-child{padding-right:6px}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-item>.list-item__right,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-item>.list-item__right{padding-right:12px}html[onsflag-iphonex-landscape] .dialog .page__content>.list:not(.list--inset)>.list-item>.list-item--chevron__right,html[onsflag-iphonex-landscape] .modal .page__content>.list:not(.list--inset)>.list-item>.list-item--chevron__right{padding-right:30px}}", ""]);
	
	// exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(363);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(361)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(363, function() {
				var newContent = __webpack_require__(363);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Muli:300,400,500,600,700,800);", ""]);
	
	// module
	exports.push([module.id, ".cu-ui-button-row .cu-ui-button+.cu-ui-button{margin-left:8px}.cu-ui-button{height:36px;padding:0 8px;background-color:#e5e5e5;border:1px solid rgba(45,45,45,.16);border-radius:4px;box-shadow:0 4px 8px rgba(45,45,45,.32);font-size:1rem;font-weight:500;line-height:1rem;color:#676767;-webkit-transition:.25s ease-in-out;-moz-transition:.25s ease-in-out;-ms-transition:.25s ease-in-out;-o-transition:.25s ease-in-out;transition:.25s ease-in-out}.cu-ui-button:active,.cu-ui-button:focus,.cu-ui-button:hover{background-color:#bdbdbd;color:#fff;text-decoration:none}.cu-ui-button.cu-ui-button-xs{height:28px}.cu-ui-button.cu-ui-button-sm{height:32px}.cu-ui-button.cu-ui-button-sm .mdi{font-size:1rem;line-height:1rem}.cu-ui-button.cu-ui-button-lg{height:40px}.cu-ui-button.cu-ui-button-xl{height:46px}.cu-ui-button.cu-ui-button-xl .mdi{font-size:1.5rem;line-height:1rem;vertical-align:-3px}.cu-ui-button.cu-ui-primary{background-color:#0098ce;color:#fff;box-shadow:0 8px 12px 0 rgba(0,152,206,.42)}.cu-ui-button.cu-ui-primary:active,.cu-ui-button.cu-ui-primary:focus,.cu-ui-button.cu-ui-primary:hover{background-color:#00749d}.cu-ui-button.cu-ui-secondary{background-color:#0b4f6c;color:#fff;box-shadow:0 4px 8px 0 rgba(11,79,108,.42)}.cu-ui-button.cu-ui-secondary:active,.cu-ui-button.cu-ui-secondary:focus,.cu-ui-button.cu-ui-secondary:hover{background-color:#083c52}.cu-ui-button.cu-ui-alternate{background-color:#ff9324;color:#fff;box-shadow:0 4px 8px 0 rgba(255,147,36,.42)}.cu-ui-button.cu-ui-alternate:active,.cu-ui-button.cu-ui-alternate:focus,.cu-ui-button.cu-ui-alternate:hover{background-color:#c2701b}.cu-ui-button.cu-ui-success{background-color:#35ce8d;color:#fff;box-shadow:0 4px 8px 0 rgba(53,206,141,.42)}.cu-ui-button.cu-ui-success:active,.cu-ui-button.cu-ui-success:focus,.cu-ui-button.cu-ui-success:hover{background-color:#289d6b}.cu-ui-button.cu-ui-danger{background-color:#f25f5c;color:#fff;box-shadow:0 4px 8px 0 rgba(242,95,92,.42)}.cu-ui-button.cu-ui-danger:active,.cu-ui-button.cu-ui-danger:focus,.cu-ui-button.cu-ui-danger:hover{background-color:#b84846}.cu-ui-button.cu-ui-light{background-color:#f9f9f9;border:1px solid rgba(45,45,45,.2);box-shadow:0 4px 8px 0 rgba(45,45,45,.16)}.cu-ui-button.cu-ui-light:active,.cu-ui-button.cu-ui-light:focus,.cu-ui-button.cu-ui-light:hover{background-color:#e5e5e5;color:#676767}.cu-ui-button.cu-ui-white{border-color:#f9f9f9;text-shadow:none}.cu-ui-button.cu-ui-white,.cu-ui-button.cu-ui-white:active,.cu-ui-button.cu-ui-white:focus,.cu-ui-button.cu-ui-white:hover{background-color:#f9f9f9;color:#0098ce}.cu-ui-button.cu-ui-outline{background-color:transparent;border-width:1px;border-style:solid;box-shadow:none;color:#676767}.cu-ui-button.cu-ui-outline:active,.cu-ui-button.cu-ui-outline:focus,.cu-ui-button.cu-ui-outline:hover{background-color:#e5e5e5;color:#676767}.cu-ui-button.cu-ui-outline.cu-ui-primary{color:#0098ce;border-color:#0098ce}.cu-ui-button.cu-ui-outline.cu-ui-primary:active,.cu-ui-button.cu-ui-outline.cu-ui-primary:focus,.cu-ui-button.cu-ui-outline.cu-ui-primary:hover{background-color:#0098ce;color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-secondary{color:#0b4f6c;border-color:#0b4f6c}.cu-ui-button.cu-ui-outline.cu-ui-secondary:active,.cu-ui-button.cu-ui-outline.cu-ui-secondary:focus,.cu-ui-button.cu-ui-outline.cu-ui-secondary:hover{background-color:#0b4f6c;color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-alternate{color:#ff9324;border-color:#ff9324}.cu-ui-button.cu-ui-outline.cu-ui-alternate:active,.cu-ui-button.cu-ui-outline.cu-ui-alternate:focus,.cu-ui-button.cu-ui-outline.cu-ui-alternate:hover{background-color:#ff9324;color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-success{color:#35ce8d;border-color:#35ce8d}.cu-ui-button.cu-ui-outline.cu-ui-success:active,.cu-ui-button.cu-ui-outline.cu-ui-success:focus,.cu-ui-button.cu-ui-outline.cu-ui-success:hover{background-color:#35ce8d;color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-danger{color:#f25f5c;border-color:#f25f5c}.cu-ui-button.cu-ui-outline.cu-ui-danger:active,.cu-ui-button.cu-ui-outline.cu-ui-danger:focus,.cu-ui-button.cu-ui-outline.cu-ui-danger:hover{background-color:#f25f5c;color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-white{color:#fff;border-color:#fff}.cu-ui-button.cu-ui-outline.cu-ui-white:active,.cu-ui-button.cu-ui-outline.cu-ui-white:focus,.cu-ui-button.cu-ui-outline.cu-ui-white:hover{background-color:rgba(45,45,45,.4);color:#fff}.cu-ui-button.cu-ui-float{float:right;margin-top:-8px}.cu-ui-button.cu-ui-block{width:100%}.cu-ui-button.cu-ui-close{margin:0;padding:0 8px;font-size:1.5rem;line-height:1.5rem;color:inherit}.cu-ui-button+.cu-ui-button{margin-left:10.66667px}.cu-ui-button+.cu-ui-block{margin-left:0}.cu-ui-button-group{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;width:auto;margin-bottom:24px}.cu-ui-button-group .cu-ui-button{border-radius:0;box-shadow:none}.cu-ui-button-group .cu-ui-button:first-child{border-radius:4px 0 0 4px}.cu-ui-button-group .cu-ui-button:last-child{border-radius:0 4px 4px 0}.cu-ui-button-group .cu-ui-button+.cu-ui-button{margin-left:1px}.cu-ui-button-group.cu-ui-block{width:100%}.cu-ui-button-group.cu-ui-block .cu-ui-button{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1}form{display:block}.cu-ui-form-group+.cu-ui-button,.cu-ui-form-group+.cu-ui-switch,.cu-ui-form-group+div{margin-top:16px}.cu-ui-form-group{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:horizontal;-webkit-flex-direction:row;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-moz-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.cu-ui-form-group.cu-ui-form-switch{-webkit-flex-wrap:nowrap;-moz-flex-wrap:nowrap;-ms-flex-wrap:none;flex-wrap:nowrap;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-moz-align-items:center;align-items:center}.cu-ui-input{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;padding:10.66667px 16px;background-color:#fdfdfd;border:1px solid #cedce2;border-radius:4px;color:#0b4f6c;font-size:1rem;font-weight:500}.cu-ui-input.cu-ui-input-add-on{border-radius:4px 0 0 4px}.cu-ui-input:disabled{background-color:rgba(11,79,108,.06);cursor:not-allowed;color:#59879b}.cu-ui-add-on{-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:46px;padding-top:8px;background-color:#f1f8fc;border:1px solid #cedce2;border-left:1px solid transparent;border-radius:0 4px 4px 0;text-align:center;font-weight:700;font-size:1.25rem;color:rgba(11,79,108,.4)}.cu-ui-add-on.cu-ui-button{height:46px;padding:0;border:0}.cu-ui-add-on.cu-ui-button.cu-ui-alternate,.cu-ui-add-on.cu-ui-button.cu-ui-primary,.cu-ui-add-on.cu-ui-button.cu-ui-secondary{color:#fff}.cu-ui-chat{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-webkit-flex-direction:column;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;position:fixed;right:16px;bottom:16px;width:420px;max-width:calc(100% - 16px*2);height:640px;max-height:calc(100% - 16px*2);background-color:#fff;border-radius:4px;box-shadow:2px 4px 8px rgba(0,0,0,.16);z-index:20000;-webkit-transition:.5s ease-in-out;-moz-transition:.5s ease-in-out;-ms-transition:.5s ease-in-out;-o-transition:.5s ease-in-out;transition:.5s ease-in-out}.cu-ui-chat.cu-ui-chat-large{width:calc(100% - 16px*2);max-width:968px;height:calc(100% - 16px*2);max-height:768px}.cu-ui-chat .cu-ui-chat-header{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex-grow:0;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-justify-content:space-between;-moz-justify-content:space-between;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-moz-align-items:center;align-items:center;padding:10.66667px 16px;background-color:#0098ce;border-radius:4px 4px 0 0}.cu-ui-chat .cu-ui-chat-header .cu-ui-title{width:auto;margin:0;padding:0;font-size:1.25rem;color:#fff}.cu-ui-chat .cu-ui-chat-header .cu-ui-outline{width:36px;color:#fff}.cu-ui-chat .cu-ui-chat-header .cu-ui-outline:hover{background-color:#00749d}.cu-ui-chat .cu-ui-chat-body{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-webkit-flex-direction:column;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:480px;border-right:1px solid #e1e1e1;border-left:1px solid #e1e1e1;padding:16px;overflow-x:hidden;overflow-y:auto}.cu-ui-chat .cu-ui-chat-footer{-webkit-box-flex:0;-webkit-flex-grow:0;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;padding:16px;border:1px solid #e1e1e1;border-radius:0 0 4px 4px}.cu-ui-chat .cu-ui-chat-footer .cu-ui-form-group{-webkit-flex-wrap:nowrap;-moz-flex-wrap:nowrap;-ms-flex-wrap:none;flex-wrap:nowrap}.cu-ui-chat .cu-ui-chat-footer .cu-ui-button.cu-ui-primary{padding:4px 16px}.cu-ui-chat .cu-ui-chat-footer .cu-ui-input{width:auto;min-width:160px;padding:8px 10.66667px;background-color:#f6f8fa;border:1px solid #e1e1e1}.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on{-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:40px;padding-top:8px;background-color:#f6f8fa;border:1px solid #e1e1e1;border-left:1px solid transparent;border-radius:0 4px 4px 0;text-align:center;font-weight:700;font-size:1.25rem;color:rgba(11,79,108,.4)}.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on.cu-ui-button{height:40px;padding:0}.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on.cu-ui-button.cu-ui-alternate,.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on.cu-ui-button.cu-ui-primary,.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on.cu-ui-button.cu-ui-secondary{color:#0b4f6c}.cu-ui-chat .cu-ui-chat-footer .cu-ui-add-on.cu-ui-button:hover{background-color:#cedce2}.cu-ui-message{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:horizontal;-webkit-flex-direction:row;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-justify-content:space-between;-moz-justify-content:space-between;justify-content:space-between;-webkit-box-align:end;-ms-flex-align:end;-webkit-align-items:flex-end;-moz-align-items:flex-end;align-items:flex-end;-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:100%}.cu-ui-message.cu-ui-message-full-image{width:calc(100% + 32px + 2px);margin-left:-17px;margin-right:-17px}.cu-ui-message.cu-ui-message-full-image .cu-ui-message-content{border-radius:0}.cu-ui-message .cu-ui-message-block{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;-webkit-align-items:flex-end;-moz-align-items:flex-end;align-items:flex-end;margin:0;padding:0}.cu-ui-message .cu-ui-message-content{margin:0;padding:8px 10.66667px;background-color:#fff;border-radius:8px;border:1px solid #e1e1e1;box-shadow:0 4px 8px rgba(45,45,45,.16)}.cu-ui-message .cu-ui-message-content.cu-ui-message-image{width:100%;max-width:640px;padding:0;overflow:hidden;line-height:0}.cu-ui-message .cu-ui-message-content.cu-ui-message-image img{max-width:100%;margin:0;padding:0}.cu-ui-message .cu-ui-message-content.cu-ui-message-buttons{width:100%;max-width:640px}.cu-ui-message .cu-ui-message-content p{margin-bottom:8px}.cu-ui-message .cu-ui-message-content .cu-ui-button-group{width:100%;margin-bottom:8px}.cu-ui-message .cu-ui-message-content .cu-ui-button-group.cu-ui-block{width:100%}.cu-ui-message .cu-ui-message-content .cu-ui-button-group.cu-ui-block .cu-ui-button{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1}.cu-ui-message .cu-ui-message-content .cu-ui-button{min-width:100px;box-shadow:0 4px 8px rgba(45,45,45,.16)}.cu-ui-message .cu-ui-message-content .cu-ui-button.cu-ui-block{margin-bottom:8px}.cu-ui-message .cu-ui-message-avatar{height:40px;margin:0;padding:0;background-color:#0b4f6c;background-image:url(/images/icon/chat-icon-white.svg);background-size:70% 70%;background-repeat:no-repeat;background-position:50%;border-radius:50%}.cu-ui-message .cu-ui-message-avatar,.cu-ui-message .cu-ui-message-time{-webkit-box-flex:0;-webkit-flex-grow:0;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:40px}.cu-ui-message .cu-ui-message-time{font-size:.75rem;color:#c8c8c8;text-align:center;line-height:40px}.cu-ui-message.cu-ui-message-bot .cu-ui-message-content{margin-left:50.66667px;background-color:#fff;border:1px solid #e1e1e1;color:#2d2d2d}.cu-ui-message.cu-ui-message-bot .cu-ui-message-avatar+.cu-ui-message-content,.cu-ui-message.cu-ui-message-bot .cu-ui-message-time{margin-left:10.66667px}.cu-ui-message.cu-ui-message-user,.cu-ui-message.cu-ui-message-user .cu-ui-message-block{-webkit-box-direction:reverse;-webkit-box-orient:horizontal;-webkit-flex-direction:row-reverse;-moz-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.cu-ui-message.cu-ui-message-user .cu-ui-message-content{margin-right:50.66667px;background-color:#0098ce;border:1px solid #00749d;color:#fff}.cu-ui-message.cu-ui-message-user .cu-ui-message-avatar{background-color:#f6f8fa;background-image:none;border:1px solid #e1e1e1;font-size:1.5rem;line-height:34px;text-align:center;color:#e1e1e1}.cu-ui-message.cu-ui-message-user .cu-ui-message-avatar+.cu-ui-message-content,.cu-ui-message.cu-ui-message-user .cu-ui-message-time{margin-right:10.66667px}.cu-ui-message+.cu-ui-message{margin-top:8px}.cu-ui-message-bot+.cu-ui-message-user,.cu-ui-message-user+.cu-ui-message-bot{margin-top:16px}.cu-ui-chat-large .cu-ui-message.cu-ui-message-full-image{width:100%;margin-left:50.66667px;margin-right:0}.cu-ui-chat-large .cu-ui-message.cu-ui-message-full-image .cu-ui-message-content{border-radius:8px}.cu-ui-carousel{margin:0;background-color:#fff;border-top:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1;box-shadow:0 4px 8px rgba(45,45,45,.16);overflow-x:auto}.cu-ui-carousel,.cu-ui-carousel .cu-ui-carousel-slides{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:100%}.cu-ui-carousel .cu-ui-carousel-slides{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;margin-right:16px;padding:16px}.cu-ui-carousel .cu-ui-carousel-slide{-webkit-flex-shrink:0;-moz-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:70%;max-width:260px;margin:0 16px 0 0;background-color:#fff;border-radius:8px;border:1px solid #e1e1e1;overflow:hidden}.cu-ui-carousel .cu-ui-carousel-slide .cu-ui-carousel-image{min-height:160px;background-color:#f9f9f9;border-bottom:1px solid #e1e1e1}.cu-ui-carousel .cu-ui-carousel-slide .cu-ui-carousel-text{padding:16px}.cu-ui-carousel .cu-ui-carousel-slide .cu-ui-carousel-text .title{margin-bottom:8px;color:#0b4f6c}.cu-ui-carousel .cu-ui-carousel-slide .cu-ui-carousel-buttons .cu-ui-button{border-radius:0;box-shadow:none}.cu-ui-carousel .cu-ui-carousel-slide .cu-ui-carousel-buttons .cu-ui-button:last-child{border-radius:0 0 4px 4px}.cu-ui-chat-body .cu-ui-carousel{width:calc(100% + 32px);margin-top:16px;margin-right:-16px;margin-left:-16px}html{top:0;left:0;min-width:320px;font-size:14px}*,html{-webkit-tap-highlight-color:transparent}*{box-sizing:border-box}body{margin:0;padding:0;font-family:Muli,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1rem;font-weight:400;line-height:1.6;color:#676767;background-color:#fff}html{height:100%}body,html{width:100%}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}h1{font-size:1.5rem}@media only screen and (min-width:768px) and (min-height:420px){h1{font-size:1rem}}h2{font-size:1.5rem}@media only screen and (min-width:768px) and (min-height:420px){h2{font-size:2rem}}h3{font-size:1.75rem}h4{font-size:1.5rem}h5{font-size:1.25rem}h6{font-size:1rem}a{text-decoration:none;color:#0098ce;font-weight:700}a:active,a:focus,a:hover{color:#006082;text-decoration:underline}ol,ul{padding-left:24px}hr{margin:16px 0;border:0;border-top:1px solid #e6eaee}fieldset{margin:0;padding:0;border:0}button,input,select,textarea{margin:0;line-height:inherit;border:0}select{-webkit-appearance:none;-moz-appearance:none;appearance:none}select::-ms-expand{display:none}input[type=search]{-webkit-appearance:none}[contenteditable=true]:focus,button:focus,input:focus,select:focus,textarea:focus{outline:none}::-webkit-input-placeholder{color:rgba(11,79,108,.4)}::-moz-placeholder{color:rgba(11,79,108,.4)}:-ms-input-placeholder{color:rgba(11,79,108,.4)}:-moz-placeholder{color:rgba(11,79,108,.4)}button{border:none;background:none;cursor:pointer}.mdi{display:inline-block}.cu-ui-app{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;-webkit-align-items:flex-start;-moz-align-items:flex-start;align-items:flex-start}.cu-ui-container{-webkit-box-align:stretch;-ms-flex-align:stretch;-webkit-align-items:stretch;-moz-align-items:stretch;align-items:stretch;margin-top:64px}.cu-ui-container,.cu-ui-content{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;width:100%;height:calc(100vh - 64px)}.cu-ui-content{-webkit-flex-wrap:wrap;-moz-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-ms-flex-align:start;-webkit-align-items:flex-start;-moz-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;-moz-align-content:flex-start;-ms-flex-line-pack:start;align-content:flex-start;position:relative;padding:24px;overflow-y:auto}h1,h2,h3,h4,h5,h6{font-family:Muli;color:#2d2d2d;margin-bottom:2rem;line-height:1.2em}h1.cu-ui-title,h2.cu-ui-title,h3.cu-ui-title,h4.cu-ui-title,h5.cu-ui-title,h6.cu-ui-title{font-weight:700}.cu-ui-comment{color:#c8c8c8}.cu-ui-chat{width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;right:0!important;left:0!important;bottom:0!important;top:0!important}.cu-ui-chat .cu-ui-chat-header{position:fixed;right:0;left:0;top:0}.cu-ui-chat .cu-ui-chat-header .cu-ui-title{font-size:3vh}.cu-ui-chat .cu-ui-chat-header .button-group.hide{display:none}.cu-ui-chat .cu-ui-chat-body{position:absolute;right:0;left:0;top:0;bottom:74.4px;min-height:calc(100% - 74.4px)}.cu-ui-chat .cu-ui-chat-body .cu-ui-message.cu-ui-message-bot .cu-ui-message-block .cu-ui-message-avatar{background-image:url(" + __webpack_require__(364) + ")}.cu-ui-chat .cu-ui-chat-body .cu-ui-message:last-child{padding-bottom:16px}.cu-ui-chat .cu-ui-chat-footer{position:fixed;right:0;left:0;bottom:0;height:74.4px}", ""]);
	
	// exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6d4b0df3b2027e453826e16c3d01c38.svg";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnsenui = __webpack_require__(294);
	
	var _classnames = __webpack_require__(366);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(255);
	
	var _redux = __webpack_require__(264);
	
	var _isBrowser = __webpack_require__(367);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _actions = __webpack_require__(368);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChatHeader(_ref) {
	  var title = _ref.title,
	      mode = _ref.mode,
	      clickDebuggerButton = _ref.clickDebuggerButton,
	      clickFullButton = _ref.clickFullButton,
	      clickCloseButton = _ref.clickCloseButton;
	
	
	  var chatHeaderLeftButtonClass = (0, _classnames2.default)('button-group', {
	    'hide': mode != "development"
	  });
	
	  var chatHeaderRightButtonClass = (0, _classnames2.default)('button-group', {
	    'hide': !(0, _isBrowser2.default)()
	  });
	
	  return _react2.default.createElement(
	    _reactOnsenui.Toolbar,
	    { className: 'cu-ui-chat-header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'left' },
	      _react2.default.createElement(
	        'div',
	        { className: chatHeaderLeftButtonClass },
	        _react2.default.createElement(
	          'button',
	          { className: 'cu-ui-button cu-ui-outline', onClick: function onClick() {
	              clickDebuggerButton();
	            } },
	          _react2.default.createElement('div', { className: 'mdi mdi-android-debug-bridge' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cu-ui-title' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'right' },
	      _react2.default.createElement(
	        'div',
	        { className: chatHeaderRightButtonClass },
	        _react2.default.createElement(
	          'button',
	          { className: 'cu-ui-button cu-ui-outline', onClick: function onClick() {
	              clickFullButton();
	            } },
	          _react2.default.createElement('div', { className: 'mdi mdi-arrow-expand' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'cu-ui-button cu-ui-outline', onClick: function onClick() {
	              clickCloseButton();
	            } },
	          _react2.default.createElement('div', { className: 'mdi mdi-window-close' })
	        )
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clickDebuggerButton: (0, _redux.bindActionCreators)(actions.clickDebuggerButton, dispatch),
	    clickFullButton: (0, _redux.bindActionCreators)(actions.clickFullButton, dispatch),
	    clickCloseButton: (0, _redux.bindActionCreators)(actions.clickCloseButton, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatHeader);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return _onsenui.platform.isChrome() || _onsenui.platform.isSafari() || _onsenui.platform.isFirefox() || _onsenui.platform.isOpera() || _onsenui.platform.isEdge() || _onsenui.platform.isIE();
	};
	
	var _onsenui = __webpack_require__(252);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clickOnButton = exports.clickCloseButton = exports.clickFullButton = exports.clickDebuggerButton = exports.initApp = exports.initProtocol = exports.addMessage = exports.sendMessage = undefined;
	
	var _inputField = __webpack_require__(287);
	
	var _chatBody = __webpack_require__(288);
	
	var _chatRoot = __webpack_require__(291);
	
	var _chatHeader = __webpack_require__(369);
	
	exports.sendMessage = _inputField.sendMessage;
	exports.addMessage = _chatBody.addMessage;
	exports.initProtocol = _chatRoot.initProtocol;
	exports.initApp = _chatRoot.initApp;
	exports.clickDebuggerButton = _chatHeader.clickDebuggerButton;
	exports.clickFullButton = _chatHeader.clickFullButton;
	exports.clickCloseButton = _chatHeader.clickCloseButton;
	exports.clickOnButton = _chatBody.clickOnButton;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_DEBUGGER = exports.TOGGLE_DEBUGGER = 'TOGGLE_DEBUGGER';
	var TOGGLE_FULLBUTTON = exports.TOGGLE_FULLBUTTON = 'TOGGLE_FULLBUTTON';
	var TOGGLE_CLOSEBUTTON = exports.TOGGLE_CLOSEBUTTON = 'TOGGLE_CLOSEBUTTON';
	
	var clickDebuggerButton = exports.clickDebuggerButton = function clickDebuggerButton() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        chatRoot = _getState.chatRoot;
	
	    chatRoot.debugFunc();
	
	    return dispatch({
	      type: TOGGLE_DEBUGGER
	    });
	  };
	};
	
	var clickFullButton = exports.clickFullButton = function clickFullButton() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        chatRoot = _getState2.chatRoot;
	
	    chatRoot.fullFunc();
	
	    return dispatch({
	      type: TOGGLE_FULLBUTTON
	    });
	  };
	};
	
	var clickCloseButton = exports.clickCloseButton = function clickCloseButton() {
	  return function (dispatch, getState) {
	    var _getState3 = getState(),
	        chatRoot = _getState3.chatRoot;
	
	    chatRoot.closeFunc();
	
	    return dispatch({
	      type: TOGGLE_CLOSEBUTTON
	    });
	  };
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(255);
	
	var _chatCells = __webpack_require__(371);
	
	var _lodash = __webpack_require__(380);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getUUID = __webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatBody = function (_React$Component) {
	  _inherits(ChatBody, _React$Component);
	
	  function ChatBody(props) {
	    _classCallCheck(this, ChatBody);
	
	    return _possibleConstructorReturn(this, (ChatBody.__proto__ || Object.getPrototypeOf(ChatBody)).call(this, props));
	  }
	
	  _createClass(ChatBody, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.refs.chatBody.scrollTop = this.refs.chatBody.scrollHeight;
	      // this.refs.chatBody.animate({scrollTop: this.refs.chatBody.scrollHeight}, 600, 'linear')
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var messages = this.props.messages;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'chatBody', className: 'cu-ui-chat-body' },
	        _lodash2.default.map(messages, function (e) {
	          switch (e.type) {
	            case "text":
	              return _react2.default.createElement(_chatCells.TextCell, { isBot: e.isBot, withIcon: e.withIcon, text: e.text, time: e.time, key: (0, _getUUID.getUUID)() });
	            case "normal-image":
	              return _react2.default.createElement(_chatCells.ImageCell, { isBot: e.isBot, url: e.url, time: e.time, key: (0, _getUUID.getUUID)() });
	            case "large-image":
	              return _react2.default.createElement(_chatCells.LargeImageCell, { url: e.url, key: (0, _getUUID.getUUID)() });
	            case "button":
	              return _react2.default.createElement(_chatCells.ButtonCell, { text: e.text, isBot: e.isBot, time: e.time, buttons: e.buttons, buttonLayoutType: e.buttonType, key: (0, _getUUID.getUUID)() });
	            case 'carousel':
	              return _react2.default.createElement(_chatCells.CarouselCell, { carousels: e.carousels, key: (0, _getUUID.getUUID)() });
	          }
	        })
	      );
	    }
	  }]);
	
	  return ChatBody;
	}(_react2.default.Component);
	
	ChatBody.propTypes = {
	  messages: _propTypes2.default.array
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    messages: state.chatBody.messages
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatBody);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarouselCell = exports.ButtonCell = exports.LargeImageCell = exports.ImageCell = exports.TextCell = undefined;
	
	var _textCell = __webpack_require__(372);
	
	var _textCell2 = _interopRequireDefault(_textCell);
	
	var _imageCell = __webpack_require__(374);
	
	var _imageCell2 = _interopRequireDefault(_imageCell);
	
	var _largeImageCell = __webpack_require__(375);
	
	var _largeImageCell2 = _interopRequireDefault(_largeImageCell);
	
	var _buttonCell = __webpack_require__(376);
	
	var _buttonCell2 = _interopRequireDefault(_buttonCell);
	
	var _carouselCell = __webpack_require__(379);
	
	var _carouselCell2 = _interopRequireDefault(_carouselCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TextCell = _textCell2.default;
	exports.ImageCell = _imageCell2.default;
	exports.LargeImageCell = _largeImageCell2.default;
	exports.ButtonCell = _buttonCell2.default;
	exports.CarouselCell = _carouselCell2.default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextCell = function (_BaseCell) {
	  _inherits(TextCell, _BaseCell);
	
	  function TextCell() {
	    _classCallCheck(this, TextCell);
	
	    return _possibleConstructorReturn(this, (TextCell.__proto__ || Object.getPrototypeOf(TextCell)).apply(this, arguments));
	  }
	
	  _createClass(TextCell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isBot = _props.isBot,
	          withIcon = _props.withIcon,
	          text = _props.text,
	          time = _props.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.messageClass(isBot) },
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-block' },
	          withIcon && _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-avatar' },
	            !isBot && _react2.default.createElement('div', { className: 'mdi mdi-account' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-content' },
	            text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-time' },
	          time
	        )
	      );
	    }
	  }]);
	
	  return TextCell;
	}(_index2.default);
	
	exports.default = TextCell;
	
	
	TextCell.propTypes = {
	  isBot: _propTypes2.default.bool,
	  withIcon: _propTypes2.default.bool,
	  text: _propTypes2.default.string,
	  time: _propTypes2.default.string
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(366);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseCell = function (_React$Component) {
	  _inherits(BaseCell, _React$Component);
	
	  function BaseCell(props) {
	    _classCallCheck(this, BaseCell);
	
	    return _possibleConstructorReturn(this, (BaseCell.__proto__ || Object.getPrototypeOf(BaseCell)).call(this, props));
	  }
	
	  _createClass(BaseCell, [{
	    key: 'messageClass',
	    value: function messageClass(isBot) {
	      return (0, _classnames2.default)('cu-ui-message', {
	        'cu-ui-message-bot': isBot,
	        'cu-ui-message-user': !isBot
	      });
	    }
	  }]);
	
	  return BaseCell;
	}(_react2.default.Component);
	
	exports.default = BaseCell;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageCell = function (_BaseCell) {
	  _inherits(ImageCell, _BaseCell);
	
	  function ImageCell() {
	    _classCallCheck(this, ImageCell);
	
	    return _possibleConstructorReturn(this, (ImageCell.__proto__ || Object.getPrototypeOf(ImageCell)).apply(this, arguments));
	  }
	
	  _createClass(ImageCell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isBot = _props.isBot,
	          url = _props.url,
	          time = _props.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.messageClass(isBot) },
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-avatar' },
	            !isBot && _react2.default.createElement('div', { className: 'mdi mdi-account' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-content cu-ui-message-image' },
	            _react2.default.createElement('img', { src: url })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-time' },
	          time
	        )
	      );
	    }
	  }]);
	
	  return ImageCell;
	}(_index2.default);
	
	exports.default = ImageCell;
	
	
	ImageCell.propTypes = {
	  url: _propTypes2.default.string,
	  time: _propTypes2.default.string,
	  isBot: _propTypes2.default.bool
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LargeImageCell = function (_BaseCell) {
	  _inherits(LargeImageCell, _BaseCell);
	
	  function LargeImageCell() {
	    _classCallCheck(this, LargeImageCell);
	
	    return _possibleConstructorReturn(this, (LargeImageCell.__proto__ || Object.getPrototypeOf(LargeImageCell)).apply(this, arguments));
	  }
	
	  _createClass(LargeImageCell, [{
	    key: 'render',
	    value: function render() {
	      var url = this.props.url;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cu-ui-message cu-ui-message-full-image' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-content cu-ui-message-image' },
	            _react2.default.createElement('img', { src: url })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LargeImageCell;
	}(_index2.default);
	
	exports.default = LargeImageCell;
	
	
	LargeImageCell.propTypes = {
	  url: _propTypes2.default.string
	};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _getUUID = __webpack_require__(377);
	
	var _customButton = __webpack_require__(378);
	
	var _customButton2 = _interopRequireDefault(_customButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonCell = function (_BaseCell) {
	  _inherits(ButtonCell, _BaseCell);
	
	  function ButtonCell() {
	    _classCallCheck(this, ButtonCell);
	
	    return _possibleConstructorReturn(this, (ButtonCell.__proto__ || Object.getPrototypeOf(ButtonCell)).apply(this, arguments));
	  }
	
	  _createClass(ButtonCell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isBot = _props.isBot,
	          time = _props.time,
	          text = _props.text,
	          buttons = _props.buttons,
	          buttonLayoutType = _props.buttonLayoutType;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.messageClass(isBot) },
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-block' },
	          _react2.default.createElement('div', { className: 'cu-ui-message-avatar' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-message-content cu-ui-message-buttons' },
	            _react2.default.createElement(
	              'p',
	              null,
	              text
	            ),
	            this.renderButton(buttons, buttonLayoutType)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-message-time' },
	          time
	        )
	      );
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(buttons, buttonLayoutType) {
	      switch (buttonLayoutType) {
	        case "block":
	          return _.map(buttons, function (b) {
	            return _react2.default.createElement(_customButton2.default, { button: b, buttonType: 'wide', key: (0, _getUUID.getUUID)() });
	          });
	        case "flex":
	          return _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-button-group cu-ui-block' },
	            _.map(buttons, function (b) {
	              return _react2.default.createElement(_customButton2.default, { button: b, buttonType: 'block', key: (0, _getUUID.getUUID)() });
	            })
	          );
	      }
	    }
	  }]);
	
	  return ButtonCell;
	}(_index2.default);
	
	exports.default = ButtonCell;
	
	
	ButtonCell.propTypes = {
	  isBot: _propTypes2.default.bool,
	  time: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  buttonLayoutType: _propTypes2.default.string,
	  buttons: _propTypes2.default.array
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUUID = getUUID;
	function getUUID() {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(366);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(368);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRedux = __webpack_require__(255);
	
	var _redux = __webpack_require__(264);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomButton(_ref) {
	  var button = _ref.button,
	      buttonType = _ref.buttonType,
	      clickButton = _ref.clickButton;
	
	  var buttonClass = (0, _classnames2.default)('cu-ui-button', {
	    'cu-ui-button-base': buttonType != 'carousel'
	  }, {
	    'cu-ui-secondary': buttonType == 'carousel'
	  }, {
	    'cu-ui-block': buttonType == 'wide' || buttonType == 'carousel'
	  });
	  return _react2.default.createElement(
	    'button',
	    { className: buttonClass, onClick: function onClick() {
	        clickButton(button);
	      } },
	    button.text
	  );
	};
	
	CustomButton.propTypes = {
	  button: _propTypes2.default.object,
	  buttonType: _propTypes2.default.string,
	  clickButton: _propTypes2.default.func
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clickButton: (0, _redux.bindActionCreators)(actions.clickOnButton, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(CustomButton);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _getUUID = __webpack_require__(377);
	
	var _customButton = __webpack_require__(378);
	
	var _customButton2 = _interopRequireDefault(_customButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarouselCell = function (_BaseCell) {
	  _inherits(CarouselCell, _BaseCell);
	
	  function CarouselCell() {
	    _classCallCheck(this, CarouselCell);
	
	    return _possibleConstructorReturn(this, (CarouselCell.__proto__ || Object.getPrototypeOf(CarouselCell)).apply(this, arguments));
	  }
	
	  _createClass(CarouselCell, [{
	    key: 'render',
	    value: function render() {
	      var carousels = this.props.carousels;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cu-ui-carousel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cu-ui-carousel-slides' },
	          _.map(carousels, function (c) {
	            return _react2.default.createElement(Carousel, { title: c.title, explain: c.explain, buttons: c.buttons, key: (0, _getUUID.getUUID)() });
	          })
	        )
	      );
	    }
	  }]);
	
	  return CarouselCell;
	}(_index2.default);
	
	exports.default = CarouselCell;
	
	
	function Carousel(_ref) {
	  var title = _ref.title,
	      explain = _ref.explain,
	      buttons = _ref.buttons;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cu-ui-carousel-slide' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cu-ui-carousel-image' },
	      _react2.default.createElement('div', { className: 'cu-ui-carousel-placeholder' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cu-ui-carousel-text' },
	      _react2.default.createElement(
	        'h5',
	        { className: 'title' },
	        title
	      ),
	      explain
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cu-ui-carousel-buttons' },
	      _.map(buttons, function (b) {
	        return _react2.default.createElement(_customButton2.default, { button: b, buttonType: 'carousel', key: (0, _getUUID.getUUID)() });
	      })
	    )
	  );
	}
	
	CarouselCell.propTypes = {
	  carousels: _propTypes2.default.array
	};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.5';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)(module)))

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(255);
	
	var _redux = __webpack_require__(264);
	
	var _actions = __webpack_require__(368);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _moment = __webpack_require__(382);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(380);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(257);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatFooter = function (_React$Component) {
	  _inherits(ChatFooter, _React$Component);
	
	  function ChatFooter(props) {
	    _classCallCheck(this, ChatFooter);
	
	    var _this = _possibleConstructorReturn(this, (ChatFooter.__proto__ || Object.getPrototypeOf(ChatFooter)).call(this, props));
	
	    _lodash2.default.bindAll(_this, 'typing', 'selectFile', 'sendButtonClicked', 'sendFileButtonClicked');
	    return _this;
	  }
	
	  _createClass(ChatFooter, [{
	    key: 'typing',
	    value: function typing(e) {
	      if (e.key == 'Enter') {
	        e.preventDefault();
	        this.sendRequest();
	      }
	    }
	  }, {
	    key: 'sendButtonClicked',
	    value: function sendButtonClicked(e) {
	      e.preventDefault();
	      this.sendRequest();
	    }
	  }, {
	    key: 'sendRequest',
	    value: function sendRequest() {
	      var sendMessage = this.props.sendMessage;
	
	      var inputs = this.refs.inputField.value;
	
	      if (inputs.length > 0) {
	        sendMessage({
	          "type": "text",
	          "isBot": false,
	          "withIcon": true,
	          "text": inputs,
	          "time": (0, _moment2.default)().format('HH:mm')
	        });
	        this.refs.inputField.value = "";
	      }
	    }
	  }, {
	    key: 'sendFileButtonClicked',
	    value: function sendFileButtonClicked(e) {
	      e.preventDefault();
	      this.refs.fileUploadTag.click();
	    }
	  }, {
	    key: 'selectFile',
	    value: function selectFile(e) {
	      var sendMessage = this.props.sendMessage;
	
	      var files = e.target.files || e.dataTransfer.files;
	      var file = _lodash2.default.first(files);
	      var url = URL.createObjectURL(file);
	      switch (file.type) {
	        case 'application/pdf':
	        default:
	          sendMessage({
	            'type': 'normal-image',
	            'isBot': false,
	            'withIcon': true,
	            'url': url,
	            'time': '22:22'
	          });
	      }
	      this.refs.inputField.value = "";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cu-ui-chat-footer' },
	        _react2.default.createElement(
	          'form',
	          { action: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cu-ui-form-group' },
	            _react2.default.createElement('input', { ref: 'inputField', className: 'cu-ui-input cu-ui-input-add-on', type: 'text', onKeyPress: this.typing }),
	            _react2.default.createElement(
	              'button',
	              { className: 'cu-ui-add-on cu-ui-button cu-ui-outline cu-ui-secondary', onClick: this.sendFileButtonClicked },
	              _react2.default.createElement('div', { className: 'mdi mdi-plus-circle' })
	            ),
	            _react2.default.createElement('input', { ref: 'fileUploadTag', type: 'file', accept: 'image/*, application/pdf', style: fileUploadTagStyle, onChange: this.selectFile }),
	            _react2.default.createElement(
	              'button',
	              { className: 'cu-ui-button cu-ui-button-lg cu-ui-primary', onClick: this.sendButtonClicked },
	              'Send'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChatFooter;
	}(_react2.default.Component);
	
	var fileUploadTagStyle = {
	  display: "none"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    input_value: state.inputField.input_value
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    sendMessage: (0, _redux.bindActionCreators)(actions.sendMessage, dispatch)
	  };
	};
	
	ChatFooter.propTypes = {
	  sendMessage: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatFooter);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(383)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)(module)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 384,
		"./af.js": 384,
		"./ar": 385,
		"./ar-dz": 386,
		"./ar-dz.js": 386,
		"./ar-kw": 387,
		"./ar-kw.js": 387,
		"./ar-ly": 388,
		"./ar-ly.js": 388,
		"./ar-ma": 389,
		"./ar-ma.js": 389,
		"./ar-sa": 390,
		"./ar-sa.js": 390,
		"./ar-tn": 391,
		"./ar-tn.js": 391,
		"./ar.js": 385,
		"./az": 392,
		"./az.js": 392,
		"./be": 393,
		"./be.js": 393,
		"./bg": 394,
		"./bg.js": 394,
		"./bm": 395,
		"./bm.js": 395,
		"./bn": 396,
		"./bn.js": 396,
		"./bo": 397,
		"./bo.js": 397,
		"./br": 398,
		"./br.js": 398,
		"./bs": 399,
		"./bs.js": 399,
		"./ca": 400,
		"./ca.js": 400,
		"./cs": 401,
		"./cs.js": 401,
		"./cv": 402,
		"./cv.js": 402,
		"./cy": 403,
		"./cy.js": 403,
		"./da": 404,
		"./da.js": 404,
		"./de": 405,
		"./de-at": 406,
		"./de-at.js": 406,
		"./de-ch": 407,
		"./de-ch.js": 407,
		"./de.js": 405,
		"./dv": 408,
		"./dv.js": 408,
		"./el": 409,
		"./el.js": 409,
		"./en-au": 410,
		"./en-au.js": 410,
		"./en-ca": 411,
		"./en-ca.js": 411,
		"./en-gb": 412,
		"./en-gb.js": 412,
		"./en-ie": 413,
		"./en-ie.js": 413,
		"./en-nz": 414,
		"./en-nz.js": 414,
		"./eo": 415,
		"./eo.js": 415,
		"./es": 416,
		"./es-do": 417,
		"./es-do.js": 417,
		"./es-us": 418,
		"./es-us.js": 418,
		"./es.js": 416,
		"./et": 419,
		"./et.js": 419,
		"./eu": 420,
		"./eu.js": 420,
		"./fa": 421,
		"./fa.js": 421,
		"./fi": 422,
		"./fi.js": 422,
		"./fo": 423,
		"./fo.js": 423,
		"./fr": 424,
		"./fr-ca": 425,
		"./fr-ca.js": 425,
		"./fr-ch": 426,
		"./fr-ch.js": 426,
		"./fr.js": 424,
		"./fy": 427,
		"./fy.js": 427,
		"./gd": 428,
		"./gd.js": 428,
		"./gl": 429,
		"./gl.js": 429,
		"./gom-latn": 430,
		"./gom-latn.js": 430,
		"./gu": 431,
		"./gu.js": 431,
		"./he": 432,
		"./he.js": 432,
		"./hi": 433,
		"./hi.js": 433,
		"./hr": 434,
		"./hr.js": 434,
		"./hu": 435,
		"./hu.js": 435,
		"./hy-am": 436,
		"./hy-am.js": 436,
		"./id": 437,
		"./id.js": 437,
		"./is": 438,
		"./is.js": 438,
		"./it": 439,
		"./it.js": 439,
		"./ja": 440,
		"./ja.js": 440,
		"./jv": 441,
		"./jv.js": 441,
		"./ka": 442,
		"./ka.js": 442,
		"./kk": 443,
		"./kk.js": 443,
		"./km": 444,
		"./km.js": 444,
		"./kn": 445,
		"./kn.js": 445,
		"./ko": 446,
		"./ko.js": 446,
		"./ky": 447,
		"./ky.js": 447,
		"./lb": 448,
		"./lb.js": 448,
		"./lo": 449,
		"./lo.js": 449,
		"./lt": 450,
		"./lt.js": 450,
		"./lv": 451,
		"./lv.js": 451,
		"./me": 452,
		"./me.js": 452,
		"./mi": 453,
		"./mi.js": 453,
		"./mk": 454,
		"./mk.js": 454,
		"./ml": 455,
		"./ml.js": 455,
		"./mr": 456,
		"./mr.js": 456,
		"./ms": 457,
		"./ms-my": 458,
		"./ms-my.js": 458,
		"./ms.js": 457,
		"./mt": 459,
		"./mt.js": 459,
		"./my": 460,
		"./my.js": 460,
		"./nb": 461,
		"./nb.js": 461,
		"./ne": 462,
		"./ne.js": 462,
		"./nl": 463,
		"./nl-be": 464,
		"./nl-be.js": 464,
		"./nl.js": 463,
		"./nn": 465,
		"./nn.js": 465,
		"./pa-in": 466,
		"./pa-in.js": 466,
		"./pl": 467,
		"./pl.js": 467,
		"./pt": 468,
		"./pt-br": 469,
		"./pt-br.js": 469,
		"./pt.js": 468,
		"./ro": 470,
		"./ro.js": 470,
		"./ru": 471,
		"./ru.js": 471,
		"./sd": 472,
		"./sd.js": 472,
		"./se": 473,
		"./se.js": 473,
		"./si": 474,
		"./si.js": 474,
		"./sk": 475,
		"./sk.js": 475,
		"./sl": 476,
		"./sl.js": 476,
		"./sq": 477,
		"./sq.js": 477,
		"./sr": 478,
		"./sr-cyrl": 479,
		"./sr-cyrl.js": 479,
		"./sr.js": 478,
		"./ss": 480,
		"./ss.js": 480,
		"./sv": 481,
		"./sv.js": 481,
		"./sw": 482,
		"./sw.js": 482,
		"./ta": 483,
		"./ta.js": 483,
		"./te": 484,
		"./te.js": 484,
		"./tet": 485,
		"./tet.js": 485,
		"./th": 486,
		"./th.js": 486,
		"./tl-ph": 487,
		"./tl-ph.js": 487,
		"./tlh": 488,
		"./tlh.js": 488,
		"./tr": 489,
		"./tr.js": 489,
		"./tzl": 490,
		"./tzl.js": 490,
		"./tzm": 491,
		"./tzm-latn": 492,
		"./tzm-latn.js": 492,
		"./tzm.js": 491,
		"./uk": 493,
		"./uk.js": 493,
		"./ur": 494,
		"./ur.js": 494,
		"./uz": 495,
		"./uz-latn": 496,
		"./uz-latn.js": 496,
		"./uz.js": 495,
		"./vi": 497,
		"./vi.js": 497,
		"./x-pseudo": 498,
		"./x-pseudo.js": 498,
		"./yo": 499,
		"./yo.js": 499,
		"./zh-cn": 500,
		"./zh-cn.js": 500,
		"./zh-hk": 501,
		"./zh-hk.js": 501,
		"./zh-tw": 502,
		"./zh-tw.js": 502
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 383;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(382)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(81);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnsenui = __webpack_require__(294);
	
	__webpack_require__(504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_React$Component) {
	  _inherits(Loader, _React$Component);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	  }
	
	  _createClass(Loader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactOnsenui.Page,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'spinner-icon' },
	          _react2.default.createElement(
	            'svg',
	            { className: 'spinner', viewBox: '25 25 50 50' },
	            _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '4' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Loader;
	}(_react2.default.Component);
	
	exports.default = Loader;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(505);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(361)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(505, function() {
				var newContent = __webpack_require__(505);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(297)();
	// imports
	
	
	// module
	exports.push([module.id, ".spinner-icon{width:64px;height:64px;margin:0 auto}.spinner-icon .spinner{position:relative;width:64px;height:64px;animation:rotate 2s linear infinite}.spinner-icon .path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,colors 6s ease-in-out infinite;stroke-linecap:round}@keyframes rotate{to{transform:rotate(1turn)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}@keyframes colors{0%{stroke:#0098ce}25%{stroke:#0b4f6c}50%{stroke:#0098ce}75%{stroke:#006494}to{stroke:#0098ce}}.spinner-icon{position:absolute;top:calc(50% - 32px);left:calc(50% - 32px)}", ""]);
	
	// exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(91);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// cu-web-plugin.bundle.min.js